{
  "testit": {
    "catalog": {
      "title": "TestIt",
      "subtitle": "Tus resultados de pruebas reutilizables — haz una prueba una vez y reutilízala en cualquier CheckUp.",
      "notTaken": "Aún no realizado",
      "validDays": "Válido · {{days}}d restantes",
      "expired": "Caducado",
      "delete": "Eliminar",
      "declareHint": "Autodeclara tu nivel (sin verificar). Puedes reemplazarlo por una prueba verificada más adelante.",
      "retake": "Repetir",
      "kindPitch": "Pitch en vídeo",
      "kindCefr": "Prueba de idioma",
      "kindMotivational": "Cuestionario",
      "valid": "Válido",
      "takeTest": "Hacer prueba",
      "heroTitle": "Tu banco de pruebas reutilizables",
      "heroSubtitle": "Los resultados válidos se usan automáticamente la próxima vez que hagas un CheckUp.",
      "statValid": "Válidos",
      "statExpired": "Caducados",
      "statUntaken": "Sin hacer",
      "errorTitle": "No pudimos cargar tus pruebas",
      "errorBody": "Algo salió mal al obtener tu banco de pruebas. Inténtalo de nuevo en un momento.",
      "band": {
        "ringValue": "{{valid}}/{{total}}",
        "ringCaption": "pruebas válidas",
        "ringLabel": "{{valid}} de {{total}} pruebas válidas",
        "allValid": "Todas las pruebas válidas",
        "toRenew_one": "{{count}} por renovar",
        "toRenew_other": "{{count}} por renovar",
        "toTake_one": "{{count}} por hacer",
        "toTake_other": "{{count}} por hacer",
        "nextEyebrow": "Tu próximo paso",
        "startNow": "Empezar ahora",
        "renewNow": "Renovar ahora",
        "renewCaption": "Su resultado caducó · unos {{minutes}} min",
        "upToDate": "Todos los resultados al día",
        "soonestExpiry": "{{test}} caduca primero, el {{date}}"
      },
      "measures": {
        "pitch": "Un vídeo corto en el que te presentas: la claridad y la seguridad con que cuentas quién eres y por qué te mudas.",
        "cefr": "Tu nivel en el idioma, de A1 a C2: general y en lectura, comprensión auditiva, expresión oral y expresión escrita.",
        "motivational": "Un cuestionario corto sobre por qué te mudas y qué buscas en tu nueva vida."
      },
      "kindWithMinutes": "{{kind}} · unos {{minutes}} min",
      "aboutMinutes": "Unos {{minutes}} min",
      "expiredOn": "caducó el {{date}}",
      "viewResult": "Ver resultado",
      "renew": "Renovar"
    },
    "modal": {
      "history": "Historial",
      "historyError": "No pudimos cargar tus intentos.",
      "current": "Actual",
      "superseded": "Sustituido",
      "daysLeft": "{{days}} días restantes",
      "takenOn": "Hecho el {{date}}",
      "expiresOn": "caduca el {{date}}",
      "reuseNote": "Reutilizado automáticamente en tu próximo CheckUp",
      "takeNew": "Hacer una nueva prueba",
      "declareCta": "Declarar nivel"
    },
    "test": {
      "pitch": "Pitch",
      "languageEn": "Inglés",
      "languagePt": "Portugués",
      "language": "Idioma",
      "motivational": "Motivacional"
    },
    "invite": {
      "bulkKindNote": "Se aplica a todos los candidatos seleccionados.",
      "kindFull": "CheckUp completo",
      "kindFullHint": "La evaluación CheckUp completa — un perfil iQulture completo.",
      "kindLabel": "¿Qué deben completar?",
      "kindTestit": "Pruebas específicas",
      "kindTestitHint": "Solo las pruebas que elijas abajo: más rápido y los resultados son reutilizables.",
      "previewFull": "El correo de invitación al CheckUp completo.",
      "previewLabel": "Recibirán",
      "previewTestit": "Una invitación TestIt que menciona: {{tests}}.",
      "previewTestitEmpty": "Una invitación TestIt: elige las pruebas arriba.",
      "selectAtLeastOne": "Selecciona al menos una prueba.",
      "selectTestsHint": "Elige una o varias. El candidato completa solo estas.",
      "selectTestsLabel": "¿Qué pruebas deben realizar?",
      "testNeverExpires": "Sin caducidad",
      "wizardBannerCta": "Empezar ahora",
      "wizardCompleteBody": "Tus resultados se han compartido con la empresa. Puedes cerrar esto y explorar tu panel.",
      "wizardCompleteTitle": "¡Todas las pruebas completadas!",
      "wizardDoLater": "Hacerlo más tarde",
      "wizardDone": "Completada",
      "wizardGoToDashboard": "Ir al panel",
      "wizardIntro": "Te invitaron a completar estas pruebas. Hazlas en el orden que quieras: tus resultados se guardan y son reutilizables.",
      "wizardPending": "Pendiente",
      "wizardProgress": "{{done}} de {{total}} completadas",
      "wizardRetake": "Repetir",
      "wizardStart": "Empezar",
      "wizardTitle": "Completa tus pruebas asignadas",
      "testValidityDays_one": "Válido {{count}} día",
      "testValidityDays_other": "Válido {{count}} días",
      "wizardBannerTitle_one": "Te han invitado a completar {{count}} prueba",
      "wizardBannerTitle_other": "Te han invitado a completar {{count}} pruebas",
      "completeBannerTitle": "Las pruebas que te pidieron están completadas",
      "completeBannerBody": "La empresa que las pidió puede ver tus resultados. No queda nada por hacer."
    },
    "vetting": {
      "allComplete": "Todas las pruebas invitadas completadas",
      "askDescription": "Pediremos a {{name}} la evaluación seleccionada. Si necesita más de lo que comparte contigo ahora, decide si lo comparte; no se comparte nada más hasta que responda. Los resultados que ya tiene se reutilizan.",
      "askFailed": "No se pudo enviar la solicitud",
      "askForCheckup": "Pedir CheckUp completo",
      "askSend": "Enviar solicitud",
      "askSending": "Enviando…",
      "askEmailFailed": "La solicitud a {{name}} quedó registrada, pero no se pudo enviar el correo",
      "askTitle": "Solicitar una evaluación a {{name}}",
      "decline": "Rechazar",
      "declined": "Rechazado",
      "expired": "Caducado",
      "invitedProgress": "{{done}} de {{total}} pruebas completadas",
      "latestResult": "Último resultado",
      "noPriorAttempts": "Sin intentos anteriores",
      "noResults": "Aún no hay resultados de pruebas",
      "noVerdict": "Sin decisión aún",
      "notTaken": "No realizada",
      "otherResults": "Otros resultados",
      "overviewTitle": "Evaluación TestIt",
      "pass": "Aprobar",
      "passed": "Aprobado",
      "pending": "Pendiente",
      "pitchAria": "Grabación del pitch del candidato",
      "pitchUnavailable": "Grabación no disponible",
      "previousAttempts": "Intentos anteriores",
      "remind": "Recordar",
      "reminderFailed": "No se pudo enviar el recordatorio.",
      "reminderSent": "Recordatorio enviado",
      "reminderTooSoon": "Ya lo recordaste hace poco — inténtalo más tarde.",
      "takenOn": "realizada el {{date}}",
      "valid": "Válido · {{days}}d restantes",
      "validShort": "Válido",
      "verdictTitle": "Veredicto",
      "failed": "Análisis fallido",
      "failedReason": {
        "languageMismatch": "El certificado acredita un idioma distinto al de esta prueba.",
        "unsupportedDocument": "No se ha podido leer el archivo subido.",
        "archiveTooLarge": "El documento Word es demasiado grande para leerlo de forma segura.",
        "docxEmpty": "El documento Word no tiene texto ni imagen legibles.",
        "tooManyPages": "El certificado tiene más de {{max}} páginas; solo se leen certificados de hasta {{max}} páginas.",
        "noLevelFound": "No se ha encontrado ningún nivel MCER en el certificado.",
        "serviceUnavailable": "Nuestro servicio de análisis no ha podido procesar el certificado."
      },
      "withheldBody": "Este ciudadano no ha compartido los resultados de sus pruebas con tu empresa. Las pruebas a las que le invitaste siguen listadas; si las ha completado está retenido: no es «pendiente».",
      "moreActions": "Más acciones",
      "repositoryTitle": "Resultados de pruebas guardados",
      "repositorySubtitle": "Todas las pruebas y lo que el candidato ha completado de cada una — solo lectura. Esta invitación de CheckUp no pidió pruebas específicas.",
      "loadFailed": "No se han podido cargar los resultados de las pruebas.",
      "askRequested": "Solicitud enviada a {{name}}: no se comparte nada más hasta que responda",
      "askReminded": "Recordamos a {{name}} lo que le falta por hacer",
      "askAlreadyShared": "{{name}} ya comparte esto contigo: no hay nada que pedir"
    },
    "doOnWeb": "Hacer mis pruebas en la web",
    "doOnWebDesc": "Las pruebas que pidió tu empresa se realizan en el portal web Citizen: ábrelo en un navegador de escritorio para empezar.",
    "result": {
      "overallLevel": "Nivel general",
      "skillReading": "Lectura",
      "skillListening": "Comprensión auditiva",
      "skillSpeaking": "Expresión oral",
      "skillWriting": "Expresión escrita",
      "selfDeclared": "Autodeclarado",
      "analyserConfidence": "Confianza del análisis: {{value}}",
      "recorded": "Grabado",
      "motivationalComplete": "Cuestionario completado",
      "motivationalAnswered_one": "{{count}} respuesta",
      "motivationalAnswered_other": "{{count}} respuestas",
      "sourceCheckup": "Del CheckUp",
      "sourceTestit": "TestIt",
      "duration": "Duración",
      "cefrLevel": "MCER {{level}}",
      "recordedDuration": "Grabado · {{duration}}",
      "answersCaption_one": "respuesta",
      "answersCaption_other": "respuestas"
    },
    "tabs": {
      "tests": "Pruebas",
      "history": "Historial"
    },
    "brief": {
      "title": "Antes de empezar: {{test}}",
      "measuresHeading": "Qué mide",
      "needsHeading": "Qué necesitarás",
      "stepsHeading": "Cómo funciona",
      "start": "Empezar la prueba",
      "replaces": "Tu resultado actual ({{result}}) se sustituye por el nuevo y queda en tu historial.",
      "needs": {
        "camera": "Una cámara y un micrófono",
        "quietPlace": "Un lugar tranquilo — respondes en inglés",
        "computer": "Un ordenador con acceso a internet",
        "headphones": "Auriculares para la parte de comprensión auditiva",
        "resultFile": "Una captura de pantalla, un PDF o un archivo Word del resultado",
        "time": "Un momento tranquilo — tus respuestas se guardan mientras escribes"
      },
      "steps": {
        "pitch": {
          "read": "Lee las preguntas en pantalla",
          "record": "Graba tus respuestas en un solo vídeo",
          "send": "Revísalo, vuelve a grabar si quieres y envíalo"
        },
        "language": {
          "take": "Haz la prueba en la web del socio",
          "upload": "Sube tu resultado — una captura de pantalla, un PDF o un archivo Word",
          "read": "Leemos tu nivel automáticamente y te lo mostramos"
        },
        "motivational": {
          "answer": "Responde a las preguntas sobre tu mudanza, a tu ritmo",
          "review": "Revisa tus respuestas",
          "send": "Envíalas"
        }
      }
    },
    "done": {
      "title": "Resultado guardado",
      "saving": "Guardando tu resultado…",
      "validUntil": "Válido hasta el {{date}}",
      "finish": "Listo",
      "seeResult": "Ver resultado e historial"
    },
    "history": {
      "deleteTitle": "¿Eliminar este intento?",
      "deleteWhat": "{{test}} · {{result}} · {{date}}",
      "deleteCurrent": "Es tu resultado actual: el intento anterior, si lo hay, pasa a ser el resultado de esta prueba.",
      "deleteAttempt": "Eliminar el intento de {{test}}",
      "errorTitle": "No hemos podido cargar tu historial",
      "errorBody": "Inténtalo de nuevo en un momento.",
      "emptyTitle": "Aún no hay intentos",
      "emptyBody": "Cada prueba que hagas aparece aquí, con su resultado y su fecha.",
      "browseTests": "Ver las pruebas",
      "filterLabel": "Mostrar intentos de",
      "filterAll": "Todos"
    }
  },
  "introCarousel": {
    "back": "Atrás",
    "business": {
      "cta": "Añadir talentos",
      "ctaSecondary": "Quizás más tarde",
      "slides": {
        "welcome": {
          "eyebrow": "Bienvenido a Tonnie",
          "title": "Patrocina talento global, con protección",
          "body": "Evalúa, patrocina y apoya contrataciones internacionales en un solo lugar: Tonnie protege cada patrocinio, con trazabilidad en cada paso."
        },
        "acquire": {
          "eyebrow": "Talent Pool · Evaluación",
          "title": "Evalúa antes de patrocinar",
          "body": "Revisa la preparación para la reubicación de cada candidato en el Talent Pool, para patrocinar solo a quienes de verdad llegarán."
        },
        "sponsor": {
          "eyebrow": "Patrocinio · Protegido",
          "title": "Patrocina con protección",
          "body": "Apuesta por un talento y Tonnie protege la inversión de principio a fin: verificaciones de preparación, hitos y evidencia mantienen cada patrocinio en marcha."
        },
        "mobility": {
          "eyebrow": "Movilidad · Adaptación",
          "title": "Sigue la mudanza y la adaptación",
          "body": "Sigue cada reubicación entre trámites legales, viaje e instalación, y observa cómo se adapta cada contratación patrocinada al puesto y al país."
        },
        "care": {
          "eyebrow": "Care · Cumplimiento",
          "title": "Retén el talento, respaldado por evidencia",
          "body": "Apoya el bienestar sin vigilancia y exporta registros verificados en cuanto lo pidan auditoría, legal o dirección."
        },
        "start": {
          "eyebrow": "Empecemos",
          "title": "Patrocina a tu primer talento",
          "body": "Añade un talento a tu programa: cada patrocinio queda protegido por Tonnie, desde el primer día."
        }
      }
    },
    "goToSlide": "Ir a la diapositiva {{number}}",
    "next": "Siguiente",
    "skip": "Omitir",
    "title": "Introducción a Tonnie"
  },
  "activity": {
    "task": {
      "completed": "Completado: {{label}}",
      "completedForMember": "Completado: {{label}} — {{member}}"
    },
    "housing": {
      "secured": "Vivienda asegurada"
    },
    "checkup": {
      "scored": "CheckUp puntuación calculada"
    },
    "checkin": {
      "completed": "Registro completado"
    },
    "checkpoint": {
      "completed": "Punto de control: {{label}}"
    },
    "mission": {
      "completed": "Misión completada: {{label}}"
    },
    "world": {
      "completed": "Mundo completado: {{label}}"
    },
    "streak": {
      "milestone_one": "¡Racha de {{count}} día!",
      "milestone_other": "¡Racha de {{count}} días!"
    },
    "stamp": {
      "earned": "Sello ganado: {{label}}"
    },
    "badge": {
      "earned": "Insignia ganada: {{label}}"
    },
    "onboarding": {
      "completed": "Comenzando"
    },
    "journey": {
      "completed": "¡Viaje completo!"
    },
    "event": {
      "addedFromPool": "Añadido del grupo de talentos",
      "adoptedByInvitation": "Trayecto vinculado a una invitación de empresa",
      "arrived": "Llegado al destino",
      "badgeEarned": "Insignia ganada",
      "checkpointCompleted": "Punto de control completado",
      "checkupCompleted": "CheckUp completado",
      "checkupStarted": "CheckUp iniciado",
      "companyTaskCompleted": "Tarea de la empresa completada",
      "documentUploaded": "Documento subido",
      "expiryRenewed": "Viaje extendido",
      "fundingChanged": "Financiación cambiada",
      "guideCompleted": "Guía completada",
      "guideDiscarded": "Guía descartada",
      "guideRestarted": "Guía reiniciada",
      "guideRetaken": "Guía retomada",
      "guideStarted": "Guía iniciada",
      "interventionLogged": "Intervención Care registrada",
      "interventionResolved": "Intervención Care resuelta",
      "interventionScheduled": "Intervención Care programada",
      "interventionUpdated": "Intervención Care actualizada",
      "interviewRequested": "Entrevista solicitada",
      "invitationAccepted": "Invitación aceptada",
      "journeyArchived": "Viaje archivado",
      "journeyCreated": "Viaje creado",
      "journeyLifecycle": "Estado del viaje cambiado",
      "journeyRestored": "Viaje restaurado",
      "missionCompleted": "Misión completada",
      "objectiveFeedbackSubmitted": "Retroalimentación objetiva enviada",
      "pipelineStageChanged": "Etapa del pipeline cambiada",
      "pitchAnalyzed": "Análisis de la propuesta",
      "protectiveActionLogged": "Acción protectora registrada",
      "setPrimary": "Establecer como viaje principal",
      "sponsorshipAccepted": "Patrocinio aceptado",
      "sponsorshipCancelled": "Patrocinio cancelado",
      "sponsorshipDeclined": "Patrocinio rechazado",
      "sponsorshipRefunded": "Patrocinio reembolsado",
      "sponsorshipStarted": "Patrocinio iniciado",
      "stampEarned": "Sello ganado",
      "talentArchived": "Talento archivado",
      "talentSponsored": "Patrocinio activado",
      "talentUnarchived": "Talento desarchivado",
      "teleportalTaskCompleted": "TelePortal tarea completada",
      "trackCompleted": "Seguimiento completado",
      "vettingInviteEmailFailed": "No se pudo enviar el correo de la invitación de evaluación",
      "visaApproved": "Visa aprobada",
      "worldCompleted": "Mundo completado",
      "copilotInterviewCompleted": "Entrevista con CoPilot completada",
      "testResultsRecorded": "Resultados de las pruebas registrados",
      "testitPassed": "Veredicto TestIt: aprobado",
      "testitDeclined": "Veredicto TestIt: rechazado",
      "profileCompleted": "Perfil completado",
      "documentValidated": "Documento validado",
      "relocationPlanCreated": "Plan de reubicación creado",
      "relocationPlanUpdated": "Plan de reubicación actualizado",
      "milestoneReached": "Hito alcanzado",
      "interventionDue": "Acción de cuidado programada pendiente",
      "taskReopened": "Tarea de reubicación reabierta",
      "relationshipMoved": "Pasó a un viaje propio",
      "programmeLeft": "Salió del programa",
      "shareRequested": "Pidió ver más",
      "shareRequestAccepted": "Compartió lo que se pidió",
      "shareRequestDeclined": "Rechazó la solicitud de ver más",
      "vettingReminded": "Recordatorio de lo que falta por hacer",
      "testitCompleted": "Completó las pruebas que se le pidieron"
    },
    "externalLevel": {
      "reached": "{{world}}: nivel {{band}} alcanzado"
    },
    "pipeline": {
      "transition": "Pipeline: {{from}} → {{to}}"
    },
    "business": {
      "intervention": "Intervención: {{label}}",
      "feedbackRoutineCreated": "Rutina de feedback \"{{name}}\" creada",
      "feedbackRoutineStarted": "Rutina de feedback iniciada",
      "feedbackRoutineCompleted": "Rutina de feedback completada",
      "feedbackRoutinePaused": "Rutina de feedback pausada",
      "protectiveAction": "Acción protectora — {{label}}",
      "interventionLogged": "Intervención — {{label}}",
      "documentUploaded": "Documento subido — {{label}}",
      "taskReminderSent": "Recordatorio enviado — {{label}}",
      "interventionScheduled": "{{label}} programado",
      "messageSent": "Enviado \"{{name}}\" a través de {{channel}}",
      "messageSentNoName": "Mensaje enviado a través de {{channel}}",
      "messageNotDelivered": "\"{{name}}\" a través de {{channel}} no se entregó",
      "messageNotDeliveredNoName": "El mensaje a través de {{channel}} no se entregó",
      "messageDispatched": "\"{{name}}\" a través de {{channel}} se entregó para su envío; resultado no registrado",
      "messageDispatchedNoName": "El mensaje a través de {{channel}} se entregó para su envío; resultado no registrado",
      "invitationCreated": "Invitación creada",
      "invitationSent": "Invitación enviada",
      "invitationReminded": "Recordatorio de la invitación enviado",
      "invitationAccepted": "Invitación aceptada",
      "invitationRevoked": "Invitación revocada",
      "invitationRevokedAccountDeleted": "Invitación revocada — la persona eliminó su cuenta",
      "invitationExpired": "Invitación caducada",
      "invitationDeclined": "Invitación rechazada"
    },
    "generic": "{{text}}",
    "objective": {
      "selfEvaluated": "Se completó una autoevaluación de objetivos"
    },
    "messageTemplate": {
      "account_email_changed": "Correo de acceso cambiado",
      "account_invitation_claim_code": "Código para reclamar la invitación",
      "adaptation_nudge_missions": "Sugerencia de misión de adaptación",
      "adaptation_streak_broken": "Recordatorio de racha de adaptación",
      "care_checkin_request": "Solicitud de registro de Care",
      "care_checkpoint_overdue_reminder": "Recordatorio de fecha límite de punto de control (talento)",
      "care_feedback_requested": "Solicitud de retroalimentación Care (a talento)",
      "care_intervention_due": "Intervención Care pendiente (interno)",
      "care_objective_feedback_cycle_open": "Retroalimentación objetiva — ronda abierta (talento)",
      "care_objective_feedback_due": "Retroalimentación objetiva — pendiente (proveedor)",
      "care_objective_feedback_received": "Retroalimentación objetiva — recibida (talento)",
      "coaching_message": "Mensaje de coaching",
      "cohort_welcome": "Bienvenida a la cohorte",
      "company_nudge_digest": "Acción necesaria — resumen semanal de la empresa",
      "evidence_celebrate_badge": "Celebración de insignia",
      "evidence_request": "Solicitud de evidencia / documento",
      "integration_mission_assigned": "Misión de QultureUp asignada",
      "interview_first_requested": "Solicitud de Interview-First",
      "mobility_task_assigned": "Tarea de movilidad asignada",
      "mobility_task_pending": "Recordatorio de tarea de movilidad",
      "program_enrollment": "Bienvenida a la inscripción en el programa",
      "services_request_received": "Solicitud de servicios Tonnie recibida (interna)",
      "sponsorship_activate": "Activación de patrocinio — esperando aceptación del talento",
      "sponsorship_invite": "Invitación de patrocinio (lanzamiento del viaje)",
      "sponsorship_offer_reminder": "Recordatorio de oferta de patrocinio (sin respuesta)",
      "sponsorship_talent_accepted": "Patrocinio — talento aceptado (notificación administrativa)",
      "sponsorship_talent_declined": "Patrocinio — talento rechazado (notificación administrativa + reembolso)",
      "sponsorship_welcome": "Bienvenida al patrocinio",
      "talent_invite": "Invitación de incorporación de talento",
      "team_invite": "Invitación a miembro del equipo",
      "team_invite_reminder": "Recordatorio de invitación al equipo",
      "vetting_complete_checkup": "Recordatorio de progreso CheckUp",
      "vetting_invite": "Invitar candidato a CheckUp",
      "vetting_invite_reminder": "Recordatorio de invitación (sin respuesta)",
      "vetting_invite_testit": "Invitar candidato a pruebas específicas (TestIt)",
      "vetting_reminder": "Recordatorio de CheckUp",
      "talent_checkup_link": "Enlace del CheckUp para el ordenador",
      "coaching_encourage": "Coaching — ánimo",
      "coaching_challenge": "Coaching — reto semanal",
      "coaching_checkin": "Coaching — seguimiento",
      "coaching_celebrate": "Coaching — celebración",
      "coaching_remind": "Coaching — recordatorio",
      "talent_programme_left": "Talento salió del programa (notificación administrativa)",
      "vetting_share_request": "Solicitud para ver el CheckUp (relación existente)",
      "vetting_share_request_testit": "Solicitud para ver resultados de pruebas (relación existente)",
      "vetting_testit_reminder": "Recordatorio de TestIt",
      "talent_share_request_declined": "El talento rechazó una solicitud (notificación al administrador)",
      "talent_testit_completed": "El talento completó las pruebas que pediste (notificación al administrador)",
      "fiscal_document_issued": "Factura-recibo emitida",
      "fiscal_document_issued_company": "Factura-recibo emitida a la empresa",
      "inout_notice_lead_time": "InOut: se acerca un límite de residencia",
      "inout_notice_confirmation": "InOut: confirmación de presencia",
      "inout_notice_renewal_window": "InOut: plazo de renovación abierto",
      "inout_agency_contact_request": "InOut: solicitud de contacto a la asesoría",
      "inout_agency_refund_request": "InOut: solicitud de reembolso a la asesoría",
      "inout_refund_request_tonnie": "InOut: solicitud de reembolso a Tonnie",
      "inout_agency_dossier": "InOut: el dosier, a la asesoría",
      "qultureup_academy_mission_completed": "Languages Academy: misión completada",
      "qultureup_academy_level_reached": "Languages Academy: nivel alcanzado",
      "qultureup_academy_goal_reached": "Languages Academy: meta alcanzada",
      "qultureup_academy_inactive": "Languages Academy: hora de una clase"
    },
    "guide": {
      "started": "Guía de {{flow}} iniciada",
      "completed": "Guía de {{flow}} completada",
      "discarded": "Guía de {{flow}} descartada",
      "restarted": "Guía de {{flow}} reiniciada",
      "retaken": "Guía de {{flow}} repetida"
    },
    "milestone": {
      "reached": "Hito alcanzado: {{label}}"
    },
    "inout": {
      "started": "InOut iniciado",
      "tripRecorded_one": "Viaje registrado: {{count}} día fuera",
      "tripRecorded_other": "Viaje registrado: {{count}} días fuera",
      "tripPlanned_one": "Viaje planificado: {{count}} día",
      "tripPlanned_other": "Viaje planificado: {{count}} días"
    }
  },
  "catalog": {
    "stamps": {
      "first_step": {
        "name": "Primer Paso",
        "description": "Completa tu incorporación y comienza tu viaje"
      },
      "first_checkup": {
        "name": "Primer CheckUp",
        "description": "Completa tu primera evaluación de CheckUp"
      },
      "iqulture_pro": {
        "name": "iQulture PRO",
        "description": "Alcanza el estatus iQulture PRO (puntuación 70+)"
      },
      "visa_approved": {
        "name": "Visa Aprobada",
        "description": "Tu visa o permiso de residencia ha sido aprobado"
      },
      "arrived": {
        "name": "Llegado a Destino",
        "description": "Has llegado a tu país de destino"
      },
      "housing_secured": {
        "name": "Hogar, dulce hogar",
        "description": "Has asegurado vivienda en tu destino"
      },
      "first_mission": {
        "name": "Primera Misión",
        "description": "Completa tu primera misión de aprendizaje de QultureUp"
      },
      "world_explorer": {
        "name": "Explorador del Mundo",
        "description": "Completa tu primer mundo de QultureUp (todas las pistas)"
      },
      "streak_7": {
        "name": "Racha de 7 Días",
        "description": "Completa QultureUp actividades 7 días seguidos"
      },
      "streak_30": {
        "name": "Racha de 30 Días",
        "description": "Completa QultureUp actividades 30 días seguidos"
      },
      "first_checkpoint": {
        "name": "Primer Punto de Control",
        "description": "Completa tu primer punto de control de bienestar de Care"
      },
      "care_champion": {
        "name": "Care Campeón",
        "description": "Completa los 4 puntos de control programados de Care"
      },
      "all_heroes": {
        "name": "Viaje Completo",
        "description": "Activaste los 5 héroes en tu viaje"
      },
      "adaptation_master": {
        "name": "Maestro de Adaptación",
        "description": "Dominaste la adaptación cultural en múltiples mundos"
      },
      "journey_complete": {
        "name": "Viaje Completo",
        "description": "Completaste con éxito todo tu viaje de integración"
      },
      "inout_started": {
        "name": "InOut iniciado",
        "description": "Empieza a llevar tu registro de residencia en InOut"
      },
      "inout_first_trip": {
        "name": "Primer viaje registrado",
        "description": "Registra un viaje fuera de tu país de acogida"
      },
      "inout_trip_planned": {
        "name": "Planificado con antelación",
        "description": "Planifica un viaje en InOut antes de salir"
      }
    },
    "badges": {
      "legal_expert": {
        "name": "Experto Legal",
        "description": "Dominaste la trayectoria legal y los derechos cívicos"
      },
      "culture_citizen": {
        "name": "Cultura Citizen",
        "description": "Completaste todos los mundos culturales a nivel Avanzado"
      },
      "workplace_master": {
        "name": "Maestro del Lugar de Trabajo",
        "description": "Adaptación al lugar de trabajo y dominio del idioma completados"
      },
      "fully_adapted": {
        "name": "Totalmente Adaptado Citizen",
        "description": "Integración completa: todos los viajes finalizados"
      },
      "cultural_ambassador": {
        "name": "Embajador Cultural",
        "description": "Adaptación cultural excepcional: estatus de embajador"
      }
    }
  },
  "about": {
    "aiModel": "Modelo de IA",
    "appName": "Tonnie Citizen",
    "appVersion": "Versión de la app",
    "brainService": "Servicio del cerebro",
    "build": "Construir",
    "copyright": "© {{year}} Tonnie. Todos los derechos reservados.",
    "description": "Tonnie es una plataforma global de movilidad de talento que reduce el fracaso en la reubicación y acelera la integración estable. Combinamos orientación impulsada por IA con cuidado humano para apoyar cada paso de tu viaje.",
    "environment": "Entorno",
    "expoSdk": "Expo SDK",
    "fetchingVersions": "Obteniendo información de la versión...",
    "platform": "Plataforma",
    "platformApi": "API de la plataforma",
    "systemInfo": "Información del sistema",
    "title": "Acerca de Tonnie",
    "version": "Versión {{version}}"
  },
  "accessControl": {
    "accessDenied": "Acceso denegado",
    "accessFeatureInCitizenApp": "Accede a {{feature}} a través de la aplicación móvil Citizen.",
    "buildJourney": "Construir viaje",
    "enableFamilyProgram": "Habilita el Programa Familiar en la facturación para acceder a esta función.",
    "familyMasterOnly": "Esta función solo está disponible para los Maestros de Familia.",
    "familyProgramRequired": "Programa familiar requerido",
    "featureInCitizenApp": "Esta función está disponible a través de la aplicación móvil Citizen.",
    "featureLocked": "Función bloqueada",
    "goToBilling": "Ir a facturación",
    "heroNotEnabled": "Héroe no habilitado",
    "heroNotEnabledDescription": "Este héroe no está habilitado en tu plan actual. Mejora o cambia de viaje para desbloquearlo.",
    "journeyRequired": "Viaje requerido",
    "locked": "Bloqueado",
    "needJourneyToAccess": "Necesitas construir un viaje para acceder a esta función.",
    "noPermission": "No tienes permiso para acceder a esta función.",
    "openCitizen": "Abrir Citizen",
    "switchJourney": "Cambiar viaje",
    "talentOrFamilyMasterOnly": "Esta función solo está disponible para Talentos y Maestros de Familia.",
    "upgrade": "Actualizar",
    "useCitizenMobileApp": "Usar la aplicación móvil Citizen"
  },
  "accessScenario": {
    "badges": {
      "companySponsored": "Patrocinado por la empresa",
      "familyMember": "Miembro de la familia",
      "free": "Modo gratuito",
      "governmentSponsored": "Patrocinado por el gobierno"
    },
    "companySponsored": {
      "description": "Talento con viaje patrocinado por la empresa. Acceso completo a nivel Pro, sin pago requerido.",
      "label": "Patrocinado por la empresa"
    },
    "familyMember": {
      "description": "Miembro de la familia con el mismo acceso que el Modo gratuito. El viaje se desbloquea a través del Programa Familiar.",
      "label": "Miembro de la familia"
    },
    "free": {
      "description": "Suscripción gratuita con acceso limitado. Actualiza a través de Facturación para desbloquear Pro, Familia o más Viajes.",
      "label": "Modo gratuito"
    },
    "governmentSponsored": {
      "description": "Talento con viaje patrocinado por el gobierno. Acceso completo a nivel Pro, sin pago requerido.",
      "label": "Patrocinado por el gobierno"
    },
    "info": {
      "description": "Los escenarios de acceso te ayudan a probar diferentes combinaciones de modos de suscripción, patrocinio de viaje y roles de usuario. Tu escenario seleccionado determina qué funciones puedes acceder en el prototipo. En producción, tu acceso está determinado por tu suscripción real y las instancias de viaje.",
      "title": "Acerca de los escenarios de acceso"
    },
    "loading": "Cargando...",
    "matrix": {
      "allowed": "Acceso completo",
      "billingDescription": "Gestión de planes y facturación",
      "careDescription": "Puntos de control y apoyo post-llegada",
      "careNotAllowed": "Sin acceso a Care en Modo Gratis",
      "careerDescription": "Oportunidades laborales y herramientas de carrera",
      "checkupDescription": "Evaluación de preparación previa a la inmigración",
      "citizenMobile": "Citizen móvil",
      "cvBuilder": "Constructor de CV",
      "cvBuilderDescription": "Generador de CV y plantillas al estilo de la UE",
      "description": "Compara el acceso a funciones en todos los escenarios. Selecciona un escenario para continuar.",
      "familyProgramDescription": "Gestión e invitaciones del programa familiar",
      "familyProgramViaBilling": "Disponible a través de facturación. Compra el complemento familiar (€4.99/mes) para habilitar.",
      "features": "Funciones",
      "homeDescription": "Panel de control y resumen del viaje",
      "journeyBuilder": "Constructor de viajes",
      "journeyBuilderDescription": "Configura y construye tu viaje personalizado",
      "journeyBuilderViaBilling": "Disponible después de comprar un viaje a través de Facturación",
      "legend": {
        "allowed": "Acceso completo",
        "citizenMobile": "Disponible a través de la aplicación móvil Citizen",
        "limited": "Acceso limitado",
        "notAllowed": "No disponible",
        "readOnly": "Solo lectura (miembro de la familia)",
        "viaBilling": "Disponible a través de facturación/Actualización"
      },
      "limited": "Acceso limitado",
      "notAllowed": "No disponible",
      "passportDescription": "Línea de tiempo del viaje y logros",
      "passportLimited": "Ver solo eventos/log, sin funciones avanzadas",
      "profileDescription": "Configuraciones y preferencias del perfil",
      "qultureupDescription": "Integración cultural y aprendizaje",
      "qultureupLimited": "Solo misiones básicas, contenido limitado",
      "readOnly": "Solo lectura",
      "selected": "Seleccionado",
      "teleportalDescription": "Tareas de reubicación y movilidad",
      "teleportalLimited": "Solo lista de verificación, sin carga de documentos, sin revisión de IA",
      "title": "Matriz de acceso a funciones",
      "viaBilling": "A través de facturación"
    },
    "select": "Seleccionar escenario",
    "subtitle": "Elige un escenario para probar diferentes niveles de acceso. Puedes actualizar a Pro, añadir Familia o comprar más Viajes a través de Facturación.",
    "title": "Seleccionar escenario de acceso"
  },
  "address": {
    "city": "Ciudad",
    "country": "País",
    "detailsError": "Error al obtener los detalles de la dirección. Por favor, intenta de nuevo.",
    "search": "Buscar dirección",
    "searchDescription": "Comienza a escribir para buscar una dirección",
    "searchError": "Error al buscar direcciones. Por favor, inténtalo de nuevo.",
    "searchPlaceholder": "Comienza a escribir una dirección...",
    "typeMinChars": "Escribe al menos 3 caracteres para buscar",
    "citySearch": {
      "suggestions": "Sugerencias de ciudades",
      "noResults": "No se encontró ninguna ciudad — puedes mantener lo que escribiste.",
      "unavailable": "Las sugerencias no están disponibles ahora — puedes mantener lo que escribiste."
    }
  },
  "admin": {
    "carePillars": {
      "saveSuccess": "¡Configuración de pilares guardada!"
    }
  },
  "alt": {
    "care": "Care",
    "career": "Career",
    "checkup": "CheckUp",
    "copilot": "CoPilot",
    "dialogGraphic": "Gráfico de diálogo",
    "logo": "Logo",
    "passport": "Passport",
    "profile": "Perfil",
    "qultureup": "QultureUp",
    "teleportal": "TelePortal",
    "tonnieLogo": "Logotipo de Tonnie"
  },
  "assessment": {
    "analyzing": "Analizando tu nivel de conocimiento...",
    "answerPlaceholder": "Escribe tu respuesta aquí...",
    "duration": "Toma alrededor de 5-10 minutos",
    "evaluating": "Evaluando tus respuestas",
    "finish": "Finalizar",
    "saveFailed": "No se han podido guardar tus respuestas. Inténtalo de nuevo.",
    "getRecommendations": "Obtén tu nivel y recomendaciones",
    "loadingAssessment": "Cargando evaluación...",
    "next": "Siguiente",
    "personalizedResults": "Resultados personalizados",
    "previous": "Anterior",
    "questionOf": "Pregunta {{current}} de {{total}}",
    "quickAssessment": "Evaluación rápida",
    "skipAhead": "Saltar adelante",
    "skipKnownContent": "Saltar contenido que ya conoces",
    "startAssessment": "Iniciar evaluación",
    "startFailed": "No pudimos cargar las preguntas. Comprueba tu conexión e inténtalo de nuevo.",
    "startFromBeginning": "Comenzar desde el principio",
    "subtitle": "Déjanos evaluar tu nivel actual de conocimiento cultural",
    "title": "Evaluación de conocimientos",
    "viewRecommendedPath": "Ver ruta recomendada",
    "placement": {
      "beginner": "Estás empezando — tu recorrido empieza por los fundamentos de la cultura.",
      "intermediate": "Ya conoces lo esencial — tu recorrido parte de lo que ya sabes.",
      "advanced": "Conoces bien la cultura — tu recorrido te lleva más lejos."
    }
  },
  "assessmentChat": {
    "clickToStartRecording": "Haz clic para comenzar a grabar",
    "clickToUpload": "Haz clic para subir CV",
    "fileFormats": "PDF, DOC, DOCX",
    "notAtAll": "Para nada",
    "recordAgain": "Grabar de nuevo",
    "recordPitch": "Graba tu presentación",
    "recordPitchDesc": "Graba una presentación de 60 segundos sobre ti y tus objetivos",
    "recordVideoDesc": "Graba un video corto presentándote (máx. 30 segundos)",
    "recording": "Grabando...",
    "recordingPitch": "Grabando... (máx. 60 segundos)",
    "startRecording": "Comenzar a grabar",
    "stopRecording": "Detener grabación",
    "typeAnswer": "Escribe tu respuesta...",
    "typeMessage": "Escribe tu mensaje...",
    "veryMuch": "Mucho"
  },
  "auth": {
    "alreadySignedIn": {
      "continueToDashboard": "Continuar al panel de control",
      "description": "Has iniciado sesión como {{email}}. Continúa tu viaje o cierra sesión para usar otra cuenta.",
      "descriptionBusiness": "Has iniciado sesión como {{email}}. Continúa al panel de control de Negocios, o cierra sesión para usar otra cuenta.",
      "signingOut": "Cerrando sesión…",
      "switchAccount": "Cerrar sesión y usar otra cuenta",
      "title": "Ya has iniciado sesión"
    },
    "backToLogin": "Volver a iniciar sesión",
    "biometricSignIn": "Iniciar sesión con biometría",
    "checkEmail": "Revisa tu correo electrónico",
    "confirmPassword": "Confirmar contraseña",
    "createNewPassword": "Crear nueva contraseña",
    "createStrongPassword": "Crea una contraseña fuerte para tu cuenta",
    "email": "Correo electrónico",
    "enterEmailToReset": "Introduce tu correo electrónico para restablecer tu contraseña",
    "enterNewPassword": "Introduce tu nueva contraseña a continuación",
    "errors": {
      "invalidCredentials": "Correo electrónico o contraseña inválidos. Por favor, inténtalo de nuevo.",
      "invalidVerificationCode": "Código de verificación inválido. Por favor, inténtalo de nuevo.",
      "resetFailed": "No se pudo restablecer la contraseña. Por favor, inténtalo de nuevo o solicita un nuevo enlace de restablecimiento.",
      "twoFactorRequiredOnReset": "Se requiere autenticación de dos factores. Por favor, inicia sesión normalmente y restablece tu contraseña desde Configuración.",
      "unableToCreate": "No se pudo crear la cuenta. Por favor, inténtalo de nuevo.",
      "unableToProcess": "No se pudo procesar tu solicitud. Por favor, inténtalo de nuevo más tarde.",
      "unableToResend": "No se pudo reenviar el código. Por favor, inténtalo de nuevo."
    },
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "forgotPasswordTitle": "¿Olvidaste la contraseña?",
    "goToLogin": "Ir a iniciar sesión",
    "hidePassword": "Ocultar contraseña",
    "newPassword": "Nueva contraseña",
    "oauthError": "No se pudo completar la autenticación OAuth. Por favor, intenta de nuevo.",
    "oauthFailed": "Error en el inicio de sesión",
    "oauthRedirecting": "Redirigiéndote ahora...",
    "oauthSuccess": "¡Inicio de sesión exitoso!",
    "oauthVerifying": "Por favor, espera mientras verificamos tu cuenta",
    "password": "Contraseña",
    "passwordResetSuccess": "¡Contraseña restablecida con éxito!",
    "passwordResetSuccessDesc": "Tu contraseña ha sido restablecida con éxito",
    "passwordResetSuccessTitle": "Restablecimiento de contraseña exitoso",
    "resendEmail": "Reenviar correo electrónico",
    "resetCode": "Código de restablecimiento",
    "resetLinkInstructions": "Haz clic en el enlace del correo electrónico para restablecer tu contraseña. El enlace caducará en 1 hora.",
    "resetLinkSent": "¡Enlace de restablecimiento de contraseña enviado a tu correo electrónico!",
    "resetLinkSentTo": "Hemos enviado un enlace de restablecimiento de contraseña a {{email}}",
    "resetPassword": "Restablecer contraseña",
    "returnToLogin": "Volver a iniciar sesión",
    "sendResetCode": "Enviar código de restablecimiento",
    "sendResetLink": "Enviar enlace de restablecimiento",
    "sessionExpiring": "Sesión a punto de expirar",
    "sessionExpiringDesc": "Has estado inactivo. Se cerrará tu sesión en {{seconds}} segundos.",
    "showPassword": "Mostrar contraseña",
    "signIn": "Iniciar sesión",
    "signOut": "Cerrar sesión",
    "staySignedIn": "Mantener sesión iniciada",
    "validation": {
      "passwordsMatch": "Las contraseñas coinciden"
    },
    "providerErrors": {
      "emailTaken": "Ya existe una cuenta con este correo electrónico. Inicia sesión.",
      "accountNotFound": "No hemos encontrado ninguna cuenta con este correo electrónico.",
      "passwordIncorrect": "La contraseña no es correcta. Inténtalo de nuevo o restablécela.",
      "credentialsIncorrect": "El correo electrónico o la contraseña no son correctos.",
      "passwordBreached": "Esta contraseña ha aparecido en una filtración de datos. Elige otra, por favor.",
      "passwordTooShort": "La contraseña debe tener al menos {{passwordMinLength}} caracteres.",
      "passwordTooWeak": "Esta contraseña es demasiado débil. Elige una más segura, por favor.",
      "passwordUnchanged": "La nueva contraseña debe ser distinta de la actual.",
      "codeIncorrect": "Ese código no es correcto. Revisa el correo e inténtalo de nuevo.",
      "codeExpired": "Ese código ha caducado. Pide uno nuevo.",
      "codeAttemptsExhausted": "Demasiados códigos incorrectos. Pide uno nuevo.",
      "emailInvalid": "Introduce una dirección de correo electrónico válida.",
      "emailNotAllowed": "Esta dirección de correo electrónico no se puede usar aquí.",
      "tooManyAttempts": "Demasiados intentos. Espera unos minutos e inténtalo de nuevo.",
      "accountLocked": "Tu cuenta está bloqueada temporalmente tras demasiados intentos. Inténtalo más tarde.",
      "alreadySignedIn": "Ya has iniciado sesión.",
      "botCheckFailed": "No hemos podido verificar esta solicitud. Actualiza la página e inténtalo de nuevo.",
      "passwordNotSet": "Esta cuenta no usa contraseña. Inicia sesión del mismo modo en que la creaste.",
      "accountUnavailable": "Esta cuenta no se puede usar. Ponte en contacto con el soporte, por favor.",
      "networkUnreachable": "No hemos podido conectar con el servidor. Comprueba tu conexión e inténtalo de nuevo.",
      "passwordTooLong": "Esta contraseña es demasiado larga. Elige una más corta, por favor.",
      "reverificationRequired": "Por seguridad, cierra sesión y vuelve a iniciarla; después inténtalo de nuevo.",
      "socialCancelled": "Se canceló el inicio de sesión. Puedes intentarlo de nuevo o usar tu correo electrónico.",
      "socialAccountInUse": "Esa cuenta ya está vinculada a otra cuenta de Tonnie. Inicia sesión en esa cuenta o elige otra opción."
    },
    "passwordRule": {
      "length": "Al menos {{passwordMinLength}} caracteres",
      "advice": "Unas cuantas palabras juntas forman una contraseña fuerte y fácil de recordar.",
      "levels": {
        "weak": "Débil",
        "fair": "Aceptable",
        "good": "Buena",
        "strong": "Fuerte"
      }
    },
    "passwordCard": {
      "signOutOthers": "Cerrar sesión en los demás dispositivos",
      "signOutOthersHint": "Quien tenga tu cuenta abierta en otro sitio necesitará la nueva contraseña."
    },
    "social": {
      "continueWith": "Continuar con {{provider}}",
      "failed": "No hemos podido iniciar tu sesión con {{provider}}. Inténtalo de nuevo o usa tu correo electrónico.",
      "failedGeneric": "No hemos podido completar el inicio de sesión. Inténtalo de nuevo o usa tu correo electrónico.",
      "signingIn": "Iniciando sesión…",
      "signingInDesc": "Un momento mientras completamos el inicio de sesión.",
      "returnFailed": "No hemos podido completar el inicio de sesión",
      "returnFailedDesc": "La vuelta desde la página de inicio de sesión tardó demasiado. Inténtalo de nuevo."
    },
    "signUpContinue": {
      "unsupported": "No hemos podido terminar de crear tu cuenta",
      "unsupportedDesc": "Ese inicio de sesión necesita algo que no pedimos. Empieza de nuevo o regístrate con tu correo electrónico.",
      "startAgain": "Empezar de nuevo"
    },
    "connected": {
      "connect": "Vincular {{provider}}",
      "disconnect": "Desvincular",
      "disconnectTitle": "¿Desvincular {{provider}}?",
      "disconnectDesc": "Ya no podrás iniciar sesión con {{provider}}. Podrás seguir iniciando sesión con tu correo electrónico.",
      "connected": "{{provider}} está vinculado. Ya puedes iniciar sesión con él.",
      "disconnected": "{{provider}} se ha desvinculado.",
      "failed": "No hemos podido vincular {{provider}}. Inténtalo de nuevo.",
      "disconnectFailed": "No hemos podido desvincular {{provider}}. Inténtalo de nuevo."
    },
    "brand": {
      "name": "Tonnie",
      "copyright": "© {{year}} Tonnie",
      "citizen": {
        "signInHeadline": "Tu mudanza al extranjero, guiada paso a paso.",
        "signInSubline": "Un solo lugar para tu proceso de reubicación — desde el primer CheckUp hasta sentirte en casa.",
        "signUpHeadline": "Empieza tu mudanza con un plan.",
        "signUpSubline": "Crea tu cuenta y Tonnie te guía en cada paso — antes de irte, el día de la mudanza y cuando llegues.",
        "checkup": "Descubre en qué punto estás antes de mudarte",
        "teleportal": "Todas las tareas de la mudanza, en orden",
        "qultureup": "Conoce la cultura antes de llegar",
        "care": "Apoyo cuando llegues",
        "passport": "Cada hito de tu viaje, sellado"
      },
      "business": {
        "signInHeadline": "Reubica a tu talento con confianza.",
        "signInSubline": "Invita, patrocina y sigue la mudanza de cada contratación — en un solo lugar.",
        "signUpHeadline": "Reúne en un solo lugar las reubicaciones de tu equipo.",
        "signUpSubline": "Crea la cuenta de tu empresa e invita a las personas que estás reubicando cuando quieras.",
        "vetting": "Descubre quién está listo para mudarse",
        "mobility": "Todas las tareas de la reubicación, en orden",
        "adaptation": "Ayuda a quien llega a instalarse",
        "care": "Apoyo después de la llegada"
      }
    },
    "flow": {
      "back": "Atrás",
      "continue": "Continuar",
      "orWithEmail": "o con tu correo electrónico",
      "or": "o",
      "emailLabel": "Correo electrónico",
      "emailPlaceholder": "nombre@ejemplo.com",
      "change": "Cambiar",
      "signIn": {
        "title": "Te damos la bienvenida de nuevo",
        "descriptionCitizen": "Inicia sesión para continuar tu viaje.",
        "descriptionBusiness": "Inicia sesión en el espacio de trabajo de tu empresa.",
        "newHere": "¿Eres nuevo en Tonnie?",
        "createAccount": "Crear una cuenta",
        "noAccount": "No hay ninguna cuenta de Tonnie con este correo electrónico."
      },
      "password": {
        "title": "Introduce tu contraseña",
        "label": "Contraseña",
        "forgot": "¿Has olvidado tu contraseña?",
        "submit": "Iniciar sesión",
        "codeInstead": "Entrar con un código por correo"
      },
      "code": {
        "title": "Revisa tu correo",
        "description": "Hemos enviado un código de 6 dígitos a {{email}}.",
        "newDevice": "Este dispositivo es nuevo para nosotros. Hemos enviado un código de 6 dígitos a {{email}} para confirmar que eres tú.",
        "label": "Código de 6 dígitos",
        "submit": "Iniciar sesión",
        "resend": "Enviar un código nuevo",
        "resendIn": "Podrás enviar un código nuevo en {{seconds}} s."
      },
      "totp": {
        "title": "Introduce el código del autenticador",
        "description": "Abre tu aplicación de autenticación e introduce el código de 6 dígitos de Tonnie.",
        "label": "Código del autenticador"
      },
      "signUp": {
        "title": "Crea tu cuenta",
        "description": "Usa una cuenta que ya tengas, o tu correo electrónico.",
        "haveAccount": "¿Ya tienes una cuenta?",
        "signIn": "Iniciar sesión",
        "emailTaken": "Ya existe una cuenta con este correo electrónico.",
        "signInInstead": "Iniciar sesión",
        "legal": "Al continuar, aceptas los términos de Tonnie.",
        "terms": "Términos del servicio",
        "privacy": "Política de privacidad",
        "step": "Paso {{current}} de {{total}}",
        "detailsTitle": "Cuéntanos sobre ti",
        "firstName": "Nombre",
        "lastName": "Apellidos",
        "passwordLabel": "Crea una contraseña",
        "submit": "Crear cuenta",
        "codeNext": "Después te enviaremos un código por correo para confirmar la dirección.",
        "codeTitle": "Confirma tu correo electrónico",
        "codeSubmit": "Confirmar"
      },
      "invitation": {
        "signIn": "Esta invitación se envió a {{email}}. Inicia sesión con esa dirección para aceptarla.",
        "signUp": "Esta invitación se envió a {{email}}. Crea tu cuenta con esa dirección para aceptarla."
      }
    },
    "security": {
      "methods": {
        "title": "Métodos de acceso",
        "description": "Todas las formas de entrar en tu cuenta de Tonnie, en un solo lugar."
      },
      "email": {
        "label": "Correo electrónico",
        "badge": "Acceso y mensajes",
        "change": "Cambiar"
      },
      "password": {
        "label": "Contraseña",
        "set": "Configurada — úsala con tu correo para iniciar sesión.",
        "notSetWith": "Sin configurar — inicias sesión con {{providers}} o con un código enviado a tu correo.",
        "notSet": "Sin configurar — inicias sesión con un código enviado a tu correo.",
        "add": "Añadir contraseña",
        "change": "Cambiar"
      },
      "connected": {
        "heading": "Cuentas vinculadas",
        "connected": "Vinculada",
        "notConnected": "Sin vincular",
        "connect": "Vincular",
        "description": "Inicia sesión con una cuenta que ya tienes."
      },
      "sessions": {
        "title": "Dónde tienes la sesión iniciada",
        "description": "Cierra la sesión en cualquier lugar que no reconozcas.",
        "signOutOthers": "Cerrar sesión en los demás dispositivos",
        "thisDevice": "Este dispositivo",
        "signOut": "Cerrar sesión",
        "none": "No hay sesiones abiertas en otros dispositivos."
      },
      "passwordDialog": {
        "changeTitle": "Cambiar contraseña",
        "addTitle": "Añadir una contraseña",
        "description": "La usarás la próxima vez que inicies sesión con tu correo.",
        "current": "Contraseña actual",
        "new": "Nueva contraseña",
        "confirm": "Confirmar nueva contraseña",
        "submitChange": "Actualizar contraseña",
        "submitAdd": "Añadir contraseña"
      },
      "emailDialog": {
        "step": "Paso {{current}} de {{total}}",
        "title": "Cambiar tu correo electrónico",
        "description": "Enviaremos un código a la nueva dirección. Nada cambia hasta que lo introduzcas.",
        "current": "Actual",
        "new": "Nuevo correo electrónico",
        "linkedNote": "{{provider}} sigue iniciando tu sesión. Su dirección sigue vinculada y este cambio no la afecta.",
        "send": "Enviar código",
        "codeTitle": "Introduce el código",
        "codeDescription": "Lo hemos enviado a {{email}}.",
        "codeLabel": "Código",
        "confirm": "Confirmar nuevo correo",
        "resend": "Enviar un código nuevo",
        "doneTitle": "Tu correo electrónico ha cambiado",
        "close": "Listo"
      }
    },
    "welcome": {
      "haveAccount": "Ya tengo una cuenta"
    },
    "stepUp": {
      "title": "Confirma que eres tú",
      "description": "Por seguridad, confirma que eres tú antes de este cambio.",
      "password": "Tu contraseña",
      "continue": "Continuar",
      "useCode": "Recibir un código por correo",
      "confirm": "Confirmar",
      "failed": "No hemos podido confirmar que eres tú. Inténtalo de nuevo.",
      "unavailable": "No hemos podido confirmar que eres tú aquí. Cierra e inténtalo más tarde."
    }
  },
  "billing": {
    "availableJourneys": "Trayectos disponibles",
    "basicAccess": "Acceso básico",
    "cancel": "Cancelar",
    "cancelFailed": "No se pudo cancelar la suscripción. Por favor, inténtalo de nuevo.",
    "cancelFamilyAddon": "Cancelar complemento familiar",
    "cancelFamilyAddonError": "No se pudo cancelar el complemento familiar",
    "cancelFamilyDesc": "Tus familiares perderán el acceso al final del período de facturación actual.",
    "cancelMessage": "¿Estás seguro de que deseas cancelar tu suscripción Pro? Mantendrás el acceso hasta el final de tu período de facturación.",
    "cancelSubscriptionError": "Error al cancelar la suscripción",
    "cancelSuccess": "Suscripción cancelada. El acceso continúa hasta el final del período.",
    "cancelTitle": "Cancelar suscripción",
    "checkoutError": "No se pudo iniciar el pago. Por favor, inténtalo de nuevo.",
    "checkoutFailed": "No se pudo iniciar el pago. Por favor, inténtalo de nuevo.",
    "commitmentNote": "Sin compromiso: cancela cuando quieras.",
    "confirmCancellation": "Confirmar cancelación",
    "contactSupport": "Contactar con soporte",
    "createFirstJourney": "Crea tu primer trayecto",
    "currentPlan": "Plan actual",
    "downgradeToFree": "Bajar a gratis",
    "email": "Correo electrónico",
    "emailPlaceholder": "member@example.com",
    "expired": "Caducado",
    "expires": "Caduca",
    "expiringSoon": "Caducando pronto",
    "familyAddonError": "Error al comprar el complemento familiar. Por favor, inténtalo de nuevo.",
    "familyCancelFailed": "Error al cancelar el complemento familiar. Por favor, inténtalo de nuevo.",
    "familyCancelSuccess": "Tu complemento familiar ha sido cancelado.",
    "familyDesc": "Lleva a tu familia contigo: acceso compartido a tu trayecto de reubicación.",
    "familyMembersWithAccess": "Familiares con acceso",
    "familyProgram": "Programa familiar",
    "familyProgramAccess": "Acceso al programa familiar",
    "familyPurchaseFailed": "Error al comprar el complemento familiar. Por favor, inténtalo de nuevo.",
    "freeDescription": "Acceso limitado a las funciones de Tonnie",
    "freePlan": "Plan gratuito",
    "fullAccess": "Acceso completo",
    "invalidEmail": "Por favor, introduce una dirección de correo electrónico válida",
    "inviteDesc": "Envía una invitación para que puedan unirse a tu trayecto.",
    "inviteFailed": "Error al enviar la invitación. Por favor, inténtalo de nuevo.",
    "inviteFamilyMember": "Invitar a un familiar",
    "inviteMember": "Enviar invitación",
    "inviteSent": "Invitación enviada a {{email}}",
    "journeyInstances": "Tus trayectos",
    "journeyUnlockedPro": "Este trayecto está desbloqueado con Pro.",
    "keepAddon": "Mantener complemento",
    "keepPro": "Mantener Pro",
    "locked": "Bloqueado",
    "manageHousehold": "Gestionar hogar",
    "members": "Miembros",
    "monthly": "Mensual",
    "monthlyPrice": "Precio mensual",
    "needHelp": "¿Necesitas ayuda?",
    "nextRenewal": "Próxima renovación",
    "noFamilyMembers": "Aún no hay familiares",
    "noJourneyInstances": "Todavía no tienes trayectos",
    "paymentAlreadyProcessed": "Pago ya procesado. ¡Tu viaje está activo!",
    "paymentCompleted": "¡Pago completado! Tu viaje ha sido desbloqueado.",
    "paymentStillProcessing": "El pago aún se está procesando. Por favor, espera un momento y actualiza.",
    "paymentSuccessUnlocked": "¡Pago exitoso! Tu viaje ha sido desbloqueado.",
    "paymentVerificationIssue": "Problema de verificación de pago. Por favor, contacta con soporte si tu viaje no está desbloqueado.",
    "pending": "Pendiente",
    "perMonth": "/mes",
    "perYear": "/año",
    "pro": "Pro",
    "proDescription": "Viajes ilimitados, todas las funciones, soporte prioritario",
    "proFullAccessDesc": "Acceso completo a todos los héroes, herramientas y documentos de tu trayecto.",
    "proPlan": "Plan Pro",
    "proUnlockDesc": "Desbloquea el trayecto completo con Pro.",
    "proceedToPayment": "Continuar al pago",
    "processing": "Procesando",
    "purchaseFamilyAddon": "Añadir el programa familiar",
    "purchased": "Comprado",
    "recentInvoices": "Facturas recientes",
    "recommended": "Recomendado",
    "renewFailed": "Error al renovar el viaje. Por favor, inténtalo de nuevo.",
    "renewJourney": "Renovar viaje",
    "renewStripeDesc": "Te llevaremos a Stripe para renovar tu suscripción de forma segura.",
    "revokeAccess": "Revocar acceso",
    "revokeConfirm": "¿Estás seguro de que deseas revocar el acceso de este miembro?",
    "revokeFailed": "Error al revocar el acceso. Por favor, inténtalo de nuevo.",
    "revokeSuccess": "Acceso revocado con éxito",
    "sendInvite": "Enviar invitación",
    "sending": "Enviando",
    "statusActive": "Activa",
    "stripeRedirectDesc": "Te llevaremos a Stripe para completar el pago de forma segura.",
    "title": "Facturación",
    "unlockFailed": "Error al desbloquear el viaje. Por favor, inténtalo de nuevo.",
    "unlockJourney": "Desbloquear viaje",
    "unlockNow": "Desbloquear ahora",
    "unlocked": "Desbloqueado",
    "unlockedJourneys": "Trayectos desbloqueados",
    "upgradeToPro": "Actualizar a Pro",
    "verificationFailed": "No se pudo verificar la sesión de pago.",
    "verificationIssue": "Pago completado, pero hubo un problema con la verificación. Tu acceso debería actualizarse en breve.",
    "verifyPaymentError": "No se pudo verificar el pago. Por favor, actualiza la página o contacta con soporte.",
    "yearly": "Anual",
    "yearlyDiscount": "Ahorra con la facturación anual",
    "planChangesUnavailable": "Los cambios de plan no están disponibles en esta aplicación.",
    "invoiceKind": {
      "journey_unlock": "Desbloqueo del viaje",
      "journey_renewal": "Renovación del viaje",
      "talent_sponsorship": "Patrocinio de talento",
      "pro_subscription": "Suscripción Pro",
      "enterprise_subscription": "Suscripción Enterprise",
      "family_addon": "Complemento familiar",
      "subscription": "Suscripción",
      "inout_consultation": "Consulta InOut",
      "inout_requisition": "Solicitud InOut"
    },
    "invoiceStatus": {
      "draft": "Borrador",
      "open": "Pendiente de pago",
      "paid": "Pagada",
      "void": "Anulada",
      "uncollectible": "Pago fallido"
    },
    "planFeature": {
      "checkup_basic": "Acceso básico a CheckUp",
      "career_basic": "Herramientas de carrera básicas",
      "teleportal_limited": "Acceso limitado a TelePortal",
      "qultureup_limited": "Acceso limitado a QultureUp",
      "copilot_limited": "Uso limitado de CoPilot",
      "passport_basic": "Acceso básico a Passport",
      "journeys_unlimited": "Viajes ilimitados",
      "checkup_full": "Acceso completo a CheckUp",
      "teleportal_full": "Acceso completo a TelePortal",
      "qultureup_full": "Acceso completo a QultureUp",
      "copilot_unlimited": "Uso ilimitado de CoPilot",
      "care_advanced": "Funciones avanzadas de Care",
      "passport_full": "Acceso completo a Passport",
      "career_tools": "Herramientas de Career",
      "journey_access_shared": "Acceso compartido al viaje",
      "family_dashboard": "Panel familiar",
      "seats_unlimited": "Puestos ilimitados",
      "candidates_unlimited": "Candidatos ilimitados",
      "programs_unlimited": "Programas ilimitados",
      "cohorts_unlimited": "Cohortes ilimitadas",
      "copilot_queries_unlimited": "Preguntas a CoPilot ilimitadas",
      "analytics_basic": "Analítica básica",
      "analytics_advanced_api": "Analítica avanzada y API",
      "mobility_adaptation_full": "Itinerarios completos de Movilidad y Adaptación",
      "yearly_two_months_free": "2 meses gratis frente al mensual",
      "sponsorship_full_access": "Acceso completo al viaje y al área ciudadana para el talento",
      "sponsorship_heroes": "CheckUp, TelePortal, QultureUp y Care",
      "sponsorship_passport": "Passport y logros",
      "family_access_optional": "Complemento opcional de acceso familiar",
      "discount_vs_free": "{{count}}% de descuento frente al plan Gratis",
      "support_email": "Soporte por correo",
      "support_priority": "Soporte prioritario",
      "family_members_up_to_one": "Hasta {{count}} miembro de la familia",
      "family_members_up_to_other": "Hasta {{count}} miembros de la familia",
      "seats_one": "{{count}} puesto (un usuario)",
      "seats_other": "{{count}} puestos",
      "candidates_up_to_one": "Hasta {{count}} candidato",
      "candidates_up_to_other": "Hasta {{count}} candidatos",
      "programs_one": "{{count}} programa",
      "programs_other": "{{count}} programas",
      "cohorts_one": "{{count}} cohorte",
      "cohorts_other": "{{count}} cohortes",
      "copilot_queries_monthly_one": "{{count}} pregunta a CoPilot al mes",
      "copilot_queries_monthly_other": "{{count}} preguntas a CoPilot al mes",
      "access_window_months_one": "Acceso durante {{count}} mes",
      "access_window_months_other": "Acceso durante {{count}} meses"
    },
    "seeAllInvoices": "Ver todas",
    "profile": {
      "validation": {
        "legalNameRequired": "Indica el nombre para la factura.",
        "countryRequired": "Elige el país de facturación.",
        "addressRequired": "Indica la dirección de facturación.",
        "postalCodeRequired": "Indica el código postal.",
        "cityRequired": "Indica la ciudad.",
        "taxIdInvalid": "Este número fiscal no es válido para el país elegido.",
        "tooLong": "Es demasiado largo.",
        "taxIdRequired": "Indica el número fiscal de la empresa."
      },
      "title": "Datos de facturación",
      "description": "A quién se emiten tus facturas. Un cambio se aplica a tu próximo pago.",
      "add": "Añadir datos",
      "edit": "Editar",
      "empty": "Aún no hay datos de facturación. Se te pedirán antes de tu primer pago.",
      "legalName": "Nombre en la factura",
      "taxId": "Número fiscal",
      "taxIdHint": "Opcional. Añádelo si lo quieres en tus facturas.",
      "noTaxId": "No indicado",
      "country": "País de facturación",
      "countryPlaceholder": "Elige un país",
      "address": "Dirección",
      "addressLine1": "Dirección",
      "addressLine2": "Dirección (continuación)",
      "postalCode": "Código postal",
      "city": "Ciudad",
      "save": "Guardar",
      "saveAndContinue": "Guardar y continuar al pago",
      "saveFailed": "No se pudieron guardar tus datos de facturación. Inténtalo de nuevo.",
      "beforePaymentTitle": "Datos para tu factura",
      "beforePaymentDescription": "Cada pago incluye su factura-recibo. Dinos a quién emitirla y seguimos al pago."
    },
    "invoiceDocument": {
      "certified": "Ver factura-recibo",
      "invoice": "Ver factura",
      "receipt": "Ver recibo"
    },
    "statusPastDue": "Pago pendiente",
    "statusCancelled": "Cancelado",
    "statusExpired": "Caducado",
    "loadError": "No se ha podido cargar tu plan."
  },
  "biometric": {
    "authenticating": "Autenticando...",
    "benefits": {
      "dataOnDevice": "Tus datos permanecen en el dispositivo",
      "fastLogin": "Inicio de sesión rápido con un toque",
      "secure": "Seguro y encriptado"
    },
    "enable": "Habilitar {{name}}",
    "maybeLater": "Quizás más tarde",
    "settingUp": "Configurando...",
    "touchSensorOrLook": "Toca el sensor o mira tu dispositivo para autenticarte",
    "tryAgain": "Intenta de nuevo",
    "use": "Usar {{name}}",
    "usePasswordInstead": "Usar contraseña en su lugar",
    "type": {
      "iris": "Escaneo de iris",
      "generic": "Biométrico"
    },
    "usePasscode": "Usar código de acceso",
    "authenticatePrompt": "Autenticar para continuar",
    "verifyToEnablePrompt": "Verifica para habilitar el inicio de sesión biométrico",
    "error": {
      "initFailed": "Error al inicializar la autenticación biométrica",
      "notSupported": "Autenticación biométrica no soportada",
      "lockout": "Demasiados intentos fallidos. Por favor, inténtalo de nuevo más tarde.",
      "authFailed": "Autenticación fallida",
      "enableFailed": "Error al habilitar la autenticación biométrica",
      "disableFailed": "Error al deshabilitar la autenticación biométrica"
    }
  },
  "sponsorships": {
    "offer": {
      "fallbackCompany": "Tu patrocinador",
      "headline": "{{company}} le gustaría patrocinar tu viaje",
      "subheadline": "Acepta para desbloquear la experiencia Pro completa — sin costo para ti.",
      "loading": "Cargando detalles de la oferta…",
      "unlocks": {
        "title": "Qué incluye el patrocinio",
        "checkup": "Evaluación completa de CheckUp",
        "teleportal": "Manual de reubicación de TelePortal",
        "qultureup": "Integración cultural de QultureUp",
        "care": "Care para el viaje de inmigración",
        "passport": "Passport — tu registro portátil"
      },
      "route": "Ruta: {{from}} → {{to}}",
      "declineNote": "Si rechazas, la empresa será reembolsada automáticamente. Mantendrás tu acceso de nivel básico de todos modos.",
      "declineCta": "Rechazar",
      "acceptCta": "Aceptar patrocinio",
      "decline": {
        "title": "¿Rechazar este patrocinio?",
        "body": "{{company}} será reembolsado en su totalidad. Aún puedes completar tu CheckUp en el nivel básico.",
        "reasonLabel": "Dile a {{company}} por qué (opcional)",
        "cancel": "Cancelar",
        "confirmCta": "Rechazar de todos modos",
        "bodyKeepsAccess": "{{company}} recibirá el reembolso completo. Tu viaje queda exactamente como está."
      },
      "accepted": {
        "toast": "¡Bienvenido a bordo! Tu viaje ahora está completamente patrocinado."
      },
      "declined": {
        "toast": "Patrocinio rechazado. {{company}} ha sido reembolsado."
      },
      "errors": {
        "load": "No pudimos cargar esta oferta de patrocinio.",
        "accept": "No se pudo aceptar el patrocinio en este momento.",
        "decline": "No se pudo rechazar el patrocinio en este momento.",
        "notOpen": "Esta oferta ya no está disponible: ya se respondió o se retiró."
      },
      "dedicatedNote": "{{company}} patrocinará un viaje nuevo solo tuyo en esta ruta. Tu viaje actual se queda como está, con las empresas que ya lo siguen.",
      "takeover": {
        "subheadline": "{{company}} cubrirá este viaje a partir de ahora, sin coste para ti.",
        "pro": {
          "title": "Ya tienes acceso completo con Pro",
          "body": "{{company}} se hace cargo de este viaje. Tu Pro sigue cubriendo tus otros viajes, y este vuelve a tu Pro si se cancela el patrocinio."
        },
        "paid": {
          "title": "Ya pagaste este viaje",
          "refund": "{{company}} se hace cargo, y te reembolsamos {{amount}} —la parte no usada del desbloqueo del viaje— en tu método de pago original. Los reembolsos suelen llegar en 5–10 días hábiles.",
          "noRefund": "{{company}} se hace cargo. No queda nada por reembolsar del desbloqueo del viaje."
        },
        "declineNote": "Si lo rechazas, la empresa recibe el reembolso automáticamente y tu viaje queda exactamente como está."
      },
      "card": {
        "eyebrow": "Oferta de patrocinio",
        "detail": "Tu viaje a {{country}}",
        "detailDedicated": "Un viaje nuevo solo tuyo a {{country}}",
        "review": "Ver oferta",
        "actionFailed": "No se ha podido completar. Revisa tu conexión e inténtalo de nuevo."
      },
      "notNow": "Ahora no",
      "deferredUntil": "Has aplazado esta oferta por ahora. Te espera aquí hasta que decidas y vuelve a Inicio el {{date}}.",
      "list": {
        "title": "{{company}} quiere patrocinarte",
        "kind": "Patrocinio",
        "sent": "Enviada el {{date}}"
      }
    }
  },
  "business": {
    "externalWorlds": {
      "course": "Curso: {{language}}",
      "line": "{{world}} · {{language}}",
      "status": {
        "never_synced": "Sin progreso aún",
        "active": "Activo",
        "stalled": "Estancado",
        "paused": "En pausa",
        "goal_reached": "Meta alcanzada"
      },
      "hint": {
        "never_synced": "Todavía no ha llegado progreso de {{world}}.",
        "stalled": "Sin progreso desde hace {{days}} días.",
        "paused": "El ciudadano retiró su consentimiento para compartir con {{world}}: el progreso ya no llega y se muestra como estaba.",
        "goal_reached": "Alcanzó la meta del curso el {{date}}."
      },
      "bands": {
        "start": "Inicio",
        "current": "Ahora",
        "goal": "Meta"
      },
      "bandProgress": "{{percent}} del camino en {{band}}",
      "completion": "Itinerario completado",
      "noMissions": "Aún sin misiones",
      "progress": "Progreso global: {{percent}}",
      "paceLabel": "Ritmo",
      "pace_one": "{{count}} misión en los últimos 30 días",
      "pace_other": "{{count}} misiones en los últimos 30 días",
      "lastActivityLabel": "Último progreso",
      "reduced": "Por ahora, {{world}} envía solo el nivel actual, así que los porcentajes son sobre ese nivel.",
      "summaryOnly": "Solo un resumen: las misiones y sus títulos se quedan con el ciudadano."
    },
    "activity": {
      "title": "Actividad",
      "subtitle": "Todo lo que sucede en tus talentos",
      "empty": "Sin actividad aún",
      "untitled": "Actividad"
    },
    "pipeline": {
      "stages": {
        "acquisition": "Adquisición",
        "vetting": "Evaluación",
        "mobility": "Movilidad",
        "integration": "Integración",
        "adaptation": "Adaptación",
        "care": "Care",
        "evidence": "Evidencia",
        "sponsored": "Patrocinado",
        "pending_invite": "Invitación pendiente",
        "archived": "Archivado",
        "cohort_assigned": "Cohorte asignada",
        "unknown": "Desconocido"
      },
      "talentActions": "Acciones de talento"
    },
    "about": {
      "aboutUs": "Sobre nosotros",
      "backToDashboard": "Volver al tablero",
      "heroCare": "Gestión de puntos de control de Care y seguimiento del bienestar",
      "heroCheckup": "Resultados de CheckUp, puntuaciones de MESH y perspectivas de iQulture para la evaluación",
      "heroEvidence": "Evidencia de Passport/IRR y resultados del programa",
      "heroPrograms": "Gestión de programas y cohortes",
      "heroQultureup": "Progreso de adaptación de QultureUp a través de Mundos, Pistas y Misiones",
      "heroSponsored": "Asignaciones y facturación de viajes patrocinados",
      "heroTeleportal": "Progreso de TelePortal en las pistas de Legal, Viaje y Configuración",
      "heroes": "Héroes",
      "heroesDesc": "Conoce a los héroes detrás de Tonnie — el equipo dedicado a transformar la movilidad global de talento.",
      "learnMore": "Aprende más sobre Tonnie Business",
      "platformOverview": "Descripción general de la plataforma",
      "platformOverviewDesc": "Nuestra plataforma ayuda a las empresas a gestionar todo el ciclo de vida de la movilidad del talento: desde la búsqueda y selección hasta la reubicación y el cuidado continuo.",
      "termsAndPrivacy": "Términos y privacidad",
      "title": "Acerca de",
      "tonnieBusiness": "Tonnie Business",
      "tonnieBusinessDesc": "Tonnie Business es una plataforma integral para gestionar la movilidad internacional del talento, la contratación y los programas de integración.",
      "version": "Versión {{version}}"
    },
    "adaptationPage": {
      "active": "Activo",
      "activeFilter": "Activo",
      "activeTab": "Activo",
      "archivedTab": "Archivado",
      "activelyLearning": "Aprendiendo activamente",
      "attentionReason": {
        "inactive": "Sin actividad en más de 2 semanas",
        "declining": "Actividad en declive",
        "not_begun": "Evaluación realizada — aún sin misiones",
        "streak_at_risk": "Racha a punto de romperse"
      },
      "levels": {
        "beginner": "Principiante",
        "intermediate": "Intermedio",
        "advanced": "Avanzado"
      },
      "clearFilters": "Borrar filtros",
      "coach": "Entrenar",
      "errors": {
        "messageTooShort": "El mensaje debe tener al menos 5 caracteres",
        "messageTooLong": "El mensaje debe tener 500 caracteres o menos"
      },
      "nudge": "Empujón",
      "nudgeAria": "Envía un rápido recordatorio a {{name}}",
      "sendCoachAria": "Enviar mensaje de coaching a {{name}}",
      "sendMessage": "Enviar mensaje",
      "streakAtRisk": "Racha en riesgo",
      "talentRowActionsAria": "Acciones para {{name}}",
      "tryAdjustFilters": "Intenta ajustar tu búsqueda o filtros",
      "view": "Ver",
      "viewTalentAria": "Ver detalles para {{name}}",
      "aiCoachDesc": "Coaching sugerido para cada talento, según su progreso en QultureUp",
      "aiCoachRecommendations": "Recomendaciones del entrenador de IA",
      "alertDescription": "{{inactive}} talentos inactivos, {{atRisk}} en riesgo y {{streaks}} rachas en riesgo",
      "allCohorts": "Todos los cohortes",
      "allEngagement": "Todo el compromiso",
      "allTalents": "Todos los talentos",
      "atRiskExcl": "¡En riesgo!",
      "atRiskFilter": "En riesgo",
      "avgMiles": "Prom. Miles",
      "avgQultureUpCompletion": "Prom. QultureUp completación",
      "boostMotivation": "Aumentar la motivación",
      "celebrateTopPerformers": "Celebrar a los mejores desempeñadores",
      "coachAlert": "Alerta de entrenador",
      "coachTip1": "Los mensajes personalizados tienen 3 veces más interacción que los genéricos",
      "coachTip2": "Los talentos que reciben chequeos semanales tienen un 40% más de probabilidades de completar su viaje",
      "coachTip3": "Celebrar pequeñas victorias aumenta la motivación y la retención de rachas",
      "coachingCenter": "Centro de coaching",
      "coachingToolkit": "Kit de herramientas de coaching",
      "coachingToolkitDesc": "Herramientas de coaching personalizadas y plantillas de mensajes",
      "description": "Rastrea y gestiona el progreso de adaptación del talento, métricas de compromiso e insights de coaching",
      "engagement": "Compromiso",
      "engagementDistDesc": "Ver el compromiso del talento en diferentes niveles",
      "engagementDistribution": "Distribución del compromiso",
      "engagementLegendAria": "Cómo se calculan las bandas de compromiso",
      "engagementLegendTitle": "Cómo se calculan las bandas",
      "engagementLegendDesc": "Cada talento se clasifica según cuán recientemente estuvo activo, su racha diaria y cuántas misiones completó esta semana.",
      "quickActionsAllClear": "Todo claro",
      "quickActionsAllClearDesc": "No se necesitan acciones de coaching en este momento.",
      "coachingQueueTitle": "Cola de coaching",
      "coachingQueueDesc": "Cada talento agrupado por compromiso — los más urgentes primero.",
      "coachAllCount": "Entrenar a todos {{count}}",
      "noCoachingTalents": "No hay talentos en Adaptación aún",
      "noCoachingTalentsDesc": "Los talentos aparecen aquí una vez que comienzan su viaje de QultureUp.",
      "engagementTrends": "Aprendizaje de un vistazo",
      "engagementTrendsDesc": "Dónde están tus talentos esta semana",
      "filterByCohort": "Filtrar por cohorte",
      "gentleNudge": "Suave empujón",
      "healthDashboard": "Tablero de salud",
      "healthScore": "Puntuación de salud",
      "inactiveFilter": "Inactivo",
      "insights": "Perspectivas",
      "messageFailed": "Error al enviar el mensaje",
      "messageSent": "Mensaje {{type}} enviado a {{name}}",
      "miles": "Miles",
      "missions": "Misiones",
      "missionsThisWeek": "Misiones esta semana",
      "motivateActiveLearners": "Motiva a los aprendices activos con nuevos desafíos",
      "needAttention": "Necesita atención",
      "needsEncouragement": "Necesita ánimo",
      "noTalentsFound": "No se encontraron talentos",
      "notificationInApp": "El talento recibirá una notificación en la app",
      "overallProgress": "Progreso general",
      "quickCoachActions": "Acciones rápidas de coaching",
      "quickCoachActionsDesc": "Acciones de un clic para apoyar a tus talentos",
      "quickNudgeSent": "Se envió un empujón rápido a {{name}}",
      "reachInactiveTalents": "Alcanza a talentos inactivos",
      "recognizeAchievements": "Reconocer logros",
      "saveStreaks": "Guardar rachas",
      "score": "Puntuación",
      "searchTalents": "Buscar talentos...",
      "sendPersonalizedMessage": "Elige una acción y después añade una nota personal o envía el mensaje de tu empresa.",
      "sendWeeklyChallenge": "Enviar desafío semanal",
      "setGoals": "Establecer objetivos",
      "showYouCare": "Demuestra que te importa",
      "slowing": "Disminuyendo el ritmo",
      "slowingDownFilter": "Disminuyendo el ritmo",
      "streak": "Racha",
      "thriving": "Prosperando",
      "thrivingFilter": "Prosperando",
      "title": "Adaptación",
      "topPerformers": "Mejores desempeños",
      "topPerformersDesc": "Talentos con el mayor compromiso y progreso",
      "worlds": "Mundos",
      "writeYourMessage": "Escribe tu mensaje",
      "engagementDescriptions": {
        "thriving": "Altamente comprometido, progreso constante",
        "active": "Actividad regular, progreso constante",
        "slowing": "Actividad decreciente, puede necesitar ánimo",
        "at_risk": "Compromiso en declive, necesita atención",
        "inactive": "Sin actividad reciente, atención urgente necesaria"
      },
      "engagementCriteria": {
        "thriving": "Una racha de {{thrivingStreak}}+ días con un fuerte impulso esta semana",
        "active": "Activo recientemente con un impulso semanal constante",
        "slowing": "Inactivo más de {{slowingDays}} días, o reciente pero perdiendo impulso",
        "at_risk": "Inactivo más de {{atRiskDays}} días, o estancado sin progreso esta semana",
        "inactive": "Sin actividad en {{inactiveDays}}+ días"
      },
      "coachingBandMessage": {
        "thriving": "Celebra su progreso para reforzar el hábito.",
        "active": "Mantén el impulso con un nuevo desafío.",
        "slowing": "Un empujón a tiempo ahora les evita caer más.",
        "at_risk": "Contacta para eliminar obstáculos y reconstruir el impulso.",
        "inactive": "Reinvolucra con un chequeo personal antes de que se desconecten."
      },
      "coachingBandLabel": {
        "thriving": "Celebra los talentos florecientes",
        "active": "Desafía a los talentos activos",
        "slowing": "Entrena a los talentos que están disminuyendo",
        "at_risk": "Entrena a los talentos en riesgo",
        "inactive": "Entrena a los talentos inactivos"
      },
      "coachTipsTitle": "Consejos de coaching",
      "coachActions": {
        "encourage": "Animar",
        "challenge": "Desafiar",
        "checkin": "Registro",
        "celebrate": "Celebrar",
        "remind": "Recordar"
      },
      "insightsRecommendations": {
        "topWorldRecommend": "El Mundo de Exploración Cultural tiene el mayor compromiso — recomiéndalo a los talentos que están luchando",
        "sendReminders": "Enviar recordatorios",
        "celebrate": "Celebrar",
        "recommend": "Recomendar",
        "checkIn": "Registro",
        "streaksAtRisk_one": "{{count}} talento está a punto de perder su racha — envía un recordatorio ahora",
        "streaksAtRisk_other": "{{count}} talentos están a punto de perder sus rachas — envía recordatorios ahora",
        "thrivingCelebrate_one": "{{count}} talento está floreciendo — considera celebrar sus logros",
        "thrivingCelebrate_other": "{{count}} talentos están floreciendo — considera celebrar sus logros",
        "inactiveCheckIn_one": "{{count}} talento no ha iniciado sesión en más de 2 semanas — puede necesitar un check-in",
        "inactiveCheckIn_other": "{{count}} talentos no han iniciado sesión en más de 2 semanas — pueden necesitar un chequeo"
      },
      "trendMetrics": {
        "activeLearners": "Aprendices activos",
        "weeklyMissions": "Misiones semanales",
        "avgMiles": "Prom. Miles"
      },
      "noOneNeedsAttention": "Nadie necesita atención inmediata",
      "confirmBulkSend": "Enviar {{count}}",
      "personalNote": "Nota personal (opcional)",
      "personalNoteHint": "Déjalo vacío para enviar el mensaje de {{action}} de tu empresa, definido en Mensajes.",
      "ofTotal": "{{value}} de {{total}}",
      "viewAllInBand": "Ver los {{count}}",
      "dayStreak_one": "Racha de {{count}} día",
      "dayStreak_other": "Racha de {{count}} días",
      "engagementBandAria_one": "Mostrar {{count}} talento {{band}}",
      "engagementBandAria_other": "Mostrar {{count}} talentos {{band}}",
      "needsAttentionCount_one": "{{count}} necesita atención",
      "needsAttentionCount_other": "{{count}} necesitan atención",
      "milesCount_one": "{{count}} Mile",
      "milesCount_other": "{{count}} Miles",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos",
      "viewAllNeedingAttention_one": "Ver el {{count}} que necesita atención",
      "viewAllNeedingAttention_other": "Ver todos {{count}} que necesitan atención",
      "confirmBulkTitle_one": "¿Enviar {{count}} mensaje de coaching?",
      "confirmBulkTitle_other": "¿Enviar {{count}} mensajes de coaching?",
      "confirmBulkDescription_one": "A punto de enviar \"{{action}}\" a {{count}} talento. Recibirá una notificación en su aplicación móvil.",
      "confirmBulkDescription_other": "A punto de enviar \"{{action}}\" a {{count}} talentos. Cada uno recibirá una notificación en su aplicación móvil.",
      "searchTalentsLabel": "Buscar talentos",
      "sentCheckIns_one": "Check-in enviado a {{count}} talento",
      "sentCheckIns_other": "Check-in enviado a {{count}} talentos",
      "sendCheckInsTo_one": "Enviar un check-in a {{count}} talento inactivo",
      "sendCheckInsTo_other": "Enviar un check-in a {{count}} talentos inactivos",
      "sentStreakReminders_one": "Recordatorio de racha enviado a {{count}} talento",
      "sentStreakReminders_other": "Recordatorio de racha enviado a {{count}} talentos",
      "remindAboutStreaks_one": "Recordar a {{count}} talento con la racha en riesgo",
      "remindAboutStreaks_other": "Recordar a {{count}} talentos con la racha en riesgo",
      "recognizeThriving_one": "Reconocer a {{count}} talento destacado",
      "recognizeThriving_other": "Reconocer a {{count}} talentos destacados",
      "sentRecognition_one": "Reconocimiento enviado a {{count}} talento",
      "sentRecognition_other": "Reconocimiento enviado a {{count}} talentos",
      "sentChallenges_one": "Reto semanal enviado a {{count}} talento",
      "sentChallenges_other": "Reto semanal enviado a {{count}} talentos",
      "sentCoaching_one": "Coaching enviado a {{count}} talento",
      "sentCoaching_other": "Coaching enviado a {{count}} talentos"
    },
    "addTalentsWizard": {
      "addCohortToOrganize": "Agregar un nuevo grupo para organizar talentos",
      "atsIntegration": "Integración de ATS",
      "atsMethodDesc": "Conecta tu sistema ATS e importa candidatos directamente a tu pipeline. Sincroniza en tiempo real con tus herramientas de reclutamiento existentes.",
      "biWeekly": "Quincenal (primeras 8 semanas)",
      "cancel": "Cancelar",
      "chooseCohortForCandidates": "Elige a qué cohorte agregar estos candidatos",
      "chooseCohortForTalents": "Elige a qué grupo añadir a estos talentos",
      "clear": "Limpiar",
      "close": "Cerrar",
      "cohortCreated": "Grupo \"{{name}}\" creado con éxito",
      "cohortNamePlaceholder": "p. ej., Q2 2024 — Ingenieros Backend",
      "cohortNameRequired": "Nombre de la cohorte *",
      "cohortsCanExistWithoutProgram": "Los grupos pueden existir sin un programa. Las rutas se definen por talento al patrocinar.",
      "connectAdditionalATS": "Puedes conectar sistemas ATS adicionales desde la configuración de integraciones.",
      "createCohortButton": "Crear cohorte",
      "createCohortDesc": "Crea un nuevo grupo. Puedes asignarlo a un programa más tarde, o dejarlo sin asignar.",
      "createNewCohort": "Crear nueva cohorte",
      "createNewProgram": "Crear nuevo programa",
      "createProgramButton": "Crear programa",
      "createProgramDesc": "Crea un nuevo programa para organizar tus iniciativas de contratación internacional.",
      "defaultFeedbackCadence": "Cadencia de retroalimentación predeterminada",
      "describeProgramPlaceholder": "Describe los objetivos y el alcance del programa...",
      "descriptionOptional": "Descripción (opcional)",
      "deselectAll": "Deseleccionar todo",
      "downloadTemplateCsv": "Descargar plantilla CSV",
      "dropFileHere": "Suelta tu archivo aquí o haz clic para buscar",
      "email": "Correo electrónico",
      "enterProgramName": "Por favor, introduce un nombre de programa",
      "errorReason": "Razón",
      "errorReason_duplicate": "Duplicar",
      "errorReason_invalid": "Inválido",
      "errorReason_system": "Error del sistema",
      "errors": {
        "cohortNameRequired": "El nombre de la cohorte es obligatorio",
        "createCohortFailed": "No se pudo crear el grupo. Por favor, inténtalo de nuevo.",
        "createProgramFailed": "No se pudo crear el programa. Por favor, inténtalo de nuevo.",
        "emptyFile": "El archivo está vacío o no tiene filas de datos",
        "endDateInvalid": "Introduce una fecha de finalización válida",
        "malformedFile": "No pudimos leer este archivo. Intenta guardarlo como .csv y vuelve a subirlo.",
        "mustMapEmail": "Asocia al menos una columna con el correo electrónico antes de continuar",
        "mustMapName": "Asocia al menos una columna con el nombre (o nombre completo) antes de continuar",
        "noValidRows": "No se pasaron filas a la validación. Corrige los errores anteriores e inténtalo de nuevo.",
        "programNameRequired": "Se requiere el nombre del programa",
        "selectCohort": "Selecciona un grupo antes de continuar",
        "startDateInvalid": "Introduce una fecha de inicio válida",
        "startDateRequired": "La fecha de inicio es obligatoria",
        "systemFailure": "Algo salió mal. Por favor, inténtalo de nuevo.",
        "tooManyRows": "Los archivos están limitados a {{max}} filas. Divide tu archivo e inténtalo de nuevo.",
        "unsupportedFile": "Por favor, sube un archivo .csv, .xlsx o .xls",
        "planLimit": "El plan gratuito permite hasta 100 candidatos. Actualiza a Enterprise para añadir más.",
        "fileTooLarge": "El archivo es más grande de 10 MB. Recorta el archivo e inténtalo de nuevo.",
        "cohortAtCapacity": "Esta cohorte está completa ({{max}} talentos). Elige otra cohorte o amplía su límite.",
        "programAtCapacity": "Este programa está completo ({{max}} talentos). Elige otro programa o amplía su límite."
      },
      "excelColumn": "Columna de Excel",
      "excelCsvUpload": "Carga de Excel/CSV",
      "excelMethodDesc": "Importa talentos desde archivos de hoja de cálculo. Soporta formatos de Excel y CSV con mapeo automático de columnas.",
      "expectedTalentCount": "Número esperado de talentos (opcional)",
      "fieldLabels": {
        "email": "Correo electrónico",
        "firstName": "Nombre",
        "ignore": "Ignorar",
        "lastName": "Apellido",
        "location": "Ubicación",
        "name": "Nombre completo (se dividirá)",
        "role": "Rol",
        "skills": "Habilidades"
      },
      "fileReady": "¡Archivo listo!",
      "fillRequiredFields": "Por favor, completa todos los campos obligatorios",
      "firstName": "Nombre",
      "fixValidationErrors": "Por favor, corrige los errores de validación antes de continuar",
      "importCandidatesFrom": "Importar candidatos directamente desde {{name}}",
      "importMethodLabel": "Método de importación",
      "importSummary": "Resumen de importación",
      "invalidEmail": "Correo electrónico no válido",
      "invalidFileType": "Por favor, sube un archivo Excel o CSV válido",
      "inviteToVetting": "Invitar a la evaluación",
      "inviteToVettingFailed": "No se pudo invitar a los talentos",
      "lastName": "Apellido",
      "location": "Ubicación",
      "mapColumnsInstruction": "Mapea las columnas de Excel a los campos de Tonnie. Se muestran las primeras 5 filas:",
      "mapTo": "Mapear A",
      "match": "coincidir",
      "missingName": "Nombre faltante",
      "monthly": "Mensual (meses 3-6)",
      "name": "Nombre",
      "needDifferentATS": "¿Necesitas conectar un ATS diferente?",
      "noDataYet": "Aún no hay datos — los talentos en esta etapa poblarán esta vista",
      "noProgramUnassigned": "Sin programa (no asignado)",
      "plusMore": "+ Más",
      "poolMethodDesc": "Explora y añade talentos de tu Tonnie Talent Pool directamente a tu pipeline.",
      "programCreated": "Programa \"{{name}}\" creado con éxito",
      "programNamePlaceholder": "p. ej., Iniciativa de Talento Tecnológico",
      "programNameRequired": "Nombre del programa *",
      "programOptional": "Programa (opcional)",
      "quarterly": "Trimestral (meses 6-12)",
      "readyToImport": "Listo para importar talentos",
      "readyToMapColumns": "Listo para mapear columnas",
      "requiredFields": "El nombre y el correo electrónico son campos obligatorios",
      "resultDuplicates": "Duplicados",
      "resultFailed": "Fallido",
      "resultImported": "Importado",
      "resultPartial": "Algunos talentos no fueron importados",
      "role": "Rol",
      "samplePreview": "Valor de muestra",
      "searchPlaceholder": "Buscar por nombre, rol o ubicación...",
      "select": "Seleccionar",
      "selectATSError": "Por favor, selecciona un sistema ATS",
      "selectAllCount": "Seleccionar todo ({{count}})",
      "selectCandidateError": "Por favor, selecciona al menos un candidato",
      "selectCohortError": "Por favor, selecciona una cohorte",
      "selectFile": "Seleccionar archivo",
      "selectProgramOptional": "Seleccionar programa (opcional)",
      "selectedLabel": "Seleccionado",
      "startDateRequired": "Fecha de inicio *",
      "status": "Estado",
      "stepATS": "ATS",
      "stepCohort": "Cohorte",
      "stepConfirm": "Confirmar",
      "stepMap": "Mapear",
      "stepMethod": "Método",
      "stepReview": "Revisión",
      "stepSelect": "Seleccionar",
      "stepUpload": "Subir",
      "supportsFileTypes": "Soporta archivos de Excel (.xlsx, .xls) y CSV de hasta 10MB",
      "targetArrivalDate": "Fecha de llegada objetivo",
      "toastImportedHint": "Abre el Pipeline > columna de Adquisición y haz clic en Enviar invitación a Evaluación cuando estés listo para enviar un correo electrónico a cada candidato.",
      "toastNothingImported": "No se importaron talentos",
      "totalCandidates": "Total de candidatos",
      "totalTalents": "Total de talentos",
      "unassigned": "No Asignado",
      "uploadDifferentFile": "Sube un archivo diferente",
      "vettingNotStarted": "La evaluación no ha comenzado para este talento",
      "whatHappensNext": "¿Qué sucede a continuación?",
      "whatHappensNextDesc": "Después de importar, los talentos aparecerán en la etapa de Adquisición. Luego puedes invitarlos a CheckUp y patrocinar a aquellos que estén listos.",
      "addingToPill": "Añadiendo a: {{name}}",
      "guard": {
        "archivedTitle": "Esta cohorte está archivada",
        "pausedTitle": "Esta cohorte está en pausa",
        "programPausedTitle": "El programa principal está en pausa",
        "archivedBody": "Las cohortes archivadas no pueden aceptar nuevos talentos. Restaura la cohorte primero para invitar a personas a ella.",
        "pausedBody": "Las cohortes en pausa no pueden aceptar nuevos talentos. Reanuda la cohorte primero para invitar a personas a ella.",
        "programPausedBody": "El programa principal está en pausa. Reanuda el programa para comenzar a aceptar nuevos talentos en esta cohorte.",
        "cohortPill": "Cohorte: {{name}}"
      },
      "issues": {
        "emailInvalid": "Email no válido o ausente",
        "emailDuplicate": "Duplicado de la fila {{row}}",
        "nameMissing": "Falta el nombre",
        "textTooLong": "{{field}} supera los {{max}} caracteres",
        "skillsTooMany": "Más de {{max}} habilidades",
        "skillTooLong": "Una habilidad supera los {{max}} caracteres"
      },
      "candidatesAttached_one": "{{count}} candidato asociado al grupo",
      "candidatesAttached_other": "{{count}} candidatos asociados al grupo",
      "candidatesSelected_one": "{{count}} candidato seleccionado",
      "candidatesSelected_other": "{{count}} candidatos seleccionados",
      "candidatesWillBeAdded_one": "{{count}} candidato se añadirá a {{cohort}}",
      "candidatesWillBeAdded_other": "{{count}} candidatos se añadirán a {{cohort}}",
      "candidatesWillBeAddedVetting_one": "{{count}} candidato se añadirá al grupo seleccionado y podrá ser invitado a iniciar la selección.",
      "candidatesWillBeAddedVetting_other": "{{count}} candidatos se añadirán al grupo seleccionado y podrán ser invitados a iniciar la selección.",
      "errorsCount_one": "{{count}} error",
      "errorsCount_other": "{{count}} errores",
      "errorsTitle_one": "{{count}} fila necesita atención",
      "errorsTitle_other": "{{count}} filas necesitan atención",
      "inviteToVettingSent_one": "Se invitó a {{count}} talento a la selección",
      "inviteToVettingSent_other": "Se invitó a {{count}} talentos a la selección",
      "ofShown_one": "(de {{count}} mostrado)",
      "ofShown_other": "(de {{count}} mostrados)",
      "readyToAddCandidates_one": "Listo para añadir {{count}} candidato de tu ATS",
      "readyToAddCandidates_other": "Listo para añadir {{count}} candidatos de tu ATS",
      "readyToImportTalents_one": "Listo para importar {{count}} talento de tu hoja de cálculo",
      "readyToImportTalents_other": "Listo para importar {{count}} talentos de tu hoja de cálculo",
      "reviewImportedData_one": "Revisar datos importados ({{count}} fila)",
      "reviewImportedData_other": "Revisar datos importados ({{count}} filas)",
      "rowsDetected_one": "{{count}} fila detectada",
      "rowsDetected_other": "{{count}} filas detectadas",
      "talentsCount_one": "{{count}} talento",
      "talentsCount_other": "{{count}} talentos",
      "talentsImported_one": "{{count}} talento importado",
      "talentsImported_other": "{{count}} talentos importados",
      "talentsWillBeImported_one": "{{count}} talento se importará en {{cohort}}",
      "talentsWillBeImported_other": "{{count}} talentos se importarán en {{cohort}}",
      "talentsWillBeImportedAcquisition_one": "{{count}} talento se importará en la cohorte seleccionada y aparecerá en la etapa de Adquisición.",
      "talentsWillBeImportedAcquisition_other": "{{count}} talentos se importarán en la cohorte seleccionada y aparecerán en la etapa de Adquisición.",
      "toastDuplicates_one": "{{count}} ya está en tu empresa",
      "toastDuplicates_other": "{{count}} ya están en tu empresa",
      "toastFailed_one": "{{count}} fallido",
      "toastFailed_other": "{{count}} fallidos",
      "toastImported_one": "{{count}} añadido a adquisición",
      "toastImported_other": "{{count}} añadidos a adquisición",
      "validCount_one": "{{count}} válido",
      "validCount_other": "{{count}} válidos",
      "mapColumnTo": "Asignar la columna {{column}} a"
    },
    "sponsor": {
      "modal": {
        "title": "Patrocina el viaje de {{firstName}}",
        "subtitle": "Activa la experiencia completa de Tonnie para este talento.",
        "steps": {
          "recap": "Resumen",
          "pricing": "Precios",
          "message": "Mensaje",
          "review": "Revisión"
        },
        "step1": {
          "noCheckup": "CheckUp pendiente — la puntuación aparecerá una vez que {{firstName}} complete la evaluación.",
          "craHeading": "Perfil de riesgo",
          "verdictHeading": "Por qué patrocinar ahora",
          "verdict": {
            "pro": "Candidato PRO fuerte. El patrocinio desbloquea el viaje completo para una contratación de alta confianza.",
            "potential": "Alto potencial — el patrocinio acelera el camino de la evaluación a la evidencia.",
            "emerging": "Señal emergente — el patrocinio permite una evaluación completa a través de los cinco héroes."
          },
          "unlocksHeading": "Lo que desbloquea el patrocinio",
          "unlocksFootnote": "Una vez que {{firstName}} acepte, se activan los cinco héroes.",
          "continueCta": "Continuar a precios"
        },
        "step2": {
          "heading": "Precios",
          "planNameFree": "Pago por uso",
          "planNameEnterprise": "Tarifa Enterprise",
          "subtitle": "Cargo único — reembolso prorrateado si cancelas más tarde.",
          "monthlyRate": "Tarifa mensual",
          "duration": "Duración",
          "total": "Compromiso total",
          "billedOnce": "Facturado una vez a través de Stripe",
          "heroes": {
            "checkup": "CheckUp",
            "teleportal": "TelePortal",
            "qultureup": "QultureUp",
            "care": "Care",
            "passport": "Passport"
          },
          "familyAccess": "Acceso familiar",
          "familyAccessHint": "Incluir a los miembros del hogar en el viaje",
          "refundHeading": "Reembolsable de manera prorrateada",
          "refundScenarios": {
            "decline": {
              "label": "Si declinan",
              "body": "reembolso automático completo, no se necesita acción."
            },
            "cancel": {
              "label": "Si cancelas a mitad de camino",
              "body": "el reembolso equivale a los meses restantes × tarifa mensual."
            },
            "lock": {
              "label": "Los héroes se bloquean hasta la aceptación",
              "body": "sin riesgo antes de que el talento acepte."
            }
          },
          "refundFootnote": "Los reembolsos se procesan automáticamente a través de Stripe.",
          "continueCta": "Continúa enviando mensajes",
          "durationMonths_one": "{{count}} mes",
          "durationMonths_other": "{{count}} meses"
        },
        "step3": {
          "subtitle": "Tonnie envía un correo electrónico de activación curado con el enlace de aceptar/rechazar. Agrega una nota personal opcional que aparecerá en el correo electrónico por encima de la llamada a la acción.",
          "customMessageLabel": "Tu nota (opcional)",
          "customMessagePlaceholder": "Bienvenido a bordo: nos encantaría que te unieras a nosotros en {{destination}}.",
          "charsCounter": "{{count}} / {{max}}",
          "previewHeading": "Vista previa del correo electrónico",
          "previewSubheading": "Lo que {{firstName}} recibirá realmente",
          "previewAriaLabel": "Vista previa del correo electrónico de activación que {{firstName}} recibirá",
          "previewDisclaimer": "Enviado automáticamente al éxito del pago. {{firstName}} tiene tiempo ilimitado para aceptar.",
          "toneHint": {
            "concise": "Conciso",
            "warm": "Cálido",
            "professional": "Detallado"
          },
          "chips": {
            "label": "Inserciones rápidas",
            "destination": "Agregar destino",
            "destinationSnippet": "No podemos esperar a tenerte con nosotros en {{destination}}.",
            "destinationAria": "Inserta una frase sobre el destino",
            "teamWelcome": "Agregar bienvenida del equipo",
            "teamWelcomeSnippet": "Todo el equipo de {{company}} está apoyándote.",
            "teamWelcomeAria": "Inserta una frase de bienvenida del equipo",
            "signoff": "Agregar despedida",
            "signoffSnippet": "Esperamos construir este viaje juntos.",
            "signoffAria": "Inserta una frase de despedida personal"
          },
          "continueCta": "Revisar y pagar"
        },
        "step4": {
          "talentLabel": "Talento",
          "routeLabel": "Ruta",
          "pricingLabel": "Precios",
          "rateTimesMonths": "{{rate}}/mes × {{count}}",
          "messageLabel": "Nota de activación",
          "messageEmptyPlaceholder": "El mensaje de activación predeterminado de Tonnie será enviado.",
          "routeEmpty": "Configurado en el perfil del talento.",
          "routeUnknown": "No establecido",
          "vatNote": "Los impuestos (si los hay) se calculan en Stripe Checkout.",
          "previewToggle": "Vista previa del correo electrónico de activación",
          "previewToggleOpen": "Ocultar vista previa del correo electrónico",
          "commitmentTitle": "Estás a punto de comprometerte",
          "commitmentBody": "{{total}} hoy. Reembolso prorrateado disponible durante el período de {{durationMonths}} meses. {{firstName}} tiene tiempo ilimitado para aceptar.",
          "trustAriaLabel": "Señales de confianza de pago",
          "trust": {
            "stripe": "Asegurado por Stripe",
            "refundable": "Reembolso prorrateado",
            "noExpiry": "Sin caducidad para el talento",
            "autoSent": "Correo electrónico enviado automáticamente"
          },
          "nextTitle": "Qué sucede a continuación",
          "next": {
            "s1": "Abrimos Stripe Checkout en esta pestaña.",
            "s2": "Al éxito del pago, {{firstName}} recibe automáticamente tu correo electrónico de activación.",
            "s3": "La tarjeta pasa a Patrocinado — A la espera de aceptación."
          },
          "payCta": "Patrocinar y pagar {{total}}"
        },
        "preview": {
          "fromLabel": "De",
          "subject": "{{company}} le gustaría patrocinar tu viaje de Tonnie",
          "greeting": "Hola {{firstName}},",
          "introTail": "acaba de pagar para patrocinar tu viaje completo de Tonnie — pendiente de tu aceptación.",
          "unlocksHeading": "Lo que desbloqueas si aceptas",
          "heroes": {
            "checkup": "evaluación completa iQulture",
            "teleportal": "guía de visa, reubicación y vivienda",
            "qultureup": "misiones de integración cultural",
            "care": "apoyo al bienestar durante la mudanza",
            "passport": "tu registro portátil de progreso"
          },
          "noCost": "No te cuesta nada. Si rechazas, {{company}} será reembolsado automáticamente y tú mantendrás tu acceso básico.",
          "yourNoteHeading": "Una nota del equipo",
          "ctaLabel": "Revisa y responde a la oferta de patrocinio",
          "noExpiry": "Esta oferta te espera — no tiene fecha de caducidad. Tómate el tiempo que necesites.",
          "signOff": "Bienvenido a bordo,",
          "signature": "El equipo de Tonnie",
          "fallbackCompany": "Tu empresa"
        },
        "footer": {
          "back": "Atrás",
          "cancel": "Cancelar",
          "peekPreview": "Echa un vistazo al correo electrónico"
        },
        "errors": {
          "checkoutFailed": "No se pudo abrir Stripe Checkout. Inténtalo de nuevo o contacta con soporte.",
          "customMessageTooLong": "Tu nota debe tener 2000 caracteres o menos.",
          "planNotFound": "No se ha encontrado el plan de patrocinio. Contacta con soporte.",
          "planMisconfigured": "El plan de patrocinio no está configurado correctamente. Contacta con soporte.",
          "discountUnavailable": "Ese descuento ya no está disponible. Revisa el precio e inténtalo de nuevo.",
          "planLimitExceeded": "Has alcanzado el límite de tu plan. Mejora tu plan para patrocinar más talentos.",
          "needsInvitation": "Tu empresa aún no tiene una relación con esta persona, así que no se puede patrocinar directamente. Invítala primero desde el Pool.",
          "inviteFromPool": "Invitar desde el Pool",
          "alreadySponsored": "Este viaje ya tiene un patrocinio en curso, así que no se puede volver a patrocinar hasta que termine.",
          "sharedWithAnotherCompany": "Otra empresa también sigue a esta persona en este viaje, y un viaje patrocinado pertenece a una sola empresa. Puedes patrocinarla en un viaje propio en la misma ruta: lo acepta con tu oferta.",
          "sponsoredByAnotherCompany": "Otra empresa ya patrocina este viaje.",
          "routeFull": "Esta persona ya tiene el máximo de viajes que permite una ruta, así que no se puede crear uno nuevo para ti. Puede archivar uno primero.",
          "sponsorDedicated": "Patrocinar en un viaje propio",
          "notSponsorable": "Este viaje ya está financiado de una forma que un patrocinio de empresa no puede asumir, así que no se ha cobrado nada."
        }
      },
      "return": {
        "verifyingPayment": "Confirmando tu pago…",
        "paymentFailed": "El pago no pudo ser confirmado",
        "paymentFailedDescription": "Tonnie no recibió una sesión de pago de Stripe Checkout. Si completaste el pago, actualiza en un momento — los webhooks pueden tardar unos segundos en llegar. De lo contrario, intenta de nuevo desde el cajón de Vetting.",
        "backToVetting": "Volver a evaluación",
        "stepConfirm": {
          "title": "Patrocinio pagado — esperando aceptación",
          "subtitleHint": "El talento sigue en Evaluación, marcado como “Patrocinio ofrecido”, hasta que acepte.",
          "headline": "Patrocinio pagado — correo electrónico de activación enviado",
          "awaitingTitle": "Esperando aceptación del talento",
          "body": "El talento recibirá un correo y podrá aceptar o rechazar. Pasa a Patrocinado cuando acepte; si rechaza, se te reembolsa automáticamente. Mientras tanto lo encontrarás en Evaluación, donde puedes reenviar la oferta o abandonarla.",
          "backToVetting": "Volver a evaluación",
          "viewTalent": "Ver talento",
          "resendCta": "Reenviar correo de activación",
          "resendSuccess": "Correo electrónico de activación reenviado.",
          "resendAlready": "El correo electrónico de activación ya fue enviado — no se envió duplicado."
        },
        "errors": {
          "missingSponsorship": "Tonnie aún está confirmando el pago. Actualiza en unos segundos e intenta de nuevo.",
          "resendFailed": "No se pudo reenviar el correo electrónico de activación."
        }
      }
    },
    "talentDetail": {
      "loading": "Cargando…",
      "viewFullVettingReport": "Ver informe completo de evaluación",
      "header": {
        "couple": "Pareja",
        "familyWithKids": "Familia +{{count}}",
        "singleParent": "Familia monoparental +{{count}}",
        "openLinkedIn": "Abrir perfil de LinkedIn",
        "solo": "Solo",
        "sponsorCta": "Patrocinar a este talento"
      },
      "iqultureBlock": {
        "ariaLabel": "Puntuación iQulture {{score}} sobre 100, nivel {{tier}}",
        "label": "iQulture"
      },
      "kebab": {
        "label": "Más acciones"
      },
      "insights": {
        "vettingInsights": "El veredicto de Tonnie de un vistazo — puntuación, fundamentos de MESH, riesgos culturales y evidencia de pilares en un panel de decisiones.",
        "vettingMesh": "Motivación, inglés, habilidades blandas, habilidades duras — las cuatro señales sobre las que se basa cada decisión de patrocinio segura.",
        "vettingArchetypes": "Los arquetipos culturales revelan cómo se adapta {{name}}. Los arquetipos de bajo riesgo son tus apuestas más seguras para patrocinadores.",
        "vettingPillars": "Cada pilar se puntúa de forma independiente con banderas verdes, banderas rojas y evidencia — la pista de auditoría detrás de la puntuación iQulture.",
        "vettingSkills": "Lo que {{name}} aporta: habilidades blandas, habilidades duras y el ajuste cultural.",
        "vettingPitch": "El discurso de 60 segundos de {{name}} — míralos en sus propias palabras antes de patrocinar.",
        "vettingProfile": "Identidad, antecedentes, contexto familiar — el perfil completo que {{name}} construyó en Tonnie.",
        "vettingActivity": "Cada señal que Tonnie capturó: mensajes enviados, transiciones de etapa, hitos de héroes.",
        "sponsoredOverview": "Dónde se encuentra {{name}} ahora en su viaje de reubicación.",
        "sponsoredVetting": "Por qué patrocinaste a {{name}}: su puntuación iQulture y evidencia MESH.",
        "sponsoredMobility": "Legal y documentos, instalación local, viaje y logística — tres vías de movilidad. Un bloqueo aquí retrasa todo lo demás.",
        "sponsoredAdaptation": "QultureUp convierte el choque cultural en adaptación medible. La consistencia supera a los sprints.",
        "sponsoredCare": "La estabilidad es el éxito patrocinado. El registro barato hoy previene la recuperación costosa más tarde.",
        "sponsoredEvidence": "Prueba tangible del viaje de {{name}}: insignias, millas, hitos.",
        "sponsoredActivity": "Señal en vivo de cada héroe — la respuesta a '¿qué ha estado pasando?' que los administradores siempre necesitan."
      },
      "toneRibbon": {
        "label": "Tonnie recomienda",
        "phase": {
          "invited": "Invitado",
          "started": "CheckUp en progreso",
          "submitted": "CheckUp enviado",
          "scored": "Puntuado",
          "verdict": "Listo para el veredicto"
        },
        "tone": {
          "green": "Ajuste fuerte — procede con confianza",
          "amber": "Algunas advertencias — revisa los insights antes de patrocinar",
          "red": "Preocupaciones significativas — lee las banderas con cuidado",
          "neutralAwaiting": "Esperando señal de CheckUp",
          "neutralScored": "Puntuación disponible — señal cualitativa pendiente"
        }
      },
      "recommendation": {
        "green": {
          "title": "Tonnie recomienda patrocinar"
        },
        "amber": {
          "title": "Patrocina con los ojos abiertos"
        },
        "red": {
          "title": "Preocupaciones significativas"
        },
        "neutral": {
          "title": "Recomendación pendiente"
        }
      },
      "radar": {
        "tooltip": {
          "pillar": {
            "scoreAt": "En {{min}}–{{max}}",
            "evaluationQuestion": "Preguntas de Brain",
            "band": {
              "excellent": "Excelente",
              "solid": "Sólido",
              "mixed": "Mixto",
              "weak": "Débil",
              "tier": "Nivel {{tier}}"
            }
          },
          "archetype": {
            "persona": "Persona {{persona}}",
            "bucketLow": "Bajo riesgo ({{score}})",
            "bucketModerate": "Riesgo moderado ({{score}})",
            "bucketHigh": "Alto riesgo ({{score}})"
          }
        },
        "axis": {
          "ariaLabel": "Más sobre {{label}}"
        }
      },
      "insightsTab": {
        "label": "Perspectivas",
        "emptyTitle": "Las ideas se desbloquean una vez que se puntúa CheckUp",
        "verdict": {
          "scoreSuffix": "/ 100",
          "badgeLabel": "insignia iQulture",
          "scoreLabel": "puntuación iQulture",
          "confidenceBand": {
            "high": "Alta confianza",
            "moderate": "Confianza moderada",
            "low": "Baja confianza"
          },
          "confidenceTooltip": "La confianza de Tonnie en esta evaluación: {{percent}}% (promedio en los 7 pilares de evaluación).",
          "scoredToday": "Puntuado hoy",
          "scoredAgo_one": "Puntuado hace {{count}}d",
          "scoredAgo_other": "Puntuado hace {{count}}d",
          "fallbackRationale": "Tonnie evaluó este perfil en base a MESH fundamentos y 10 arquetipos culturales — las pestañas de soporte a continuación llevan el desglose completo.",
          "rationaleStrong": "Fuerte {{strongest}} ({{strongestScore}}%) sostiene este perfil.",
          "rationaleWeak": "Debilidad en {{weakest}} ({{weakestScore}}%) es la preocupación principal.",
          "rationaleAlert": "Alerta principal: {{alert}}",
          "eyebrow": "Recomendación de Tonnie"
        },
        "deepLink": {
          "openActivity": "Actividad abierta",
          "openArchetypes": "Arquetipos abiertos",
          "openMesh": "Abrir MESH",
          "openPillars": "Pilares abiertos",
          "openPitch": "Pitch abierto",
          "openSkills": "Habilidades abiertas"
        },
        "deepDive": {
          "activity": "Cronología de participación y actividad de este perfil",
          "pillars": "Para el rastro de auditoría y evidencia pilar por pilar",
          "pitch": "Para ver a este candidato en sus propias palabras",
          "skills": "Para el inventario completo de capacidades",
          "title": "Dónde mirar a continuación"
        },
        "badgeAndScore": {
          "title": "puntuación iQulture & insignia",
          "scoreLabel": "Puntuación",
          "badgeLabel": "Insignia"
        },
        "mesh": {
          "title": "Fundamentos de MESH",
          "subtitle": "Las cuatro señales sobre las que se construye cada patrocinio seguro."
        },
        "conclusion": {
          "title": "Conclusión de Tonnie"
        },
        "snapshot": {
          "title": "A simple vista"
        },
        "cra": {
          "title": "Arquetipos de riesgo cultural",
          "severityChip": "{{low}} bajo · {{moderate}} moderado · {{high}} alto",
          "severityTier": {
            "low": "bajo",
            "moderate": "moderado",
            "high": "alto"
          },
          "radarSeries": "Puntuación de riesgo",
          "radarA11yLabel": "Radar de arquetipos de riesgo cultural — {{summary}}",
          "empty": "No hay datos de arquetipos disponibles aún.",
          "description_one": "Dónde se sitúa {{name}} en el {{count}} arquetipo — más cerca del centro = menor riesgo cultural.",
          "description_other": "Dónde se sitúa {{name}} a través de los {{count}} arquetipos — más cerca del centro = menor riesgo cultural."
        },
        "pillars": {
          "title": "Evaluación de pilares",
          "description": "Los siete pilares de evaluación en un radar — más cerca del borde exterior significa una puntuación de pilar más fuerte.",
          "confidenceChip": "{{band}} · confianza promedio",
          "radarSeries": "Puntuación de pilar",
          "radarA11yLabel": "Radar de evaluación de Pilares — {{summary}}",
          "legendUnknownCodes": "Las etiquetas de los ejes son códigos de pilares. Abre la pestaña de Pilares para el desglose completo."
        }
      },
      "tabs": {
        "testit": "TestIt",
        "activity": "Actividad",
        "adaptation": "Adaptación",
        "archetypes": "Arquetipos",
        "care": "Care",
        "checkup": "CheckUp",
        "evidence": "Evidencia",
        "insights": "Perspectivas",
        "mesh": "MESH",
        "mobility": "Movilidad",
        "overview": "Resumen",
        "pillars": "Pilares",
        "pitch": "Presentación",
        "profile": "Perfil",
        "skills": "Habilidades",
        "vetting": "Evaluación",
        "decisionRecords": "Registros de decisión",
        "stripLabel": "Secciones del talento",
        "scrollPrevious": "Mostrar secciones anteriores",
        "scrollNext": "Mostrar más secciones"
      },
      "communications": {
        "privacyNote": "Ves qué se envió y qué pasó con ello, nunca su contenido, la dirección a la que se envió ni por qué un mensaje no se entregó.",
        "empty": "Todavía no se ha enviado nada a este talento.",
        "loadError": "No se han podido cargar las comunicaciones. Inténtalo de nuevo en un momento.",
        "loadMore": "Cargar mensajes anteriores",
        "channelEmail": "Correo electrónico",
        "channelInApp": "En la app",
        "channelPush": "Push",
        "kindSystem": "Mensaje automático",
        "kindAdmin": "Mensaje de tu equipo",
        "kindInApp": "Notificación en la app",
        "statusQueued": "En cola",
        "statusDispatched": "Enviado · resultado no registrado",
        "statusSent": "Enviado",
        "statusDelivered": "Entregado",
        "statusOpened": "Abierto",
        "statusFailed": "Fallido",
        "statusBounced": "Rebotado",
        "statusNotDelivered": "No entregado",
        "deliveredAt": "Entregado el {{date}}",
        "openedAt": "Abierto el {{date}}",
        "readInAppAt": "Leído en Tonnie el {{date}}"
      },
      "activity": {
        "empty": "No hay actividad aún — los eventos aparecerán aquí cuando el talento avance por el pipeline, complete un paso de CheckUp o reciba un mensaje.",
        "error": "No se pudo cargar la actividad. Inténtalo de nuevo en un momento.",
        "eventCount_one": "{{count}} evento",
        "eventCount_other": "{{count}} eventos",
        "loadMore": "Cargar actividad anterior",
        "loadingMore": "Cargando actividad anterior…",
        "live": "En vivo",
        "polling": "Actualización periódica",
        "withheldBody": "Este ciudadano no ha compartido su propia actividad con tu empresa. Los eventos que aparecen son de tu propia empresa: movimientos en el pipeline y mensajes que enviaste.",
        "eventCountPartial_one": "{{count}} evento solo de tu empresa",
        "eventCountPartial_other": "{{count}} eventos solo de tu empresa",
        "viewLabel": "Mostrar",
        "view": {
          "all": "Todo",
          "progress": "Progreso del talento",
          "pipeline": "Pipeline",
          "messages": "Mensajes"
        },
        "viewEmpty": "Todavía no hay nada en esta vista.",
        "hero": {
          "checkup": "CheckUp",
          "mobility": "Movilidad",
          "adaptation": "Adaptación",
          "care": "Care",
          "evidence": "Evidencia",
          "pipeline": "Pipeline",
          "system": "Tonnie"
        },
        "actorNotRecorded": "Autor no registrado"
      },
      "sponsored": {
        "ribbon": {
          "status": {
            "awaitingAcceptance": "Esperando aceptación del talento",
            "active": "Patrocinio activo",
            "cancelling": "Procesando reembolso",
            "talentDeclined": "El talento rechazó",
            "refunded": "Reembolsado",
            "cancelled": "Cancelado",
            "pastDue": "Pago vencido",
            "failed": "Pago fallido",
            "unknown": "Sin patrocinio activo",
            "completed": "Completado"
          },
          "monthsRemaining_one": "{{count}} meses restantes",
          "monthsRemaining_other": "{{count}} meses restantes",
          "refundAtRisk": "{{amount}} reembolso en riesgo",
          "acceptedOn": "Aceptado {{date}}",
          "awaitingTalent": "Esperando aceptación del talento"
        },
        "health": {
          "totalMonths_one": "{{count}} meses",
          "totalMonths_other": "{{count}} meses",
          "elapsed": "{{elapsed}} de {{total}} meses transcurridos",
          "awaitingActivationSent": "Activación enviada {{ago}}",
          "awaitingBody": "El talento ha recibido un enlace de activación por correo electrónico. El patrocinio se activa en el momento en que lo aceptan.",
          "cancellingBody": "El reembolso está en proceso. Stripe nos notificará cuando los fondos se asienten; el patrocinio se moverá a reembolsado automáticamente.",
          "declinedBody": "El talento rechazó la oferta de patrocinio. Se ha emitido un reembolso completo.",
          "closedBody": "El patrocinio está cerrado y la empresa ya no financia este viaje. El talento conserva su propio acceso y aún puede completar su CheckUp.",
          "closedOn": "Cerrado {{date}}",
          "paymentFailedBody": "El último pago del patrocinio falló. Actualiza el método de pago para mantener al talento activo.",
          "refundAmount": "Monto del reembolso: {{amount}}",
          "completedBody": "El patrocinio de 12 meses ha llegado a su fin. No se reembolsa nada; el talento continúa con su propio plan.",
          "completedOn": "Terminó el {{date}}"
        },
        "heroes": {
          "mobility": "Movilidad",
          "adaptation": "Adaptación",
          "care": "Care",
          "evidence": "Evidencia",
          "notStarted": "No iniciado aún"
        },
        "heroesGrid": {
          "mobilitySubtitle": "Visa, documentación, preparación para viajar",
          "adaptationSubtitle": "Preparación cultural, misiones, racha",
          "careSubtitle": "Bienestar, estabilidad, intervenciones",
          "evidenceSubtitle": "Insignias, sellos y millas ganadas",
          "blockers_one": "{{count}} bloqueador",
          "blockers_other": "{{count}} bloqueadores",
          "worldsLabel": "Mundos",
          "missionsLabel": "Misiones",
          "tracksLabel": "Pistas",
          "streakDays_one": "racha de {{count}} días",
          "streakDays_other": "racha de {{count}} días",
          "wellbeingLabel": "Puntuación de bienestar",
          "lastCheckin": "Último {{ago}}",
          "openInterventions_one": "{{count}} abiertos",
          "openInterventions_other": "{{count}} abiertos",
          "moodLabel": "Estado de ánimo",
          "settlementLabel": "Liquidación",
          "checkpointsValue": "{{done}}/{{total}} puntos de control",
          "docsReady": "Docs listos",
          "assessmentDone": "Evaluación completada",
          "awaitingData": "Esperando el primer registro para ver la puntuación de bienestar.",
          "miles": "Miles",
          "badges": "Medallas",
          "stamps": "Sellos",
          "openTabHint": "Abre la pestaña para enviar un recordatorio"
        },
        "activity": {
          "preview": {
            "title": "Actividad reciente",
            "viewAll": "Ver actividad completa",
            "empty": "Aún no hay eventos de patrocinio"
          }
        },
        "meta": {
          "familyAccess": "Acceso familiar",
          "familyAccessOn": "Habilitado",
          "familyAccessOff": "Desactivado",
          "familyAccessOnToast": "Acceso familiar habilitado",
          "familyAccessOffToast": "Acceso familiar deshabilitado",
          "familyAccessFailed": "Error al actualizar el acceso familiar",
          "startedAt": "Comenzado",
          "endsAt": "Termina",
          "amountPaid": "Importe pagado",
          "refundIfCancelledToday": "Reembolso si se cancela hoy",
          "monthsLeft_one": "Queda {{count}} mes",
          "monthsLeft_other": "Quedan {{count}} meses"
        },
        "banner": {
          "headline": "El viaje de {{name}}",
          "miles": "Miles de viaje",
          "monthsLeft": "Meses restantes",
          "ctaViewVetting": "Ver evaluación",
          "ctaOpenMobility": "Abrir movilidad",
          "ctaOpenAdaptation": "Abrir adaptación",
          "ctaOpenCare": "Abrir Care",
          "statusNotStarted": "No iniciado",
          "statusLocked": "Bloqueado",
          "statusDone": "Hecho",
          "day": "Día {{day}}",
          "dayLabel": "del viaje",
          "nextEyebrow": "Dónde mirar ahora"
        },
        "footer": {
          "action": {
            "resendActivation": "Reenviar correo de activación",
            "abandon": "Abandonar patrocinio",
            "cancel": "Cancelar patrocinio",
            "close": "Cerrar",
            "reoffer": "Reofrecer patrocinio",
            "updatePayment": "Actualizar pago"
          },
          "refundProcessing": "Reembolso en proceso — no se pueden realizar acciones mientras Stripe finaliza"
        },
        "smartNudge": {
          "sending": "Enviando…",
          "cta": {
            "mobility": "Enviar tarea de movilidad",
            "adaptation": "Enviar recordatorio de adaptación",
            "care": "Enviar chequeo de Care"
          },
          "sent": {
            "mobility": "Recordatorio de tarea de movilidad enviado a {{name}}",
            "adaptation": "Recordatorio de adaptación enviado a {{name}}",
            "care": "Solicitud de chequeo de Care enviada a {{name}}"
          },
          "errorMissingEmail": "No se puede enviar — el talento no tiene correo electrónico registrado.",
          "templateMissing": "La plantilla \"{{code}}\" no está configurada para este inquilino. Agrégala o restáurala en Mensajes → Plantillas.",
          "sendFailed": "Error al enviar el recordatorio",
          "fallback": {
            "mobilityTask": "tu próximo paso de movilidad",
            "adaptationMission": "tu próxima misión de QultureUp"
          }
        },
        "abandon": {
          "confirmTitle": "¿Abandonar este patrocinio?",
          "confirmDescription": "{{name}} recibirá un reembolso completo y el viaje volverá a acceso solo por invitación. Esta acción no se puede deshacer.",
          "confirmCancel": "Mantener patrocinio",
          "confirmAction": "Abandonar y reembolsar",
          "successToast": "Patrocinio abandonado · reembolso emitido",
          "failedToast": "Error al abandonar el patrocinio"
        },
        "resendActivation": {
          "successToast": "Correo de activación reenviado",
          "failedToast": "Error al reenviar el correo de activación"
        },
        "noSponsorshipTitle": "No hay patrocinio activo para este viaje",
        "noSponsorshipBody": "El talento no tiene fila de patrocinio activa para este viaje. Revisa la pestaña Patrocinado en el pipeline si hay un viaje diferente patrocinado, o inicia uno nuevo desde el cajón de Evaluación.",
        "relative": {
          "justNow": "justo ahora",
          "minAgo_one": "{{count}}m hace",
          "minAgo_other": "{{count}}m hace",
          "hourAgo_one": "{{count}}h hace",
          "hourAgo_other": "{{count}}h hace",
          "dayAgo_one": "hace {{count}}d",
          "dayAgo_other": "hace {{count}}d"
        },
        "alreadyAnswered": "El talento ya ha respondido a esta oferta de patrocinio."
      },
      "nudge": {
        "cta": "Enviar recordatorio",
        "description": "Elige un mensaje predefinido para despertarlos. Puedes sobrescribir el contenido antes de enviar.",
        "failed": "Error al enviar el recordatorio",
        "noTemplates": "No hay plantillas configuradas para esta etapa. Agrega una en Mensajes → Plantillas.",
        "overrideHint": "Deja en blanco para enviar la plantilla tal cual. Cualquier cosa que escribas aquí reemplaza el contenido de la plantilla.",
        "overrideLabel": "Mensaje personalizado (opcional)",
        "overridePlaceholder": "Agrega una nota personal antes de enviar…",
        "recommended": "Recomendado",
        "send": "Enviar recordatorio",
        "sending": "Enviando…",
        "sent": "“{{name}}” enviado",
        "templateLabel": "Plantilla",
        "title": "Enviar un recordatorio"
      },
      "mobility": {
        "blocked": "Bloqueado",
        "blockers": {
          "onTrack": "En camino — sin bloqueos ni tareas vencidas.",
          "blockedTracks_one": "{{count}} pista bloqueada",
          "blockedTracks_other": "{{count}} pistas bloqueadas",
          "overdueTasks_one": "{{count}} tarea vencida",
          "overdueTasks_other": "{{count}} tareas vencidas"
        },
        "docStatus": {
          "pending": "Pendiente",
          "uploaded": "Subido",
          "validated": "Validado",
          "rejected": "Rechazado",
          "missing": "Faltante"
        },
        "documents": {
          "title": "Documentos",
          "otherTrack": "Otro",
          "certified": "Certificado",
          "expiringSoon": "Caducando pronto",
          "downloadAll": "Descargar todo",
          "downloadSelected": "Descargar {{count}}",
          "downloadError": "No se pudieron descargar los documentos.",
          "select": "Seleccionar documento",
          "withheldBody": "Este ciudadano no ha compartido sus documentos con tu empresa. La lista de abajo sigue siendo correcta: lo que ya no se puede descargar son los archivos en sí."
        },
        "error": "No se pudieron cargar los datos de movilidad.",
        "header": {
          "title": "Viaje de reubicación",
          "subtitle": "Tareas, documentos y hitos en cada pista"
        },
        "noTracks": "No se han iniciado pistas de movilidad aún.",
        "nudge": "Enviar recordatorio de movilidad",
        "progress": "{{percent}}% completo",
        "taskStatus": {
          "pending": "Por hacer",
          "in_progress": "En progreso",
          "completed": "Completado",
          "blocked": "Bloqueado",
          "skipped": "Omitido",
          "archived": "Archivado"
        },
        "tasks": {
          "title": "Tareas de talento",
          "talent": "Talento",
          "otherTrack": "Otro",
          "blocking": "Bloqueando",
          "blockedBy": "Bloqueado por {{count}}",
          "overdue": "Atrasado",
          "certified": "Certificado",
          "docCount_one": "{{count}} documento",
          "docCount_other": "{{count}} documentos",
          "location": {
            "home_country": "País de origen",
            "target_country": "Destino",
            "online": "En Línea",
            "either": "Cualquiera"
          },
          "ownership": {
            "company": "Empresa",
            "government": "Gobierno",
            "dual": "Compartido"
          }
        },
        "timeline": {
          "title": "Hitos",
          "summary": "{{reached}} de {{total}} alcanzados",
          "reached": "Alcanzado"
        }
      },
      "adaptation": {
        "error": "No se pudieron cargar los datos de adaptación.",
        "header": {
          "assessedOn": "Evaluado el {{date}}",
          "miles": "Miles",
          "missions": "Misiones",
          "notAssessed": "No evaluado",
          "streak": "Racha",
          "streakDays": "{{count}}d",
          "timeLearning": "Tiempo de aprendizaje",
          "title": "Adaptación"
        },
        "overviewTab": "Resumen",
        "tracksTab": "Mundos y pistas",
        "thisWeek": "Esta semana",
        "ariaWeekly": "Gráfico de compromiso semanal",
        "missionsProgress": "{{completed}} de {{total}} misiones",
        "tracksProgress": "{{completed}}/{{total}} pistas",
        "noWorlds": "No se han iniciado mundos de QultureUp aún.",
        "tracksTitle": "Mundos y pistas",
        "levelAll": "Todo",
        "noTracksForLevel": "No hay pistas en este nivel.",
        "noMissions": "No hay misiones en esta pista aún.",
        "recommendedNext": "Siguiente recomendado",
        "status": {
          "completed": "Completado",
          "in_progress": "En progreso",
          "locked": "Bloqueado",
          "not_started": "No iniciado"
        },
        "suggest": "Sugerir",
        "suggestionSent": "Sugerido “{{mission}}” — enviado por correo electrónico",
        "worldsTitle": "Mundos",
        "missionsCount_one": "misión",
        "missionsCount_other": "misiones"
      },
      "evidence": {
        "error": "No se pudo cargar los datos de evidencia.",
        "export": {
          "title": "Registro de viaje",
          "description": "Exporta el registro completo del talento como informe PDF o archivo CSV.",
          "pdf": "Exportar PDF",
          "csv": "Exportar CSV"
        },
        "header": {
          "title": "Viaje Passport",
          "subtitle": "Sellos, insignias y millas ganadas a lo largo del viaje",
          "miles": "Total de Miles",
          "level": "Nivel Citizen",
          "stamps": "Sellos",
          "badges": "Medallas",
          "thisWeek": "Esta semana"
        }
      },
      "care": {
        "checkins": {
          "empty": "No hay verificaciones aún.",
          "last30Days": "Últimos 30 días",
          "lastCheckin": "Última verificación {{date}}",
          "moodTrend": "Tendencia de estado de ánimo",
          "privacyNote": "Las entradas individuales de estado de ánimo permanecen privadas para el talento — solo se muestran la frecuencia y la tendencia.",
          "streak": "Racha de días",
          "title": "Actividad de verificación",
          "trend": {
            "down": "Cayendo",
            "stable": "Estable",
            "up": "Aumentando"
          }
        },
        "commitment": {
          "component": {
            "careResponsiveness": "Responsividad de Care",
            "checkinConsistency": "Consistencia de verificación",
            "engagementLevel": "Compromiso",
            "integrationProgress": "Progreso de integración",
            "pillarStability": "Estabilidad de pilares",
            "tenureStability": "Estabilidad de permanencia"
          },
          "empty": "El Índice de Compromiso aparecerá una vez que el talento tenga verificaciones o puntos de control.",
          "history": {
            "empty": "No hay suficiente historial aún — la línea de tendencia aparece después de un segundo cálculo.",
            "range": "{{min}}–{{max}}",
            "title": "Historial del índice",
            "ariaLabel_one": "Historial del Índice de Compromiso, {{count}} punto de datos de {{min}} a {{max}}",
            "ariaLabel_other": "Historial del Índice de Compromiso, {{count}} puntos de datos de {{min}} a {{max}}"
          },
          "level": {
            "at_risk": "En riesgo",
            "champion": "Campeón",
            "committed": "Comprometido",
            "engaged": "Involucrado",
            "flight_risk": "Riesgo de fuga"
          },
          "noRisks": "No hay señales de riesgo activas.",
          "risks": "Señales de riesgo",
          "risksRestricted": "Las señales de riesgo están restringidas en esta empresa. Habla con un administrador si las necesitas.",
          "title": "Índice de compromiso",
          "trend": {
            "declining": "En declive",
            "improving": "Mejorando",
            "stable": "Estable"
          }
        },
        "checkpoints": {
          "empty": "No hay puntos de control programados aún.",
          "status": {
            "cancelled": "Cancelado",
            "completed": "Completado",
            "due": "Vencido",
            "in_progress": "En curso",
            "overdue": "Atrasado",
            "scheduled": "Programado",
            "skipped": "Omitido"
          },
          "title": "Puntos de control"
        },
        "error": "No se pudo cargar los datos de cuidado.",
        "header": {
          "title": "Care",
          "stage": "Fase: {{stage}}"
        },
        "pillars": {
          "concerns": "Preocupaciones:",
          "empty": "No hay pilares de bienestar aún.",
          "title": "Pilares de bienestar"
        },
        "interventions": {
          "empty": "No hay intervenciones programadas aún.",
          "loadError": "No se pudieron cargar las intervenciones.",
          "past": "Pasado",
          "retry": "Intenta de nuevo",
          "subtitle": "Programa seguimientos de atención recurrentes o únicos para este talento.",
          "title": "Intervenciones de Care",
          "upcoming": "Próximamente"
        },
        "withheldBody": "Este ciudadano no ha compartido su registro de Care con tu empresa. La puntuación de bienestar, los pilares y los checkpoints están retenidos. Las intervenciones que aparecen abajo son el registro de tu propia empresa sobre lo que envió."
      },
      "consent": {
        "withheld": {
          "srLabel": "Retenido — no compartido por este ciudadano",
          "tooltip": "Este ciudadano no ha compartido esta información con tu empresa. Está retenida, no es cero.",
          "title": "Retenido por el ciudadano",
          "body": "Este ciudadano no ha compartido esta información con tu empresa. Está retenida: no es cero ni falta.",
          "householdGroup": "Miembro del hogar — nombre retenido"
        }
      },
      "checkup": {
        "withheldBody": "Este ciudadano no ha compartido su CheckUp con tu empresa. Las puntuaciones, el desglose MESH y el análisis del pitch están retenidos: no faltan ni son cero.",
        "completedOn": "CheckUp completado el {{date}}",
        "awaitingConsentBody": "{{name}} ha completado el CheckUp y no ha compartido el resultado con tu empresa. La decisión de compartirlo es del talento. Hasta entonces, las puntuaciones, el desglose MESH y el análisis del pitch están retenidos: no faltan ni son cero.",
        "withdrawnBody": "{{name}} ha dejado de compartir el resultado del CheckUp con tu empresa. Las puntuaciones, el desglose MESH y el análisis del pitch están retenidos: no faltan ni son cero."
      }
    },
    "askTonnieServices": {
      "budgetLabel": "Rango de presupuesto (opcional)",
      "budgetPlaceholder": "Si tienes un rango de presupuesto en mente, por favor compártelo...",
      "description": "Solicita a Tonnie manejar todo el proceso llave en mano (Paquete Tonnie). Los Servicios de Tonnie redactarán una propuesta para tu aprobación.",
      "descriptionLabel": "Descripción de necesidades",
      "descriptionPlaceholder": "Describe tus necesidades y requisitos específicos...",
      "scopes": {
        "adaptationDesc": "QultureUp y adaptación cultural",
        "adaptationLabel": "Adaptación",
        "careDesc": "Apoyo post-llegada y Care",
        "careLabel": "Care & estabilidad",
        "hireDesc": "Adquisición y búsqueda de talento",
        "hireLabel": "Contratar",
        "mobilityDesc": "Visa, viaje y reubicación",
        "mobilityLabel": "Movilidad",
        "sponsorDesc": "Decisiones de evaluación y patrocinio",
        "sponsorLabel": "Patrocinador"
      },
      "serviceScopeHint": "Selecciona qué partes del proceso te gustaría que Tonnie manejara:",
      "serviceScopeLabel": "Alcance del servicio",
      "submitFailed": "Error al enviar la solicitud",
      "submitRequest": "Enviar solicitud",
      "submitSuccess": "Solicitud enviada — los Servicios de Tonnie se pondrán en contacto en breve",
      "submitting": "Enviando…",
      "timelineLabel": "Expectativas de tiempo",
      "timelinePlaceholder": "¿Cuándo necesitas que esto esté completado? ¿Alguna fecha límite específica?",
      "title": "Preguntar servicios de Tonnie",
      "whatHappensNextBody": "Los servicios de Tonnie revisarán tu solicitud y redactarán una propuesta (tarifa diaria / honorarios / paquete) para tu aprobación. Una vez aprobada, se activará el modo Pack de Tonnie y el progreso se reflejará en tu pipeline.",
      "whatHappensNextTitle": "¿Qué sucede a continuación?"
    },
    "auth": {
      "backToSignIn": "Volver a iniciar sesión",
      "inviteRoleAdmin": "Admin",
      "inviteRoleMember": "Miembro del equipo",
      "joinCompanySubtitle": "Crea tu cuenta para unirte como {{role}}",
      "joinCompanyTitle": "Únete a {{company}}",
      "noAccess": {
        "acceptInvitation": "Aceptar una invitación",
        "contactAdmin": "Contacta a tu administrador",
        "description": "Has iniciado sesión como {{email}}, pero esta cuenta aún no tiene acceso a Tonnie Business.",
        "hint": "Pide a un compañero que te invite, acepta una invitación pendiente o cierra sesión para usar otra cuenta.",
        "signingOut": "Cerrando sesión…",
        "switchAccount": "Cerrar sesión y usar otra cuenta",
        "title": "Sin acceso a negocios"
      },
      "signUp": "Registrarse"
    },
    "billing": {
      "statusLabel": {
        "active": "Activo",
        "pending": "Pendiente",
        "paid": "Pagado",
        "cancelling": "Cancelando",
        "cancelled": "Cancelado",
        "past_due": "Vencido",
        "overdue": "Atrasado",
        "failed": "Fallido",
        "completed": "Completado"
      },
      "active": "Activo",
      "activeSponsorships": "Patrocinios activos",
      "checkoutCancelled": "Pago cancelado",
      "checkoutSuccessPending": "Pago recibido — tu cuenta se actualizará en breve.",
      "checkoutSuccessVerified": "Pago confirmado — tu cuenta ha sido actualizada.",
      "checkoutVerifyError": "Recibimos tu pago pero no pudimos confirmarlo en tiempo real. Actualiza en un momento.",
      "coPilot": "CoPilot",
      "cohorts": "Cohortes",
      "description": "Tu plan, patrocinios, facturas y método de pago",
      "downgradeDialog": {
        "confirmDowngrade": "Confirmar degradación",
        "description": "Revisa qué cambia antes de pasar a un plan inferior",
        "discountedRate": "Tarifa con descuento",
        "keepEnterprise": "Mantener empresa",
        "loseAccess": "Perderás acceso a:",
        "periodEndNote": "Enterprise sigue activo hasta el final del período ya pagado; después, la empresa pasa al plan Gratis.",
        "sponsorshipNote": "Nota: Los patrocinios activos continuarán a su tarifa actual hasta que expiren. Los nuevos patrocinios se cobrarán a la tarifa del plan Gratuito.",
        "title": "Diálogo de degradación",
        "unlimitedProgramsCohorts": "Cohortes de programas ilimitados",
        "unlimitedTeam": "Equipo ilimitado"
      },
      "downgradeFailed": "No se pudo cancelar la suscripción.",
      "downgradeSuccess": "Degradado al plan Gratuito. Algunas funciones ahora son limitadas.",
      "downgradeScheduled": "Enterprise termina el {{date}}. Hasta entonces, nada cambia.",
      "enterprisePlanMissing": "Plan empresarial no configurado. Contacta con soporte.",
      "familyAccessDesc": "El acceso familiar incluye a los miembros del hogar en el mismo viaje.",
      "familyAddonToggled": "Complemento familiar {{action}} para {{name}}",
      "familyToggleFailed": "No se pudo alternar el acceso familiar.",
      "invoices": {
        "description": "Todas las facturas de tu empresa, listas para descargar",
        "empty": "Aún no hay facturas",
        "emptyHint": "Las facturas aparecerán después de tu primer pago.",
        "title": "Facturas",
        "view": "Ver",
        "viewAllInStripe": "Ver todo en Stripe",
        "paymentReference": "Ref. de pago {{reference}}",
        "refunded": "Reembolsado {{amount}}",
        "documentUnavailable": "No hemos podido abrir este documento ahora. Inténtalo de nuevo."
      },
      "limitedFeaturesDesc": "Lo que tu plan actual no incluye",
      "managePlan": "Gestionar plan",
      "monthlySpend": "Gasto mensual",
      "nextInvoice": "Próxima factura",
      "payment": {
        "addressLabel": "Dirección de facturación",
        "billingSummary": "Resumen de facturación",
        "currency": "Moneda",
        "dueOn": "Vencido {{date}}",
        "enterpriseSubscription": "Suscripción empresarial",
        "nextInvoiceEstimate": "Estimación de la próxima factura",
        "noAddress": "No hay dirección en el archivo",
        "openStripePortal": "Abrir el portal de Stripe",
        "paymentsSecuredBy": "Pagos asegurados por",
        "portalSummary": "Abre el portal de facturación para gestionar tu suscripción, métodos de pago e facturas.",
        "securePaymentVia": "Pago seguro A través de"
      },
      "planLabel": "Plan {{plan}}",
      "planUpdated": "Tu plan ha sido actualizado. No se requiere nuevo pago.",
      "plans": {
        "anonymizedReporting": "Informes anonimizados",
        "breakEvenPoint": "Punto de equilibrio",
        "checkupTeleportalQultureupCare": "CheckUp, TelePortal, QultureUp y Care",
        "complianceAuditTools": "Herramientas de auditoría de cumplimiento",
        "contactSales": "Contactar ventas",
        "currentPlan": "Plan actual",
        "custom": "Personalizado",
        "customIntegrations": "Integraciones personalizadas",
        "customJourneyTemplates": "Plantillas de viaje personalizadas",
        "dedicatedSupport": "Soporte dedicado",
        "downgradeToFree": "Bajar a gratis",
        "eachSponsorshipIncludes": "Cada patrocinio incluye",
        "enterprise": "Empresa",
        "enterpriseRate": "Tarifa empresarial",
        "familyAccessOptional": "Acceso familiar opcional",
        "free": "Gratis",
        "freePlanRate": "Tarifa del plan gratuito",
        "fullJourneyCitizenAccess": "Acceso completo al viaje Citizen",
        "fullMobilityAdaptation": "Adaptación completa de movilidad",
        "fullMobilityAdaptationTitle": "Movilidad completa y adaptación",
        "getStarted": "Empezar",
        "government": "Gobierno",
        "governmentContactDesc": "Contacta a nuestro equipo de ventas para establecer un contrato personalizado para programas públicos.",
        "intelligenceDesc": "Desbloquea soporte completo de Movilidad y Adaptación con análisis avanzados y acceso a API.",
        "inviteWholeTeamDesc": "Invita a todo tu equipo con asientos, programas y cohortes ilimitados.",
        "mobilityAdaptationLocked": "Adaptación de movilidad bloqueada",
        "multiYearContracts": "Contratos a varios años",
        "percentOff": "{{percent}}% de descuento",
        "passportAchievements": "Logros de Passport",
        "perTalentJourney": "Por viaje de talento",
        "perTalentPerMonth": "Por talento por mes",
        "publicPrograms": "Programas públicos",
        "quickRoi": "Roi rápido",
        "recommended": "Recomendado",
        "savePercent": "Ahorra un {{percent}}%",
        "savePerYear": "Ahorra en patrocinios",
        "scaleYourMobility": "Escala tu movilidad",
        "sponsorship": "Patrocinio",
        "sponsorshipRate": "Tarifa de patrocinio",
        "sponsorshipsDropDesc": "Las tarifas de patrocinio bajan al nivel Empresarial, por lo que cada viaje de talento cuesta menos.",
        "tailoredToYourNeeds": "Adaptado a tus necesidades",
        "unlimitedTeamScale": "Escala de equipo ilimitada",
        "whyUpgrade": "Por qué actualizar",
        "totalSuffix": "total",
        "sponsorshipMonthlyCaption_one": "{{rate}}/mes · acceso de {{count}} mes",
        "sponsorshipMonthlyCaption_other": "{{rate}}/mes · acceso de {{count}} meses",
        "sponsorshipRateError": "No se pudo cargar la tarifa de patrocinio. Por favor, actualiza."
      },
      "portalUnavailable": "El Portal de Clientes de Stripe aún no está disponible. Completa primero un pago.",
      "programs": "Programas",
      "redirectingToStripe": "Redirigiendo a la compra de Stripe...",
      "renewsOn": "Se renueva el {{date}}",
      "enterpriseEndsOn": "Enterprise termina el {{date}}",
      "sponsorships": {
        "access": "Acceso",
        "activeSponsorships": "Patrocinios activos",
        "addFamilyAccess": "Añadir acceso familiar",
        "description": "Los trayectos que patrocina tu empresa, con sus fechas y coste",
        "empty": "No hay patrocinios aún",
        "enterpriseDiscount": "Descuento empresarial",
        "family": "Familia",
        "removeFamilyAccess": "Eliminar acceso familiar",
        "title": "Patrocinios",
        "totalSponsored": "Total patrocinado",
        "rowActionsAria": "Acciones para {{name}}",
        "viewDetails": "Ver detalles",
        "yourRate": "Tu tarifa",
        "accessMonths_one": "{{count}} mes",
        "accessMonths_other": "{{count}} meses",
        "monthsLeft_one": "Queda {{count}} mes",
        "monthsLeft_other": "Quedan {{count}} meses",
        "journeyProgress": "Progreso del viaje"
      },
      "subscriptionError": "No se pudo cargar la suscripción. Por favor, actualiza.",
      "tabs": {
        "invoices": "Facturas",
        "payment": "Pago",
        "plans": "Planes",
        "sponsorships": "Patrocinios",
        "fiscal": "Facturación certificada"
      },
      "title": "Facturación",
      "totalSponsored": "Total patrocinado",
      "unlimitedAccessDesc": "Todo lo que incluye tu plan, sin límites",
      "upgradeDialog": {
        "continueToPayment": "Continuar al pago",
        "description": "Desbloquea asientos ilimitados, candidatos, programas y soporte completo de movilidad.",
        "monthlyLabel": "Mensual",
        "saveYearly": "Ahorra {{amount}} al año",
        "whatYouGet": "Lo que obtienes",
        "yearlyLabel": "Anual"
      },
      "upgradeFailed": "No se pudo iniciar el proceso de pago. Por favor, inténtalo de nuevo.",
      "upgradeToEnterprise": "Actualizar a Enterprise",
      "vetting": "Evaluación",
      "stage": {
        "preMobility": "Pre-Movilidad",
        "mobility": "Movilidad",
        "adaptation": "Adaptación",
        "care": "Care",
        "stable": "Estable"
      },
      "planUnavailable": "Este plan no se puede contratar ahora mismo. Ponte en contacto con el soporte, por favor.",
      "details": {
        "title": "Datos de facturación",
        "description": "A quién se emiten las facturas de la empresa. Un cambio se aplica al próximo pago.",
        "edit": "Editar",
        "legalName": "Razón social",
        "taxId": "NIF / número de IVA",
        "country": "País de facturación",
        "countryPlaceholder": "Elige un país",
        "addressLine1": "Dirección",
        "addressLine2": "Dirección (continuación)",
        "postalCode": "Código postal",
        "city": "Ciudad",
        "save": "Guardar",
        "saveAndContinue": "Guardar y continuar al pago",
        "saveFailed": "No se pudieron guardar los datos de facturación. Inténtalo de nuevo.",
        "beforePaymentTitle": "Datos para la factura",
        "beforePaymentDescription": "Cada pago incluye una factura-recibo a nombre de tu empresa. Completa sus datos y seguimos al pago."
      },
      "fiscal": {
        "title": "Facturación certificada — conciliación",
        "description": "Cada pago de la plataforma y su factura-recibo, en todas las empresas y ciudadanos. Solo el equipo Tonnie lo ve.",
        "enabled": "Emisión activada",
        "disabled": "Emisión desactivada",
        "providerJasmin": "Jasmin",
        "providerSimulated": "Simulado — no se emite nada real",
        "issueFrom": "Emisión desde {{date}}",
        "configMissing": "Configuración ausente o no válida",
        "count": {
          "issued": "Emitidas",
          "pending": "Pendientes",
          "failed": "Fallidas",
          "creditNotesPending": "Notas de crédito por emitir",
          "retroactive": "Pagos anteriores por facturar"
        },
        "attentionTitle": "Necesita a alguien",
        "attentionEmpty": "Nada requiere atención.",
        "reason": {
          "failed": "No se pudo emitir la factura-recibo",
          "pending": "Esperando desde hace más de una hora",
          "creditNotePending": "Reembolsado — emite la nota de crédito en Jasmin"
        },
        "refunded": "{{amount}} reembolsados",
        "retry": "Reintentar",
        "creditNoteIssued": "Nota de crédito emitida",
        "done": "Hecho.",
        "actionFailed": "No funcionó. Inténtalo de nuevo.",
        "loadFailed": "No se pudo cargar la conciliación.",
        "alert": {
          "nextYearSeriesMissing": "La serie de {{year}} aún no está configurada — créala y comunícala en Jasmin antes del 31 de diciembre.",
          "euConsumerThreshold": "Ventas a consumidores de otros países de la UE en {{year}}: {{amount}} del umbral de {{threshold}} — decide el OSS con la contable.",
          "failedDocuments_one": "{{count}} factura-recibo falló — ver abajo.",
          "failedDocuments_other": "{{count}} facturas-recibo fallaron — ver abajo."
        }
      }
    },
    "businessMessages": {
      "analytics": {
        "attemptedCount_one": "{{count}} intento",
        "attemptedCount_other": "{{count}} intentos",
        "byEngagement": "Por compromiso",
        "channelPerformance": "Rendimiento del canal",
        "channelPerformanceDesc": "Cómo entrega y se abre cada canal",
        "deliveryRate": "Tasa de entrega",
        "messagesByCategory": "Mensajes por categoría",
        "messagesByCategoryDesc": "Mensajes enviados en cada categoría",
        "noChannelDataYet": "Todavía no se ha enviado ningún mensaje: las tasas aparecerán aquí en cuanto salga el primero.",
        "noTemplatesYet": "Crea tu primera plantilla para ver el compromiso aquí.",
        "openRate": "Tasa de apertura",
        "templatesCount_one": "{{count}} plantilla",
        "templatesCount_other": "{{count}} plantillas",
        "topTemplates": "Plantillas principales"
      },
      "cohortAllSuppressed": "Nadie recibió este mensaje: todos en esta cohorte tienen estos correos desactivados.",
      "cohortSentWithSuppressed": "Enviado a {{queued}}. {{suppressed}} no lo recibieron: han desactivado estos correos.",
      "suppressedByPreferenceGeneric": "El destinatario ha desactivado estos correos — no se envió nada",
      "suppressedByPreference": "{{name}} ha desactivado estos correos — no se envió nada",
      "channels": {
        "channelIntegrations": "Integraciones de canal",
        "channelIntegrationsDesc": "Los canales por los que pueden salir tus mensajes",
        "comingSoon": "Próximamente",
        "configure": "Configurar",
        "connected": "Conectado",
        "delivered": "Entregado",
        "email": "Correo electrónico",
        "getHelp": "Obtener ayuda",
        "openRate": "Tasa de apertura",
        "opened": "Abierto",
        "push": "Push",
        "setupRequired": "Configuración requerida",
        "sms": "SMS",
        "test": "Prueba",
        "viewDocumentation": "Ver documentación",
        "whatsapp": "WhatsApp",
        "names": {
          "email": "Correo electrónico",
          "whatsapp": "WhatsApp",
          "sms": "SMS",
          "push": "Citizen push"
        },
        "descriptions": {
          "email": "Envía correos electrónicos HTML enriquecidos con archivos adjuntos y seguimiento",
          "whatsapp": "Envía mensajes de WhatsApp a través de la API de Negocios",
          "sms": "Envía mensajes SMS para notificaciones urgentes",
          "push": "Notificaciones push a la aplicación móvil Citizen"
        },
        "attempts": "Intentos"
      },
      "composer": {
        "bold": "Negrita (**texto**)",
        "boldHtml": "Negrita (<strong>texto</strong>)",
        "boldShort": "Negrita",
        "channelsLabel": "Canales de entrega",
        "formattingToolbar": "Formato de texto",
        "italic": "Cursiva (*texto*)",
        "italicHtml": "Cursiva (<em>texto</em>)",
        "italicShort": "Cursiva",
        "link": "Enlace ([texto](url))",
        "linkHtml": "Enlace (<a href=\"…\">texto</a>)",
        "linkShort": "Vincular",
        "message": "Mensaje",
        "messageBodyHtml": "Cuerpo del mensaje (HTML)",
        "messagePlaceholder": "Escribe tu mensaje aquí…",
        "noSubject": "(sin asunto)",
        "noTemplate": "Mensaje en blanco — escribe el tuyo",
        "previewDesktop": "Escritorio",
        "previewEmpty": "Comienza a escribir para ver la vista previa.",
        "previewLabel": "Vista previa en vivo",
        "previewMobile": "Móvil",
        "previewPlain": "Texto plano",
        "recipientsCount_one": "{{count}} destinatario",
        "recipientsCount_other": "{{count}} destinatarios",
        "rendering": "Renderizando…",
        "startFromTemplate": "Comenzar desde una plantilla (opcional)",
        "subject": "Asunto",
        "subjectPlaceholder": "Un recordatorio amistoso — tu CheckUp está esperando",
        "tagsLabel": "Insertar una etiqueta",
        "tagsUsed": "Usado en este mensaje",
        "templatePlaceholder": "Elige una plantilla o deja en blanco",
        "viaEmail": "Correo electrónico"
      },
      "description": "Plantillas, envíos y entregas de cada mensaje de tu empresa",
      "editor": {
        "bodyRequired": "El cuerpo es obligatorio",
        "bodyTooLong": "El cuerpo es demasiado largo",
        "cancel": "Cancelar",
        "category": "Categoría",
        "channelRequired": "Selecciona al menos un canal",
        "createNewTemplate": "Crear nueva plantilla",
        "editTemplate": "Editar plantilla",
        "editorDescription": "Configura tu plantilla de mensaje con canales, contenido y etiquetas de personalización.",
        "hintPlain": "Usa la barra de herramientas (o **negrita**, *cursiva*, [enlace](url)) para formatear. Usa los marcadores de posición {{variable}} para insertar valores dinámicos.",
        "nameRequired": "El nombre es obligatorio",
        "nameTooLong": "El nombre es demasiado largo",
        "saveChanges": "Guardar cambios",
        "saving": "Guardando…",
        "sendTest": "Enviar prueba",
        "templateName": "Nombre de la plantilla",
        "templateNamePlaceholder": "Introduce el nombre de la plantilla...",
        "testSendSaveFirst": "Guarda tus cambios antes de enviar una prueba",
        "testSending": "Enviando prueba…",
        "unsaved": "Cambios no guardados",
        "unsavedConfirm": "Tienes cambios no guardados. ¿Deseas descartarlos y continuar?"
      },
      "newTemplate": "Nueva plantilla",
      "stats": {
        "activeTemplates": "Plantillas activas",
        "avgOpenRate": "Tasa de apertura promedio",
        "delivered": "Entregado",
        "sendAttempts": "Intentos de envío"
      },
      "tabs": {
        "analytics": "Analíticas",
        "channels": "Canales",
        "messageTemplates": "Plantillas de mensaje"
      },
      "templates": {
        "activated": "Plantilla activada",
        "allCategories": "Todas las categorías",
        "allChannels": "Todos los canales",
        "createFailed": "No se pudo crear la plantilla",
        "createFirstTemplate": "Crear primera plantilla",
        "createTemplate": "Crear plantilla",
        "created": "Plantilla creada",
        "deactivated": "Plantilla desactivada",
        "delete": "Eliminar",
        "deleteFailed": "No se pudo eliminar la plantilla",
        "deleteTitle": "¿Eliminar plantilla?",
        "deleteWarning": "Esto elimina permanentemente \"{{name}}\". Esta acción no se puede deshacer.",
        "deleted": "Plantilla eliminada",
        "deleting": "Eliminando…",
        "duplicate": "Duplicar",
        "duplicateFailed": "No se pudo duplicar la plantilla",
        "duplicated": "Plantilla duplicada",
        "edit": "Editar",
        "filterCategory": "Categoría",
        "filterChannel": "Canal",
        "inactive": "Inactivo",
        "loadError": "No se pudieron cargar las plantillas.",
        "noTemplatesFound": "No se encontraron plantillas",
        "restoreDefault": "Restaurar predeterminado",
        "restoreFailed": "No se pudo restaurar la plantilla predeterminada",
        "restored": "Plantilla predeterminada restaurada",
        "saveFailed": "No se pudo guardar la plantilla",
        "saved": "Plantilla guardada",
        "searchPlaceholder": "Introduce búsqueda...",
        "sendTest": "Enviar prueba",
        "testSendFailed": "Error al enviar el mensaje de prueba",
        "testSent": "Mensaje de prueba enviado",
        "toggleFailed": "No se pudo actualizar el estado de la plantilla",
        "tryAdjustingSearch": "Intenta ajustar la búsqueda",
        "talentTagWithoutSubject": "Este mensaje se envía a tu equipo sin referirse a ningún talento, así que {{tags}} no tiene a quién nombrar. Usa {{readerTag}} para dirigirte al lector.",
        "activeToggle": "Activa: {{name}}",
        "moreActions": "Más acciones para {{name}}",
        "alwaysOn": "Siempre activa: la propia plataforma envía los correos de cuenta y seguridad.",
        "sourceDuplicate": "Duplicado",
        "sourceCustom": "Personalizada",
        "sourceCustomized": "Modificada",
        "sourceSystem": "Predeterminada",
        "deliveredCount_one": "{{count}} entregado",
        "deliveredCount_other": "{{count}} entregados",
        "opened_one": "{{count}} abierto",
        "opened_other": "{{count}} abiertos",
        "sent_one": "{{count}} enviado",
        "sent_other": "{{count}} enviados",
        "searchLabel": "Buscar plantillas"
      },
      "title": "Mensajes",
      "categories": {
        "names": {
          "vetting": "Evaluación",
          "sponsorship": "Patrocinio",
          "mobility": "Movilidad",
          "adaptation": "Adaptación",
          "care": "Care",
          "evidence": "Evidencia",
          "general": "General",
          "account": "Cuenta y seguridad",
          "fiscal_document": "Facturas",
          "inout": "Avisos de InOut",
          "inout_agency": "Correo para la asesoría",
          "qultureup": "Avisos de QultureUp"
        },
        "descriptions": {
          "vetting": "CheckUp invitaciones, resultados y seguimientos",
          "sponsorship": "Invitaciones de viaje y comunicaciones de patrocinio",
          "mobility": "TelePortal tareas, documentos y actualizaciones de estado",
          "adaptation": "QultureUp misiones y recomendaciones de aprendizaje",
          "care": "Check-ins, intervenciones y apoyo al bienestar",
          "evidence": "Passport actualizaciones, insignias y logros",
          "general": "Anuncios generales y mensajes personalizados",
          "account": "Códigos y avisos de seguridad que envía la propia plataforma. Llegan a las personas sean cuales sean sus ajustes de notificaciones.",
          "fiscal_document": "El aviso que la plataforma envía cuando se emite la factura-recibo de un pago. Llega a todos, sean cuales sean sus ajustes de notificaciones.",
          "inout": "Avisos sobre el registro de residencia de una persona: un límite que se acerca, una pregunta de presencia, un plazo de renovación. Los envía la plataforma; cada persona elige cómo en los ajustes de InOut.",
          "inout_agency": "Lo que la plataforma envía sobre el caso de una persona con una asesoría — al buzón de casos de la asesoría o al de Tonnie — a petición de esa persona. Llega sean cuales sean los ajustes de notificaciones.",
          "qultureup": "Avisos sobre el progreso de una persona en un World de QultureUp con un socio (la Languages Academy): una misión completada, un nivel o la meta alcanzados, un recordatorio tras un tiempo sin actividad. La plataforma los envía; cada persona elige cómo en sus ajustes de notificaciones."
        }
      },
      "variables": {
        "talentFirstName": "Nombre de pila del talento",
        "talentLastName": "Apellido del talento",
        "talentFullName": "Nombre completo del talento",
        "talentEmail": "Dirección de correo electrónico del talento",
        "recipientFirstName": "Nombre de pila del destinatario",
        "recipientLastName": "Apellido del destinatario",
        "recipientFullName": "Nombre completo del destinatario",
        "recipientEmail": "Dirección de correo electrónico del destinatario",
        "talentRole": "Rol laboral del talento",
        "companyName": "Nombre de la empresa patrocinadora",
        "companyContact": "Persona de contacto de la empresa",
        "programName": "Nombre del programa",
        "cohortName": "Nombre de la cohorte",
        "journeyStage": "Etapa actual del viaje",
        "checkupBadge": "iQulture nivel de insignia",
        "mobilityArrivalDate": "Fecha estimada de llegada",
        "mobilityNextTask": "Próxima tarea de movilidad",
        "missionName": "QultureUp nombre de la misión",
        "actionUrl": "URL/enlace de acción",
        "actionDeadline": "Fecha límite de acción"
      },
      "cohortRecipientCount_one": "{{count}} miembro",
      "cohortRecipientCount_other": "{{count}} miembros",
      "cohortSent_one": "Mensaje enviado a {{count}} persona.",
      "cohortSent_other": "Mensaje enviado a {{count}} personas."
    },
    "businessNotifications": {
      "allCaughtUp": "Todo al día",
      "allNotifications": "Todas las notificaciones",
      "allTab": "Todo ({{count}})",
      "delete": "Eliminar",
      "deleteCount": "Eliminar ({{count}})",
      "filter": "Filtrar",
      "markAllRead": "Marcar todo como leído",
      "markAsRead": "Marcar como leído",
      "new": "Nuevo",
      "noNotifications": "Sin notificaciones",
      "noNotificationsDesc": "La nueva actividad de tus talentos aparecerá aquí",
      "noUnreadNotifications": "Sin notificaciones no leídas",
      "selectAll": "Seleccionar todo",
      "settings": "Configuraciones",
      "summary": {
        "completed": "Completado",
        "unread": "No Leídas",
        "urgent": "Urgente",
        "warnings": "Advertencias"
      },
      "title": "Notificaciones",
      "unreadTab": "No leídas ({{count}})",
      "unreadUrgent": "{{unread}} no leídas, {{urgent}} urgentes",
      "urgentBadge": "Insignia urgente",
      "viewDetails": "Ver detalles",
      "viewDetailsButton": "Botón ver detalles",
      "categories": {
        "all": "Todo",
        "mobility": "Movilidad",
        "care": "Care",
        "vetting": "Evaluación",
        "evidence": "Evidencia",
        "cohorts": "Cohortes"
      },
      "unreadCount_one": "{{count}} notificación no leída",
      "unreadCount_other": "{{count}} notificaciones no leídas",
      "actionsFor": "Acciones para «{{title}}»",
      "selectNotification": "Seleccionar «{{title}}»"
    },
    "businessOnboarding": {
      "addTalents": {
        "addFromATSOrExcel": "Añadir candidatos desde tu ATS o subir un archivo Excel/CSV",
        "addTalentsButton": "Añadir talentos",
        "added": "Añadido",
        "afterOnboarding": "Después de completar la incorporación, invita a estos talentos a CheckUp desde el menú de Adquisición",
        "emptyStateDescription": "Importar candidatos desde tu ATS o subir un archivo Excel/CSV. Se creará automáticamente una cohorte predeterminada.",
        "importDescription": "Importa tus candidatos para comenzar. Los talentos importados aparecerán en el menú de Adquisición, donde podrás invitarlos para CheckUp (evaluación). Se creará automáticamente una cohorte predeterminada cuando agregues tus primeros talentos.",
        "importTalents": "Importar talentos",
        "startImport": "Iniciar importación",
        "step1": "Selecciona un grupo de talentos para invitar a CheckUp (evaluación y valoración)",
        "step2": "Después de la finalización de CheckUp, podrás patrocinar talentos evaluados y definir su ruta de migración",
        "step3": "Los talentos patrocinados comenzarán el viaje a través de: Movilidad -> Adaptación -> Care -> Evidencia",
        "step4": "Organiza tus iniciativas de contratación creando programas y cohortes en cualquier momento",
        "step5": "Usa CoPilot para operaciones guiadas y apoyo durante todo el proceso",
        "title": "Añadir talentos",
        "whatsNext": "¿Qué sigue?",
        "whatsNextDescription": "Después de importar talentos, aparecerán en el menú de Adquisición. Desde allí:",
        "readyForCheckUp_one": "{{count}} talento listo para el CheckUp",
        "readyForCheckUp_other": "{{count}} talentos listos para el CheckUp",
        "talentsAdded_one": "{{count}} talento añadido",
        "talentsAdded_other": "{{count}} talentos añadidos"
      },
      "additionalDetails": {
        "billing": {
          "billingAddressHint": "Utilizado para facturas y notificaciones de facturación",
          "billingAddressLabel": "Dirección de facturación",
          "billingAddressPlaceholder": "Dirección de la calle",
          "businessTypeLabel": "Tipo de negocio",
          "city": "Ciudad",
          "complement": "Apartamento, suite, etc. (opcional)",
          "complementPlaceholder": "p. ej. Suite 200",
          "country": "País",
          "description": "Requerido antes de que puedas actualizar a un plan de pago.",
          "legalNameLabel": "Nombre de la entidad legal",
          "postalCodeLabel": "Código postal",
          "state": "Estado / Región",
          "street": "Calle",
          "taxIdLabel": "ID fiscal / IVA",
          "title": "Facturación y legal"
        },
        "contact": {
          "description": "Teléfono directo y año de fundación de la empresa.",
          "foundedLabel": "Año de fundación",
          "phoneLabel": "Teléfono de contacto",
          "title": "Información de contacto y de la empresa"
        },
        "description": "Cada campo es opcional. Expande las secciones que deseas completar — el resto permanecerá como recordatorios en tu panel.",
        "geographic": {
          "branchesLabel": "Oficinas sucursales",
          "cityPlaceholder": "Ciudad",
          "countryPlaceholder": "País",
          "description": "Sucursales, requisitos de idioma y arreglo laboral.",
          "languagesLabel": "Requisitos de idioma",
          "title": "Detalles geográficos",
          "workArrangement": "Arreglo laboral",
          "minimumLevel": "Nivel mínimo",
          "languageLabel": "Idioma"
        },
        "hiring": {
          "challengesLabel": "Principales desafíos (máx. 3)",
          "description": "Objetivos, plazo, madurez, roles objetivo y desafíos.",
          "goalsLabel": "Objetivos de contratación primarios",
          "maturityLabel": "Madurez del programa de movilidad",
          "rolesLabel": "Tipos de roles objetivo",
          "timeframeLabel": "Plazo de contratación",
          "title": "Detalles de contratación"
        },
        "title": "Completa los detalles restantes"
      },
      "companyProfile": {
        "businessDetails": {
          "description": "Ayúdanos a entender tu modelo de negocio y presencia en línea",
          "title": "Detalles del negocio"
        },
        "businessType": "Tipo de negocio",
        "businessTypes": {
          "agency": "Agencia",
          "enterprise": "Empresa",
          "scaleup": "Escalado",
          "startup": "Startup",
          "startupDesc": "Etapa temprana, alto crecimiento",
          "scaleupDesc": "Modelo probado, escalando rápido",
          "enterpriseDesc": "Gran empresa establecida",
          "agencyDesc": "Proveedor de servicios"
        },
        "companyInfo": {
          "description": "Detalles básicos sobre tu organización",
          "title": "Información de la empresa"
        },
        "companyName": "Nombre de la empresa",
        "companySize": "Tamaño de la empresa",
        "description": "Cuéntanos sobre tu organización. Esta información nos ayuda a personalizar tu experiencia y prepararnos para los requisitos de cumplimiento.",
        "emailPlaceholder": "john@company.com",
        "emailRequired": "Correo electrónico *",
        "enterCompanyName": "Introduce el nombre de la empresa",
        "enterPhoneNumber": "Introduce tu número de teléfono",
        "forContractsAndLegal": "Para contratos y documentos legales",
        "foundedYear": "Año de fundación",
        "fullNamePlaceholder": "John Doe",
        "fullNameRequired": "Nombre completo *",
        "industry": "Industria",
        "legalEntityName": "Nombre de la entidad legal",
        "legalEntityPlaceholder": "p. ej., Company Inc., Company Ltd.",
        "legalInfo": {
          "description": "Para la preparación de cumplimiento y contratos (opcional pero recomendado para empresas)",
          "title": "Información legal"
        },
        "linkedinCompanyPage": "Página de empresa de LinkedIn",
        "phone": "Teléfono",
        "primaryContact": {
          "description": "El principal punto de contacto para tu organización",
          "title": "Contacto principal"
        },
        "registeredCountry": "País registrado",
        "registeredCountryDesc": "Dónde está legalmente registrada tu empresa",
        "registeredCountryRequired": "País registrado *",
        "requiredForEnterprise": "Requerido para la facturación empresarial",
        "roleJobTitle": "Rol / Título del trabajo",
        "selectCountry": "Selecciona país",
        "selectIndustry": "Selecciona industria",
        "selectRole": "Selecciona rol",
        "selectSize": "Selecciona tamaño",
        "selectYear": "Selecciona año",
        "taxIdPlaceholder": "p. ej., DE123456789",
        "taxIdVat": "ID fiscal / Número de IVA",
        "title": "Perfil de la empresa",
        "website": "Sitio web",
        "industries": {
          "technology": "Tecnología",
          "healthcare": "Atención médica",
          "finance": "Finanzas",
          "manufacturing": "Manufactura",
          "retail": "Retail",
          "hospitality": "Hospitalidad",
          "construction": "Construcción",
          "education": "Educación",
          "consulting": "Consultoría",
          "logistics": "Logística",
          "energy": "Energía",
          "telecommunications": "Telecomunicaciones",
          "mediaEntertainment": "Medios y entretenimiento",
          "realEstate": "Bienes raíces",
          "other": "Otro"
        },
        "companySizes": {
          "size1to50": "1-50 empleados",
          "size51to200": "51-200 empleados",
          "size201to500": "201-500 empleados",
          "size501to1000": "501-1000 empleados",
          "size1000plus": "1000+ empleados"
        },
        "contactRoles": {
          "ceoFounder": "CEO / Fundador",
          "hrDirector": "Director de RRHH",
          "headOfTalentAcquisition": "Jefe de adquisición de talento",
          "mobilityManager": "Gerente de movilidad",
          "hrBusinessPartner": "Socio de RRHH",
          "peopleOperations": "Operaciones de personas",
          "recruiter": "Reclutador",
          "other": "Otro"
        }
      },
      "complete": "¡Onboarding completo!",
      "confirmCard": {
        "backToConfirm": "Volver a la vista autocompletada",
        "dataFrom": "Datos de",
        "description": "Hemos extraído esto del sitio web público de tu empresa. Confirma que se ve correcto.",
        "editDetails": "Editar detalles",
        "loading": "Buscando tu empresa...",
        "loadingDesc": "Esto suele tardar de 2 a 3 segundos.",
        "manualDesc": "No pudimos detectar automáticamente tu empresa. Por favor, completa lo básico a continuación.",
        "multipleSources": "múltiples fuentes",
        "retry": "Reintentar detección automática",
        "thatsUs": "Ese somos nosotros",
        "title": "¿Eres tú?",
        "yourRole": "Tu rol en {{company}}"
      },
      "errors": {
        "cohortCreation": "Error al crear el grupo. Por favor, inténtalo de nuevo.",
        "completion": "Error al finalizar la incorporación. Por favor, inténtalo de nuevo.",
        "programCreation": "Error al crear el programa. Por favor, inténtalo de nuevo."
      },
      "geographicSetup": {
        "addAnotherCountry": "Añadir otro país...",
        "addBranchOffice": "Añadir oficina sucursal",
        "branchOfficesDesc": "Añadir otras ubicaciones que puedan recibir talento reubicado (opcional)",
        "branchOfficesTitle": "Oficinas sucursales",
        "canReceiveTalent": "Puede recibir talento",
        "city": "Ciudad",
        "cityName": "Nombre de la ciudad",
        "cityPlaceholder": "p. ej., Lisboa, Berlín, Ámsterdam",
        "cityRequired": "Ciudad *",
        "country": "País",
        "countryRequired": "País *",
        "description": "Configura las ubicaciones de tu empresa y los mercados de contratación objetivo. Esto nos ayuda a preconfigurar rutas de migración y requisitos de cumplimiento.",
        "headquartersDesc": "La ubicación de tu oficina principal donde trabajará principalmente el talento reubicado",
        "headquartersTitle": "Ubicación de la sede",
        "languageRequirementsDesc": "¿Qué idiomas deben hablar los candidatos? (Opcional)",
        "languageRequirementsTitle": "Requisitos de idioma",
        "migrationRoutesDesc": "Según tu configuración, estas rutas de migración se preconfigurarán",
        "migrationRoutesPreview": "Vista previa de rutas de migración",
        "officeName": "Nombre de la oficina",
        "officeNamePlaceholder": "p. ej., Oficina de Berlín",
        "popularSourceMarkets": "Mercados de origen populares",
        "selectCountry": "Selecciona país",
        "selectedMarkets": "Mercados seleccionados ({{count}})",
        "targetHiringMarketsDesc": "¿De dónde planeas contratar? Selecciona tus mercados de origen.",
        "targetHiringMarketsTitle": "Mercados de contratación objetivo",
        "workArrangementDesc": "¿Qué tipo de acuerdo laboral ofreces para el talento reubicado?",
        "workArrangementTitle": "Arreglo laboral",
        "languages": {
          "english": "Inglés",
          "spanish": "Spanish",
          "portuguese": "Portuguese",
          "german": "German",
          "french": "French",
          "dutch": "Dutch",
          "italian": "Italian",
          "polish": "Polish",
          "arabic": "Arabic",
          "chineseMandarin": "Chino (Mandarín)",
          "japanese": "Japanese",
          "korean": "Korean"
        },
        "languageLevels": {
          "a1": "A1 — Principiante",
          "a2": "A2 — Elemental",
          "b1": "B1 — Intermedio",
          "b2": "B2 — Intermedio alto",
          "c1": "C1 — Avanzado",
          "c2": "C2 — Dominante"
        },
        "workArrangements": {
          "onsite": "En sitio",
          "onsiteDesc": "Presencia en oficina a tiempo completo",
          "hybrid": "Híbrido",
          "hybridDesc": "Mezcla de oficina y remoto",
          "flexible": "Flexible",
          "flexibleDesc": "Elección del empleado"
        },
        "minimumLevelFor": "Nivel mínimo de {{language}}",
        "otherMarketLabel": "Otro mercado de contratación",
        "addMarket": "Añadir mercado",
        "addLanguage": "Añadir {{language}}"
      },
      "hiringContext": {
        "annualHiringVolume": "Volumen anual de contratación internacional",
        "description": "Ayúdanos a entender tus objetivos y estrategia de contratación. Esto nos permite personalizar tu experiencia y ofrecer recomendaciones relevantes.",
        "hiringGoalsDesc": "¿Qué quieres lograr? Selecciona todo lo que aplique.",
        "hiringGoalsTitle": "Objetivos de contratación",
        "mobilityProgramMaturity": "Madurez del programa de movilidad",
        "primaryUseCaseDesc": "¿Cuál es tu principal razón para usar Tonnie? Selecciona la opción que mejor describa tu situación.",
        "primaryUseCaseTitle": "Caso de uso principal",
        "scaleTimelineDesc": "Ayúdanos a entender el alcance y la urgencia de tus necesidades de contratación.",
        "scaleTimelineTitle": "Escala y cronograma",
        "targetRoleTypesDesc": "¿Qué tipos de roles estás contratando principalmente? Selecciona todo lo que aplique.",
        "targetRoleTypesTitle": "Tipos de roles objetivo",
        "topChallengesDesc": "¿Cuáles son tus mayores desafíos con la contratación internacional? Selecciona tus 3 principales.",
        "topChallengesTitle": "Principales desafíos",
        "useCases": {
          "costOptimization": "Optimización de costos",
          "costOptimizationDesc": "Acceso a talento de diferentes mercados",
          "diversity": "Diversidad e inclusión",
          "diversityDesc": "Construcción de equipos internacionales diversos",
          "globalExpansion": "Expansión global",
          "globalExpansionDesc": "Expansión de operaciones a nuevos mercados con talento local",
          "internationalHiring": "Contratación internacional",
          "internationalHiringDesc": "Contratando talento internacional para reubicarlo en tus oficinas",
          "remoteToRelocation": "Remoto a reubicación",
          "remoteToRelocationDesc": "Convirtiendo trabajadores remotos en empleados reubicados",
          "talentShortage": "Escasez de talento",
          "talentShortageDesc": "Abordando las brechas de talento local con abastecimiento global"
        },
        "volumes": {
          "enterprise": "Escala empresarial",
          "established": "Programa establecido",
          "growing": "Programa en crecimiento",
          "starting": "Comenzando"
        },
        "whenPlanToStart": "¿Cuándo planeas empezar?",
        "goals": {
          "reduceTimeToHire": "Reducir el tiempo de contratación para candidatos internacionales",
          "improveCandidateExperience": "Mejorar la experiencia del candidato durante la reubicación",
          "increaseRetention": "Aumentar la retención de empleados reubicados",
          "streamlineCompliance": "Optimizar procesos de cumplimiento y visados",
          "trackMobilityRoi": "Rastrear y medir el ROI de la movilidad",
          "reduceRelocationCosts": "Reducir costos de reubicación",
          "buildTalentPipeline": "Construir un pipeline de talento sostenible",
          "improveOnboarding": "Mejorar la incorporación y adaptación post-llegada"
        },
        "challenges": {
          "immigrationVisa": "Complejidad de inmigración y visados",
          "findingCandidates": "Encontrar candidatos internacionales calificados",
          "candidateDropoff": "Abandono de candidatos durante la reubicación",
          "postArrival": "Adaptación y retención post-llegada",
          "complianceLegal": "Complejidad de cumplimiento y legal",
          "costManagement": "Gestión de costos",
          "trackingReporting": "Seguimiento e informes"
        },
        "timeframes": {
          "immediate": "Inmediato",
          "immediateDesc": "Listo para comenzar ahora",
          "planningDesc": "Fase de planificación",
          "futureDesc": "Pipeline futuro",
          "strategicDesc": "Planificación estratégica"
        },
        "maturity": {
          "firstTime": "Primera vez",
          "firstTimeDesc": "Nuevo en la contratación internacional",
          "someExperience": "Algo de experiencia",
          "someExperienceDesc": "Hecho algunas reubicaciones",
          "establishedProgram": "Programa establecido",
          "establishedProgramDesc": "Función de movilidad madura"
        },
        "roleTypes": {
          "engineering": "Ingeniería",
          "product": "Producto",
          "design": "Diseño",
          "dataScience": "Ciencia de datos",
          "devops": "DevOps / Infraestructura",
          "marketing": "Marketing",
          "sales": "Ventas",
          "customerSuccess": "Éxito del cliente",
          "finance": "Finanzas",
          "hrPeople": "RRHH / Personas",
          "operations": "Operaciones",
          "executive": "Ejecutivo / Liderazgo",
          "other": "Otro"
        }
      },
      "hiringSignals": {
        "annualVolume": "Volumen de contratación anual",
        "annualVolumeDesc": "¿Cuántas contrataciones internacionales esperas en los próximos 12 meses?",
        "description": "Dos preguntas rápidas para que podamos personalizar tu espacio de trabajo.",
        "primaryUseCase": "Caso de uso principal",
        "title": "¿Qué te trae a Tonnie?"
      },
      "loadingProgress": "Cargando tu progreso...",
      "markets": {
        "description": "Selecciona hasta 3 mercados. Siempre puedes agregar más después.",
        "headquarters": "Sede",
        "targetMarkets": "Mercados de contratación objetivo",
        "title": "¿De dónde estás contratando?"
      },
      "progressRestored": "Tu progreso ha sido restaurado",
      "progressSaved": "Progreso guardado",
      "validation": {
        "requiredFields": "Por favor completa los campos requeridos antes de continuar."
      },
      "review": {
        "editDescription": "Revisa tus detalles y guarda cuando estés listo. Siempre puedes volver a este asistente desde la página de Configuración.",
        "editTitle": "Tu perfil organizacional",
        "firstTimeDescription": "Aquí está lo que capturamos para que empieces. Siempre puedes agregar más detalles más tarde desde tu panel.",
        "firstTimeNotice": "Toca Completar Configuración para activar tu espacio de trabajo. Los detalles opcionales que falten aparecerán como recordatorios en tu panel de control.",
        "firstTimeTitle": "Estás listo",
        "jumpToAdditional": "Volver a detalles adicionales",
        "missingFieldsNotice_one": "Aún tienes {{count}} detalle opcional por completar. Completarlo mejora la coincidencia por IA y desbloquea la facturación.",
        "missingFieldsNotice_other": "Aún tienes {{count}} detalles opcionales por completar. Completarlos mejora la coincidencia por IA y desbloquea la facturación."
      },
      "roles": {
        "founderExec": "Fundador / Ejecutivo",
        "hrPeople": "RRHH / Personas",
        "mobilityManager": "Gerente de movilidad",
        "talentAcquisition": "Adquisición de talento"
      },
      "saveFailed": "Error al guardar el progreso",
      "steps": {
        "addTalents": {
          "badge": "Clave",
          "description": "Activa tu cuenta añadiendo talentos",
          "title": "Añadir primeros talentos"
        },
        "additionalDetails": {
          "description": "Campos opcionales para mejorar la coincidencia y desbloquear la facturación.",
          "title": "Detalles adicionales"
        },
        "companyProfile": {
          "description": "Cuéntanos sobre tu organización",
          "title": "Perfil de la empresa"
        },
        "geographicSetup": {
          "description": "Ubicaciones y rutas de migración",
          "title": "Configuración geográfica"
        },
        "hiringContext": {
          "description": "Tus objetivos y estrategia de contratación",
          "title": "Contexto de contratación"
        },
        "review": {
          "description": "Confirma lo que capturamos y finaliza la configuración.",
          "title": "Revisar y completar"
        }
      },
      "updated": "Perfil actualizado",
      "wizard": {
        "completeSetup": "Completar configuración",
        "completing": "Configurando...",
        "progressSaved": "Tu progreso se guardará automáticamente",
        "saveChanges": "Guardar cambios",
        "skipInfo": "Puedes omitir y completar más tarde",
        "subtitle": "Incorporación de la empresa",
        "title": "Tonnie Business"
      }
    },
    "businessSettings": {
      "branding": {
        "a11yBrandConsistency": "Mantén la consistencia de la marca mientras aseguras la accesibilidad",
        "a11yColorBlind": "Prueba con simuladores de daltonismo",
        "a11yContrast": "Asegura un contraste suficiente entre el texto y el fondo (WCAG AA: 4.5:1)",
        "accessibilityGuidelines": "Directrices de accesibilidad",
        "activateTheme": "Activar tema",
        "activateThisTheme": "Activar este tema",
        "active": "Activo",
        "appIcon": "Icono de la aplicación",
        "appIconDesc": "El icono cuadrado que aparece en las pestañas del navegador y en los móviles",
        "assets": "Activos",
        "colors": "Colores",
        "customDesc": "Los colores de tu marca",
        "customMode": "Modo personalizado",
        "dark": "Oscuro",
        "darkDesc": "Texto claro sobre fondo oscuro",
        "dashboard": "Tablero",
        "description": "Tu logotipo, colores y tema en todo el portal",
        "draft": "Borrador",
        "enterPreviewDesc": "Mira el portal con tu marca antes de guardarla",
        "enterPreviewMode": "Entrar en modo vista previa",
        "exitPreview": "Salir de la vista previa",
        "favicon": "Favicon",
        "faviconDesc": "El pequeño icono de la pestaña del navegador",
        "fileFormatsHint": "{{formats}} (máx {{maxSize}})",
        "heroImageN": "Imagen hero {{number}}",
        "heroImages": "Imágenes hero",
        "heroImagesDesc": "Imágenes de cabecera que aparecen arriba de tus páginas",
        "light": "Ligero",
        "lightDesc": "Texto oscuro sobre fondo claro",
        "loginPage": "Página de inicio de sesión",
        "preview": "Vista previa",
        "previewModeActive": "Modo vista previa activo",
        "primaryLogo": "Logo principal",
        "primaryLogoDesc": "Aparece en la barra lateral y en los documentos que compartes",
        "replace": "Reemplazar",
        "saveDraft": "Guardar borrador",
        "secondaryLogo": "Logo secundario",
        "secondaryLogoDesc": "Una versión compacta para espacios pequeños",
        "switchToCustomAssets": "Cambiar a activos personalizados",
        "switchToCustomColors": "Cambiar a colores personalizados",
        "switchToCustomPreview": "Cambiar a vista previa personalizada",
        "themeMode": "Modo de tema",
        "themeModeDesc": "Claro, oscuro o tus colores",
        "title": "Marca",
        "upload": "Subir",
        "uploading": "Subiendo…",
        "colorNames": {
          "primary": "Principal",
          "secondary": "Secundario",
          "accent": "Acento",
          "success": "Éxito",
          "warning": "Advertencia",
          "error": "Error",
          "background": "Fondo",
          "foreground": "Texto"
        },
        "colorPickerLabel": "Selector de color: {{name}}",
        "colorHexLabel": "Código hexadecimal: {{name}}"
      },
      "care": {
        "description": "Cómo funciona Care para tus talentos: pilares, check-ins y objetivos",
        "enterpriseDescription": "Los ajustes personalizados de Care forman parte del plan Enterprise",
        "features": {
          "checkpointSchedule": "Horario de checkpoint",
          "checkpointScheduleDesc": "Cuándo se pide a los talentos su check-in de Care",
          "customPillars": "Pilares personalizados",
          "customPillarsDesc": "Qué pilares de bienestar valoran tus talentos",
          "feedbackConfig": "Configuración de feedback",
          "feedbackConfigDesc": "Quién da feedback sobre objetivos, y con qué frecuencia",
          "talentObjectives": "Objetivos de los talentos",
          "talentObjectivesDesc": "Los objetivos en los que trabajan tus talentos",
          "title": "Funciones"
        },
        "saveFailed": "No se pudo guardar la configuración de Care. Por favor, inténtalo de nuevo.",
        "saved": "Configuración de Care guardada",
        "title": "Care"
      },
      "compliance": {
        "actionLabels": {
          "system_template_dispatched_pre_clerk": "Correo del sistema enviado",
          "talent_bulk_imported": "Talentos importados en masa",
          "talent_invitation_created": "Invitación creada",
          "talent_invitation_email_failed": "Correo de invitación no enviado",
          "talent_invitation_revoked": "Invitación revocada",
          "talent_invitation_sent": "Invitación enviada",
          "talent_invited_to_vetting": "Invitado a la evaluación",
          "account_email_changed": "Correo de la cuenta cambiado",
          "account_name_changed": "Nombre de la cuenta cambiado",
          "affiliate_payout_cancelled": "Pago de afiliado cancelado",
          "affiliate_payout_invoice_attached": "Factura adjuntada al pago de afiliado",
          "affiliate_payout_requested": "Pago de afiliado solicitado",
          "affiliate_platform_overview_viewed": "Resumen de la plataforma de afiliados consultado",
          "communications_relinked_to_account": "Mensajes vinculados a la cuenta",
          "evidence_blob_read": "Archivo de evidencia abierto",
          "evidence_blob_released": "Archivo de evidencia liberado",
          "evidence_capture_expired": "Registro de decisión caducado",
          "evidence_capture_read": "Registro de decisión abierto",
          "evidence_diff_viewed": "Registro de decisión comparado con hoy",
          "evidence_item_redacted": "Elemento de evidencia ocultado",
          "feature_flags_write": "Funciones activadas cambiadas",
          "invitation_claimed": "Invitación reclamada",
          "pool_bulk_imported": "Candidatos importados en bloque",
          "pool_candidate_ingested": "Candidato añadido a la bolsa",
          "pool_cv_viewed": "CV del candidato consultado",
          "service_credential_created": "Credencial de servicio creada",
          "service_credential_revoked": "Credencial de servicio revocada",
          "talent_invitation_deleted": "Invitación eliminada",
          "talent_invitation_superseded": "Invitación sustituida por una nueva",
          "account_name_reconciled": "Nombre de la cuenta conciliado",
          "ops_vault_orphan_delete": "Archivo huérfano eliminado",
          "talent_invitation_declined": "Invitación rechazada",
          "fiscal_document_retried": "Factura-recibo reintentada",
          "fiscal_credit_note_recorded": "Nota de crédito registrada",
          "fiscal_config_written": "Configuración de facturación cambiada",
          "fiscal_retroactive_queued": "Facturas de pagos anteriores en cola",
          "inout_cases_listed": "Casos InOut listados",
          "inout_case_viewed": "Caso InOut consultado",
          "inout_case_event_recorded": "Evento de caso InOut registrado",
          "inout_tracking_file_previewed": "Archivo de seguimiento InOut previsualizado",
          "inout_tracking_file_loaded": "Archivo de seguimiento InOut cargado",
          "inout_refund_request_handled": "Solicitud de reembolso InOut tramitada",
          "inout_reconciliation_viewed": "Conciliación InOut consultada",
          "inout_portal_saved": "Portal InOut guardado"
        },
        "allActions": "Todas las acciones",
        "allUsers": "Todos los usuarios",
        "auditLogs": "Registros de auditoría",
        "auditLogsDesc": "Rastrear quién hizo qué, cuándo y dónde en tu negocio.",
        "date": "Fecha",
        "description": "Registros de auditoría, retención de datos y ajustes de privacidad de la empresa",
        "loadMore": "Cargar más",
        "loading": "Cargando…",
        "noResults": "No hay eventos de auditoría que coincidan con tus filtros.",
        "resourceLabels": {
          "journey_invitation": "Invitación de viaje",
          "message_template": "Plantilla de mensaje",
          "tenant": "Organización",
          "affiliate_payout": "Pago de afiliado",
          "affiliate_platform": "Plataforma de afiliados",
          "engagement_evidence_blob": "Archivo de evidencia",
          "engagement_evidence_capture": "Registro de decisión",
          "engagement_evidence_item": "Elemento de evidencia",
          "platform_configs": "Ajustes de la plataforma",
          "service_credential": "Credencial de servicio",
          "talent": "Talento",
          "user": "Usuario",
          "vault_file": "Archivo de la bóveda",
          "billing_invoice": "Pago",
          "inout_case": "Caso InOut",
          "inout_reconciliation": "Conciliación InOut",
          "inout_tracking_import": "Archivo de seguimiento InOut",
          "inout_portal": "Portal InOut"
        },
        "showing": "Mostrando {{shown}} de {{total}}",
        "systemActor": "Sistema",
        "title": "Cumplimiento",
        "filterByUser": "Filtrar por usuario",
        "filterByAction": "Filtrar por acción"
      },
      "description": "Tu organización, equipo, marca y preferencias",
      "enterpriseLock": {
        "badge": "Empresa",
        "description": "Esta función está disponible en el plan Enterprise.",
        "title": "Bloqueado",
        "upgrade": "Actualizar a Enterprise"
      },
      "organization": {
        "annualVolume": "Volumen anual",
        "billingAddress": "Dirección de facturación",
        "billingCity": "Ciudad",
        "billingCountry": "País",
        "billingLegal": "Información legal",
        "billingLegalDesc": "Utilizado en facturas, contratos y documentos fiscales.",
        "billingState": "Estado / Región",
        "branchOffices": "Oficinas sucursales",
        "businessType": "Tipo de negocio",
        "companyName": "Nombre de la empresa",
        "companyProfile": "Perfil de la empresa",
        "companyProfileDesc": "El nombre, el sector y los datos de contacto de tu empresa",
        "companySetup": "Configuración de la empresa",
        "companySize": "Tamaño de la empresa",
        "complement": "Apartamento, suite, etc.",
        "contactEmail": "Correo electrónico de contacto",
        "contactPhone": "Teléfono de contacto",
        "contactRole": "Rol de contacto",
        "description": "El perfil de tu empresa, ubicaciones y contexto de contratación",
        "editInOnboardingWizard": "Editar en el asistente de incorporación",
        "foundedYear": "Fundado",
        "geographicSetup": "Configuración geográfica",
        "geographicSetupDesc": "Dónde está tu empresa y a dónde se trasladan los talentos",
        "headquarters": "Sede",
        "hiringContext": "Contexto de contratación",
        "hiringContextDesc": "Los puestos para los que contratas y los retos que afrontas",
        "hiringGoals": "Objetivos de contratación",
        "industry": "Industria",
        "languageRequirements": "Requisitos de idioma",
        "legalName": "Nombre legal",
        "linkedin": "LinkedIn",
        "maturityLevel": "Nivel de madurez",
        "postalCode": "Código postal",
        "primaryContact": "Contacto principal",
        "primaryUseCase": "Caso de uso principal",
        "registeredCountry": "País registrado",
        "targetHiringMarkets": "Mercados de contratación objetivo",
        "targetRoles": "Roles objetivo",
        "taxId": "ID fiscal / IVA",
        "timeframe": "Plazo",
        "title": "Organización",
        "topChallenges": "Principales desafíos",
        "website": "Sitio web",
        "workArrangement": "Arreglo laboral"
      },
      "preferences": {
        "dateFormat": "Formato de fecha",
        "description": "Idioma, notificaciones y cómo funciona el portal para ti",
        "discardChanges": "Descartar",
        "emailNotifications": "Notificaciones por correo electrónico",
        "emailNotificationsDesc": "Qué novedades te llegan por correo electrónico",
        "language": "Idioma",
        "localization": "Localización",
        "localizationDesc": "Tu idioma, zona horaria y formato de fecha",
        "moreComingSoon": "Más preferencias están en camino: idiomas adicionales, zonas horarias y controles de notificación aparecerán aquí a medida que los implementemos.",
        "pushNotifications": "Notificaciones push",
        "pushNotificationsDesc": "Qué novedades aparecen como notificaciones del navegador",
        "saveFailed": "No se pudieron guardar las preferencias. Por favor, inténtalo de nuevo.",
        "savePreferences": "Guardar preferencias",
        "quietHours": "Horario de silencio",
        "quietHoursDesc": "Pausa las notificaciones push durante estas horas.",
        "quietHoursEnd": "Hasta",
        "quietHoursStart": "Desde",
        "saved": "Preferencias actualizadas",
        "timezone": "Zona horaria",
        "title": "Preferencias",
        "unsavedChanges": "Tienes cambios no guardados",
        "channelsTitle": "Canales de notificación",
        "channelsDesc": "Cómo recibes las notificaciones.",
        "categoriesTitle": "Sobre qué recibes avisos",
        "categoriesDesc": "Elige qué tipos de novedades te llegan.",
        "category": {
          "hero": "Recorrido del talento",
          "heroDesc": "Progreso de CheckUp, Care y movilidad de tus talentos.",
          "system": "Cuenta y sistema",
          "systemDesc": "Seguridad, cuenta y mantenimiento de la plataforma.",
          "social": "Personas y pipeline",
          "socialDesc": "Evaluaciones, equipo e interacciones con candidatos.",
          "alert": "Alertas y facturación",
          "alertDesc": "Sensibles al tiempo o al dinero: facturación, pagos y plazos."
        }
      },
      "sections": {
        "branding": "Marca",
        "brandingDesc": "Tema, colores y activos",
        "care": "Care",
        "careDesc": "Configuración y pilares de Care",
        "compliance": "Cumplimiento",
        "complianceDesc": "Registros de auditoría, retención de datos y exportaciones",
        "organization": "Organización",
        "organizationDesc": "Perfil y configuración de la empresa",
        "preferences": "Preferencias",
        "preferencesDesc": "Notificaciones, idioma y configuración regional",
        "profile": "Perfil",
        "profileDesc": "Tu información personal y avatar",
        "security": "Seguridad",
        "securityDesc": "Autenticación, contraseñas y acceso",
        "team": "Equipo",
        "teamDesc": "Miembros, roles y permisos",
        "serviceCredentials": "Credenciales de servicio",
        "serviceCredentialsDesc": "Tokens de solo lectura para scripts y herramientas de informes"
      },
      "security": {
        "accountDeleteFailed": "No se pudo eliminar la cuenta",
        "accountDeleted": "Cuenta eliminada",
        "confirmDelete": "Eliminar para siempre",
        "confirmDeleteOrg": "Eliminar organización para siempre",
        "dangerZone": "Zona de peligro",
        "dangerZoneDesc": "Acciones irreversibles. Por favor, asegúrate.",
        "deleteAccount": "Eliminar cuenta",
        "deleteAccountConfirmPrompt": "Escribe DELETE para confirmar:",
        "deleteAccountDesc": "Eliminar permanentemente tu cuenta de usuario y todos los datos asociados.",
        "deleteAccountTitle": "Eliminar cuenta",
        "deleteAccountWarning": "Esta acción es permanente y no se puede deshacer. Todos tus datos serán eliminados.",
        "deleteOrg": "Eliminar organización",
        "deleteOrgConfirmPrompt": "Escribe el nombre de la organización para confirmar:",
        "deleteOrgFailed": "No se pudo eliminar la organización. Por favor, intenta de nuevo o contacta con soporte.",
        "deleteOrgSuccess": "Organización eliminada.",
        "deleteOrgTitle": "Eliminar organización",
        "deleteOrgWarning": "Esto eliminará permanentemente la organización, todas las membresías del equipo, programas, cohortes y datos de talento.",
        "deleteOrganization": "Eliminar esta organización",
        "deleteOrganizationDesc": "Eliminar la organización, todos los miembros del equipo, programas y datos. Esto no se puede deshacer.",
        "deleting": "Eliminando…",
        "description": "Inicio de sesión, sesiones y eliminación de tu organización",
        "title": "Seguridad",
        "deleteOrgStripeWarning_one": "Organización eliminada. {{count}} suscripción no se pudo cancelar automáticamente — contacta con soporte si surgen dudas de facturación.",
        "deleteOrgStripeWarning_other": "Organización eliminada. {{count}} suscripciones no se pudieron cancelar automáticamente — contacta con soporte si surgen dudas de facturación."
      },
      "team": {
        "description": "Gestionar miembros del equipo e invitaciones",
        "enterpriseDescription": "Gestión completa del equipo con acceso basado en roles",
        "features": {
          "activityTracking": "Seguimiento de actividades",
          "activityTrackingDesc": "Ver cuándo los miembros del equipo accedieron por última vez a la plataforma",
          "roleBasedAccess": "Acceso basado en roles",
          "roleBasedAccessDesc": "Asignar roles para controlar lo que cada miembro puede ver y hacer",
          "stakeholderIdentification": "Gestión de interesados",
          "stakeholderIdentificationDesc": "Identificar propietarios de presupuesto y campeones de programa",
          "title": "Funciones",
          "unlimitedMembers": "Miembros ilimitados",
          "unlimitedMembersDesc": "Invita a todo tu equipo — sin límites de asientos"
        },
        "invitationResent": "Invitación reenviada",
        "invitationRevoked": "Invitación revocada",
        "invitations": {
          "description": "Gestionar invitaciones pendientes a tu espacio de trabajo.",
          "expired": "Caducado",
          "pending": "Pendiente",
          "resend": "Reenviar",
          "revoke": "Revocar",
          "sentOn": "Enviado",
          "title": "Invitaciones pendientes"
        },
        "inviteDesc": "Envía una invitación por correo electrónico para unirte a tu organización.",
        "inviteEmailLabel": "Dirección de correo electrónico",
        "inviteFailed": "No se pudo enviar la invitación",
        "inviteRoleLabel": "Rol",
        "inviteSent": "Invitación enviada",
        "inviteTitle": "Invitar a un miembro del equipo",
        "memberRemoved": "Miembro del equipo eliminado",
        "members": {
          "description": "Miembros activos del equipo con acceso a tu organización",
          "inviteMember": "Invitar miembro",
          "title": "Miembros"
        },
        "removeConfirm": "¿Eliminar a {{name}} del equipo?",
        "removeFailed": "Error al eliminar al miembro del equipo",
        "resendFailed": "Error al reenviar la invitación",
        "revokeFailed": "Error al revocar la invitación",
        "roleAdmin": "Admin",
        "roleTeamMember": "Miembro del equipo",
        "roles": {
          "adminDesc": "Acceso completo — gestionar equipo, facturación, programas y configuraciones",
          "description": "Roles disponibles y sus permisos",
          "teamMemberDesc": "Acceso a programas, talentos y paneles de movilidad",
          "title": "Roles"
        },
        "sendInvite": "Enviar invitación",
        "sending": "Enviando…",
        "stats": {
          "pendingInvitations": "Invitaciones pendientes",
          "teamMembers": "Total de miembros"
        },
        "title": "Equipo"
      },
      "title": "Configuraciones",
      "inviteEmailPlaceholder": "colega@empresa.com",
      "serviceCredentials": {
        "title": "Credenciales de servicio",
        "description": "Tokens de solo lectura que permiten a un script o herramienta de informes obtener datos del cohort sin que nadie inicie sesión.",
        "howToTitle": "Cómo usar una credencial",
        "howToBody": "Envía el token en la cabecera Authorization: Authorization: Bearer <token>. Solo puede leer snapshots de cohort y programa, no puede cambiar nada y deja de funcionar en el momento en que la revocas o caduca.",
        "empty": "Aún no hay credenciales",
        "emptyHint": "Crea una cuando un script o herramienta de informes necesite leer datos del cohort por su cuenta.",
        "create": "Nueva credencial",
        "createTitle": "Nueva credencial de servicio",
        "createDescription": "Verás el token una sola vez. Guárdalo antes de cerrar.",
        "nameLabel": "Nombre",
        "namePlaceholder": "Informe trimestral del cohort",
        "nameHint": "Para distinguir esta credencial de las demás más adelante.",
        "scopeLabel": "Acceso",
        "scopeCohortRead": "Leer datos del cohort",
        "scopeHint": "Solo lectura. Una credencial nunca cambia datos ni gestiona credenciales.",
        "cohortModeLabel": "Cohorts",
        "cohortAll": "Todos los cohorts",
        "cohortPick": "Solo los cohorts que elija",
        "cohortsLabel": "Qué cohorts",
        "cohortsHint": "Elige al menos uno.",
        "expiryLabel": "Caduca en",
        "expiryHint": "Las credenciales siempre caducan. Noventa días es el máximo.",
        "revealTitle": "Copia tu token ahora",
        "revealWarning": "Este token se muestra una sola vez. Guárdalo ahora: no podrá volver a mostrarse.",
        "copy": "Copiar",
        "copied": "Copiado",
        "storedConfirm": "He guardado este token en un lugar seguro",
        "done": "Hecho",
        "statusActive": "Activa",
        "statusExpired": "Caducada",
        "statusRevoked": "Revocada",
        "allCohorts": "Todos los cohorts",
        "neverUsed": "Nunca usada",
        "revoke": "Revocar",
        "revokeTitle": "¿Revocar esta credencial?",
        "revokeDescription": "Todo lo que la use deja de funcionar de inmediato. Esto no se puede deshacer.",
        "revokeReasonLabel": "Motivo (opcional)",
        "revokeConfirm": "Revocar credencial",
        "issued": "Credencial creada",
        "revoked": "Credencial revocada",
        "issueFailed": "No se pudo crear la credencial",
        "revokeFailed": "No se pudo revocar la credencial",
        "loadFailed": "No se pudieron cargar las credenciales",
        "expiryDays_one": "{{count}} día",
        "expiryDays_other": "{{count}} días",
        "cohortCount_one": "{{count}} cohort",
        "cohortCount_other": "{{count}} cohorts",
        "expiringSoon_one": "Caduca en {{count}} día",
        "expiringSoon_other": "Caduca en {{count}} días"
      }
    },
    "care": {
      "config": {
        "addCustomObjective": "Agregar objetivo personalizado",
        "addToCatalog": "Agregar al catálogo",
        "baselineDescription": "Configura la configuración predeterminada de Care para tu organización. Estas configuraciones serán heredadas automáticamente por todos los Programas y Cohortes. Los Programas o Cohortes individuales pueden personalizar si es necesario.",
        "cadences": {
          "monthly": "Mensual",
          "quarterlyRecommended": "Trimestral (recomendado)",
          "semiannual": "Semestral"
        },
        "careModelSummary": "Resumen del modelo Care",
        "carePillars": "Pilares de Care",
        "carePillarsDescription": "Selecciona qué dimensiones de estabilidad los talentos se auto-informarán durante los chequeos. Los Programas y Cohortes pueden habilitar/deshabilitar estos.",
        "pillarCatalog": {
          "housing_stability": {
            "name": "Estabilidad de vivienda",
            "description": "Monitorear transiciones y estabilidad de vivienda después de la llegada"
          },
          "schooling_childcare": {
            "name": "Educación y cuidado infantil",
            "description": "Rastrear la educación y los arreglos de cuidado infantil de los niños"
          },
          "work_fit": {
            "name": "Ajuste laboral",
            "description": "Rastrear la adaptación al lugar de trabajo, la integración en el equipo y la productividad"
          },
          "wellbeing_social": {
            "name": "Bienestar y social",
            "description": "Monitorea el bienestar, las conexiones sociales y la participación comunitaria"
          }
        },
        "carePillarsScheduleDesc": "Pilares de Care + horario de puntos de control: Los talentos completan auto-registros en dimensiones de bienestar seleccionadas en intervalos de hitos. Los programas/Cohortes pueden habilitar/deshabilitar pilares y ajustar el tiempo de los puntos de control.",
        "catalogWorkDescription": "Habilita objetivos aquí para que estén disponibles para Programas y Cohortes. Cada Programa/Cohorte puede elegir qué objetivos rastrear para sus talentos.",
        "changesApplyNote": "Los cambios se aplicarán a todos los Programas y Cohortes que no hayan personalizado sus configuraciones",
        "checkpointSchedule": "Horario de checkpoint",
        "checkpointScheduleDescription": "Tiempo predeterminado para los registros de Pilares de Care (hitos post-llegada). Los Programas y Cohortes pueden ajustar la recurrencia.",
        "common": "Común",
        "companyCareBaseline": "Línea base de Care de la empresa",
        "customObjectiveAdded": "Objetivo personalizado añadido al catálogo",
        "detailedFeedbackDescription": "Selecciona roles que pueden ver el texto de retroalimentación detallada (otros solo ven resúmenes)",
        "detailedFeedbackVisibility": "Visibilidad de retroalimentación detallada",
        "feedbackCadenceDescription": "Con qué frecuencia los agentes de la empresa y los talentos intercambian retroalimentación sobre los objetivos",
        "feedbackCadenceLabel": "Frecuencia de retroalimentación",
        "feedbackConfigDescription": "Con qué frecuencia los agentes de la empresa proporcionan retroalimentación sobre los Objetivos de Talento y cuándo los talentos se autoevalúan",
        "feedbackConfiguration": "Configuración de retroalimentación",
        "feedbackFlowDescription": "En cada intervalo de cadencia, los proveedores seleccionados envían retroalimentación sobre los objetivos de talento. El talento recibe una notificación y puede ver la retroalimentación + enviar su propia autoevaluación.",
        "feedbackFlowTitle": "Flujo de retroalimentación:",
        "feedbackProviders": "Proveedores de retroalimentación",
        "forObjectives": "Para objetivos",
        "forPillars": "Para pilares",
        "howCatalogWorks": "Cómo funciona el catálogo:",
        "milestones": {
          "monthNine": "Mes 9",
          "monthOne": "Mes 1",
          "monthSix": "Mes 6",
          "monthThree": "Mes 3",
          "monthTwelve": "Mes 12"
        },
        "objectivePlaceholder": "p. ej., Completar la formación de concienciación sobre seguridad",
        "objectivesCatalogDescription": "Biblioteca de la empresa de objetivos de adaptación. Habilita los que se utilizan comúnmente — Los Programas y Cohortes pueden seleccionar cuáles aplicar.",
        "primaryConfig": "Configuración principal",
        "providers": {
          "admin": {
            "description": "Posee el programa de cuidado — revisa señales sensibles y da retroalimentación estratégica sobre los objetivos."
          },
          "teamMember": {
            "description": "Contacto diario — proporciona retroalimentación sobre adaptación, ajuste laboral y progreso respecto a los objetivos."
          }
        },
        "recommended": "Recomendado",
        "riskSignalsDescription": "Selecciona roles que pueden ver indicadores de riesgo sensibles y alertas de estabilidad",
        "riskSignalsVisibility": "Visibilidad de señales de riesgo",
        "saveConfiguration": "Guardar configuración",
        "schedules": {
          "intensive": "Intensivo",
          "intensiveCadence": "Cadencia: cada trimestre + chequeo de asentamiento del mes-1 (5 puntos de control)",
          "intensiveDescription": "Programas de alta atención que necesitan un monitoreo cercano en las primeras etapas y señales trimestrales adicionales.",
          "light": "Toque ligero",
          "lightCadence": "Cadencia: semestral (2 puntos de control)",
          "lightDescription": "Cuidado mínimo viable — solo la señal del primer trimestre y el punto de decisión anual.",
          "standard": "Estándar",
          "standardCadence": "Cadencia: primer mes, luego trimestral hasta el mes 12 (4 puntos de control)",
          "standardDescription": "Puntos de control equilibrados que cubren asentamiento, adaptación y retención anual."
        },
        "talentCheckIns": "Autoevaluaciones de talento",
        "talentObjectivesCatalog": "Catálogo de objetivos de talento",
        "talentObjectivesFeedbackDesc": "Objetivos de talento + retroalimentación: Habilita objetivos en tu catálogo. Los programas/Cohortes seleccionan qué objetivos rastrear. Los agentes de la empresa proporcionan retroalimentación y los talentos se autoevalúan.",
        "visibilityDescription": "Controla quién puede ver datos sensibles de Care según su rol",
        "visibilityPrivacy": "Visibilidad y privacidad",
        "pillarRequired": "Requerido",
        "pillarMakeRequired": "Hacer requerido",
        "objectives": {
          "language_level": "Alcanza un nivel de competencia laboral en el idioma local",
          "office_visits": "Asiste a la oficina regularmente cada periodo",
          "onboarding": "Completa el programa de integración de la empresa",
          "team_integration": "Establece relaciones laborales productivas con el equipo",
          "role_competency": "Demuestra competencia en el rol mediante la revisión de hitos",
          "culture_fit": "Comprende y abraza la cultura y los valores de la empresa",
          "communication": "Comunicación efectiva con las partes interesadas",
          "tools_systems": "Competencia con las herramientas y sistemas de la empresa",
          "network_building": "Construye una red profesional interna",
          "feedback_giving": "Participa activamente en los ciclos de retroalimentación",
          "goal_setting": "Establece y sigue tus objetivos de desarrollo personal",
          "mentorship": "Involúcrate con tu mentor/amigo asignado"
        },
        "objectiveCategory": {
          "Adaptation": "Adaptación",
          "Onboarding": "Integración",
          "Performance": "Rendimiento",
          "Culture": "Cultura",
          "Skills": "Habilidades",
          "Technical": "Técnico",
          "Growth": "Crecimiento",
          "Custom": "Personalizado"
        },
        "enabled_one": "{{count}} habilitado",
        "enabled_other": "{{count}} habilitados",
        "pillarsEnabledCount_one": "{{count}} pilar habilitado. Los programas y las cohortes lo heredan y pueden elegir qué pilares están activos en su contexto.",
        "pillarsEnabledCount_other": "{{count}} pilares habilitados. Los programas y las cohortes los heredan y pueden elegir qué pilares están activos en su contexto."
      },
      "customizeModal": {
        "cancel": "Cancelar",
        "carePillars": "Pilares de Care",
        "carePillarsDesc": "Dimensiones para autoevaluaciones de talento",
        "checkpointSchedule": "Horario de checkpoint",
        "checkpointScheduleDesc": "Cuando los talentos completen los registros de Care",
        "cohorts": "Cohortes",
        "configSaved": "Configuración de Care personalizada para {{name}}",
        "customized": "Personalizado",
        "feedbackConfig": "Configuración de retroalimentación",
        "feedbackConfigDesc": "Con qué frecuencia se proporciona retroalimentación sobre los objetivos",
        "feedbackFrequencyInfo": "HRBP y gerentes proporcionan retroalimentación sobre los objetivos de talento con esta frecuencia",
        "feedbackMonthly": "Mensual",
        "feedbackMonthlyDesc": "Una vez al mes",
        "feedbackQuarterly": "Trimestral",
        "feedbackQuarterlyDesc": "Cada 3 meses",
        "inherited": "Heredado",
        "inheritedInfo": "Las configuraciones se heredan de {{from}}. Activa las secciones a continuación para personalizar para este {{level}}.",
        "objectivesAllApply": "No se seleccionaron objetivos — se aplican todos los objetivos de la empresa. Elige un subconjunto para restringirlos a este alcance.",
        "objectivesNoneEnabled": "No hay objetivos habilitados en la configuración de Care de la empresa aún. Habilita algunos en la Configuración de la Empresa para definirlos aquí.",
        "oneMonth": "1 mes",
        "overrideDesc": "Sobrescribir configuraciones de Care para {{name}}. {{inheritors}} heredarán esto a menos que tengan sus propias personalizaciones.",
        "pillarHousing": "Vivienda",
        "pillarHousingDesc": "Estabilidad de la situación de vida",
        "pillarWellbeing": "Bienestar",
        "pillarWellbeingDesc": "Salud y bienestar mental",
        "pillarWork": "Trabajo",
        "pillarWorkDesc": "Adaptación laboral y de carrera",
        "resetAllToInherited": "Restablecer todo a heredado",
        "saveChanges": "Guardar cambios",
        "scheduleIntensive": "Intensivo",
        "scheduleIntensiveDesc": "Chequeos frecuentes para nuevos llegados",
        "scheduleLight": "Toque ligero",
        "scheduleLightDesc": "Chequeos mínimos para talentos asentados",
        "scheduleStandard": "Estándar",
        "scheduleStandardDesc": "Programa de chequeos equilibrado",
        "sixMonths": "6 meses",
        "talentObjectives": "Objetivos de los talentos",
        "talentObjectivesDesc": "Selecciona qué objetivos de la empresa se aplican a este ámbito",
        "talents": "Talentos",
        "threeMonths": "3 meses",
        "title": "Personalizar modal",
        "twelveMonths": "12 meses",
        "pillarSchooling": "Educación y cuidado infantil",
        "pillarSchoolingDesc": "Rastrear la educación y los arreglos de cuidado infantil de los niños",
        "nineMonths": "9 meses",
        "feedbackSemiannual": "Semestral",
        "feedbackSemiannualDesc": "Comentarios recopilados dos veces al año",
        "objectivesSelected_one": "{{count}} objetivo seleccionado. Los agentes de la empresa dan feedback sobre él",
        "objectivesSelected_other": "{{count}} objetivos seleccionados. Los agentes de la empresa proporcionan retroalimentación sobre estos",
        "pillarsActive_one": "{{count}} pilar activo. Los talentos lo califican durante los check-ins",
        "pillarsActive_other": "{{count}} pilares activos. Los talentos calificarán cada pilar durante los chequeos"
      },
      "effectiveCard": {
        "cadence": "Cadencia",
        "careConfiguration": "Configuración de Care",
        "carePillars": "Pilares de Care",
        "customized": "Personalizado",
        "customizedFor": "Personalizado para {{level}}",
        "inherited": "Heredado",
        "inheritedFrom": "Heredado de {{source}}",
        "providers": "Proveedores",
        "talentObjectives": "Objetivos de los talentos",
        "programSource": "Programa: {{name}}"
      },
      "feedback": {
        "commentWithheld": "Comentario oculto por la configuración de visibilidad de tu empresa",
        "modal": {
          "description": "Califica cada objetivo en relación a su meta, luego revisa el historial completo.",
          "provideTab": "Proporcionar",
          "historyTab": "Historia",
          "submit": "Enviar retroalimentación",
          "giveFeedback": "Dar feedback",
          "cycleDue": "Vencido {{date}}",
          "awaitingSelfEval": "Esperando autoevaluación",
          "noOpenCycle": "No hay ciclo abierto",
          "historyEmpty": "No se ha registrado ningún comentario aún.",
          "archivedObjective": "Objetivo archivado",
          "providerValue": "Empresa",
          "selfValue": "Auto"
        }
      },
      "objective": {
        "measureType": {
          "number": "Contar",
          "scale": "Nivel",
          "percent": "Porcentaje",
          "milestone": "Hito",
          "rating": "Calificación"
        },
        "currentLabel": "Actual",
        "targetLabel": "Objetivo",
        "baselineLabel": "Base",
        "recordValueLabel": "Este período",
        "valuePlaceholder": "Seleccionar…",
        "milestoneDone": "Hecho",
        "milestoneNotYet": "Aún no",
        "editTarget": "Editar objetivo",
        "dashboard": {
          "byObjective": "Por objetivo",
          "onTargetShare": "En objetivo",
          "avgProgress": "Promedio de progreso",
          "empty": "No se están rastreando objetivos aún. Configúralos en la estrategia de Care y aparecerán a medida que se incorporen talentos.",
          "talentsCount_one": "{{count}} talento",
          "talentsCount_other": "{{count}} talentos"
        },
        "targetSaved": "Objetivo actualizado",
        "targetSaveFailed": "No se pudo guardar el objetivo. Por favor, inténtalo de nuevo.",
        "nothingToSubmit": "Registra un valor o comentario para al menos un objetivo primero.",
        "feedbackSubmitted": "Comentarios registrados",
        "feedbackSubmitFailed": "No se pudo registrar el comentario. Por favor, inténtalo de nuevo.",
        "errors": {
          "unitTooLong": "La unidad debe tener 24 caracteres o menos",
          "targetRequired": "Establecer una base o un objetivo",
          "ratingRange": "La calificación debe ser de 1 a 5",
          "commentTooLong": "El comentario debe tener 2000 caracteres o menos",
          "entryEmpty": "Agregar un valor, calificación o comentario"
        },
        "noOpenCycle": "Todavía no hay un ciclo de feedback abierto para este talento, así que no hay nada que enviar."
      },
      "intervention": {
        "actAria": "Intervenir en {{name}}",
        "actLabel": "Intervenir",
        "assigneeLabel": "Propietario",
        "assigneeUnassigned": "No Asignado",
        "inbox": {
          "title": "Seguimientos",
          "empty": "Estás al día — no hay seguimientos abiertos.",
          "overdue": "Atrasado",
          "open": "Abrir",
          "done": "Hecho",
          "mine": "Mío",
          "all": "Todo",
          "due": "Vencido {{date}}",
          "search": "Buscar por talento…",
          "groupByTalent": "Por talento",
          "flat": "Lista",
          "noMatch": "No hay interacciones que coincidan con ese talento.",
          "expandAll": "Expandir todo",
          "collapseAll": "Colapsar todo",
          "overdueCount_one": "{{count}} vencido",
          "overdueCount_other": "{{count}} vencidos"
        },
        "manageLabel": "Programación y propietario",
        "markDoneLabel": "Registrar resultado + minutos",
        "markDoneHint": "Copia y pega las actas de la reunión o notas de grabación aquí (si las tienes) — solo interno, guardado para evaluación futura.",
        "markDone": "Marcar como hecho",
        "ataPlaceholder": "Pega las actas / lo que se discutió aquí (solo interno)…",
        "commentsLabel": "Comentarios",
        "commentsEmpty": "No hay comentarios aún.",
        "commentPlaceholder": "Agregar un comentario…",
        "commentSend": "Enviar",
        "rescheduledToast": "Interacción reprogramada",
        "reassignedToast": "Interacción reasignada",
        "actionFailed": "Acción fallida. Por favor, inténtalo de nuevo.",
        "bulkAllFailed": "No se pudieron crear acciones. Por favor, inténtalo de nuevo.",
        "bulkPartial": "{{m}} no se pudo crear",
        "bulkSummary": "{{n}} programado, {{m}} fallido",
        "cancel": "Cancelar",
        "cancelFailed": "No se pudo cancelar.",
        "cancelledToast": "Intervención cancelada",
        "descriptionLabel": "Descripción",
        "descriptionPlaceholder": "Agrega cualquier contexto para esta acción…",
        "dialogDescription": "Registra una acción o contacta — elige un tipo y nosotros nos encargaremos del resto. Las acciones dirigidas al talento siempre son sin puntuación.",
        "dialogTitle": "Intervenir",
        "effect": {
          "logOnly": "Registro interno únicamente — nunca llega al talento.",
          "talentTouch": "Elegible para un contacto cálido, opcional y sin puntuación con el talento."
        },
        "errors": {
          "descriptionTooLong": "La descripción debe tener 2000 caracteres o menos",
          "editClosed": "Esta interacción está cerrada y ya no se puede editar.",
          "invalidDate": "Introduce una fecha válida",
          "resolutionTooLong": "La resolución debe tener 2000 caracteres o menos",
          "titleRequired": "Se requiere un título",
          "titleTooLong": "El título debe tener 200 caracteres o menos"
        },
        "errorToast": "No se pudo crear la acción. Por favor, inténtalo de nuevo.",
        "edit": "Editar",
        "save": "Guardar cambios",
        "saveSuccess": "Interacción actualizada",
        "saveFailed": "No se pudieron guardar los cambios. Por favor, inténtalo de nuevo.",
        "wizard": {
          "stepType": "Tipo",
          "stepDetails": "Detalles",
          "stepReview": "Revisión",
          "next": "Siguiente",
          "back": "Atrás",
          "progressLabel": "Progreso de configuración de interacción",
          "reviewBulk_one": "Esto se creará para {{count}} talento.",
          "reviewBulk_other": "Esto se creará para {{count}} talentos."
        },
        "notesLabel": "Notas",
        "notesPlaceholder": "Notas internas (opcional)…",
        "outcome": {
          "completed": "Completado",
          "noShow": "No presentado",
          "rescheduled": "Reprogramado",
          "declined": "Rechazado"
        },
        "outcomeLabel": "Resultado",
        "priority": {
          "high": "Alto",
          "low": "Bajo",
          "medium": "Medio",
          "urgent": "Urgente"
        },
        "priorityLabel": "Prioridad",
        "resolutionLabel": "Nota de resolución",
        "resolutionPlaceholder": "¿Qué ocurrió? (opcional)",
        "resolve": "Resolver",
        "resolveFailed": "No se pudo resolver.",
        "resolvedToast": "Intervención resuelta",
        "submit": "Crear",
        "submitting": "Guardando…",
        "successToast": "Acción creada",
        "titleLabel": "Título",
        "titlePlaceholder": "por ejemplo, chequeo de bienestar 1:1",
        "scheduledAtLabel": "Fecha y hora",
        "locationOrLinkLabel": "Enlace / ubicación de la reunión",
        "locationOrLinkPlaceholder": "por ejemplo, https://meet… o una dirección",
        "requestCheckinHint": "Añade un chequeo único a la línea de tiempo del talento que alimenta su índice de bienestar.",
        "type": {
          "call": "Llamada",
          "video_call": "Videollamada",
          "in_person_meeting": "Reunión en persona",
          "message": "Mensaje",
          "internal_note": "Nota interna",
          "request_checkin": "Solicitar un chequeo",
          "buddy_connect": "Conectar con un compañero",
          "checkpoint_trigger": "Activar un punto de control",
          "coaching_note": "Nota de coaching",
          "manager_alert": "Alertar a un gerente",
          "mission_recommend": "Recomendar una misión",
          "personal_check_in": "Chequeo personal",
          "reminder": "Establecer un recordatorio",
          "support_resource": "Compartir un recurso de apoyo"
        },
        "typeLabel": "Tipo de interacción",
        "bulkAppliesTo_one": "Este plan se aplica a {{count}} talento:",
        "bulkAppliesTo_other": "Este plan se aplica a {{count}} talentos:",
        "dialogTitleBulk_one": "Intervenir en {{count}} talento",
        "dialogTitleBulk_other": "Intervenir en {{count}} talentos",
        "submitBulk_one": "Crear {{count}} acción",
        "submitBulk_other": "Crear {{count}} acciones",
        "bulkAppliesToMatching_one": "Este plan llega al {{count}} talento que coincide con tus filtros y necesita una intervención.",
        "bulkAppliesToMatching_other": "Este plan llega a los {{count}} talentos que coinciden con tus filtros y necesitan una intervención."
      },
      "effectiveCare": {
        "scheduleLabel": "Horario {{schedule}}",
        "providersList": "Proveedores: {{providers}}",
        "customize": "Personalizar",
        "detailsTitle": "Detalles de configuración Care",
        "fullConfigFor": "Configuración completa para {{name}}",
        "inheritedFromSuffix": "(heredado de {{source}})",
        "activeCarePillars": "Pilares activos Care",
        "checkpointSchedule": "Horario de checkpoint",
        "scheduleTitle": "Horario {{schedule}}",
        "talentObjectivesCount": "Objetivos de talento ({{count}})",
        "feedbackConfiguration": "Configuración de retroalimentación",
        "inheritanceInfoCustomized": "Este {{level}} tiene configuraciones personalizadas de Care. Haz clic en \"Restablecer\" para volver a las configuraciones de {{source}}.",
        "inheritanceInfoInherited": "Este {{level}} hereda todas las configuraciones de Care de {{source}}. Haz clic en \"Personalizar\" para anular configuraciones específicas solo para este {{level}}.",
        "activeCount_one": "{{count}} activo",
        "activeCount_other": "{{count}} activos",
        "moreObjectives_one": "+{{count}} objetivo más",
        "moreObjectives_other": "+{{count}} más objetivos"
      }
    },
    "carePage": {
      "act": "Intervenir",
      "actAria": "Intervenir por {{name}}",
      "activeTab": "Activo",
      "activeTracking": "Seguimiento activo",
      "archivedTab": "Archivado",
      "commitmentDistribution": "Distribución del compromiso",
      "startedSummary": "{{started}} de {{total}} iniciados",
      "awaitingCheckin": "Esperando el primer chequeo",
      "pillarsCardSubtitle": "Bienestar por pilar en toda la cohorte",
      "pillarsEmptyHint": "La salud del pilar aparece una vez que los talentos completan su primer registro de Care.",
      "bandChampion": "Campeón",
      "bandCommitted": "Comprometido",
      "bandEngaged": "Involucrado",
      "bandAtRisk": "En riesgo",
      "bandFlightRisk": "Riesgo de vuelo",
      "bandTracked": "Rastreado",
      "clearSelection": "Borrar selección",
      "errors": {
        "notesTooLong": "Las notas deben tener 2000 caracteres o menos"
      },
      "feedbackPending": "Retroalimentación pendiente",
      "interveneAria": "Intervenir por {{name}}",
      "talentRowActionsAria": "Acciones para {{name}}",
      "viewAllRisks": "Ver todos los riesgos",
      "viewDetails": "Ver detalles",
      "viewDetailsAria": "Ver detalles de cuidado para {{name}}",
      "aiCommitmentInsights": "Perspectivas de compromiso AI",
      "allCohorts": "Todos los cohortes",
      "allLevels": "Todos los niveles",
      "allPillars": "Todos los pilares",
      "atRiskFilter": "en riesgo",
      "carePillar": "Pilar de Care",
      "carePillarsHealth": "Salud de los pilares de Care",
      "champions": "Campeones",
      "championsDesc": "Tus talentos más comprometidos, del mayor Commitment Index al menor",
      "championsFilter": "Campeones",
      "commitment": "Compromiso",
      "commitmentChampions": "Campeones del compromiso",
      "commitmentLabel": "Compromiso",
      "commitmentPercent": "{{value}}%",
      "commitmentRiskAlert": "Alerta de riesgo de compromiso",
      "coldStartDesc": "Tan pronto como un talento invitado complete su evaluación de Care o su primer registro, su Índice de Compromiso y la salud del pilar aparecerán aquí.",
      "coldStartTitle": "No hay actividad de Care aún",
      "committedFilter": "Comprometido",
      "description": "Bienestar, compromiso e intervenciones de tus talentos patrocinados",
      "engagedFilter": "Involucrado",
      "filterByCohort": "Filtrar por cohorte",
      "filterByPillar": "Pilar",
      "flightRiskCount_one": "{{count}} talento en riesgo de vuelo",
      "flightRiskCount_other": "{{count}} talentos en riesgo de vuelo",
      "flightRiskFilter": "Riesgo de vuelo",
      "healthy": "Saludable",
      "inCare": "En Care",
      "insights": "Perspectivas",
      "intervene": "Intervenir",
      "interventionQueue": "Cola de intervención",
      "interventionQueueDesc": "Talentos que necesitan una intervención o deben feedback, los más urgentes primero",
      "needCare": "Necesitar Care",
      "decliningCommitment": "En declive",
      "commitmentIndexLabel": "Índice de compromiso",
      "awaitingSelfEvalCount_one": "+{{count}} esperando auto-evaluación",
      "awaitingSelfEvalCount_other": "+{{count}} esperando auto-evaluación",
      "overdueCheckpoints": "Puntos de control vencidos",
      "needIntervention": "Necesita intervención",
      "noTalentsFound": "No se encontraron talentos",
      "overallTalentLoyalty": "Lealtad general del talento",
      "overdue": "Atrasado",
      "pendingFeedback": "Retroalimentación pendiente",
      "pillars": "Pilares",
      "searchTalents": "Buscar talentos",
      "selectAllVisible": "Seleccionar todos en esta página",
      "selectTalentAria": "Seleccionar {{name}} para intervención masiva",
      "smartRecommendations": "Recomendaciones inteligentes",
      "talentsLabel": "Talentos",
      "title": "Care",
      "tracked": "Rastreado",
      "tryAdjustingFilters": "Intenta ajustar filtros",
      "frequency": {
        "weekly": "Semanal",
        "biweekly": "Quincenal",
        "monthly": "Mensual",
        "quarterly": "Trimestral",
        "semiannual": "Semestral"
      },
      "commitmentIndexHeading": "Índice de compromiso",
      "gettingStartedBadge": "Comenzando",
      "allClearTitle": "Todo claro",
      "allClearDescription": "No hay talentos que necesiten intervención inmediata",
      "clearFilters": "Borrar filtros",
      "routineStatus": {
        "overdue": "Atrasado",
        "in_progress": "En progreso",
        "scheduled": "Programado",
        "completed": "Completado",
        "open": "Abrir",
        "resolved": "Resuelto",
        "cancelled": "Cancelado"
      },
      "commitmentHealth": "Salud del compromiso",
      "viewPillarTalentsAria": "Ver talentos bajo {{pillar}}",
      "weakOnPillar": "Débil en {{pillar}}",
      "pillarName": {
        "housing_stability": "Vivienda",
        "schooling_childcare": "Educación",
        "work_fit": "Trabajo",
        "wellbeing_social": "Bienestar"
      },
      "pillarStatus": {
        "healthy": "Saludable",
        "moderate": "Moderado",
        "concern": "Preocupación"
      },
      "insightsRecommendations": {
        "socialPillar": "El pilar social está en {{value}}% — considera actividades de cohesión de equipo",
        "schedule1on1s": "Programar 1:1s",
        "planActivities": "Planificar actividades",
        "createProgram": "Crear programa",
        "flightRisk_one": "{{count}} talento tiene riesgo de salida — programa un 1:1 inmediato con el HRBP",
        "flightRisk_other": "{{count}} talentos tienen riesgo de salida — programa 1:1s inmediatos con el HRBP",
        "championsProgram_one": "{{count}} campeón identificado — considera un programa de embajadores",
        "championsProgram_other": "{{count}} campeones identificados — considera un programa de embajadores"
      },
      "trendMetrics": {
        "avgCommitmentIndex": "Promedio del índice de compromiso",
        "champions": "Campeones",
        "flightRisk": "Riesgo de salida"
      },
      "scored": "Puntuado",
      "objectivesTitle": "Objetivos y comentarios",
      "objectivesEmpty": "No se han asignado objetivos a este talento aún. Configúralos en la estrategia de Care.",
      "objectivesLoadError": "No se pudieron cargar los objetivos.",
      "objectivesRetry": "Reintentar",
      "objectiveFeedbackCycleStatus": {
        "provider_submitted": "Proveedor enviado",
        "completed": "Completado",
        "overdue": "Atrasado"
      },
      "objectiveFeedbackNoCycle": "No hay ciclos de retroalimentación abiertos en este momento. Los objetivos están listados a continuación; un formulario aparecerá cuando se abra el próximo ciclo.",
      "objectiveFeedbackProviderLabel": "Proveedor",
      "objectiveFeedbackSelfLabel": "Autoevaluación",
      "objectiveFeedbackCommentLabel": "Comentario (opcional)",
      "objectiveFeedbackCommentPlaceholder": "Comparte retroalimentación específica y accionable…",
      "objectiveFeedbackSubmitting": "Enviando…",
      "objectiveFeedbackDueTitle": "Comentarios pendientes",
      "objectiveFeedbackDueEmpty": "No hay ciclos de retroalimentación abiertos en este momento. Estás al día.",
      "objectiveFeedbackDueLoadError": "No se pudo cargar la lista de retroalimentación vencida.",
      "objectiveFeedbackDueRow": "Vencido {{date}}",
      "objectiveFeedbackDueCurrent": "Viendo",
      "feedbackStrategyScope": "Configuración de retroalimentación resuelta · {{scope}}",
      "feedbackStrategyLoading": "Cargando…",
      "feedbackStrategyError": "No se pudo cargar la estrategia de retroalimentación.",
      "feedbackCadenceLabel": "Cadencia",
      "feedbackProvidersLabel": "Proveedores",
      "feedbackProvidersNone": "No hay proveedores configurados",
      "feedbackProvider": {
        "admin": "Admin",
        "team_member": "Miembro del equipo"
      },
      "scopeCompanyWide": "A nivel de empresa",
      "scopeCohort": "Cohorte seleccionada",
      "tabs": {
        "feedback": "Retroalimentación",
        "interactions": "Interacciones"
      },
      "objectivesProgress": {
        "title": "Progreso de objetivos",
        "desc": "Participación en objetivo y progreso medio por objetivo, en todos los talentos."
      },
      "objectiveFeedback": {
        "title": "Comentarios sobre el objetivo",
        "desc": "Comentarios estructurados, basados en objetivos, a la cadencia configurada. Califica a cada talento en función de sus objetivos; ellos completan una autoevaluación a cambio.",
        "dueKpi": "Comentarios pendientes",
        "awaitingSelfEvalKpi": "Esperando autoevaluación",
        "caughtUp": "Todo al día — no hay comentarios pendientes en este momento.",
        "rowStatusOpen": "Necesita tu calificación",
        "rowStatusProviderSubmitted": "Esperando la autoevaluación del talento",
        "notProvider": "No eres un proveedor de comentarios configurado para este ámbito. Pide a un Administrador que añada tu rol en la configuración de Care.",
        "loadError": "No se pudo cargar la bandeja de entrada de comentarios."
      },
      "objectiveFeedbackNotGoverning": "Otra empresa gestiona el Care de este talento, así que solo ella da feedback y fija objetivos. Puedes leer las autoevaluaciones del propio talento.",
      "commitmentAtAGlance": "Compromiso de un vistazo",
      "commitmentAtAGlanceDesc": "Dónde están hoy tus talentos evaluados",
      "ofScored": "{{value}} de {{total}} evaluados",
      "bulkInterveneCta_one": "Programar una intervención para {{count}} talento",
      "bulkInterveneCta_other": "Programar una intervención para {{count}} talentos",
      "pendingCount_one": "{{count}} pendiente",
      "pendingCount_other": "{{count}} pendientes",
      "selectedCount_one": "{{count}} seleccionado",
      "selectedCount_other": "{{count}} seleccionados",
      "gettingStartedNote_one": "+ {{count}} empezando (aún sin historial de check-in suficiente para puntuar)",
      "gettingStartedNote_other": "+ {{count}} empezando (aún sin historial de check-in suficiente para puntuar)",
      "interveneAllMatching_one": "Intervenir en el {{count}} que coincide",
      "interveneAllMatching_other": "Intervenir en los {{count}} que coinciden",
      "interveneAllFlightRisk_one": "Intervenir en el {{count}} con riesgo de salida",
      "interveneAllFlightRisk_other": "Intervenir en los {{count}} con riesgo de salida"
    },
    "heroOverview": {
      "title": "Resumen del viaje",
      "subtitle": "Rastrear progreso",
      "acquisition": {
        "title": "Adquisición",
        "description": "Talentos invitados que aún no han aceptado.",
        "open": "Abrir adquisición en Pipeline",
        "pendingInvites": "invitación pendiente",
        "statusLabel": "Estado",
        "awaitingAcceptance": "Esperando aceptación",
        "ttl": "TTL de invitación de 14 días",
        "viewInPipeline": "Ver en pipeline",
        "empty": "Todos los invitados han aceptado. Nuevas invitaciones llegarán aquí."
      },
      "vetting": {
        "title": "Evaluación",
        "description": "Embudo previo al patrocinio — invitados, en evaluación, completados.",
        "open": "Abrir evaluación",
        "inVetting": "En evaluación",
        "passRate": "Tasa de aprobación",
        "funnel": "Embudo",
        "inProgress": "en evaluación",
        "completed": "completados",
        "done": "hecho"
      },
      "sponsored": {
        "title": "Patrocinado",
        "empty": "No se han patrocinado talentos aún. Una vez que un talento sea patrocinado, su movilidad, adaptación y compromiso con Care aparecerán aquí.",
        "headcount_one": "{{count}} talento",
        "headcount_other": "{{count}} talentos"
      },
      "mobility": {
        "title": "Movilidad",
        "activeOfTotal_one": "{{count}} de {{total}} activo",
        "activeOfTotal_other": "{{count}} de {{total}} activos"
      },
      "adaptation": {
        "title": "Adaptación",
        "activeOfTotal_one": "{{count}} de {{total}} activo",
        "activeOfTotal_other": "{{count}} de {{total}} activos"
      },
      "care": {
        "title": "Care",
        "activeOfTotal_one": "{{count}} de {{total}} activo",
        "activeOfTotal_other": "{{count}} de {{total}} activos"
      },
      "notStartedYet_one": "{{count}} patrocinado · aún no iniciado",
      "notStartedYet_other": "{{count}} patrocinados · aún no iniciados",
      "notStartedMore_one": "+{{count}} más",
      "notStartedMore_other": "+{{count}} más"
    },
    "cohorts": {
      "activeCohorts": "Cohortes en curso",
      "addTalents": "Añadir talentos",
      "adjustFilters": "Ajustar filtros",
      "alerts": "Alertas",
      "all": "Todo",
      "allPrograms": "Todos los programas",
      "allStatus": "Todo estado",
      "askCoPilot": "Preguntar a CoPilot",
      "atRisk": "en riesgo",
      "atRiskLabel": "en riesgo",
      "avgProgress": "Promedio de progreso",
      "backToCohorts": "Volver a cohortes",
      "biWeekly": "Quincenal",
      "blocked": "Bloqueado",
      "care": "Care",
      "careRequiresEnterprise": "Care requiere empresa",
      "careSettingsReset": "Restablecimiento de configuración de Care",
      "careSettingsSaved": "Estrategia de Care guardada",
      "cohortCreated": "Cohorte creada",
      "cohortDeleted": "Cohorte eliminada",
      "cohortNameLabel": "Nombre de la cohorte",
      "cohortNamePlaceholder": "Introduce el nombre de la cohorte...",
      "cohortPaused": "Cohorte pausada",
      "cohortResumed": "Cohorte reanudada",
      "cohortUpdated": "Cohorte actualizada",
      "createCohort": "Crear cohorte",
      "createDialogDescription": "Una cohorte es un grupo de talentos que estás moviendo juntos a través del viaje: misma ventana de inicio, mismo destino, mismo programa.",
      "createFirstCohort": "Crear primera cohorte",
      "createNewCohort": "Crear nueva cohorte",
      "deleteCohort": "Eliminar cohorte",
      "deleteConfirmDescription": "Esto eliminará permanentemente la cohorte. Esta acción no se puede deshacer.",
      "deleteConfirmTitle": "¿Eliminar esta cohorte?",
      "deleteFailed": "Error al eliminar la cohorte",
      "description": "Agrupa a los talentos por promoción para seguirlos juntos",
      "editCohort": "Editar cohorte",
      "editDialogDescription": "Actualiza los detalles de la cohorte a continuación.",
      "exportCsv": "Exportar CSV",
      "exportCsvFailed": "No se pudo exportar esta cohorte. Inténtalo de nuevo.",
      "exportCsvTruncated": "Esta exportación solo incluye los primeros 500 talentos — esta cohorte tiene más.",
      "exportingCsv": "Exportando…",
      "warningRosterTruncated": "Mostrando {{exported}} de {{total}} talentos — esta cohorte es mayor de lo que la lista puede mostrar.",
      "warningAcceptedWithoutJourney_one": "{{count}} invitación aceptada aún no tiene un viaje registrado.",
      "warningAcceptedWithoutJourney_other": "{{count}} invitaciones aceptadas aún no tienen un viaje registrado.",
      "feedbackCadence": "Frecuencia de retroalimentación",
      "fillRequiredFields": "Completa los campos requeridos",
      "filterByProgram": "Filtrar por programa",
      "getMoreInsights": "Obtener más información",
      "insights": "Perspectivas",
      "insightsDescription": "Cómo avanza esta cohorte",
      "insightCompletionRate": "El {{percent}}% de los talentos activos de esta cohorte ha llegado a Evidencia.",
      "insightSponsoredWithoutCare_one": "{{count}} talento patrocinado no tiene puntos de contacto de Care activos — revisa la cadencia de seguimiento.",
      "insightSponsoredWithoutCare_other": "{{count}} talentos patrocinados no tienen puntos de contacto de Care activos — revisa la cadencia de seguimiento.",
      "insightsEmpty": "Todavía no hay conclusiones para esta cohorte.",
      "inviteToVetting": "Invitar a Evaluación",
      "iqulture": "iQulture",
      "journeyOverview": "Resumen del viaje",
      "latestUpdates": "Últimas actualizaciones",
      "messageCohort": "Mensaje a la cohorte",
      "monthly": "Mensual",
      "noCohortsFound": "No se encontraron cohortes",
      "noProgramUnassigned": "No hay programa no asignado",
      "notFound": "Cohorte no encontrada",
      "notFoundDesc": "Esta cohorte no existe o ha sido eliminada. Intenta volver a la lista de cohortes.",
      "onTrack": "En progreso",
      "overview": "Resumen",
      "pauseCohort": "Pausar cohorte",
      "programOptional": "Programa opcional",
      "progress": "Progreso",
      "quarterly": "Trimestral",
      "recentActivity": "Actividad reciente",
      "requestUpdate": "Solicitar actualización",
      "resumeCohort": "Reanudar cohorte",
      "searchCohorts": "Buscar cohortes",
      "searchTalents": "Buscar talentos",
      "selectProgram": "Seleccionar programa",
      "sendMessage": "Enviar mensaje",
      "stability": "Estabilidad",
      "startDateLabel": "Fecha de inicio",
      "started": "Comenzado",
      "status": "Estado",
      "statusChangeFailed": "Error al cambiar el estado de la cohorte",
      "targetArrival": "Llegada prevista",
      "talents": "Talentos",
      "title": "Cohortes",
      "totalTalents": "Total de talentos",
      "trackProgress": "Rastrear progreso",
      "unassigned": "No Asignado",
      "updateFailed": "Error al actualizar la cohorte",
      "viewDetails": "Ver detalles",
      "viewProfile": "Ver perfil",
      "whatHappensNext": "Qué sucede a continuación",
      "whatHappensNextDescription": "Llegarás a la página de detalles de la cohorte donde podrás invitar talentos directamente, asignarlos desde el Pool y seguir su progreso a través de la Evaluación y los héroes Patrocinados paralelos (Movilidad, Adaptación, Care).",
      "errors": {
        "nameRequired": "El nombre de la cohorte es obligatorio",
        "nameTooLong": "El nombre de la cohorte debe tener 200 caracteres o menos",
        "descriptionTooLong": "La descripción debe tener 2000 caracteres o menos",
        "planLimit": "El plan gratuito permite 1 cohorte activa. Actualiza a Enterprise para cohortes ilimitadas."
      },
      "cohortActionsAria": "Acciones para {{name}}",
      "emptyTalentsTitle": "Aún no hay talentos en esta cohorte",
      "emptyTalentsDescription": "Invita talentos o importa una lista para comenzar a rastrearlos a través de la Evaluación y el Patrocinio.",
      "addTalentsAria": "Agregar talentos a {{name}}",
      "descriptionLabel": "Descripción",
      "descriptionPlaceholder": "Notas opcionales sobre esta cohorte",
      "targetShort": "Objetivo",
      "startDateUnset": "Fecha de inicio no establecida",
      "feedbackCadenceAria": "Cadencia de retroalimentación: {{cadence}}",
      "targetArrivalAria": "Llegada objetivo: {{date}}",
      "talentRowActionsAria": "Acciones para {{name}}",
      "archiveSuccess": "{{name}} se movió a archivado.",
      "archiveFailed": "Error al archivar la cohorte",
      "restoreSuccess": "{{name}} restaurado.",
      "restoreFailed": "Error al restaurar la cohorte",
      "activeTab": "Activo",
      "archivedTab": "Archivado",
      "manageArchivedOnPipeline": "Gestionar en el pipeline",
      "archivedReadOnly": "Los compromisos archivados son de solo lectura aquí. Restáuralos desde el Pipeline.",
      "archivedEmptyTitle": "No hay compromisos archivados en esta cohorte",
      "selectAllAria": "Seleccionar todos los talentos",
      "selectAllCount": "Seleccionar todo ({{selected}}/{{total}})",
      "viewInPipeline": "Ver talentos en el Pipeline",
      "disabledPausedCohort": "Reanuda la cohorte para habilitar esta acción",
      "disabledPausedProgram": "Reanuda el programa principal para habilitar esta acción",
      "archive": "Archivar",
      "restore": "Restaurar",
      "archiveConfirmTitle": "¿Archivar la cohorte?",
      "archiveConfirmDescription": "{{name}} se mueve a la pestaña Archivado. Restaura en cualquier momento desde allí. Los talentos existentes no se ven afectados.",
      "scope": {
        "active": "Activo",
        "archived": "Archivado"
      },
      "form": {
        "talentCountPlaceholder": "p. ej., 20"
      },
      "atRiskCount_one": "{{count}} en riesgo",
      "atRiskCount_other": "{{count}} en riesgo",
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "inviteCountToVetting_one": "Invitar a {{count}} a Vetting",
      "inviteCountToVetting_other": "Invitar a {{count}} a Vetting",
      "selectedCount_one": "{{count}} seleccionado",
      "selectedCount_other": "{{count}} seleccionados"
    },
    "common": {
      "add": "Agregar",
      "back": "Atrás",
      "cancel": "Cancelar",
      "change": "Cambiar",
      "clear": "Limpiar",
      "close": "Cerrar",
      "confidence": "confianza",
      "confirm": "Confirmar",
      "continue": "Continuar",
      "founded": "Fundado",
      "loading": "Cargando...",
      "of": "de",
      "optional": "Opcional",
      "other": "Otro",
      "save": "Guardar",
      "select": "Seleccionar",
      "tryAgain": "Intenta de nuevo",
      "view": "Ver",
      "yourCompany": "tu empresa",
      "error": {
        "sectionTitle": "No se pudo cargar esta sección",
        "sectionDescription": "Algo salió mal al obtener los datos. Intenta de nuevo — si el problema persiste, contacta con soporte.",
        "retry": "Reintentar"
      },
      "relativeTime": {
        "justNow": "justo ahora",
        "today": "Hoy",
        "yesterday": "Ayer",
        "weekAgo": "hace 1 semana",
        "monthAgo": "hace 1 mes"
      },
      "contactPlaceholder": "contacto@tonnie.ai"
    },
    "components": {
      "addTalentsWizard": {
        "assignToCohort": "Asignar a cohorte",
        "back": "Atrás",
        "cancel": "Cancelar",
        "chooseCohortTalentsDesc": "Elige la cohorte a la que se unen estos talentos",
        "bringFromPool": "Traer del Tonnie Pool",
        "browsePool": "Explorar Pool",
        "chooseImportMethod": "Elegir método de importación",
        "confirmAndImport": "Confirmar e importar",
        "confirmImport": "Confirmar importación",
        "createNewCohort": "Crear nueva cohorte",
        "createNewProgram": "Crear nuevo programa",
        "importing": "Importando...",
        "mapColumns": "Mapear columnas",
        "mapColumnsDesc": "Relaciona las columnas de tu hoja con los campos de Tonnie",
        "needHelpChoosing": "¿Necesitas ayuda para elegir?",
        "needHelpDescriptionNoATS": "Sube archivos Excel o CSV, o trae talentos de tu Tonnie Talent Pool (Enterprise), para añadirlos a tu pipeline. La integración con ATS estará disponible en una versión futura.",
        "next": "Siguiente",
        "reviewData": "Revisar datos",
        "reviewDataDesc": "Revisa cada fila antes de importarla",
        "selectImportDesc": "Importa desde una hoja de cálculo o desde tu ATS",
        "selectTargetCohort": "Seleccionar cohorte objetivo",
        "uploadExcelCsv": "Subir Excel csv",
        "uploadFile": "Subir archivo",
        "uploadFileDesc": "Un archivo Excel o CSV con un talento por fila"
      },
      "addToCohort": {
        "addToCohortBtn": "Agregar a cohorte",
        "afterAdding": "Después de agregar",
        "cancel": "Cancelar",
        "chooseCohort": "Elegir cohorte",
        "cohortDetails": "Detalles del cohorte",
        "currentTalents": "Talentos actuales",
        "pleaseSelectCohort": "Por favor, selecciona una cohorte",
        "program": "Programa",
        "selectCohort": "Seleccionar cohorte",
        "title": "Agregar a cohorte",
        "unassigned": "No Asignado",
        "description_one": "Selecciona una cohorte para añadir el {{count}} talento seleccionado",
        "description_other": "Selecciona una cohorte para añadir los {{count}} talentos seleccionados",
        "talentsAdded_one": "{{count}} talento añadido a la cohorte",
        "talentsAdded_other": "{{count}} talentos añadidos a la cohorte",
        "talentsSelected_one": "{{count}} talento seleccionado",
        "talentsSelected_other": "{{count}} talentos seleccionados",
        "talentCount_one": "{{count}} talento",
        "talentCount_other": "{{count}} talentos"
      },
      "confirmDialog": {
        "processing": "Procesando"
      },
      "countrySelect": {
        "noResults": "Sin resultados",
        "placeholder": "Marcador de posición",
        "search": "Buscar"
      },
      "pageHeader": {
        "coPilot": "CoPilot",
        "goBack": "Volver"
      }
    },
    "consent": {
      "objectivesNotShared": "Este talento no comparte Care con tu empresa, por lo que sus objetivos no se muestran.",
      "withheld": {
        "care_one": "{{count}} talento no comparte Care",
        "care_other": "{{count}} talentos no comparten Care",
        "checkup_one": "{{count}} talento no comparte su resultado del CheckUp",
        "checkup_other": "{{count}} talentos no comparten su resultado del CheckUp",
        "passport_stamps_one": "{{count}} talento no comparte su Passport",
        "passport_stamps_other": "{{count}} talentos no comparten su Passport",
        "qultureup_one": "{{count}} talento no comparte QultureUp",
        "qultureup_other": "{{count}} talentos no comparten QultureUp",
        "teleportal_one": "{{count}} talento no comparte TelePortal",
        "teleportal_other": "{{count}} talentos no comparten TelePortal"
      }
    },
    "copilot": {
      "open": "Abrir CoPilot"
    },
    "dashboard": {
      "activeJourneys": "Viajes activos",
      "addToTalentPool": "Añadir a la bolsa de talentos",
      "aiCoPilot": "AI CoPilot",
      "allClear": "Todo claro",
      "allClearTitle": "Todo claro",
      "askCoPilot": "Preguntar a CoPilot",
      "attention": "Necesita atención",
      "averageScore": "Puntuación media",
      "coPilotDescription": "Pregunta a tu asistente AI sobre información de movilidad de talentos, recomendaciones de programas y análisis de datos.",
      "conversionRate": "{{rate}}% de conversión",
      "createCohort": "Crear cohorte",
      "critical": "Crítico",
      "evidence": "Evidencia",
      "exploreHeroes": "Explorar héroes",
      "healthy": "Saludable",
      "heroes": {
        "assessReadiness": "Evaluar la preparación de talentos y la adaptación cultural",
        "checkupAndPool": "CheckUp y Pool",
        "commitment": "Compromiso",
        "culturalAdaptation": "Adaptación cultural & iQulture",
        "legalTravelSetup": "Configuración legal, de viaje y reubicación",
        "wellbeingLoyalty": "Monitoreo de bienestar y lealtad",
        "inTransitCount_one": "{{count}} en tránsito",
        "inTransitCount_other": "{{count}} en tránsito",
        "learningCount_one": "{{count}} aprendiendo",
        "learningCount_other": "{{count}} aprendiendo",
        "talentsCount_one": "{{count}} talento",
        "talentsCount_other": "{{count}} talentos",
        "thrivingCount_one": "{{count}} prosperando",
        "thrivingCount_other": "{{count}} prosperando"
      },
      "importTalents": "Importar talentos",
      "inCheckUp": "En CheckUp",
      "iqulture": "iQulture",
      "journeyFlow": "Flujo de viaje",
      "launchProgram": "Lanzar programa",
      "milesAndStamps": "{{miles}} millas · {{stamps}} sellos",
      "navigateToDashboards": "Navegar a paneles especializados",
      "needAttention": "Necesita atención",
      "needsAttention": "Necesita atención",
      "attentionMyTasks": "Mis tareas",
      "attentionAtRisk": "En riesgo",
      "noRecentEvents": "Sin eventos recientes",
      "noUrgentItems": "Sin elementos urgentes que requieran atención",
      "onTrack": "En progreso",
      "organizeTalents": "Organizar talentos en grupos",
      "pipeline": "Pipeline",
      "portfolioHealth": "Salud del portafolio",
      "portfolioSummary": "Gestionando {{programs}} programas y {{cohorts}} cohortes",
      "profileCompletion": {
        "addRemainingDetails": "Añadir detalles restantes",
        "complexFieldNotice": "Este campo se puede editar desde el asistente de incorporación. Haz clic en 'Finalizar en el asistente de incorporación' para actualizarlo.",
        "description": "Añade algunos detalles más para desbloquear una mejor coincidencia y una facturación más rápida.",
        "descriptionAlmostThere": "Casi estás allí: completa algunos detalles más para terminar tu perfil.",
        "dialogDesc": "Esto toma unos segundos y hace que la coincidencia de talentos sea más precisa.",
        "fields": {
          "annualHiringVolume": "Volumen de contratación anual",
          "branches": "Oficinas sucursales",
          "businessType": "Tipo de negocio",
          "companyName": "Nombre de la empresa",
          "companySize": "Tamaño de la empresa",
          "contactPhone": "Teléfono de contacto",
          "contactRole": "Rol de contacto",
          "foundedYear": "Año de fundación",
          "hiringGoals": "Objetivos de contratación",
          "hiringTimeframe": "Plazo de contratación",
          "hqCountry": "País de la sede",
          "industry": "Industria",
          "languages": "Requisitos de idioma",
          "legalName": "Nombre de la entidad legal",
          "mobilityMaturity": "Madurez de movilidad",
          "primaryUseCase": "Caso de uso principal",
          "targetMarkets": "Mercados objetivo",
          "targetRoleTypes": "Tipos de roles objetivo",
          "taxId": "ID fiscal / IVA",
          "topChallenges": "Principales desafíos",
          "website": "Sitio web",
          "workArrangement": "Arreglo laboral"
        },
        "finishInWizard": "Finaliza en el asistente de incorporación",
        "seeAll": "Ver todo ({{count}})",
        "title": "Completa tu perfil",
        "descriptionWithCount_one": "{{count}} detalle aún por completar: lleva aproximadamente un minuto.",
        "descriptionWithCount_other": "{{count}} detalles aún por capturar: toma aproximadamente un minuto."
      },
      "quickActions": "Acciones rápidas",
      "recentActivity": "Actividad reciente",
      "sendCheckUp": "Enviar CheckUp",
      "sponsored": "Patrocinado",
      "stages": {
        "adaptation": "Adaptación",
        "care": "Care",
        "mobility": "Movilidad",
        "vetting": "Evaluación"
      },
      "startNewMobility": "Iniciar nuevo programa de movilidad",
      "startVettingProcess": "Iniciar proceso de validación",
      "talentDistribution": "Distribución de talento a lo largo de las etapas del viaje",
      "topPerformers": "Mejores desempeños",
      "urgent": "Urgente",
      "myCareTasks": {
        "title": "Mis tareas críticas",
        "viewAll": "Ver todo en Care"
      },
      "viewAllEvents": "Ver todos los eventos",
      "viewAllIssues": "Ver todos los problemas",
      "viewAnalytics": "Ver análisis",
      "welcomeBackBusiness": "¡Bienvenido de nuevo, {{name}}!",
      "onboarding": {
        "title": "Bienvenido a Tonnie. Vamos a configurar tus primeros talentos.",
        "body": "Tu panel se llenará tan pronto como importes talentos y los agrupes en un programa. Dos pasos y estarás en vivo en adquisición, selección y patrocinio.",
        "importTitle": "Importar talentos",
        "importBody": "Sube un CSV o XLSX, o añade candidatos uno a uno. Las invitaciones se enviarán tan pronto como confirmes.",
        "programTitle": "Crea tu primer programa",
        "programBody": "Los programas agrupan cohortes y muestran métricas de adquisición / selección / patrocinio en un solo lugar.",
        "helperHint": "Consejo: puedes hacer cualquiera de los pasos primero; se conectan automáticamente una vez que ambos existen.",
        "skipToPipeline": "Ir al pipeline",
        "skipToPool": "Explorar el Pool"
      },
      "todayPanel": {
        "blockedSubtitle": "Abre el cajón para despejar el bloqueo",
        "atRiskSubtitle": "Un empujón hoy mantiene este viaje en camino",
        "title": "Prioridades de hoy",
        "blockedItem": "{{name}}: bloqueado",
        "atRiskItem": "{{name}}: en riesgo",
        "countLabel_one": "{{count}} acción",
        "countLabel_other": "{{count}} acciones",
        "goodNewsItem": "{{name}}: buenas noticias"
      },
      "weeklySummary": {
        "thisWeek": "Esta semana"
      },
      "blockedFallback": "Proceso bloqueado",
      "riskFallback": "En riesgo",
      "attentionAdaptationRisk": "Baja participación en adaptación",
      "attentionCareRisk": "Compromiso en riesgo",
      "atRiskCount_one": "{{count}} en riesgo",
      "atRiskCount_other": "{{count}} en riesgo",
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "attentionOverdue_one": "{{count}} vencido",
      "attentionOverdue_other": "{{count}} vencidos",
      "welcomeBackBusinessNoName": "¡Bienvenido de nuevo!",
      "attentionGoodNews": "Buenas noticias"
    },
    "evidence": {},
    "evidencePage": {
      "activeTab": "Activo",
      "activity": "Actividad",
      "archivedTab": "Archivado",
      "adaptation": "Adaptación",
      "allClear": "Todo claro",
      "allCohorts": "Todos los cohortes",
      "allStages": "Todas las etapas",
      "analysis": "Análisis",
      "cohortLabel": "Cohorte",
      "irrTrendsEmpty": "No hay suficientes datos de IRR aún: el gráfico de evolución se desbloquea después de al menos dos meses de actividad.",
      "mesh": {
        "motivation": "Motivación",
        "english": "Inglés",
        "softSkills": "Habilidades blandas",
        "hardSkills": "Habilidades técnicas"
      },
      "openPassportAria": "Abrir pasaporte para {{name}}",
      "sponsoredBadge": "Patrocinado",
      "stageNotShared": "No compartido",
      "talentRowActionsAria": "Acciones para {{name}}",
      "totalBadges": "Total de insignias",
      "totalStamps": "Total de sellos",
      "averageIQultureScore": "Puntuación promedio iQulture",
      "avgIQulture": "Prom. iQulture",
      "avgProgress": "Promedio de progreso",
      "careLabel": "Care",
      "carePillarsHealth": "Salud de los pilares de Care",
      "carePillarsHealthDesc": "Cómo valoran tus talentos cada pilar de Care",
      "checkUpProgress": "Progreso del CheckUp",
      "citizenBadges": "Insignias Citizen",
      "citizenBadgesDesc": "Insignias que tus talentos han ganado en sus trayectos",
      "common": "Común",
      "description": "La prueba del trayecto de cada talento: pasaportes, sellos e insignias",
      "epic": "Épico",
      "estimatedContribution": "Contribución estimada",
      "events": "Eventos",
      "iqultureBadgeDist": "Dist. Insignia iQulture",
      "irrEvolution": "Evolución de IRR",
      "irrEvolutionDesc": "Cómo han crecido las evidencias de tus talentos con el tiempo",
      "legendary": "Legendario",
      "levelsDistributionDesc": "Cuántos talentos han alcanzado cada nivel de ciudadano",
      "meshScoreBreakdown": "Desglose MESH",
      "meshScoreDesc": "Puntuaciones MESH medias de tus talentos evaluados",
      "milesAndStamps": "{{miles}} millas · {{stamps}} sellos",
      "milesFromAchievements": "Miles desde logros",
      "mobility": "Movilidad",
      "needsAttention": "Necesita atención",
      "overallHealthScore": "Puntuación de salud general",
      "overview": "Resumen",
      "passports": "Pasaportes",
      "rare": "Raro",
      "uncommon": "Poco común",
      "noEvents": "No hay eventos aún",
      "noPassports": "No hay pasaportes que coincidan con tus filtros.",
      "rarityDistribution": "Distribución de rareza",
      "recentEvents": "Eventos recientes",
      "searchTalents": "Buscar talentos",
      "sponsoredTalents": "Talentos patrocinados",
      "stageLabel": "Etapa",
      "stampsBadges": "Logros",
      "stampsCollection": "Colección de sellos",
      "stampsCollectionDesc": "Sellos que tus talentos han reunido en cada hito",
      "talentReadinessLevels": "Niveles de preparación de talentos",
      "title": "Evidencia",
      "topPerformers": "Mejores desempeños",
      "totalMiles": "Total de Miles",
      "vettingPool": "Grupo de evaluación",
      "talentStatus": {
        "on-track": "En camino",
        "at-risk": "En riesgo",
        "blocked": "Bloqueado",
        "completed": "Completado",
        "unknown": "Estado pendiente"
      },
      "pillarScoresPending": "Las puntuaciones de Care por pilar aparecerán aquí una vez que se envíe la proyección del backend Care.",
      "stages": {
        "vetting": "Evaluación",
        "mobility": "Movilidad",
        "adaptation": "Adaptación",
        "care": "Care"
      },
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "earned_one": "{{count}} ganado",
      "earned_other": "{{count}} ganados",
      "passportCount_one": "{{count}} pasaporte",
      "passportCount_other": "{{count}} pasaportes",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos"
    },
    "feedback": {
      "additionalFeedbackHint": "Puedes proporcionar comentarios detallados, adjuntar capturas de pantalla o archivos para ayudarnos a entender mejor tu experiencia.",
      "attachFiles": "Adjuntar archivos",
      "categoryDescription": "Selecciona la categoría que mejor describa tus comentarios",
      "categoryQuestion": "¿Qué tipo de comentarios son estos?",
      "characterCount": "{{current}}/{{max}} caracteres",
      "context": {
        "hero": "Héroe",
        "heroPlaceholder": "p. ej., CheckUp, TelePortal",
        "notDetected": "No se detectó contexto",
        "page": "Página",
        "pagePlaceholder": "p. ej., /dashboard, /checkup"
      },
      "contextInfo": "Información de contexto",
      "contextSaved": "Información de contexto guardada",
      "detailsDescription": "Por favor, proporciona detalles sobre tus comentarios",
      "detailsPlaceholder": "Describe tus comentarios en detalle...",
      "detailsQuestion": "Cuéntanos más",
      "editContext": "Editar",
      "fileSizeError": "El tamaño del archivo excede el límite de {{maxSize}}",
      "fileUploadDescription": "Añade capturas de pantalla, PDFs u otros archivos (hasta 20MB cada uno) para ayudarnos a entender mejor tus comentarios.",
      "optional": "Opcional",
      "privacyNote": "Tu retroalimentación es anónima y nos ayuda a mejorar Tonnie",
      "ratingDescription": "Evalúa tu satisfacción general",
      "ratingQuestion": "¿Cómo fue tu experiencia?",
      "selectRatingAndCategory": "Por favor, selecciona tanto la calificación como la categoría",
      "submit": "Enviar",
      "submitError": "Error al enviar comentarios. Por favor, inténtalo de nuevo.",
      "submitSuccess": "¡Gracias! Tus comentarios han sido enviados.",
      "submitting": "Enviando...",
      "subtitle": "Ayúdanos a mejorar tu experiencia",
      "successMessage": "Agradecemos que te tomes el tiempo para ayudarnos a mejorar Tonnie. Tu opinión ha sido recibida y será revisada por nuestro equipo.",
      "successTitle": "¡Gracias por tus comentarios!",
      "title": "Retroalimentación",
      "toggle": "Enviar comentarios",
      "totalFileSize": "{{size}} / {{maxSize}}",
      "uploadFiles": "Subir archivos",
      "validationError": "Por favor, completa todos los campos obligatorios"
    },
    "affiliate": {
      "availableBalance": "Saldo disponible",
      "codeCopied": "Código de cupón copiado",
      "colActions": "Acciones",
      "colAmount": "Cantidad",
      "colAmountPaid": "Cantidad pagada",
      "colCommission": "Comisión",
      "colDate": "Fecha",
      "colProgress": "Progreso",
      "colRequested": "Solicitado",
      "colRoute": "Ruta",
      "colScenario": "Escenario",
      "colStatus": "Estado",
      "daysWaiting": "{{count}}d esperando",
      "paidOn": "Pagado {{date}}",
      "commission": "Comisión",
      "copyCode": "Copiar código",
      "discountGiven": "Descuento otorgado",
      "exportCsv": "Exportar CSV",
      "exporting": "Exportando…",
      "exportReady": "Exportación lista",
      "exportFailed": "No se pudieron exportar las redenciones",
      "filters": {
        "granularityLabel": "Agrupar por",
        "granularity": {
          "day": "Día",
          "month": "Mes",
          "year": "Año"
        },
        "rangeLabel": "Período",
        "range": {
          "30d": "30 días",
          "90d": "90 días",
          "12m": "12 meses",
          "all": "Todo el tiempo"
        },
        "scenarioLabel": "Escenario",
        "scenarioAll": "Todos los escenarios",
        "statusLabel": "Estado",
        "statusAll": "Todos los estados"
      },
      "scenario": {
        "unlock": "Desbloqueo de viaje",
        "renewal": "Renovación",
        "pro": "Pro",
        "other": "Otro"
      },
      "noRedemptionsForFilters": "No hay redenciones que coincidan con estos filtros.",
      "redemptionsTitle": "Redenciones",
      "rowsPerPage": "Filas por página",
      "showingRange": "{{from}}–{{to}} de {{total}}",
      "goToPage": "Ir a la página {{page}}",
      "prev": "Anterior",
      "next": "Siguiente",
      "checkout": "Tonnie pago",
      "checkoutSecure": "Seguro · Stripe",
      "customerView": "Lo que ve tu cliente",
      "howTitle": "Cómo funciona el programa",
      "howStep1Title": "Comparte tu código",
      "howStep1Body": "Dale {{code}} a las personas que refieras a Tonnie.",
      "howStep2Title": "Ellos ahorran {{percent}}%",
      "howStep2Body": "El código se aplica en el pago — el precio baja antes de que paguen.",
      "howStep3Title": "Ganas {{rate}}%",
      "howStep3Body": "En cada conversión pagada, se acredita a tu saldo el {{rate}}% de lo que ellos pagan.",
      "howStep4Title": "Retirar",
      "howStep4Body": "Una vez que tu saldo alcance {{amount}}, solicita un pago y sube tu factura para recibir el pago.",
      "refundsNote": "La comisión se acumula solo cuando un pago tiene éxito. Los reembolsos dentro de la ventana revierten automáticamente la comisión correspondiente.",
      "sampleProduct": "Viaje Pro",
      "sampleProductSub": "Suscripción mensual",
      "invoiceOnFile": "Factura recibida",
      "invoiceUploaded": "Factura subida",
      "invoiceUploadFailed": "Error al subir la factura",
      "minimumPayout": "Pago mínimo: {{amount}}",
      "noPayoutsYet": "No se han solicitado pagos aún.",
      "noRedemptionsYet": "No hay canjes aún.",
      "notEnrolledBody": "Esta organización no está inscrita en el programa de afiliados Tonnie. Contacta a Tonnie para comenzar.",
      "notEnrolledTitle": "Aún no es afiliado",
      "awaitingApproval": "Esperando aprobación",
      "cancel": "Cancelar",
      "payoutCancelled": "Pago cancelado — saldo liberado",
      "payoutCancelFailed": "No se pudo cancelar el pago",
      "payoutFailed": "No se pudo solicitar el pago",
      "payoutHistory": "Historial de pagos",
      "payoutRequested": "Pago solicitado",
      "payoutStep1Title": "Solicitud",
      "payoutStep1Body": "Solicitas un pago de tu saldo disponible.",
      "payoutStep2Title": "Aprobación",
      "payoutStep2Body": "Tonnie revisa y aprueba tu solicitud.",
      "payoutStep3Title": "Factura",
      "payoutStep3Body": "Subes tu factura por el importe.",
      "payoutStep4Title": "Pago",
      "payoutStep4Body": "Tonnie te paga por transferencia bancaria.",
      "payoutStatus": {
        "approved": "Aprobado",
        "cancelled": "Cancelado",
        "invoice_received": "Factura recibida",
        "paid": "Pagado",
        "rejected": "Rechazado",
        "requested": "Solicitado"
      },
      "percentOff": "{{percent}}% de descuento",
      "platform": {
        "colCommission": "Comisión",
        "colDiscount": "Descuento",
        "colIssuer": "Afiliado",
        "colPaid": "Pagado",
        "colRedemptions": "Canjes",
        "errorHint": "Vuelve a intentarlo o comprueba tu acceso de personal de Tonnie.",
        "errorTitle": "No se pudo cargar la vista de la plataforma",
        "issuersTitle": "Por afiliado",
        "noIssuers": "Aún no hay canjes pagados.",
        "totalCommission": "Comisión total",
        "totalDiscount": "Descuento total concedido",
        "totalPaid": "Total pagado",
        "totalRedemptions": "Total de canjes"
      },
      "yourCommission": "Ganas {{rate}}%",
      "discountHint": "El descuento que obtienen tus clientes al finalizar la compra.",
      "commissionHint": "Tu comisión sobre cada cantidad que pagan.",
      "redemptionsOverTime": "Redenciones a lo largo del tiempo",
      "redemptionStatus": {
        "paid": "Pagado",
        "pending": "Pendiente",
        "refunded": "Reembolsado"
      },
      "requestPayout": "Solicitar pago",
      "subtitle": "Rastrea las redenciones de tu cupón y retira tu comisión.",
      "tabHowItWorks": "Cómo funciona",
      "tabOverview": "Resumen",
      "tabPayouts": "Pagos",
      "tabPlatform": "Plataforma",
      "title": "Programa de afiliados",
      "totalCommission": "Comisión total",
      "totalRedemptions": "Redenciones",
      "uploadInvoice": "Subir factura",
      "uploading": "Subiendo…",
      "yourCode": "Tu código de cupón"
    },
    "layout": {
      "adaptation": "Adaptación",
      "affiliates": "Afiliados",
      "billing": "Facturación",
      "business": "Business",
      "care": "Care",
      "cohorts": "Cohortes",
      "evidence": "Evidencia",
      "home": "Inicio",
      "logout": "Cerrar sesión",
      "messages": "Mensajes",
      "mobility": "Movilidad",
      "pipeline": "Pipeline",
      "pool": "Grupo",
      "programs": "Programas",
      "settings": "Configuraciones",
      "vetting": "Evaluación",
      "inoutOperations": "Operación InOut"
    },
    "legal": {
      "aboutUs": "Sobre nosotros",
      "backToDashboard": "Volver al tablero",
      "dataProtection": "Protección de datos",
      "dataProtectionBody": "Organismo de protección de datos",
      "gdprBody": "Organismo de GDPR",
      "gdprCompliance": "Cumplimiento de GDPR",
      "privacyBody": "Organismo de privacidad",
      "privacyDescription": "Cómo Tonnie recoge, usa y protege los datos personales",
      "privacyPolicy": "Política de privacidad",
      "rightsDescription": "Tus derechos sobre los datos que guarda Tonnie, y cómo ejercerlos",
      "subtitle": "Subtítulo",
      "termsBody": "Organismo de términos",
      "termsDescription": "Los términos que rigen el uso de Tonnie por tu empresa",
      "termsOfService": "Términos de servicio",
      "title": "Términos y privacidad",
      "viewPrivacy": "Ver privacidad",
      "viewTerms": "Ver términos",
      "yourRights": "Tus derechos"
    },
    "mobilityPage": {
      "activeTab": "Activo",
      "archivedTab": "Archivado",
      "allStatus": "Todo estado",
      "allTracks": "Todas las rutas",
      "analytics": "Analíticas",
      "acrossAllTracks": "A través de todas las rutas",
      "avgProgress": "Promedio de progreso",
      "blocked": "Bloqueado",
      "blockingDocs": "Documentos bloqueantes",
      "complete": "Completo",
      "viewAll": "Ver todo",
      "detailsBtn": "Detalles",
      "detailsAria": "Abrir detalles de CoPilot para {{name}}",
      "viewTalentAria": "Ver detalles para {{name}}",
      "talentRowActionsAria": "Acciones para {{name}}",
      "blockingDocsPending": "Documentos bloqueantes pendientes",
      "coTasks": "Tareas",
      "companyActions": "Acciones de la empresa",
      "atRiskTalents": "En riesgo",
      "overdueTasks": "Tareas atrasadas",
      "companyActionsRequired": "Acciones de la empresa requeridas",
      "companyDocsPending": "Documentos de la empresa pendientes",
      "companyActionsSectionTitle": "Tareas de la empresa",
      "companyTasksDesc": "Obligaciones de la empresa en relación con tus talentos patrocinados — agrupadas por talento.",
      "companyTasksPending": "Tareas de la empresa pendientes",
      "companyTasksPendingCount_one": "{{count}} tarea de la empresa pendiente",
      "companyTasksPendingCount_other": "{{count}} tareas de la empresa pendientes",
      "companyTasksTitle": "Tareas de la empresa",
      "companyTasksOpenTab": "Abierto ({{count}})",
      "companyTasksCompletedTab": "Completado ({{count}})",
      "companyTasksEmpty": "No hay tareas aquí.",
      "attachUpload": "Adjuntar y subir",
      "awaitingUpload": "Esperando carga",
      "docsAttachedCount": "{{uploaded}}/{{total}} docs",
      "noDocsRequired": "No se requieren documentos — marca como completo cuando termines.",
      "replaceDocument": "Reemplazar",
      "reopenTaskAria": "Reabrir {{title}}",
      "requiredDocuments": "Documentos requeridos",
      "docsRequiredToCompleteTitle": "Subir documentos requeridos",
      "docsUploadedProgress": "{{uploaded}} de {{total}} documentos subidos",
      "allDocsUploadedReadyToComplete": "Todos los documentos subidos — puedes completar esta tarea.",
      "taskReopened": "Reabierto \"{{title}}\"",
      "taskReopenFailed": "No se pudo reabrir \"{{title}}\". Por favor, inténtalo de nuevo.",
      "completed": "Completado",
      "completionRate": "Tasa de finalización",
      "description": "Visados, viaje e instalación en los traslados de tus talentos patrocinados",
      "documentUploadedSuccess": "{{name}} subido",
      "done": "Hecho",
      "dueDate": "Vencido: {{date}}",
      "filterStatus": "Estado",
      "filterTrack": "Rastrear",
      "for": "Para",
      "forTalent": "Para {{name}}",
      "inMobility": "En Movilidad",
      "inMobilitySplit": "{{inProgress}} en progreso · {{completed}} completados",
      "statusInProgress": "En progreso",
      "engaged": "Involucrado",
      "inProgressShort": "en progreso",
      "noTalentsInTrack": "No hay talentos en esta ruta aún",
      "viewCompletedTalents": "Ver talentos completados",
      "viewBlockedTalents": "Ver talentos bloqueados",
      "viewAtRiskTalents": "Ver talentos en riesgo",
      "trackCompletion": "Finalización de la ruta",
      "trackCompletionDescription": "Cuántos talentos han terminado cada ruta",
      "doneOfEngaged": "{{name}} · {{done}}/{{engaged}}",
      "legal": "Legal",
      "milestones": "Hitos",
      "mobilityTracks": "Rutas de movilidad",
      "overall": "General",
      "noDueDate": "Sin fecha de vencimiento",
      "noPendingTasks": "Sin tareas pendientes",
      "noTalentsFound": "No se encontraron talentos",
      "noTalentsInMobility": "No hay talentos en movilidad",
      "onTrack": "En progreso",
      "pendingTasks": "Tareas pendientes",
      "reminderSent": "Recordatorio enviado para {{title}}",
      "searchTalents": "Buscar talentos",
      "setup": "Configuración",
      "statusAtRisk": "Estado en riesgo",
      "statusBlocked": "Estado bloqueado",
      "statusOnTrack": "Estado en camino",
      "talentProgress": "Progreso del talento",
      "talentsBlocked": "Talentos bloqueados",
      "taskMarkedComplete": "{{title}} marcado como completo",
      "taskCompleteFailed": "Error al marcar \"{{title}}\" como completo. Por favor, inténtalo de nuevo.",
      "title": "Movilidad",
      "trackOverview": "Resumen de seguimiento",
      "travel": "Viajar",
      "tryAdjustingFilters": "Intenta ajustar filtros",
      "underReview": "En revisión",
      "validated": "Validado",
      "waitingOnCompanyCount": "Esperando a la empresa",
      "actionNeeded": "Acción necesaria",
      "allTasksCompletedTitle": "¡Todas las tareas completadas!",
      "clearFiltersButton": "Borrar filtros",
      "trackProgressOverview": "Resumen del progreso de seguimiento",
      "companyActionsSection": "Acciones de la empresa",
      "completeTaskAria": "Marcar {{title}} como completo",
      "waitingOnCompany": "Esperando a la empresa",
      "statusLabels": {
        "completed": "Completado",
        "on-track": "En camino",
        "blocked": "Bloqueado",
        "at-risk": "En riesgo"
      },
      "trackStatusLegend": {
        "done": "Hecho",
        "inProgress": "En progreso",
        "blocked": "Bloqueado",
        "notStarted": "No iniciado"
      },
      "lastActivityUnknown": "Sin actividad aún",
      "tracks": {
        "legal": {
          "name": "Legal",
          "description": "Visa, permisos de trabajo, documentación"
        },
        "travel": {
          "name": "Viajar",
          "description": "Vuelos, logística, coordinación de llegada"
        },
        "setup": {
          "name": "Configuración",
          "description": "Alojamiento, banca, registro local"
        }
      },
      "urgentTasksSummary_one": "{{count}} tarea urgente necesita atención",
      "urgentTasksSummary_other": "{{count}} tareas urgentes necesitan atención",
      "documentUploadFailed": "Error al subir. Inténtalo de nuevo.",
      "reminderTooSoonGeneric": "Recordatorio enviado recientemente.",
      "reminderFailed": "Error al enviar el recordatorio. Inténtalo de nuevo.",
      "uploadTooLarge": "El archivo es más grande que 25 MB. Recorta o comprime y vuelve a intentarlo.",
      "docsStillOutstanding_one": "{{count}} documento necesario",
      "docsStillOutstanding_other": "{{count}} documentos necesarios",
      "daysOverdue_one": "{{count}} día de retraso",
      "daysOverdue_other": "{{count}} días de retraso",
      "dueInDays_one": "Vence en {{count}} día",
      "dueInDays_other": "Vence en {{count}} días",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos",
      "pendingCount_one": "{{count}} pendiente",
      "pendingCount_other": "{{count}} pendientes",
      "talentCountCompleted_one": "{{count}} de {{total}} {{label}}",
      "talentCountCompleted_other": "{{count}} de {{total}} {{label}}",
      "reminderTooSoon_one": "Recordatorio enviado hace poco. Inténtalo de nuevo en {{count}} hora.",
      "reminderTooSoon_other": "Recordatorio enviado hace poco. Inténtalo de nuevo en {{count}} horas."
    },
    "nav": {
      "home": "Inicio"
    },
    "notFound": {
      "description": "La página que buscas no existe o ha sido movida.",
      "goHome": "Ir a inicio",
      "title": "Página no encontrada"
    },
    "notifications": {
      "justNow": "Justo ahora",
      "noNotifications": "Sin notificaciones",
      "title": "Notificaciones",
      "tabAll": "Todas",
      "unread": "Sin leer",
      "noUnread": "No hay notificaciones sin leer",
      "markAllRead": "Marcar todas como leídas",
      "bellLabel_one": "Notificaciones, {{shown}} sin leer",
      "bellLabel_other": "Notificaciones, {{shown}} sin leer",
      "clearRead": "Borrar leídas",
      "moreActions": "Más acciones",
      "markReadAction": "Marcar como leída",
      "dismiss": "Descartar",
      "dismissed": "Notificación descartada",
      "undo": "Deshacer",
      "viewDismissed": "Ver descartadas",
      "dismissedTitle": "Descartadas",
      "restore": "Restaurar",
      "noDismissed": "No hay notificaciones descartadas",
      "seeAll": "Ver todas las notificaciones",
      "showMore": "Ver más",
      "showLess": "Ver menos",
      "daysAgo_one": "Hace {{count}} día",
      "daysAgo_other": "Hace {{count}} días",
      "hoursAgo_one": "Hace {{count}} hora",
      "hoursAgo_other": "Hace {{count}} horas",
      "minutesAgo_one": "Hace {{count}} minuto",
      "minutesAgo_other": "Hace {{count}} minutos"
    },
    "onboarding": {
      "challenges": {
        "candidateDropoff": "Abandono de candidatos durante la reubicación",
        "complianceLegal": "Complejidad de cumplimiento y legal",
        "costManagement": "Gestión de costos",
        "findingCandidates": "Encontrar candidatos internacionales calificados",
        "immigrationVisa": "Complejidad de inmigración y visados",
        "postArrival": "Adaptación y retención post-llegada",
        "trackingReporting": "Seguimiento e informes"
      },
      "exitSetup": "Configuración de salida",
      "geographicSetup": {
        "moreRoutes_one": "+{{count}} más",
        "moreRoutes_other": "+{{count}} más"
      },
      "hiringContext": {
        "selectedChallenges": "Seleccionado: {{count}}/3 desafíos"
      },
      "hiringGoals": {
        "buildPipeline": "Construir un pipeline de talento sostenible",
        "improveExperience": "Mejorar la experiencia del candidato durante la reubicación",
        "improveOnboarding": "Mejorar la incorporación y adaptación post-llegada",
        "increaseRetention": "Aumentar la retención de empleados reubicados",
        "reduceCosts": "Reducir costos de reubicación",
        "reduceTime": "Reducir el tiempo de contratación para candidatos internacionales",
        "streamlineCompliance": "Optimizar procesos de cumplimiento y visados",
        "trackRoi": "Rastrear y medir el ROI de la movilidad"
      },
      "hiringTimeframes": {
        "immediate": "Inmediato — listo para comenzar ahora",
        "long": "A largo plazo (6–12 meses)",
        "medium": "A medio plazo (3–6 meses)",
        "short": "A corto plazo (1–3 meses)"
      },
      "maturity": {
        "established": "Programa establecido — función de movilidad madura",
        "firstTime": "Primera vez — nuevo en contratación internacional",
        "someExperience": "Algo de experiencia — he realizado algunas reubicaciones"
      },
      "personalInfo": {
        "addressDetailsError": "Error al obtener los detalles de la dirección. Por favor, intenta de nuevo.",
        "addressHint": "Selecciona tu dirección de las sugerencias",
        "addressPlaceholder": "Empieza a escribir tu dirección...",
        "addressSearchError": "Error al buscar direcciones. Por favor, inténtalo de nuevo.",
        "loadingAddressDetails": "Cargando detalles de la dirección...",
        "searchAddress": "Buscar dirección",
        "searchAddressDescription": "Escribe tu dirección y selecciona de las sugerencias de Google Places"
      },
      "saving": "Guardando...",
      "step": "Paso",
      "workArrangements": {
        "flexible": "Flexible",
        "hybrid": "Híbrido",
        "onsite": "En sitio"
      }
    },
    "pipelinePage": {
      "activeTab": "Activo",
      "addTalents": "Añadir talentos",
      "allCohorts": "Todos los cohortes",
      "allPrograms": "Todos los programas",
      "archivedSubtitle": "Candidatos cuyos viajes han terminado — cuentas archivadas por el administrador o eliminadas por sí mismos",
      "archivedTab": "Archivado",
      "avgIQulture": "Prom. iQulture",
      "bucketAcquisition": "Adquisición",
      "bucketAcquisitionDescription": "Suministrado / Importado",
      "bucketSponsored": "Patrocinado",
      "bucketSponsoredDescription": "Movilidad · Adaptación · Care",
      "bucketVetting": "Evaluación",
      "bucketVettingDescription": "CheckUp en progreso",
      "clearAll": "Limpiar todo",
      "cohort": "Cohorte",
      "description": "Cada talento desde el primer contacto hasta el patrocinio, etapa a etapa",
      "filters": "Filtros",
      "formerCandidate": "Ex-candidato",
      "inPipeline": "En proceso",
      "needAttention": "Necesita atención",
      "noCohortFound": "No se encontró ninguna cohorte",
      "noProgramFound": "No se encontró ningún programa",
      "onTrack": "En progreso",
      "pipelineView": "Vista del pipeline",
      "scrollNext": "Columna siguiente",
      "scrollPrev": "Columna anterior",
      "program": "Programa",
      "searchCohorts": "Buscar cohortes",
      "searchPlaceholder": "Introduce búsqueda...",
      "searchPrograms": "Buscar programas",
      "status": "Estado",
      "statusAtRisk": "En riesgo",
      "statusBlocked": "Bloqueado",
      "statusCompleted": "Completado",
      "statusOnTrack": "En progreso",
      "title": "Pipeline",
      "bulkBarAria": "Acciones masivas para talentos seleccionados",
      "bulkAddToCohort": "Agregar a cohorte",
      "bulkAddToCohortFailed": "Error al asignar talentos seleccionados",
      "bulkAddToCohortPartial": "{{added}} asignados a la cohorte · {{skipped}} no se pudieron asignar",
      "cardTag": "Etiqueta de la tarjeta",
      "selectWholeColumn": "Seleccionar toda la columna",
      "talentsInPipeline_one": "{{count}} talento en el pipeline",
      "talentsInPipeline_other": "{{count}} talentos en el pipeline",
      "bulkAddToCohortSuccess_one": "{{count}} talento asignado a la cohorte",
      "bulkAddToCohortSuccess_other": "{{count}} talentos asignados a la cohorte",
      "searchLabel": "Buscar talentos"
    },
    "vettingCard": {
      "acceptedAgo": "Aceptado {{when}}",
      "checkupProgress": "CheckUp {{percent}}% · {{done}} de {{total}} pasos",
      "iqultureProgress": "iQulture {{percent}}%",
      "lastSeenAgo": "Última vez visto {{when}}",
      "missingSteps": "Faltante: {{steps}}",
      "notYetActive": "Aún no activo",
      "startedAgo": "Iniciado {{when}}",
      "stateAwaitingScore": "Calculando iQulture…",
      "stateNotStarted": "No iniciado",
      "step": {
        "assistantChat": "Chat de asistente",
        "languageTests": "Pruebas de idioma",
        "motivationalAnswers": "Motivación",
        "pitchVideo": "Video de presentación",
        "videosWatched": "Ver videos"
      },
      "submittedAgo": "Enviado {{when}}",
      "testitComplete": "TestIt completado",
      "testitInvited": "TestIt invitado",
      "testitProgress": "TestIt · {{done}}/{{total}}",
      "scoredAgo": "Puntuado {{when}}",
      "completedAgo": "Completado {{when}}",
      "sharingWithdrawnAgo": "Dejó de compartir {{when}}"
    },
    "pipelineView": {
      "activateAgain": "Activar de nuevo",
      "addTalentsCta": "Añadir talentos",
      "archive": "Archivar",
      "archiveSponsoredConfirmDescription": "Esto archiva el viaje patrocinado de {{name}}: la tarjeta sale de tu pipeline y {{name}} pierde el acceso a esta oportunidad. Los resultados de CheckUp y la historia del viaje se conservan por cumplimiento. Puedes restaurarlo desde la pestaña Archivados.",
      "archiveSponsoredConfirmTitle": "Archivar talento patrocinado",
      "archiving": "Archivando…",
      "askForCheckup": "Invitar a CheckUp completo",
      "askForTestit": "Invitar a pruebas específicas",
      "bulkArchiveCta": "Archivar {{count}}",
      "bulkArchiveFailed": "No se pudo archivar talentos",
      "bulkArchivePartial": "{{archived}} archivados · {{failed}} fallidos",
      "bulkClear": "Limpiar",
      "bulkSendConfirmCta": "Enviar invitaciones",
      "bulkSendConfirmTitle": "Enviar invitaciones a Verificación",
      "bulkSendPartial": "{{sent}} enviados · {{failed}} fallidos",
      "bulkSending": "Enviando…",
      "bulkSendingProgress": "Enviando invitaciones… {{sent}}/{{total}}",
      "bulkSponsorCta": "Patrocinar {{count}}",
      "bulkSponsorFailed": "No se pudo patrocinar talentos",
      "bulkSponsorPartial": "{{sponsored}} patrocinados · {{failed}} fallidos",
      "citizenLeft": "Candidato dejó la plataforma",
      "citizenLeftTooltip": "Este candidato eliminó su cuenta de Tonnie. Su viaje se conserva para auditoría; los detalles identificativos están redactados.",
      "clearSearch": "Limpiar filtro",
      "delete": "Eliminar",
      "deleteConfirmDescription": "Esto eliminará permanentemente a {{name}} y todo el historial de importación (eventos de tubería, viajes, mensajes). Esta acción no se puede deshacer.",
      "deleteConfirmTitle": "Eliminar talento",
      "deleteInvitationConfirmDescription": "Esto eliminará permanentemente la invitación para {{name}}. No podrán aceptar el enlace del correo electrónico. Esta acción no se puede deshacer.",
      "deleteInvitationConfirmTitle": "Eliminar invitación",
      "deleteInvitationFailed": "Error al eliminar la invitación",
      "deleteInvitationSuccess": "Invitación eliminada",
      "deleting": "Eliminando…",
      "dragNotAllowed": "No se puede mover de {{from}} a {{to}} — usa el menú kebab para la acción correcta",
      "imported": "Importado {{when}}",
      "invitationDeleteFailed": "No se pudo eliminar la invitación",
      "invitationDeleted": "Invitación de {{name}} eliminada",
      "invitationResendFailed": "No se pudo reenviar",
      "invitationResent": "Invitación reenviada",
      "invitationRevokeFailed": "No se pudo revocar",
      "invitationRevoked": "Invitación revocada",
      "invitationSendFailed": "No se pudo enviar la invitación",
      "invitationSent": "Invitación enviada",
      "invitationSentHint": "{{name}} recibirá el correo electrónico y la tarjeta se mueve a Evaluación.",
      "inviteToVetting": "Invitar a Evaluación",
      "noMatches": "No hay coincidencias para \"{{query}}\"",
      "noTalentsInStage": "No hay talentos en esta etapa",
      "removeFromPipeline": "Eliminar del pipeline",
      "removeVettingConfirmDescription": "Esto retira a {{name}} de tu pipeline y {{name}} pierde el acceso a esta oportunidad. Sus datos de CheckUp y su historia se conservan por cumplimiento. Puedes restaurarlo desde la pestaña Archivados.",
      "removeVettingConfirmTitle": "Eliminar talento del pipeline",
      "invitationEmailNotSent": "La invitación quedó guardada, pero no se pudo enviar el correo",
      "resendInvitationFailed": "Error al reenviar la invitación",
      "resendInvitationSuccess": "Invitación reenviada",
      "revokeInvitationFailed": "Error al revocar la invitación",
      "revokeInvitationSuccess": "Invitación revocada",
      "searchPlaceholder": "Filtrar nombre, correo electrónico, rol…",
      "selectAllCount": "Seleccionar todo ({{selected}}/{{total}})",
      "selectAllMatching": "Seleccionar todo lo que coincide ({{visible}})",
      "statusArchived": "Archivado",
      "stageStatus": {
        "onTrack": "En camino",
        "blocked": "Bloqueado",
        "atRisk": "En riesgo",
        "completed": "Completado"
      },
      "statusAwaitingAcceptance": "Esperando aceptación",
      "statusDraft": "Borrador",
      "subStage": {
        "mobility": "Movilidad",
        "adaptation": "Adaptación",
        "care": "Care",
        "evidence": "Evidencia"
      },
      "talentArchiveFailed": "Error al archivar talento",
      "talentArchived": "{{name}} archivado",
      "talentDeleteFailed": "Error al eliminar talento",
      "talentDeleted": "{{name}} ha sido eliminado",
      "talentSponsored": "¡Talento patrocinado! Instancia de viaje creada con ruta {{origin}} → {{destination}}",
      "talentSponsoredFailed": "Error al patrocinar talento",
      "unarchiveFailed": "Error al restaurar talento",
      "unarchiveSuccess": "Talento restaurado — viaje activo nuevamente",
      "updated": "Actualizado {{when}}",
      "selectCandidate": "Seleccionar candidato",
      "signedUpNotAccepted": "Se registró, no aceptó",
      "signedUpNotAcceptedTooltip": "Esta persona ya tiene cuenta en Tonnie pero no ha aceptado tu invitación. Reenviarla tiene muchas probabilidades de llegarle. Su viaje y su CheckUp siguen siendo privados hasta que acepte.",
      "tag": {
        "inviteProblem": "Problema con la invitación",
        "onboardingIncomplete": "Completando perfil",
        "waitingForCheckup": "Esperando CheckUp",
        "checkupInProgress": "CheckUp en curso",
        "awaitingScore": "Calculando puntuación",
        "awaitingReview": "Listo para revisar",
        "testitPending": "Pruebas pendientes",
        "testitComplete": "Pruebas completadas",
        "testitPassed": "Aprobado",
        "testitDeclined": "Rechazado",
        "checkupNotRequested": "CheckUp no solicitado",
        "inviteDeclined": "Rechazó",
        "inviteExpired": "Invitación caducada",
        "sponsorshipOffered": "Patrocinio ofrecido",
        "checkupWithheld": "A la espera del consentimiento del talento",
        "consentWithdrawn": "Dejó de compartir"
      },
      "since": {
        "delivered": "Entregado {{when}}",
        "opened": "Abierto {{when}}",
        "landed": "Accedió a la página {{when}}",
        "bounced": "Rechazado {{when}}",
        "sent": "Invitado {{when}}",
        "signedUp": "Se registró {{when}}",
        "asked": "Solicitado {{when}}",
        "expired": "Caducó {{when}}"
      },
      "alreadyArchived": "Este talento ya estaba archivado. El tablero está actualizado.",
      "alreadyRestored": "Este recorrido ya se había restaurado. El tablero está actualizado.",
      "invitationAlreadyAccepted": "Esta invitación ya se ha aceptado.",
      "bulkArchiveConfirmTitle_one": "Archivar {{count}} talento",
      "bulkArchiveConfirmTitle_other": "Archivar {{count}} talentos",
      "bulkArchiveConfirmCta_one": "Archivar {{count}} talento",
      "bulkArchiveConfirmCta_other": "Archivar {{count}} talentos",
      "bulkArchiveConfirmDescription_one": "{{count}} talento saldrá de tu pipeline activo. Sus resultados de CheckUp y la historia del viaje se conservan por cumplimiento. Puedes restaurarlo desde la pestaña Archivados.",
      "bulkArchiveConfirmDescription_other": "{{count}} talentos saldrán de tu pipeline activo. Sus resultados de CheckUp y la historia del viaje se conservan por cumplimiento. Puedes restaurarlos desde la pestaña Archivados.",
      "bulkArchiveSuccess_one": "{{count}} talento archivado",
      "bulkArchiveSuccess_other": "{{count}} talentos archivados",
      "atRiskCount_one": "{{count}} en riesgo",
      "atRiskCount_other": "{{count}} en riesgo",
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "bulkSelectedCount_one": "{{count}} seleccionado",
      "bulkSelectedCount_other": "{{count}} seleccionados",
      "bulkSendCta_one": "Enviar {{count}} invitación a Vetting",
      "bulkSendCta_other": "Enviar {{count}} invitaciones a Vetting",
      "searchLabel": "Filtrar talentos en {{stage}}",
      "declinedWhen": "Rechazó {{when}}",
      "expiredWhen": "Caducó {{when}}",
      "invitationSentAgain": "Invitación enviada de nuevo",
      "leftProgramme": "Salió del programa · {{date}}",
      "leftProgrammeTooltip": "Este talento salió de tu programa, lo que terminó la relación. Ya no ves lo que compartió. Envíale una nueva invitación para volver a trabajar con él.",
      "restoreRefusedLeft": "Este talento salió de tu programa. Envíale una nueva invitación para volver a trabajar con él.",
      "resendInvitationMessageMismatch": "El mensaje de esta invitación se escribió para otra solicitud. Envíala de nuevo desde el diálogo de invitación para escribir su mensaje."
    },
    "pool": {
      "smartSearch": {
        "downloadCv": "Descargar CV",
        "cvUnavailable": "CV no disponible",
        "selectCandidate": "Seleccionar candidato",
        "clearSelection": "Limpiar",
        "bulkAddTitle": "Añadir a adquisición",
        "stepReview": "Revisar y ordenar",
        "how1": "Pega una o más descripciones de puesto.",
        "how2": "La IA extrae las competencias, la seniority y el enfoque.",
        "how3": "Ordenamos tu Pool de Talento por idoneidad.",
        "extracting": "Leyendo la descripción del puesto…",
        "extractError": "No pudimos analizar esa descripción de puesto. Inténtalo de nuevo.",
        "skillsTitle": "Competencias encontradas",
        "skillsHint": "Elimina las que no encajen o añade las tuyas: la clasificación se actualiza al instante.",
        "ranking": "Ordenando…",
        "noSkills": "No se extrajeron competencias",
        "noSkillsHint": "Añade abajo las competencias clave para este puesto.",
        "addSkillPlaceholder": "Añadir una competencia…",
        "viewResults": "Ver resultados ordenados",
        "rankedTitle": "Pool ordenado por idoneidad al puesto",
        "rankedForTitle": "Ordenado para {{title}}",
        "clear": "Limpiar",
        "nSelected_one": "{{count}} seleccionado",
        "nSelected_other": "{{count}} seleccionados",
        "addNToAcquisition_one": "Añadir {{count}} a adquisición",
        "addNToAcquisition_other": "Añadir {{count}} a adquisición",
        "bulkAddDesc_one": "Añade {{count}} candidato seleccionado a la etapa de Adquisición de tu pipeline.",
        "bulkAddDesc_other": "Añade {{count}} candidatos seleccionados a la etapa de Adquisición de tu pipeline.",
        "bulkAdded_one": "{{count}} añadido a adquisición",
        "bulkAdded_other": "{{count}} añadidos a adquisición",
        "bulkFailed_one": "{{count}} no se pudo añadir",
        "bulkFailed_other": "{{count}} no se pudieron añadir",
        "analyzing_one": "Analizando {{count}} descripción de puesto…",
        "analyzing_other": "Analizando {{count}} descripciones de puesto…",
        "resultsFound_one": "{{count}} candidato coincide",
        "resultsFound_other": "{{count}} candidatos coinciden",
        "bulkDuplicates_one": "{{count}} ya está en esta cohorte",
        "bulkDuplicates_other": "{{count}} ya están en esta cohorte",
        "addSkillLabel": "Añadir una competencia"
      },
      "matchReason": {
        "mustHaves": "Imprescindibles: {{met}}/{{total}}",
        "seniority": "Seniority {{level}}",
        "semantic": "{{score}}% de coincidencia de perfil",
        "skills": "{{count}}/{{total}} competencias: {{skills}}",
        "readiness": "Preparación {{score}}",
        "location": "En {{location}}",
        "niceToHaves_one": "+{{count}} deseable",
        "niceToHaves_other": "+{{count}} deseables"
      },
      "savedSearch": {
        "title": "Búsquedas guardadas",
        "savedCount": "Guardadas ({{count}})",
        "save": "Guardar",
        "saved": "Búsqueda guardada",
        "saveFailed": "No se pudo guardar la búsqueda",
        "delete": "Eliminar búsqueda guardada",
        "deleteFailed": "No se pudo eliminar la búsqueda",
        "noSkills": "Sin competencias",
        "saveTitle": "Guardar esta búsqueda",
        "saveDesc": "Ponle un nombre para volver a ejecutar esta búsqueda por descripción de puesto más tarde.",
        "nameLabel": "Nombre",
        "namePlaceholder": "p. ej., Ingeniero Backend Senior",
        "errors": {
          "name": "El nombre es obligatorio"
        }
      },
      "detail": {
        "unavailable": "Candidato no disponible",
        "unavailableHint": "Este candidato ya no está en el pool.",
        "curriculum": "Currículum",
        "openCv": "Abrir en pestaña nueva",
        "noCv": "Sin CV disponible",
        "noCvHint": "Este candidato aún no ha adjuntado un CV.",
        "experience": "Experiencia",
        "seniority": "Nivel",
        "origin": "Origen",
        "inPoolSince": "En el pool desde",
        "languages": "Idiomas",
        "linkedin": "Perfil de LinkedIn",
        "availOpen": "Abierto a ofertas",
        "availConsideration": "En consideración",
        "availUnavailable": "No disponible",
        "experienceValue_one": "{{count}} año",
        "experienceValue_other": "{{count}} años"
      },
      "view": {
        "cards": "Tarjetas",
        "list": "Lista"
      },
      "advancedSearch": {
        "addAtLeastOneJob": "Por favor, añade al menos una descripción de trabajo",
        "addedSuccessfully": "Añadido con éxito",
        "enterJobDescription": "Por favor, introduce una descripción de trabajo o URL",
        "stepInput": "Entrada",
        "titleAi": "Búsqueda de talento impulsada por IA",
        "subtitle": "Extrae habilidades de descripciones de trabajo y encuentra candidatos coincidentes",
        "jobDescriptionN": "Descripción del trabajo {{count}}",
        "jobPlaceholder": "Pega una descripción de trabajo aquí...\n\nEjemplo: Estamos buscando un Ingeniero de Software Senior con más de 5 años de experiencia en React, TypeScript y Node.js...",
        "addToList": "Agregar a la lista",
        "emptyTitle": "Aún no hay descripciones de trabajo",
        "emptyHint": "Agrega descripciones de trabajo para extraer palabras clave",
        "jobN": "Trabajo {{count}}",
        "howItWorks": "Cómo funciona",
        "extractBtn": "Extraer palabras clave",
        "jobsAdded_one": "{{count}} descripción de puesto añadida",
        "jobsAdded_other": "{{count}} descripciones de trabajo añadidas",
        "wordCount_one": "{{count}} palabra",
        "wordCount_other": "{{count}} palabras",
        "jobDescriptionLabel": "Descripción de trabajo"
      },
      "startAdvancedSearch": "Iniciar búsqueda avanzada",
      "addToPipeline": "Añadir al pipeline",
      "searching": "Buscando en el Talent Pool…",
      "talentCard": {
        "noCheckup": "Sin CheckUp aún",
        "preVetted": "Tonnie pre-certificado",
        "inPipeline": "En proceso",
        "whyMatched": "Por qué coinciden:",
        "iqultureScore": "Puntuación de iQulture",
        "skills": "Habilidades",
        "added": "Añadido",
        "addToVet": "Añadir a vet",
        "matchPercent": "{{score}}% de coincidencia",
        "top": "MÁS ALTO",
        "moreCount_one": "+{{count}} más",
        "moreCount_other": "+{{count}} más"
      },
      "nSelected_one": "{{count}} seleccionado",
      "nSelected_other": "{{count}} seleccionados",
      "talentsFound_one": "{{count}} talento encontrado",
      "talentsFound_other": "{{count}} talentos encontrados"
    },
    "poolImport": {
      "errors": {
        "country": "El país debe ser un código de 3 letras",
        "email": "Correo electrónico no válido",
        "empty": "No hay filas para importar",
        "tooMany": "Demasiadas filas (máx. 1000)"
      },
      "failed": "Importación fallida",
      "placeholder": "Pega CSV o TSV con una fila de encabezado: email, nombre, apellido, título del trabajo, país, ciudad, habilidades",
      "subtitle": "Pega candidatos seleccionados para añadirlos al Talent Pool público. Los perfiles existentes se actualizan.",
      "success": "Importado: {{created}} creados, {{updated}} actualizados",
      "title": "Importar perfiles",
      "import_one": "Importar {{count}} perfil",
      "import_other": "Importar {{count}} perfiles",
      "parsedCount_one": "{{count}} fila válida lista para importar",
      "parsedCount_other": "{{count}} filas válidas listas para importar"
    },
    "poolPage": {
      "addToVettingDesc": "Añadir {{name}} a tu pipeline de evaluación",
      "addToVettingPipeline": "Añadir al pipeline de evaluación",
      "advancedSearch": "Búsqueda avanzada",
      "advancedSearchDesc": "Encuentra talentos que encajan con una descripción de puesto",
      "alphabetical": "Alfabético",
      "alreadyInPipeline": "Ya en el pipeline",
      "available": "Disponible",
      "description": "Busca talentos que han elegido ser encontrados",
      "failedToAdd": "Error al añadir",
      "inPipeline": "En proceso",
      "iqultureHighToLow": "iQulture alto a bajo",
      "iqultureLowToHigh": "iQulture bajo a alto",
      "iqultureScore": "Puntuación de iQulture",
      "location": "Ubicación",
      "noCohortsYet": "Aún no hay cohortes: crea una para añadir talentos a tu pipeline.",
      "noLocationsFound": "No se encontraron ubicaciones",
      "noRolesFound": "No se encontraron roles",
      "noSkillsFound": "No se encontraron habilidades",
      "noTalentsFound": "No se encontraron talentos",
      "relevance": "Relevancia",
      "role": "Rol",
      "searchError": "La búsqueda falló",
      "searchErrorHint": "Algo salió mal al cargar los talentos. Inténtalo de nuevo.",
      "searchLocations": "Buscar ubicaciones",
      "searchPlaceholder": "Introduce búsqueda...",
      "searchRoles": "Buscar roles",
      "searchSkills": "Buscar habilidades",
      "selectACohort": "Seleccionar una cohorte",
      "selectCohort": "Seleccionar cohorte",
      "selectLocations": "Seleccionar ubicaciones",
      "selectRoles": "Seleccionar roles",
      "selectSkills": "Seleccionar habilidades",
      "skills": "Habilidades",
      "sortBy": "Ordenar Por",
      "talentAdded": "{{name}} añadido al pipeline",
      "title": "Grupo",
      "tryAdjustingFilters": "Intenta ajustar filtros",
      "upgradeDescription": "Busca y añade talentos prevalidados del Tonnie Talent Pool directamente a tu pipeline.",
      "results": "Resultados",
      "bestMatch": "Mejor coincidencia",
      "lowestMatch": "Menor coincidencia",
      "searchLabel": "Buscar talentos"
    },
    "profile": {
      "accountDescription": "Detalles sobre tu cuenta que no se pueden cambiar aquí.",
      "accountTitle": "Cuenta",
      "avatarDescription": "Mostrado en el menú superior derecho y en toda la plataforma.",
      "avatarHelper": "PNG, JPG o GIF de hasta 5 MB. Arrastra y suelta, o haz clic para buscar.",
      "avatarRemoveConfirm": "Tu foto de perfil será reemplazada por tus iniciales. Puedes subir una nueva en cualquier momento.",
      "avatarRemoveConfirmAction": "Eliminar foto",
      "avatarRemoveFailed": "No se pudo eliminar la foto. Por favor, intenta de nuevo.",
      "avatarRemoveTitle": "¿Eliminar foto de perfil?",
      "avatarRemoved": "Foto eliminada",
      "avatarTitle": "Foto de perfil",
      "avatarTooLarge": "La foto es demasiado grande. Máx. 5 MB.",
      "avatarUploadFailed": "Error al subir la foto. Por favor, inténtalo de nuevo.",
      "avatarUploaded": "Foto actualizada",
      "avatarWrongType": "Solo se admiten archivos de imagen.",
      "changeAvatar": "Cambiar foto de perfil",
      "description": "Gestiona tu información personal, avatar y detalles de la cuenta.",
      "email": "Correo electrónico",
      "emailManagedByClerk": "Gestionado a través de inicio de sesión",
      "firstName": "Nombre",
      "lastName": "Apellido",
      "memberSince": "Miembro desde",
      "nameDescription": "Cómo aparece tu nombre en toda la plataforma.",
      "nameTitle": "Tu nombre",
      "remove": "Eliminar",
      "role": "Rol",
      "roleDescription": "Establecido por el administrador de tu organización.",
      "saveChanges": "Guardar cambios",
      "saveFailed": "No se pudieron guardar los cambios. Por favor, intenta de nuevo.",
      "saved": "Perfil actualizado",
      "title": "Perfil",
      "uploadPhoto": "Subir foto"
    },
    "programs": {
      "activePrograms": "Programas en curso",
      "adjustFilters": "Ajustar filtros",
      "allCohorts": "Todos los cohortes",
      "allStatus": "Todo estado",
      "askCoPilot": "Preguntar a CoPilot",
      "avgProgress": "Promedio de progreso",
      "backToPrograms": "Volver a programas",
      "care": "Care",
      "careRequiresEnterprise": "Care requiere empresa",
      "careSettingsReset": "Restablecimiento de configuración de Care",
      "cohorts": "Cohortes",
      "createCohort": "Crear cohorte",
      "createDialogDescription": "Un programa es la capa organizativa de nivel superior para los talentos que patrocinas o invitas. Las cohortes y los viajes viven dentro de él.",
      "createFirstProgram": "Crear primer programa",
      "createNewProgram": "Crear nuevo programa",
      "createProgram": "Crear programa",
      "created": "Creado",
      "description": "Tus programas de reubicación y las cohortes que incluyen",
      "descriptionLabel": "Descripción",
      "descriptionPlaceholder": "Introduce la descripción...",
      "editDialogDescription": "Actualiza los detalles del programa a continuación.",
      "editProgram": "Editar programa",
      "filterByStatus": "Filtrar por estado",
      "getMoreInsights": "Obtener más información",
      "insightPassRate": "Tasa de aprobación",
      "insights": "Perspectivas",
      "insightsDescription": "Cómo avanza este programa",
      "iqulture": "iQulture",
      "latestUpdates": "Últimas actualizaciones",
      "manageCohorts": "Gestionar cohortes",
      "noProgramsFound": "No se encontraron programas",
      "notFound": "Programa no encontrado",
      "notFoundDesc": "Este programa no existe o ha sido eliminado. Intenta volver a la lista de programas.",
      "overview": "Resumen",
      "pauseProgram": "Pausar programa",
      "programCreated": "Programa creado",
      "programNameLabel": "Nombre del programa",
      "programNamePlaceholder": "Introduce el nombre del programa...",
      "programPaused": "Programa pausado",
      "programResumed": "Programa reanudado",
      "programUpdated": "Programa actualizado",
      "progress": "Progreso",
      "progressLabel": "Progreso",
      "recentActivity": "Actividad reciente",
      "resumeProgram": "Reanudar programa",
      "searchPrograms": "Buscar programas",
      "stability": "Estabilidad",
      "stabilityValue": "{{value}}% de estabilidad",
      "statusChangeFailed": "Error al cambiar el estado del programa",
      "talents": "Talentos",
      "title": "Programas",
      "totalCohorts": "Total de cohortes",
      "totalTalents": "Total de talentos",
      "viewDetails": "Ver detalles",
      "whatHappensNext": "Qué sucede a continuación",
      "whatHappensNextDescription": "Serás llevado a la página de detalles del programa donde podrás crear cohortes, invitar talentos y rastrear su viaje a través de las fases de Evaluación y Patrocinado.",
      "errors": {
        "nameRequired": "Se requiere el nombre del programa",
        "nameTooLong": "El nombre del programa debe tener 200 caracteres o menos",
        "descriptionTooLong": "La descripción debe tener 2000 caracteres o menos",
        "planLimit": "El plan gratuito permite 1 programa activo. Actualiza a Enterprise para programas ilimitados.",
        "createFailed": "Error al crear el programa"
      },
      "programActionsAria": "Acciones para {{name}}",
      "updateFailed": "Error al actualizar el programa",
      "archiveSuccess": "{{name}} se movió a archivado.",
      "archiveFailed": "Error al archivar el programa",
      "restoreSuccess": "{{name}} restaurado.",
      "restoreFailed": "Error al restaurar el programa",
      "activeTab": "Activo",
      "archivedTab": "Archivado",
      "viewInPipeline": "Ver talentos en el Pipeline",
      "archive": "Archivar",
      "restore": "Restaurar",
      "archiveConfirmTitle": "¿Archivar el programa?",
      "archiveConfirmDescription": "{{name}} se mueve a la pestaña Archivado. Cada cohorte activa bajo este programa también se archiva. Restaurar el programa más tarde NO restaura automáticamente las cohortes; debes reactivarlas individualmente desde la pestaña de Cohortes Archivadas.",
      "insightCareGap": "Talentos patrocinados pero sin puntos de contacto activos de Care — verifica la cadencia de registro.",
      "cohortScopeAria": "Alcance de la cohorte",
      "cohortsEmptyActive": "No hay cohortes activas en este programa aún. Crea una para empezar a invitar talentos.",
      "cohortsEmptyArchived": "No hay cohortes archivadas. Las cohortes que archivas — o que fueron archivadas en cascada con el programa — aparecerán aquí.",
      "cohortCreated": "Cohorte creada.",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos",
      "archiveSuccessWithCascade_one": "{{base}} {{count}} cohorte se archivó con él.",
      "archiveSuccessWithCascade_other": "{{base}} {{count}} cohortes se archivaron con él.",
      "restoreSuccessWithCohorts_one": "{{base}} {{count}} cohorte sigue archivada — restáurala desde la pestaña Cohortes.",
      "restoreSuccessWithCohorts_other": "{{base}} {{count}} cohortes siguen archivadas — restáuralas desde la pestaña Cohortes."
    },
    "sendToVetting": {
      "assessmentIntroTalent": "Estos talentos ya tienen un viaje con esta empresa, así que solo la evaluación es nueva — su destino no cambia.",
      "back": "Atrás",
      "branchCustom": "Destino personalizado…",
      "branchLabel": "Sucursal / oficina",
      "branchPlaceholder": "Elige una sucursal o introduce un destino personalizado",
      "bulkSendingProgress": "Enviando invitaciones… {{sent}}/{{total}}",
      "bulkTitle": "Enviar invitaciones a Verificación",
      "customizeToggle": "Personalizar mensaje",
      "description": "Crearemos un andamiaje de viaje CheckUp gratuito y enviaremos un correo electrónico al candidato. Puedes patrocinar el viaje completo más tarde si decides hacerlo.",
      "descriptionTestit": "Crearemos un esqueleto de trayecto gratuito para las pruebas específicas que elijas y enviaremos un correo al candidato. Sus resultados son reutilizables.",
      "destinationLabel": "País de destino",
      "destinationPlaceholder": "¿Dónde estarán trabajando?",
      "destinationSettingsLink": "Ajustes de la empresa",
      "destinationSource": "Desde los ajustes de la empresa (sede y sucursales).",
      "destinationUnset": "Sin sede ni sucursal en Ajustes — elige una para este lote, o añádela una vez en Ajustes.",
      "failed": "No se pudo enviar la invitación. Por favor, inténtalo de nuevo.",
      "freeCheckUpHint": "Sin cargo hasta que decidas patrocinar el viaje. El candidato recibe el CheckUp y tú ves sus resultados de MESH + iQulture en la evaluación.",
      "freeCheckUpTitle": "CheckUp gratuito · Patrocina más tarde si lo deseas",
      "freeTestitHint": "Sin coste: el candidato completa solo las pruebas que elijas, y los resultados pueden reutilizarse para futuras oportunidades. Los ves en Evaluación.",
      "freeTestitTitle": "Gratis · resultados reutilizables",
      "next": "Siguiente",
      "opportunityIntro": "Elige qué completa el candidato y dónde está el puesto.",
      "outcomeAwaiting": "Permanecen en Adquisición hasta que acepten.",
      "outcomeMixed": "{{moved}} pasaron a Evaluación · {{awaiting}} pendientes de aceptación.",
      "partial": "{{sent}} enviados · {{failed}} fallidos",
      "reviewAssessment": "Completarán",
      "reviewDestination": "Destino",
      "reviewEmailHint": "Esto es lo que llega a su bandeja de entrada.",
      "reviewRecipients": "Destinatarios",
      "sending": "Enviando…",
      "singleCta": "Enviar invitación",
      "singleSuccess": "Invitación enviada a {{name}}",
      "singleTitle": "Enviar invitación a {{name}}",
      "stepMessage": "Mensaje",
      "stepOf": "Paso {{current}} de {{total}}",
      "stepOpportunity": "Evaluación",
      "stepReview": "Revisar y enviar",
      "workLocationLabel": "Ubicación de trabajo",
      "workLocationPlaceholder": "Ciudad, oficina o remoto",
      "bulkCta_one": "Enviar {{count}} invitación",
      "bulkCta_other": "Enviar {{count}} invitaciones",
      "bulkRecipientCount_one": "{{count}} candidato",
      "bulkRecipientCount_other": "{{count}} candidatos",
      "bulkSuccess_one": "{{count}} invitación enviada",
      "bulkSuccess_other": "{{count}} invitaciones enviadas",
      "outcomeRequested_one": "Se le pidió que comparta más; nada cambia hasta que responda.",
      "outcomeRequested_other": "Se pidió a {{count}} que compartan más; nada cambia hasta que respondan.",
      "outcomeMoved_one": "Pasó a Evaluación.",
      "outcomeMoved_other": "{{count}} pasaron a Evaluación.",
      "reviewAskNotice_one": "Este talento ya trabaja contigo, así que recibe el mensaje que corresponde a su situación: una solicitud para compartir lo que ya tiene, o un recordatorio de lo que falta por hacer.",
      "reviewAskNotice_other": "Estos {{count}} talentos ya trabajan contigo, así que cada uno recibe el mensaje que corresponde a su situación: una solicitud para compartir lo que ya tiene, o un recordatorio de lo que falta por hacer."
    },
    "settings": {
      "customModeActiveDesc": "El modo personalizado está activo. Personaliza tus colores en la pestaña Colores y sube activos en la pestaña Activos.",
      "draftSaved": "Borrador guardado con éxito!",
      "fileSizeError": "El tamaño del archivo debe ser menor de 2MB",
      "invalidFileFormat": "Formato de archivo no válido. Por favor, utiliza PNG, JPG o SVG",
      "itemRemoved": "{{title}} eliminado",
      "themeActivated": "¡Tema activado con éxito! Cambiado a modo personalizado.",
      "uploadSuccess": "{{type}} subido con éxito!"
    },
    "shared": {
      "noPhoneCodeFound": "No se encontró ningún código telefónico.",
      "searchPhoneCode": "Buscar código telefónico..."
    },
    "shell": {
      "viewportGuard": {
        "description": "Esta aplicación está optimizada para pantallas de escritorio. Por favor, utiliza un dispositivo con una pantalla más grande para la mejor experiencia.",
        "hint": "Ancho mínimo de pantalla: 1024px",
        "title": "Se requiere escritorio"
      }
    },
    "theme": {
      "configure": "Configurar",
      "custom": "Personalizado",
      "dark": "Oscuro",
      "light": "Ligero",
      "system": "Sistema",
      "theme": "Tema"
    },
    "userMenu": {
      "billing": "Facturación",
      "logout": "Cerrar sesión",
      "preferences": "Preferencias",
      "profile": "Perfil",
      "roleAdmin": "Admin",
      "roleMember": "Miembro del equipo"
    },
    "vetting": {
      "adjustFilters": "Ajustar filtros",
      "allBadges": "Todas las insignias",
      "allCohorts": "Todos los cohortes",
      "allStatus": "Todo estado",
      "allTalents": "Todos los talentos",
      "analytics": "Analíticas",
      "avgIQulture": "Prom. iQulture",
      "badgeDistribution": "Distribución de insignias",
      "badgeDistributionDesc": "Cuántos talentos tienen cada insignia iQulture",
      "byCohort": "Por cohorte",
      "checkUpCompleted": "CheckUp completado",
      "clearFilters": "Limpiar filtros",
      "description": "Evalúa a los talentos con el CheckUp antes de patrocinarlos",
      "explain": "Explicar",
      "explainAria": "Explicar el resultado de {{name}} con CoPilot",
      "openTalentAria": "Abrir perfil de talento para {{name}}",
      "percentDone": "{{value}}% completado",
      "insightBodies": {
        "proInsightBody_one": "{{count}} talento obtuvo un 80% o más en iQulture: una preparación excepcional para la movilidad internacional.",
        "proInsightBody_other": "{{count}} talentos obtuvieron un 80% o más en iQulture, indicando una preparación excepcional para la movilidad internacional.",
        "potentialInsightBody_one": "{{count}} talento muestra un gran potencial. Considera QultureUp para subir su puntuación.",
        "potentialInsightBody_other": "{{count}} talentos muestran un gran potencial. Considera QultureUp para aumentar sus puntuaciones.",
        "pendingInsightBody_one": "{{count}} talento aún no ha completado el CheckUp. Envía un recordatorio para acelerar la selección.",
        "pendingInsightBody_other": "{{count}} talentos aún no han completado CheckUp. Envía recordatorios para acelerar la evaluación."
      },
      "sponsorAria": "Patrocinar a {{name}}",
      "filterByCohort": "Filtrar por cohorte",
      "inVetting": "En Evaluación",
      "iqultureAssessed": "iQulture evaluado",
      "iqultureBadge": "iQulture insignia",
      "loading": "Cargando…",
      "loadingDescription": "Cargando detalles del talento",
      "mesh": {
        "englishNative": "Inglés",
        "hardOther": "Habilidades técnicas",
        "motivation": "Motivación",
        "notScored": "Sin puntuar",
        "softCultural": "Habilidades blandas y cultura"
      },
      "noTalentsFound": "No se encontraron talentos",
      "noTalentsInVetting": "No hay talentos en evaluación",
      "noobOnly": "Solo novatos",
      "notFound": "Talento no encontrado",
      "notFoundDesc": "Este talento no existe o no tienes acceso para ver su registro.",
      "pendingAction": "Acción pendiente",
      "pendingCheckUp": "Pendiente CheckUp",
      "percentageReadyForMobility": "Porcentaje listo para movilidad",
      "potential": "Potencial",
      "potentialInsight": "Perspectiva de potencial",
      "potentialOnly": "Solo potencial",
      "proAndPotentialWithCheckUp": "Pro y potencial con CheckUp",
      "proBadges": "Insignias Pro",
      "proInsight": "Perspectiva Pro",
      "proOnly": "Solo Pro",
      "readyToSponsor": "Listo para patrocinar",
      "searchTalents": "Buscar talentos",
      "sponsor": "Patrocinador",
      "sponsorshipFunnel": "Embudo de patrocinio",
      "sponsorshipFunnelDesc": "De la invitación al patrocinio, etapa a etapa",
      "sponsorshipReadyRate": "Tasa de preparación para patrocinio",
      "statusCompleted": "Estado completado",
      "statusInProgress": "Estado en progreso",
      "statusLabel": "Estado",
      "statusPending": "Estado pendiente",
      "talentDetail": {
        "analysis": "Análisis",
        "archivedReadOnly": "Este viaje ya no está activo. El registro se conserva para auditoría; las acciones no están disponibles.",
        "exportCsv": "Exportar CSV",
        "exportFailed": "No se pudo exportar este informe. Inténtalo de nuevo.",
        "exportPdf": "Exportar PDF",
        "vettingCompleteReadOnly": "La evaluación está completa — este es un instantáneo de solo lectura de la evaluación.",
        "askCoPilot": "Preguntar CoPilot",
        "confidence": "Confianza",
        "copyEmail": "Copiar correo electrónico",
        "copyEmailSuccess": "Correo electrónico copiado al portapapeles",
        "culturalRiskAnalysis": "Análisis de riesgo cultural",
        "lowRiskCras": "CRAs de bajo riesgo",
        "moderateRiskCras": "CRAs de riesgo moderado",
        "highRiskCras": "CRAs de alto riesgo",
        "archetypesSeverityChip": "{{low}} bajo · {{moderate}} moderado · {{high}} alto",
        "topRisksTitle": "Principales riesgos culturales",
        "topRisksDescription": "Los arquetipos Tonnie señalados como el mayor riesgo de patrocinio para este candidato.",
        "topRisksEmpty": "No se han marcado arquetipos de alto riesgo.",
        "topRisks": {
          "severityShort": {
            "high": "Alto",
            "moderate": "Mod"
          },
          "a11yLabel": {
            "high": "Riesgo alto: {{score}} por ciento",
            "moderate": "Riesgo moderado: {{score}} por ciento"
          }
        },
        "meshTagline": {
          "motivation": "Por qué este candidato quiere reubicarse.",
          "english": "Preparación para el idioma de trabajo.",
          "softCultural": "Ajuste cultural y cómo colaboran.",
          "hardOther": "Capacidad técnica y operativa."
        },
        "pillars": {
          "spreadTitle": "Distribución de pilares",
          "spreadDescription": "Los siete pilares en un radar — cuanto más cerca esté cada eje del borde exterior, más fuerte será la evaluación del candidato en ese pilar.",
          "topGreenFlagsTitle": "Principales fortalezas a través de los pilares",
          "topRedFlagsTitle": "Principales preocupaciones a través de los pilares",
          "topFlagsEmpty": "Nada señalado.",
          "plan90Days": {
            "title": "Plan sugerido de 90 días",
            "description": "Secuencia recomendada de Tonnie para los primeros 90 días después del patrocinio.",
            "empty": "No se generó ningún plan.",
            "stepDuration": "Día {{day}}"
          },
          "fullName": {
            "ICM": "Motivación internacional de Career",
            "MA": "Adaptabilidad multicultural",
            "WMF": "Flexibilidad en el modelo de trabajo",
            "CP": "Dominio de la comunicación",
            "CP_ENGLISH": "Comunicación en Inglés",
            "CP_NATIVE_TARGET": "Idioma nativo / Objetivo",
            "GPE": "Experiencia profesional global",
            "AR": "Preparación académica",
            "PRM": "Resiliencia psicológica para la movilidad"
          }
        },
        "pitch": {
          "sentimentLabel": "Sentimiento",
          "sentimentValue": {
            "positive": "Positivo",
            "neutral": "Neutral",
            "negative": "Negativo"
          },
          "deliveryMetric": {
            "communicationClarity": "Claridad en la comunicación",
            "confidenceLevel": "Nivel de confianza",
            "energyLevel": "Nivel de energía",
            "pacing": "Ritmo",
            "articulation": "Articulación",
            "fillerWords": "Palabras de relleno"
          },
          "noPitchTitle": "No se ha grabado ninguna presentación aún",
          "noPitchDescription": "{{name}} no ha grabado su introducción de 60 segundos. Envía un recordatorio para motivarlo — la presentación es una de las señales cualitativas más fuertes antes de patrocinar.",
          "pendingAnalysisTitle": "Presentación grabada — análisis en progreso",
          "pendingAnalysisDescription": "La presentación de {{name}} fue subida, pero Brain aún no ha terminado de analizarla. La transcripción y los insights de IA aparecerán aquí en unos minutos.",
          "playbackMissingTitle": "Análisis listo — reproducción no disponible",
          "playbackMissingDescription": "Tonnie tiene la transcripción y análisis de la presentación a continuación, pero el archivo de video no se pudo cargar en este momento. Actualiza en un momento para volver a intentarlo, o revisa la bóveda del ciudadano.",
          "videoOnlyTitle": "Presentación grabada — análisis pendiente",
          "videoOnlyDescription": "La presentación de {{name}} está lista para ver arriba, pero la transcripción, el sentimiento y el análisis de entrega de Tonnie aún no están adjuntos a este CheckUp. La mayoría de las veces, esto significa que el analizador no se ha ejecutado para esta presentación; vuelve a activarlo a continuación para llenar las señales faltantes.",
          "rerunAnalysis": "Reejecutar análisis de presentación",
          "rerunAnalysisInProgress": "Reejecutando análisis de presentación…",
          "rerunAnalysisError": "No se pudo reejecutar el análisis de presentación",
          "videoFallback": "Tu navegador no puede reproducir este formato de video.",
          "duration": "Duración: {{value}}",
          "recordedAt": "Grabado {{date}}",
          "statusReady": "Listo para revisar",
          "statusAnalyzing": "Analizando",
          "statusPending": "Esperando carga",
          "statusFailed": "Análisis fallido",
          "statusEstimated": "Estimación",
          "failedTitle": "No se ha podido analizar el pitch",
          "failedDescription": "La grabación de {{name}} no ha producido ningún análisis. Nada en esta pestaña es una valoración de ella.",
          "heuristicTitle": "Estas señales son estimaciones, no un análisis de IA",
          "heuristicDescription": "El análisis de IA no estaba disponible, así que el sentimiento y las métricas de expresión de abajo proceden de una heurística simple basada en el recuento de palabras. No bases una decisión en ellas: vuelve a ejecutar el análisis.",
          "failedReason": {
            "noInput": "El análisis se ejecutó sin grabación. Vuelve a ejecutar el análisis.",
            "videoNotFound": "No se ha encontrado ninguna grabación de {{name}} en el almacenamiento.",
            "storageFetchFailed": "No se ha podido leer la grabación del almacenamiento. Vuelve a ejecutar el análisis.",
            "serviceComponentMissing": "Al servicio de análisis le falta un componente que necesita. Nuestro equipo ha sido avisado: vuelve a ejecutar el análisis cuando esté resuelto.",
            "noAudioTrack": "La grabación no tiene sonido. Pide a {{name}} que vuelva a grabar con el micrófono activado.",
            "unreadableRecording": "No se ha podido descodificar el formato de la grabación. Pide a {{name}} que vuelva a grabar.",
            "timedOut": "El procesamiento de la grabación tardó demasiado. Vuelve a ejecutar el análisis.",
            "noSpeech": "No se ha detectado voz en la grabación. Pide a {{name}} que vuelva a grabar.",
            "serviceRejected": "El servicio de transcripción ha rechazado la grabación. Nuestro equipo ha sido avisado.",
            "serviceUnavailable": "El servicio de transcripción no estaba disponible. Vuelve a ejecutar el análisis.",
            "internalError": "Un error inesperado ha detenido el análisis. Nuestro equipo ha sido avisado.",
            "unrecorded": "Este resultado se generó antes de que se registraran los motivos de fallo. Vuelve a ejecutar el análisis para saber por qué."
          },
          "heuristicReason": {
            "modelUnavailable": "Motivo: no había ningún modelo de IA configurado para el análisis.",
            "invalidResponse": "Motivo: no se ha podido usar la respuesta de la IA.",
            "serviceRejected": "Motivo: el servicio de IA rechazó la solicitud.",
            "serviceUnavailable": "Motivo: el servicio de IA no estaba disponible.",
            "unrecorded": "Motivo: no registrado; este resultado es anterior a ese registro."
          }
        },
        "skills": {
          "softHardCombinedTitle": "Principales habilidades blandas y duras",
          "softHardCombinedDescription": "La forma de cada lista de un vistazo y, debajo, cada habilidad ordenada por su puntuación de fuerza, con el nivel en que Tonnie la clasificó. El número de cada eje es su fila.",
          "additionalSkillsTitle": "Habilidades adicionales",
          "additionalSkillsDescription": "Capacidades más allá de la lista de habilidades blandas/duras principales, clasificadas por puntuación de poder.",
          "additionalSkillsEmpty": "No se han presentado habilidades adicionales.",
          "softEmpty": "No se han presentado habilidades blandas aún; el análisis de Tonnie no ha devuelto un conjunto de habilidades principales para este candidato.",
          "hardEmpty": "No se han presentado habilidades duras aún; el análisis de Tonnie no ha devuelto un conjunto de habilidades principales para este candidato.",
          "softShapeLabel": "Forma de las principales habilidades blandas, ejes numerados por posición — {{summary}}",
          "hardShapeLabel": "Forma de las principales habilidades técnicas, ejes numerados por posición — {{summary}}"
        },
        "deliveryMetrics": "Métricas de entrega",
        "drawerDescription": "Revisión de evaluación para {{name}} — progreso de CheckUp, datos del perfil y acciones administrativas.",
        "evaluationPillars": "Pilares de evaluación",
        "evaluationPillarsDesc": "Puntuación por pilar, confianza y evidencia — la pista de auditoría detrás del veredicto de {{name}} sobre iQulture.",
        "evidenceLabel": "Evidencia",
        "greenFlags": "Banderas verdes",
        "hideDetails": "Ocultar detalles",
        "interviewFirst": "Entrevista primero",
        "interviewConfirmTitle": "¿Enviar invitación a la entrevista?",
        "interviewConfirmDescription": "Tonnie enviará a {{name}} una invitación a la entrevista previa al patrocinio. Puedes retirar más tarde, pero el correo se enviará de inmediato.",
        "interviewConfirmCancel": "Cancelar",
        "interviewConfirmAction": "Enviar invitación",
        "lastSeenAgo_one": "Última vez visto hace {{count}} día",
        "lastSeenAgo_other": "Última vez visto hace {{count}} días",
        "lastSeenToday": "Última vez visto hoy",
        "menuLabel": "Más acciones",
        "messageSendError": "No pudimos enviar el mensaje. Por favor, inténtalo de nuevo.",
        "messageSent": "Mensaje enviado a {{name}}",
        "messageSentDescription": "Está en camino — lo verás en el registro de mensajes en breve.",
        "meshAnalysis": "Análisis de MESH",
        "meshAnalysisDesc": "Cómo puntúa {{name}} en los cuatro fundamentos sobre los que se construye cada patrocinio seguro.",
        "neverSeen": "No ha abierto la aplicación aún",
        "calculating": {
          "title": "Se está calculando la puntuación del CheckUp",
          "description": "La nueva puntuación de {{name}} aparecerá aquí en cuanto termine el cálculo."
        },
        "noneIdentified": "Ninguno identificado",
        "pitchVideoAnalysis": "Análisis del video de presentación",
        "pitchVideoDesc": "La presentación de 60 segundos de {{name}} — transcripción, sentimiento y métricas de entrega en sus propias palabras.",
        "recommendations": "Recomendaciones",
        "redFlags": "Alertas rojas",
        "reminderSendError": "No pudimos enviar el recordatorio. Por favor, inténtalo de nuevo.",
        "reminderSent": "Recordatorio enviado a {{name}}",
        "reminderSentDescription": "{{name}} recibirá un recordatorio por correo electrónico para completar CheckUp.",
        "reminderTemplateMissing": "La plantilla de recordatorio de CheckUp no se ha configurado. Visita Mensajes para crearla.",
        "sendMessage": "Enviar mensaje",
        "sendMessageDescription": "Personaliza el asunto y el mensaje antes de enviar — el talento lo recibe como un correo electrónico.",
        "sendMessageTitle": "Enviar un mensaje",
        "sendNow": "Enviar ahora",
        "sendReminder": "Enviar recordatorio",
        "sending": "Enviando…",
        "showDetails": "Mostrar detalles",
        "sponsoredDrawerDescription": "Monitoreo de talento patrocinado para {{name}} — progreso del héroe, evidencia y acciones administrativas.",
        "sponsorJourney": "Viaje del patrocinador",
        "sponsorship": {
          "cancelTitle": "¿Cancelar patrocinio?",
          "cancelLoading": "Calculando el monto del reembolso…",
          "cancelDescription": "Tonnie reembolsará {{refundAmount}} ({{monthsRemaining}} de {{durationMonths}} meses restantes) y el viaje de {{name}} volverá a acceso de nivel básico. Esta acción no se puede deshacer.",
          "cancelNoRefundDescription": "Este patrocinio no tiene saldo reembolsable — se ha consumido la ventana completa de {{durationMonths}} meses. Cancelar revertirá el viaje de {{name}} al acceso de nivel básico sin reembolso.",
          "cancelKeep": "Mantener patrocinio",
          "cancelAction": "Cancelar y reembolsar {{refundAmount}}",
          "cancelNoRefund": "Cancelar patrocinio (sin reembolso)",
          "cancelSuccess": "Patrocinio cancelado — {{amount}} reembolsados a tu tarjeta.",
          "cancelFailed": "No se pudo cancelar el patrocinio en este momento."
        },
        "tagsHint": "Consejo: comenzar desde una plantilla completa automáticamente el nombre del talento y otros detalles. Los mensajes personalizados se envían tal cual.",
        "waitingDays_one": "Esperando {{count}}d",
        "waitingDays_other": "Esperando {{count}}d",
        "waitingOverdue_one": "{{count}}d de retraso",
        "waitingOverdue_other": "{{count}}d de retraso",
        "phase": {
          "adaptation": {
            "awaiting": {
              "description": "QultureUp está desbloqueado. {{name}} aún no ha comenzado ninguna misión de preparación cultural.",
              "title": "Esperando la primera actividad"
            },
            "locked": {
              "description": "QultureUp se activa después de que {{name}} sea patrocinado. Las misiones de preparación cultural se construyen automáticamente según el destino.",
              "title": "La adaptación se desbloquea después del patrocinio"
            }
          },
          "action": {
            "careIntervention": "Intervención de Care",
            "sendReminder": "Enviar recordatorio",
            "viewKit": "Ver kit"
          },
          "care": {
            "awaiting": {
              "description": "Care está desbloqueado. {{name}} aún no ha registrado un seguimiento; un recordatorio suave puede ayudar.",
              "title": "Esperando el primer chequeo"
            },
            "locked": {
              "description": "Care se activa después de que {{name}} sea patrocinado. El programa de bienestar se construye en torno a su proceso de adaptación.",
              "title": "Care se desbloquea después del patrocinio"
            }
          },
          "checkup": {
            "awaiting": {
              "description": "{{name}} aceptó la invitación pero aún no ha comenzado CheckUp. Un recordatorio suele motivarlos a comenzar.",
              "title": "CheckUp aún no comenzado"
            },
            "locked": {
              "description": "CheckUp se activa tan pronto como {{name}} acepta la invitación y se crea un viaje.",
              "title": "CheckUp aún no activado"
            },
            "inProgress": {
              "title": "CheckUp en curso",
              "description": "{{name}} está completando su CheckUp — {{done}} de {{total}} pasos hechos."
            },
            "awaitingScore": {
              "title": "CheckUp enviado",
              "description": "{{name}} terminó su CheckUp. Estamos calculando su puntuación iQulture."
            }
          },
          "evidence": {
            "awaiting": {
              "description": "No hay sellos de pasaporte aún. Los sellos y las millas se acumulan a medida que {{name}} avanza a través de los héroes.",
              "title": "Esperando los primeros hitos"
            },
            "locked": {
              "description": "Passport se activa después del patrocinio. Los hitos de cada héroe obtienen sellos automáticamente.",
              "title": "La evidencia se desbloquea tras el patrocinio"
            }
          },
          "mobility": {
            "awaiting": {
              "description": "El kit de TelePortal está listo. {{name}} aún no ha comenzado ninguna tarea.",
              "title": "Esperando la primera actividad"
            },
            "locked": {
              "description": "TelePortal construirá automáticamente un kit de reubicación personalizado una vez que {{name}} sea patrocinado.",
              "title": "La movilidad se desbloquea tras el patrocinio"
            }
          }
        },
        "phaseStrip": {
          "scrollNext": "Mostrar fases siguientes",
          "scrollPrevious": "Mostrar fases anteriores",
          "sponsored": {
            "accepted": "Aceptado",
            "ariaLabel": "Fase de patrocinio",
            "offered": "Ofrecido",
            "sponsored": "Patrocinado",
            "thriving": "Prosperando"
          },
          "vetting": {
            "ariaLabel": "Fase de evaluación",
            "invited": "Invitado",
            "scored": "Puntuado",
            "started": "Comenzado",
            "submitted": "Enviado",
            "verdict": "Veredicto"
          }
        },
        "summary": "Resumen",
        "topHardSkills": "Principales habilidades duras",
        "topSoftSkills": "Principales habilidades blandas",
        "transcript": "Transcripción",
        "citizenAccountDeletedTitle": "Cuenta Citizen eliminada",
        "citizenAccountDeletedBody": "Este candidato eliminó su cuenta de Tonnie. Su perfil + actividad se conservan en forma de solo lectura para tus registros; no se pueden tomar más acciones.",
        "interviewInvitationQueued": "Solicitud de entrevista en cola para {{name}}. Correo electrónico enviado; integración de corredor ATS pendiente.",
        "interviewInvitationFailed": "Error al enviar la solicitud de entrevista. Inténtalo de nuevo.",
        "scoreEstimate": {
          "title": "Partes de esta puntuación son estimaciones, no mediciones",
          "pitchFailed": "Pitch: no analizado; la puntuación se calculó sin él.",
          "pitchHeuristic": "Exposición del pitch (Motivación): estimada a partir del recuento de palabras; el análisis de IA no estaba disponible.",
          "pillarsM": "Motivación: algunos pilares se estimaron con un método simplificado; la evaluación de IA no estaba disponible.",
          "pillarsE": "Inglés: algunos pilares se estimaron con un método simplificado; la evaluación de IA no estaba disponible.",
          "pillarsS": "Habilidades blandas y culturales: algunos pilares se estimaron con un método simplificado; la evaluación de IA no estaba disponible.",
          "pillarsH": "Habilidades técnicas: algunos pilares se estimaron con un método simplificado; la evaluación de IA no estaba disponible."
        },
        "languages": {
          "title": "Idiomas",
          "none": "Aún no hay resultados de idioma."
        },
        "leftProgrammeTitle": "Salió de tu programa el {{date}}",
        "leftProgrammeBody": "La relación ha terminado, así que este registro es de solo lectura y lo que compartió ya no es visible. Envía una nueva invitación para volver a trabajar con él: él decide si acepta."
      },
      "title": "Evaluación",
      "topCandidates": "Principales candidatos",
      "topCandidatesDescription": "Las mejores puntuaciones, listas para patrocinar",
      "topPick": "Selección principal",
      "totalCandidates": "Total de candidatos",
      "viewPending": "Ver pendientes",
      "viewPotentialTalents": "Ver talentos potenciales",
      "viewProTalents": "Ver talentos Pro",
      "completed": "Completado",
      "badge": {
        "pro": "PRO",
        "potential": "POTENCIAL",
        "noob": "NOOB",
        "pending": "Pendiente CheckUp"
      },
      "talentsCount_one": "{{count}} talento",
      "talentsCount_other": "{{count}} talentos",
      "readyOfTotal": "{{completed}} de {{total}} listo",
      "talentRowActionsAria": "Acciones para {{name}}",
      "testitCandidates": "Candidatos TestIt",
      "readyCount_one": "{{count}} listo",
      "readyCount_other": "{{count}} listos"
    },
    "invitationDetail": {
      "acceptedAt": "Aceptado",
      "accessibleDescription": "Estado de la invitación: {{status}}",
      "accessibleDescriptionLoading": "Cargando detalles de la invitación",
      "accessibleTitle": "Detalles de la invitación",
      "acquisitionEyebrow": "Adquisición",
      "assessment": "Evaluación",
      "branch": "Sucursal",
      "createdAt": "Creado",
      "delete": "Eliminar",
      "destination": "Destino",
      "email": "Correo electrónico",
      "errorDescription": "La invitación puede haber sido eliminada, o el servidor no es accesible.",
      "errorTitle": "No se pudo cargar la invitación",
      "expiresAt": "Caduca",
      "historyTitle": "Historia",
      "name": "Nombre",
      "noHistory": "No se han registrado cambios de estado.",
      "opportunityTitle": "Oportunidad",
      "recipientTitle": "Destinatario",
      "resend": "Reenviar",
      "resendHint": "Reenviar regenerará el token y restablecerá la caducidad.",
      "revoke": "Revocar",
      "scenario": "Escenario",
      "scenarioValue": {
        "pre_immigration": "Pre-inmigración",
        "already_abroad": "Ya en el extranjero",
        "relocation_only": "Reubicación solo",
        "integration_only": "Integración solamente"
      },
      "send": "Enviar invitación",
      "sentAt": "Enviado",
      "status": {
        "draft": "Borrador",
        "pending": "Aceptación pendiente",
        "accepted": "Aceptado",
        "expired": "Caducado",
        "revoked": "Revocado",
        "declined": "Rechazado",
        "email_queued": "Correo en cola",
        "email_skipped": "Correo omitido",
        "email_failed": "Correo no enviado",
        "email_sent": "Correo enviado",
        "email_delivered": "Entregado",
        "email_opened": "Abierto",
        "email_clicked": "Enlace pulsado",
        "email_bounced": "Rebotado",
        "landed": "Abrió la página de la invitación",
        "email_mismatch": "La sesión iniciada no coincide",
        "matched_signup": "Se registró en Tonnie",
        "deferred": "Aplazado por el candidato",
        "email_reminded": "Recordatorio enviado",
        "claimed": "Reclamada desde otra cuenta"
      },
      "tokenPreview": "Vista previa del token",
      "tokenTitle": "Token y caducidad",
      "workLocation": "Ubicación de trabajo",
      "reason": {
        "deleted_sentinel": "No enviado — el destinatario eliminó su cuenta de Tonnie.",
        "email_mismatch": "Había iniciado sesión con una cuenta diferente.",
        "email_unverified": "La dirección está en su cuenta pero aún no está verificada.",
        "expired": "La invitación ya había caducado.",
        "expiry_sweep": "Caducó sin respuesta.",
        "jit": "Detectado en su primer inicio de sesión.",
        "lazy_expire_on_open": "Ya estaba caducada cuando se abrió la página.",
        "matched_signup_unaccepted": "Caducó aunque esta persona ya está en Tonnie — reenviarla tiene muchas probabilidades de llegarle.",
        "ok": "La invitación estaba abierta y lista para aceptarse.",
        "onboarding": "Detectado durante la incorporación.",
        "opted_out": "No enviado — el destinatario rechazó recibir correos.",
        "revoked": "La invitación ya había sido revocada.",
        "webhook": "Detectado al crearse su cuenta."
      },
      "byActor": "por {{name}}",
      "hasAccountChip": "Se registró, no aceptó",
      "resendNudge": "Esta persona ya tiene cuenta en Tonnie — reenviarla tiene muchas probabilidades de llegar a alguien que puede iniciar sesión de inmediato.",
      "resendPromoted": "Reenviar invitación",
      "candidateRole": "Rol",
      "candidateLocation": "Ubicación",
      "candidateSkills": "Habilidades",
      "inviteAgain": "Invitar de nuevo",
      "closed": {
        "declinedTitle": "Rechazó la invitación el {{when}}",
        "expiredTitle": "La invitación caducó el {{when}}",
        "body": "Invita de nuevo para enviarle un nuevo correo con un enlace nuevo, o elimina la invitación para quitarla de tu pipeline."
      }
    },
    "talentRowMenu": {
      "viewDetails": "Ver detalles",
      "sendInvitation": "Enviar invitación",
      "resendInvitation": "Reenviar invitación",
      "revoke": "Revocar",
      "delete": "Eliminar",
      "sponsorJourney": "Patrocinar el viaje",
      "askCoPilot": "Preguntar CoPilot",
      "askTonnieServices": "Preguntar servicios de Tonnie",
      "inviteAgain": "Invitar de nuevo"
    },
    "vettingPage": {
      "activeTab": "Activo",
      "archivedTab": "Archivado"
    },
    "motivationalForm": {
      "questionCard": {
        "required": "Requerido",
        "optional": "Opcional",
        "maxCharsHint_one": "Máx. {{max}} carácter • Responde solo en inglés",
        "maxCharsHint_other": "Máx. {{max}} caracteres • Responde solo en inglés",
        "answerLabel": "Tu respuesta",
        "answerPlaceholder": "Escribe tu respuesta aquí en inglés…",
        "answerPlaceholderOptional": "Escribe tu respuesta aquí en inglés… (opcional)",
        "noComment": "Sin comentario",
        "optionalHint": "Pregunta opcional – puedes dejarla en blanco.",
        "validationComment": "Comentario de validación:"
      }
    },
    "quickEdit": {
      "companyPlaceholder": "Acme Corporation, Inc.",
      "taxIdPlaceholder": "EIN, IVA o ID fiscal nacional"
    },
    "additionalDetails": {
      "languagePlaceholder": "Inglés"
    },
    "acceptInvite": {
      "notFound": "Invitación no encontrada",
      "failedToLoad": "Error al cargar la invitación",
      "failedToAccept": "Error al aceptar la invitación",
      "roleAdmin": "Admin",
      "roleTeamMember": "Miembro del equipo",
      "invalidLink": "Enlace de invitación inválido. No se proporcionó token.",
      "goToLogin": "Ir a iniciar sesión",
      "welcomeTo": "¡Bienvenido a {{company}}!",
      "joinedAs": "Te has unido como {{role}}. Redirigiendo al panel de control...",
      "expiredTitle": "Invitación expirada",
      "expiredBody": "Esta invitación para unirte a {{company}} ha expirado. Por favor, pide al administrador del equipo que envíe una nueva invitación.",
      "alreadyTitle": "Ya aceptada",
      "alreadyBody": "Esta invitación ya ha sido aceptada.",
      "title": "Invitación de equipo",
      "joinCompany": "Únete a {{company}}",
      "invitedAsRole": "Has sido invitado a unirte como {{role}}",
      "signedInAs": "Conectado como {{email}}",
      "accepting": "Aceptando...",
      "accept": "Aceptar invitación",
      "emailMismatch": "Esta invitación fue enviada a {{invited}}, pero has iniciado sesión como {{current}}. Por favor, cierra sesión e inicia sesión con la dirección de correo electrónico correcta.",
      "invitedToJoin": "Has sido invitado a unirte a {{company}}",
      "joinAsRole": "Únete como {{role}}",
      "invitationSentTo": "Invitación enviada a {{email}}",
      "signUpOrLogIn": "Regístrate o inicia sesión para aceptar esta invitación y unirte al equipo.",
      "haveAccount": "¿Ya tienes una cuenta? Iniciar sesión",
      "emailUnverified": "Verifica {{email}} en tu cuenta y vuelve a aceptar la invitación."
    },
    "weeklySummary": {
      "title": "Resumen semanal",
      "insightsFor": "Perspectivas generadas por IA para {{period}}",
      "keyAchievements": "Logros clave",
      "areasNeedingAttention": "Áreas que necesitan atención",
      "trends": "Tendencias",
      "insights": "Perspectivas",
      "viewFullReport": "Ver informe completo"
    },
    "nextBestActions": {
      "title": "Próximas mejores acciones",
      "empty": "No se requieren acciones que necesiten atención inmediata. ¡Gran trabajo!",
      "explainCopilot": "Recomendaciones impulsadas por IA para tus programas de movilidad",
      "pipelineCopilot": "Recomendaciones impulsadas por IA alineadas a tu pipeline",
      "categoryCheckup": "CheckUp pendiente",
      "categorySponsorship": "Decisión de patrocinio",
      "categoryMobility": "Bloqueador de movilidad",
      "categoryCare": "Punto de control de Care",
      "categoryRisk": "Señal de riesgo",
      "urgency": {
        "high": "alto",
        "medium": "medio",
        "low": "bajo"
      },
      "reason": "Razón: {{reason}}",
      "explain": "Explicar"
    },
    "iqultureBadge": {
      "pending": "Pendiente",
      "description": {
        "pro": "Preparación excepcional para oportunidades internacionales",
        "potential": "Gran potencial con margen de crecimiento",
        "noob": "Comenzando el viaje de preparación",
        "noBadge": "CheckUp aún no completado"
      },
      "corporateInsight": {
        "pro": "Talento de primer nivel listo para movilidad inmediata",
        "potential": "Candidato fuerte — considerar con plan de preparación",
        "noob": "Etapa temprana — monitorear el progreso a través de QultureUp",
        "noBadge": "Esperando evaluación de iQulture"
      }
    },
    "routeFlags": {
      "srLabel": "{{origin}} a {{destination}}"
    },
    "inviteMessage": {
      "bodyHint": "Edita libremente. Las etiquetas se rellenan por destinatario — la previsualización muestra el resultado.",
      "editingSource": "Estás editando el mensaje solo para este envío. La plantilla del tenant no cambia.",
      "linkPresent": "Enlace de aceptación presente",
      "linkRequired": "Conserva el enlace de aceptación — sin él el candidato no puede empezar."
    },
    "attentionReason": {
      "invitation_never_sent": "Invitación nunca enviada",
      "invitation_bounced": "Correo rechazado — comprueba la dirección",
      "invitation_expired": "Invitación caducada",
      "signed_up_not_accepted": "Se registró pero no ha aceptado — reenviar",
      "invite_ignored": "Sin respuesta desde hace {{days}} días",
      "onboarding_stalled": "Perfil incompleto desde hace {{days}} días",
      "checkup_never_requested": "CheckUp nunca solicitado",
      "checkup_never_started": "CheckUp sin iniciar desde hace {{days}} días",
      "checkup_stalled": "CheckUp detenido desde hace {{days}} días",
      "scoring_stalled": "Cálculo retrasado {{days}} días",
      "awaiting_company_review": "Esperando tu revisión desde hace {{days}} días",
      "testit_awaiting_review": "Pruebas completadas — esperando tu decisión",
      "citizen_left": "El candidato dejó la plataforma",
      "mobility_track_blocked": "Patrocinado pero sin itinerario iniciado",
      "sponsorship_offer_unanswered": "Oferta de patrocinio sin respuesta desde hace {{days}} días",
      "checkup_not_shared": "Resultado del CheckUp sin compartir desde hace {{days}} días",
      "sharing_withdrawn": "Dejó de compartir hace {{days}} días",
      "academyStalled": "Sin progreso en la Languages Academy desde hace {{days}} días",
      "academyGoalReached": "Alcanzó la meta del curso en la Languages Academy"
    },
    "companyProfile": {
      "industry": {
        "technology": "Tecnología",
        "healthcare": "Sanidad",
        "finance": "Finanzas",
        "manufacturing": "Fabricación",
        "retail": "Comercio minorista",
        "hospitality": "Hostelería",
        "construction": "Construcción",
        "education": "Educación",
        "consulting": "Consultoría",
        "logistics": "Logística",
        "energy": "Energía",
        "telecommunications": "Telecomunicaciones",
        "mediaEntertainment": "Medios y entretenimiento",
        "realEstate": "Inmobiliario",
        "other": "Otra"
      },
      "roleType": {
        "engineering": "Ingeniería",
        "product": "Producto",
        "design": "Diseño",
        "dataScience": "Ciencia de datos",
        "devops": "DevOps e infraestructura",
        "marketing": "Marketing",
        "sales": "Ventas",
        "customerSuccess": "Éxito del cliente",
        "finance": "Finanzas",
        "hrPeople": "Recursos humanos",
        "operations": "Operaciones",
        "executive": "Dirección y liderazgo",
        "other": "Otra"
      },
      "employeesRange": "{{range}} empleados",
      "hiresRange": "{{range}} contrataciones al año",
      "openLinkedIn": "Abrir perfil ↗"
    },
    "lifecycleStatus": {
      "draft": "Borrador",
      "active": "En curso",
      "paused": "En pausa",
      "completed": "Completado",
      "archived": "Archivado"
    },
    "taskPriority": {
      "high": "Alta prioridad"
    },
    "iqulture": {
      "provisional": {
        "label": "Provisional",
        "tooltip": "Faltan algunos datos de este talento, así que la puntuación es la mínima posible. Con los datos completos podría llegar hasta {{max}}."
      }
    },
    "shareRequest": {
      "badge": {
        "pendingCheckup": "CheckUp solicitado — esperando al talento",
        "pendingTests": "Más pruebas solicitadas — esperando al talento",
        "declinedCheckup": "Solicitud de CheckUp rechazada · {{date}}",
        "declinedTests": "Solicitud de pruebas rechazada · {{date}}",
        "pendingTooltip": "Solicitado el {{date}}. No se comparte nada más hasta que el talento responda.",
        "declinedTooltip": "Ves lo que el talento compartió antes. Puedes volver a pedirlo más tarde."
      },
      "notice": {
        "pendingCheckupTitle": "CheckUp solicitado — esperando al talento",
        "pendingTestsTitle": "Más pruebas solicitadas — esperando al talento",
        "pendingBody": "Solicitado el {{date}}. No se comparte nada más hasta que respondan; sigues viendo lo que aceptaron antes.",
        "declinedCheckupTitle": "El talento rechazó tu solicitud para ver su CheckUp",
        "declinedTestsTitle": "El talento rechazó tu solicitud de más pruebas",
        "declinedBody": "Rechazado el {{date}}. Nada ha cambiado: ves lo que compartieron antes. Puedes volver a pedirlo más tarde."
      }
    },
    "inoutOperations": {
      "title": "Operación InOut",
      "subtitle": "Los casos InOut de las asesorías. Solo para el equipo de Tonnie: cada acceso queda registrado.",
      "tabs": {
        "cases": "Casos",
        "files": "Archivos de la asesoría",
        "reconciliation": "Conciliación",
        "portals": "Portales"
      },
      "loading": "Cargando…",
      "loadError": "No se pudo cargar. Inténtalo de nuevo.",
      "cases": {
        "empty": "Todavía no hay casos.",
        "caseRef": "Caso",
        "agency": "Asesoría",
        "state": "Estado",
        "opened": "Abierto el",
        "consultations": "Consultas pagadas",
        "requisition": "Solicitud",
        "noRequisition": "Ninguna",
        "refunds": "Reembolsos solicitados",
        "lastEvent": "Último evento",
        "noEvent": "Ninguno todavía",
        "open": "Abrir"
      },
      "detail": {
        "title": "Caso {{caseRef}}",
        "recorded": "Abrir este caso queda registrado.",
        "person": "Persona",
        "personWithheld": "No se muestra: la persona no tiene un consentimiento vigente para la asesoría.",
        "consultations": "Consultas",
        "noConsultations": "Ninguna consulta.",
        "requisition": "Solicitud",
        "paid": "{{amount}} pagados · {{credit}} de crédito aplicado",
        "credit": "Crédito disponible: {{amount}}",
        "events": "Eventos",
        "noEvents": "Todavía ningún evento.",
        "refunds": "Solicitudes de reembolso",
        "noRefunds": "Ninguna solicitud de reembolso.",
        "markHandled": "Reembolsado en Stripe — marcar tramitado",
        "links": "Enlaces del dosier",
        "noLinks": "Todavía ningún dosier enviado.",
        "linkRevoked": "Revocado: se retiró el consentimiento",
        "loadingTitle": "Caso",
        "handled": "Solicitud de reembolso marcada como tramitada.",
        "handleFailed": "No se pudo marcar la solicitud de reembolso como tramitada. Inténtalo de nuevo.",
        "linkSent": "Enviado el {{date}}",
        "linkValidUntil": "Válido hasta el {{date}}",
        "linkOpens_one": "Abierto una vez",
        "linkOpens_other": "Abierto {{opens}} veces"
      },
      "event": {
        "title": "Registrar un evento de la asesoría",
        "code": "Evento",
        "note": "Nota",
        "noNote": "Sin nota",
        "when": "Cuándo ocurrió",
        "submit": "Registrar",
        "done": "Evento registrado",
        "refused": "El evento no encaja en este caso: revisa el código o si el caso está cerrado.",
        "failed": "No se pudo registrar el evento. Inténtalo de nuevo.",
        "whenRequired": "Indica cuándo ocurrió.",
        "codeRequired": "Elige el evento."
      },
      "files": {
        "agency": "Asesoría",
        "noAgency": "Todavía ninguna asesoría tiene casos.",
        "choose": "Elige el archivo de la asesoría (CSV, formato v1)",
        "readFailed": "No se pudo leer el archivo.",
        "tooBig": "El archivo es más grande de lo que la operación lee.",
        "browserPreview": "Lo que leyó tu navegador",
        "serverReport": "La comprobación del servidor",
        "line": "Línea",
        "event": "Evento",
        "when": "Cuándo",
        "outcome": "Resultado",
        "problems": "Problemas",
        "check": "Comprobar y guardar el archivo",
        "fixFirst": "Corrige primero los problemas del archivo: se carga entero o no se carga.",
        "load": "Cargar el archivo",
        "loaded": "Archivo cargado",
        "closed": "Este archivo no se puede cargar: fue rechazado, ya se cargó o su comprobación caducó.",
        "failed": "No funcionó. Inténtalo de nuevo.",
        "history": "Archivos recibidos",
        "noHistory": "Todavía ningún archivo recibido.",
        "received": "Recibido",
        "fileName": "Archivo",
        "rows": "Filas",
        "state": "Estado"
      },
      "reconciliation": {
        "month": "Mes",
        "empty": "No se pagó nada en este mes.",
        "problem": "La base sin IVA no se puede calcular ahora.",
        "agency": "Asesoría",
        "charged": "Cobrado (IVA incl.)",
        "refunded": "Reembolsado",
        "net": "Base sin IVA",
        "share": "Parte de la asesoría",
        "notYet": "Aún no: un pago no tiene línea de IVA",
        "payments": "Pagos",
        "documentsMissing": "Documentos sin emitir",
        "cases": "Casos"
      },
      "portals": {
        "intro": "Los sitios donde funciona la calculadora InOut: el de Tonnie y los de sus socios. La calculadora de un portal en borrador no carga.",
        "empty": "Todavía no hay portales.",
        "new": "Nuevo portal",
        "code": "Código",
        "name": "Nombre",
        "status": "Estado",
        "origins": "Sitios autorizados",
        "updated": "Actualizado",
        "edit": "Editar",
        "statusDraft": "Borrador",
        "statusActive": "Activo",
        "originsCount_one": "{{count}} sitio",
        "originsCount_other": "{{count}} sitios",
        "newTitle": "Nuevo portal",
        "editTitle": "Portal {{code}}",
        "description": "Lo que la calculadora muestra en este portal, qué sitios pueden incrustarla y su aspecto. Un cambio guardado llega a la calculadora la próxima vez que carga.",
        "codeHint": "Mayúsculas, dígitos y _: las páginas del portal lo llaman así (data-portal). No se puede cambiar después.",
        "active": "Activo: la calculadora carga en este portal",
        "nameHint": "Aparece en la cabecera de la calculadora.",
        "nameGender": "Cómo se dice el nombre",
        "nameGenderFeminine": "Femenino — «na Tonnie», «na Ei!»",
        "nameGenderMasculine": "Masculino — «no portal»",
        "nameGenderHint": "El género del nombre en portugués: el registro dice que el cálculo se hizo «na Tonnie», «na Ei!» o «no portal».",
        "website": "Sitio web",
        "logo": "Logotipo",
        "logoHint": "Opcional: una dirección https://, o una imagen que sirve la calculadora (/assets/partners/…). Se muestra con 32 px de alto: un logotipo horizontal o un símbolo cuadrado.",
        "originsHint": "Los sitios autorizados a incrustar la calculadora, cada uno como https://host. Un portal activo necesita al menos uno.",
        "originPlaceholder": "https://www.ejemplo.com",
        "addOrigin": "Añadir",
        "removeOrigin": "Quitar {{origin}}",
        "country": "Empieza en",
        "countryNone": "Elige el visitante",
        "language": "Idioma",
        "languageNone": "El del visitante",
        "partner": "Asesoría",
        "partnerNone": "Ninguna",
        "partnerDraft": "{{name}} (borrador)",
        "look": "Aspecto",
        "customTheme": "Usar los colores del portal",
        "accent": "Color de acción",
        "accentForeground": "Texto sobre el color de acción",
        "pageColours": "Usar los colores de página del portal",
        "background": "Página",
        "foreground": "Texto sobre la página",
        "radius": "Esquinas",
        "radiusNone": "Rectas",
        "radiusSm": "Leves",
        "radiusMd": "Medias",
        "radiusLg": "Redondeadas",
        "radiusXl": "Redondas",
        "font": "Tipografía",
        "fontSystem": "La del dispositivo",
        "contrast": "Contraste {{ratio}}:1",
        "contrastOk": "Legible",
        "contrastLow": "Demasiado bajo: al menos 4,5:1",
        "preview": "Vista previa",
        "embed": "Ponerla en el portal",
        "embedHint": "Pega esto en las páginas del portal: el botón abre la calculadora en una ventana; el bloque vacío la muestra en la página.",
        "copy": "Copiar",
        "copied": "Copiado",
        "saved": "Portal guardado.",
        "failed": "No se pudo guardar el portal. Inténtalo de nuevo.",
        "refused": "Se rechazaron algunos valores: revisa los campos.",
        "partnerUnknown": "Esa asesoría no está en el registro de socios.",
        "copyFailed": "El navegador no ha permitido copiar. Selecciona el código de abajo y cópialo."
      }
    }
  },
  "capture": {
    "uploadFailedDefault": "La subida falló. Por favor, inténtalo de nuevo."
  },
  "care": {
    "additionalComments": "Comentarios adicionales (opcional)",
    "allStatuses": "Todos los estados",
    "alreadyCheckedIn": "Ya has hecho el check-in hoy",
    "appOnlyNotice": {
      "message": "Este panel es tu visión de solo lectura. Abre la aplicación Tonnie para registrar tu estado de ánimo, realizar seguimientos rápidos y completar puntos de control.",
      "title": "Los check-ins diarios se realizan en la aplicación"
    },
    "askCopilotAboutThis": "Preguntar a CoPilot sobre esto",
    "askCopilotFirst": "Preguntar a CoPilot cerebro primero",
    "assessedOn": "Evaluado el {{date}}",
    "assessment": {
      "completeTitle": "Evaluación completa",
      "completed": "Completado",
      "gateTitle": "Evaluación de Care",
      "loading": "Cargando evaluación…",
      "redirecting": "Redirigiendo…",
      "retake": "Repetir evaluación",
      "saving": "Guardando…",
      "subtitle": "Un breve check-in para evaluar cómo te estás adaptando. Toma aproximadamente 5 minutos.",
      "title": "Evaluación de Care"
    },
    "assessmentEstimatedTime": "Acerca de 5 minutos",
    "assessmentInfoDescription": "Tus respuestas ayudan a Care a personalizar los seguimientos, sugerir recursos locales y ofrecer apoyo cuando lo necesites.",
    "assessmentInfoIntro": "Haremos algunas preguntas sobre tu bienestar en salud, finanzas y comunidad.",
    "baseline": {
      "anxiety": "Ansiedad actual sobre la reubicación",
      "concerns": "Principales áreas de preocupación",
      "desc": "Selecciona la opción que mejor describe tu estado emocional actual.",
      "familyConfidence": "Confianza sobre la adaptación familiar",
      "minimal": "Mínima",
      "notConfident": "No estoy seguro",
      "selectMultiple": "selecciona todas las que apliquen",
      "significant": "Significativa",
      "supportNeed": "¿Cuánto apoyo crees que necesitarás?",
      "title": "¿Cómo te sientes acerca de la mudanza?",
      "veryConfident": "Muy seguro"
    },
    "carePillars": "Pilares de Care",
    "challengePlaceholder": "Describe tu desafío o pregunta...",
    "checkin": {
      "responseField": {
        "qc_concern": "Preocupaciones",
        "qc_notes": "Notas"
      },
      "responses": "Respuestas"
    },
    "checkinType": {
      "daily_mood": "Estado de ánimo diario",
      "evening_checkin": "Registro nocturno",
      "morning_checkin": "Registro matutino",
      "quick_checkin": "Registro rápido",
      "weekly_checkin": "Registro semanal"
    },
    "checkpoint": {
      "complete": {
        "milesEarned": "+{{miles}} Miles ganadas",
        "nextCheckpoint": "Próximo punto de control: {{date}}",
        "recorded": "Respuestas registradas en tu Passport",
        "subtitle": "Gracias por compartir. Tus respuestas nos ayudan a apoyarte mejor.",
        "title": "¡Punto de control completo!"
      },
      "completed": "Completado",
      "confirmSubmit": {
        "message": "¿Estás listo para enviar tus respuestas del punto de control? No podrás cambiar tus respuestas después de enviarlas.",
        "title": "¿Enviar punto de control?"
      },
      "due": "Vencido",
      "feedbackLabel": "¿Algún comentario adicional? (opcional)",
      "feedbackPlaceholder": "Comparte tus pensamientos...",
      "loading": "Cargando punto de control...",
      "notFound": "Punto de control no encontrado",
      "unavailableTitle": "Registro no disponible",
      "unavailableBody": "No pudimos cargar las preguntas para este registro en este momento. Por favor, inténtalo de nuevo más tarde.",
      "overallScore": "Puntuación general",
      "overdue": "Atrasado",
      "previous": "Anterior",
      "reviewSubmit": "Revisar y enviar",
      "scaleLabels": [
        "Muy insatisfecho",
        "Insatisfecho",
        "Neutral",
        "Satisfecho",
        "Muy satisfecho"
      ],
      "scheduled": "Programado",
      "scoresSummary": "Resumen de tus puntuaciones:",
      "skipped": "Omitido",
      "stepOf": "Paso {{current}} de {{total}}",
      "submit": "Enviar",
      "title": "Punto de control",
      "typeNames": {
        "ad_hoc": "Chequeo",
        "annual": "Punto de control anual",
        "custom": "Punto de control",
        "month_1": "Punto de control de 1 mes",
        "month_12": "Punto de control de 12 meses",
        "month_3": "Punto de control de 3 meses",
        "month_6": "Punto de control de 6 meses",
        "month_9": "Punto de control de 9 meses",
        "onboarding": "Punto de control de incorporación",
        "pre_move_baseline": "Línea base pre-mudanza",
        "week_1": "Punto de control de la semana 1",
        "week_2": "Punto de control de la semana 2"
      },
      "framing": {
        "expectations": "Antes de tu mudanza — tus expectativas",
        "reality": "Instalándose — cómo son las cosas en realidad",
        "settling": "Encontrando tu ritmo",
        "established": "Estableciéndose",
        "thriving": "Mirando hacia adelante"
      },
      "focusPillar": "Enfoque",
      "miles_one": "{{count}} Mile",
      "miles_other": "{{count}} Miles",
      "pillarsTime_one": "{{count}} pilar · {{time}} min",
      "pillarsTime_other": "{{count}} pilares · {{time}} min"
    },
    "checkpointCommentsPlaceholder": "Comparte cualquier pensamiento o preocupación sobre la estabilidad de tu hogar y la integración...",
    "checkpointCompleted": "¡Punto de Control completado con éxito!",
    "checkpointDescription": "Autoevaluación para el bienestar y la integración",
    "checkpointEvolution": "Evolución del punto de control",
    "checkpointFormDescription": "Completa este punto de control para rastrear tu progreso. También puedes completarlo en móvil.",
    "checkpointHistory": "Historial de puntos de control",
    "checkpointMonth": "Punto de control de {{month}} meses",
    "checkpointTitle": "Punto de control de Care",
    "checkpoints": {
      "status": {
        "completed": "Completado",
        "due": "Vencido ahora",
        "in_progress": "En progreso",
        "overdue": "Atrasado",
        "pending": "Próximamente",
        "scheduled": "Próximamente",
        "skipped": "Omitido"
      },
      "title": "Puntos de control"
    },
    "checkpointsCompleted": "Puntos de control completados",
    "checkpointsDescription": "Ver puntos de control y completarlos en la aplicación móvil",
    "commitment": {
      "at_risk": "En riesgo",
      "champion": "Campeón",
      "committed": "Comprometido",
      "engaged": "Involucrado",
      "flight_risk": "Necesita atención"
    },
    "companyFeedback": "Comentarios de la empresa",
    "companyRating": "Calificación de la empresa",
    "completeCheckinMobile": "Completa el registro en móvil",
    "completeCheckpointMobile": "Completo en móvil",
    "completeFirstCycle": "Completa tu primer ciclo de retroalimentación para verlo aquí",
    "completedOn": "Completado el",
    "concern": {
      "family": "Familia",
      "finances": "Finanzas",
      "healthcare": "Atención médica",
      "housing": "Vivienda",
      "language": "Idioma",
      "loneliness": "Soledad",
      "schooling": "Educación",
      "title": "Preocupaciones",
      "work": "Trabajo"
    },
    "continue": {
      "description": "Has comenzado tu evaluación Care. Retoma justo donde lo dejaste en Citizen Web: tus respuestas hasta ahora están guardadas.",
      "title": "Continúa tu evaluación de Care"
    },
    "continueOnWeb": "Continúa en Citizen Web",
    "continueOnWebDesc": "Retoma tu evaluación Care donde la dejaste en el portal web Citizen.",
    "copilotSuggestions": "💡 sugerencias de cerebro CoPilot",
    "copilotSuggestionsText": "Antes de enviar, intenta preguntar a Cerebro CoPilot para obtener ayuda inmediata. Puede sugerir lecciones, tareas o recursos.",
    "createdOn": "Creado el",
    "current": "Actual",
    "description": "Rastrea tu bienestar",
    "due": "Vencido",
    "dueNow": "Vencido ahora",
    "error": {
      "description": "Desliza para actualizar o toca volver a intentar. Si sigue fallando, verifica tu conexión.",
      "title": "No pudimos cargar tus datos de Care"
    },
    "excellent": "5 — Excelente",
    "familyMasterOnly": "Solo el Maestro de Familia puede responder a los puntos de control de Care",
    "feedbackComment1": "Gran rendimiento en el proyecto reciente. ¡Sigue así!",
    "feedbackComment2": "Buen progreso, continúa practicando portugués.",
    "feedbackComment3": "Sintiendo más confianza en las conversaciones en portugués en el trabajo.",
    "feedbackComment4": "Aún ajustándome a la cultura laboral, pero avanzando.",
    "feedbackPillars": "Pilares de retroalimentación",
    "from": "De",
    "getHelpWith": "Obtén ayuda con {{topic}}",
    "heroBanner": {
      "assessmentComplete": "Evaluación completa",
      "awaitingFirstCheckin": "Comienza tu primer chequeo de estado de ánimo",
      "focusFromAssessment": "Áreas de enfoque de tu evaluación",
      "title": "Tu bienestar",
      "wellbeing": "Bienestar",
      "gettingStarted": "Comenzando"
    },
    "heroMiles": "Miles de Care",
    "householdAware": "Consciente del Hogar",
    "householdAwareDescription": "Este pilar considera el contexto de tu hogar (pareja, hijos) en la evaluación",
    "improving": "Mejorando",
    "manager": "Gerente",
    "mood": {
      "amazing": "Increíble",
      "checkedIn": "¡Registrado hoy!",
      "earnMiles": "Gana millas registrándote diariamente",
      "good": "Bueno",
      "great": "Genial",
      "howAreYou": "¿Cómo te sientes hoy?",
      "label1": "Luchando",
      "label2": "Está bien",
      "label3": "Bueno",
      "label4": "Genial",
      "label5": "Increíble",
      "okay": "Está bien",
      "struggling": "Luchando",
      "streakDays_one": "Racha de {{count}} día",
      "streakDays_other": "Racha de {{count}} días"
    },
    "mySupportRequests": "Mis solicitudes de soporte",
    "mySupportRequestsDesc": "Rastrea y revisa tus solicitudes de soporte enviadas",
    "needSupport": "¿Necesitas soporte?",
    "needsImprovement": "1 — Necesita mejora",
    "newRequest": "Nueva solicitud",
    "noCheckins": "Aún no hay chequeos. ¡Comienza a rastrear tu estado de ánimo!",
    "noCheckpointsScheduled": "Aún no hay puntos de control programados",
    "noDataYet": "Aún no hay datos",
    "noHistory": "Aún no hay historial de comentarios",
    "noSupportRequests": "No hay solicitudes de soporte que coincidan con este filtro",
    "noUpdatesYet": "Aún no hay actualizaciones",
    "objectiveChildcareArrangement": "Organizar cuidado infantil",
    "objectiveDefinitiveHousing": "Asegurar vivienda definitiva",
    "objectiveHousingStress": "Reducir el estrés relacionado con la vivienda",
    "objectiveSchoolEnrollment": "Completar la inscripción escolar",
    "objectiveSocialIntegration": "Construir conexiones sociales",
    "objectiveTemporaryHousing": "Asegurar vivienda temporal",
    "objectiveWellbeingSupport": "Acceder a apoyo de bienestar",
    "objectiveWorkAdaptation": "Adaptarse a la cultura laboral",
    "objectiveWorkplaceCulture": "Entender la cultura del lugar de trabajo",
    "objectives": {
      "title": "Tus objetivos",
      "subtitle": "Lo que tu equipo patrocinador te está ayudando a lograr.",
      "categoryFallback": "Objetivo",
      "currentLabel": "Ahora",
      "targetLabel": "Objetivo",
      "milestoneDone": "Hecho",
      "milestoneNotYet": "Aún no",
      "feedbackReadyBadge": "Comentarios listos",
      "viewFeedbackCta": "Ver comentarios y autoevaluarte",
      "sourceCompany": "De tu empresa",
      "sourcePersonal": "Tu propio objetivo",
      "currentCycleHeading": "Comentarios de este ciclo",
      "selfEmpty": "Aún no has añadido tu autoevaluación para este objetivo.",
      "ratingValue": "{{label}} ({{value}}/5)",
      "cadenceNote": "Los comentarios se revisan {{cadence}}.",
      "cadence": {
        "bi-weekly": "cada dos semanas",
        "monthly": "mensualmente",
        "quarterly": "trimestralmente"
      },
      "selfEvalBanner": {
        "title": "Tu equipo compartió nuevos comentarios",
        "message": "Hay un ciclo de retroalimentación abierto esperando tu autoevaluación. Agrégalo en la app de Tonnie para reflexionar sobre cada objetivo.",
        "cta": "Añade tu autoevaluación en la app"
      }
    },
    "objectiveFeedback": {
      "title": "Objetivos y comentarios",
      "intro": "Tu equipo patrocinador compartió comentarios sobre tus objetivos. Reflexiona sobre cada uno y añade tu propia autoevaluación honesta — se queda entre tú y tu equipo.",
      "providerHeading": "Comentarios de tu equipo",
      "providerEmpty": "Tu equipo aún no ha añadido una nota para este objetivo.",
      "selfHeading": "Tu autoevaluación",
      "ratingPrompt": "¿Cómo te va en esto?",
      "valuePlaceholder": "Introduce tu número",
      "ratingLabel1": "Solo comenzando",
      "ratingLabel2": "Encontrando mi camino",
      "ratingLabel3": "Haciendo progresos",
      "ratingLabel4": "Haciendo bien",
      "ratingLabel5": "Prosperando",
      "commentLabel": "¿Algo que te gustaría añadir? (opcional)",
      "commentPlaceholder": "Lo que va bien, lo que ha sido difícil, lo que necesitas…",
      "submit": "Enviar autoevaluación",
      "submitting": "Enviando…",
      "noRatingHint": "Califica al menos un objetivo para enviar.",
      "loadingTitle": "Cargando tus objetivos…",
      "emptyTitle": "No hay objetivos aún",
      "emptyBody": "Una vez que tu equipo de patrocinadores establezca objetivos para ti, aparecerán aquí.",
      "allCaughtUpTitle": "Estás al día",
      "allCaughtUpBody": "No hay ningún ciclo de retroalimentación abierto en este momento. Te avisaremos cuando tu equipo comparta nueva retroalimentación.",
      "errorTitle": "No pudimos cargar tus objetivos",
      "errorBody": "Desliza para actualizar o toca volver a intentar. Si sigue fallando, verifica tu conexión.",
      "successTitle": "Autoevaluación compartida",
      "successBody": "Gracias por reflexionar. Tu equipo puede ver tu evaluación junto a su retroalimentación.",
      "successDone": "Hecho",
      "dueOn": "Vencido {{date}}",
      "cadenceNote": "Tu equipo revisa estos {{cadence}}.",
      "cadence": {
        "weekly": "semanalmente",
        "bi-weekly": "cada dos semanas",
        "biweekly": "cada dos semanas",
        "monthly": "mensualmente",
        "quarterly": "trimestralmente",
        "semiannual": "dos veces al año",
        "annual": "anualmente"
      },
      "trust": {
        "why": "Tu autoevaluación ayuda a tu equipo de patrocinadores a entender tus objetivos desde tu punto de vista.",
        "who": "Solo tú y tu equipo de patrocinadores de Tonnie pueden ver tus respuestas. Nunca se comparte con otros colegas.",
        "how": "Reflexionar sobre tus objetivos mantiene tu apoyo personal y en camino."
      }
    },
    "overdue": "Atrasado",
    "phase": {
      "adapting": "Adaptándose",
      "preMove": "Antes del traslado",
      "settlingIn": "Instalándose",
      "thriving": "Prosperando"
    },
    "pillar": {
      "housing_stability": {
        "desc": "Vivienda temporal y definitiva, estrés y riesgo",
        "name": "Estabilidad de vivienda"
      },
      "schooling_childcare": {
        "desc": "Arreglos de educación y cuidado infantil",
        "name": "Educación y cuidado infantil"
      },
      "wellbeing_social": {
        "desc": "Salud mental, conexiones sociales y bienestar general",
        "name": "Bienestar y social"
      },
      "work_fit": {
        "desc": "Ajuste laboral y adaptación en el lugar de trabajo",
        "name": "Ajuste laboral y adaptación"
      },
      "housing": {
        "name": "Estabilidad de vivienda",
        "description": "Encontrar, instalarse y sentirse seguro en tu hogar.",
        "obj1": "Asegurar una vivienda estable y adecuada",
        "obj2": "Reducir el estrés relacionado con la vivienda",
        "obj3": "Instalarse en el vecindario",
        "q1": "¿Qué tan satisfecho estás con tu situación de vivienda actual?",
        "q1_hh": "¿Qué tan satisfecha está tu familia con su situación de vivienda actual?",
        "q2": "¿Qué tan seguro te sientes acerca de tus arreglos de vivienda?",
        "q2_hh": "¿Qué tan segura se siente tu familia acerca de sus arreglos de vivienda?",
        "q3": "¿Qué tan bien conoces tu área local y sus servicios?",
        "qPreMove": "¿Qué tan preparado te sientes acerca de tus arreglos de vivienda para la mudanza?"
      },
      "schooling": {
        "name": "Educación y cuidado infantil",
        "description": "Los arreglos de educación y cuidado infantil de tus hijos.",
        "obj1": "Inscribir a los niños en una educación adecuada",
        "obj2": "Organizar cuidado infantil confiable",
        "obj3": "Ayudar a los niños a integrarse socialmente",
        "q1": "¿Qué tan satisfecho estás con los arreglos educativos de tus hijos?",
        "q2": "¿Qué tan bien se han adaptado tus hijos a su nueva escuela?",
        "q3": "¿Qué tan manejable es tu situación de cuidado infantil?"
      },
      "work": {
        "name": "Ajuste laboral",
        "description": "Qué tan bien te has adaptado a tu nuevo rol y lugar de trabajo.",
        "obj1": "Adaptarse al nuevo rol",
        "obj2": "Integrarse con el equipo",
        "obj3": "Entender la cultura del lugar de trabajo",
        "q1": "¿Qué tan bien sientes que encajas en tu lugar de trabajo?",
        "q2": "¿Qué tan claros son tu rol y responsabilidades?",
        "q3": "¿Qué tan apoyado te sientes por tu equipo?",
        "q4": "¿Qué tan seguro te sientes en tu trabajo diario?",
        "qMonth3": "Tres meses después, ¿qué tan asentado te sientes en tu rol?"
      },
      "wellbeing": {
        "name": "Bienestar y social",
        "description": "Tu bienestar general y conexiones sociales.",
        "obj1": "Mantener el bienestar emocional",
        "obj2": "Construir conexiones sociales",
        "obj3": "Apoyar la integración de compañeros",
        "q1": "¿Cómo calificarías tu bienestar general?",
        "q1_hh": "¿Cómo calificarías el bienestar general de tu familia?",
        "q2": "¿Qué tan conectado te sientes con las personas a tu alrededor?",
        "q2_hh": "¿Qué tan conectada se siente tu familia con las personas a su alrededor?",
        "q3": "¿Qué tan bien estás manejando la vida diaria aquí?",
        "q4": "¿Qué tan optimista te sientes acerca de instalarte?",
        "q4_hh": "¿Qué tan optimista se siente tu familia acerca de instalarse?",
        "qMonth1": "Un mes después, ¿qué tan conectado te sientes con las personas aquí hasta ahora?"
      }
    },
    "pillarCommunication": "Comunicación",
    "pillarHousingStability": "Estabilidad de vivienda",
    "pillarHousingStabilityDesc": "Vivienda temporal/definitiva, estrés, riesgo",
    "pillarIntegration": "Comportamiento y adaptación",
    "pillarSchoolingChildcare": "Estabilidad escolar/guardería",
    "pillarSchoolingChildcareDesc": "Arreglos educativos y de cuidado infantil (si corresponde)",
    "pillarSelector": {
      "conditional": "Condicional",
      "desc": "Recomendamos estos pilares según tu perfil. Puedes ajustarlos.",
      "selected": "seleccionado",
      "title": "Elige tus áreas de enfoque"
    },
    "pillarTechnical": "Habilidades técnicas",
    "pillarWellbeing": "Bienestar y adaptación social",
    "pillarWellbeingDesc": "Salud mental, conexiones sociales y bienestar general",
    "pillarWorkFit": "Ajuste y adaptación laboral",
    "pillarWorkFitDesc": "Ajuste laboral y adaptación en el lugar de trabajo",
    "pillars": {
      "housingStability": "Estabilidad de vivienda",
      "schoolingChildcare": "Educación y cuidado infantil",
      "title": "Pilares de Care",
      "wellbeingSocial": "Bienestar y social",
      "workFit": "Ajuste laboral y adaptación"
    },
    "plan": {
      "active": "Debido ahora",
      "assessmentDone": "Evaluación completa",
      "completed": "Completado",
      "encouragement": "Cada punto de control nos ayuda a entender cómo te estás adaptando y cómo podemos apoyarte mejor.",
      "focusAreas": "Tus áreas de enfoque",
      "locked": "Próximamente",
      "milesReward": "+{{miles}} Miles",
      "milestones": "Hitos del punto de control"
    },
    "preferences": {
      "afternoon": "Tarde",
      "daily": "Diario",
      "desc": "Dile a Care cuándo y con qué frecuencia debe comunicarse contigo. Puedes cambiar esto en cualquier momento.",
      "evening": "Noche",
      "frequencyLabel": "Frecuencia",
      "moodReminder": "Recordatorio de estado de ánimo",
      "moodReminderDesc": "Recibe un suave recordatorio para registrar cómo te sientes.",
      "morning": "Mañana",
      "timeLabel": "Hora preferida",
      "title": "Preferencias de Care",
      "weekdays": "Días laborables",
      "weekly": "Semanal"
    },
    "proFeature": "Función Pro — Actualiza para acceder",
    "proFeatureDescription": "Actualiza a Pro para acceder a todas las funciones de Care, ciclos de retroalimentación y apoyo.",
    "proFeatureTitle": "Care y soporte — Función Pro",
    "progressOverTime": "Tu progreso a lo largo del tiempo",
    "quickCheckin": {
      "concern": "¿Hay alguna área que te gustaría señalar?",
      "continue": "Continuar",
      "notes": "¿Algo más que te gustaría compartir?",
      "overall": "¿Cómo te sientes esta semana en general?",
      "copilotPrompts": {
        "concern": "¿Hay alguna área que te gustaría señalar?",
        "notes": "¿Algo más que te gustaría compartir?",
        "overall": "¿Cómo te sientes en general esta semana?"
      },
      "error": {
        "message": "No pudimos guardar tu registro. Por favor, inténtalo de nuevo.",
        "title": "Algo salió mal"
      },
      "finish": "Finalizar",
      "intro": {
        "quickEasy": "Rápido y fácil",
        "quickEasyDesc": "Solo 3-5 preguntas, toma 2 minutos",
        "subtitle": "CoPilot te guiará a través de algunas preguntas",
        "trackProgress": "Rastrear progreso",
        "trackProgressDesc": "Comparar con tus registros anteriores"
      },
      "processing": {
        "subtitle": "CoPilot está preparando tus insights...",
        "title": "Analizando tus respuestas"
      },
      "questionOf": "Pregunta {{current}} de {{total}}",
      "questions": {
        "notesPlaceholder": "Escribe tus pensamientos aquí...",
        "qcConcern": "¿Hay alguna área que te gustaría señalar?",
        "qcNotes": "¿Algo más que te gustaría compartir?",
        "qcOverall": "¿Cómo te sientes esta semana en general?",
        "qcOverallLabels": ["Muy mal", "Mal", "Regular", "Bien", "Genial"]
      },
      "results": {
        "areasOfConcern": "Áreas de preocupación",
        "milesEarned": "+{{miles}} Miles ganadas",
        "moodScoreOf": "Puntuación de estado de ánimo de {{score}}",
        "nextStep1": "Continúa tus registros diarios para rastrear tu bienestar a lo largo del tiempo",
        "title": "¡Registro completo!",
        "today": "Hoy",
        "trendTitle": "Tendencia",
        "whatsNext": "¿Qué sigue?",
        "yesterday": "Ayer",
        "yourNotes": "Tus notas",
        "concernHint": "CoPilot dará seguimiento a estas áreas",
        "nextStep2": "CoPilot rastreará tus tendencias a lo largo del tiempo",
        "nextStep3": "Recibirás consejos personalizados para áreas señaladas"
      },
      "selectAll": "Selecciona todo lo que aplique",
      "alreadyDone": {
        "title": "Estás listo para hoy",
        "message": "Ya has completado el registro de hoy. ¡Vuelve mañana!"
      },
      "doneToday": "Completado hoy",
      "shortDesc": "Chequeo rápido diario de bienestar",
      "startButton": "Iniciar registro",
      "title": "Registro rápido",
      "milesReward_one": "+{{count}} Mile",
      "milesReward_other": "+{{count}} Miles"
    },
    "rateProgress": "¿Cómo calificarías tu progreso?",
    "recentCycles": "Tus puntos de control recientes",
    "requestSupport": "Solicitar soporte",
    "responses": "respuestas",
    "retakeAssessment": "Repetir evaluación",
    "retakeOnWeb": "Reevaluar en la web",
    "retakeOnWebDesc": "Para retomar tu evaluación Care, utiliza el portal web Citizen.",
    "returnToDashboard": "Volver al tablero",
    "risk": {
      "checkinGap": "Un largo intervalo desde el último registro",
      "crossHeroStall": "Sin actividad de TelePortal o QultureUp en más de 30 días",
      "isolation": "Bajas puntuaciones sociales/de bienestar en los puntos de control recientes",
      "missedCheckpoint": "Un punto de control está {{overdueDays}} días atrasado",
      "moodDecline": "Estado de ánimo bajo durante {{consecutive}} registros consecutivos",
      "pillarDrop": "{{pillar}} bajó {{drop}} pts desde el último punto de control"
    },
    "selectPillarOrTheme": "Seleccionar pilar o tema",
    "selectPillarOrThemePlaceholder": "Elige un pilar o tema",
    "selectSeverity": "Seleccionar gravedad (opcional)",
    "selfFeedback": "Autoevaluación",
    "severity": {
      "high": "Alto",
      "low": "Bajo",
      "medium": "Medio",
      "urgent": "Urgente"
    },
    "severityHigh": "Alto",
    "severityLow": "Bajo",
    "severityMedium": "Medio",
    "shareThoughts": "Comparte tus pensamientos sobre {{pillar}}...",
    "startCheckpoint": "Iniciar punto de control",
    "startOnWeb": "Comienza en Citizen Web",
    "startOnWebDesc": "Configura tu evaluación Care en el portal web Citizen (unos 5 minutos). Una vez hecho, los registros diarios y los puntos de control ocurren aquí en la aplicación.",
    "status": {
      "closed": "Cerrado",
      "in_progress": "En progreso",
      "open": "Abrir",
      "resolved": "Resuelto"
    },
    "statusInProgress": "En progreso",
    "statusOpen": "Abrir",
    "statusResolved": "Resuelto",
    "streak": {
      "awesome": "¡Increíble!",
      "dayStreak": "¡Racha de {{days}} días!",
      "badges": {
        "starter": "Primeros pasos",
        "weeklyWarrior": "Una semana entera",
        "consistent": "Dos semanas de cuidado",
        "monthlyChampion": "Un mes entero",
        "dedicated": "Dos meses de cuidado",
        "unstoppable": "Imparable"
      }
    },
    "submitCheckpoint": "Enviar punto de control",
    "submitRequest": "Enviar solicitud",
    "suggestionMicroLearning": "Recomendaciones de micro-aprendizaje",
    "suggestionQultureUp": "Lecciones recomendadas de QultureUp",
    "suggestionSelfHelp": "Contenido de autoayuda",
    "suggestionTelePortal": "Tareas de TelePortal",
    "support": {
      "footer": "Elige de qué se trata para pedir ayuda a quien acompaña tu mudanza.",
      "openRequests": "Solicitudes de soporte abiertas",
      "statusInProgress": "En progreso",
      "statusOpen": "Abrir",
      "subtitle": "Obtén ayuda con desafíos específicos",
      "title": "¿Necesitas soporte?"
    },
    "supportCommunication": "Comunicación",
    "supportCultural": "Ajuste cultural",
    "supportDescription": "Obtén ayuda con desafíos específicos",
    "supportHelpText": "Selecciona un tema para obtener recomendaciones personalizadas de Tonnie CoPilot o solicita apoyo humano de nuestro equipo.",
    "supportHousing": "Vivienda",
    "supportRequestActions": "Acciones",
    "supportRequestDetails": "Detalles de la solicitud de soporte",
    "supportRequestDetailsDesc": "Ver detalles y actualizaciones de tu solicitud de soporte",
    "supportRequestSubmitted": "¡Solicitud de soporte enviada! Nuestro equipo se pondrá en contacto contigo pronto.",
    "supportRequestsOpen": "Solicitudes abiertas",
    "supportSchooling": "Educación",
    "supportTeamWillRespond": "Nuestro equipo de soporte responderá a tu solicitud pronto.",
    "supportTechnical": "Técnico",
    "supportWellbeing": "Bienestar",
    "tabs": {
      "checkins": "Check-ins",
      "checkpoints": "Puntos de control",
      "objectives": "Objetivos",
      "overview": "Resumen",
      "support": "Soporte"
    },
    "teamLead": "Líder de equipo",
    "thermometer": {
      "mood": "Estado de ánimo",
      "settlement": "Liquidación",
      "wellbeing": "Bienestar"
    },
    "title": "Care y soporte",
    "todaysCare": "Care de hoy",
    "tonnieSupport": "Soporte de Tonnie",
    "topic": "Tema",
    "trust": {
      "checkpoint": {
        "how": "Ayuda a Tonnie a proporcionar apoyo y orientación específicos.",
        "who": "Tus respuestas son privadas. Las empresas solo ven resúmenes agregados.",
        "why": "Los puntos de control nos ayudan a entender cómo te estás adaptando y dónde se necesita apoyo."
      },
      "questions": {
        "how": "Ayuda a identificar opciones de apoyo adaptadas a ti.",
        "who": "Solo tú y el soporte de Tonnie pueden ver tus respuestas. Las empresas ven tendencias agregadas.",
        "why": "Hacemos estas preguntas para entender tu ajuste actual."
      },
      "quickCheckin": {
        "how": "Ayuda a personalizar el apoyo y mantener tu ajuste en el camino correcto.",
        "who": "Solo tú y el soporte de Tonnie pueden ver tus respuestas. Las empresas ven tendencias agregadas únicamente.",
        "why": "Chequeos rápidos nos ayudan a entender tu bienestar diario y detectar necesidades de apoyo temprano."
      },
      "results": {
        "how": "Los insights ayudan a CoPilot a dar mejores recomendaciones.",
        "who": "Solo tú y el soporte de Tonnie. Las empresas ven tendencias agregadas únicamente.",
        "why": "Tus datos de chequeo nos ayudan a rastrear tu bienestar a lo largo del tiempo."
      }
    },
    "tryAgainLater": "Por favor, intenta de nuevo más tarde.",
    "unableToLoadData": "No se pudo cargar los datos de Care",
    "upcoming": "Próximamente",
    "updates": "Actualizaciones",
    "weekPulse": {
      "title": "Pulso semanal"
    },
    "welcome": {
      "description": "Care te apoya a lo largo de tu viaje de reubicación. Esta configuración única toma unos 5 minutos en Citizen Web: después de eso, tus registros diarios y el apoyo al bienestar están aquí en la aplicación.",
      "familyStep": "Familia y trabajo",
      "familyStepDesc": "Rastrea la adaptación familiar, la escolarización y la integración en el lugar de trabajo",
      "letsStart": "Empecemos",
      "settlingStep": "Instalándose",
      "settlingStepDesc": "Rastrea tu estabilidad habitacional y la comodidad de tu vida diaria",
      "timeEstimate": "Toma alrededor de 5 minutos para completar",
      "title": "Bienvenido a Care",
      "wellbeingStep": "Bienestar y social",
      "wellbeingStepDesc": "Revisa tu salud emocional y conexiones sociales"
    },
    "yourChallenge": "tu desafío",
    "yourRating": "Tu calificación",
    "interactions": {
      "title": "Con tu equipo",
      "subtitle": "Llamadas y reuniones que tu equipo patrocinador ha organizado",
      "upcoming": "Próximamente",
      "past": "Hecho",
      "type": {
        "call": "Llamada",
        "video_call": "Videollamada",
        "in_person_meeting": "Reunión en persona",
        "message": "Mensaje",
        "request_checkin": "Chequeo"
      }
    },
    "momentum": {
      "event": {
        "checkin": "Te has chequeado",
        "checkpoint": "Punto de control completado",
        "feedback": "Has compartido comentarios",
        "intervention": "Tu equipo se ha puesto en contacto",
        "generic": "Actividad de Care"
      }
    },
    "zone": {
      "youToday": "Tú hoy",
      "forYou": "Para ti",
      "yourProgress": "Tu progreso"
    },
    "assessmentDimension": {
      "baseline": "Línea base emocional",
      "baselineDesc": "Tu estado de ánimo, energía y niveles de estrés actuales",
      "pillars": "Pilares de bienestar",
      "pillarsDesc": "Selecciona las áreas de enfoque que más te importan",
      "preferences": "Preferencias de registro",
      "preferencesDesc": "Cómo y cuándo quieres ser apoyado"
    },
    "milesAwarded_one": "+{{count}} Mile",
    "milesAwarded_other": "+{{count}} Miles",
    "supportRequest": {
      "title": "Pedir apoyo",
      "subtitle": "Cuéntale a quien acompaña tu mudanza lo que necesitas.",
      "pillarLabel": "¿De qué se trata?",
      "severityLabel": "¿Cuánta urgencia tiene?",
      "descriptionLabel": "¿Qué está pasando?",
      "descriptionPlaceholder": "Con tus palabras: qué ha pasado y qué te ayudaría.",
      "descriptionHint": "Al menos {{min}} caracteres.",
      "descriptionCount": "{{count}}/{{max}}",
      "send": "Enviar solicitud",
      "sent": "Tu solicitud se ha enviado.",
      "failed": "Tu solicitud no se ha enviado. Inténtalo de nuevo.",
      "waitingForConnection": "No tienes conexión: la solicitud se enviará cuando vuelvas a tenerla.",
      "trustWhy": "Para que la solicitud llegue a las personas adecuadas, con lo que necesitan para ayudarte.",
      "trustWho": "Tú y la empresa que patrocina este viaje, si compartes Care con ella.",
      "trustHow": "La solicitud se guarda en el Care de este viaje.",
      "validation": {
        "pillarRequired": "Elige de qué se trata.",
        "descriptionShort": "Cuéntanos un poco más: al menos {{min}} caracteres.",
        "descriptionLong": "Usa como máximo {{max}} caracteres."
      }
    }
  },
  "career": {
    "achievementsSummary": "Logros relevantes de Career",
    "allLocations": "Todas las ubicaciones",
    "allOpportunities": "Todas las oportunidades",
    "allTypes": "Todos los tipos",
    "apply": "Aplicar",
    "avgMatch": "Promedio de coincidencia",
    "careerOverviewDesc": "Resumen de tu preparación profesional y perfil",
    "careerReadiness": "Preparación de Career",
    "careerReady": "Career listo",
    "categoryCareer": "Servicios de Career",
    "categoryEducation": "Educación",
    "categoryNetworking": "Redes",
    "checkBackLater": "Vuelve más tarde para nuevas coincidencias",
    "contract": "Contrato",
    "copilotAnalysis": "Análisis cerebral de CoPilot para {{title}}",
    "createCV": "Crear CV",
    "createOrEditCV": "Crear o editar CV",
    "createYourFirstCV": "Crea tu primer CV profesional para mostrar tus habilidades",
    "cv": {
      "downloadError": "Error al descargar el CV",
      "generateError": "Error al generar el CV"
    },
    "cvDownloaded": "{{format}} CV para {{opportunityTitle}} descargado con éxito",
    "cvView": "Constructor de CV",
    "cvViewDescription": "Crea y gestiona tu CV profesional para solicitudes de empleo",
    "cvsGenerated": "CVs generados",
    "description": "Descubre oportunidades y haz crecer tu carrera",
    "disableProactive": "Deshabilitar aplicaciones proactivas",
    "downloadCV": "Descargar CV",
    "downloadPDF": "Descargar PDF",
    "downloadWord": "Descargar word",
    "ecosystemPartners": "Socios del ecosistema",
    "editCV": "Editar CV",
    "enableProactive": "Habilitar aplicaciones proactivas",
    "experience": "Experiencia",
    "experienceMatchDesc": "Tu experiencia coincide con el rol",
    "fullTime": "A tiempo completo",
    "gotIt": "Entendido",
    "highMatchOpportunities": "Oportunidades de alta coincidencia",
    "iWantIt": "Lo quiero...",
    "improveMatchText": "Considera mejorar habilidades relevantes o niveles de idioma para aumentar tu puntuación de coincidencia.",
    "languages": "Idiomas",
    "lastGenerated": "Última generación",
    "lastUpdated": "Última actualización",
    "learnMore": "Aprender más",
    "letCompaniesFind": "Deja que las empresas te encuentren",
    "levelLabel": "Nivel",
    "lisbon": "Lisboa",
    "location": "Ubicación",
    "locationMatchDesc": "La ubicación del trabajo se ajusta a tus preferencias",
    "mainRole": "Rol principal",
    "match": "Coincidencia",
    "matchQuality": "Calidad de coincidencia",
    "matchScore": "Puntuación de coincidencia",
    "matchScoreLabel": "Puntuación de coincidencia",
    "matchingOpportunities": "Oportunidades de coincidencia",
    "mostRecentCV": "CV más reciente",
    "noCVsYet": "No se han creado CVs aún",
    "noDescription": "No hay descripción disponible",
    "noOpportunities": "No se encontraron oportunidades",
    "noSavedOpportunities": "No hay oportunidades guardadas aún",
    "notSpecified": "No especificado",
    "opportunitiesFound": "Oportunidades encontradas",
    "opportunitiesSaved": "Oportunidades guardadas",
    "opportunitiesView": "Oportunidades",
    "opportunityRemoved": "Oportunidad eliminada de guardados",
    "opportunityRequirements": "Requisitos de oportunidad",
    "opportunitySaved": "Oportunidad guardada",
    "partTime": "A tiempo parcial",
    "partnerCVDesc": "Revisión y optimización de CV",
    "partnerLinguaDesc": "Cursos de idiomas profesionales",
    "partnerNetworkDesc": "Eventos de networking profesional",
    "partnersDescription": "Socios de Tonnie-Checked para acelerar tu viaje profesional",
    "porto": "Oporto",
    "proactiveApplications": "Solicitudes proactivas",
    "proactiveDescription": "Habilita tu perfil para que sea visible para reclutadores y empresas que buscan talento como tú.",
    "proactiveDisabled": "Solicitudes proactivas deshabilitadas. Tu perfil ya no es visible para reclutadores.",
    "proactiveEnabled": "¡Solicitudes proactivas habilitadas! Las empresas ahora pueden encontrarte.",
    "professionalCV": "CV profesional",
    "profileComplete": "Perfil completo",
    "profileCompleteness": "Completitud del perfil",
    "profileLabel": "Perfil",
    "readinessLabel": "Preparación",
    "readinessMessage": "Estás bien preparado para oportunidades internacionales. ¡Sigue mejorando tus habilidades lingüísticas!",
    "readyToApply": "Listo para aplicar",
    "recentCVs": "CVs recientes",
    "remote": "Remoto",
    "removeFromSaved": "Eliminar de guardados",
    "requiredSkills": "Habilidades requeridas",
    "save": "Guardar",
    "saveOpportunitiesMessage": "Guarda oportunidades para verlas aquí más tarde",
    "saved": "Guardado",
    "savedJobs": "Trabajos guardados",
    "savedOpportunities": "Oportunidades guardadas ({{count}})",
    "savedOpportunitiesTab": "Oportunidades guardadas",
    "savedOpportunitiesTitle": "Oportunidades guardadas",
    "sharedKeyAchievements": "Logros clave y hitos de Passport",
    "sharedProfileSnapshot": "Resumen del perfil (rol, habilidades, experiencia)",
    "sharedReadinessScore": "Puntuación de preparación (iQulture) y desglose de MESH",
    "skills": "Habilidades",
    "skillsMatchDesc": "Tus habilidades se alinean con los requisitos del trabajo",
    "targetCountries": "Países objetivo",
    "tipsToImprove": "💡 consejos para mejorar la coincidencia:",
    "title": "Career, oportunidades y constructor de CV",
    "total": "Total",
    "type": "Tipo",
    "unsave": "Desguardar",
    "untitledCV": "CV sin título",
    "viewAllCVs": "Ver todos los CVs ({{count}})",
    "whatWillBeShared": "Lo que se compartirá:",
    "why": "¿Por qué?",
    "whyMatch": "¿Por qué esta coincidencia?",
    "years": "años",
    "yourCV": "Tu CV",
    "yourReadiness": "Tu preparación",
    "highMatchCount_one": "{{count}} alta coincidencia",
    "highMatchCount_other": "{{count}} altas coincidencias",
    "rolesFound_one": "{{count}} rol encontrado",
    "rolesFound_other": "{{count}} roles encontrados",
    "savedOpportunitiesDescription_one": "{{count}} oportunidad guardada para revisar más tarde",
    "savedOpportunitiesDescription_other": "{{count}} oportunidades guardadas para revisar más tarde"
  },
  "checkup": {
    "aboutDescription": "Esta evaluación evalúa tu preparación en múltiples dimensiones:",
    "achievement": "Logro",
    "additionalSkills": "Habilidades adicionales",
    "aiTalentSnapshot": "Instantánea de talento AI",
    "allSet": "Estás listo",
    "allSetDesc": "Tu CheckUp está completo. Ahora podemos construir tu viaje.",
    "analyzingTitle": "Analizando tu perfil de iQulture",
    "areasToWatch": "Áreas a vigilar",
    "assessmentDescription": "Evalúa tu preparación internacional",
    "assessmentHistory": "Historial de evaluaciones",
    "assessmentResults": "Resultados de la evaluación",
    "assessmentSubmitted": "Evaluación enviada",
    "assessmentTitle": "Evaluación de CheckUp",
    "badge": {
      "explorer": "Explorador",
      "explorerTagline": "Comenzando tu viaje internacional",
      "globalPro": "Pro global",
      "globalProTagline": "Listo para el éxito internacional",
      "risingStar": "Estrella en ascenso",
      "risingStarTagline": "Construyendo bases sólidas"
    },
    "badgeAlt": "{{badge}} insignia",
    "band": {
      "noob": "NOOB",
      "potential": "POTENCIAL",
      "pro": "PRO"
    },
    "bandLabels": {
      "emerging": "Emergente",
      "growing": "Creciendo",
      "power": "Poder",
      "strong": "Fuerte"
    },
    "buildJourneyCta": "Construir mi camino",
    "buildJourneyTitle": "¿Listo para construir tu camino?",
    "calcTimeEstimate": "Acerca de 30 segundos",
    "calculateScore": "Calcular mi puntuación",
    "calculating": "Calculando…",
    "calculatingAriaLabel": "Calculando tu puntuación",
    "calculatingDesc": "Analizando tus respuestas para generar tu evaluación personalizada de MESH...",
    "calculatingScore": "Calculando tu puntuación…",
    "calculatingTitle": "Calculando tu puntuación de iQulture…",
    "calculationComplete": "Cálculo completo",
    "calculationError": "Error al iniciar el cálculo. Por favor, inténtalo de nuevo.",
    "calculationTimedOut": "Tu cálculo de CheckUp ha superado el tiempo de espera. Por favor, inténtalo de nuevo.",
    "cancelConfirm": {
      "error": "No se pudo cancelar tu CheckUp. Por favor, inténtalo de nuevo.",
      "success": "CheckUp cancelado. Puedes iniciar uno nuevo en cualquier momento."
    },
    "capture": {
      "acceptedFormats": "Acepta fotos, PDFs, documentos de Word y más",
      "backToTask": "Volver a la tarea",
      "backToTelePortal": "Volver a TelePortal",
      "cameraPermissionRequired": "Se requiere acceso a la cámara para escanear documentos.",
      "cameraScanHint": "Apunta tu cámara al documento para obtener el mejor escaneo de calidad",
      "chooseAnother": "Elegir otro",
      "fieldDocType": "Tipo de documento",
      "fieldFile": "Archivo",
      "removeFile": "Eliminar",
      "retakeCamera": "Repetir",
      "selectDocType": "Seleccionar tipo de documento",
      "sourceCamera": "Escaneo con cámara",
      "sourceFiles": "Examinar archivos",
      "sourceGallery": "Biblioteca de fotos",
      "tapSelectDocType": "Toca para seleccionar tipo de documento",
      "tryAgain": "Intenta de nuevo",
      "uploadButton": "Subir documento",
      "uploadFailed": "Carga fallida",
      "uploaded": "Documento subido",
      "uploadedDesc": "Tu {{type}} ha sido cargado y adjuntado.",
      "uploading": "Cargando tu documento…",
      "uploadingNote": "Esto puede tardar un momento"
    },
    "chat": {
      "clickToUpload": "Haz clic para subir",
      "notAtAll": "Para nada",
      "typeMessage": "Escribe un mensaje…",
      "typeYourAnswer": "Escribe tu respuesta…",
      "veryMuch": "Mucho"
    },
    "checkAgain": "Verifica de nuevo",
    "checkAgainHelp": "Completa los requisitos anteriores y luego haz clic en 'Verifica de nuevo'",
    "checkupHistory": "Historia de CheckUp",
    "checkupHistoryDesc": "Ver tus evaluaciones anteriores de CheckUp",
    "companyAverage": "El promedio de tu empresa",
    "companyCohort": "Cohorte de la empresa",
    "comparisonsDescription": "Tu puntuación comparada con otros",
    "comparisonsTitle": "Cómo te comparas",
    "completeMoreCheckUps": "Completa más CheckUps para ver tu evolución",
    "completeTitle": "¡Evaluación completa!",
    "conclusionDesc": "Análisis completo de tu preparación internacional",
    "congratulations": "¡Felicidades por completar tu iQulture CheckUp!",
    "copilotGuideDescription": "Responde preguntas sobre tu experiencia y objetivos",
    "copilotGuideTitle": "Guía de CoPilot",
    "couldNotLoadResults": "No pudimos cargar tus resultados de CheckUp. Por favor, inténtalo de nuevo.",
    "description": "Evaluación integral de preparación internacional 360°",
    "didYouKnow": "¿Sabías que?",
    "dimensionInternational": "Experiencia internacional",
    "dimensionLanguage": "Dominio del idioma",
    "dimensionMotivation": "Motivación y mentalidad",
    "dimensionProfessional": "Experiencia profesional y habilidades",
    "dontCloseWarning": "Por favor, no cierres esta página.",
    "downloadReport": "Descargar informe completo",
    "elapsed": "transcurrido",
    "errorDescription": "Algo salió mal al cargar tu CheckUp. Por favor, inténtalo de nuevo.",
    "errorMessage": "No se pudo calcular tu CheckUp. Por favor, inténtalo de nuevo.",
    "errorTitle": "¡Ups! Algo salió mal",
    "estimated": "Estimado",
    "estimatedRemaining": "~{{minutes}}m restantes",
    "estimatedTime": "Tiempo estimado",
    "evaluationRadar": "Radar de evaluación",
    "exportGenerating": "Generando exportación...",
    "exportPDFDescription": "En producción, esto generaría un PDF con tus resultados de CheckUp.",
    "exportResults": "Exportar resultados",
    "exportSuccess": "Resultados de CheckUp exportados con éxito",
    "filePickUnavailable": "La selección de archivos no está disponible actualmente.",
    "finalMessage": "Has completado una evaluación integral de preparación internacional 360°. Tu insignia {{badge}} refleja bases sólidas en motivación, adaptabilidad cultural y comunicación. Concéntrate en el {{plan}} para fortalecer tus habilidades técnicas y estarás listo para oportunidades globales.",
    "finalScore": "Puntuación final",
    "goToCheckUp": "Ir a CheckUp",
    "goToQultureUp": "Ir a QultureUp",
    "goToTelePortal": "Ir a TelePortal",
    "greenFlags": "Banderas verdes",
    "heroMiles": "Miles de CheckUp",
    "iqultureBand": "Grupo de iQulture",
    "journeyStepsSubtitle": "Esto es lo que necesitamos para evaluar tu preparación.",
    "languageTests": {
      "analyzeResult": "Subir y analizar",
      "analyzing": "Analizando...",
      "attention": "Atención:",
      "attentionText": "Guarda tu resultado como captura de pantalla, o descárgalo como PDF con texto seleccionable ",
      "changeFile": "Cambiar archivo",
      "completedTest": "Prueba completada",
      "dropHere": "Haz clic para seleccionar el archivo de tu resultado",
      "englishTests": "Pruebas de inglés",
      "iUnderstand": "Entiendo, continuar",
      "immediatelyAfter": "inmediatamente después de completar la prueba",
      "importantInstructions": "Instrucciones importantes",
      "instructions": "Sube tu resultado como captura de pantalla (PNG, JPG, WEBP o GIF), PDF con texto seleccionable o documento Word (.docx). Leemos el nivel automáticamente.",
      "languageTests": "Pruebas de idioma",
      "listening": "Escuchando",
      "lowConfidenceHint": "Detectamos un resultado pero no pudimos leerlo con confianza. Por favor, revisa y confirma.",
      "modalDesc": "Añade un resultado de prueba de idioma para fortalecer tu perfil.",
      "openPlatform": "Abrir plataforma de pruebas",
      "openPlatformHint": "Abre la plataforma de pruebas para descargar tu certificado.",
      "portugueseTests": "Pruebas de portugués",
      "reUpload": "Re-subir",
      "readCarefully": "Por favor, lee el certificado cuidadosamente antes de subirlo.",
      "reading": "Lectura",
      "readyToStart": "¿Listo para hacer la prueba?",
      "referenceHint": "Utiliza un certificado reciente (de menos de 2 años).",
      "referenceImage": "Referencia: Página de resultados esperados",
      "resultDetected": "Resultado detectado",
      "resultLowConfidence": "Resultado detectado — por favor confirma",
      "retakeWarning": "Ya tienes un resultado para esta prueba. Subir uno nuevo reemplazará la puntuación anterior.",
      "sampleHint": "Certificados de muestra: PDF, JPG, PNG.",
      "sampleResults": "Página de resultados de muestra",
      "screenshotReminder": "Recuerda capturar tus resultados",
      "screenshotReminderDetail": "Asegúrate de que tu nombre y la puntuación sean visibles en el archivo que subas.",
      "speaking": "Hablando",
      "stepConfirm": "Confirmar",
      "stepInstructions": "Instrucciones",
      "stepTakeTest": "Hacer prueba",
      "stepUpload": "Subir",
      "submitResult": "Enviar resultado",
      "submitted": "¡Resultado enviado!",
      "submittedHint": "Has enviado un resultado. Lo revisaremos y actualizaremos tu puntuación en breve.",
      "supportedFormats": "Formatos admitidos: PNG, JPG, WEBP, GIF, PDF (con texto seleccionable), DOCX. Un PDF escaneado o una imagen dentro de un archivo Word no se puede leer.",
      "testOpened": "Plataforma de prueba abierta en una nueva pestaña",
      "uploadFailed": "Error al subir. Por favor, inténtalo de nuevo.",
      "uploadFailedError": "La subida falló. Por favor, inténtalo de nuevo.",
      "uploadSuccess": "Resultado de la prueba enviado a tu Vault",
      "uploading": "Subiendo...",
      "useThisExtension": "usa esta extensión",
      "alt": {
        "screenshotPreview": "Vista previa de captura de pantalla",
        "reference": "Referencia",
        "sampleResults": "Resultados de muestra",
        "uploadedResult": "Resultado subido"
      },
      "failed": {
        "title": "No hemos podido leer un resultado en este archivo",
        "languageMismatch": "Este certificado parece acreditar un idioma distinto al de esta prueba. Sube el certificado del idioma de esta prueba.",
        "unsupportedDocument": "No podemos leer este archivo. Sube una imagen PNG, JPG, WEBP o HEIC, un PDF o un documento Word (.docx).",
        "archiveTooLarge": "Este documento Word es demasiado grande para que podamos leerlo. Sube en su lugar tu resultado como imagen (PNG, JPG o HEIC) o como PDF.",
        "docxEmpty": "Este documento Word no tiene texto ni imagen que podamos leer. Sube en su lugar tu resultado como imagen (PNG, JPG o HEIC) o como PDF.",
        "tooManyPages": "Este documento tiene más de {{max}} páginas. Sube solo las páginas que muestran tu resultado.",
        "noLevelFound": "No hemos encontrado un nivel MCER (A1–C2) en este archivo. Comprueba que tu resultado muestra tu nivel e inténtalo de nuevo.",
        "serviceUnavailable": "Nuestro servicio de análisis no ha podido procesar tu archivo ahora mismo. Inténtalo de nuevo en unos minutos.",
        "notCompletedHint": "Esta prueba no se marca como completada hasta que se lea un nivel en tu certificado."
      },
      "cefrLevel": {
        "a1": "Principiante",
        "a2": "Elemental",
        "b1": "Intermedio",
        "b2": "Intermedio alto",
        "c1": "Avanzado",
        "c2": "Maestría",
        "native": "Hablante nativo"
      },
      "notDone": "Pendiente"
    },
    "lastAssessment": "Última evaluación: {{date}}",
    "lastCheckup": "Último CheckUp",
    "legend": {
      "attention": "Atención",
      "critical": "Crítico",
      "excellent": "Excelente",
      "good": "Bueno"
    },
    "loadingAssessment": "Cargando evaluación…",
    "measureReadiness": "Mide tu preparación",
    "mesh": {
      "english": "Inglés / Realidad lingüística",
      "englishDesc": "Tus habilidades lingüísticas son fuertes, con excelente dominio del inglés y buen progreso en portugués.",
      "englishRec1": "Continúa practicando portugués en conversaciones diarias",
      "englishRec2": "Considera cursos de idiomas avanzados",
      "hardSkills": "Habilidades duras / Competencia profesional",
      "hardSkillsDesc": "Tu experiencia técnica es excelente y está bien alineada con el mercado objetivo.",
      "hardSkillsRec1": "Mantente actualizado con las últimas tecnologías",
      "hardSkillsRec2": "Considera certificaciones en tu campo",
      "motivation": "Motivación",
      "motivationDesc": "Tu motivación y mentalidad hacia la reubicación internacional son fuertes. Muestras objetivos claros y una actitud positiva.",
      "motivationRec1": "Mantén tu actitud positiva",
      "motivationRec2": "Establece objetivos y hitos claros",
      "softSkills": "Habilidades blandas y comportamientos",
      "softSkillsDesc": "Tienes una buena comprensión de las diferencias culturales, pero hay margen de mejora en la adaptación al lugar de trabajo.",
      "softSkillsRec1": "Completa QultureUp lecciones sobre la cultura local",
      "softSkillsRec2": "Involúcrate con comunidades locales"
    },
    "meshAnalysisDesc": "Motivación • Inglés • cultura suave • duras y otras",
    "meshAssessmentIntro": "La evaluación MESH mide los cuatro pilares de la preparación para una carrera internacional: Motivación, Inglés, Soft skills y Hard skills.",
    "meshBreakdown": "Desglose de MESH",
    "meshBreakdownDesc": "Tu preparación en Motivación, Inglés, Habilidades blandas y Habilidades duras",
    "meshInfo": {
      "E": "Inglés",
      "H": "Habilidades técnicas",
      "M": "Motivación",
      "S": "Habilidades blandas"
    },
    "meshReadinessEvaluation": "Evaluación de preparación de MESH",
    "monthsAgo": "hace meses",
    "motivational": {
      "questionNumber": "Pregunta {{number}}"
    },
    "nextStepsDesc": "Acciones para mejorar tu preparación",
    "noAssessmentYet": "Sin evaluación aún",
    "noCheckUpForJourney": "Este viaje aún no tiene un CheckUp.",
    "noHistory": "Aún no hay CheckUps anteriores",
    "noResultsDesc": "No has completado tu CheckUp aún. Completa para ver tu puntuación de preparación.",
    "noResultsForJourneyDesc": "Este viaje aún no tiene resultados de CheckUp. Completa la evaluación para ver tu puntuación.",
    "noResultsForJourneyTitle": "Sin resultados para este viaje",
    "noResultsTitle": "Sin resultados aún",
    "notReadyMessage": "Completa primero estos pasos y luego haz tu CheckUp.",
    "notReadyTitle": "¡Casi allí!",
    "now": "Ahora",
    "phase": {
      "dataCollection": "Recopilación de datos",
      "iqultureScoring": "Puntuación de iQulture",
      "meshAnalysis": "Análisis de MESH",
      "reportGeneration": "Generación de informes"
    },
    "photoLibraryUnavailable": "La biblioteca de fotos no está disponible en este momento.",
    "pillar": {
      "AR": {
        "brief": "Tus credenciales, certificaciones y aprendizaje continuo",
        "name": "Preparación académica"
      },
      "CP": {
        "brief": "Tu efectividad general en lenguaje y comunicación",
        "name": "Dominio de la comunicación"
      },
      "CP_ENGLISH": {
        "brief": "Tu dominio del inglés en contextos profesionales",
        "name": "Comunicación en Inglés"
      },
      "CP_NATIVE_TARGET": {
        "brief": "Tu dominio en idiomas nativos y del mercado objetivo",
        "name": "Idioma nativo/Objetivo"
      },
      "GPE": {
        "brief": "Tu historial de trabajo internacional/fronterizo",
        "name": "Experiencia profesional global"
      },
      "ICM": {
        "brief": "Qué tan claro y comprometido está tu plan de carrera internacional",
        "name": "Motivación internacional de Career"
      },
      "MA": {
        "brief": "Tu capacidad para adaptarte y prosperar en diferentes culturas",
        "name": "Adaptabilidad multicultural"
      },
      "PRM": {
        "brief": "Tu preparación mental y estrategias de afrontamiento para la reubicación",
        "name": "Resiliencia psicológica para la movilidad"
      },
      "WMF": {
        "brief": "Tu apertura a diferentes modalidades de trabajo (remoto/híbrido/en sitio)",
        "name": "Flexibilidad en el modelo de trabajo"
      }
    },
    "pillarsDesc": "Siete dimensiones clave de preparación internacional",
    "pillarsPassed": "Pilares superados",
    "plan90Days": "Plan de acción de 90 días",
    "pollingError": "No se pudo verificar el estado de cálculo. Por favor, inténtalo de nuevo.",
    "previousScore": "Tu puntuación anterior",
    "processingInitializing": "Inicializando cálculo de iQulture...",
    "processingStatus": "Estado del procesamiento",
    "processingSubtitle": "Esto puede tardar hasta 5 minutos. Por favor, no cierres esta página.",
    "processingTitle": "Analizando tu perfil de iQulture",
    "progressTitle": "Progreso de evaluación",
    "readinessCheckError": "No se pudo verificar la preparación. Por favor, inténtalo de nuevo.",
    "readinessScore": "Obtendrás tu puntuación de preparación",
    "readyForJourney": "Estás listo para tu viaje",
    "recommendation1Description": "Comienza a aprender sobre la cultura y las normas laborales portuguesas",
    "recommendation1Title": "Completa la evaluación de QultureUp",
    "recommendation2Description": "Obtén tu lista de verificación personalizada para la reubicación",
    "recommendation2Title": "Iniciar evaluación de TelePortal",
    "recommendation3Description": "Tu puntuación de comunicación es buena, pero la práctica hace al maestro",
    "recommendation3Title": "Continúa aprendiendo idiomas",
    "recommendations": "Recomendaciones",
    "recommendedNextSteps": "Próximos pasos recomendados",
    "redirecting": "Redirigiendo a tus resultados...",
    "requirementMissing": "Requisito faltante",
    "requirementsTitle": "Lista de verificación de requisitos",
    "results": {
      "activateSubtitle": "Tu CheckUp está completo. Aquí está tu camino a seguir.",
      "activateTitle": "Activa tu viaje",
      "activeJourney": "Activo",
      "areasRequiringAttention": "Áreas que requieren atención",
      "areasToWatch": "Áreas a vigilar",
      "assessedOn": "Evaluado {{date}}",
      "backToTop": "Volver arriba",
      "bandAttention": "Atención",
      "bandAttentionDesc": "Desarrollo — mejora específica recomendada",
      "bandAttentionRange": "60-69",
      "bandCritical": "Crítico",
      "bandCriticalDesc": "Necesita enfoque prioritario antes de avanzar",
      "bandCriticalRange": "Por debajo de 60",
      "bandExcellent": "Excelente",
      "bandExcellentDesc": "Fuerte y consistente — un claro activo",
      "bandExcellentRange": "80-100",
      "bandGood": "Bueno",
      "bandGoodDesc": "Base sólida con margen para mejorar",
      "bandGoodRange": "70-79",
      "careDesc": "Obtén apoyo post-llegada y asistencia para la integración",
      "caveat": {
        "lowMotivationSignal": "Tus respuestas motivacionales fueron muy breves, así que esta puntuación es menos fiable que las demás. Una respuesta más completa la afinaría.",
        "noMotivationData": "No escribiste nada en la evaluación motivacional, así que no pudimos puntuar Motivación. Complétala y recalcula para ver esta dimensión.",
        "noPitch": "Todavía no has grabado un vídeo de presentación, así que Motivación se basa solo en tus respuestas escritas.",
        "pitchAnalysisFailed": "No se ha podido analizar tu vídeo de presentación, así que Motivación se basa solo en tus respuestas escritas.",
        "pitchHeuristicScoring": "El análisis completo de tu vídeo de presentación no estaba disponible, así que su parte de esta puntuación es una estimación simplificada.",
        "pillarsEstimated": "Parte de esta puntuación se estimó con un método simplificado porque nuestro análisis completo no estaba disponible.",
        "skillsInferenceEmpty": "Aún no hemos podido identificar tus habilidades con lo que has compartido, así que Habilidades duras y otras habilidades no tiene puntuación. Añade tus habilidades y experiencia a tu perfil y recalcula."
      },
      "confidence": "Confianza: {{value}}%",
      "description": "Tu evaluación de preparación internacional",
      "doctorsRecommendation": "Recomendación del doctor",
      "errorDescription": "Hubo un problema al obtener tus resultados de CheckUp. Por favor, intenta de nuevo.",
      "errorTitle": "No se pudieron cargar los resultados",
      "examCount_one": "{{count}} examen",
      "examCount_other": "{{count}} exámenes",
      "explore": "Explorar",
      "freeAssessmentNote": "Evaluación gratuita completa • Actualiza para acceder a todos los héroes",
      "greenFlags": "Banderas verdes",
      "growthSubtitle": "Donde tu impulso puede acelerar",
      "growthTitle": "Tus áreas de crecimiento",
      "historyTitle": "Historia de CheckUp",
      "journeys": "Viajes",
      "meshDnaSubtitle": "Cuatro pilares que definen tu preparación internacional",
      "meshDnaTitle": "Tu ADN de MESH",
      "meshE": "Inglés y comunicación",
      "meshELbl": "Inglés",
      "meshH": "Habilidades duras y otras habilidades",
      "meshHLbl": "Habilidades técnicas",
      "meshM": "Motivación",
      "meshMLbl": "Motivación",
      "meshS": "Habilidades culturales blandas",
      "meshSLbl": "Cultural",
      "moreCheckupsNeeded": "Completa más CheckUps para ver tu evolución a lo largo del tiempo",
      "navActivate": "Activar viaje",
      "navGrowth": "Tus áreas de crecimiento",
      "navHistory": "Historia de CheckUp",
      "navMeshDna": "ADN de MESH",
      "navPillars": "Resultados de la evaluación",
      "navPrescription": "Prescripción de 90 días",
      "navStrengths": "Tus fortalezas",
      "nextSection": "Siguiente: {{label}}",
      "notScored": "Sin puntuar",
      "overallScore": "Puntuación general de preparación",
      "pillarOverview": "Resumen de pilares",
      "pillarPerformance": "Tu rendimiento en todas las dimensiones de evaluación",
      "pillarTapHint": "Toca un pilar para ver qué mide",
      "pillarSubtitle": "Como un informe de laboratorio médico, cada pilar mide una dimensión específica de tu preparación internacional — cuán preparado estás para tu viaje a otro país. Cada dimensión se puntúa de 0 a 100: cuanto más alta sea la puntuación, más fuerte es esa área.",
      "pillarTitle": "Tus resultados de evaluación",
      "positiveIndicators": "Indicadores positivos",
      "prescriptionSubtitle": "Un plan estructurado para convertir el potencial en rendimiento",
      "prescriptionTitle": "Tu prescripción de 90 días",
      "progressOverTime": "Tu progreso a lo largo del tiempo",
      "qultureupDesc": "Mejora tu preparación cultural con formación personalizada",
      "scaleCaption": "Tu posición en la escala",
      "scaleToNext": "{{points}} pts a {{tier}}",
      "scaleMax": "Has alcanzado el nivel más alto",
      "readingResults": "Leyendo tus resultados",
      "recommendedNextSteps": "Próximos pasos recomendados",
      "scoreOutOf": "/ 100",
      "scrollBackTop": "Desplázate hacia arriba",
      "scrollToNext": "Desplázate a la siguiente sección",
      "strengthsSubtitle": "Qué hace que tu perfil se destaque",
      "strengthsTitle": "Tus fortalezas",
      "teleportalDesc": "Comienza tu plan de movilidad con verificación de documentos y orientación sobre visados",
      "title": "Resultados de CheckUp",
      "topHardSkills": "Principales habilidades duras",
      "topSoftSkills": "Principales habilidades blandas",
      "unlockJourney": "Desbloquea tu viaje completo",
      "snapshotFallback": "Tu evaluación de iQulture está completa.",
      "badgeReasonFallback": "Basado en tu rendimiento general de evaluación.",
      "provisional": {
        "label": "Provisional",
        "body": "Faltan algunos de tus datos, así que esta es la puntuación mínima posible. Con los datos completos podría llegar hasta {{max}}.",
        "unlock": {
          "M": "Completa tus respuestas de Motivación o graba tu pitch — hasta +{{gain}}",
          "E": "Añade tus niveles de idiomas, incluida tu lengua materna — hasta +{{gain}}",
          "S": "Completa tu CheckUp para que podamos medir tus soft skills — hasta +{{gain}}",
          "H": "Añade tus habilidades y experiencia a tu perfil — hasta +{{gain}}"
        }
      },
      "skillsNotEnoughEvidence": "Aún no hay suficiente información para medir estas habilidades."
    },
    "resultsError": "Error al obtener resultados. Por favor, inténtalo de nuevo.",
    "retakeAssessment": "Repetir evaluación",
    "retakeOnWeb": "Reevaluar en la web",
    "retakeOnWebDesc": "Para retomar tu evaluación CheckUp, utiliza el portal web Citizen en un navegador de escritorio.",
    "score": "Puntuación",
    "scoreEvolution": "Evolución de la puntuación",
    "scrollForDetails": "Desplázate para ver detalles",
    "scrollForDetailsHint": "Toca para desplazarte a tus resultados detallados",
    "selected": "Seleccionado",
    "selectedCheckupDetails": "Detalles seleccionados de CheckUp",
    "shareResults": "Compartir resultados",
    "similarProfiles": "Perfiles Similares",
    "somethingWentWrong": "Algo salió mal",
    "startFailed": "No se pudo iniciar CheckUp. Por favor, intenta de nuevo.",
    "startOnWeb": "Comienza en Citizen Web",
    "startOnWebDesc": "Completa tu primera evaluación CheckUp en el portal web Citizen para la experiencia completa.",
    "step": {
      "assistantChat": "Chat de asistente",
      "assistantChatMsg": "Chatea con nuestro asistente de IA para darnos más contexto sobre tu situación.",
      "chatDone": "Chat completo",
      "chatDoneDesc": "Has terminado el chat con el asistente.",
      "journeyInstance": "Configuración del viaje",
      "journeyInstanceMsg": "Dinos a dónde te mudas y de dónde.",
      "languageTests": "Pruebas de idioma",
      "languageTestsDesc": "Añadir resultados de competencia lingüística.",
      "languageTestsMsg": "Sube tus certificados de idioma para fortalecer tu puntuación de preparación.",
      "motivational": "Motivación",
      "motivationalMsg": "Ayúdanos a entender qué impulsa tu mudanza.",
      "onboarding": "Datos básicos del perfil",
      "onboardingMsg": "Detalles rápidos sobre ti para personalizar el resto.",
      "pitch": "Video de presentación",
      "pitchMsg": "Graba un video de 30 segundos presentándote.",
      "pitchRecorded": "Presentación grabada",
      "pitchRecordedDesc": "Tu video de presentación está listo para revisión.",
      "videos": "Ver videos",
      "videosMsg": "Mira algunos videos cortos sobre tu destino.",
      "profileComplete": "Completa tu perfil",
      "profileCompleteMsg": "Tu puntuación necesita algunos datos de identificación.",
      "profileCompletePercentMsg": "Tu perfil está completo al {{percent}}%. La puntuación lo necesita entero."
    },
    "stuckMessage": "¿Atascado? Háznoslo saber — podemos ayudar.",
    "suggestedNextSteps": "Siguientes pasos sugeridos",
    "tabAnalysis": "Análisis",
    "tabComparisons": "Comparaciones",
    "tabConclusion": "Conclusión 360°",
    "tabHistory": "Historia",
    "tabInsights": "Perspectivas",
    "tabMESH": "Análisis de MESH",
    "tabNextSteps": "Siguientes pasos",
    "tabOverview": "Resumen",
    "tabPillars": "Pilares de evaluación",
    "tabSkills": "Termómetro de habilidades",
    "tapToCollapse": "Toca para colapsar",
    "tapToReadMore": "Toca para leer el resumen completo",
    "tip": {
      "1": "Tu puntuación de MESH mide Motivación, Inglés, Habilidades blandas y Habilidades duras — los 4 pilares de la preparación para una carrera internacional.",
      "2": "Las insignias de iQulture (Explorador, Estrella en Ascenso, Profesional Global) reflejan tu preparación general para trabajar en el extranjero.",
      "3": "Nuestra IA analiza tu video de presentación, competencia lingüística y respuestas motivacionales para construir un perfil 360°.",
      "4": "Tu plan de acción personalizado de 90 días incluirá pasos específicos para mejorar tus áreas más débiles.",
      "5": "La Evaluación de Riesgo Cultural identifica posibles desafíos de adaptación y cómo superarlos."
    },
    "title": "iQulture CheckUp",
    "tonnieDatabaseAverage": "Promedio de la base de datos de Tonnie",
    "top10Hard": "Top 10 habilidades duras",
    "top10Soft": "Top 10 habilidades blandas",
    "topHardSkills": "Principales habilidades duras",
    "topSoftSkills": "Principales habilidades blandas",
    "triggerFailed": "No se pudo iniciar el cálculo. Por favor, inténtalo de nuevo.",
    "tryAgain": "Intenta de nuevo",
    "unableToLoad": "No se pudo cargar CheckUp",
    "unknownDate": "Fecha desconocida",
    "verifiedByTonnieGuard": "Verificado por Tonnie guard",
    "vsAverage": "vs promedio",
    "vsPrevious": "vs anterior",
    "welcome": {
      "chatStep": "Conversación guiada",
      "chatStepDesc": "Responde algunas preguntas con nuestro asistente de IA",
      "description": "Descubre tu preparación internacional con nuestra evaluación de MESH. Evalúa tu Motivación, Inglés, Habilidades Blandas y Habilidades Duras para generar tu puntuación personalizada de iQulture.",
      "languageStep": "Chequeo de idioma",
      "languageStepDesc": "Evaluación rápida de tus habilidades lingüísticas",
      "letsStart": "Empecemos",
      "pitchStep": "Video de presentación corto",
      "pitchStepDesc": "Graba un breve video presentándote",
      "timeEstimate": "Toma alrededor de 10-15 minutos para completar",
      "title": "Bienvenido a CheckUp"
    },
    "scoreOutOfSuffix": "/100",
    "missingSteps": {
      "journey_instance": {
        "label": "Instancia de viaje",
        "message": "Necesitas crear un Viaje antes de comenzar tu CheckUp."
      },
      "onboarding_complete": {
        "label": "Integración",
        "message": "Completa la integración de tu perfil para desbloquear CheckUp."
      },
      "assistant_chat": {
        "label": "Chat de evaluación",
        "message": "Completa la conversación de evaluación guiada."
      },
      "motivational_answers": {
        "label": "Preguntas motivacionales",
        "message": "Responde las preguntas motivacionales sobre tus objetivos."
      },
      "pitch_video": {
        "label": "Vídeo de presentación",
        "message": "Graba o sube tu video de presentación."
      },
      "generic": "Este paso necesita ser completado.",
      "videos_watched": {
        "label": "Ver los vídeos de introducción",
        "message": "Una breve introducción antes de empezar."
      },
      "language_tests": {
        "label": "Pruebas de idiomas",
        "message": "Cuéntanos qué idiomas hablas y a qué nivel."
      },
      "profile_complete": {
        "label": "Completa tu perfil",
        "message": "Tu puntuación necesita algunos datos de identificación. Complétalos en el portal web."
      }
    },
    "reuse": {
      "title": "¿Reutilizar tu resultado guardado?",
      "subtitle": "Ya completaste esta prueba. Reutilízala para esta evaluación o haz una nueva.",
      "takenOn": "Realizada el {{date}}",
      "reuseCta": "Reutilizar este resultado",
      "newCta": "Hacer una nueva",
      "daysLeft_one": "{{count}} día restante",
      "daysLeft_other": "{{count}} días restantes"
    },
    "calculatingPct": "Calculando… {{pct}}%",
    "requestedBy": {
      "badge": "Solicitado por {{company}}",
      "purpose": "Tu puntuación define las recomendaciones que recibes y el apoyo que pueden ofrecerte.",
      "whatTheySee": "Ven tu puntuación y tu preparación, nunca tus respuestas."
    },
    "reusedFrom": {
      "title": "Reutilizado de tu CheckUp para {{destination}}",
      "body": "Tus respuestas y las pruebas aún válidas se han trasladado desde ese CheckUp. Tu puntuación se calcula de nuevo para este destino."
    },
    "profileGate": {
      "progressLabel": "Perfil",
      "percent": "{{percent}}%",
      "cta": "Completar perfil",
      "field": {
        "name": "Nombre",
        "dateOfBirth": "Fecha de nacimiento",
        "nationality": "Ciudadanía",
        "currentCountry": "País actual",
        "currentCity": "Ciudad actual",
        "phone": "Teléfono"
      },
      "fieldMissing": "Falta"
    },
    "readyToCalculate": {
      "title": "Tu evaluación está completa",
      "description": "Está todo respondido. Tu puntuación aún no se ha generado.",
      "ctaTitle": "Generar tu puntuación",
      "ctaDescription": "Un toque. Tarda unos minutos y te enviamos una notificación cuando tu puntuación esté lista.",
      "cta": "Calcular mi puntuación"
    },
    "awaitingProfile": {
      "assessmentDone": "Evaluación completada",
      "assessmentDoneDetail": "Todos los pasos están hechos — tus respuestas están guardadas.",
      "calculateLocked": "Completa tu perfil para desbloquear tu puntuación."
    },
    "calculationFailedTitle": "No se ha podido calcular tu puntuación",
    "calculationFailedBody": "Tus respuestas están guardadas. Vuelve a calcular la puntuación; tarda alrededor de un minuto.",
    "calculateAgain": "Calcular de nuevo"
  },
  "common": {
    "active": "Activo",
    "appName": "Tonnie Citizen",
    "appShortName": "Citizen",
    "applicationError": "Error de aplicación",
    "availableSoon": "Disponible pronto",
    "back": "Atrás",
    "backToDashboard": "Volver al tablero",
    "cancel": "Cancelar",
    "clear": "Limpiar",
    "clearFilters": "Limpiar filtros",
    "close": "Cerrar",
    "collapse": "Colapsar",
    "comingSoon": "Próximamente",
    "completed": "Completado",
    "confirm": "Confirmar",
    "continue": "Continuar",
    "continueAssessment": "Continuar evaluación",
    "continueSetup": "Continuar configuración",
    "copiedToClipboard": "{{label}} copiado al portapapeles",
    "copilot": "CoPilot",
    "copyFailed": "Error al copiar {{label}}",
    "countries": {
      "AE": "Emiratos Árabes Unidos",
      "AU": "Australia",
      "BR": "Brasil",
      "CA": "Canadá",
      "CN": "China",
      "DE": "Alemania",
      "ES": "España",
      "FR": "Francia",
      "GB": "Reino Unido",
      "IE": "Irlanda",
      "IN": "India",
      "IT": "Italia",
      "JP": "Japón",
      "KR": "Corea del Sur",
      "NL": "Países Bajos",
      "NZ": "Nueva Zelanda",
      "PT": "Portugal",
      "SG": "Singapur",
      "UK": "Reino Unido",
      "US": "Estados Unidos",
      "AF": "Afganistán",
      "AL": "Albania",
      "DZ": "Argelia",
      "AD": "Andorra",
      "AO": "Angola",
      "AG": "Antigua y Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AT": "Austria",
      "AZ": "Azerbaiyán",
      "BS": "Bahamas",
      "BH": "Baréin",
      "BD": "Bangladés",
      "BB": "Barbados",
      "BY": "Bielorrusia",
      "BE": "Bélgica",
      "BZ": "Belice",
      "BJ": "Benín",
      "BT": "Bután",
      "BO": "Bolivia",
      "BA": "Bosnia y Herzegovina",
      "BW": "Botsuana",
      "BN": "Brunéi",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "CV": "Cabo Verde",
      "KH": "Camboya",
      "CM": "Camerún",
      "CF": "República Centroafricana",
      "TD": "Chad",
      "CL": "Chile",
      "CO": "Colombia",
      "KM": "Comoras",
      "CG": "Congo",
      "CD": "Congo (RDC)",
      "CR": "Costa Rica",
      "CI": "Costa de Marfil",
      "HR": "Croacia",
      "CU": "Cuba",
      "CY": "Chipre",
      "CZ": "Chequia",
      "DK": "Dinamarca",
      "DJ": "Yibuti",
      "DM": "Dominica",
      "DO": "República Dominicana",
      "EC": "Ecuador",
      "EG": "Egipto",
      "SV": "El Salvador",
      "GQ": "Guinea Ecuatorial",
      "ER": "Eritrea",
      "EE": "Estonia",
      "SZ": "Esuatini",
      "ET": "Etiopía",
      "FJ": "Fiyi",
      "FI": "Finlandia",
      "GA": "Gabón",
      "GM": "Gambia",
      "GE": "Georgia",
      "GH": "Ghana",
      "GR": "Grecia",
      "GD": "Granada",
      "GT": "Guatemala",
      "GN": "Guinea",
      "GW": "Guinea-Bisáu",
      "GY": "Guyana",
      "HT": "Haití",
      "HN": "Honduras",
      "HK": "Hong Kong",
      "HU": "Hungría",
      "IS": "Islandia",
      "ID": "Indonesia",
      "IR": "Irán",
      "IQ": "Irak",
      "IL": "Israel",
      "JM": "Jamaica",
      "JO": "Jordania",
      "KZ": "Kazajistán",
      "KE": "Kenia",
      "KI": "Kiribati",
      "KW": "Kuwait",
      "KG": "Kirguistán",
      "LA": "Laos",
      "LV": "Letonia",
      "LB": "Líbano",
      "LS": "Lesoto",
      "LR": "Liberia",
      "LY": "Libia",
      "LI": "Liechtenstein",
      "LT": "Lituania",
      "LU": "Luxemburgo",
      "MO": "Macao",
      "MG": "Madagascar",
      "MW": "Malaui",
      "MY": "Malasia",
      "MV": "Maldivas",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Islas Marshall",
      "MR": "Mauritania",
      "MU": "Mauricio",
      "MX": "México",
      "FM": "Micronesia",
      "MD": "Moldavia",
      "MC": "Mónaco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MA": "Marruecos",
      "MZ": "Mozambique",
      "MM": "Myanmar (Birmania)",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NI": "Nicaragua",
      "NE": "Níger",
      "NG": "Nigeria",
      "KP": "Corea del Norte",
      "MK": "Macedonia del Norte",
      "NO": "Noruega",
      "OM": "Omán",
      "PK": "Pakistán",
      "PW": "Palaos",
      "PS": "Palestina",
      "PA": "Panamá",
      "PG": "Papúa Nueva Guinea",
      "PY": "Paraguay",
      "PE": "Perú",
      "PH": "Filipinas",
      "PL": "Polonia",
      "QA": "Catar",
      "RO": "Rumanía",
      "RU": "Rusia",
      "RW": "Ruanda",
      "KN": "San Cristóbal y Nieves",
      "LC": "Santa Lucía",
      "VC": "San Vicente y las Granadinas",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "Santo Tomé y Príncipe",
      "SA": "Arabia Saudí",
      "SN": "Senegal",
      "RS": "Serbia",
      "SC": "Seychelles",
      "SL": "Sierra Leona",
      "SK": "Eslovaquia",
      "SI": "Eslovenia",
      "SB": "Islas Salomón",
      "SO": "Somalia",
      "ZA": "Sudáfrica",
      "SS": "Sudán del Sur",
      "LK": "Sri Lanka",
      "SD": "Sudán",
      "SR": "Surinam",
      "SE": "Suecia",
      "CH": "Suiza",
      "SY": "Siria",
      "TW": "Taiwán",
      "TJ": "Tayikistán",
      "TZ": "Tanzania",
      "TH": "Tailandia",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TO": "Tonga",
      "TT": "Trinidad y Tobago",
      "TN": "Túnez",
      "TR": "Turquía",
      "TM": "Turkmenistán",
      "TV": "Tuvalu",
      "UG": "Uganda",
      "UA": "Ucrania",
      "UY": "Uruguay",
      "UZ": "Uzbekistán",
      "VU": "Vanuatu",
      "VA": "Ciudad del Vaticano",
      "VE": "Venezuela",
      "VN": "Vietnam",
      "YE": "Yemen",
      "ZM": "Zambia",
      "ZW": "Zimbabue"
    },
    "delete": "Eliminar",
    "destination": "Destino",
    "discard": "Descartar",
    "discardChanges": "¿Descartar cambios?",
    "discardChangesBody": "Tus cambios no guardados se perderán.",
    "discardProgress": "¿Descartar progreso?",
    "discardProgressBody": "Tu progreso en esta pantalla se perderá.",
    "dismiss": "Descartar",
    "done": "Hecho",
    "download": "Descargar",
    "earned": "Ganadas",
    "earnedDateMiles": "Ganado {{date}} • +{{miles}} Miles",
    "edit": "Editar",
    "email": "Correo electrónico",
    "error": "Error",
    "errorTitle": "Error",
    "estimatedTime": "Tiempo estimado",
    "expand": "Expandir",
    "familyWillLose": "Tus familiares perderán",
    "filter": "Filtrar",
    "free": "Gratis",
    "goBack": "Regresar",
    "heroes": {
      "care": "Care",
      "checkup": "CheckUp",
      "qultureup": "QultureUp",
      "teleportal": "TelePortal",
      "inout": "InOut"
    },
    "inProgress": "En progreso",
    "info": "Info",
    "keepEditing": "Seguir editando",
    "keepFamily": "Mantener familia",
    "keepPro": "Mantener Pro",
    "loading": "Cargando...",
    "locked": "Bloqueado",
    "logout": "Cerrar sesión",
    "miles": "Miles",
    "minutes": "minutos",
    "more": "más",
    "next": "Siguiente",
    "no": "No",
    "notAvailable": "No disponible",
    "of": "de",
    "openInApp": "Abrir en la app",
    "optional": "Opcional",
    "origin": "Origen",
    "other": "Otro",
    "page": "Página",
    "pending": "Pendiente",
    "plan": {
      "basic": "Básico",
      "pro": "Pro"
    },
    "pleaseRetryLater": "Por favor, intenta de nuevo más tarde.",
    "previous": "Anterior",
    "progress": "Progreso",
    "refresh": "Actualizar",
    "remove": "Eliminar",
    "reset": "Restablecer",
    "resumeWhereYouLeftOff": "Reanudar donde lo dejaste",
    "retry": "Reintentar",
    "routeSrLabel": "{{origin}} a {{destination}}",
    "review": "Revisión",
    "save": "Guardar",
    "selectLanguage": "Seleccionar idioma",
    "send": "Enviar",
    "settings": "Configuraciones",
    "skip": "Omitir",
    "soon": "Pronto",
    "submit": "Enviar",
    "success": "Éxito",
    "successTitle": "Éxito",
    "time": {
      "daysAgo": "hace {{n}}d",
      "hoursAgo": "hace {{n}}h",
      "minutesAgo": "hace {{n}}m",
      "monthsAgo": "hace {{n}}mo",
      "now": "justo ahora",
      "weeksAgo": "hace {{n}}w",
      "yesterday": "ayer"
    },
    "to": "A",
    "toast": {
      "documentUploaded": "Documento subido",
      "moodFailed": "No se pudo guardar el estado de ánimo, intenta de nuevo",
      "moodRecorded": "Estado de ánimo registrado",
      "settingFailed": "No se pudo actualizar la configuración",
      "settingSaved": "Configuración guardada",
      "somethingWentWrong": "Algo salió mal, por favor intenta de nuevo",
      "taskCompleted": "Tarea completada",
      "taskFailed": "No se pudo actualizar la tarea",
      "taskReopened": "Tarea reabierta"
    },
    "today": "Hoy",
    "tonnieChecked": "Tonnie-Verificado",
    "traveler": "Viajero",
    "trust": {
      "howItHelps": "Cómo te ayuda",
      "tapToSee": "Toca para ver cómo protegemos tus datos",
      "whoCanSee": "Quién puede ver esto",
      "whyAsking": "Por qué lo estamos preguntando",
      "yourDataProtected": "Tus Datos están Protegidos"
    },
    "tryAgain": "Intenta de nuevo",
    "upload": "Subir",
    "uploading": "Subiendo…",
    "view": "Ver",
    "viewAll": "Ver todo",
    "welcome": "Bienvenido",
    "yes": "Sí",
    "yesterday": "Ayer",
    "youWillLose": "Perderás acceso a",
    "beta": {
      "bannerMessage": "Acceso anticipado — ayuda a dar forma a Tonnie 💜",
      "bannerMessageMobile": "Acceso anticipado — evoluciona con Tonnie 💜",
      "bannerCta": "Dar feedback"
    },
    "openActionTitle": "Abrir {{action}}",
    "copy": "Copiar",
    "network": {
      "a11y": {
        "retry": "Reintentar solicitudes fallidas",
        "dismiss": "Descartar banner de error de red",
        "showDetails": "Mostrar detalles del error",
        "hideDetails": "Ocultar detalles del error",
        "copy": "Copiar detalles del error al portapapeles",
        "dismissOffline": "Cerrar el aviso de falta de conexión"
      },
      "hideDetails": "Ocultar detalles",
      "detailsCount": "Detalles · {{count}}",
      "noDetails": "No se han capturado detalles aún.",
      "copy": {
        "unstable": {
          "title": "La conexión es inestable",
          "subtitle": "Hemos pausado los reintentos automáticos para ahorrar batería. Toca Reintentar para intentar de nuevo.{{countHint}}"
        },
        "network": {
          "title": "No se puede alcanzar el servidor",
          "subtitle": "Verifica tu conexión a internet.{{countHint}}"
        },
        "timeout": {
          "title": "Conexión lenta",
          "subtitle": "Las solicitudes están tardando más de lo habitual.{{countHint}}"
        },
        "server": {
          "title": "Algo salió mal",
          "subtitle": "Nuestro equipo ha sido notificado. Intenta de nuevo en un momento.{{countHint}}"
        },
        "default": {
          "title": "Problema de conexión",
          "subtitle": "Estamos teniendo problemas para cargar tus datos.{{countHint}}"
        },
        "countHint_one": " ({{count}} solicitud fallida)",
        "countHint_other": " ({{count}} solicitudes fallidas)"
      },
      "offline": {
        "title": "No tienes conexión",
        "subtitle": "Estás viendo lo que ya se había cargado. Lo que guardes se enviará cuando vuelvas a tener conexión; CoPilot y las subidas de archivos necesitan conexión."
      }
    },
    "apiError": {
      "network": "No podemos alcanzar el servidor. Verifica tu conexión.",
      "timeout": "La solicitud tardó demasiado. Reintentaremos automáticamente.",
      "unauthorized": "Tu sesión ha expirado. Por favor, inicia sesión de nuevo.",
      "forbidden": "No tienes permiso para eso.",
      "notFound": "Recurso no encontrado.",
      "badRequest": "Algo en la solicitud era inválido.",
      "serverError": "Algo salió mal de nuestra parte. Estamos investigando.",
      "unknown": "Algo salió mal."
    },
    "relativeTime": {
      "justNow": "Justo ahora",
      "minutesAgo_one": "hace {{count}} minuto",
      "minutesAgo_other": "hace {{count}} minutos",
      "hoursAgo_one": "hace {{count}} hora",
      "hoursAgo_other": "hace {{count}} horas",
      "daysAgo_one": "hace {{count}} día",
      "daysAgo_other": "hace {{count}} días"
    },
    "device": {
      "unknown": "Dispositivo desconocido",
      "mobile": "Móvil",
      "desktop": "Escritorio"
    },
    "browser": {
      "unknown": "Navegador desconocido"
    },
    "location": {
      "unknown": "Ubicación desconocida"
    },
    "searchCountry": "Buscar país...",
    "noCountryFound": "No se encontró ningún país.",
    "phoneCode": "Código",
    "searchPhoneCode": "Buscar código telefónico...",
    "noPhoneCodeFound": "No se encontró ningún código telefónico.",
    "untitled": "Sin título",
    "unassigned": "No Asignado",
    "unknown": "Desconocido",
    "member": "Miembro",
    "phoneCountryCodeLabel": "Prefijo del país",
    "pageOf": "Página {{page}} de {{total}}",
    "pagination": "Páginas",
    "daysAgo_one": "Hace {{count}} día",
    "daysAgo_other": "Hace {{count}} días",
    "rewardMiles_one": "Recompensa: {{count}} Mile",
    "rewardMiles_other": "Recompensa: {{count}} Miles",
    "removeItem": "Quitar {{name}}",
    "milesGained_one": "+{{miles}} Mile",
    "milesGained_other": "+{{miles}} Miles",
    "aiBadge": "IA",
    "list": {
      "two": "{{first}} y {{second}}"
    },
    "heroTabs": {
      "label": "Secciones de {{hero}}",
      "strip": "Secciones",
      "scrollPrevious": "Mostrar las secciones anteriores",
      "scrollNext": "Mostrar más secciones"
    },
    "timeRange": "{{from}}–{{to}}",
    "dateFormat": {
      "day": "dd",
      "month": "mm",
      "year": "aaaa"
    },
    "openSettings": "Abrir Ajustes",
    "choosePhotoInstead": "Elegir una foto",
    "photoLibraryUnavailable": "No se han podido abrir tus fotos.",
    "aiUnavailable": {
      "title": "Algunas funciones no están disponibles temporalmente",
      "description": "Esto necesita la IA de Tonnie, que no puede responder ahora mismo. Lo estamos reintentando; todo lo demás en Tonnie funciona con normalidad.",
      "retry": "Reintentar"
    }
  },
  "copilot": {
    "beta": {
      "badge": "Beta",
      "tooltipTitle": "Tonnie CoPilot está en beta",
      "tooltipBody": "Estamos mejorándolo activamente — califica las respuestas con 👍 o 👎 para ayudarnos a hacerlo mejor.",
      "ariaLabel": "Acerca de la beta de Tonnie CoPilot"
    },
    "action": {
      "dismiss": "Descartar",
      "goTo": "Ir a",
      "open": "Abrir"
    },
    "aiDisclaimer": "CoPilot utiliza IA. Las respuestas pueden no ser siempre precisas.",
    "answered": "Respondido",
    "answersSubmitted": "Tus respuestas han sido enviadas",
    "askAnything": "Pregunta cualquier cosa...",
    "billingPage": "Página de facturación",
    "brainAssessment": {
      "errorTitle": "No se pudieron cargar las preguntas",
      "evaluating": {
        "subtitle": "Nuestra IA está revisando tu respuesta",
        "title": "Evaluando tu respuesta…"
      },
      "feedback": {
        "correct": "¡Correcto!",
        "incorrectEncouragement": "Tómate un momento — verás este concepto de nuevo.",
        "incorrectHeadline": "Casi — aquí está la respuesta",
        "movingOn": "Pasando a la siguiente pregunta…",
        "next": "Siguiente pregunta",
        "theAnswerIs": "La respuesta es"
      },
      "level": {
        "advanced": {
          "label": "Avanzado",
          "desc_one": "¡Excelente! {{count}} misión está marcada como opcional.",
          "desc_other": "¡Excelente! {{count}} misiones están marcadas como opcionales."
        },
        "beginner": {
          "desc": "¡Estás comenzando tu viaje! Todas las lecciones están desbloqueadas y listas para ti.",
          "label": "Principiante"
        },
        "intermediate": {
          "label": "Intermedio",
          "desc_one": "¡Gran conocimiento! {{count}} misión de principiante está marcada como opcional.",
          "desc_other": "¡Gran conocimiento! {{count}} misiones de principiante están marcadas como opcionales."
        }
      },
      "loading": "Cargando preguntas de evaluación…",
      "noQuestions": "No hay preguntas disponibles para este mundo.",
      "question": {
        "next": "Siguiente pregunta",
        "openAnswerHint": "Tu respuesta será evaluada por la IA. ¡Tómate tu tiempo!",
        "openAnswerCounter": "{{count}} / {{max}} caracteres",
        "openAnswerMinHint": "Mínimo {{min}} caracteres ({{remaining}} restantes)",
        "openAnswerPlaceholder": "Escribe tu respuesta aquí…",
        "submitFinal": "Enviar y ver resultados"
      },
      "results": {
        "continue": "Continuar",
        "correct": "Correcto",
        "questionDetails": "Detalles de la pregunta",
        "retake": "Repetir",
        "score": "Puntuación",
        "total": "Total",
        "yourAnswer": "Tu respuesta",
        "skipNote_one": "{{count}} misión se marcará como opcional para tu nivel. Aún puedes completarla para ganar Miles.",
        "skipNote_other": "{{count}} misiones se marcarán como opcionales para tu nivel. Aún puedes completarlas para ganar Miles."
      }
    },
    "brainSubtitle": "Impulsado por Tonnie Brain",
    "bringFamily": "¿Traes a tu familia?",
    "bringingFamilyNoProgram": "Trayendo familia (sin programa)",
    "cameraError": "Error de cámara",
    "cameraErrorTitle": "Cámara no disponible",
    "cameraPermissionDenied": "Permiso de cámara denegado. Permite el acceso a la cámara en tu navegador para grabar un video.",
    "chatLog": "Mensajes de chat",
    "playVideo": "Reproducir video",
    "clickToPlay": "Haz clic para empezar el video",
    "close": "Cerrar CoPilot",
    "confidence": "Confianza",
    "contextualGreeting": "¡Hola! Soy Tonnie CoPilot, tu asistente de IA contextual. {{context}}¿Qué te gustaría saber?",
    "couldImprove": "Podría mejorar",
    "createMyJourney": "Crear mi viaje",
    "dailyQuotaReached": "Cuota diaria alcanzada",
    "destination": "¿A dónde vas?",
    "disclaimer": "Tus respuestas son privadas y se utilizan solo para personalizar tu viaje.",
    "errorLoadingQuestions": "Error al cargar preguntas",
    "errorTitle": "Algo salió mal",
    "familyAddon": "Complemento Familiar incluido",
    "familyComingSoonNote": "El Programa Familiar estará disponible pronto. Por ahora, tu viaje está configurado para uso individual.",
    "familyConfig": "Configuración familiar",
    "familyFeature1": "Invitar a miembros de la familia (Compañero y Miembros de la Familia)",
    "familyFeature2": "Controlar permisos de acceso por héroe",
    "familyFeature3": "Rastrear el progreso consciente del hogar",
    "familyFeature4": "Gestionar el viaje familiar juntos",
    "familyJoinQuestion": "¿Se unirán los miembros de la familia a este viaje?",
    "familyJoining": "Los miembros de la familia se unirán a tu viaje",
    "familyProgramAddon": "Complemento del programa familiar",
    "familyProgramDesc": "Gestiona el viaje de tu familia juntos con acceso compartido y seguimiento del progreso",
    "familyProgramEnabled": "Programa familiar habilitado",
    "findings": {
      "emptyProfile": "Tu perfil no tiene hallazgos aún.",
      "expand": "Expandir",
      "looksGood": "Se ve bien",
      "profile": "Perfil",
      "profileIntro": "Esto es lo que hemos recopilado sobre tu perfil a partir de tus respuestas.",
      "profileTitle": "Hallazgos del perfil"
    },
    "fixErrors": "Corregir errores",
    "formSubmittedNote": "Tu formulario ha sido enviado. ¡Gracias!",
    "goBack": "Regresar",
    "greeting": "¡Hola! Soy Tonnie CoPilot, tu asistente de IA. {{context}}¿Qué te gustaría saber?",
    "guide": {
      "newMessages": "Nuevos mensajes",
      "typeHere": "Escribe aquí...",
      "avatarAlt": "CoPilot asistente de IA",
      "aria": {
        "stepOf": "Paso {{step}} de {{total}}"
      },
      "taskFallback": "Evaluación"
    },
    "guideCompleted": "Guía completada",
    "guideCompletedDesc": "Has completado esta guía.",
    "guideTitle": "Guía de Tonnie CoPilot",
    "household": {
      "addChild": "Agregar niño",
      "addPet": "Agregar mascota",
      "cat": "Gato",
      "child": "Niño",
      "childN": "Niño {{n}}",
      "children": "Niños",
      "childrenDetails": "Cuéntanos sobre cada niño que se muda contigo.",
      "description": "Cuéntanos quién se muda contigo para que podamos personalizar tu viaje.",
      "dog": "Perro",
      "hasPassport": "Tiene pasaporte",
      "name": "Nombre",
      "namePlaceholder": "Nombre completo",
      "nationality": "Nacionalidad",
      "other": "Otro",
      "partner": "Socio",
      "partnerDetails": "Cuéntanos sobre tu pareja.",
      "pet": "Mascota",
      "petN": "Mascota {{n}}",
      "petName": "Nombre de la mascota",
      "petNamePlaceholder": "¿Cuál es el nombre de tu mascota?",
      "petVaccination": "Vacunas al día",
      "pets": "Mascotas",
      "petsDetails": "Cuéntanos sobre cada mascota que se muda contigo.",
      "relocating": "Mudándose conmigo",
      "selectCountry": "Selecciona país",
      "species": "Especie",
      "title": "Tu hogar",
      "vaccinationOk": "Vacunas OK",
      "prefilledFromOnboarding": "Rellenado con las respuestas que diste al registrarte. Revísalo y cambia lo que sea distinto: no se guarda nada hasta que confirmes.",
      "you": "Tú"
    },
    "hybrid": {
      "complete": "¡Todo listo! Tus respuestas han sido registradas.",
      "error": "Algo salió mal. Intentemos de nuevo.",
      "escapeHatch": "Preferiría no responder a esto",
      "placeholder": "Escribe tu respuesta...",
      "progress": "Progreso",
      "selectOption": "Selecciona una opción",
      "stepOf": "Paso {{current}} de {{total}}",
      "title": "Entrevista guiada",
      "typeAnswer": "Escribe tu respuesta",
      "openingFallback": "Comencemos."
    },
    "includedFeatures": "Características incluidas",
    "individualJourney": "Viaje individual",
    "inputPlaceholder": "Pregunta a Tonnie cualquier cosa...",
    "journeyPurpose": "Propósito del viaje",
    "journeyPurposes": "Propósitos del viaje",
    "journeyReady": "¡Tu viaje está listo para desbloquear!",
    "journeyRoute": "Ruta del viaje",
    "journeyRouteDesc": "Selecciona tus países de origen y destino",
    "journeySummary": "Resumen de tu viaje",
    "justMe": "Solo yo",
    "lifecycle": {
      "acknowledge": {
        "default": "Entiendo que esta acción no se puede deshacer."
      },
      "autosave": {
        "justNow": "justo ahora",
        "offline": "Sin conexión — se reintentará",
        "saved": "Guardado · {{relative}}",
        "saving": "Guardando…",
        "unsaved": "Guardado pendiente"
      },
      "completion": {
        "errorBody": "Algo salió mal al guardar tus respuestas. Puedes intentarlo de nuevo — tu trabajo sigue aquí.",
        "errorTitle": "No se pudo guardar tus resultados",
        "saving": "Guardando tus resultados…",
        "successBody": "Tus respuestas están guardadas. Te llevamos a tu panel de control.",
        "successContinue": "Continuar",
        "successRedirect": "Redirigiendo en {{seconds}}…",
        "successStay": "Quédate aquí",
        "successTitle": "¡Todo listo!"
      },
      "confirm": {
        "stepLabel": "Paso {{currentStep}} de {{totalSteps}} · {{progress}}%"
      },
      "discard": {
        "body": "Estás al {{progress}}%. Si cancelas ahora, tu trabajo en este intento se eliminará.",
        "bodyTeleportalSetup": "Tus tareas existentes de TelePortal permanecen como están. Tus respuestas borrador de esta sesión no se guardarán.",
        "confirm": "Sí, descartar",
        "keep": {
          "history": "Cualquier resultado completado previamente",
          "teleportalTasks": "Tus tareas existentes de TelePortal"
        },
        "lose": {
          "answers": "Tus respuestas actuales ({{progress}}%)",
          "position": "Tu posición en el paso {{currentStep}}",
          "teleportalDraft": "Las respuestas borrador de esta sesión",
          "teleportalPosition": "Perderás tu progreso de TelePortal en este viaje"
        },
        "titleTeleportalSetup": "¿Omitir la configuración por ahora?",
        "confirmTeleportalSetup": "Sí, descartar este intento",
        "titleCheckup": "¿Descartar el progreso de tu CheckUp?",
        "titleCareAssessment": "¿Descartar el progreso de tu evaluación de Care?",
        "titleQultureup": "¿Descartar el progreso de tu prueba de nivel de QultureUp?",
        "titleJourneyBuilder": "¿Descartar el viaje que estás creando?"
      },
      "keep": {
        "empty": "Nada se transfiere.",
        "title": "Manteniendo"
      },
      "leave": {
        "body": "Tu progreso a través del paso {{currentStep}} ya está guardado. Puedes retomar esto en cualquier momento.",
        "confirm": "Sí, aléjate",
        "keep": {
          "answers": "Cada respuesta que completaste",
          "progress": "Tu progreso hasta ahora ({{progress}}%)"
        },
        "title": "¿Alejarse por ahora?"
      },
      "lose": {
        "empty": "Nada se elimina.",
        "title": "Perdiendo"
      },
      "restart": {
        "body": "Tus respuestas actuales se borrarán. Comenzarás de nuevo desde el paso 1.",
        "bodyJourneyBuilder": "Comenzarás el constructor de viajes de nuevo. Tus respuestas en progreso se borrarán.",
        "bodyTeleportalSetup": "Tus respuestas anteriores se prellenarán. La conversación comienza de nuevo desde el principio, y tu lista de tareas se reconstruye.",
        "confirm": "Sí, reiniciar",
        "keep": {
          "history": "Tu resultado anterior (si lo hay)"
        },
        "lose": {
          "answers": "Tus respuestas actuales ({{progress}}%)",
          "builderAnswers": "Tus respuestas del constructor en progreso",
          "position": "Tu posición en el paso {{currentStep}}"
        },
        "title": "¿Reiniciar desde el paso 1?",
        "titleJourneyBuilder": "¿Reiniciar el constructor de viajes?",
        "titleTeleportalSetup": "¿Restablecer la configuración de TelePortal?"
      },
      "retake": {
        "bodyCare": "Tu evaluación anterior de Care está archivada. La conversación comienza de nuevo desde el paso 1.",
        "bodyCheckup": "Tu resultado anterior de CheckUp está archivado. La conversación comienza de nuevo desde el paso 1.",
        "bodyQultureup": "Solo se repite la prueba de nivel inicial — tus misiones y logros permanecen intactos.",
        "confirm": "Sí, volver a tomar",
        "keep": {
          "archived": "Tu resultado anterior (guardado en la historia)",
          "miles": "Todas tus Miles ganadas",
          "missions": "Tu progreso en la misión"
        },
        "lose": {
          "activeScore": "Tu puntuación activa y medalla"
        },
        "titleCheckup": "¿Volver a hacer tu CheckUp?",
        "titleCare": "¿Volver a hacer tu evaluación de Care?",
        "titleQultureup": "¿Volver a hacer tu prueba de nivel de QultureUp?"
      },
      "reversible": {
        "no": "No se puede deshacer",
        "yes": "Puedes volver a esto"
      },
      "stay": "Quedarse",
      "toolbar": {
        "discard": "Descartar",
        "discardHint": "Cancelar este intento y salir. Tus respuestas son eliminadas.",
        "restart": "Reiniciar",
        "restartHint": "Borrar tus respuestas y empezar de nuevo desde el paso 1."
      },
      "aria": {
        "whatChanges": "Qué cambios"
      }
    },
    "loadingQuestions": "Cargando preguntas…",
    "maxChars": "Máx {{max}} caracteres",
    "validation": {
      "required": "Esta pregunta es obligatoria.",
      "thin": "Una respuesta corta está bien: unas frases más nos dan más con lo que trabajar ({{words}} palabras hasta ahora).",
      "tooLong": "Demasiado largo — por favor, manténlo por debajo de {{max}} caracteres.",
      "ok": "Se ve genial — claro y detallado."
    },
    "suggestedWords": "Intenta escribir {{min}}+ palabras",
    "typeAnswer": "Escribe tu respuesta",
    "words_one": "{{count}} palabra",
    "words_other": "{{count}} palabras",
    "motivationalAssessment": "Evaluación de motivación",
    "motivationalDesc": "Una breve reflexión para ayudarnos a entender qué impulsa tu movimiento.",
    "needsFix": "Necesita arreglos",
    "nextVideo": "Próximo video",
    "noCountriesFound": "No se encontraron países",
    "noQuestionsForPersona": "Aún no tenemos preguntas para este perfil.",
    "noVideoData": "No hay datos de video",
    "noVideos": "No hay videos disponibles.",
    "notAnsweredYet": "Aún no respondido",
    "optional": "Opcional",
    "origin": "¿De dónde eres?",
    "pitch": {
      "fileTooLarge": "Este archivo de vídeo es demasiado grande para subirlo. Elige un archivo más pequeño o graba tu pitch aquí.",
      "tooLong": "Este vídeo dura más de {{minutes}} minutos. Elige un vídeo más corto o graba tu pitch aquí.",
      "uploadStalled": "La subida se ha detenido porque tu conexión dejó de enviar datos. Comprueba tu conexión e inténtalo de nuevo.",
      "unreadable": "No hemos podido leer este vídeo, así que no se puede comprobar su duración. Elige un vídeo MP4 o WebM que se reproduzca en este dispositivo o graba tu pitch aquí."
    },
    "pitchRecorder": "Grabador de pitch",
    "practiceNote": "Consejo: practica una vez antes de grabar.",
    "previousVideo": "Video anterior",
    "progressComplete": "{{percent}}% completo",
    "questionN": "Pregunta {{n}}",
    "questionNofM": "Pregunta {{n}} de {{m}}",
    "questions": "Preguntas",
    "questionsLoadError": "Error al cargar preguntas",
    "questionsUnavailable": "Preguntas no disponibles",
    "quota": {
      "exceeded": "Límite diario alcanzado. Mejora tu plan para más mensajes.",
      "remaining": "Mensajes restantes",
      "upgrade": "Mejora para más"
    },
    "quotaReached": "¡Cuota alcanzada! Actualiza a Pro para acceso ilimitado.",
    "ready": "Listo",
    "readyQ": "¿Listo para empezar?",
    "recordAnswer": "Grabar respuesta",
    "recordYourPitch": "Graba tu presentación",
    "required": "Requerido",
    "responseCare": "Tu retroalimentación de Care muestra mejora en Comunicación y Habilidades Técnicas. ¡Sigue así! Para Comportamiento y Adaptación, considera unirte a comunidades locales y eventos de networking.",
    "responseCareer": "Según tu perfil, estás bien posicionado para oportunidades en Portugal. Tus habilidades técnicas son fuertes y tu nivel de inglés es excelente. Te sugeriría centrarte en la práctica del idioma portugués para aumentar tu tasa de coincidencia.",
    "responseCheckup": "Basado en tus resultados de CheckUp, ¡puedo ver que lo estás haciendo bien! Tu puntuación de preparación de 85 muestra una fuerte preparación. Te recomendaría enfocarte en la adaptación cultural, que está en 75. Considera completar lecciones de QultureUp para mejorar esta área.",
    "responseDefault": "Entiendo tu pregunta. Déjame ayudarte con eso.",
    "responseHelp": "¡Estoy aquí para ayudar! Puedo asistirte con la comprensión de tus resultados de CheckUp, navegar por las tareas de TelePortal, aprender sobre la cultura en QultureUp, rastrear tu progreso en Care, y encontrar oportunidades de carrera. ¿En qué área específica te gustaría ayuda?",
    "responseQultureup": "¡Genial que estés interesado en QultureUp! Te recomiendo comenzar con el mundo de 'Cultura Local' para familiarizarte con las costumbres y tradiciones portuguesas. Esto te ayudará a adaptarte más rápido cuando llegues.",
    "responseScore": "Tu puntuación actual de preparación es 85/100, ¡lo cual es excelente! Estás en la categoría 'Casi Listo'. Las principales áreas en las que debes centrarte son Adaptación Cultural (75) y Experiencia Internacional (70). ¿Te gustaría recomendaciones específicas?",
    "responseTeleportal": "Para tu viaje de TelePortal, veo que estás en la fase de Preparación de Visa. Asegúrate de reunir todos los documentos requeridos y programar tu entrevista. ¿Te gustaría que te ayude con una tarea específica?",
    "responseVisa": "Para tu reubicación, te recomiendo comenzar con la Evaluación de TelePortal para obtener una lista de verificación personalizada. Asegúrate de tener todos los documentos requeridos listos. El proceso de visa generalmente toma de 2 a 3 meses, así que planifica en consecuencia.",
    "restartFlow": "Reiniciar",
    "reviewAnswers": "Revisar respuestas",
    "reviewDesc": "Tómate un momento para revisar tus respuestas antes de enviar.",
    "reviewJourney": "Revisa la configuración de tu viaje antes de que la preparemos para ti",
    "reviewYourAnswers": "Revisar tus respuestas",
    "safety": {
      "critical": "No tienes que pasar por esto sin ayuda: basta una llamada.",
      "elevated": "Este tema requiere una cuidadosa consideración. CoPilot proporciona solo orientación general; consulte a un profesional para obtener asesoramiento específico.",
      "standard": "CoPilot utiliza IA. Las respuestas pueden no ser siempre precisas. Siempre verifique información importante.",
      "getHelp": "Obtener ayuda",
      "help": {
        "title": "Ayuda, ahora",
        "intro": "Si tú o alguien cerca de ti está en peligro, llama ahora: estas líneas atienden día y noche.",
        "lines": {
          "emergency": "Número europeo de emergencias",
          "sns24": "SNS 24 — salud y apoyo psicológico"
        },
        "availability": {
          "always": "24 horas, todos los días"
        },
        "care": "Hablar con el apoyo de Care",
        "careHint": "Care tiene un equipo y recursos para lo que estás sintiendo."
      }
    },
    "sameCountryWarning": "El origen y el destino no pueden ser el mismo país.",
    "saved": "Guardado",
    "saving": "Guardando…",
    "searchCountry": "Buscar país...",
    "selectCountry": "Seleccionar...",
    "selectedAsDest": "Seleccionado como destino",
    "selectedAsOrigin": "Seleccionado como origen",
    "send": "Enviar",
    "situation": {
      "answered": "Respondido",
      "companyProvides": "Mi empresa proporciona esto",
      "companySponsored": "Patrocinado por la empresa",
      "companySponsoredDesc": "Mi empleador está patrocinando mi reubicación.",
      "description": "Elige la opción que mejor describa tu situación.",
      "digitalNomad": "Nómada digital",
      "digitalNomadDesc": "Trabajaré de forma remota desde mi nuevo país.",
      "employedSelf": "Estoy empleado y me mudo por mi cuenta",
      "employedSponsored": "Estoy empleado y mi empresa patrocina la mudanza",
      "entrepreneur": "Emprendedor",
      "euCitizen": "Ciudadano de la UE",
      "euCitizenDesc": "Soy ciudadano de la UE y no necesito visa.",
      "familyReunion": "Reunificación familiar",
      "familyReunionDesc": "Me uno a la familia que ya está en el extranjero.",
      "haveHousing": "Tengo vivienda arreglada",
      "haveVisa": "Ya tengo una visa",
      "haveVisaDesc": "He asegurado mi visa para esta mudanza.",
      "housingTitle": "Situación de vivienda",
      "jobSeeking": "Buscando trabajo",
      "legalTitle": "Situación legal",
      "needFind": "Necesito encontrar vivienda",
      "needTemp": "Necesito vivienda temporal",
      "needVisa": "Necesito obtener una visa",
      "needVisaDesc": "Aún no he solicitado una visa.",
      "pathwayTitle": "Ruta de visa",
      "pathwaysUnavailable": "No pudimos cargar las rutas de visa. Puedes continuar sin elegir una.",
      "credentialTitle": "Profesión regulada",
      "credentialQuestion": "¿Trabajas en una profesión regulada (por ejemplo medicina, enfermería, ingeniería o derecho) en el país al que te mudas? Si es así, tu titulación debe reconocerse allí antes de poder ejercer.",
      "credentialYes": "Sí, mi profesión está regulada",
      "credentialNo": "No",
      "pathway": {
        "workPermit": "Permiso de trabajo (patrocinado)",
        "workPermitDesc": "Residencia patrocinada por el empleador",
        "techVisa": "Visa tech",
        "techVisaDesc": "Contratación técnica de empresa certificada",
        "d7": "D7 — Ingresos pasivos / remoto",
        "d7Desc": "Basado en ingresos o trabajo remoto",
        "euFamily": "Reunificación familiar / UE",
        "euFamilyDesc": "Nacional de la UE o unirse a la familia",
        "d1": "D1 — Visa de trabajo",
        "d1Desc": "Empleo por cuenta ajena",
        "d2": "D2 — Emprendedor / trabajador autónomo",
        "d2Desc": "Negocio propio o actividad por cuenta propia",
        "d8": "D8 — Nómada digital",
        "d8Desc": "Trabajo remoto para empleadores o clientes en el extranjero",
        "startup": "Visa para startups",
        "startupDesc": "Creación de una startup innovadora",
        "notSure": "Aún no estoy seguro",
        "notSureDesc": "Tonnie ayudará a determinarlo"
      },
      "professionalTitle": "Situación profesional",
      "retired": "Jubilado",
      "selfEmployed": "Autónomo",
      "student": "Estudiante",
      "studentVisa": "Visa de estudiante",
      "studentVisaDesc": "Me estoy mudando con una visa de estudiante.",
      "title": "Tu situación"
    },
    "submitFailed": "Error al enviar",
    "subtitle": "Tu asistente de IA está aquí para ayudar",
    "suggestedQuestions": "Preguntas sugeridas:",
    "thinking": "Pensando...",
    "title": "Tonnie CoPilot",
    "launcher": {
      "label": "Pregunta a Tonnie"
    },
    "toggle": "Alternar CoPilot",
    "trace": {
      "artifactUpdate": "Artifact actualizado",
      "cancel": "Cancelar",
      "completeness": "Completitud",
      "confirm": "Confirmar",
      "error": "Error",
      "retry": "Reintentar",
      "widget": "Widget"
    },
    "tryAgain": "Intenta de nuevo",
    "unavailable": "CoPilot no está disponible temporalmente. Por favor, inténtalo de nuevo en un momento.",
    "unlimited": "Plan Pro: Consultas ilimitadas",
    "unlimitedQuestions": "Preguntas ilimitadas",
    "unlockNote": "Tu viaje personalizado ha sido creado. Desbloquéalo desde el",
    "upgrade": "Actualizar",
    "upgradeToPro": "Actualizar a Pro",
    "uploadNote": "Mantendremos tu video privado: solo tú y nuestra IA lo verán.",
    "uploadingVideo": "Subiendo video…",
    "verifiedByTonnieGuard": "Verificado por Tonnie guard",
    "videoCompleted": "Completado",
    "videoPlayerDesc": "Reproductor de video para {{title}}. Haz clic en reproducir para comenzar el video.",
    "videoResume": "Reanudar",
    "videoSent": "Video enviado",
    "videoStateInProgress": "En curso",
    "videoStatePending": "Sin empezar",
    "videoStateWatched": "Visto",
    "videoSubmitted": "Video enviado",
    "videoToWatch": "Por ver",
    "videoUploadFailed": "Error al subir el video",
    "videoWatchedLabel": "Visto",
    "videosWatched": "videos vistos",
    "voice": {
      "error": "Lo siento, no te he entendido. Inténtalo de nuevo.",
      "status": {
        "listening": "Estoy escuchando...",
        "transcribing": "Transcribiendo…"
      },
      "a11y": {
        "pause": "Pausar escucha",
        "start": "Iniciar entrada de voz"
      }
    },
    "whyWeAsk": "Por qué preguntamos",
    "widgetError": "Este widget no se pudo cargar.",
    "widgetNotFound": "Widget \"{{name}}\" no encontrado",
    "yesBringingFamily": "Sí, trayendo a la familia",
    "aria": {
      "conversation": "Conversación",
      "messageInput": "Mensaje",
      "sendMessage": "Enviar mensaje",
      "answerInput": "Tu respuesta"
    },
    "tools": {
      "checkingCohorts": "Comprobando tus programas…",
      "checkingJourney": "Comprobando tu viaje…",
      "checkingTasks": "Comprobando tus tareas…",
      "checkingCheckup": "Comprobando tu CheckUp…",
      "checkingCare": "Comprobando tu bienestar…",
      "checkingObjectives": "Comprobando tus objetivos de Care…",
      "checkingPassport": "Comprobando tu Passport…",
      "checkingMiles": "Comprobando tus millas…",
      "checkingNotifications": "Comprobando tus notificaciones…",
      "checkingHousehold": "Comprobando tu hogar…",
      "checkingBilling": "Comprobando tu facturación…",
      "checkingCareer": "Comprobando oportunidades de carrera…",
      "submittingCheckpoint": "Enviando tu punto de control…",
      "creatingSupport": "Generando una solicitud de soporte…",
      "schedulingCheckpoints": "Programando tus puntos de control…",
      "submittingSelfEval": "Enviando tu autoevaluación…",
      "completingMission": "Completando tu misión…",
      "submittingQuiz": "Enviando tu cuestionario…",
      "markingRead": "Actualizando tus notificaciones…",
      "addingMember": "Añadiendo un miembro del hogar…",
      "updatingMember": "Actualizando un miembro del hogar…",
      "savingOpportunity": "Guardando la oportunidad…",
      "expressingInterest": "Enviando tu interés…",
      "checkingDocuments": "Revisando tus documentos…",
      "checkingProfile": "Revisando tu perfil…",
      "checkingMesh": "Revisando tu MESH…",
      "checkingQultureup": "Revisando tu QultureUp…",
      "checkingWorlds": "Revisando tus mundos…",
      "savingToVault": "Guardando en tu Bóveda…",
      "attachingFile": "Adjuntando el archivo…",
      "updatingTask": "Actualizando la tarea…",
      "startingMission": "Iniciando la misión…",
      "checkingProgramSetup": "Revisando la configuración de tu programa…",
      "reopeningTask": "Reabriendo la tarea…",
      "completingTask": "Completando la tarea…",
      "submittingCheckin": "Registrando tu check-in…",
      "startingRetake": "Iniciando tu CheckUp…",
      "recallingMemories": "Revisando lo que recuerdo…",
      "rememberingFact": "Haciendo una nota…",
      "forgettingFact": "Olvidando eso…",
      "searchingKnowledge": "Revisando la base de conocimientos…",
      "readingNote": "Leyendo sobre eso…",
      "listingPipelineTalents": "Revisando tu pipeline de talento…",
      "checkingTalentOverview": "Revisando la visión general del talento…",
      "checkingTalentReadiness": "Revisando la preparación del talento…",
      "checkingTalentMobility": "Revisando el progreso de reubicación del talento…",
      "checkingTalentAdaptation": "Revisando la adaptación del talento…",
      "checkingTalentRisk": "Revisando el bienestar y riesgo del talento…",
      "checkingTalentEvidence": "Revisando la evidencia del talento…",
      "checkingCohort": "Revisando la cohorte…",
      "checkingProgram": "Revisando el programa…",
      "checkingPipeline": "Revisando tu pipeline…",
      "checkingAffiliate": "Comprobando tu cuenta de afiliado…",
      "checkingPoolCounts": "Contando tu pool de talentos…",
      "checkingPoolTalent": "Comprobando el talento del pool…",
      "searchingWeb": "Buscando en la web…",
      "sponsoringTalent": "Preparando el patrocinio…",
      "addingTalentToCohort": "Añadiendo el talento a la cohorte…",
      "addingTalentNote": "Añadiendo una nota interna…",
      "savingVettingDocument": "Guardando el documento de evaluación…",
      "checkingMyWorkQueue": "Revisando lo que necesitas…",
      "messagingTalent": "Preparando tu mensaje…",
      "requestingCheckin": "Preparando una solicitud de check-in…",
      "schedulingMeeting": "Preparando la invitación…",
      "checkingCompany": "Revisando el perfil de tu empresa…",
      "checkingPrograms": "Comprobando tus programas…",
      "checkingDashboard": "Revisando tu panel…",
      "checkingActivity": "Revisando la actividad reciente…",
      "checkingAnalytics": "Revisando tus análisis…",
      "checkingVetting": "Revisando tu visión general de evaluación…",
      "checkingMobility": "Revisando tu visión general de movilidad…",
      "checkingAdaptation": "Revisando tu visión general de adaptación…",
      "checkingEvidence": "Revisando tu visión general de evidencia…",
      "checkingCareConfig": "Revisando la configuración de tu Care…",
      "checkingInvoices": "Revisando tus facturas…",
      "checkingSponsorships": "Revisando tus patrocinios…",
      "checkingTeam": "Revisando tu equipo…",
      "checkingMessageTemplates": "Revisando tus plantillas de mensajes…",
      "checkingMessageAnalytics": "Revisando tus análisis de mensajes…",
      "checkingAuditLog": "Revisando tu registro de auditoría…",
      "creatingProgram": "Preparando el nuevo programa…",
      "creatingCohort": "Preparando la nueva cohorte…",
      "invitingTeamMember": "Preparando la invitación al equipo…",
      "removingTeamMember": "Preparando para eliminar al miembro del equipo…",
      "resolvingInteraction": "Actualizando la interacción de Care…",
      "reschedulingInteraction": "Reprogramando la interacción de Care…",
      "cancellingInteraction": "Cancelando la interacción de Care…",
      "commentingInteraction": "Añadiendo tu comentario…",
      "working": "Trabajando…",
      "preparingNextStep": "Preparando tu próximo paso…",
      "checkingInOut": "Comprobando tus relojes de InOut…",
      "simulatingTrip": "Simulando tu viaje…"
    },
    "errors": {
      "quota_exceeded": "Has alcanzado tu límite diario de mensajes. Se reinicia a medianoche.",
      "budget_degraded": "Estoy funcionando en un modo limitado en este momento — aún puedo ayudar con respuestas concretas.",
      "provider_unavailable": "Estoy teniendo problemas para alcanzar mis capacidades completas en este momento. Por favor, inténtalo de nuevo en un momento.",
      "capability_disabled": "Esa capacidad no está disponible temporalmente.",
      "stale_proposal": "Eso cambió desde que lo sugerí — pregúntame de nuevo y lo revisaré de nuevo.",
      "aborted": "Detenido.",
      "internal": "Algo salió mal de mi lado. Por favor, inténtalo de nuevo.",
      "messageRequired": "Por favor, escribe un mensaje primero.",
      "uploadFailed": "La subida falló. Por favor, inténtalo de nuevo.",
      "ref": "Referencia"
    },
    "source": {
      "from": "De",
      "why": "Por qué puedes confiar en esto",
      "cases": "{{n}} reubicaciones similares",
      "webSources": "Fuentes"
    },
    "webSearch": {
      "toggle": "Buscar en la web",
      "toggleHint": "Deja que Tonnie busque información actual en la web para esta pregunta"
    },
    "feedback": {
      "helpful": "Útil",
      "notHelpful": "No útil",
      "thanks": "Gracias por los comentarios"
    },
    "toolResult": {
      "success": "Hecho",
      "failed": "Eso no funcionó"
    },
    "suggestions": {
      "complete_checkup": {
        "title": "Completa tu CheckUp"
      },
      "explore_qultureup": {
        "title": "Explora QultureUp"
      },
      "check_passport": {
        "title": "Consulta tu progreso"
      },
      "checkup_incomplete": {
        "title": "¿Quieres terminar tu CheckUp? Puedo guiarte a través de ello."
      },
      "tasks_blocked": {
        "title_one": "Tienes {{count}} tarea bloqueada — ¿quieres ayuda para desbloquearla?",
        "title_other": "Tienes {{count}} tareas bloqueadas — ¿quieres ayuda para desbloquearlas?"
      },
      "care_pending": {
        "title_one": "Tienes {{count}} check-in pendiente — ¿lo hacemos?",
        "title_other": "Tienes {{count}} check-ins pendientes — ¿los hacemos?"
      },
      "docs_expiring": {
        "title_one": "{{count}} documento está por caducar — ¿quieres revisarlo?",
        "title_other": "{{count}} documentos están por caducar — ¿quieres revisarlos?"
      },
      "checkup_result_published": {
        "title": "Tus resultados están listos — ¿quieres que te los explique?"
      },
      "vetting_backlog": {
        "title_one": "{{count}} talento está esperando en Vetting — ¿quieres revisarlo?",
        "title_other": "{{count}} talentos están esperando en Vetting — ¿quieres revisarlos?"
      },
      "care_overdue": {
        "title_one": "{{count}} checkpoint de Care está atrasado — ¿quieres ver quién necesita atención?",
        "title_other": "{{count}} checkpoints de Care están atrasados — ¿quieres ver quién necesita atención?"
      }
    },
    "proposal": {
      "aria": "Confirmación de acción",
      "confirm": "Confirmar",
      "confirming": "Confirmando…",
      "dismiss": "No ahora",
      "expired": "Esta oferta ha expirado — pregúntame de nuevo.",
      "stale": "Esto ha cambiado desde que lo sugerí — pregúntame de nuevo.",
      "error": "Algo salió mal. Por favor, inténtalo de nuevo.",
      "untrustedWarning": "Esto provino de un archivo subido — revísalo antes de confirmar.",
      "typeToConfirm": "Escribe {{token}} para confirmar",
      "confirmed": "✓ Hecho — he completado eso por ti.",
      "alreadyCheckedIn": "Ya has registrado un check-in hoy, así que no se añadió nada nuevo.",
      "attachedCompletionPending": "✓ Archivo adjunto — pero la tarea aún no está completa; faltan algunos documentos requeridos."
    },
    "attachFile": "Adjuntar un archivo",
    "proactive": {
      "dismiss": "Descartar"
    },
    "newConversation": "Nueva conversación",
    "choices": {
      "label": "Opciones sugeridas",
      "other": "Otro…"
    },
    "removeAttachment": "Eliminar archivo",
    "depth": {
      "label": "Longitud de respuesta",
      "brief": "Breve",
      "balanced": "Equilibrado",
      "detailed": "Detallado",
      "briefHint": "Respuestas cortas y directas",
      "balancedHint": "Detalle equilibrado (predeterminado)",
      "detailedHint": "Respuestas completas y detalladas"
    },
    "rewrite": {
      "shorter": "Más corto",
      "longer": "Más largo",
      "shorterCommand": "Haz que tu respuesta anterior sea más corta y directa, en el mismo idioma.",
      "longerCommand": "Amplía tu respuesta anterior con más detalles y explicaciones, en el mismo idioma."
    },
    "attach": {
      "takePhoto": "Tomar una foto",
      "choosePhoto": "Elegir una foto",
      "recordVideo": "Grabar un video",
      "chooseVideo": "Elegir un video",
      "videoTooLarge": "Ese video es demasiado grande. Graba un clip más corto (hasta 25 MB) y vuelve a intentarlo."
    },
    "permissions": {
      "cameraTitle": "Cámara no disponible",
      "cameraDenied": "Permite el acceso a la cámara en la configuración de tu dispositivo para que puedas mostrarle a Tonnie una foto o video.",
      "libraryTitle": "Biblioteca de fotos no disponible",
      "libraryUnavailable": "No pudimos abrir tu biblioteca de fotos. Intenta de nuevo, o permite el acceso en la configuración de tu dispositivo.",
      "microphoneDenied": "Permite el acceso al micrófono en la configuración de tu dispositivo para que puedas hablar con Tonnie en lugar de escribir."
    },
    "history": {
      "title": "Conversaciones",
      "back": "Volver al chat",
      "newChat": "Nuevo chat",
      "searchPlaceholder": "Buscar conversaciones",
      "empty": "No hay conversaciones aún",
      "emptySearch": "Sin coincidencias",
      "untitled": "Sin título",
      "rename": "Renombrar",
      "delete": "Eliminar",
      "actions": "Acciones de conversación",
      "deleteTitle": "¿Eliminar conversación?",
      "deleteBody": "Esta conversación será eliminada de tu historial. Esto no se puede deshacer.",
      "cancel": "Cancelar"
    },
    "familyFromProfile": "De tu perfil: cámbialo si ahora es diferente.",
    "originShort": "Origen",
    "destinationShort": "Destino",
    "actionsAvailable_one": "{{count}} acción disponible",
    "actionsAvailable_other": "{{count}} acciones disponibles",
    "questionsRemaining_one": "{{count}} pregunta restante hoy",
    "questionsRemaining_other": "{{count}} preguntas restantes hoy",
    "offer": {
      "title": "Tu próximo paso con {{partner}}",
      "kind": {
        "CONSULTATION": "Consulta especializada",
        "REQUISITION": "Requisición — la asesoría se encarga de tu solicitud"
      },
      "vatIncluded": "IVA incluido",
      "credit": "Lo que pagas por la consulta se descuenta de la requisición.",
      "open": "Continuar",
      "openOnWeb": "Continuar en la web",
      "website": "Sobre {{partner}}"
    },
    "aiUnavailable": {
      "description": "CoPilot no puede responder ahora mismo. Lo estamos reintentando; todo lo demás en Tonnie funciona con normalidad."
    }
  },
  "coupon": {
    "applied": "¡Cupón {{code}} aplicado con éxito!",
    "apply": "Aplicar",
    "enterCode": "Introduce el código del cupón",
    "error": "Error al aplicar el cupón. Por favor, inténtalo de nuevo.",
    "invalid": "Código de cupón inválido"
  },
  "cvBuilder": {
    "addExperience": "Añadir experiencia",
    "addSkill": "Agregar habilidad",
    "aiOptimize": "Optimizar IA para el mercado de Portugal",
    "clickEditToExpand": "Haz clic en Editar para expandir esta sección",
    "complete": "completo",
    "completeAllSections": "Completa todas las secciones para obtener los mejores resultados",
    "copilotSuggestions": "Sugerencias de CoPilot",
    "cvCompleteness": "Completitud del CV",
    "cvSections": "Secciones del CV",
    "deleteExperience": "Eliminar experiencia",
    "description": "Crea un CV profesional adaptado a tu mercado objetivo",
    "editExperience": "Editar experiencia",
    "editSection": "Editar sección",
    "education": "Educación",
    "exportDescription": "En producción, esto generaría tu archivo CV.",
    "exportFileDesc": "CV_{{firstName}}_{{lastName}}.{{format}} se descargaría.",
    "exportPDF": "Exportar PDF",
    "exportSuccess": "{{format}} exportado con éxito!",
    "exportWord": "Exportar word",
    "fullName": "Nombre completo",
    "generatingExport": "Generando exportación {{format}}...",
    "importLinkedIn": "Importar desde LinkedIn PDF",
    "items": "elementos",
    "languages": "Idiomas",
    "location": "Ubicación",
    "mockEducation1": {
      "degree": "Licenciatura en informática",
      "institution": "Universidad de tecnología",
      "period": "2014–2018"
    },
    "mockExperience1": {
      "company": "Tech solutions inc.",
      "description": "Lideré el desarrollo de aplicaciones web escalables. Colaboré con equipos internacionales.",
      "period": "2020 — Presente",
      "role": "Ingeniero de software senior"
    },
    "mockExperience2": {
      "company": "StartupXYZ",
      "description": "Construí y mantuve aplicaciones web utilizando React y Node.js.",
      "period": "2018–2020",
      "role": "Desarrollador full-stack"
    },
    "personalInfo": "Información personal",
    "phone": "Teléfono",
    "preview": "Vista previa",
    "professionalSummary": "Resumen profesional",
    "quickActions": "Acciones rápidas",
    "removeSkill": "Eliminar habilidad",
    "skills": "Habilidades",
    "suggestAddSkills": "Añade más habilidades relevantes para tu rol objetivo (se recomiendan 5 más)",
    "suggestExpandSummary": "Amplía tu resumen profesional con logros clave",
    "template": "Plantilla",
    "templates": {
      "classic": "Clásica",
      "creative": "Creativa",
      "minimal": "Mínima",
      "modern": "Moderna"
    },
    "title": "Constructor de CV",
    "translateToPortuguese": "Traducir al portugués",
    "wizard": {
      "applyChanges": "Aplicar cambios",
      "applying": "Aplicando...",
      "backToEdit": "Volver a editar",
      "characters": "caracteres",
      "clickNextToGenerate": "Haz clic en Generar para crear tu CV personalizado",
      "company": "Empresa",
      "companyPlaceholder": "p. ej., TechCorp Solutions",
      "completeAllSteps": "Completa todos los pasos antes de guardar",
      "createFirstCV": "Crea tu primer CV para comenzar",
      "cvDeleted": "CV eliminado con éxito!",
      "cvGeneratedDescription": "Tu CV ha sido generado y guardado. Ahora puedes revisar y editar cada sección, o exportarlo directamente.",
      "cvGeneratedSuccess": "CV generado con éxito!",
      "cvSaved": "CV guardado con éxito!",
      "cvUpdated": "CV actualizado con éxito!",
      "defaultJobTitle": "este puesto",
      "deleteConfirm": "¿Estás seguro de que quieres eliminar este CV?",
      "deleteConfirmTitle": "Eliminar CV",
      "description": "Genera CVs profesionales adaptados a descripciones de trabajo utilizando tus datos de Journey",
      "done": "Hecho",
      "dragDropFile": "Arrastra y suelta un archivo aquí, o haz clic para seleccionar",
      "edit": "Editar",
      "enterPrompt": "Por favor, introduce instrucciones de refinamiento",
      "fileSelected": "Archivo seleccionado",
      "fileUploaded": "Archivo subido: {{fileName}}",
      "generateCV": "Generar CV",
      "generatedEducation": "{{degree}} de {{institution}} ({{period}})",
      "generatedExperience": "{{role}} en {{company}} ({{period}})\n{{description}}",
      "generatedReadiness": "Puntuación de preparación internacional: {{iqulture}}/100\ndesglose de MESH: Motivación {{motivation}}% • Inglés {{english}}% • Habilidades blandas {{softSkills}}% • Habilidades duras {{hardSkills}}%",
      "generatedSummary": "Profesional experimentado con una puntuación de preparación internacional de {{iqulture}}/100. {{name}} aporta una sólida experiencia técnica y una adaptabilidad comprobada a entornos internacionales, lo que lo convierte en un candidato ideal para {{jobTitle}}.",
      "generating": "Generando...",
      "generatingCV": "Generando tu CV...",
      "generatingDescription": "La IA está analizando tu perfil y los requisitos del trabajo",
      "invalidFileType": "Tipo de archivo no válido. Por favor, sube archivos .txt, .doc, .docx o .pdf.",
      "jobDescription": "Descripción del trabajo",
      "jobDescriptionPlaceholder": "Pega la descripción completa del trabajo aquí...",
      "jobTitle": "Título del trabajo",
      "jobTitlePlaceholder": "p. ej., Ingeniero de Software Senior",
      "newCV": "Nuevo CV",
      "next": "Siguiente",
      "noCVs": "No hay CVs aún",
      "of": "de",
      "optional": "(Opcional)",
      "orCreateNew": "o crea uno nuevo",
      "orUploadFile": "O subir archivo de descripción del trabajo",
      "preview": "Vista previa",
      "previous": "Anterior",
      "promptPlaceholder": "Ej. Añadir más detalles sobre infraestructura en la nube, enfocarse en servicios de AWS...",
      "readyToGenerate": "Listo para generar",
      "refine": "Refinar",
      "refineDescription": "Introduce instrucciones para modificar esta sección:",
      "refineSection": "Refinar sección",
      "refinedBasedOn": "Refinado basado en",
      "refinementSuccess": "¡Sección refinada con éxito!",
      "saveCV": "Guardar CV",
      "savedCVs": "CVs guardados",
      "sections": {
        "education": "Educación",
        "internationalReadiness": "Preparación internacional",
        "professionalSummary": "Resumen profesional",
        "skills": "Habilidades",
        "workExperience": "Experiencia laboral"
      },
      "selectCVToPreview": "Selecciona un CV para vista previa",
      "step": "Paso",
      "step1": {
        "description": "Introduce la descripción del trabajo para el puesto al que estás aplicando. Esto nos ayudará a personalizar tu CV.",
        "title": "Descripción del trabajo"
      },
      "step2": {
        "description": "La IA analizará la descripción del trabajo y generará secciones de CV personalizadas basadas en tus datos de Journey.",
        "title": "Generación de CV"
      },
      "step3": {
        "description": "Revisa y refina cada sección. Usa indicaciones para personalizar el contenido según requisitos específicos.",
        "title": "Refinamiento"
      },
      "step4": {
        "description": "Revisa tu CV final y guárdalo o expórtalo en tu formato preferido.",
        "title": "Revisar y exportar"
      },
      "steps": {
        "generation": "Generación",
        "jobDescription": "Descripción del trabajo",
        "refinement": "Refinamiento",
        "review": "Revisión"
      },
      "subtitle": "Crea CVs específicos para cada oportunidad",
      "supportedFormats": "Soporta: .txt, .doc, .docx, .pdf",
      "title": "Asistente de generación de CV",
      "unsavedChanges": "Tienes cambios no guardados. ¿Estás seguro de que quieres salir?",
      "unsavedChangesTitle": "Cambios no guardados"
    },
    "workExperience": "Experiencia laboral"
  },
  "dashboard": {
    "activity": {
      "checkupUpdated": "Evaluación de CheckUp actualizada",
      "portugueseBasicsCompleted": "Completado Portugués básico nivel 1",
      "twoDaysAgo": "hace 2 días",
      "twoHoursAgo": "Hace 2 horas",
      "visaVerificationPending": "Verificación de documentos de visa pendiente",
      "yesterday": "Ayer",
      "title": "Actividad reciente",
      "showAll": "Mostrar todo"
    },
    "allCheckpointsDone": "Todos los puntos de control completados",
    "banner": {
      "completed": "Hecho",
      "notStarted": "No iniciado",
      "progress": "Progreso"
    },
    "care": {
      "allComplete": "Todos los puntos de control completados",
      "assessmentDone": "Evaluación completada",
      "awaitingData": "Esperando datos",
      "mood": "Estado de ánimo:",
      "moodCta": "¿Cómo te sientes hoy?",
      "notStarted": "Rastrea tu bienestar a través de 5 pilares de la vida con chequeos regulares.",
      "startCta": "Iniciar Care",
      "subtitle": "Soporte de bienestar y chequeos"
    },
    "checkup": {
      "assessmentDone": "Evaluación completa",
      "calculateCta": "Calcular puntuación",
      "calculating": "Calculando...",
      "calculatingDesc": "Analizando tu preparación en Motivación, Inglés, Habilidades Blandas y Habilidades Duras.",
      "iqulture": "Puntuación de iQulture",
      "lastAssessment": "Último: {{date}}",
      "notStarted": "Descubre tu puntuación de preparación en Motivación, Inglés, Habilidades Blandas y Habilidades Duras.",
      "readyToCalculate": "Tu puntuación de preparación de MESH está lista para ser calculada.",
      "startCta": "Iniciar evaluación",
      "subtitle": "Mide tu preparación con MESH",
      "awaitingProfile": "Falta el perfil",
      "awaitingProfileDesc": "Tu evaluación está hecha. Completa tu perfil para obtener tu puntuación."
    },
    "continueJourney": "Continuar viaje",
    "cta": {
      "continueQultureUp": "Continuar QultureUp",
      "continueTelePortal": "Continuar TelePortal",
      "startCare": "Iniciar Care",
      "startCheckUp": "Iniciar CheckUp",
      "startQultureUp": "Iniciar QultureUp",
      "startTelePortal": "Iniciar TelePortal",
      "viewCheckUp": "Ver CheckUp",
      "viewPassport": "Ver Passport",
      "completeProfile": "Completa tu perfil",
      "continueCare": "Continuar Care"
    },
    "emptyState": {
      "description": "Crea tu viaje profesional internacional para desbloquear tu panel personalizado con seguimiento de progreso a través de todos los héroes.",
      "title": "Construye tu viaje"
    },
    "errorState": {
      "description": "Algo salió mal al cargar los datos de tu panel. Por favor, intenta actualizar la página.",
      "title": "No se pudo cargar el panel"
    },
    "heroInsight": {
      "care": {
        "checkpoints": "{{done}} de {{total}} puntos de control",
        "notStarted": "Rastrea tu bienestar",
        "startCheckin": "Registra tu primer chequeo",
        "streak": "Racha de {{n}} días",
        "subtitle": "Rastrea tu bienestar"
      },
      "checkup": {
        "notStarted": "Realiza tu evaluación",
        "subtitle": "Mide tu preparación"
      },
      "qultureup": {
        "allDone": "¡Todas las misiones completas!",
        "missionsLabel": "misiones",
        "notStarted": "Descubre tu nivel cultural",
        "subtitle": "Aprende tu nueva cultura",
        "todaysMission": "La misión de hoy"
      },
      "teleportal": {
        "allDone": "No hay plazos próximos",
        "next": "Siguiente: {{name}}",
        "notStarted": "Construye tu plan de reubicación",
        "overdue_one": "{{count}} vencido",
        "overdue_other": "{{count}} vencidos",
        "subtitle": "Planifica tu reubicación",
        "tasksLabel": "tareas"
      }
    },
    "journeyProgress": "Tu viaje {{route}} está {{percent}}% completo.",
    "journeyProgressDescription": "Rastrea tu progreso en cada paso",
    "journeyProgressTitle": "Tu progreso en el viaje",
    "journeyReady": "Tu viaje está listo para comenzar.",
    "miles": "Miles de viaje",
    "moodLabel": "Estado de ánimo:",
    "noActivity": "No hay actividad reciente aún. ¡Empieza a explorar a tus héroes!",
    "noJourney": "Sin viaje",
    "passport": {
      "badges": "Medallas",
      "citizenLevelValue": "Nv.{{level}}",
      "level": "Nivel",
      "noData": "Tu puntuación aparecerá aquí",
      "readiness": "Preparación",
      "recentStamps": "Sellos recientes",
      "stamps": "Sellos",
      "subtitle": "Tu registro completo del viaje",
      "totalMiles": "Total de Miles"
    },
    "qultureup": {
      "missions": "Misiones",
      "notStarted": "Explora mundos culturales y completa misiones para adaptarte a tu nuevo hogar.",
      "startCta": "Iniciar evaluación",
      "streak": "Racha de {{days}} días",
      "subtitle": "Adaptación cultural a través del aprendizaje",
      "tracks": "Pistas",
      "worlds": "Mundos"
    },
    "recentActivity": "Actividad reciente",
    "recentActivityDescription": "Tus últimos hitos y actualizaciones",
    "teleportal": {
      "docs": "Documentos listos:",
      "notStarted": "Configura tu plan de reubicación con las rutas Legal, Viaje y Configuración.",
      "startCta": "Iniciar configuración",
      "subtitle": "Planifica y ejecuta tu reubicación"
    },
    "welcomeBack": "¡Bienvenido de nuevo, {{name}}! 👋",
    "hero": {
      "scoreIn": "Ya tienes tu puntuación",
      "hello": "Hola, {{name}}",
      "helloNoName": "Hola de nuevo",
      "strongest": "Tu fuerte: {{dimension}}",
      "toGrow": "Por desarrollar: {{dimension}}",
      "resultsLink": "Ver tus resultados",
      "day": "Día {{day}}",
      "dayLabel": "de tu viaje"
    }
  },
  "deepLink": {
    "copyUrl": "Copiar URL",
    "downloadApp": "Descargar aplicación",
    "error": {
      "invalidAction": "Acción de enlace profundo no válida",
      "noUser": "Usuario no autenticado"
    },
    "fallbackDescription": "Si la aplicación no se abre automáticamente, instálala desde la tienda de aplicaciones.",
    "landing": {
      "continueIn": "Continuar en",
      "continueOnWeb": "Continuar en la web",
      "copied": "Enlace copiado",
      "copyLink": "Copiar enlace",
      "desktopBody": "Estás en un navegador de escritorio. Abre la aplicación Tonnie en tu teléfono o continúa en la web.",
      "goHome": "Ir a inicio",
      "installApp": "Instalar la app",
      "invalidBody": "Este enlace no es válido o ha expirado.",
      "invalidTitle": "Enlace no válido",
      "mobileBody": "Abre este enlace en la aplicación Tonnie para la mejor experiencia.",
      "openApp": "Abrir en la app",
      "publicNote": "Esta página es pública. Cualquiera con el enlace puede verla hasta que expire.",
      "retryAgain": "Intenta de nuevo"
    },
    "openInMobile": "Abrir en la app móvil",
    "qr": {
      "copied": "Enlace copiado",
      "copyLink": "Copiar enlace",
      "description": "Escanea este código QR con tu teléfono para abrir la aplicación Tonnie y continuar.",
      "dontHaveApp": "¿No tienes la app aún?",
      "note": "El enlace expira después del tiempo mostrado arriba.",
      "title": "Continúa en tu teléfono"
    },
    "urlCopied": "URL de enlace profundo copiada al portapapeles"
  },
  "error": {
    "goHome": "Ir a inicio",
    "pageDescription": "Lamentamos las molestias. Por favor, inténtalo de nuevo o regresa a la página de inicio.",
    "pageTitle": "Algo salió mal",
    "retry": "Reintentar",
    "sectionDescription": "Esta sección encontró un error. Intenta actualizar o continuar con otras secciones.",
    "sectionTitle": "Error de sección",
    "tryAgain": "Intenta de nuevo",
    "clerkMissing": {
      "title": "Servicio de autenticación no configurado",
      "body": "Esta versión carece de EXPO_PUBLIC_CLERK_PUBLISHABLE_KEY. Reinstala una versión más reciente desde EAS, o contacta con soporte si esto persiste."
    }
  },
  "errorBoundary": {
    "goHome": "Ir a inicio",
    "pageEncounteredError": "Esta página encontró un error",
    "pageMessage": "Lamentamos las molestias. Por favor, inténtalo de nuevo o regresa a la pantalla de inicio.",
    "reloadPage": "Recargar página",
    "retry": "Reintentar",
    "sectionError": "Error de sección",
    "sectionMessage": "Esta sección encontró un error. Intenta actualizar o continuar con otras secciones.",
    "somethingWentWrong": "Algo salió mal",
    "tryAgain": "Intenta de nuevo",
    "unexpectedError": "Ocurrió un error inesperado.",
    "appErrorTitle": "Error de aplicación"
  },
  "evidence": {
    "kind": {
      "adaptationProgress": "Progreso de adaptación",
      "careCheckins": "Registros de bienestar de Care",
      "careOverview": "Resumen de Care",
      "checkupProgress": "Progreso de CheckUp",
      "checkupResults": "Resultados de CheckUp",
      "cv": "CV",
      "household": "Unidad familiar",
      "mobilityDocuments": "Documentos de movilidad",
      "mobilityPlan": "Plan de movilidad",
      "passportEvidence": "Evidencias de Passport",
      "pitchVideo": "Vídeo de presentación",
      "testitResults": "Resultados de TestIt"
    },
    "redaction": {
      "reason": {
        "controllerMinimisation": "Eliminado por la empresa para conservar solo lo necesario",
        "dataSubjectRequest": "Eliminado a petición de la persona",
        "legalObligation": "Eliminado para cumplir una obligación legal"
      }
    },
    "retention": {
      "reason": {
        "decisionInForce": "Se conserva como registro de la empresa de una decisión que sigue vigente. Se eliminará en la fecha indicada, o antes si la relación llega a un resultado.",
        "engagementEnded": "Se conserva como registro de la empresa de una decisión de contratación, para defender o responder a reclamaciones legales, hasta el final del periodo de conservación tras el fin de la relación.",
        "notProgressed": "Se conserva como registro de la empresa de una decisión de no seguir adelante, para defender o responder a reclamaciones legales, hasta el final del periodo de conservación."
      },
      "until": "Se conserva hasta el {{date}}",
      "noEndDate": "Aún sin fecha de fin: se fija cuando la relación llega a un resultado."
    },
    "trigger": {
      "engagementEnd": "Relación finalizada",
      "engagementStart": "Inicio de la relación",
      "onDemand": "Guardado a petición",
      "sponsorshipActivation": "Patrocinio activado",
      "stageTransition": "Etapa cambiada",
      "verdict": "Decisión de TestIt"
    },
    "withheld": {
      "scopeNotGranted": "No compartido con esta empresa cuando se tomó la decisión"
    },
    "record": {
      "title": "Registros de decisión",
      "description": "Lo que su empresa podía ver sobre {{name}} cada vez que tomó una decisión. Un registro se conserva tal como se guardó: los cambios posteriores en el perfil no lo modifican.",
      "captureNow": "Guardar un registro ahora",
      "capturing": "Guardando…",
      "captureSuccess": "Registro guardado",
      "captureRefusedEnded": "Esta relación está archivada o ha terminado, por lo que no se puede guardar un nuevo registro.",
      "captureFailed": "No se pudo guardar el registro.",
      "listLabel": "Registros de decisión, del más reciente al más antiguo",
      "empty": "Todavía no hay registros de decisión. Se guarda un registro cada vez que su empresa mueve, decide sobre, patrocina o termina su relación con este candidato.",
      "loadError": "No se pudieron cargar los registros de decisión.",
      "detailLoadError": "No se pudo cargar este registro.",
      "retry": "Reintentar",
      "itemsTitle": "Qué contiene el registro",
      "actorBy": "Por {{name}}",
      "actorSystem": "Guardado automáticamente",
      "actorOutsideTeam": "Por una acción de alguien ajeno a su equipo",
      "decision": {
        "stageMove": "Movido de {{from}} a {{to}}",
        "stageEntered": "Entró en {{to}}"
      },
      "origin": {
        "backfill": "Registro heredado",
        "backfillNote": "Guardado antes de que los registros se conservaran en el servidor. Solo contiene lo que el navegador envió en ese momento, y el consentimiento vigente entonces no quedó registrado."
      },
      "listTitle": "Registros · del más reciente",
      "count_one": "{{count}} registro",
      "count_other": "{{count}} registros"
    },
    "item": {
      "legacy": "Enviado por el navegador · sin verificar",
      "legacyNote": "Esto es lo que el navegador envió con la decisión. Nunca se comprobó en el servidor.",
      "redact": "Eliminar",
      "redactAria": "Eliminar {{kind}} de este registro",
      "redacted": "Eliminado del registro",
      "redactedOn": "Eliminado del registro el {{date}}",
      "viewerRedacted": "Algunos detalles están ocultos para su rol."
    },
    "redact": {
      "title": "Eliminar {{kind}} de este registro",
      "description": "Su contenido se elimina de forma permanente. El registro conserva una nota de que se eliminó, cuándo y por qué. No se puede deshacer.",
      "reasonLabel": "Motivo",
      "reasonRequired": "Elija un motivo.",
      "confirm": "Eliminar definitivamente",
      "success": "Eliminado del registro",
      "notRedactable": "Este elemento no tiene nada más que eliminar.",
      "failed": "No se pudo eliminar el elemento."
    },
    "file": {
      "open": "Abrir",
      "opening": "Abriendo…",
      "openAria": "Abrir {{name}}",
      "auditNote": "Cada apertura queda registrada.",
      "openFailed": "No se pudo abrir el archivo.",
      "unavailable": "Este archivo ya no está disponible: se eliminó del registro o terminó el periodo de conservación del registro.",
      "notInStorage": "El archivo no estaba almacenado cuando se guardó el registro, por lo que no se conserva ninguna copia."
    },
    "compare": {
      "title": "En la decisión · Actual",
      "show": "Comparar con lo actual",
      "hide": "Ocultar comparación",
      "atDecision": "En la decisión",
      "current": "Actual",
      "comparedAt": "Comparado el {{date}}",
      "same": "Igual que en la decisión",
      "different": "No es igual que en la decisión",
      "notComparable": "No comparable",
      "currentDated": "valor actual con fecha {{date}}",
      "withheldNow": "Actualmente no compartido con esta empresa",
      "loadError": "No se pudo cargar la comparación."
    },
    "summary": {
      "nothingAtTheTime": "Nada que registrar en ese momento",
      "none": "Nada registrado",
      "notScored": "Sin puntuar",
      "percent": "{{value}} %",
      "fraction": "{{done}} de {{total}}",
      "score": "Puntuación",
      "calculatedAt": "Calculado",
      "completedAt": "Completado",
      "progress": "Progreso",
      "tasks": "Tareas",
      "documents": "Documentos listos",
      "missions": "Misiones",
      "wellbeing": "Bienestar",
      "checkpoints": "Puntos de control",
      "results": "Resultados",
      "resultsSent": "Resultados enviados",
      "miles": "Miles",
      "stamps": "Sellos",
      "badges": "Insignias",
      "fileName": "Archivo",
      "fileSize": "Tamaño",
      "uploadedAt": "Subido",
      "members": "Miembros",
      "checkins": "Registros de estado",
      "lastCheckin": "Último registro de estado",
      "nothingNow": "Nada que mostrar ahora",
      "files": "Archivos"
    },
    "verdict": {
      "title": "Historial de decisiones",
      "earlier": "Decisiones anteriores ({{count}})",
      "replacedValue": "Sustituyó una decisión anterior: {{verdict}}",
      "replacedNotRecorded": "Cualquier decisión anterior no quedó registrada",
      "viewRecord": "Ver registro",
      "loadError": "No se pudo cargar el historial de decisiones."
    },
    "notice": {
      "title": "Algunas empresas conservan un registro",
      "introFile": "El archivo ha salido de su bóveda. Estas empresas tomaron una decisión sobre usted que lo incluía y conservan su propio registro de esa decisión:",
      "introAccount": "Su cuenta se ha eliminado. Estas empresas tomaron una decisión sobre usted y conservan su propio registro de ella:",
      "listLabel": "Empresas que conservan un registro",
      "what": "Qué",
      "until": "Hasta",
      "why": "Por qué",
      "noEndDate": "Aún sin fecha de fin: se fija cuando su decisión llegue a un resultado",
      "acknowledge": "Entendido"
    }
  },
  "family": {
    "admin": "Admin",
    "children": "Niños",
    "complete": "completo",
    "emailPlaceholder": "member@example.com",
    "enableFamilyPlan": "Activar plan familiar",
    "familyPlan": "Plan familiar",
    "hasPartner": "Tiene pareja",
    "hasPets": "Tiene mascotas",
    "householdConfig": "Tu configuración del hogar",
    "householdContext": "Contexto del hogar",
    "invalidEmail": "Por favor, introduce una dirección de correo electrónico válida",
    "inviteFamilyMember": "Invitar a un miembro de la familia",
    "inviteMember": "Invitar miembro",
    "inviteSent": "Invitación enviada a {{email}}",
    "journeys": "Viajes",
    "manageMembers": "Gestionar miembros",
    "master": "Maestro",
    "member": "Miembro",
    "members": "Miembros",
    "membersAccess": "Miembros de la familia con acceso a viajes compartidos",
    "noMembers": "Aún no se han añadido miembros de la familia",
    "pendingName": "Pendiente",
    "removeMember": "Eliminar miembro",
    "removeMemberConfirm": "¿Eliminar a este miembro de la familia?",
    "role": "Rol",
    "sendInvitation": "Enviar una invitación para unirse a tu plan familiar",
    "sendInvite": "Enviar invitación",
    "shareJourney": "Comparte tu viaje con los miembros de la familia y sigue el progreso juntos.",
    "sharedJourneys": "Instancias de viaje compartido",
    "sharedJourneysSubtitle": "Viajes compartidos con miembros de la familia",
    "title": "Programa familiar",
    "invite": {
      "emailPlaceholder": "member@example.com"
    }
  },
  "familyProgram": {
    "accepted": "Aceptado",
    "accessRevoked": "Acceso revocado con éxito",
    "accessRules": "Reglas de acceso",
    "accessRulesDesc": "Quién puede acceder a qué funciones",
    "addFamilyMember": "Añadir miembro de la familia",
    "addMember": "Añadir miembro",
    "care": "Care",
    "careRule": "Solo el Maestro de Familia puede responder a los puntos de control de Care. El Compañero no tiene acceso.",
    "career": "Career y oportunidades",
    "careerRule": "El Maestro de Familia y el Compañero pueden acceder a sus propias Career y Oportunidades",
    "checkup": "CheckUp",
    "checkupRule": "El Maestro de Familia y el Compañero pueden completar su propia evaluación de CheckUp",
    "children": "Niños",
    "childrenCount": "Conteo de niños",
    "complete": "Completo",
    "copilotTip": "Consejo de CoPilot",
    "description": "Gestiona el acceso y los permisos del hogar",
    "disabled": "Desactivado",
    "docs": "Documentos",
    "docsComplete": "Documentos completos",
    "documents": "Documentos",
    "documentsIncompleteMessage": "Los documentos de {{name}} están incompletos. Sube los documentos requeridos para continuar con la solicitud de visa.",
    "editMember": "Editar miembro",
    "educationSupport": "Soporte educativo",
    "educationSupportDesc": "Asistencia para la colocación escolar, clases de idiomas y recursos educativos.",
    "emailAddress": "Dirección de correo electrónico",
    "enabled": "Habilitado",
    "familyAddonRequired": "Complemento familiar requerido",
    "familyAddonRequiredDesc": "El Programa Familiar requiere Pro Journey, Journey Pack o plan patrocinado. Actualiza para habilitar el Programa Familiar.",
    "familyAdmin": "Administrador familiar",
    "familyAdminDesc": "Puede gestionar miembros y configuraciones familiares",
    "familyMaster": "Maestro de la familia",
    "familyMember": "Miembro de la familia",
    "familyMemberDesc": "Miembro de la familia con acceso solo a Citizen",
    "familySponsored": "Patrocinado por la familia",
    "familySupportBenefits": "Beneficios de soporte familiar",
    "householdContext": "Contexto del hogar",
    "householdContextDesc": "Tu configuración del hogar",
    "householdCouple": "Pareja",
    "householdCouplePets": "Pareja + mascotas",
    "householdFamily": "Familia",
    "householdFamilyPets": "Familia + mascotas",
    "householdReadinessOverTime": "Progreso de preparación del hogar a lo largo del tiempo",
    "householdSingle": "Soltero",
    "householdSingleParent": "Padre soltero",
    "householdSinglePets": "Soltero + mascotas",
    "householdType": "Tipo de hogar",
    "incomplete": "Incompleto",
    "invalidEmail": "Por favor, introduce una dirección de correo electrónico válida",
    "inviteError": "Error al enviar la invitación",
    "inviteMember": "Invitar miembro",
    "inviteMemberDesc": "Invita a un miembro de la familia a unirse a tu viaje",
    "inviteNote": "Los miembros de la familia recibirán una invitación por correo electrónico para unirse a tu viaje. Tendrán acceso al contenido de QultureUp y podrán seguir su propio progreso.",
    "inviteSent": "Invitación enviada a {{email}}",
    "journeyInstance": "Instancia de viaje",
    "management": "Gestión",
    "members": "Miembros de la familia",
    "membersDescription": "Gestionar el acceso para los miembros de la familia",
    "milesAndLessonsPerMember": "Miles y lecciones completadas por miembro",
    "monitoring": "Care",
    "monitoringSection": {
      "achievements": "Logros",
      "acrossAllMembers": "a través de todos los miembros",
      "active": "activo",
      "badgesEarned": "insignias ganadas",
      "careNote": "Los puntos de control de Care son respondidos por el Maestro de Familia en nombre del hogar",
      "checkup": "CheckUp",
      "dayStreak": "racha de días",
      "events": "eventos",
      "householdStability": "Estabilidad del hogar",
      "householdStabilityDesc": "Puntuaciones actuales de pilares de Care (consciente del hogar, respondido por el Maestro de Familia)",
      "lessons": "lecciones",
      "lessonsCompleted": "lecciones completadas",
      "memberProgress": "Progreso del miembro",
      "memberProgressDesc": "Seguimiento del progreso individual para cada miembro de la familia",
      "memberReadiness": "Preparación del miembro",
      "noActivity": "Sin actividad aún",
      "noMembersToMonitor": "Sin miembros de la familia a seguir aún",
      "noReadinessData": "No hay datos de preparación disponibles para el Acompañante",
      "noRecentActivity": "Sin actividad reciente",
      "notAvailable": "No disponible",
      "progressTrends": "Tendencias de progreso",
      "progressTrendsDesc": "Visualiza el progreso familiar a lo largo del tiempo",
      "qultureupMiles": "QultureUp Miles",
      "qultureupProgress": "Progreso de QultureUp",
      "readinessEvolution": "Evolución de la preparación",
      "recentActivity": "Actividad reciente",
      "teleportalProgress": "TelePortal",
      "totalAchievements": "Logros totales",
      "totalMembers": "Total de miembros",
      "totalMiles": "Total de Miles",
      "totalQultureupMiles": "Total de Miles de QultureUp"
    },
    "noJourneyInstance": "Sin viaje activo",
    "noMembers": "Aún no se han invitado miembros de la familia",
    "noSharedJourneys": "Sin instancias de viaje compartidas",
    "passport": "Passport",
    "passportRule": "Cada miembro ve su propia vista filtrada. El acompañante accede a través de la aplicación móvil Tonnie Citizen.",
    "pending": "Pendiente",
    "petsPresence": "Mascotas",
    "pillar": {
      "housingStability": "Estabilidad de vivienda",
      "schoolingChildcare": "Educación y cuidado infantil",
      "wellbeing": "Bienestar",
      "workFit": "Ajuste laboral"
    },
    "purchaseFamilyAddon": "Comprar complemento familiar",
    "qultureup": "QultureUp",
    "qultureupPercent": "QultureUp %",
    "qultureupRule": "Todos los miembros de la familia acceden a través de la aplicación móvil Tonnie Citizen (el acompañante no puede acceder a través de Citizen Web)",
    "readinessPercent": "Preparación %",
    "removeError": "No se pudo eliminar al miembro",
    "removeMember": "Eliminar miembro",
    "revokeAccess": "Revocar acceso",
    "role": "Rol",
    "schoolReady": "Listo para la escuela",
    "sendInvite": "Enviar invitación",
    "servicesAvailable": "Servicios disponibles para tu familia",
    "sharedJourneyInstances": "Instancias de viaje compartido",
    "sharedJourneyInstancesDesc": "Instancias de viaje compartidas con miembros de la familia",
    "spouseEmployment": "Empleo del cónyuge",
    "spouseEmploymentDesc": "Apoyo en la búsqueda de empleo, oportunidades de networking y orientación sobre permisos de trabajo.",
    "status": "Estado del programa familiar",
    "statusDescription": "Estado actual de tu Programa Familiar",
    "teleportal": "TelePortal",
    "teleportalRule": "Solo el Maestro de Familia puede controlar las tareas de TelePortal. El Compañero no tiene acceso.",
    "title": "Programa familiar",
    "totalMiles": "Total de Miles",
    "tryAgainLater": "Por favor, inténtalo de nuevo más tarde",
    "unableToLoad": "No se pueden cargar los miembros de la familia",
    "viewDetails": "Ver detalles",
    "visa": "Visa",
    "visaApproved": "Aprobado",
    "visaDenied": "Denegado",
    "visaInProgress": "En progreso",
    "visaNotStarted": "No comenzado",
    "visaStatus": "Estado de la visa",
    "visasApproved": "Visas aprobadas",
    "wellbeingCare": "Bienestar Care",
    "wellbeingCareDesc": "Inscripción en atención médica, apoyo en salud mental e integración social.",
    "yearsOld": "{{age}} años",
    "you": "Tú",
    "sharedJourneyCount_one": "{{count}} trayecto compartido",
    "sharedJourneyCount_other": "{{count}} trayectos compartidos"
  },
  "feedback": {
    "additionalFeedbackHint": "Puedes proporcionar comentarios detallados, adjuntar capturas de pantalla o archivos para ayudarnos a entender mejor tu experiencia.",
    "attachFiles": "Adjuntar archivos",
    "attachFilesOptional": "Adjuntar archivos (opcional)",
    "category": {
      "bug": {
        "description": "Algo no está funcionando",
        "label": "Informe de error"
      },
      "other": {
        "description": "Algo más",
        "label": "Otro"
      },
      "praise": {
        "description": "Me encanta esta función",
        "label": "Elogio"
      },
      "question": {
        "description": "Necesito ayuda",
        "label": "Pregunta"
      },
      "suggestion": {
        "description": "Tengo una idea",
        "label": "Sugerencia"
      }
    },
    "categoryDescription": "Selecciona la categoría que mejor describa tus comentarios",
    "categoryQuestion": "¿Qué tipo de comentarios son estos?",
    "characterCount": "{{current}} / {{max}} caracteres",
    "characters": "{{current}}/{{max}} caracteres",
    "close": "Cerrar comentarios",
    "context": {
      "hero": "Héroe",
      "heroPlaceholder": "p. ej., CheckUp, TelePortal",
      "notDetected": "No se detectó contexto",
      "page": "Página",
      "pagePlaceholder": "p. ej., /dashboard, /checkup"
    },
    "contextInfo": "Información de contexto",
    "contextSaved": "Información de contexto guardada",
    "detailsDescription": "Por favor, proporciona detalles sobre tus comentarios",
    "detailsPlaceholder": "Describe tus comentarios, sugerencia o problema...",
    "detailsQuestion": "Cuéntanos más",
    "editContext": "Editar",
    "fileSizeError": "El tamaño del archivo excede el límite máximo de {{maxSize}}",
    "fileSizeLimit": "Los archivos deben ser de menos de 20MB",
    "fileUploadDescription": "Añade capturas de pantalla, PDFs u otros archivos (hasta 20MB cada uno) para ayudarnos a entender mejor tus comentarios.",
    "optional": "Opcional",
    "placeholder": "Comparte tus pensamientos...",
    "pleaseDescribe": "Por favor, describe tus comentarios en detalle",
    "privacyNote": "Tu retroalimentación es anónima y nos ayuda a mejorar Tonnie",
    "rating": {
      "1": "Muy insatisfecho",
      "2": "Insatisfecho",
      "3": "Neutral",
      "4": "Satisfecho",
      "5": "Muy satisfecho",
      "veryDissatisfied": "Muy insatisfecho",
      "dissatisfied": "Insatisfecho",
      "neutral": "Neutral",
      "satisfied": "Satisfecho",
      "verySatisfied": "Muy satisfecho"
    },
    "ratingDescription": "Evalúa tu satisfacción general",
    "ratingQuestion": "¿Cómo fue tu experiencia?",
    "selectRatingAndCategory": "Por favor, selecciona tanto la calificación como la categoría",
    "submit": "Enviar comentarios",
    "submitError": "Error al enviar comentarios. Por favor, inténtalo de nuevo.",
    "submitFeedback": "Enviar comentarios",
    "submitSuccess": "¡Gracias! Tus comentarios han sido enviados.",
    "submitted": "Tus comentarios han sido enviados.",
    "submitting": "Enviando...",
    "subtitle": "Ayúdanos a mejorar tu experiencia",
    "successMessage": "Agradecemos que te tomes el tiempo para ayudarnos a mejorar Tonnie. Tu opinión ha sido recibida y será revisada por nuestro equipo.",
    "successTitle": "¡Gracias por tus comentarios!",
    "tellUsMore": "Cuéntanos más",
    "thankYou": "¡Gracias!",
    "thankYouMessage": "Tu opinión nos ayuda a mejorar Tonnie.",
    "title": "Compartir comentarios",
    "toggle": "Enviar comentarios",
    "totalFileSize": "Total: {{size}} / {{maxSize}}",
    "totalSize": "Total: {{size}} / 20MB máx",
    "uploadFiles": "Subir archivos",
    "validationError": "Por favor, completa todos los campos obligatorios",
    "attachImages": "Adjuntar capturas de pantalla",
    "removeImage": "Eliminar {{name}}",
    "aria": {
      "description": "Descripción de comentarios",
      "uploadFiles": "Subir archivos",
      "removeFile": "Eliminar {{name}}",
      "satisfactionRating": "Calificación de satisfacción",
      "ratingOption": "{{label}} – {{value}} de 5"
    }
  },
  "form": {
    "addressSearch": {
      "city": "Ciudad: ",
      "country": "País: ",
      "postalCode": "Código postal: "
    },
    "datePicker": {
      "cancel": "Cancelar",
      "done": "Hecho",
      "months": [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "placeholder": "Seleccionar fecha",
      "selectDate": "Seleccionar fecha",
      "day": "Día",
      "month": "Mes",
      "year": "Año"
    },
    "phoneCountryCode": {
      "clearSearch": "Borrar búsqueda",
      "noCountriesFound": "No se encontraron países",
      "placeholder": "+XX",
      "searchPlaceholder": "Buscar país o código...",
      "selectCountryCode": "Seleccionar código de país"
    },
    "countrySelect": {
      "searchPlaceholder": "Buscar países"
    },
    "countryList": {
      "remove": "Quitar {{country}}"
    },
    "timePicker": {
      "hour": "Hora",
      "minute": "Minuto"
    }
  },
  "gating": {
    "upgrade": "Actualizar",
    "lockedLabel": "Bloqueado",
    "upgradeToUnlock": "Mejora tu plan para desbloquear",
    "unlockJourney": {
      "title": "Desbloquea tu Journey",
      "qultureup": "Para desbloquear esta misión de QultureUp, abre el Portal Web y desbloquea tu journey para acceso completo.",
      "teleportal": "Para desbloquear esta tarea de TelePortal, abre el Portal Web y desbloquea tu journey para acceso completo."
    },
    "upgradeBanner": {
      "passport": "Actualiza a Pro para desbloquear análisis de pasaporte, exportación y funciones de compartición.",
      "qultureup": "Actualiza a Pro para acceder a todos los mundos, lecciones y contenido de creadores en QultureUp.",
      "teleportal": "Actualiza a Pro para subir documentos, validar con revisión de IA y desbloquear todas las fases de TelePortal."
    }
  },
  "heroes": {
    "care": {
      "description": "Puntos de control y soporte post-llegada",
      "title": "Care"
    },
    "career": {
      "description": "Oportunidades y constructor de CV",
      "title": "Career"
    },
    "checkup": {
      "description": "Evaluación de preparación pre-inmigración",
      "readinessScore": "Puntuación de preparación",
      "title": "CheckUp"
    },
    "passport": {
      "badges": "Medallas",
      "description": "Tu línea de tiempo de viaje",
      "stamps": "Sellos",
      "timeline": "Cronograma",
      "title": "Passport"
    },
    "qultureup": {
      "description": "Adaptación Cultural",
      "level2Basics": "Nivel 2: Básicos",
      "title": "QultureUp"
    },
    "teleportal": {
      "actionRequired": "Acción requerida",
      "description": "Reubicación y Movilidad",
      "title": "TelePortal",
      "visaProcess": "Proceso de visa"
    },
    "vault": {
      "allDocuments": "Todos los documentos",
      "category": {
        "other": "Otro"
      },
      "chooseCategoryDesc": "Selecciona el héroe al que pertenece este documento.",
      "chooseCategoryTitle": "Elige una categoría",
      "detail": {
        "by": "Por",
        "certification": "Certificación",
        "details": "Detalles",
        "documentIdentity": "Identidad del documento",
        "expires": "Caduca",
        "issuingAuthority": "Autoridad emisora",
        "location": "Ubicación",
        "size": "Tamaño",
        "status": "Estado",
        "tags": "Etiquetas",
        "type": "Tipo",
        "uploaded": "Subido",
        "validation": "Validación",
        "validityPeriod": "Período de validez"
      },
      "documents": "documentos",
      "downloadAll": "Descargar todo",
      "downloadSelected": "Descargar {{count}}",
      "downloadToView": "Descargar para ver",
      "selectDocument": "Seleccionar documento",
      "emptyState": "Tus documentos de todos los héroes aparecerán aquí",
      "fetchError": "Error al cargar la bóveda",
      "filter": {
        "allStatus": "Todo estado",
        "certification": {
          "label": "Certificación",
          "none": "Sin certificación"
        },
        "clear": "Limpiar",
        "expired": "Caducado",
        "expiringSoon": "Caducando pronto",
        "expiry": "Caducidad",
        "sort": "Ordenar",
        "status": "Estado",
        "tags": "Etiquetas",
        "valid": "Válido"
      },
      "noDocuments": "Aún no hay documentos",
      "noResults": "No se encontraron documentos",
      "previewError": "No se pudo cargar la vista previa",
      "previewUnavailable": "Vista previa no disponible para este tipo de archivo",
      "removeConfirmDesc": "Esta acción no se puede deshacer. El documento será eliminado permanentemente.",
      "removeDocument": "¿Eliminar documento?",
      "searchPlaceholder": "Buscar documentos...",
      "sort": {
        "largestFirst": "Más grande primero",
        "nameAZ": "Nombre A-Z",
        "nameZA": "Nombre Z-A",
        "newestFirst": "Más nuevo primero",
        "oldestFirst": "Más antiguo primero",
        "smallestFirst": "Más pequeño primero"
      },
      "status": {
        "all": "Todos los estados",
        "pending": "Pendiente",
        "rejected": "Rechazado",
        "uploaded": "Subido",
        "validated": "Validado"
      },
      "subtitle": "Todos tus documentos de viaje en un lugar seguro",
      "tag": {
        "approved": "Aprobado",
        "archived": "Archivado",
        "expiringSoon": "Caducando pronto",
        "important": "Importante",
        "pendingReview": "Revisión pendiente",
        "urgent": "Urgente"
      },
      "title": "Bóveda",
      "track": {
        "legal": "Legal",
        "setup": "Configuración",
        "travel": "Viajar"
      },
      "verifiedByTonnie": "Verificado por Tonnie",
      "view": {
        "grid": "Vista de cuadrícula",
        "list": "Vista de lista",
        "timeline": "Vista del cronograma"
      },
      "viewDetails": "Ver detalles",
      "documentActions": "Acciones del documento",
      "searchLabel": "Buscar documentos",
      "topic": {
        "pitchVideo": "Video de presentación",
        "languageTest": "Prueba de idioma",
        "cv": "CV"
      },
      "links": {
        "title": "Usado en",
        "trip": "Viaje del {{from}} al {{to}}",
        "tripAway": "Viaje desde el {{from}}, aún fuera",
        "task": "Tarea de TelePortal: {{document}}",
        "taskUnnamed": "Una tarea de TelePortal",
        "removeWarning": "Al eliminarlo, también sale de donde se usa: cada viaje pierde esta prueba y cada tarea volverá a necesitar un documento:",
        "count_one": "Usado en 1 sitio",
        "count_other": "Usado en {{count}} sitios"
      }
    }
  },
  "invitations": {
    "error": {
      "acceptFailedTitle": "No pudimos aceptar esta invitación",
      "alreadyAcceptedDescription": "Esta invitación ya ha sido aceptada por otra cuenta.",
      "alreadyAcceptedTitle": "Ya aceptada",
      "backHome": "Volver a inicio",
      "declinedDescription": "Esta invitación fue rechazada. Pide a {{company}} que envíe una nueva si fue un error.",
      "declinedTitle": "Invitación rechazada",
      "emailMismatchDescription": "Esta invitación es para {{email}}. Cierra sesión y vuelve a iniciar sesión con esa dirección para aceptar.",
      "emailMismatchTitle": "Cuenta incorrecta",
      "emailUnverifiedDescription": "La dirección a la que se envió esta invitación está en tu cuenta, pero aún no se ha verificado.",
      "emailUnverifiedTitle": "Verifica primero esta dirección",
      "expiredDescription": "Pide a la empresa con la que has estado hablando que envíe una nueva invitación.",
      "expiredTitle": "Esta invitación ha expirado",
      "invalidLinkDescription": "Este enlace no tiene el token de invitación. Revisa el correo electrónico que recibiste y vuelve a intentarlo.",
      "invalidLinkTitle": "Enlace de invitación inválido",
      "notFoundDescription": "El enlace puede estar incompleto. Asegúrate de haber utilizado el correo electrónico más reciente.",
      "notFoundTitle": "No pudimos encontrar esa invitación",
      "revokedDescription": "La empresa ha retirado esta invitación. Comunícate con ellos si crees que esto es un error.",
      "revokedTitle": "Esta invitación fue revocada",
      "tryAgain": "Por favor, intenta de nuevo en un momento.",
      "wrongPortalDescription": "Esta invitación es para una cuenta de ciudadano de Tonnie. Inicia sesión con tu cuenta de ciudadano para abrirla.",
      "wrongPortalTitle": "Usa tu cuenta de ciudadano",
      "requestNotYoursTitle": "Esta solicitud es para otra cuenta",
      "requestNotYoursDescription": "Inicia sesión con la cuenta con la que trabaja esta empresa para responder.",
      "requestClosedTitle": "Esta solicitud ya no se puede responder",
      "requestClosedDescription": "Tu relación con esta empresa ya no está activa, así que no se puede compartir nada más con ella."
    },
    "preview": {
      "acceptCta": "Aceptar invitación",
      "accepting": "Aceptando…",
      "branch": "Sucursal",
      "declineCta": "Rechazar",
      "declining": "Rechazando…",
      "destination": "Destino",
      "emailHint": "Esta invitación es para {{email}}",
      "expires": "Esta invitación expira el {{date}}",
      "headline": "Has sido invitado",
      "invitingYou": "Invitación de",
      "loading": "Cargando tu invitación…",
      "location": "Ubicación",
      "opportunity": "Oportunidad",
      "signInCta": "Inicia sesión para aceptar",
      "signUpCta": "Regístrate para aceptar",
      "subheadline": "{{company}} te gustaría que realizaras un CheckUp para explorar una oportunidad internacional. Es gratuito y toma aproximadamente 20 minutos.",
      "subheadlineNamed": "Hola {{firstName}} — {{company}} te gustaría que realizaras un CheckUp para explorar una oportunidad internacional. Es gratuito y toma aproximadamente 20 minutos.",
      "subheadlineTestit": "{{company}} quiere que completes algunas pruebas específicas para explorar una oportunidad internacional. Es gratis y tus resultados son reutilizables.",
      "subheadlineTestitNamed": "Hola {{firstName}} — {{company}} quiere que completes algunas pruebas específicas para explorar una oportunidad internacional. Es gratis y tus resultados son reutilizables.",
      "testitTestsLabel": "Qué vas a completar"
    },
    "identity": {
      "addEmailBody": "{{company}} envió esta invitación a {{email}}. Añade esa dirección a tu cuenta y verifícala para aceptar sin empezar de nuevo.",
      "addEmailCta": "Añadir y verificar esta dirección",
      "addEmailError": "No pudimos añadir esa dirección. Inténtalo de nuevo en un momento.",
      "addEmailTitle": "Esta invitación es para otra dirección",
      "cancelCta": "Cancelar",
      "codeInvalid": "Ese código no es correcto. Revísalo e inténtalo de nuevo.",
      "codeLabel": "Código de 6 dígitos",
      "codeSentBody": "Enviamos un código de 6 dígitos a {{email}}. Introdúcelo abajo para terminar la verificación.",
      "codeSentHint": "Enviado a {{email}}. Caduca en unos minutos.",
      "codeSentTitle": "Revisa tu bandeja de entrada",
      "invitedAddress": "Invitación enviada a",
      "sendCodeCta": "Enviarme un código",
      "sending": "Enviando…",
      "signedInAs": "Has iniciado sesión como",
      "switchAccountCta": "Iniciar sesión con otra cuenta",
      "switchAccountHint": "Volverás a esta invitación después de iniciar sesión.",
      "tryAgainCta": "Inténtalo de nuevo",
      "unverifiedBody": "{{email}} ya está en tu cuenta, pero no se ha verificado. {{company}} envió esta invitación allí, así que verificarla prueba que es tuya.",
      "unverifiedTitle": "Verifica esta dirección para continuar",
      "verifyCta": "Verificar y continuar",
      "verifyError": "No pudimos verificar esa dirección. Inténtalo de nuevo en un momento.",
      "verifying": "Verificando…"
    },
    "card": {
      "eyebrow": "Invitación",
      "titleCheckup": "{{company}} te ha invitado a un CheckUp",
      "titleTestit": "{{company}} te ha pedido algunas pruebas",
      "detail": "Enviada a {{email}} · traslado a {{country}}",
      "detailNoCountry": "Enviada a {{email}}",
      "expires": "Caduca el {{date}}",
      "review": "Ver invitación",
      "notNow": "Ahora no",
      "decline": "Rechazar",
      "actionFailed": "No se ha podido completar. Revisa tu conexión e inténtalo de nuevo.",
      "declineTitle": "¿Rechazar la invitación de {{company}}?",
      "declineBody": "{{company}} verá que la has rechazado y esta invitación ya no podrá usarse.",
      "declineConfirm": "Rechazar invitación",
      "declineCancel": "Conservarla"
    },
    "review": {
      "title": "Unirte a {{company}}",
      "bodyCheckup": "{{company}} te pide que hagas un CheckUp para tu traslado a {{country}}.",
      "bodyCheckupNoCountry": "{{company}} te pide que hagas un CheckUp.",
      "accept": "Aceptar invitación",
      "accepting": "Aceptando…",
      "residenceBody": "Tu viaje con {{company}} empieza aquí y se abre en cuanto aceptes.",
      "deferredUntil": "Has aplazado esta invitación por ahora. Te espera aquí hasta que decidas y vuelve a Inicio el {{date}}."
    },
    "claim": {
      "title": "Esa dirección tiene su propia cuenta de Tonnie",
      "subtitle": "{{email}} pertenece a otra cuenta de Tonnie.",
      "body": "Si esa cuenta también es tuya, puedes aceptar aquí la invitación de {{company}}. Enviaremos un código a esa dirección para confirmar que es tuya.",
      "sendCta": "Enviarme un código",
      "sending": "Enviando…",
      "switchInstead": "Iniciar sesión con esa cuenta",
      "codeSentBody": "Hemos enviado un código de 6 dígitos a {{email}}. Caduca en {{minutes}} minutos.",
      "resendCta": "Enviar un código nuevo",
      "resendIn": "Enviar un código nuevo en {{seconds}} s",
      "codeWrong_one": "Ese código no es correcto. Te queda {{count}} intento.",
      "codeWrong_other": "Ese código no es correcto. Te quedan {{count}} intentos.",
      "codeExpired": "Ese código ha caducado o ya se ha agotado. Envía uno nuevo.",
      "tooManyCodes": "Ya hemos enviado varios códigos. Inténtalo más tarde.",
      "noOtherAccount": "Ninguna otra cuenta de Tonnie usa ya esta dirección. Añádela a esta cuenta.",
      "failed": "Algo ha salido mal. Inténtalo de nuevo.",
      "retireNote": "{{email}} está confirmada como tuya. Tu otra cuenta de Tonnie con esta dirección no tiene nada, así que se cerrará cuando aceptes. Tendrás una sola cuenta.",
      "keptNote": "{{email}} está confirmada como tuya. Tu otra cuenta de Tonnie con esta dirección conserva su trayecto, y puedes seguir iniciando sesión en ella."
    },
    "choice": {
      "checking": "Comprobando tus viajes…",
      "loadFailed": "No pudimos cargar tus viajes. Inténtalo de nuevo antes de aceptar.",
      "legend": "¿Qué viaje compartes con {{company}}?",
      "route": "{{origin}} → {{destination}}",
      "companyJourney": "{{company}} ya te acompaña en este viaje",
      "sharedWith": "También compartido con {{companies}}",
      "checkupShared": "{{company}} verá tu CheckUp del {{date}}",
      "newTitle": "Un viaje nuevo para {{company}}",
      "newBody": "Empieza de cero: {{company}} solo verá lo que hagas en él a partir de ahora.",
      "newCapped_one": "Ya tienes {{count}} viaje en esta ruta, el máximo posible. Archívalo para empezar otro.",
      "newCapped_other": "Ya tienes {{count}} viajes en esta ruta, el máximo posible. Archiva uno para empezar otro.",
      "newOnly": "Empezaremos un viaje nuevo a {{country}} para {{company}}.",
      "newOnlyNoCountry": "Empezaremos un viaje nuevo para {{company}}.",
      "blocked_one": "Tu viaje en esta ruta pertenece a otra empresa, y ya tienes {{count}}, el máximo por ruta. Archiva uno para aceptar la invitación de {{company}}.",
      "blocked_other": "Tus viajes en esta ruta pertenecen a otras empresas, y ya tienes {{count}}, el máximo por ruta. Archiva uno para aceptar la invitación de {{company}}."
    },
    "list": {
      "title": "{{company}} te ha invitado",
      "deferredUntil": "Aplazada hasta el {{date}}",
      "expires": "Válida hasta el {{date}}",
      "openHint": "Abre la invitación para aceptarla o rechazarla"
    },
    "request": {
      "eyebrow": "Solicitud",
      "titleCheckup": "{{company}} pide ver la puntuación de tu CheckUp",
      "titleTests": "{{company}} pide ver tus resultados de {{tests}}",
      "cardBody": "No se comparte nada hasta que lo decidas. Revisa lo que verían y decide.",
      "bodyCheckupScored": "Tu puntuación está lista. No se comparte nada hasta que lo decidas.",
      "bodyCheckupPending": "Si lo compartes, verán tu puntuación cuando tu CheckUp esté calculado. No se comparte nada hasta que lo decidas.",
      "bodyTests": "Los resultados que ya tienes se reutilizan. No se comparte nada hasta que lo decidas.",
      "willSeeTitle": "Si lo compartes, {{company}} ve",
      "wontSeeTitle": "{{company}} sigue sin ver",
      "new": "Nuevo",
      "share": "Compartir",
      "sharing": "Compartiendo…",
      "declineTitle": "¿Rechazar la solicitud de {{company}}?",
      "declineBody": "Se avisará a {{company}}. Nada más cambia: sigue viendo solo lo que compartiste antes.",
      "declineConfirm": "Rechazar solicitud",
      "sharedToast": "Compartido con {{company}}",
      "sharedToastBody": "Ya pueden verlo. Puedes cambiar lo que ven cuando quieras en Mis viajes.",
      "declinedToast": "Rechazaste la solicitud de {{company}}",
      "listTitle": "{{company}} pide ver más",
      "kindCheckup": "La puntuación de tu CheckUp",
      "kindTests": "Tus resultados de pruebas",
      "signInBody": "Inicia sesión en la cuenta con la que trabaja {{company}} para ver exactamente lo que pide y decidir.",
      "signIn": "Iniciar sesión",
      "notWaitingTitle": "Esta solicitud no está esperando tu respuesta",
      "notWaitingBody": "Ya se respondió o se retiró, o es para otra cuenta."
    },
    "testit": {
      "title": "{{company}} pide los resultados de tus pruebas",
      "body": "{{company}} te pide las pruebas de abajo. Haces las que aún no has hecho después de aceptar.",
      "bodyAllDone": "Ya has hecho todas las pruebas que pide {{company}}. No hay nada nuevo que hacer.",
      "listLabel": "Lo que pide {{company}}",
      "testDone": "Ya hecha — se compartirá tu resultado del {{date}}",
      "testPending": "Para hacer después de aceptar",
      "scopeTestsOnly": "Al aceptar, compartes los resultados de estas pruebas con {{company}}. No se comparte tu CheckUp.",
      "scopeUnchanged": "Al aceptar, añades los resultados de estas pruebas. {{company}} sigue viendo lo que ya compartes con ella.",
      "accept": "Aceptar y hacer las pruebas",
      "acceptShare": "Compartir mis resultados",
      "confirmTitle": "Tus resultados se han compartido con {{company}}",
      "confirmBody": "{{company}} ya puede ver tus resultados en estas pruebas. No te queda nada por hacer.",
      "confirmDone": "Listo"
    }
  },
  "journey": {
    "arrives": "Llega el {{date}}",
    "buildFirstJourney": "Construye tu primer viaje internacional para comenzar",
    "buildYourFirstJourney": "Construye tu primer viaje",
    "builder": {
      "title": "Constructor de viajes",
      "createErrorFallback": "Error al crear viaje",
      "notAuthenticated": "Debes estar conectado para continuar",
      "missingCountries": "No hemos podido determinar dónde empieza y termina tu recorrido. Elige tu país actual y tu destino e inténtalo de nuevo.",
      "alsoToDestination": "También tienes un viaje a {{destination}} desde {{origins}}.",
      "advice": {
        "title": "Ya tienes esta ruta",
        "body": "Ya tienes un viaje de {{origin}} a {{destination}}. Ábrelo, o crea otro.",
        "capTitle": "Esta ruta está completa",
        "capBody_one": "Ya tienes {{count}} viaje de {{origin}} a {{destination}}, el máximo por ruta. Ábrelo.",
        "capBody_other": "Ya tienes {{count}} viajes de {{origin}} a {{destination}}, el máximo por ruta. Abre uno de ellos.",
        "listLabel": "Tus viajes en esta ruta",
        "open": "Abrir",
        "buildAnother": "Crear otro",
        "notNow": "Ahora no"
      }
    },
    "daysOnJourney": "Días en el viaje",
    "details": {
      "amount": "Cantidad",
      "featuresIncluded": "Características incluidas",
      "paymentInfo": "Información de pago",
      "scenario": "Escenario",
      "scenario_already_abroad": "Ya en el extranjero",
      "scenario_integration_only": "Solo integración",
      "scenario_pre_immigration": "Pre-Inmigración",
      "scenario_relocation_only": "Solo reubicación",
      "status": "Estado",
      "title": "Detalles del viaje",
      "type": "Tipo"
    },
    "expires": "Caduca",
    "family": "Familia",
    "govSponsored": "Patrocinado por el gobierno",
    "guard": {
      "buildDescription": "Antes de que puedas acceder a esta función, necesitas crear tu viaje profesional internacional. Esto toma solo unos minutos.",
      "buildFirst": "Construye tu primer viaje",
      "buildNew": "Construir nuevo viaje",
      "buildTitle": "Construye tu viaje primero",
      "builderHint": "El constructor de viajes te ayudará a configurar tu origen, destino y objetivos profesionales.",
      "expiredDescription": "Este viaje ha alcanzado el final de su plan. Renueva o mejora para continuar utilizando tus héroes.",
      "expiredTitle": "Tu viaje ha expirado",
      "goToDashboard": "Ir al tablero",
      "loadErrorDescription": "Algo salió mal al cargar tus viajes. Tus datos están seguros — por favor intenta de nuevo.",
      "loadErrorTitle": "No pudimos cargar tus viajes",
      "noActiveDescription": "Todos tus viajes pueden estar en pausa, expirados o completados. Selecciona uno del encabezado o construye uno nuevo.",
      "noActiveTitle": "Sin viaje activo",
      "pausedDescription": "El acceso está temporalmente en pausa — generalmente porque el pago de un patrocinador no se procesó, o el viaje fue pausado por un administrador. Comunícate con tu patrocinador o verifica la facturación para reanudar.",
      "pausedTitle": "Tu viaje está en pausa",
      "pendingSetupDescription": "Hemos reservado este viaje para ti. Dinos desde dónde te mudas y se abrirá al momento.",
      "pendingSetupTitle": "Termina de configurar tu viaje",
      "renewJourney": "Renovar",
      "selectDescription": "Necesitas seleccionar una instancia de viaje activa para acceder a esta función. Usa el selector de viaje en el encabezado de arriba para elegir uno.",
      "selectTitle": "Selecciona un viaje",
      "selectorHint": "Consejo: Usa el selector de viaje en la barra de navegación superior para cambiar entre tus viajes.",
      "unavailableDescription": "Este viaje ya no es accesible. Elige otro o construye un nuevo viaje para continuar.",
      "unavailableTitle": "Viaje no disponible",
      "viewBilling": "Ver facturación",
      "errorTitle": "No se pudieron cargar tus viajes",
      "errorDescription": "No pudimos alcanzar el servidor. Verifica tu conexión e intenta de nuevo.",
      "openSelector": "Abrir selector de viaje",
      "openJourney": "Abrir mi viaje"
    },
    "loadingJourneys": "Cargando viajes…",
    "milesToGo": "Miles por recorrer",
    "nextMilestone": "Próximo hito",
    "pro": "Pro",
    "progress": "Progreso",
    "selectJourney": "Seleccionar viaje",
    "selector": {
      "andMore_one": "y 1 más",
      "andMore_other": "y {{count}} más",
      "basicAccess": "Acceso básico",
      "buildFirst": "Construye tu primer viaje",
      "buildNew": "Construir nuevo viaje",
      "buildOne": "Construir un viaje",
      "buildOneShort": "Construir viaje",
      "companiesHint": "Muestra todas las empresas de este viaje",
      "companiesTitle": "Empresas en este viaje",
      "company": "Empresa",
      "expired": "Caducado",
      "expiresOn": "Caduca",
      "family": "Familia",
      "from": "de {{country}}",
      "fromUnknown": "De desconocido",
      "fullAccess": "Acceso completo",
      "government": "Gobierno",
      "invitedBy": "Invitado por {{company}}",
      "invitedOnly": "Solo invitado",
      "loadingJourneys": "Cargando viajes…",
      "locked": "Bloqueado",
      "noJourneys": "No hay viajes aún",
      "noJourneysDescription": "No tienes ningún viaje aún. Comienza uno para iniciar tu reubicación.",
      "noJourneysTitle": "No hay viajes aún",
      "paused": "Pausado",
      "setupPending": "Configuración pendiente",
      "sponsored": "Patrocinado",
      "unlocked": "Desbloqueado",
      "sharedWith": "Compartido con {{company}}"
    },
    "sponsored": "Patrocinado",
    "status": {
      "active": "Activo",
      "completed": "Completado",
      "draft": "Borrador",
      "expired": "Caducado",
      "limited": "Limitado",
      "paused": "Pausado"
    },
    "statusActive": "Activo",
    "statusExpired": "Caducado",
    "statusLimited": "Limitado",
    "switchBetweenJourneys": "Cambia entre tus viajes activos",
    "yourJourneyTo": "Tu viaje a {{country}}",
    "originPending": "Origen pendiente",
    "invited": "Invitado",
    "yourJourneyToUnknown": "Tu recorrido",
    "relationship": {
      "live": "Activo",
      "archivedByCompany": "Archivado por la empresa",
      "ended": "Finalizado",
      "left": "Saliste"
    },
    "manage": {
      "accessUntil": "Acceso hasta el {{date}}",
      "activeDescription": "Cada viaje guarda su propio progreso en CheckUp, TelePortal y Care. Tu viaje actual es el que muestra tu panel.",
      "activeSection": "Viajes activos",
      "archive": "Archivar",
      "archiveCanRestore": "Puedes recuperarlo desde esta página cuando quieras.",
      "archiveConfirm": "Archivar viaje",
      "archiveDialogDescription": "Sale de tu lista de viajes. No se pierde nada de lo que contiene.",
      "archiveDialogTitle": "¿Archivar tu viaje a {{destination}}?",
      "archiveFailed": "No hemos podido archivar este viaje. Inténtalo de nuevo.",
      "archiveKeepsProgress": "No se elimina nada: su progreso en CheckUp, TelePortal y Care se conserva con él.",
      "archiveSwitchesCurrent": "Es tu viaje actual, así que Tonnie te cambia a otro si tienes alguno.",
      "archivedDescription": "Los viajes archivados lo conservan todo. Recupera uno para seguir donde lo dejaste.",
      "archivedOn": "Archivado el {{date}}",
      "archivedSection": "Archivados",
      "archivedToastBody": "Tu viaje a {{destination}} está archivado. No se ha eliminado nada.",
      "archivedToastTitle": "Viaje archivado",
      "blockedLiveProgramBody": "Sal primero del programa — eso termina tu relación con la empresa — y después podrás archivar este viaje.",
      "blockedLiveProgramTitle": "Una empresa sigue manteniendo este programa",
      "blockedSponsorshipBody": "El patrocinio debe terminar antes de que este viaje pueda archivarse.",
      "blockedSponsorshipTitle": "Este viaje está patrocinado",
      "continueJourney": "Continuar viaje",
      "current": "Actual",
      "emptyWithArchived": "No tienes ningún viaje activo. Empieza uno nuevo o recupera uno que archivaste.",
      "leaveConfirm": "Salir del programa",
      "leaveDialogTitle": "¿Salir del programa de {{company}}?",
      "leaveFailed": "No hemos podido sacarte del programa. Inténtalo de nuevo.",
      "leaveFinerHint": "¿Solo quieres ocultar algunas cosas? Elige exactamente qué pueden ver.",
      "leaveKeepsJourney": "Tu viaje, su progreso y tus documentos siguen siendo tuyos.",
      "leaveProgramme": "Salir del programa",
      "leaveCompanyProgramme": "Salir del programa, {{company}}",
      "leaveWithdrawsAccess": "Retiras el acceso de {{company}} a los datos que compartiste en este viaje.",
      "leftToastCanArchive": "Ya no ven tus datos y la relación ha terminado. Ya puedes archivar este viaje.",
      "leftToastTitle": "Has salido del programa de {{company}}",
      "manageConsents": "Qué ven",
      "manageJourneys": "Gestionar viajes",
      "newJourney": "Nuevo viaje",
      "openExisting": "Abrirlo",
      "recoverArchived": "Recuperar un viaje archivado ({{count}})",
      "restore": "Recuperar",
      "restoreFailed": "No hemos podido recuperar este viaje. Inténtalo de nuevo.",
      "restoredToastTitle": "Viaje recuperado",
      "startedOn": "Iniciado el {{date}}",
      "subtitle": "Cambia entre tus viajes, archiva los que no estés usando y decide qué pueden ver las empresas.",
      "switchToJourney": "Cambiar a este viaje",
      "title": "Mis viajes",
      "undo": "Deshacer",
      "actionsLabel": "Gestionar viaje",
      "actionsHint": "Mantén pulsado, o usa el menú de acciones, para archivar o salir",
      "restoreCapTitle": "Esta ruta está completa",
      "restoreCapBody_one": "Ya tienes {{count}} viaje activo a {{destination}} desde este origen. Ábrelo, o archívalo antes de restaurar este.",
      "restoreCapBody_other": "Ya tienes {{count}} viajes activos a {{destination}} desde este origen. Abre uno, o archiva uno antes de restaurar este.",
      "labelField": "Nombre del viaje",
      "labelPlaceholder": "p. ej., Trabajo — Lisboa",
      "nameIt": "Ponerle nombre",
      "rename": "Cambiar nombre",
      "renamedToast": "Nombre del viaje cambiado",
      "nameClearedToast": "Nombre del viaje eliminado",
      "renameFailed": "No pudimos guardar el nombre. Inténtalo de nuevo.",
      "leaveDialogDescriptionInvited": "{{company}} te invitó a tu viaje a {{destination}}.",
      "leaveDialogDescriptionShared": "Compartiste tu viaje a {{destination}} con {{company}}.",
      "leaveEndsRelationship": "Tu relación con {{company}} en este viaje termina. Pueden volver a invitarte, y tú decides si aceptas.",
      "leftToastOtherProgramme": "Ya no ven tus datos y la relación ha terminado. El programa de otra empresa sigue en este viaje, así que se mantiene.",
      "leftToastSponsorshipHolds": "Ya no ven tus datos y la relación ha terminado. Un patrocinio sigue activo en este viaje, así que se mantiene hasta que el patrocinio termine.",
      "archiveAfterSponsorship": "Este viaje está patrocinado hasta el {{date}}. Podrás archivarlo cuando termine el patrocinio.",
      "archiveAfterSponsorshipNoDate": "Hay un patrocinio activo en este viaje. Podrás archivarlo cuando termine el patrocinio."
    },
    "consent": {
      "action": {
        "granted": "Compartido",
        "narrowed": "Se comparte menos",
        "revoked": "Dejó de compartirse",
        "widened": "Se comparte más"
      },
      "allRevoked": "Ya no ven tus resultados en este viaje.",
      "archivedByCompany": "Archivado por la empresa",
      "changeFailed": "El cambio no se aplicó. No se ha modificado nada.",
      "changedToastBody": "{{company}} · {{scope}}",
      "empty": "Ninguna empresa tiene acceso a tus datos en este viaje.",
      "grantedOn": "Compartido desde el {{date}}",
      "grantedToast": "Vuelves a compartirlo",
      "grantedUnknown": "Compartido antes de que empezáramos a registrar fechas de consentimiento",
      "groupJourney": "En este viaje",
      "groupProfile": "De tu perfil",
      "revokedToast": "Has dejado de compartirlo",
      "scope": {
        "care": "Mi historial de Care",
        "care_checkins": "Mis check-ins diarios",
        "checkup": "Mis resultados de CheckUp",
        "cv": "Mi CV",
        "household": "Los datos de mi familia",
        "irr": "Mi historial de actividad",
        "passport_stamps": "Mis sellos y millas de Passport",
        "pitch_video": "Mi grabación de presentación",
        "qultureup": "Mi progreso en QultureUp",
        "teleportal": "Mi plan de traslado",
        "testit": "Mis resultados de TestIt"
      },
      "sharingCount": "{{shared}} de {{total}} compartidos",
      "subtitle": "Cada empresa de esta lista tiene acceso a una parte de tu viaje. Desactiva lo que quieras y dejarán de verlo; vuelve a activarlo cuando quieras. No se borra nada de lo que has hecho.",
      "title": "Quién ve mis datos",
      "trailTitle": "Qué ha cambiado",
      "leftOn": "Saliste el {{date}}",
      "endedOn": "Finalizado el {{date}}",
      "stoppedOn": "Dejaste de compartir el {{date}}",
      "leftReadOnly": "Esta relación ha terminado. No se vuelve a compartir nada con {{company}} salvo que aceptes una nueva invitación suya."
    }
  },
  "journeyBuilder": {
    "aboutDescription": "Crea la configuración de tu viaje internacional personalizado",
    "creatingMessage": "Configurando tu viaje — esto solo toma un momento.",
    "creatingTitle": "Creando tu viaje…",
    "creationErrorTitle": "No se pudo crear tu viaje",
    "description": "Vamos a configurar tu viaje internacional",
    "estimatedTime": "Tiempo estimado",
    "infoCountries": "Elige tus países de origen y destino",
    "infoDescription": "Cuéntanos algunas cosas sobre tu mudanza para que podamos personalizar tu viaje.",
    "infoDestination": "Destino",
    "infoDestinationDesc": "A dónde te mudas.",
    "infoFeatures": "Selecciona qué características incluir en tu viaje",
    "infoHousehold": "Configura la composición de tu hogar y la estructura familiar",
    "infoIntro": "Construir un viaje lleva unos minutos. Una vez hecho, verás tu hoja de ruta personalizada.",
    "infoJourney": "Viaje",
    "infoJourneyDesc": "El plan completo desde el origen hasta el destino.",
    "infoOrigin": "Origen",
    "infoOriginDesc": "De dónde te mudas.",
    "infoProfile": "Perfil",
    "infoProfileDesc": "Tus datos personales — utilizados para adaptar las recomendaciones.",
    "infoScenario": "Selecciona el propósito de tu viaje y lo que estás buscando",
    "progress": "Progreso",
    "progressTitle": "Progreso",
    "purposeCare": "Apoyo y cuidado para llegar allí",
    "purposeCheckup": "Verifica tus Habilidades Internacionales",
    "purposeCulture": "Conoce la Cultura y conviértete en un Citizen",
    "purposeJob": "Tener una oportunidad laboral y apoyo",
    "purposeRelocation": "Apoyo en el proceso de reubicación",
    "redirectingMessage": "Redirigiéndote a tu panel de control...",
    "scenario": "¿Cuál es tu situación?",
    "scenarioAlreadyAbroad": "Ya estoy viviendo en el extranjero",
    "scenarioAlreadyAbroadDesc": "Ya te has mudado y quieres mejorar tu integración",
    "scenarioIntegration": "Solo apoyo en integración",
    "scenarioIntegrationDesc": "Quieres centrarte en la cultura, el idioma y el desarrollo profesional",
    "scenarioPreImmigration": "Estoy planeando mudarme al extranjero",
    "scenarioPreImmigrationDesc": "Todavía estás en tu país de origen y planeando tu mudanza internacional",
    "scenarioRelocation": "Solo apoyo en reubicación",
    "scenarioRelocationDesc": "Necesitas ayuda con el lado logístico de la mudanza: visa, vivienda, legal",
    "successTitle": "¡Viaje configurado! 🎉",
    "successToast": "¡Viaje configurado con éxito!",
    "title": "Constructor de viajes",
    "mobile": {
      "stepOf": "Crea tu viaje · {{current}} de {{total}}",
      "create": "Crear mi viaje",
      "sameCountry": "Elige el país que dejas: no puede ser tu destino.",
      "createFailed": "No pudimos crear tu viaje. Revisa tu conexión e inténtalo de nuevo.",
      "gateBody": "Tres preguntas y tu viaje estará listo, aquí mismo en tu móvil.",
      "adviceFailed": "No pudimos comprobar tus viajes en esta ruta. Inténtalo de nuevo."
    }
  },
  "language": {
    "languages": {
      "de": "Deutsch",
      "en": "Inglés",
      "es": "Español",
      "fr": "Français",
      "it": "Italiano",
      "pt": "Português"
    }
  },
  "legal": {
    "privacy": {
      "changes": {
        "content": "Podemos actualizar esta Política de Privacidad de vez en cuando. Te notificaremos de cualquier cambio publicando la nueva política en esta página.",
        "title": "10. Cambios en esta política"
      },
      "children": {
        "content": "Nuestro servicio no está destinado a niños menores de 16 años. No recopilamos intencionadamente datos personales de niños menores de 16 años.",
        "title": "9. Privacidad de los niños"
      },
      "collect": {
        "account": "Información de la cuenta (nombre, correo electrónico, número de teléfono)",
        "assessment": "Respuestas a evaluaciones y datos de progreso",
        "documents": "Documentos subidos a nuestro servicio Vault",
        "intro": "Recopilamos información que nos proporcionas directamente, incluyendo:",
        "location": "Datos de ubicación (país actual, país de destino)",
        "profile": "Información del perfil (profesión, educación, habilidades)",
        "title": "1. Información que recopilamos"
      },
      "contact": {
        "content": "Para preguntas sobre esta política de privacidad o para ejercer tus derechos de datos, contacta a nuestro Oficial de Protección de Datos en",
        "title": "11. Contáctanos"
      },
      "cookies": {
        "content": "Utilizamos cookies y tecnologías similares para mejorar tu experiencia, analizar patrones de uso y ofrecer contenido personalizado. Puedes gestionar las preferencias de cookies a través de la configuración de tu navegador.",
        "title": "7. Cookies y seguimiento"
      },
      "international": {
        "content": "Tu información puede ser transferida y procesada en países distintos a tu país de residencia. Aseguramos que se implementen salvaguardias adecuadas para proteger tus datos de acuerdo con esta política de privacidad.",
        "title": "8. Transferencias internacionales de datos"
      },
      "lastUpdated": "Última actualización: {{date}}",
      "retention": {
        "content": "Retenemos tus datos personales mientras tu cuenta esté activa o según sea necesario para proporcionarte servicios. Puedes solicitar la eliminación de tus datos en cualquier momento contactándonos.",
        "title": "5. Retención de datos"
      },
      "rights": {
        "access": "Acceder a tus datos personales",
        "correct": "Corregir datos inexactos",
        "delete": "Solicitar la eliminación de tus datos",
        "intro": "Bajo las leyes de protección de datos aplicables, tienes el derecho de:",
        "object": "Oponerte al procesamiento de tus datos",
        "portability": "Solicitar la portabilidad de datos",
        "title": "6. Tus derechos"
      },
      "security": {
        "content": "Implementamos medidas técnicas y organizativas adecuadas para proteger tus datos personales contra el acceso no autorizado, alteración, divulgación o destrucción. Todos los datos están cifrados en tránsito y en reposo.",
        "title": "4. Seguridad de los datos"
      },
      "sharing": {
        "employers": "Con empleadores que patrocinan tu viaje (con tu consentimiento explícito)",
        "intro": "Podemos compartir tu información:",
        "legal": "Cuando sea requerido por la ley o para proteger nuestros derechos",
        "providers": "Con proveedores de servicios que ayudan en la operación de nuestra plataforma",
        "title": "3. Compartición de información"
      },
      "title": "Política de privacidad",
      "use": {
        "communicate": "Comunicarte sobre el progreso de tu viaje",
        "intro": "Utilizamos la información que recopilamos para:",
        "personalize": "Personalizar tu experiencia y recomendaciones de viaje",
        "process": "Procesa tus evaluaciones de iQulture y genera información",
        "protect": "Proteger contra fraudes y accesos no autorizados",
        "provide": "Proporcionar, mantener y mejorar nuestro servicio",
        "title": "2. Cómo utilizamos tu información"
      }
    },
    "terms": {
      "acceptance": {
        "content": "Al acceder y utilizar la Plataforma Tonnie (\"Servicio\"), aceptas estar sujeto a estos Términos de Servicio (\"Términos\"). Si no estás de acuerdo con estos Términos, por favor no uses el Servicio.",
        "title": "1. Aceptación de los términos"
      },
      "accounts": {
        "content": "Para utilizar ciertas funciones del servicio, debes crear una cuenta. Eres responsable de mantener la confidencialidad de las credenciales de tu cuenta y de todas las actividades que ocurran bajo tu cuenta.",
        "title": "3. Cuentas de usuario"
      },
      "changes": {
        "content": "Nos reservamos el derecho de modificar estos términos en cualquier momento. Te notificaremos de cualquier cambio publicando los nuevos términos en esta página y actualizando la fecha de \"Última actualización\".",
        "title": "8. Cambios en los términos"
      },
      "contact": {
        "content": "Si tienes preguntas sobre estos términos, por favor contáctanos en",
        "title": "9. Contacto"
      },
      "ip": {
        "content": "El Servicio y su contenido original, características y funcionalidad son propiedad de Tonnie y están protegidos por derechos de autor, marcas registradas y otras leyes de propiedad intelectual internacionales.",
        "title": "5. Propiedad intelectual"
      },
      "lastUpdated": "Última actualización: {{date}}",
      "liability": {
        "content": "En ningún caso Tonnie será responsable de ningún daño indirecto, incidental, especial, consecuente o punitivo que surja de o esté relacionado con tu uso del Servicio.",
        "title": "7. Limitación de responsabilidad"
      },
      "responsibilities": {
        "accurate": "Proporcionar información precisa y completa",
        "compliance": "Utilizar el servicio en cumplimiento con las leyes aplicables",
        "intro": "Aceptas:",
        "noMisuse": "No malutilizar ni intentar eludir las características de seguridad del servicio",
        "title": "4. Responsabilidades del usuario",
        "upToDate": "Mantener la información de tu cuenta actualizada"
      },
      "serviceDesc": {
        "care": "Care — Soporte de bienestar",
        "checkup": "CheckUp — Evaluaciones de preparación",
        "content": "Tonnie proporciona una plataforma global de movilidad de talento que asiste a individuos (\"Talentos\") con reubicación internacional y ayuda a las empresas (\"Empleadores\") a gestionar programas de talento global. El Servicio incluye:",
        "passport": "Passport — Seguimiento y verificación de progreso",
        "qultureup": "QultureUp — Módulos de aprendizaje cultural",
        "teleportal": "TelePortal — Gestión de tareas de reubicación",
        "title": "2. Descripción del servicio"
      },
      "termination": {
        "content": "Podemos terminar o suspender tu cuenta y acceso al servicio de inmediato, sin previo aviso, por conductas que creamos que violan estos términos o son perjudiciales para otros usuarios, nosotros o terceros.",
        "title": "6. Terminación"
      },
      "title": "Términos de servicio"
    }
  },
  "mission": {
    "almostThere": "¡Casi allí!",
    "answerPlaceholder": "Escribe tu respuesta aquí...",
    "complete": "Completar misión",
    "completeToEarn": "Completar para ganar",
    "completedBadge": "¡Completado!",
    "completedSuccess": "¡Misión completa!",
    "correct": "Correcto",
    "correctOf": "{{correct}} de {{total}} correctos",
    "exitForNow": "Salir por ahora",
    "milesEarnedLabel": "Miles ganadas",
    "milesHint": "Miles rastrean tu progreso de aprendizaje cultural en QultureUp",
    "needToPass": "Necesitas un 75% para aprobar. Revisa el contenido y vuelve a intentarlo.",
    "next": "Siguiente",
    "notFound": "Misión no encontrada",
    "notPassed": "No aprobado",
    "passed": "Aprobado",
    "perfectScoreBonus": "Bono por puntuación perfecta",
    "previous": "Anterior",
    "progressWarning": "Perderás tu progreso. ¿Estás seguro?",
    "progressWarningTitle": "¿Dejar misión?",
    "questionBreakdown": "Desglose de preguntas",
    "quizResults": "Resultados del cuestionario",
    "review": "Revisión",
    "reviewAndTryAgain": "Revisar y intentar de nuevo",
    "startMission": "Comenzar misión",
    "watchVideo": "Ver vídeo",
    "scrollToContinue": "Desplázate hasta el final para continuar",
    "startQuiz": "Iniciar cuestionario",
    "submit": "Enviar",
    "submitAnyway": "Enviar de todos modos",
    "submitError": "Error al enviar el cuestionario. Por favor, inténtalo de nuevo.",
    "tipReread": "Consejo: Vuelve a leer el contenido",
    "tipRereadDetail": "Presta atención a las secciones que perdiste. Las preguntas del cuestionario provienen directamente del material de la lección.",
    "title": "Misión",
    "unansweredTitle": "Preguntas sin responder",
    "whatYoullLearn": "Lo que aprenderás",
    "wrong": "Incorrecto",
    "lockedError": "Esta misión todavía está bloqueada. Completa primero las misiones anteriores.",
    "milesEarned_one": "+{{count}} Mile",
    "milesEarned_other": "+{{count}} Miles",
    "questionsCount_one": "{{count}} pregunta",
    "questionsCount_other": "{{count}} preguntas",
    "unansweredMessage_one": "Tienes {{count}} pregunta sin responder. ¿Enviar de todos modos?",
    "unansweredMessage_other": "Tienes {{count}} preguntas sin responder. ¿Enviar de todos modos?",
    "sectionOf": "{{current}} de {{total}}",
    "questionOf": "Pregunta {{current}} de {{total}}"
  },
  "nav": {
    "billing": "Facturación",
    "care": "Care",
    "career": "Career",
    "checkup": "CheckUp",
    "family": "Familia",
    "home": "Inicio",
    "passport": "Passport",
    "profile": "Perfil",
    "qultureup": "QultureUp",
    "settings": "Configuraciones",
    "teleportal": "TelePortal",
    "testit": "TestIt",
    "userMenu": {
      "billing": "Facturación",
      "loggingOut": "Cerrando sesión…",
      "logout": "Cerrar sesión",
      "preferences": "Preferencias",
      "profile": "Perfil",
      "howItWorks": "Cómo funciona Tonnie"
    },
    "vault": "Bóveda",
    "inout": "InOut"
  },
  "notFound": {
    "description": "La página que buscas no existe o ha sido movida.",
    "goBack": "Volver",
    "goHome": "Ir a inicio",
    "message": "La página que buscas no existe.",
    "title": "Página no encontrada"
  },
  "inbox": {
    "title": "Bandeja de entrada",
    "subtitle": "Todos los mensajes que te han enviado —por correo electrónico y en la app— en un solo lugar.",
    "tabInbox": "Bandeja de entrada",
    "tabUnread": "No leídos",
    "tabArchived": "Archivados",
    "unreadCount_one": "{{count}} mensaje sin leer",
    "unreadCount_other": "{{count}} mensajes sin leer",
    "unreadLabel": "Sin leer",
    "emptyInbox": "Todavía no tienes mensajes.",
    "emptyUnread": "Lo tienes todo leído.",
    "emptyArchived": "No hay mensajes archivados.",
    "loadError": "No hemos podido cargar tus mensajes.",
    "retry": "Intentar de nuevo",
    "loadMore": "Cargar más",
    "archive": "Archivar",
    "restore": "Mover a la bandeja de entrada",
    "back": "Volver a los mensajes",
    "fromPlatform": "Tonnie",
    "channelEmail": "Correo electrónico",
    "channelInApp": "En la app",
    "channelPush": "Notificación push",
    "notRetainedTitle": "Contenido no conservado",
    "notRetainedBody": "Este correo se envió antes de que Tonnie guardara una copia de los mensajes que envía, así que su texto no se puede mostrar aquí.",
    "openAction": "Abrir",
    "selectPrompt": "Selecciona un mensaje para leerlo.",
    "actionError": "No ha funcionado. Inténtalo de nuevo.",
    "sentAt": "Enviado el {{date}}",
    "openFromBell": "Abrir bandeja de entrada",
    "markAllRead": "Marcar todo como leído",
    "markAllReadDone": "Todos los mensajes se han marcado como leídos",
    "allCaughtUp": "No hay mensajes sin leer",
    "archived": "Mensaje archivado",
    "restored": "Movido a la bandeja de entrada",
    "undo": "Deshacer",
    "markUnread": "Marcar como no leído",
    "markRead": "Marcar como leído",
    "markedUnread": "Marcado como no leído",
    "markedRead": "Marcado como leído",
    "groupToday": "Hoy",
    "groupYesterday": "Ayer",
    "groupThisWeek": "Esta semana",
    "groupEarlier": "Anteriores",
    "selectTitle": "Ningún mensaje seleccionado",
    "emptyInboxHint": "Aquí aparecerán los correos y los mensajes de la app de Tonnie y de las empresas con las que trabajas.",
    "emptyUnreadHint": "Los mensajes nuevos aparecerán aquí en cuanto lleguen.",
    "emptyArchivedHint": "Los mensajes que archives se guardan aquí y puedes devolverlos a la bandeja de entrada cuando quieras.",
    "loadErrorHint": "Comprueba tu conexión e inténtalo de nuevo.",
    "loading": "Cargando tus mensajes",
    "readerLabel": "Mensaje",
    "messageNotFound": "Este mensaje no está aquí",
    "messageNotFoundHint": "Puede que se haya eliminado o que se enviara a otra cuenta.",
    "notRetainedPreview": "El texto de este correo no se guardó.",
    "opensInNewTab": "(se abre en una pestaña nueva)",
    "viewArchived": "Ver archivados",
    "invitationsSection": "Invitaciones · {{count}}",
    "invitationsWaiting_one": "{{count}} invitación esperando tu respuesta",
    "invitationsWaiting_other": "{{count}} invitaciones esperando tu respuesta",
    "notificationSettings": "Ajustes de notificaciones"
  },
  "notifications": {
    "care": {
      "checkpointOverdueTitle": "Tu registro está esperando",
      "coachingAssignedTitle": {
        "encourage": "Asignado a ti: enviar unas palabras de ánimo",
        "challenge": "Asignado a ti: proponer un nuevo reto",
        "checkin": "Asignado a ti: preguntar cómo está",
        "celebrate": "Asignado a ti: celebrar su progreso",
        "remind": "Asignado a ti: enviar un recordatorio amistoso"
      },
      "coachingTouchTitle": {
        "encourage": "Tu equipo te ha enviado unas palabras de ánimo",
        "challenge": "Tu equipo te ha propuesto un nuevo reto",
        "checkin": "Tu equipo quiere saber cómo estás",
        "celebrate": "Tu equipo está celebrando tu progreso",
        "remind": "Un recordatorio amistoso de tu equipo"
      },
      "checkpointOverdueBody": "Un registro de Care está atrasado — solo toma unos 3 minutos. Abre Care para completarlo.",
      "interactionAssignedBody": "Se te ha asignado una interacción de Care.",
      "interventionTouchBody": "Tu equipo de patrocinadores programó algo de apoyo para ti. Abre Care para ver más.",
      "objectiveFeedbackCycleOpenTitle": "Nueva ronda de feedback",
      "objectiveFeedbackCycleOpenBody": "Tu equipo compartirá su feedback en breve — después podrás añadir tu autoevaluación. Abre Care para ver tus objetivos.",
      "objectiveFeedbackDueTitle": "Feedback solicitado",
      "objectiveFeedbackDueBody": "Es momento de compartir tu feedback sobre los objetivos de esta ronda. Abre Care para darlo.",
      "objectiveFeedbackReceivedTitle": "Nuevo feedback recibido",
      "objectiveFeedbackReceivedBody": "Tu equipo compartió feedback sobre tus objetivos. Abre Care para revisarlo y añadir tu autoevaluación."
    },
    "checkup": {
      "scoreReadyBody": "{{score}}: mira qué significa, pilar a pilar.",
      "scoreReadyTitle": "Puntuación iQulture lista"
    },
    "billing": {
      "actionRequiredBody": "Tu banco necesita que autorices este pago. Abre Facturación para completarlo.",
      "actionRequiredTitle": "Confirma tu pago",
      "paymentFailedBody": "No pudimos procesar tu pago. Actualiza tu método de pago para mantener el acceso.",
      "paymentFailedTitle": "Pago fallido"
    },
    "testit": {
      "reminderBody": "Completa tu TestIt para que la empresa que te evalúa pueda ver tus resultados.",
      "reminderTitle": "Tu TestIt está esperando"
    },
    "justNow": "Justo ahora",
    "bellLabel_one": "Notificaciones, {{shown}} sin leer",
    "bellLabel_other": "Notificaciones, {{shown}} sin leer",
    "title": "Notificaciones",
    "moreActions": "Más acciones",
    "tabAll": "Todas",
    "markReadAction": "Marcar como leída",
    "unsubscribe": {
      "confirmBody": "Dejaremos de enviar correos de «{{category}}» a {{email}}.",
      "confirmCta": "Darse de baja",
      "confirmTitle": "¿Darse de baja de estos correos?",
      "confirming": "Dándote de baja…",
      "doneBody": "Ya no recibirás correos de «{{category}}».",
      "doneTitle": "Te has dado de baja",
      "failed": "No se ha podido completar. Inténtalo de nuevo.",
      "invalidBody": "Puede que ya se haya usado, o que la cuenta a la que pertenecía se haya cerrado. No se ha cambiado nada.",
      "invalidTitle": "Este enlace ya no es válido",
      "loading": "Comprobando tu enlace…",
      "malformedBody": "El enlace para darse de baja parece truncado. Algunas aplicaciones de correo cortan los enlaces largos: prueba a abrir el mensaje en un navegador o usa el botón Darse de baja que tu aplicación de correo muestra en la parte superior del mensaje.",
      "malformedTitle": "Este enlace está incompleto",
      "stillReceive": "Los correos esenciales de la cuenta —restablecimientos de contraseña y avisos de seguridad— seguirán llegándote."
    },
    "showMore": "Ver más",
    "showLess": "Ver menos",
    "journey": {
      "relationshipMovedTitle": "Tus viajes han cambiado",
      "relationshipMovedBody": "{{company}} te acompaña ahora en un viaje propio, en la misma ruta. Míralo en Mis viajes."
    },
    "bellLabelNeedsYou_one": "Notificaciones, {{shown}} esperándote, incluida una invitación",
    "bellLabelNeedsYou_other": "Notificaciones, {{shown}} esperándote, incluidas invitaciones",
    "tabInvitations": "Invitaciones",
    "company": {
      "programmeLeftTitle": "Un talento dejó tu programa",
      "programmeLeftBody": "La tarjeta de {{name}} pasó a la pestaña Archivado de tu Pipeline y ya no ves lo que compartió.",
      "programmeLeftSponsoredBody": "{{name}} salió y ya no ves lo que compartió. Tu patrocinio continúa hasta el {{date}}, el final del periodo pagado.",
      "programmeLeftSponsoredOpenEndedBody": "{{name}} salió y ya no ves lo que compartió. Tu patrocinio continúa hasta el final del periodo pagado.",
      "shareRequestDeclinedTitle": "Solicitud rechazada",
      "shareRequestDeclinedBody": "{{name}} la rechazó. Nada ha cambiado: ves exactamente lo que ya había compartido contigo. Puedes volver a pedirlo desde su tarjeta.",
      "testitCompletedTitle": "Pruebas pedidas completadas",
      "testitCompletedBody": "{{name}} completó las pruebas que pediste. Abre su tarjeta en tu Pipeline para revisarlas y registrar tu decisión.",
      "sponsorshipAcceptedTitle": "Patrocinio aceptado",
      "sponsorshipAcceptedBody": "{{name}} lo aceptó. Su tarjeta está ahora en la columna Patrocinado de tu Pipeline, donde puedes seguir su progreso.",
      "sponsorshipDeclinedTitle": "Patrocinio rechazado",
      "sponsorshipDeclinedBody": "{{name}} lo rechazó. Lo que pagaste se reembolsa automáticamente. Puedes hacer una nueva oferta desde su tarjeta en tu Pipeline.",
      "nudgeDigestTitle": "A la espera de tu equipo",
      "nudgeDigestBody": "Pendientes de ti: {{count}}. Invitaciones sin enviar o rebotadas y ofertas de patrocinio sin respuesta: solo tu equipo las mueve."
    },
    "inout": {
      "confirmationBody": "¿Estuviste en el país de residencia cada día del {{from}} al {{to}}, salvo tus ausencias? Responde en InOut.",
      "confirmationTitle": "Confirma si estuviste aquí",
      "leadTimeBody": "Con tu ausencia y los viajes previstos, alcanzarías un límite de residencia el {{date}}. Mira en InOut qué hacer antes de salir.",
      "leadTimeTitle": "Límite de residencia cercano",
      "renewalWindowBody": "Ya puedes pedir la renovación de tu título de residencia, hasta el {{date}}.",
      "renewalWindowTitle": "Plazo de renovación abierto",
      "consultationBookedTitle": "Consulta reservada",
      "consultationBookedBody": "Tu consulta con la asesoría está reservada. Mira el día, la hora y el enlace para entrar en InOut.",
      "consultationRebookTitle": "Elige otra hora",
      "consultationRebookBody": "La hora que elegiste se ocupó mientras pagabas. Elige otra en InOut: no vuelves a pagar.",
      "consultationCancelledTitle": "Consulta cancelada",
      "consultationCancelledBody": "La asesoría canceló tu consulta. Elige una nueva hora en InOut: no vuelves a pagar.",
      "documentsRequestedTitle": "Documentos para tu caso",
      "documentsRequestedBody": "Tu asesoría ha pedido documentos para tu caso. Mira en su correo lo que necesita.",
      "refundHandledTitle": "Tu reembolso se ha tramitado",
      "refundHandledBody": "La asesoría tramitó el reembolso que pediste. Mira tu caso en InOut.",
      "dossierDeliveredTitle": "Tu dosier se ha entregado",
      "dossierDeliveredBody": "Tu dosier se entregó a la asesoría. El siguiente paso es de la asesoría: mira tu caso en InOut."
    },
    "qultureup": {
      "academyInactiveTitle": "Hora de una clase",
      "academyInactiveBody": "Hace tiempo desde tu último progreso en la Languages Academy. Una clase corta mantiene tu idioma en marcha."
    }
  },
  "onboarding": {
    "completed": "Completar incorporación",
    "education": {
      "addEducation": "Añadir educación",
      "bachelor": "Licenciatura",
      "degree": "Título",
      "description": "Añade tu formación académica",
      "emptyDescription": "Añade tu historial educativo para ayudarnos a entender mejor tu trayectoria y cualificaciones.",
      "emptyTitle": "No hay entradas educativas aún",
      "entry": "Entrada educativa",
      "field": "Campo de estudio",
      "fieldPlaceholder": "p.ej., Informática",
      "graduationYear": "Año de graduación",
      "institution": "Institución",
      "institutionPlaceholder": "Nombre de la universidad",
      "master": "Máster",
      "phd": "Doctorado",
      "selectDegree": "Selecciona el tipo de título",
      "title": "Historial educativo"
    },
    "experience": {
      "addExperience": "Añadir experiencia",
      "company": "Empresa",
      "companyPlaceholder": "Nombre de la empresa",
      "current": "Actual",
      "currentJob": "Dejar en blanco si es actual",
      "description": "Descripción",
      "descriptionPlaceholder": "Describe tu rol y logros...",
      "emptyDescription": "Añade tu experiencia laboral para mostrar tu trayectoria profesional y habilidades.",
      "emptyTitle": "No hay experiencia laboral aún",
      "endDate": "Fecha de finalización",
      "endDateHint": "Dejar en blanco si este es tu puesto actual",
      "entry": "Entrada de experiencia",
      "locationCity": "Ciudad",
      "locationCityPlaceholder": "p.ej., San Francisco",
      "locationCountry": "País",
      "locationCountryPlaceholder": "Selecciona país",
      "role": "Rol / Título",
      "rolePlaceholder": "Título del trabajo",
      "startDate": "Fecha de inicio",
      "title": "Experiencia laboral"
    },
    "family": {
      "childrenCount": "Número de hijos",
      "description": "Cuéntanos sobre tu hogar",
      "familyProgramHint": "Puedes configurar el Programa Familiar más tarde para invitar a los miembros de la familia a tu viaje",
      "hasChildren": "Tengo hijos",
      "hasPartner": "Tengo pareja/esposo",
      "hasPets": "Tengo mascotas",
      "householdInfo": "Información del hogar",
      "householdInfoDesc": "Esto nos ayuda a personalizar tus puntos de control de TelePortal y Care",
      "title": "Configuración familiar"
    },
    "fieldFilledFromImport": "Rellenado desde el perfil importado",
    "fieldImportHint": "Importar perfil para pre-rellenar este campo",
    "languages": {
      "addLanguage": "Añadir idioma",
      "advanced": "Avanzado",
      "beginner": "Principiante",
      "description": "Cuéntanos sobre tus habilidades lingüísticas",
      "elementary": "Elemental",
      "emptyDescription": "Añade los idiomas que hablas para ayudarnos a evaluar tu preparación comunicativa.",
      "emptyTitle": "No se han añadido idiomas aún",
      "entry": "Idioma",
      "intermediate": "Intermedio",
      "language": "Idioma",
      "level": "Nivel de competencia",
      "native": "Nativo",
      "proficient": "Competente",
      "selectLanguage": "Selecciona un idioma",
      "selectLevel": "Selecciona el nivel de competencia",
      "title": "Idiomas",
      "upperIntermediate": "Intermedio Superior"
    },
    "linkedin": {
      "dropPdfSubtitle": "o haz clic para explorar",
      "dropPdfTitle": "Suelta tu PDF de Perfil de LinkedIn aquí",
      "fileTooLarge": "El archivo es demasiado grande. El tamaño máximo es 10 MB.",
      "invalidFileType": "Tipo de archivo no soportado. Por favor, sube un PDF, documento de Word o archivo de texto.",
      "parseFailed": "No se pudo extraer datos del documento. Por favor, intenta con un archivo diferente.",
      "pdfInstructions": {
        "step1": "Ve a LinkedIn e inicia sesión",
        "step2": "Navega a Configuración y Privacidad → Privacidad de Datos → Obtén una copia de tus datos",
        "step3": "Selecciona 'Perfil' y descarga como PDF",
        "step4": "Sube el archivo PDF a continuación",
        "title": "Cómo obtener tu PDF de Perfil de LinkedIn"
      },
      "pdfUploadError": "Error al subir el PDF. Por favor, intenta de nuevo.",
      "selectPdfFile": "Seleccionar archivo PDF",
      "uploadDifferentFile": "Subir archivo diferente",
      "uploading": "Subiendo...",
      "wizard": {
        "compliance": {
          "description": "Tus datos permanecen privados. Solo leemos el documento que subes — nada se almacena o comparte sin tu consentimiento.",
          "title": "Cumplimiento de GDPR y LinkedIn"
        },
        "confirmAndContinue": "Confirmar y continuar",
        "getStarted": "Empezar",
        "guide": {
          "cv": {
            "subtitle": "Algunos consejos para obtener los mejores resultados de tu CV",
            "tip1": {
              "description": "Sube tu CV más actualizado para la importación de perfil más precisa.",
              "title": "Usa una versión reciente"
            },
            "tip2": {
              "description": "Los CV con secciones claras (Experiencia, Educación, Habilidades) dan los mejores resultados de extracción.",
              "title": "Los formatos estructurados funcionan mejor"
            },
            "tip3": {
              "description": "Aceptamos archivos PDF, DOCX, DOC y TXT de hasta 10 MB.",
              "title": "Formatos soportados"
            },
            "title": "Consejos para la subida de tu CV"
          },
          "linkedin": {
            "openLinkedIn": "Abrir LinkedIn",
            "step1": {
              "description": "Ve a linkedin.com, inicia sesión y navega a tu página de perfil.",
              "title": "Abrir tu perfil"
            },
            "step2": {
              "description": "En tu página de perfil, haz clic en el botón \"Más\" debajo de tu titular, luego selecciona \"Guardar como PDF\".",
              "title": "Haz clic en \"Más\" y luego en \"Guardar como PDF\""
            },
            "step3": {
              "description": "LinkedIn generará un PDF. Guárdalo en tu computadora — lo subirás en el siguiente paso.",
              "title": "Descargar el archivo"
            },
            "subtitle": "Sigue estos 3 sencillos pasos para descargar tu perfil",
            "tip": "El PDF se genera instantáneamente desde tu página de perfil. No es necesario solicitar una exportación de datos.",
            "title": "Cómo obtener tu PDF de LinkedIn"
          }
        },
        "processing": {
          "analyzing": "Analizando con IA",
          "extracting": "Extrayendo contenido de texto",
          "structuring": "Estructurando tus datos",
          "subtitle": "Por favor, espera mientras analizamos tu documento...",
          "title": "Extrayendo tu perfil",
          "uploading": "Subiendo documento"
        },
        "progress": "Progreso",
        "readyToUpload": "Estoy listo para subir",
        "review": {
          "at": "en",
          "editHint": "Puedes editar todos los detalles en los siguientes pasos de incorporación.",
          "fieldCertifications": "Certificaciones",
          "fieldEducation": "Educación",
          "fieldExperience": "Experiencia laboral",
          "fieldHeadline": "Título profesional",
          "fieldLanguages": "Idiomas",
          "fieldNames": "Nombre",
          "fieldSkills": "Habilidades",
          "fieldWebsites": "Sitios web y enlaces",
          "noDataFound": "No se pudo extraer ningún dato. Asegúrate de que el archivo sea un documento de perfil válido (PDF, DOCX o TXT).",
          "present": "Presente",
          "previewDescription": "Los siguientes campos se completarán automáticamente en tu perfil de Tonnie:",
          "subtitle": "Encontramos la siguiente información en tu documento. Revísala y confirma para continuar.",
          "title": "Tu perfil extraído",
          "entries_one": "{{count}} entrada",
          "entries_other": "{{count}} entradas",
          "languagesCount_one": "{{count}} idioma",
          "languagesCount_other": "{{count}} idiomas",
          "positions_one": "{{count}} puesto",
          "positions_other": "{{count}} puestos",
          "skillsCount_one": "{{count}} habilidad",
          "skillsCount_other": "{{count}} habilidades",
          "summaryStats_one": "{{count}} campo extraído de tu documento",
          "summaryStats_other": "{{count}} campos extraídos de tu documento"
        },
        "reviewData": "Revisar datos",
        "source": {
          "cvCard": {
            "description": "Sube tu CV o currículum existente en formato PDF, DOCX o TXT. Funciona con cualquier diseño.",
            "title": "CV / Currículum personal"
          },
          "linkedinCard": {
            "description": "Descarga tu perfil de LinkedIn y sube el PDF. Mejor para datos precisos y estructurados.",
            "tag": "Recomendado",
            "title": "PDF de perfil de LinkedIn"
          },
          "subtitle": "Elige cómo te gustaría importar tu perfil profesional. Extraeremos automáticamente tu experiencia, educación y habilidades.",
          "title": "Importar tu perfil"
        },
        "steps": {
          "guide": "Guía",
          "processing": "Procesando",
          "review": "Revisión",
          "source": "Fuente",
          "upload": "Subir"
        },
        "success": {
          "description": "Tus datos han sido importados. Ahora puedes generar CVs profesionales y gestionar múltiples versiones.",
          "title": "¡Perfil importado exitosamente!"
        },
        "upload": {
          "subtitle": "Arrastra y suelta tu archivo o haz clic para buscar. Aceptamos archivos PDF, DOCX y TXT.",
          "title": "Sube tu documento"
        },
        "aria": {
          "progress": "Progreso de mago"
        }
      }
    },
    "linkedinBound": "Perfil importado",
    "linkedinConnectionError": "Error al importar el perfil. Por favor, intenta de nuevo.",
    "location": {
      "currentCountry": "País actual",
      "description": "¿Dónde estás ahora y a dónde quieres ir?",
      "goal": "Tu objetivo",
      "goalHint": "Esto nos ayuda a personalizar tu viaje",
      "goalPlaceholder": "Cuéntanos sobre tus objetivos y expectativas de reubicación...",
      "selectCountry": "Selecciona un país",
      "targetCountry": "País objetivo",
      "title": "Ubicación y objetivos"
    },
    "mobility": {
      "citizenship": "Países de ciudadanía",
      "citizenshipHint": "Selecciona todos los países donde tienes ciudadanía",
      "description": "Cuéntanos sobre tus intereses de ciudadanía y reubicación",
      "selectCitizenship": "Selecciona un país...",
      "removeCitizenship": "Quitar {{country}}",
      "title": "Movilidad",
      "validPassport": "¿Tienes un pasaporte válido?",
      "validPassportHint": "Los detalles de Passport se gestionarán en TelePortal"
    },
    "personalInfo": {
      "addAddress": "Añadir dirección",
      "addWebsiteUrl": "Añadir URL del sitio web",
      "address": "Dirección",
      "addressDetails": "Detalles de la dirección",
      "addressDetailsError": "Error al obtener los detalles de la dirección. Por favor, intenta de nuevo.",
      "addressHint": "Selecciona tu dirección de las sugerencias",
      "addressInitError": "Error al inicializar la búsqueda de dirección. Por favor, intenta de nuevo.",
      "addressInvalid": "Datos de dirección no válidos. Por favor, intenta seleccionar otra dirección.",
      "addressLoadError": "Error al cargar la búsqueda de dirección. Por favor, actualiza la página.",
      "addressPlaceholder": "Empieza a escribir tu dirección...",
      "addressSearchError": "Error al buscar direcciones. Por favor, inténtalo de nuevo.",
      "addressSelected": "Dirección seleccionada",
      "addressSuggestions": "Sugerencias de direcciones",
      "avatarFileSizeError": "El tamaño del archivo debe ser menor de 5MB",
      "avatarFileTypeError": "Por favor, sube un archivo de imagen válido (JPG, PNG, GIF o WEBP)",
      "avatarRemoved": "¡Foto eliminada con éxito!",
      "avatarUploadFailed": "Error al subir el avatar",
      "avatarUploaded": "¡Foto subida con éxito!",
      "changePhoto": "Cambiar foto",
      "city": "Ciudad",
      "clickEditToAdd": "Haz clic en Editar para añadir tu dirección",
      "clickToUpload": "Haz clic para subir",
      "complement": "Complemento",
      "complementPlaceholder": "Apartamento, suite, unidad, etc.",
      "country": "País",
      "dateOfBirth": "Fecha de nacimiento",
      "description": "Cuéntanos sobre ti",
      "firstName": "Nombre",
      "firstNamePlaceholder": "Introduce tu nombre",
      "lastName": "Apellido",
      "lastNamePlaceholder": "Introduce tu apellido",
      "linkedinConnected": "Datos del perfil importados de LinkedIn",
      "loadingAddressDetails": "Cargando detalles de la dirección...",
      "noAddress": "No se ha añadido ninguna dirección aún",
      "phone": "Número de teléfono",
      "phoneHint": "Usaremos esto para contactarte sobre tu viaje",
      "phonePlaceholder": "Introduce tu número de teléfono",
      "photoFileTypes": "JPG, PNG, GIF o WEBP. Máx 5MB.",
      "photoInstructions": "Añade una foto profesional para personalizar tu perfil. Esto ayuda a los reclutadores y empresas a reconocerte.",
      "profilePhoto": "Foto de perfil",
      "removePhoto": "Eliminar foto",
      "searchAddress": "Buscar dirección",
      "searchAddressDescription": "Escribe tu dirección y selecciona de las sugerencias de Google Places",
      "state": "Estado/Provincia",
      "street": "Calle",
      "title": "Información personal",
      "uploadPhoto": "Subir foto",
      "websiteLabelPlaceholder": "Etiqueta personalizada (p. ej., Mi Blog)",
      "websiteType": {
        "blog": "Blog",
        "facebook": "Facebook",
        "github": "GitHub",
        "gitlab": "GitLab",
        "instagram": "Instagram",
        "linkedin": "LinkedIn",
        "other": "Otro",
        "personal": "Personal",
        "portfolio": "Portafolio",
        "twitter": "Twitter / X",
        "website": "Sitio web",
        "youtube": "YouTube"
      },
      "websiteUrlPlaceholder": "https://...",
      "websiteUrls": "URLs de sitios web y enlaces sociales",
      "websiteUrlsHint": "Añade tu portafolio, sitio web personal, GitHub, LinkedIn u otros enlaces profesionales",
      "workModel": {
        "flexible": "Flexible",
        "hybrid": "Híbrido",
        "on-site": "En sitio",
        "remote": "Remoto"
      },
      "workModelPreference": "Preferencia de modelo de trabajo",
      "workModelPreferenceHint": "Selecciona los modelos de trabajo a los que estás abierto",
      "zipCode": "Código postal",
      "websiteTypeLabel": "Tipo de enlace",
      "websiteUrlLabel": "URL del enlace",
      "websiteCustomLabel": "Etiqueta personalizada",
      "removeWebsiteUrl": "Quitar enlace"
    },
    "professional": {
      "advanced": "Avanzado",
      "beginner": "Principiante",
      "description": "Cuéntanos sobre tu carrera",
      "elementary": "Elemental",
      "englishLevel": "Dominio del inglés",
      "englishLevelHint": "Esto nos ayuda a evaluar tu preparación",
      "intermediate": "Intermedio",
      "junior": "Junior",
      "mid": "Nivel medio",
      "proficient": "Competente",
      "role": "Rol actual / Título del trabajo",
      "rolePlaceholder": "p. ej., Ingeniero de Software",
      "selectEnglishLevel": "Selecciona tu nivel de inglés",
      "selectSeniority": "Selecciona tu nivel de antigüedad",
      "senior": "Senior",
      "seniority": "Nivel de antigüedad",
      "title": "Experiencia profesional",
      "upperIntermediate": "Intermedio superior"
    },
    "review": {
      "address": "Dirección",
      "careerTime": "Tiempo de Career",
      "certifications": "Certificaciones",
      "countriesOfInterest": "Países de interés",
      "currentRole": "Rol actual",
      "education": "Educación",
      "experience": "Experiencia",
      "familyConfig": "Configuración familiar",
      "hardSkills": "Habilidades técnicas",
      "hasChildren": "Tiene hijos",
      "hasPartner": "Tiene pareja",
      "hasPets": "Tiene mascotas",
      "mobility": "Movilidad",
      "passport": "Passport válido",
      "personalInfo": "Información personal",
      "profilePhoto": "Foto de perfil",
      "profilePhotoSet": "La foto de perfil ha sido establecida",
      "skills": "Habilidades y experiencia",
      "softSkills": "Habilidades blandas",
      "spokenLanguages": "Idiomas hablados",
      "websiteUrls": "URLs de sitios web y enlaces sociales",
      "workModel": "Preferencia de modelo de trabajo",
      "years": "años"
    },
    "saveError": "Error al guardar el progreso. Por favor, inténtalo de nuevo.",
    "saved": "Progreso guardado con éxito",
    "skills": {
      "addCertification": "Añadir certificación",
      "addHardSkill": "Añadir habilidad técnica",
      "addLanguage": "Añadir idioma",
      "addSoftSkill": "Añadir habilidad blanda",
      "careerTime": "Tiempo de Career",
      "certification": "Certificación",
      "certificationAuthority": "Autoridad emisora",
      "certificationAuthorityPlaceholder": "p. ej., Amazon Web Services",
      "certificationExpiryDate": "Fecha de caducidad",
      "certificationExpiryDatePlaceholder": "Deja vacío si no hay caducidad",
      "certificationIssueDate": "Fecha de emisión",
      "certificationLicenseNumber": "Número de licencia",
      "certificationLicenseNumberPlaceholder": "Número de licencia o certificado (opcional)",
      "certificationName": "Nombre de la certificación",
      "certificationNamePlaceholder": "p. ej., AWS Certified Solutions Architect",
      "certificationUrl": "URL del certificado",
      "certificationUrlPlaceholder": "https://...",
      "certifications": "Certificaciones",
      "certificationsHint": "Añadir certificaciones y licencias profesionales",
      "currentRole": "Rol actual",
      "description": "Cuéntanos sobre tus habilidades y experiencia profesional",
      "experienceYears": {
        "0_1": "0-1 años",
        "11_15": "11-15 años",
        "16_plus": "16+ años",
        "2_3": "2-3 años",
        "4_5": "4-5 años",
        "6_10": "6-10 años"
      },
      "hardSkills": "Habilidades técnicas",
      "hardSkillsHint": "Añadir habilidades técnicas y tus años de experiencia",
      "hardSkillsInfo": "Proporciona al menos 5 de tus habilidades técnicas más fuertes y tiempo de experiencia.",
      "languageLevels": {
        "A1": "A1 — Principiante",
        "A2": "A2 — Elemental",
        "B1": "B1 — Intermedio",
        "B2": "B2 — Intermedio alto",
        "C1": "C1 — Avanzado",
        "C2": "C2 — Dominante",
        "native": "Nativo"
      },
      "languages": "Idiomas hablados",
      "languagesHint": "Añadir idiomas que conoces y tu nivel de competencia",
      "languagesInfo": "Es importante añadir tus habilidades en inglés y en tu lengua nativa, al menos. Cuanto más informes, más oportunidades estarán disponibles.",
      "noHardSkillFound": "No se encontraron habilidades técnicas.",
      "noLanguageFound": "No se encontró ningún idioma.",
      "noRoleFound": "No se encontró ningún rol.",
      "noSoftSkillFound": "No se encontró ninguna habilidad blanda.",
      "searchHardSkill": "Buscar habilidades técnicas...",
      "searchLanguage": "Buscar idiomas...",
      "searchRole": "Buscar roles...",
      "searchSoftSkill": "Buscar habilidades blandas...",
      "selectExperience": "Seleccionar experiencia",
      "selectLevel": "Seleccionar nivel",
      "selectRole": "Selecciona tu rol...",
      "skillExperience": {
        "0_1": "0-1 años",
        "11_plus": "11+ años",
        "2_3": "2-3 años",
        "4_5": "4-5 años",
        "6_10": "6-10 años"
      },
      "softSkillLevels": {
        "advanced": "Avanzado",
        "beginner": "Principiante",
        "expert": "Experto",
        "intermediate": "Intermedio"
      },
      "softSkills": "Habilidades blandas",
      "softSkillsHint": "Añadir habilidades blandas y tu nivel de competencia",
      "softSkillsInfo": "Proporciona al menos 3 de tus habilidades blandas más fuertes.",
      "title": "Autoevaluación de habilidades",
      "levelFor": "Nivel de {{name}}",
      "experienceFor": "Experiencia en {{name}}"
    },
    "validation": {
      "address_city_country_required": "Por favor, proporciona al menos tu ciudad y país",
      "address_city_required": "La ciudad es obligatoria",
      "address_country_required": "El país es obligatorio",
      "career_experience_required": "Por favor, selecciona tu experiencia profesional",
      "certification_authority_required": "La autoridad emisora es obligatoria",
      "certification_name_required": "El nombre de la certificación es obligatorio",
      "citizenship_required": "Por favor, selecciona al menos una ciudadanía",
      "company_required": "La empresa es obligatoria",
      "dateOfBirth_invalid": "Por favor, introduce una fecha de nacimiento válida",
      "dateOfBirth_invalid_format": "Formato de fecha no válido",
      "dateOfBirth_min_age": "Debes tener al menos {{minAge}} años",
      "dateOfBirth_required": "La fecha de nacimiento es obligatoria",
      "degree_required": "El título es obligatorio",
      "end_date_after_start": "La fecha de finalización debe ser posterior a la fecha de inicio",
      "exp_role_required": "El rol es obligatorio",
      "field_of_study_required": "El campo de estudio es obligatorio",
      "firstName_max_length": "El nombre debe tener como máximo 100 caracteres",
      "firstName_min_length": "El nombre debe tener al menos 2 caracteres",
      "firstName_required": "El nombre es obligatorio",
      "fixErrors": "Por favor, corrige los campos resaltados antes de continuar.",
      "graduation_year_invalid": "Por favor, introduce un año de graduación válido",
      "institution_required": "La institución es obligatoria",
      "lastName_max_length": "El apellido debe tener como máximo 100 caracteres",
      "lastName_min_length": "El apellido debe tener al menos 2 caracteres",
      "lastName_required": "El apellido es obligatorio",
      "passport_required": "Por favor, indica si tienes un pasaporte válido",
      "phone_invalid_characters": "El número de teléfono contiene caracteres no válidos",
      "phone_max_digits": "El número de teléfono debe tener como máximo {{maxDigits}} dígitos",
      "phone_min_digits": "El número de teléfono debe tener al menos {{minDigits}} dígitos",
      "phone_required": "El número de teléfono es obligatorio",
      "role_select_required": "Por favor, selecciona tu rol actual",
      "start_date_required": "La fecha de inicio es obligatoria",
      "url_invalid": "Por favor, introduce una URL válida (p. ej. https://...)",
      "work_model_required": "Por favor, selecciona al menos una preferencia de modelo de trabajo"
    }
  },
  "passport": {
    "achievementUnlocked": "🎉 Logro desbloqueado: {{name}}!",
    "activeJourneys": "Viajes activos",
    "adjustFilters": "Ajusta tus filtros o completa actividades para ver eventos",
    "allTime": "Todo el tiempo",
    "badgeMilesReward": "+{{miles}} millas",
    "badges": "Medallas",
    "badgesCount": "{{earned}} de {{total}} medallas ganadas",
    "badgesEarned": "{{earned}} de {{total}} ganadas",
    "badgesProgress": "Progreso de insignias",
    "bio": {
      "address": "Dirección",
      "citizenLevel": "Nivel Citizen",
      "dateOfBirth": "Fecha de nacimiento",
      "email": "Correo electrónico",
      "fullName": "Nombre completo",
      "nationality": "Ciudadanía",
      "phone": "Teléfono"
    },
    "rarityHeading": "Rareza",
    "citizenBadges": "Insignias Citizen",
    "citizenBadgesDesc": "Insignias especiales ganadas al demostrar adaptación cultural y finalización del viaje",
    "citizenBadgesSection": "Insignias Citizen",
    "citizenLevel": {
      "starter": "Principiante"
    },
    "companyCohort": "Cohorte de empresa",
    "completeForBadges": "¡Completa actividades para ganar insignias de ciudadano!",
    "coverSubtitle": "Passport",
    "coverTitle": "Citizen",
    "daysOnJourney": "Días en el viaje",
    "description": "Tu registro de viaje",
    "earnBadgesMessage": "¡Completa evaluaciones y lecciones para ganar insignias!",
    "earned": "Ganadas",
    "earnedOn": "Ganadas el",
    "errors": {
      "tryAgain": "Por favor, intenta de nuevo más tarde.",
      "unableToLoad": "No se pudo cargar los datos de Passport"
    },
    "event": {
      "ACHIEVEMENT_EARNED.desc": "Has ganado un logro"
    },
    "eventCategory": "Categoría",
    "eventData": "Datos del evento",
    "eventDetails": "Detalles del evento",
    "eventType": "Tipo de evento",
    "heroBanner": {
      "levelLabel": "Nivel {{level}}",
      "milesToNextLevel": "{{miles}} millas a {{nextLevel}}",
      "subtitle": "Rastrea tus sellos, insignias y hitos a lo largo de cada héroe en tu viaje de reubicación.",
      "title": "Tu viaje Passport"
    },
    "heroes": "Héroes",
    "identification": "Identificación",
    "insightCultural": "🌍 La integración cultural es clave",
    "insightCulturalDesc": "Enfócate en las lecciones de QultureUp para mejorar tu preparación para la integración.",
    "insightProgress": "🎯 ¡Estás progresando más rápido de lo esperado!",
    "insightProgressDesc": "Tu puntuación de preparación ha mejorado en 15 puntos en las últimas 2 semanas.",
    "insightStreak": "📚 Mantén viva tu racha de aprendizaje",
    "insightStreakDesc": "Estás en una racha de 7 días. ¡Un día más para desbloquear una nueva insignia!",
    "insights": "Perspectivas",
    "issued": "Emitido: {{date}}",
    "journeyMiles": "Miles",
    "journeyStamps": "Sellos de viaje",
    "journeySummary": "Resumen del viaje",
    "journeyTimeline": "Línea de tiempo del viaje",
    "journeyTimelineDesc": "Un registro de tus hitos y logros en el viaje",
    "keepGoingMilestones": "¡Sigue adelante para ganar hitos!",
    "kpiSectionDesc": "Evolución general de la preparación y tendencias de los pilares M/E/S/H",
    "last3Months": "Últimos 3 meses",
    "level": "Nivel",
    "levelCurrent": "Actual",
    "levelMilesThreshold": "{{miles}} Miles",
    "levelMilesToReach": "{{miles}} más Miles para alcanzar este nivel",
    "levelProgress": "Progreso de nivel",
    "levels": {
      "ambassador": "Embajador",
      "explorer": "Explorador",
      "newcomer": "Recién llegado",
      "pioneer": "Pionero",
      "voyager": "Viajero"
    },
    "levelsCollection": "Niveles de viaje",
    "levelsCount": "{{achieved}} de {{total}} niveles alcanzados",
    "limitedJourneys": "Viajes limitados",
    "loading": "Cargando tu pasaporte...",
    "locked": "Bloqueado",
    "maxLevel": "(Máx)",
    "meshPillarTrends": "Tendencias de los pilares m/E/S/H",
    "miles": "Miles",
    "milesAbbr": "mi",
    "milesThisWeek": "Miles esta semana",
    "milesToNextLevel": "Miles al siguiente nivel",
    "milesValue": "Valor de Miles",
    "milestonesAchievements": "Hitos y logros",
    "milestonesSection": "Hitos",
    "mobileApp": {
      "description": "Consulta tu pasaporte completo, comparte tus logros y sigue el progreso de tu viaje con la aplicación móvil.",
      "openApp": "Abrir en la app",
      "title": "Passport en móvil"
    },
    "nextMilestone": "Siguiente: {{name}}",
    "noAchievements": "Sin logros aún",
    "noBadgesYet": "Sin insignias de ciudadano aún. Completa actividades del viaje para ganar insignias.",
    "noRecentActivity": "Sin actividad reciente. ¡Comienza tu viaje para ganar millas!",
    "noStampsYet": "Sin sellos aún",
    "noTimelineYet": "Sin eventos en la línea de tiempo aún. Completa actividades del viaje para ver tu historial.",
    "notReady": {
      "badges": "Insignias Citizen",
      "badgesDesc": "Desbloquea insignias especiales que reconocen tu adaptación cultural",
      "miles": "Miles de viaje",
      "milesDesc": "Acumula millas a medida que avanzas en tu reubicación",
      "progress": "Rastrear progreso",
      "progressDesc": "Consulta tu línea de tiempo completa del viaje y los hitos",
      "stamps": "Colecciona sellos",
      "stampsDesc": "Gana sellos completando actividades con todos los héroes",
      "startCheckup": "Iniciar evaluación de CheckUp",
      "subtitle": "Completa tus primeras actividades de héroe para comenzar a coleccionar sellos, ganar insignias y construir tu historial de reubicación.",
      "title": "¡Tu Passport te espera!"
    },
    "openInApp": "Abrir en la app",
    "overallReadinessEvolution": "Evolución general de la preparación",
    "pagePrefix": "P.",
    "percentComplete": "{{percent}}% completo",
    "photo": "Foto",
    "progress": "Progreso",
    "progressLabel": "Progreso",
    "rarity": {
      "common": "Común",
      "epic": "Épico",
      "legendary": "Legendario",
      "rare": "Raro",
      "uncommon": "Poco común"
    },
    "readinessScore": "Puntuación de preparación",
    "recentActivity": "Actividad reciente",
    "recentActivityDesc": "Tus últimas millas de viaje ganadas",
    "returnToDashboard": "Volver al tablero",
    "reward": "Recompensa",
    "searchEvents": "Buscar eventos...",
    "shareAchievement": "Compartir logro",
    "shareMessage": "¡He ganado el sello {{name}} en Tonnie! +{{miles}} Miles 🏆",
    "since": "Desde",
    "stampArrived": "Llegado al destino",
    "stampArrivedDesc": "Has llegado a tu país de destino",
    "stampCultureStarter": "Inicio de Cultura",
    "stampCultureStarterDesc": "Completado tu primer mundo de QultureUp",
    "stampCategory": {
      "onboarding": "Primeros pasos",
      "checkup": "CheckUp",
      "teleportal": "TelePortal",
      "qultureup": "QultureUp",
      "care": "Care",
      "inout": "InOut",
      "cross_hero": "Entre héroes"
    },
    "stampDetail": {
      "earned": "¡Sello ganado!",
      "locked": "Aún no ganado",
      "milesReward": "Recompensa de Miles",
      "milesValueUnit": "{{value}} Miles",
      "title": "Detalles del sello",
      "source": "Origen: {{category}}"
    },
    "stampFirstCare": "Primer ciclo de Care",
    "stampFirstCareDesc": "Completado tu primer ciclo de retroalimentación de Care",
    "stampFirstCheckup": "Primer CheckUp",
    "stampFirstCheckupDesc": "Has completado tu primera evaluación de preparación",
    "stampNotFound": "Sello no encontrado",
    "stampVisaApproved": "Visa aprobada",
    "stampVisaApprovedDesc": "Tu solicitud de visa fue aprobada",
    "stamps": "Sellos",
    "stampsCollection": "Colección de sellos",
    "stampsCollectionDesc": "Gana sellos completando logros a lo largo de tu viaje",
    "stampsCount": "{{earned}} de {{total}} sellos ganados",
    "stampsEarned": "Sellos ganados",
    "stampsSection": "Sellos",
    "status": "Estado",
    "swipeToOpen": "Desliza para abrir",
    "tabs": {
      "levels": "Niveles",
      "overview": "Resumen",
      "stamps": "Sellos",
      "timeline": "Cronograma"
    },
    "thisWeek": "Esta semana",
    "timelineCheckupCompleted": "CheckUp completado",
    "timelineCheckupCompletedDesc": "Tu puntuación de preparación: 85/100",
    "timelineCultureBadge": "Insignia de inicio de cultura ganada",
    "timelineCultureBadgeDesc": "Has completado CheckUp + 5 lecciones de cultura",
    "timelineFeedbackChampion": "Campeón de retroalimentación",
    "timelineFeedbackChampionDesc": "Has completado tu 3er ciclo de retroalimentación",
    "timelineJourneyStarted": "Viaje comenzado",
    "timelineJourneyStartedDesc": "¡Bienvenido a tu viaje internacional!",
    "timelineLessonsCompleted": "10 lecciones completadas",
    "timelineLessonsCompletedDesc": "Has completado 10 lecciones de QultureUp",
    "timelineStreak": "Racha de 7 días",
    "timelineStreakDesc": "Has estado aprendiendo de manera constante durante 7 días",
    "timelineVisaDocs": "Documentos de visa subidos",
    "timelineVisaDocsDesc": "Todos los documentos requeridos verificados y listos",
    "toNextLevel": "Siguiente nivel",
    "tonnieAverage": "Promedio de Tonnie",
    "title": "Passport",
    "totalJourneys": "Total de viajes",
    "totalMiles": "Total de Miles",
    "totalStamps": "Total de sellos",
    "tryDifferentSearch": "Prueba un término de búsqueda diferente",
    "unlocked": "Desbloqueado",
    "viewInMobile": "Ver en móvil",
    "visibility": "Visibilidad",
    "visibleToCompany": "Empresa",
    "visibleToTalent": "Talento",
    "visibleToTonnie": "Tonnie",
    "vsCompanyCohort": "vs cohorte de la empresa",
    "vsSelfHistory": "vs historial personal",
    "vsTonnieDatabase": "vs base de datos de Tonnie",
    "welcome": {
      "badgesStep": "Insignias Citizen",
      "badgesStepDesc": "Desbloquea insignias que reconocen tu adaptación cultural",
      "description": "Tu Passport es tu registro de reubicación. Completa actividades de héroe para comenzar a coleccionar sellos, ganar insignias y rastrear los hitos de tu viaje.",
      "hint": "Completa tu primer CheckUp para comenzar a coleccionar sellos",
      "progressStep": "Rastrea tu viaje",
      "progressStepDesc": "Ve tu línea de tiempo completa, hitos y millas",
      "stampsStep": "Colecciona sellos",
      "stampsStepDesc": "Gana sellos completando actividades con todos los héroes",
      "startJourney": "Comienza tu viaje",
      "title": "Tu Passport te espera"
    },
    "yourScore": "Tu puntuación"
  },
  "payment": {
    "addPaymentMethod": "Añadir método de pago",
    "amount": "Cantidad",
    "basePrice": "Precio base",
    "cancelFamilyAddon": "Cancelar complemento familiar",
    "cancelFamilyAddonDesc": "¿Estás seguro de que quieres cancelar tu Complemento Familiar? Mantendrás el acceso hasta el final de tu período de facturación.",
    "cancelFamilyAddonWarning": "Después de la cancelación, perderás el acceso a las funciones del Programa Familiar al final de tu período de facturación.",
    "cardEnding": "Tarjeta terminando en {{last4}}",
    "cardExpires": "Expira {{month}}/{{year}}",
    "checkoutCancelled": "Pago cancelado",
    "checkoutError": "No se pudo iniciar el pago. Por favor, inténtalo de nuevo.",
    "checkoutSuccess": "¡Pago exitoso! Procesando tu pedido...",
    "citizenOnly": "Solo Citizen",
    "confirmAndPay": "Confirmar y pagar",
    "coupon": {
      "apply": "Aplicar",
      "applied": "{{code}} · {{percent}}% de descuento aplicado",
      "applyOrClear": "Aplica el cupón para usarlo, o elimínalo para continuar sin uno.",
      "invalid": "Este código de cupón no es válido.",
      "label": "¿Tienes un cupón?",
      "placeholder": "Introduce el código",
      "remove": "Eliminar",
      "errors": {
        "notFound": "Este código de cupón no existe. Revísalo e inténtalo de nuevo.",
        "expired": "Este cupón ha caducado o todavía no está activo.",
        "disabled": "Este cupón ya no está disponible.",
        "exhausted": "Este cupón ha alcanzado su límite de usos y no se puede volver a usar.",
        "wrongProduct": "Este cupón no se puede usar en esta compra."
      }
    },
    "confirmCancelFamily": "Confirmar cancelación",
    "confirmCancelPro": "Confirmar cancelación",
    "confirmDowngrade": "¿Estás seguro de que quieres cancelar tu suscripción Pro? Mantendrás el acceso hasta el final de tu período de facturación.",
    "confirmRenewal": "Confirmar renovación",
    "createFirstJourney": "Crea tu primer viaje",
    "createJourneyFirst": "Por favor, crea primero una instancia de viaje",
    "createNewJourney": "Crear nuevo viaje",
    "creditSourcePromotion": "Bono de bienvenida",
    "creditSourceReferral": "Invité a 2 amigos",
    "currentExpiration": "Expiración actual",
    "currentPlan": "Plan actual",
    "discount": "Descuento",
    "downgradeToJourney": "Cancelar suscripción Pro",
    "downgradeWarning": "Tras la cancelación, mantendrás el acceso Pro hasta el final de tu período de facturación. Después, los viajes que cubre Pro vuelven al acceso básico; un viaje que hayas desbloqueado o que patrocine una empresa mantiene el acceso completo.",
    "downgradedToJourney": "Suscripción Pro cancelada. Mantendrás el acceso hasta el final de tu período de facturación.",
    "editPaymentMethod": "Editar",
    "expiresOn": "Expira el",
    "expiringSoon": "Caducando pronto",
    "familyAddon": "Complemento familiar",
    "familyAddonActive": "Programa Familiar está activo",
    "familyAddonCancelled": "¡Complemento Familiar cancelado con éxito!",
    "familyAddonDesc": "Reúne a tu hogar en tu viaje. Invita a los miembros de la familia a compartir acceso, gestionar tareas del hogar juntos y apoyar el éxito de la integración de todos.",
    "familyAddonFeature1": "Invita a los miembros de la familia: todos obtienen acceso a Citizen y funciones web Citizen",
    "familyAddonFeature2": "TelePortal y Care conscientes del hogar — gestiona la reubicación juntos",
    "familyAddonFeature3": "Progreso de viaje compartido — todos se mantienen conectados y apoyados",
    "familyAddonFeatures": "Gestiona miembros del hogar y permisos",
    "familyAddonPurchased": "¡Complemento Familiar comprado con éxito!",
    "familyAddonTitle": "Acceso al programa familiar",
    "featureAdvancedCare": "Características completas de Care: puntos de control, ciclos de retroalimentación y soporte",
    "featureAllHeroes": "Todos los 5 héroes desbloqueados",
    "featureBasicCareer": "Oportunidades de Career y constructor de CV",
    "featureBasicCheckup": "Evaluación completa de CheckUp y resultados",
    "featureBasicPassport": "Passport: Miles, sellos, insignias Citizen y niveles",
    "featureCareer": "Oportunidades de Career, coincidencias y aplicaciones proactivas",
    "featureFullAccess": "Acceso completo a todas las funciones del viaje",
    "featureFullCheckup": "Completa CheckUp con análisis completo de MESH y puntuaciones de iQulture",
    "featureFullPassport": "Passport completo, incluido el Cronograma de tu viaje",
    "featureFullQultureup": "Completa QultureUp: todos los mundos, lecciones y contenido de creadores",
    "featureFullTeleportal": "TelePortal completo: todas las fases, validación de documentos y revisión de IA",
    "featureLimitedCopilot": "Consultas limitadas de CoPilot",
    "featureLimitedQultureup": "Misiones limitadas de QultureUp",
    "featureLimitedTeleportal": "Lista de verificación de TelePortal solamente (sin carga de documentos)",
    "featureNoExtra": "No se requiere pago adicional",
    "featurePriority": "Soporte prioritario y respuestas más rápidas",
    "featureProPeriod": "Acceso durante la duración de tu suscripción Pro",
    "featureUnlimitedCopilot": "CoPilot ilimitado (guía, cerebro y agente) — todos los modos",
    "featureEveryJourneyFull": "Acceso completo en todos los viajes que crees",
    "freePlan": "Plan gratuito",
    "freePlanDesc": "Crea tantos viajes como necesites: cada uno empieza con acceso básico a las funciones esenciales. Desbloquea un viaje o pásate a Pro para tener acceso completo.",
    "fullAccessEnabled": "Acceso completo habilitado",
    "includedInPro": "Incluido en tu plan Pro",
    "includedInSubscription": "Incluido en la suscripción Pro",
    "installmentPeriod": "Período de pago a plazos",
    "installmentPlan": "Plan de pago a plazos",
    "installments": "Pagos a plazos",
    "instantUnlock": "Desbloqueo instantáneo",
    "invoiceHistory": "Historial de facturas",
    "invoiceHistoryDesc": "Ver y descargar tus facturas",
    "journeyRenewed": "¡Viaje renovado con éxito!",
    "journeyUnlocked": "¡Viaje desbloqueado con éxito!",
    "managePaymentMethods": "Gestiona tus métodos de pago",
    "month": "mes",
    "monthly": "Mensual",
    "monthlyPayment": "Pago mensual",
    "newExpiration": "Nueva fecha de caducidad",
    "noInvoices": "Aún no hay facturas",
    "noInvoicesHint": "Las facturas aparecerán aquí después de tu primer pago",
    "noJourneyInstances": "Aún no hay viajes configurados",
    "oneTimePayment": "Pago único",
    "paymentMethods": "Métodos de pago",
    "paymentOption": "Opción de pago",
    "paymentSecurity": "Tu pago es seguro y está encriptado. Aceptamos las principales tarjetas de crédito y métodos de pago locales (SIBS para Portugal, Stripe para otros).",
    "paymentType": "Tipo de pago",
    "price": "Precio",
    "proJourney": "Plan Pro",
    "proJourneyDesc": "Acceso completo en todos los viajes que crees: todos los héroes, funciones avanzadas y soporte premium.",
    "proEndsOn": "Tu plan Pro termina el {{date}}",
    "proUnlockDesc": "Desbloquea este viaje instantáneamente con tu suscripción Pro",
    "proUnlockError": "Error al desbloquear el viaje. Por favor, inténtalo de nuevo.",
    "proUnlockSuccess": "¡Viaje desbloqueado instantáneamente con tu suscripción Pro!",
    "proceedToPayment": "Proceder al pago",
    "processing": "Procesando...",
    "purchaseFamilyAddon": "Comprar complemento familiar",
    "purchaseJourneyInstance": "Comprar instancia de viaje",
    "purchaseJourneyInstanceDesc": "Desbloquea todas las funciones de este viaje",
    "purchasedOn": "Comprado el",
    "recommended": "Recomendado",
    "removePaymentMethod": "Eliminar",
    "renewJourneyInstance": "Renovar instancia de viaje",
    "renewJourneyInstanceDesc": "Amplía tu acceso a este viaje",
    "renewNow": "Renovar ahora",
    "renewalPrice": "Precio de renovación",
    "saveYearly": "¡Ahorra {{amount}} al año!",
    "scenarioAlreadyAbroad": "Ya en el extranjero",
    "scenarioIntegrationOnly": "Integración solamente",
    "scenarioPreImmigration": "Pre-inmigración",
    "scenarioRelocationOnly": "Reubicación solo",
    "secureCheckout": "Pago seguro impulsado por Stripe",
    "selectInstallmentPeriod": "Seleccionar período de pago a plazos",
    "selectJourneyToPurchase": "Por favor, selecciona una instancia de viaje para comprar",
    "selfPaidJourneys": "Viajes pagados por uno mismo",
    "sponsoredJourneys": "Viajes patrocinados",
    "total": "Total",
    "totalAmount": "Cantidad total",
    "unlockInstant": "Desbloquear al instante",
    "unlockJourney": "Desbloquear viaje",
    "unlockNow": "Desbloquear ahora",
    "unlockedJourneys": "Viajes configurados",
    "unlockedJourneysDesc": "Todas tus instancias de viaje compradas y patrocinadas",
    "unlocking": "Desbloqueando...",
    "upfront": "Por adelantado",
    "upfrontPrice": "Pago por adelantado",
    "upgradeDescription": "Desbloquea todas las funciones y acelera tu viaje",
    "upgradeToPro": "Actualizar a Pro",
    "upgradedToPro": "¡Actualizado al plan Pro!",
    "whatYouGet": "Lo que obtienes",
    "year": "año",
    "yearly": "Anual",
    "featureMonthsAccess_one": "{{count}} mes de acceso ilimitado",
    "featureMonthsAccess_other": "{{count}} meses de acceso ilimitado",
    "coveredByPro": "Tu suscripción Pro ya cubre este viaje: desbloquéalo con Pro, sin coste adicional.",
    "renewNotRenewable": "Este viaje no se puede renovar mientras una empresa lo patrocina.",
    "paymentReference": "Ref. de pago {{reference}}",
    "refunded": "Reembolsado {{amount}}",
    "documentUnavailable": "No hemos podido abrir este documento ahora. Inténtalo de nuevo.",
    "invoicesLoadFailed": "No hemos podido cargar tus facturas."
  },
  "persona": {
    "familyMaster": {
      "badge": "Controlador",
      "controlsHousehold": "Controlas TelePortal y Care para tu hogar",
      "description": "Principal talento que controla el viaje familiar. Acceso completo a todas las funciones más responsabilidades de gestión del hogar.",
      "title": "Maestro de la familia"
    },
    "info": {
      "description": "Tu persona determina tu nivel de acceso y funciones disponibles. Puedes cambiar esto más tarde en la configuración de tu perfil si es necesario.",
      "title": "Acerca de las personas"
    },
    "loading": "Cargando...",
    "matrix": {
      "allowed": "Acceso completo",
      "billingCompanySponsored": "Facturación gestionada por la empresa patrocinadora",
      "billingDescription": "Gestión de planes y facturación",
      "billingGovernmentSponsored": "Facturación gestionada por el gobierno/programa patrocinador",
      "careDescription": "Puntos de control y apoyo post-llegada",
      "careerDescription": "Oportunidades laborales y herramientas de carrera",
      "checkupDescription": "Evaluación de preparación previa a la inmigración",
      "citizenMobile": "Citizen móvil",
      "controls": "Controles",
      "cvBuilder": "Constructor de CV",
      "cvBuilderDescription": "Generador de CV y plantillas al estilo de la UE",
      "description": "Compara el acceso a funciones entre todas las personas. Selecciona una persona para continuar.",
      "familyProgramDescription": "Gestión e invitaciones del programa familiar",
      "familyProgramViaBilling": "Disponible a través de facturación. Compra un plan para convertirte en maestro familiar y gestionarlo",
      "features": "Funciones",
      "homeDescription": "Panel de control y resumen del viaje",
      "journeyBuilder": "Constructor de viajes",
      "journeyBuilderDescription": "Configura y construye tu viaje personalizado",
      "journeyBuilderViaBilling": "Disponible después de comprar un plan a través de Facturación",
      "journeyBuilderViaBillingBecomesTalent": "Disponible a través de facturación. Después de comprar créditos/pro, se convierte en flujo de talento",
      "legend": {
        "allowed": "Acceso completo",
        "citizenMobile": "Disponible a través de la aplicación móvil Citizen",
        "controls": "Función de controles",
        "limited": "Acceso limitado (solo propio)",
        "notAllowed": "No disponible",
        "viaBilling": "Disponible a través de facturación/Actualización"
      },
      "limited": "Acceso limitado",
      "notAllowed": "No disponible",
      "passportDescription": "Línea de tiempo del viaje y logros",
      "profileDescription": "Configuraciones y preferencias del perfil",
      "qultureupDescription": "Integración cultural y aprendizaje",
      "selected": "Seleccionado",
      "teleportalDescription": "Tareas de reubicación y movilidad",
      "title": "Matriz de acceso a funciones",
      "viaBilling": "A través de facturación"
    },
    "select": "Selecciona este rol",
    "subtitle": "Elige la persona que mejor se adapte a tu rol en el viaje. Esto determinará qué funciones puedes acceder.",
    "talent": {
      "description": "Principal talento planificando un movimiento internacional de carrera. Acceso completo a todas las funciones Citizen.",
      "title": "Talento (individual)"
    },
    "talentB2B2C": {
      "badge": "Patrocinado por la empresa",
      "description": "Talento con viaje patrocinado por una empresa. Funciones de nivel Pro, sin pago requerido.",
      "title": "Talento (patrocinado por la empresa)"
    },
    "talentB2G": {
      "badge": "Patrocinado por el gobierno",
      "description": "Talento con viaje patrocinado por un programa gubernamental/público. Funciones de nivel Pro, sin pago requerido.",
      "title": "Talento (patrocinado por el gobierno)"
    },
    "title": "Selecciona tu rol en el viaje"
  },
  "preferences": {
    "title": "Preferencias"
  },
  "profile": {
    "aboutAndLegal": "Acerca de & legal",
    "aboutTonnieJourney": "Acerca de Tonnie Citizen",
    "address": "Dirección",
    "allowCohortComparisons": "Permitir comparación de empresas",
    "allowCohortComparisonsDesc": "Permite que las empresas asociadas comparen tu perfil anonimizado para obtener información sobre talentos",
    "backupCodesDesc": "Guarda estos códigos en un lugar seguro. Cada código solo se puede usar una vez para acceder a tu cuenta si pierdes tu dispositivo de autenticación.",
    "backupCodesDone": "He guardado mis códigos",
    "backupCodesTitle": "Guarda tus códigos de respaldo",
    "cantScanQr": "¿No puedes escanear? Introduce esta clave manualmente:",
    "changePhoto": "Cambiar foto",
    "photo": {
      "actionSheetTitle": "Foto de perfil",
      "takePhoto": "Tomar foto",
      "chooseFromLibrary": "Elegir de la biblioteca",
      "remove": "Eliminar foto",
      "removeConfirmTitle": "¿Eliminar foto de perfil?",
      "removeConfirmBody": "Tu foto será eliminada y se mostrarán tus iniciales en su lugar.",
      "uploadSuccess": "Foto de perfil actualizada",
      "uploadError": "No se pudo actualizar tu foto. Por favor, inténtalo de nuevo.",
      "removeSuccess": "Foto de perfil eliminada",
      "managedByTitle": "Gestionado por {{provider}}",
      "genericProvider": "tu proveedor de inicio de sesión",
      "cameraPermissionTitle": "Se necesita acceso a la cámara",
      "cameraPermissionMessage": "Para tomar una nueva foto de perfil, permite el acceso a la cámara para Tonnie en la configuración de tu dispositivo.",
      "libraryUnavailableTitle": "Biblioteca de fotos no disponible",
      "libraryUnavailableMessage": "No pudimos abrir tu biblioteca de fotos. Por favor, inténtalo de nuevo."
    },
    "completeOnWeb": "Completa el perfil en la web",
    "completeOnWebDesc": "Establece tus objetivos de movilidad y edita los detalles de tu carrera en el Portal Web de Citizen.",
    "completeProfile": "Completa tu perfil",
    "confirmDeleteAccount": "Sí, eliminar mi cuenta",
    "confirmDisable2FA": "Sí, Desactivar 2FA",
    "connectLinkedInIdentity": "Conectar LinkedIn (para identidad)",
    "contactSupport": "Ponte en contacto con nuestro equipo de soporte",
    "contactSupportButton": "Contactar soporte",
    "copyBackupCodes": "Copiar todos los códigos",
    "copyright": "© 2024 Tonnie. Todos los derechos reservados.",
    "currentRole": "Rol actual",
    "currentSession": "Sesión actual",
    "dangerZone": "Zona de peligro",
    "dataProtection": "Protección de datos",
    "dataProtectionDesc": "Tienes derecho a acceder, modificar o eliminar tus datos personales en cualquier momento. Para más información sobre cómo manejamos tus datos, por favor revisa nuestra Política de Privacidad.",
    "dateOfBirth": "Fecha de nacimiento",
    "deleteAccount": "Eliminar cuenta",
    "deleteAccountError": "No se pudo eliminar la cuenta. Por favor, inténtalo de nuevo.",
    "deleteAccountTitle": "Eliminar tu cuenta",
    "deleteAccountWarning": "Esta acción es permanente. Todos tus datos, progreso del viaje y documentos subidos serán eliminados permanentemente. Esto no se puede deshacer.",
    "description": "Gestiona tu cuenta y preferencias",
    "disable2FA": "Desactivar 2FA",
    "disable2FATitle": "Desactivar la autenticación de dos factores",
    "disable2FAWarning": "¿Estás seguro de que quieres desactivar la autenticación de dos factores? Tu cuenta será menos segura sin ella.",
    "disconnectIdentity": "Desconectar identidad",
    "educationCount": "Educación ({{count}})",
    "educationalBackground": "Formación académica",
    "email": "Correo electrónico",
    "emailNotifications": "Notificaciones por correo electrónico",
    "emailNotificationsDesc": "Recibir actualizaciones por correo electrónico",
    "enable2FA": "Habilitar 2FA",
    "enabled": "Habilitado",
    "experienceCount": "Experiencia ({{count}})",
    "feature": {
      "billingManagement": "Gestión de facturación y suscripciones",
      "careCheckpoints": "Gestión de puntos de control de Care y seguimiento del bienestar",
      "careerOpportunities": "Oportunidades de Career y constructor de CV",
      "checkupAssessments": "Evaluaciones completas de CheckUp y seguimiento de preparación",
      "familyProgram": "Gestión del programa familiar",
      "passportTimeline": "Línea de tiempo de Passport, sellos e insignias",
      "qultureupLearning": "Resúmenes de aprendizaje de QultureUp y paneles de progreso",
      "teleportalManagement": "Gestión del plan de TelePortal y coordinación de tareas"
    },
    "firstName": "Nombre",
    "firstNamePlaceholder": "Introduce el nombre",
    "fullName": "Nombre completo",
    "gdprCompliance": "Cumplimiento del GDPR",
    "gdprComplianceDesc": "Tonnie cumple con el Reglamento General de Protección de Datos (GDPR) y otras leyes de protección de datos aplicables. Puedes ejercer tus derechos contactándonos a través de la app o el sitio web.",
    "keyFeatures": "Características clave",
    "languages": "Idiomas",
    "lastName": "Apellido",
    "lastNamePlaceholder": "Introduce el apellido",
    "lastPdfUpload": "Último PDF subido: {{date}}",
    "learnMoreAboutTonnie": "Aprende más sobre Tonnie Citizen y nuestra plataforma",
    "legalInformation": "Información legal y políticas",
    "linkedInDisconnected": "LinkedIn desconectado",
    "logOut": "Cerrar sesión",
    "mobility": "Movilidad",
    "mobilityDescription": "Ciudadanía, pasaporte e intereses de reubicación",
    "needHelp": "¿Necesitas ayuda?",
    "notProvided": "—",
    "notificationSettings": "Configuración de notificaciones",
    "ongoing": "En curso",
    "personalInfo": "Información del perfil",
    "personalInfoDescription": "Actualiza tu información personal y detalles del perfil",
    "phone": "Teléfono",
    "phoneInvalidFormat": "El número de teléfono solo puede contener dígitos, espacios, guiones y +",
    "phoneNumber": "Número de teléfono",
    "phonePlaceholder": "912 345 678",
    "phoneTooShort": "El número de teléfono es demasiado corto (mínimo 6 dígitos)",
    "photoSet": "Foto establecida",
    "platformOverview": "Descripción general de la plataforma",
    "platformOverviewDescription": "Tonnie Citizen Web funciona sin problemas con Tonnie Citizen Mobile para proporcionar una experiencia de reubicación completa. La aplicación móvil es tu compañera diaria para acciones rápidas y funciones móviles, mientras que el portal web ofrece herramientas de planificación completas, evaluaciones detalladas y seguimiento del progreso.",
    "preferenceSettings": "Configuración de preferencias",
    "preferences": "Preferencias",
    "preferencesSaveError": "Error al guardar la preferencia",
    "privacyImportance": "Tu privacidad es importante para nosotros. Nuestra Política de Privacidad explica cómo recopilamos, usamos y protegemos tu información personal.",
    "privacyPolicy": "Política de privacidad",
    "privacyPolicyDesc": "Cómo manejamos y protegemos tus datos personales",
    "privacySettingUpdated": "Configuración de privacidad actualizada",
    "privacySettings": "Configuraciones de privacidad",
    "professionalWorkExperience": "Experiencia laboral profesional",
    "profile": "Perfil",
    "profilePhoto": "Foto de perfil",
    "profileUpdateFailed": "Error al actualizar el perfil. Por favor, inténtalo de nuevo.",
    "profileUpdated": "¡Perfil actualizado con éxito!",
    "pushNotifications": "Notificaciones push",
    "pushNotificationsDesc": "Recibe notificaciones en tu dispositivo",
    "readyToComplete": "¡Listo para completar tu incorporación!",
    "reviewAndComplete": "Revisa toda la información anterior y haz clic en \"Completar\" para finalizar.",
    "scanQrCode": "Escanea este código QR",
    "scanQrCodeDesc": "Usa tu aplicación de autenticación (por ejemplo, Google Authenticator, Authy) para escanear el código QR a continuación.",
    "security": "Seguridad",
    "sessionBrowserOnDevice": "{{browser}} en {{device}}",
    "settingDisabled": "{{setting}} desactivado",
    "settingEnabled": "{{setting}} activado",
    "shareAnalytics": "Compartir analíticas",
    "shareAnalyticsDesc": "Ayuda a mejorar nuestra plataforma con datos de uso anonimizados",
    "showInTalentPool": "Muéstrame en el Talent Pool",
    "showInTalentPoolDesc": "Deja que las empresas contratantes en Tonnie descubran tu perfil. Puedes darte de baja en cualquier momento.",
    "skills": "Habilidades",
    "skillsDescription": "Habilidades y experiencia profesional",
    "quietHours": "Horario de silencio",
    "quietHoursDesc": "Pausa las notificaciones push durante estas horas.",
    "quietHoursEnd": "Hasta",
    "quietHoursTimezone": "Las horas están en {{timeZone}}.",
    "quietHoursStart": "Desde",
    "termsAgreement": "Al usar Tonnie Citizen, aceptas nuestros Términos de Servicio. Por favor, revisa los términos completos para entender tus derechos y obligaciones.",
    "termsAndPrivacy": "Términos y privacidad",
    "termsOfService": "Términos de servicio",
    "termsOfServiceDesc": "Nuestros términos y condiciones para usar Tonnie Citizen",
    "title": "Perfil",
    "tonnieJourney": "Tonnie Citizen",
    "tonnieJourneyDescription": "Tonnie Citizen es tu plataforma integral para planificar y gestionar tu viaje de reubicación internacional. Realiza un seguimiento de tu progreso, accede a paneles de control detallados y coordina tu mudanza con precisión.",
    "twoFactor": {
      "backupCodesLabel": "Códigos de respaldo",
      "disableError": "Error al desactivar 2FA",
      "disabledToast": "Autenticación de dos factores desactivada",
      "enableError": "Error al iniciar la configuración de 2FA",
      "enabledToast": "Autenticación de dos factores activada",
      "copySecretKey": "Copiar clave secreta",
      "secretKeyLabel": "Clave secreta",
      "verifyError": "Código de verificación inválido. Por favor, inténtalo de nuevo."
    },
    "twoFactorAuth": "Autenticación de dos factores",
    "twoFactorAuthDesc": "Agrega una capa extra de seguridad",
    "verificationCode": "Código de verificación",
    "verify": "Verificar",
    "version": "Versión {{version}}",
    "viewPolicy": "Ver política",
    "viewTerms": "Ver términos",
    "yourRights": "Tus derechos",
    "notifCatHero": "Recorrido y progreso",
    "notifCatHeroDesc": "Novedades de CheckUp, Care, QultureUp, TelePortal y Passport.",
    "notifCatSystem": "Cuenta y sistema",
    "notifCatSystemDesc": "Seguridad, cuenta y mantenimiento de la plataforma.",
    "notifCatSocial": "Personas y empresas",
    "notifCatSocialDesc": "Invitaciones, evaluaciones, equipo y mensajes.",
    "notifCatAlert": "Alertas y recordatorios",
    "notifCatAlertDesc": "Sensibles al tiempo o al dinero: facturación, pagos y plazos.",
    "notifMatrixTitle": "Cómo te avisamos de cada novedad",
    "notifMatrixDesc": "Elige correo electrónico y push para cada tipo de novedad. Tu bandeja de entrada siempre guarda una copia.",
    "notifMatrixCategory": "Categoría",
    "notifMatrixInApp": "En la app",
    "notifMatrixEmail": "Correo electrónico",
    "notifMatrixPush": "Push",
    "notifMatrixInAppAlways": "Siempre activo: tu bandeja de entrada guarda todos los mensajes",
    "notifMatrixEmailOff": "Las Notificaciones por Correo Electrónico están desactivadas, así que ninguna categoría envía correos. Actívalas para elegir aquí.",
    "notifMatrixPushOff": "Las Notificaciones Push están desactivadas, así que ninguna categoría envía notificaciones push. Actívalas para elegir aquí.",
    "notifMatrixCell": "{{channel}} para {{category}}",
    "identitySection": "Identidad",
    "currentCountry": "País actual",
    "currentCountryPlaceholder": "Selecciona dónde vives ahora",
    "currentCity": "Ciudad actual",
    "currentCityPlaceholder": "La ciudad en la que vives ahora",
    "sections": {
      "add": "Añadir {{section}}",
      "saved": "Guardado.",
      "saveFailed": "No hemos podido guardarlo. Inténtalo de nuevo.",
      "importSaved": "Importado a tu perfil.",
      "fixErrors_one": "{{count}} campo necesita tu atención",
      "fixErrors_other": "{{count}} campos necesitan tu atención",
      "status": {
        "complete": "Completa",
        "empty": "Sin añadir"
      },
      "identity": {
        "title": "Identidad",
        "description": "Tu nombre, fecha de nacimiento, teléfono y dónde vives."
      },
      "mobility": {
        "title": "Movilidad y pasaporte",
        "description": "Tu ciudadanía, pasaporte, unidad familiar y cómo prefieres trabajar."
      },
      "skills": {
        "title": "Habilidades",
        "description": "Tu puesto, años de experiencia, idiomas y habilidades."
      },
      "education": {
        "title": "Formación",
        "description": "Tus títulos y cursos."
      },
      "experience": {
        "title": "Experiencia",
        "description": "Dónde has trabajado y qué hiciste."
      },
      "import": {
        "title": "Importar desde tu CV o LinkedIn",
        "description": "Sube un CV o un PDF de LinkedIn y rellenamos tus habilidades, formación y experiencia. Lo revisas todo antes de guardarlo.",
        "cta": "Importar CV o LinkedIn"
      }
    },
    "strengthen": {
      "title": "Refuerza tu perfil",
      "description": "Tu puntuación ya está lista. Cuéntales más sobre ti a las empresas: añade cualquiera de estos cuando quieras. Nada de esto es obligatorio."
    },
    "degreeInField": "{{degree}} en {{field}}",
    "strength": {
      "gaugeCaption": "solidez",
      "gaugeLabel": "Solidez del perfil: {{percent}} por ciento",
      "headline": "Tu perfil está completo al {{percent}} %",
      "headlineComplete": "Tu perfil está completo",
      "subline_one": "Te falta {{count}} cosa. Las marcadas abajo influyen en tu puntuación iQulture.",
      "subline_other": "Te faltan {{count}} cosas. Las marcadas abajo influyen en tu puntuación iQulture.",
      "sublineComplete": "Tu CheckUp tiene todo lo que el perfil puede darle, y las empresas lo ven todo.",
      "level": {
        "getting_started": "Empezando",
        "good": "Bien",
        "strong": "Sólido",
        "complete": "Completo"
      },
      "next": {
        "label": "Siguiente paso",
        "labelFastest": "Siguiente paso · el más rápido",
        "documentFills": "Una sola subida rellena: {{items}}",
        "documentButton": "Subir pasaporte"
      },
      "why": {
        "start": "Necesario para empezar tu CheckUp",
        "persona": "Necesario para empezar · define cómo te lee iQulture",
        "languages": "Tu nivel de inglés influye en la puntuación de Comunicación",
        "experience": "Influye en tu puntuación de Experiencia Global",
        "years": "Influye en tus puntuaciones de competencias y experiencia",
        "skills": "Influye en tu puntuación de competencias",
        "education": "Influye en tu puntuación de Preparación Académica",
        "workModel": "Influye en tu puntuación de Flexibilidad del Modelo de Trabajo",
        "passport": "Tu traslado lo necesita — TelePortal lo usa"
      },
      "readiness": {
        "startTitle": "Necesario para empezar tu CheckUp",
        "startDone": "Todo listo. Tu CheckUp puede empezar cuando quieras.",
        "scoreTitle": "Influye en tu puntuación iQulture",
        "scoreHint": "La puntuación se calcula sin esto, pero con menos información:",
        "scoreDone": "Tu puntuación tiene todo lo que el perfil puede darle.",
        "more_one": "+{{count}} más",
        "more_other": "+{{count}} más"
      },
      "tag": {
        "start": "Necesario para empezar",
        "score": "Influye en iQulture",
        "journey": "Para tu viaje"
      },
      "item": {
        "name": "Nombre completo",
        "date_of_birth": "Fecha de nacimiento",
        "phone": "Teléfono",
        "residence": "Dónde vives",
        "nationality": "Ciudadanía",
        "passport": "Pasaporte válido",
        "work_model": "Cómo te gusta trabajar",
        "current_role": "Puesto actual",
        "years_experience": "Años de experiencia",
        "skills": "Competencias",
        "languages": "Nivel de inglés",
        "education": "Un título o curso",
        "experience": "Un puesto que hayas ocupado"
      },
      "addItem": "Añadir {{item}}",
      "sectionBar": "Secciones del perfil",
      "sectionCount": "{{complete}} de {{total}}",
      "fillFaster": {
        "recommended": "Recomendado"
      },
      "missing": "Aún falta",
      "fromCareerCv": "Tu CV en Career ya le da esto a tu puntuación iQulture. Añádelo también aquí para mostrarlo en tu perfil.",
      "loadFailed": "No hemos podido cargar cuán completo está tu perfil.",
      "tiles": {
        "start": "Para empezar tu CheckUp",
        "score": "Para tu puntuación iQulture",
        "sections": "Secciones completas"
      }
    },
    "identityDocument": {
      "title": "Rellénalo con tu pasaporte o DNI",
      "subtitle": "Súbelo una vez. Lo leemos y tú confirmas.",
      "close": "Cerrar",
      "typeGroup": "Tipo de documento",
      "passport": "Mi pasaporte",
      "passportHint": "Una sola página. Rellena más datos y todo traslado lo necesita.",
      "idCard": "Mi documento de identidad",
      "idCardHint": "Anverso y reverso. Rellena tu nombre, fecha de nacimiento y nacionalidad.",
      "uploadPassport": "La página con foto de tu pasaporte",
      "uploadFront": "Anverso de tu documento de identidad",
      "uploadBack": "Reverso de tu documento de identidad",
      "uploadHint": "Una foto o un escaneo · JPG, PNG, HEIC o PDF, hasta {{size}} MB",
      "chooseFile": "Elegir archivo",
      "source": {
        "camera": "Hacer una foto",
        "library": "Elegir una foto",
        "files": "Elegir un archivo"
      },
      "cameraPermission": "Necesitamos acceso a la cámara para fotografiar tu documento. Puedes permitirlo en Ajustes.",
      "pickUnavailable": "Ahora mismo no se puede elegir un archivo.",
      "replaceFile": "Cambiar",
      "aiNotice": "Nuestro servicio de IA lee tu documento para rellenar tu perfil. No se guarda nada en tu perfil hasta que lo confirmes. El archivo se guarda en tu Bóveda y puedes eliminarlo cuando quieras.",
      "continue": "Continuar",
      "back": "Atrás",
      "cancel": "Cancelar",
      "read": "Leer documento",
      "reading": {
        "saving": "Guardando en tu Bóveda",
        "reading": "Leyendo el documento"
      },
      "review": {
        "intro": "Marca lo que quieras usar. Donde tu perfil ya dice algo distinto, queda sin marcar para que nada cambie por sorpresa.",
        "verified": "Comprobado",
        "unverified": "Leído por IA — revísalo",
        "onFile": "En tu perfil: {{value}}",
        "passportValid": "Válido hasta el {{date}}",
        "passportExpired": "Caducó el {{date}}",
        "profileYes": "Sí",
        "profileNo": "No",
        "documentNumber": "Documento terminado en {{last4}}",
        "expiredWarning": "Este pasaporte ha caducado. Usarlo registra que no tienes un pasaporte válido.",
        "save": "Guardar en mi perfil",
        "discard": "Descartar",
        "matches": "Coincide con tu perfil"
      },
      "done": {
        "title": "Tu documento ya está",
        "bodyPassport": "Guardado en tu Bóveda y volcado en tu perfil. TelePortal lo usará en las tareas de pasaporte, sin volver a subirlo.",
        "bodyIdCard": "Guardado en tu Bóveda y volcado en tu perfil.",
        "close": "Hecho"
      },
      "error": {
        "notIdentity": "Esto no parece un pasaporte ni un documento de identidad. Prueba con una foto nítida de la página con foto.",
        "unreadable": "No hemos podido leer ese archivo. Prueba con una foto más nítida o un escaneo en PDF.",
        "unsupported": "Ese tipo de archivo no es compatible. Usa JPG, PNG, HEIC o PDF.",
        "tooLarge": "Ese archivo supera los {{size}} MB. Usa una foto o un escaneo más pequeño.",
        "unavailable": "La lectura de documentos no está disponible ahora. Inténtalo de nuevo en un momento.",
        "generic": "Algo ha fallado al leer tu documento. Inténtalo de nuevo.",
        "upload": "La subida no ha terminado. Inténtalo de nuevo.",
        "save": "No hemos podido guardarlo. Inténtalo de nuevo.",
        "tryAgain": "Probar otro archivo"
      },
      "steps": {
        "document": "Documento",
        "upload": "Subida",
        "reading": "Lectura",
        "review": "Revisión"
      },
      "stepsAria": "Progreso de la subida",
      "start": "Empezar",
      "privacyTitle": "Privado por diseño.",
      "upload": {
        "title": "Añade una foto o un escaneo nítido",
        "tipFrame": "La página entera, plana y enfocada",
        "tipGlare": "Sin reflejos ni dedos sobre el texto",
        "tipMrzPassport": "Las dos líneas de código al pie de la página, completas y visibles",
        "tipMrzIdCard": "Las líneas de código del reverso, completas y visibles",
        "dropHint": "Arrastra aquí una foto o un PDF"
      },
      "readingView": {
        "title": "Leyendo tu documento",
        "subtitle": "Tarda unos segundos. Nada llega a tu perfil hasta que lo confirmes.",
        "savingCount": "Guardando en tu Vault · {{saved}} de {{total}}"
      },
      "reviewView": {
        "title": "Revisa lo que hemos leído",
        "mrzVerified": "La zona de lectura mecánica es correcta",
        "mrzUnverified": "No hemos podido comprobar una zona de lectura mecánica — revisa cada línea",
        "selected_one": "{{count}} línea para guardar",
        "selected_other": "{{count}} líneas para guardar"
      },
      "doneView": {
        "applied": "Ya en tu perfil",
        "nothingApplied": "Tu documento está en tu Vault. No ha cambiado nada en tu perfil."
      },
      "line": {
        "name": "Nombre legal, como en el documento",
        "account_name": "Usarlo como nombre de tu cuenta",
        "date_of_birth": "Fecha de nacimiento",
        "nationality": "Nacionalidad",
        "passport": "Pasaporte válido"
      },
      "legalName": {
        "label": "Nombre en tu pasaporte o DNI",
        "hint": "Leído de tu documento. Rellena los formularios en los que el documento debe coincidir; el nombre de cuenta de arriba es el que ve la gente."
      },
      "sourceShort": {
        "camera": "Cámara",
        "library": "Fotos",
        "files": "Archivos"
      },
      "slot": {
        "empty": "Aún no añadido",
        "added": "Añadido"
      }
    },
    "emailChange": {
      "sameAsCurrent": "Este ya es tu correo de acceso.",
      "taken": "Esta dirección pertenece a otra cuenta de Tonnie. Usa otra.",
      "done": "Tu correo de acceso ahora es {{email}}. Enviamos un aviso a tu dirección anterior.",
      "oldKept": "Ahora inicias sesión con {{email}}, pero {{old}} sigue en tu cuenta.",
      "oldLinked": "{{old}} sigue en tu cuenta: sigues iniciando sesión con {{provider}} a través de ella.",
      "oldLinkedOther": "{{old}} sigue en tu cuenta: un método de acceso que usas está vinculado a ella.",
      "removeOld": "Eliminar la dirección antigua",
      "sendError": "No hemos podido enviar el código ahora mismo. Inténtalo de nuevo en unos minutos.",
      "verifyError": "No hemos podido comprobar el código ahora mismo. Inténtalo de nuevo en unos minutos.",
      "switchError": "La nueva dirección está confirmada, pero no pudimos hacerla tu correo de acceso. Inténtalo de nuevo."
    },
    "review": {
      "company": {
        "children_one": "1 hijo",
        "children_other": "{{count}} hijos",
        "partner": "Pareja",
        "personalInfoDescription": "Lo que el talento compartió sobre sí",
        "pets": "Mascotas",
        "validPassport": "Pasaporte válido"
      },
      "present": "Actualidad",
      "showMore": "Ver más",
      "showLess": "Ver menos"
    },
    "ways": {
      "document": {
        "title": "Pasaporte o DNI",
        "body": "Rellena tu fecha de nacimiento, nacionalidad y pasaporte a partir de una foto.",
        "cta": "Escanear mi pasaporte"
      },
      "import": {
        "title": "PDF de LinkedIn o CV",
        "body": "Rellena tu experiencia, formación, habilidades e idiomas a partir de un PDF.",
        "cta": "Importar un PDF"
      },
      "fastest": "Lo más rápido"
    },
    "citizenshipsAdd": "Añadir ciudadanía",
    "preferencesLoadError": "No se han podido cargar tus preferencias."
  },
  "qultureup": {
    "aboutDescription": "Esta evaluación evalúa tu conocimiento sobre:",
    "aboveLevel": "Por encima del nivel",
    "achievementAdvanced": "Experto cultural",
    "achievementAdvancedDesc": "Alcanza el nivel Avanzado",
    "achievementCultureExplorer": "Explorador cultural",
    "achievementCultureExplorerDesc": "Comenzaste 2+ mundos",
    "achievementFirstMission": "Primera misión",
    "achievementFirstMissionDesc": "Has completado tu primera misión",
    "achievementStreak3": "Racha de 3 días",
    "achievementStreak3Desc": "Aprendiendo durante 3 días seguidos",
    "achievementWorldMaster": "Maestro del mundo",
    "achievementWorldMasterDesc": "Completa un mundo entero",
    "achievements": "Logros",
    "ariaWeeklyActivityChart": "Gráfico de actividad semanal",
    "assessedOn": "Evaluado el {{date}}",
    "assessment": {
      "aboutDesc": "Una breve evaluación de alineación cultural que toma alrededor de 10 minutos.",
      "completeMessage": "Tu evaluación de QultureUp está completa. Explora los mundos para seguir aprendiendo.",
      "completeTitle": "Evaluación completa",
      "description": "Responde algunas preguntas sobre tu orientación cultural para que podamos personalizar tu viaje.",
      "saving": "Guardando…",
      "subtitle": "Alrededor de 10 minutos",
      "title": "Evaluación de QultureUp"
    },
    "assessmentDescription": "Determina tu nivel de aprendizaje",
    "assessmentTitle": "Evaluación de QultureUp",
    "coPilot": "CoPilot",
    "complete": "completo",
    "completeDescription": "Tu camino de aprendizaje ha sido personalizado.",
    "completePreviousTrack": "Completa la pista anterior para desbloquear esta",
    "completePreviousWorld": "Completar mundo anterior",
    "completeTitle": "¡Evaluación completa!",
    "continue": "Continuar",
    "continueDescription": "Has comenzado tu evaluación de QultureUp. Retoma justo donde lo dejaste en Citizen Web — tus respuestas hasta ahora están guardadas.",
    "continueInApp": "Continuar en la app",
    "continueInAppButton": "Continuar en la app",
    "continueLearning": "Seguir aprendiendo",
    "continueOnWeb": "Continúa en Citizen Web",
    "continueOnWebDesc": "Retoma tu evaluación de QultureUp donde lo dejaste en el Portal Web de Citizen.",
    "continueTitle": "Continúa tu evaluación de QultureUp",
    "copilotGuideDescription": "Responde preguntas sobre tu conocimiento cultural",
    "copilotGuideTitle": "Guía de CoPilot",
    "dayStreak": "Racha de días",
    "description": "Aprende tu nueva cultura",
    "difficultyAdvanced": "Avanzado",
    "difficultyBeginner": "Principiante",
    "difficultyIntermediate": "Intermedio",
    "dimensionCulture": "Cultura y normas locales",
    "dimensionHistory": "Historia y vida cotidiana",
    "dimensionLanguage": "Realidad del idioma (nativo + inglés, y frases básicas del idioma objetivo)",
    "dimensionWorkplace": "Cultura laboral y derechos/deberes básicos",
    "error": {
      "description": "No pudimos cargar tus datos de QultureUp. Por favor, inténtalo de nuevo.",
      "retry": "Intenta de nuevo",
      "title": "Algo salió mal"
    },
    "estimatedTime": "Tiempo estimado",
    "filterAdvanced": "Avanzado",
    "filterAll": "Todos los niveles",
    "filterBeginner": "Principiante",
    "filterIntermediate": "Intermedio",
    "heroBanner": {
      "subtitle": "Domina el lado cultural de tu mudanza",
      "title": "QultureUp"
    },
    "heroMiles": "QultureUp Miles",
    "hours": "h",
    "learnOnTheGo": "Aprender en movimiento",
    "learnOnTheGoDesc": "Completa misiones, gana Miles y sigue tu progreso de aprendizaje cultural con la aplicación móvil.",
    "loadingAssessment": "Cargando evaluación…",
    "miles": "Miles",
    "minutes": "min",
    "missionDetailsInApp": "Detalles de la misión disponibles en la aplicación móvil",
    "missions": "Misiones",
    "missionsCompleted": "{{completed}} de {{total}} misiones completadas",
    "missionsCount": "{{completed}}/{{total}} misiones",
    "missionsLabel": "Misiones",
    "nextMission": "Siguiente",
    "noMissionsForLevel": "No hay misiones en este nivel para esta ruta.",
    "noTracksAvailable": "No hay rutas disponibles para este mundo aún.",
    "noUnlockedWorlds": "No hay mundos desbloqueados aún.",
    "noWorldsAvailable": "No hay mundos disponibles aún. ¡Vuelve pronto!",
    "ofTotal": "{{completed}} de {{total}}",
    "ofTotalCompleted": "{{completed}} de {{total}} completados",
    "openInApp": "Abrir en la app",
    "openTonnieCitizen": "Abrir en la app",
    "percentComplete": "{{percent}}% completo",
    "progressTitle": "Progreso de evaluación",
    "qultureupMiles": "QultureUp millas",
    "recentlyCompleted": "Recientemente completado",
    "retakeAssessment": "Repetir evaluación",
    "retakeOnWeb": "Repetir en Citizen Web",
    "retakeOnWebDesc": "Repite tu evaluación de QultureUp en el Portal Web de Citizen para actualizar tu ruta de aprendizaje personalizada.",
    "returnToDashboard": "Volver al tablero",
    "score": "Puntuación: {{score}}%",
    "start": "Comenzar",
    "startInApp": "Comenzar en la app",
    "startMission": "Comenzar misión",
    "startOnWeb": "Comienza en Citizen Web",
    "startOnWebDesc": "Completa tu evaluación de QultureUp en el Portal Web de Citizen para desbloquear tu ruta de aprendizaje personalizada.",
    "tabOverview": "Resumen",
    "tabTracksAndMissions": "Rutas y misiones",
    "tabWorlds": "Mundos",
    "thisWeek": "Esta semana",
    "timeLearning": "Tiempo de aprendizaje",
    "title": "QultureUp",
    "todaysMission": "Misión de hoy",
    "tracks": "Pistas",
    "tracksCompleted": "{{completed}} de {{total}} rutas completadas",
    "tryAgainLater": "Por favor, intenta de nuevo más tarde.",
    "unableToLoad": "No se pudo cargar los datos de QultureUp",
    "upNext": "Próximo",
    "welcome": {
      "cultureStep": "Cultura e historia",
      "cultureStepDesc": "Explora tradiciones locales, patrimonio y vida cívica",
      "description": "Descubre tu preparación cultural y desbloquea un camino de aprendizaje personalizado. Nuestra evaluación evalúa tu conocimiento en dimensiones clave de ciudadanía para guiar tu viaje de integración.",
      "languageStep": "Idioma y comunicación",
      "languageStepDesc": "Construye confianza en interacciones diarias y oficiales",
      "letsStart": "Empecemos",
      "socialStep": "Normas sociales y laborales",
      "socialStepDesc": "Entiende las costumbres cotidianas y las expectativas profesionales",
      "timeEstimate": "Toma alrededor de 5-10 minutos para completar",
      "title": "Bienvenido a QultureUp"
    },
    "world": {
      "completed": "Completado"
    },
    "worlds": "Mundos",
    "questionTier": {
      "easy": "Fácil",
      "medium": "Media",
      "hard": "Difícil"
    },
    "difficultyA11y": "Dificultad: {{level}}",
    "min_one": "{{count}} min",
    "min_other": "{{count}} min",
    "sectionsLabel_one": "{{count}} sección",
    "sectionsLabel_other": "{{count}} secciones",
    "comingSoon": {
      "body": "Estamos preparando los mundos y las misiones para {{country}}. Se abrirán aquí en cuanto estén listos.",
      "title": "QultureUp para {{country}} llega pronto"
    },
    "academy": {
      "title": "Tonnie Languages Academy",
      "poweredBy": "Con {{partner}}",
      "card": {
        "body": "Aprende inglés, portugués europeo, español o italiano con profesores en directo y estudio autónomo.",
        "cta": "Ver la Academy",
        "level": "Nivel {{band}}",
        "completion": "{{percent}} del recorrido",
        "next": "Próxima misión",
        "neverSynced": "Tu progreso aparece aquí después de tu primera visita.",
        "paused": "Progreso en pausa: consentimiento retirado",
        "goalReached": "Meta alcanzada: {{band}}"
      },
      "page": {
        "description": "Cursos de idiomas con {{partner}}, con tu cuenta de Tonnie."
      },
      "about": {
        "title": "Qué es la Academy",
        "live": "Clases en directo con profesores reales, individuales o en grupos pequeños.",
        "selfStudy": "Estudio autónomo entre clases, con ejercicios y comentarios en cada actividad.",
        "billing": "En la app de Tonnie no se vende nada: {{partner}} presenta sus planes y los cobra en su propio sitio.",
        "noPassword": "Entras en {{partner}} con tu cuenta de Tonnie, sin una contraseña nueva."
      },
      "language": {
        "title": "¿Qué idioma quieres aprender?",
        "fixedTitle": "Tu idioma en la Academy",
        "names": {
          "en": "English",
          "ptPT": "Português de Portugal",
          "es": "Español",
          "it": "Italiano"
        },
        "level": "Tu nivel en TestIt: {{level}}",
        "levelHint": "{{partner}} confirma tu punto de partida con su propia prueba de nivel.",
        "required": "Elige un idioma para abrir la Academy.",
        "fixed": "Fijo para esta escuela: {{partner}} crea tu curso en el idioma de tu primera entrada y lo mantiene."
      },
      "consent": {
        "title": "Qué comparte Tonnie con {{partner}}",
        "intro": "Para abrir la Academy con tu cuenta, Tonnie envía a {{partner}}:",
        "fields": {
          "name": "Tu nombre",
          "email": "Tu correo electrónico verificado",
          "learningLanguage": "El idioma que elijas",
          "level": "Tu nivel en TestIt en ese idioma, si lo tienes",
          "uiLanguage": "El idioma en que usas la app",
          "birthDate": "Tu fecha de nacimiento, si está en tu perfil",
          "phone": "Tu número de teléfono, si está en tu perfil",
          "nationality": "Tu nacionalidad, si está en tu perfil"
        },
        "version": "Texto del consentimiento, versión {{version}}",
        "give": "Acepto compartir estos datos con {{partner}}",
        "given": "Aceptaste el {{date}}.",
        "withdraw": "Retirar el consentimiento",
        "withdrawHint": "Una vez retirado, Tonnie no comparte nada más y {{partner}} ya no puede iniciar tu sesión desde Tonnie.",
        "outdated": "El texto del consentimiento ha cambiado. Léelo y acepta de nuevo para abrir la Academy."
      },
      "open": {
        "action": "Abrir la Academy",
        "opening": "Abriendo…",
        "hintWeb": "Se abre en una pestaña nueva.",
        "hintPhone": "Se abre en el navegador de tu móvil."
      },
      "demo": {
        "action": "Ver la Academy (demostración)",
        "note": "Una demostración del sitio de {{partner}}, sin tu cuenta de Tonnie: no se comparte nada tuyo."
      },
      "blocked": {
        "title": "Tu navegador ha bloqueado la pestaña nueva",
        "body": "Abre la Academy con el enlace de abajo: funciona durante un minuto.",
        "link": "Abrir la Academy ahora"
      },
      "unavailable": {
        "assessmentRequired": "Haz primero la evaluación de QultureUp: la Tonnie Languages Academy se abre justo después.",
        "notConfigured": "La Academy aún no está abierta aquí.",
        "partnerPending": "La Academy se abrirá en cuanto se firme el acuerdo de Tonnie con {{partner}}."
      },
      "refusal": {
        "consentRequired": "Acepta lo que se comparte antes de abrir la Academy.",
        "languageFixed": "Tu curso en {{partner}} ya es en otro idioma: es fijo para esta escuela. Abre la Academy en ese idioma.",
        "profileIncomplete": {
          "name": "{{partner}} necesita tu nombre. Añádelo a tu perfil y abre la Academy.",
          "email": "{{partner}} necesita un correo electrónico verificado. Verifica tu correo y abre la Academy.",
          "both": "{{partner}} necesita tu nombre y un correo electrónico verificado. Añádelos y abre la Academy."
        },
        "fixName": "Añadir tu nombre",
        "fixEmail": "Verificar tu correo",
        "generic": "No se ha podido abrir la Academy. Inténtalo de nuevo."
      },
      "load": {
        "error": "No se ha podido cargar la Academy."
      },
      "progress": {
        "title": "Tu progreso en la Academy",
        "neverSynced": {
          "title": "Aún sin progreso",
          "body": "Tu recorrido aparece aquí en cuanto {{partner}} envíe tu primer progreso, normalmente justo después de tu primera visita."
        },
        "paused": {
          "title": "Progreso en pausa",
          "body": "Retiraste tu consentimiento, así que {{partner}} ya no envía tu progreso. Así estaba en la última actualización."
        },
        "goalReached": {
          "title": "Meta alcanzada",
          "body": "Has alcanzado el nivel {{band}}, la meta de tu curso. Puedes seguir aprendiendo en {{partner}}."
        },
        "level": "Nivel {{band}}",
        "bandProgress": "{{percent}} del nivel {{band}}",
        "startTarget": "Empezaste en {{start}} · Meta {{target}}",
        "scale": "Nivel {{level}} de {{max}} en la escala de {{partner}}.",
        "completed": "{{completed}} de {{total}} misiones",
        "completedPercent": "{{percent}} del recorrido",
        "miles_one": "Has ganado {{count}} Mile en la Academy",
        "miles_other": "Has ganado {{count}} Miles en la Academy",
        "lastSync": "Última actualización de {{partner}}: {{date}}",
        "reduced": "Por ahora, {{partner}} envía solo tu nivel actual; estas son sus misiones. Tu progreso general es tu nivel en la escala de 0 a {{max}}.",
        "next": {
          "title": "Próxima misión",
          "in": "Nivel {{band}}"
        },
        "allDone": "Todas las misiones de tu recorrido están completadas.",
        "path": {
          "title": "Tu recorrido",
          "titlesNote": {
            "en": "Misiones en inglés, con los nombres que les da {{partner}}.",
            "ptPT": "Misiones en portugués europeo, con los nombres que les da {{partner}}.",
            "es": "Misiones en español, con los nombres que les da {{partner}}.",
            "it": "Misiones en italiano, con los nombres que les da {{partner}}."
          }
        },
        "module": {
          "band": "Nivel {{band}}",
          "current": "Estás aquí",
          "count": "{{completed}}/{{total}}"
        },
        "mission": {
          "completed": "Completada",
          "inProgress": "En curso · {{percent}}",
          "notStarted": "Sin empezar",
          "startingPoint": "Ya lo sabías",
          "startingPointHint": "Ya lo sabías cuando empezaste en la Academy: cuenta para tu recorrido y no da Miles.",
          "miles_one": "+{{count}} Mile",
          "miles_other": "+{{count}} Miles",
          "capped": "Límite diario de Miles"
        },
        "milestones": {
          "title": "Hitos",
          "band": "Nivel {{band}} alcanzado",
          "goal": "Meta alcanzada"
        },
        "retired": {
          "title": "Completadas antes",
          "body": "Misiones que completaste y que ya no forman parte de tu recorrido."
        }
      }
    }
  },
  "settings": {
    "about": {
      "title": "Acerca de"
    },
    "billing": "Facturación",
    "dark": "Oscuro",
    "deleteAccount": "Eliminar cuenta",
    "deleteAccountConfirm": "Esto eliminará permanentemente tu cuenta y todos los datos. Esto no se puede deshacer.",
    "deleteAccountFailed": "No se pudo eliminar la cuenta. Por favor, inténtalo de nuevo.",
    "freePlan": "Plan gratuito",
    "language": {
      "title": "Idioma"
    },
    "light": "Ligero",
    "myCheckups": "Mis CheckUps",
    "myFamily": "Mi familia",
    "myJourneys": "Mis viajes",
    "preferences": "Preferencias",
    "profile": "Perfil",
    "security": "Seguridad",
    "sendFeedback": "Enviar comentarios",
    "signOut": "Cerrar sesión",
    "signOutConfirm": "¿Estás seguro de que quieres cerrar sesión?",
    "termsPrivacy": "Términos y privacidad",
    "theme": {
      "title": "Tema"
    },
    "themeSystem": "Sistema ({{mode}})",
    "title": "Configuraciones",
    "sessions": {
      "notFound": "Sesión no encontrada",
      "signedOut": "Sesión cerrada",
      "signOutFailed": "Error al cerrar sesión",
      "loadFailed": "Error al cargar sesiones"
    },
    "preferencesLanguageFallback": "Inglés",
    "membersCount_one": "{{count}} miembro",
    "membersCount_other": "{{count}} miembros",
    "groups": {
      "journey": "Tu viaje",
      "app": "Aplicación",
      "help": "Ayuda e información legal"
    },
    "profileStrength": "Perfil: {{level}} · {{percent}}",
    "pro": "Pro",
    "inout": "InOut — días fuera",
    "inoutPaused": "En pausa",
    "inoutNotStarted": "Sin empezar",
    "myDocuments": "Mis documentos"
  },
  "splash": {
    "authenticateToContinue": "Autenticar para continuar",
    "biometricFailed": "La autenticación biométrica ha fallado",
    "tryAgain": "Intenta de nuevo",
    "unlockPrompt": "Desbloquear Tonnie Citizen",
    "usePasswordInstead": "Usar contraseña en su lugar"
  },
  "sponsorship": {
    "companySponsored": "Patrocinado por la empresa",
    "familySponsored": "Patrocinado por la familia",
    "governmentSponsored": "Patrocinado por el gobierno",
    "selfPaid": "Pagado por Uno Mismo"
  },
  "stepper": {
    "care": "Care",
    "checkup": "CheckUp",
    "passport": "Passport",
    "qultureup": "QultureUp",
    "start": "Comenzar",
    "teleportal": "TelePortal"
  },
  "tabs": {
    "care": "Care",
    "home": "Inicio",
    "passport": "Passport",
    "qultureup": "QultureUp",
    "teleportal": "TelePortal",
    "inout": "InOut"
  },
  "teleportal": {
    "aboutDescription": "Esta evaluación nos ayuda a entender sus necesidades de reubicación:",
    "aboutTitle": "Acerca de esta evaluación",
    "addNote": "Agregar nota",
    "agentDate": "Fecha",
    "agentHistory": "Historial de interacción con el agente",
    "agentHistoryDescription": "Ver interacciones pasadas con el Agente Consultor de TelePortal",
    "agentInteraction": "Interacción",
    "agentSummary": "Resumen",
    "all": "Todo",
    "allScope": "Todos los miembros",
    "allStatus": "Todo estado",
    "allTracks": "Todas las rutas",
    "applicationPackages": "Paquetes de solicitud",
    "applicationPackagesDescription": "Ver sus paquetes de documentos organizados",
    "askCoPilot": "Pregunta a CoPilot sobre esta tarea",
    "assessment": {
      "destination": "Destino",
      "education": "Educación",
      "educationBachelor": "Título de grado",
      "educationHighSchool": "Escuela secundaria",
      "educationMaster": "Título de máster",
      "educationPhd": "PhD / Doctorado",
      "educationVocational": "Vocacional / Técnico",
      "experience": "Experiencia",
      "experience0to2": "0-2 años",
      "experience10Plus": "Más de 10 años",
      "experience3to5": "3-5 años",
      "experience6to10": "6-10 años",
      "infoDestination": "Preferencias de país de destino",
      "infoPurpose": "Propósito de reubicación",
      "infoQualifications": "Evaluación de calificaciones",
      "infoTimeline": "Cronograma y urgencia",
      "purpose": "Propósito",
      "purposeEntrepreneur": "Iniciar un negocio",
      "purposeFamily": "Reunificación familiar",
      "purposeRetire": "Jubilación",
      "purposeStudy": "Estudio / Educación",
      "purposeWork": "Empleo / Trabajo",
      "questionDestination": "¿Qué país está usted apuntando para la reubicación?",
      "questionEducation": "¿Cuál es su nivel más alto de educación?",
      "questionExperience": "¿Cuántos años de experiencia profesional tiene?",
      "questionPurpose": "¿Cuál es su propósito principal para reubicarse?",
      "questionTimeline": "¿Cuándo planea reubicarse?",
      "timeline": "Cronograma",
      "timeline1Year": "Dentro de 1 año",
      "timeline3Months": "Dentro de 3 meses",
      "timeline6Months": "Dentro de 6 meses",
      "timelineAsap": "Lo antes posible",
      "timelineExploring": "Solo explorando"
    },
    "assessmentCompleteMessage": "Hemos analizado su perfil e identificado posibles vías de visa para su destino objetivo.",
    "assessmentDescription": "Configure su viaje de reubicación",
    "assessmentTitle": "Evaluación de TelePortal",
    "associatedWithTasks": "Asociado con tareas",
    "attachExistingDocument": "Adjuntar documento existente",
    "backToDashboard": "Volver al tablero",
    "blocked": "Bloqueado",
    "blockedBy": "Bloqueado Por",
    "blocking": "Bloqueando",
    "blockingOnly": "Bloqueando solo tareas",
    "brain": {
      "error": "Algo salió mal al construir su kit. Por favor, inténtelo de nuevo en un momento.",
      "destinationNotSupported": "Todavía no podemos crear un kit de traslado para este destino. Su trayecto está guardado: TelePortal se abrirá aquí en cuanto este destino esté disponible.",
      "phase1": "Analizando tu perfil",
      "phase2": "Mapeando documentos requeridos",
      "phase3": "Construyendo lista de tareas",
      "phase4": "Personalizando hitos",
      "phase5": "Finalizando tu kit",
      "ready": "Tu kit está listo",
      "reviewKit": "Revisa tu kit",
      "stat": {
        "docsNeeded": "Documentos necesarios",
        "fromVault": "Desde tu bóveda",
        "members": "Miembros",
        "tasks": "Tareas"
      },
      "subtitle": "Construyendo tu kit de reubicación personalizado",
      "title": "Cerebro TelePortal",
      "complexity": {
        "simple": "Simple",
        "standard": "Estándar",
        "complex": "Complejo"
      }
    },
    "captureMobile": "Captura en móvil",
    "certificationLabel": "Certificación",
    "certificationRequired": "{{type}}",
    "clearFilters": "Borrar filtros",
    "clickToUpload": "Haz clic para subir o arrastra y suelta",
    "collapseDetails": "Colapsar detalles",
    "comingSoon": "Próximamente",
    "companionCareerProgress": "Progreso del compañero Career",
    "companionEmploymentReadiness": "Evaluación de preparación laboral del acompañante",
    "companionIntegrationSupport": "Hitos de apoyo a la adaptación del acompañante",
    "companionProgram": "Programa del acompañante",
    "companionProgramDesc": "Reducción de riesgos para hogares de doble carrera — rastrea la preparación laboral y el apoyo a la integración del acompañante",
    "complete": "Completo",
    "completeInMobile": "Completo en móvil",
    "completeTasksOnMobile": "Completar tareas en móvil",
    "completeTitle": "¡Evaluación completa!",
    "completed": "Completado",
    "completedDate": "Completado {{date}}",
    "completedSection": "Completado",
    "completionNotesPlaceholder": "Agregar notas de finalización (opcional)...",
    "complexity": {
      "complex": "Complejo",
      "simple": "Simple",
      "standard": "Estándar"
    },
    "consultantAgent": "Agente consultor TelePortal",
    "consultantAgentDesc": "Obtén orientación experta de nuestros consultores de inmigración",
    "consultantAgentDescription": "Obtén ayuda con tus documentos y tareas de TelePortal",
    "consultantAgentHelp": "El Agente Consultor puede ayudarte a validar, organizar y adjuntar documentos automáticamente",
    "continue": {
      "description": "Has comenzado tu configuración de TelePortal. Retoma justo donde lo dejaste en Citizen Web — tus respuestas hasta ahora están guardadas.",
      "title": "Continúa tu configuración de TelePortal"
    },
    "continueOnWeb": "Continúa en Citizen Web",
    "continueOnWebDesc": "Retoma tu configuración de TelePortal donde lo dejaste en el Portal Web de Citizen.",
    "copilotGuideDescription": "Responde preguntas sobre tus necesidades de reubicación",
    "copilotGuideTitle": "Guía de CoPilot",
    "couldNotLoad": "No pudimos cargar tus datos de TelePortal. Por favor, inténtalo de nuevo.",
    "createApplicationPackage": "Crear paquete de solicitud",
    "createApplicationPackageDesc": "Prepara y organiza todos tus documentos de solicitud",
    "createApplicationPackageDescription": "Agrupa múltiples documentos para solicitudes de visa y otras presentaciones",
    "createInMobile": "Crear en móvil",
    "criticalTasks": "Tareas críticas",
    "currentProofDocuments": "Documentos de prueba actuales",
    "currentlyInProgress": "Actualmente en progreso",
    "daysLeft": "Quedan {{count}}d",
    "deleteDocumentDescription": "Esta acción no se puede deshacer. El documento será eliminado permanentemente.",
    "deleteDocumentTitle": "¿Eliminar documento?",
    "dependencies": {
      "allTracks": "Todas las rutas",
      "blockedBy": "Bloqueado por",
      "blocking": "Bloqueando",
      "blocks": "Bloqueos",
      "connectedTasks": "tareas conectadas",
      "criticalPath": "Ruta crítica",
      "dependsOn": "Depende de",
      "description": "Visualiza cómo las tareas dependen unas de otras a través de las rutas",
      "empty": "No hay dependencias de tareas para mostrar",
      "emptyHint": "Las dependencias aparecerán cuando tu kit de reubicación tenga tareas vinculadas",
      "enterFullscreen": "Entrar en pantalla completa",
      "exitFullscreen": "Salir de pantalla completa",
      "filterByTrack": "Filtrar por ruta",
      "graphLabel": "Gráfico de dependencia de tareas",
      "graphView": "Vista de gráfico",
      "independentTasks": "tareas independientes",
      "insightBanner": "Perspectiva de dependencia",
      "listView": "Vista de lista",
      "members": "Miembros",
      "resetView": "Restablecer vista",
      "shared": "Compartido",
      "tabTitle": "Dependencias",
      "title": "Gráfico de dependencia de tareas",
      "zoomIn": "Acercar",
      "zoomOut": "Alejar"
    },
    "dependenciesResolved": "Dependencias (resueltas)",
    "description": "Descripción",
    "dimensionFamily": "Configuración familiar",
    "dimensionStatus": "Estado actual",
    "dimensionTimeline": "Cronograma y plazos",
    "dimensionVisa": "Tipo de visa y requisitos",
    "docDetail": {
      "actions": "Acciones",
      "certification": "Certificación",
      "certificationNone": "No requerido",
      "certificationRequired": "Requerido ({{type}})",
      "expired": "Caducado",
      "expiryDate": "Fecha de caducidad",
      "issuingAuthority": "Autoridad emisora",
      "location": "Ubicación",
      "locationHomeCountry": "País de origen",
      "locationOnline": "En Línea",
      "locationTargetCountry": "País objetivo",
      "noExpiry": "Sin fecha de caducidad",
      "status": "Estado",
      "title": "Detalles del documento",
      "type": "Tipo de documento",
      "upload": "Subir documento",
      "uploadedAt": "Subido",
      "validityPeriod": "Período de validez",
      "view": "Ver documento",
      "viewFailed": "Error al abrir el documento",
      "openWith": "Abrir documento con…",
      "expiresIn_one": "Caduca en {{count}} día",
      "expiresIn_other": "Caduca en {{count}} días",
      "validFor_one": "Válido por {{count}} día",
      "validFor_other": "Válido por {{count}} días"
    },
    "docEmployment": "Contrato de trabajo",
    "docIncome": "Prueba de ingresos",
    "docInsurance": "Seguro de salud",
    "docNeedsReview": "El documento necesita revisión — el formato puede no ser óptimo",
    "docNotUploaded": "Documento aún no subido",
    "docPassport": "Passport",
    "docStatusMissing": "Faltante",
    "docStatusPending": "Pendiente",
    "docStatusRejected": "Rechazado",
    "docStatusUploaded": "Subido",
    "docStatusVerified": "Verificado",
    "docSuggestion1": "Asegúrese de que el documento sea claro y legible",
    "docSuggestion2": "Verifique la fecha de caducidad",
    "docTypeEducation": "Educación",
    "docTypeFinancial": "Financiero",
    "docTypeHousing": "Vivienda",
    "docTypeIdentity": "Identidad",
    "docTypeLegal": "Legal",
    "docTypeOther": "Otro",
    "docTypeTravel": "Viajar",
    "docUploadedPendingValidation": "Documento subido, pendiente de validación",
    "docValid": "Documento verificado y válido",
    "document": {
      "apostille": "Apostilla requerida",
      "certification": "Certificación",
      "certificationRequired": "Certificación requerida",
      "docExpired": "Este documento ha caducado",
      "docExpiring": "Este documento caduca en {{days}} días",
      "expired": "Caducado",
      "expiresIn": "Caduca en {{days}} días",
      "expiresSoon": "Caduca pronto",
      "haia": "Apostilla de la haya",
      "validFor": "Válido por {{duration}}"
    },
    "documentDeleted": "Documento eliminado",
    "documentDownloaded": "Documento descargado",
    "documentName": "Nombre del documento",
    "documentNamePlaceholder": "p. ej., Passport, Certificado de Nacimiento...",
    "documentType": "Tipo de documento",
    "documentUploadError": "Error al subir el documento. Por favor, inténtelo de nuevo.",
    "documentUploadRequired": "Se requiere subir documento",
    "documentUploadedSuccess": "Documento subido con éxito",
    "documentValidatedSuccess": "Documento validado con éxito",
    "documentValidationError": "Error al validar el documento. Por favor, inténtelo de nuevo.",
    "documents": "documentos",
    "documentsDescription": "Suba y verifique los documentos requeridos para su solicitud de visa y reubicación.",
    "documentsGathered": "Documentos reunidos",
    "documentsReady": "Documentos listos",
    "documentsStatus": "Estado de los documentos",
    "documentsUploaded": "Documentos subidos con éxito",
    "done": "Hecho",
    "dueDate": "Fecha de vencimiento",
    "dueToday": "Vence hoy",
    "dueTomorrow": "Vence mañana",
    "editNote": "Editar nota",
    "editTask": "Editar tarea",
    "employerFull": "Sí, patrocinio completo",
    "employerNA": "No aplicable",
    "employerNone": "No, auto-patrocinado",
    "employerPartial": "Sí, apoyo parcial",
    "entireFamily": "Toda la familia",
    "estimatedDuration": "Duración estimada",
    "estimatedTime": "Tiempo estimado",
    "eventTargetArrival": "Llegada prevista",
    "eventVisaDecision": "Decisión de visa",
    "eventVisaInterview": "Entrevista de visa",
    "expandDetails": "Expandir detalles",
    "expired": "Caducado",
    "expiredCount": "Caducado",
    "expiresInDays": "Caduca en {{count}}d",
    "downloadAllDocuments": "Descargar todo ({{count}})",
    "downloadSelectedDocuments": "Descargar {{count}}",
    "selectDocument": "Seleccionar documento",
    "expiresOn": "Caduca: {{date}}",
    "expiringSoon": "Caducando pronto",
    "explainTask": "Explicar tarea",
    "family": "Familia",
    "familyBoth": "Con pareja e hijos",
    "familyChildren": "Con hijos",
    "familyConfig": {
      "applicableTracks": "Rutas aplicables",
      "childNumber": "Hijo {{number}}",
      "companion": "Acompañante",
      "configureTracksDescription": "Selecciona qué rutas (Legal, Viaje, Configuración) aplican a cada miembro de la familia",
      "configureTracksTitle": "Configurar rutas para cada miembro",
      "dependent": "Dependiente",
      "description": "Configura el acceso a las rutas para cada miembro de la familia, mascota, acompañante o dependiente",
      "familyMember": "Miembro de la familia",
      "justMe": "Solo yo",
      "legal": "Legal",
      "mainQuestion": "¿Te mudarás con miembros de la familia?",
      "partnerSpouse": "Pareja/Cónyuge",
      "pet": "Mascota",
      "pets": "Mascotas",
      "setup": "Configuración",
      "travel": "Viajar",
      "yesBringingFamily": "Sí, trayendo a la familia",
      "membersConfigured_one": "{{count}} miembro configurado",
      "membersConfigured_other": "{{count}} miembros configurados"
    },
    "familyJustMe": "Solo yo",
    "familyMasterOnly": "Solo el Maestro de la Familia puede modificar las tareas de TelePortal",
    "familyMasterOnlyDesc": "Solo el Maestro de la Familia puede iniciar o controlar la evaluación y tareas de TelePortal. Contacta a tu Maestro de la Familia para obtener ayuda.",
    "familyPartner": "Con pareja/cónyuge",
    "filter": {
      "allExpiry": "Todas las caducidades",
      "clearAll": "Limpiar",
      "expired": "Caducado",
      "expiringSoon": "Caducando pronto",
      "location": "Ubicación",
      "locationAll": "Todas las ubicaciones",
      "locationHome": "País de origen",
      "locationOnline": "En Línea",
      "locationTarget": "País objetivo",
      "member": "Miembro",
      "memberAll": "Todos los miembros",
      "selectMember": "Seleccionar miembro",
      "sort": "Ordenar",
      "sortDefault": "Predeterminado",
      "sortDueDate": "Fecha de vencimiento",
      "sortPriority": "Prioridad",
      "valid": "Válido"
    },
    "ganttView": "Vista de Gantt",
    "generatingChecklist": "Generando tu lista de verificación personalizada...",
    "goToJourneyBuilder": "Ir al constructor de viajes",
    "groupBy": {
      "byTrack": "Por pista",
      "label": "Agrupar por",
      "location": "Agrupar por ubicación"
    },
    "guideSetupSubtitle": "Te guiaremos a través de la configuración: responde algunas preguntas y construiremos tu kit.",
    "heroBanner": {
      "complete": "Completo",
      "documents": "Documentos",
      "household": "Hogar",
      "milestones": "Hitos",
      "subtitle": "Tu centro de mando para la reubicación",
      "tasks": "Tareas",
      "title": "TelePortal"
    },
    "heroMiles": "TelePortal Miles",
    "highPriority": "Alta prioridad",
    "household": {
      "everyone": "Todos",
      "bar": {
        "allMembers": "Todos los miembros",
        "filterBy": "Filtrar por miembro",
        "filterByMember": "Filtrar por miembro"
      },
      "petSpecies": {
        "cat": "Gato",
        "dog": "Perro",
        "other": "Otro"
      },
      "schoolStages": {
        "higher": "Educación superior",
        "pre_school": "Preescolar",
        "primary": "Escuela primaria",
        "secondary": "Escuela secundaria"
      },
      "talent": "Tú"
    },
    "householdAware": "Consciente del hogar",
    "householdMembers": "Miembros del hogar",
    "inProgressSection": "En progreso",
    "keyDates": "Fechas clave",
    "kit": {
      "activate": "Activar kit",
      "activateModified": "Activar kit modificado",
      "buildFailed": "No se pudo construir tu kit",
      "buildFailedHint": "Intenta de nuevo o contacta con soporte si esto persiste.",
      "byMember": "Por miembro",
      "byTrack": "Por pista",
      "complexity": {
        "complex": "Complejo",
        "simple": "Simple",
        "standard": "Estándar"
      },
      "defaultMember": "Tú",
      "dependencyWarning": "Algunas tareas dependen de otras. Eliminar una puede bloquear el trabajo posterior.",
      "docs": "Documentos",
      "docsLinked": "Desde vault",
      "docsNeeded": "Docs necesarios",
      "editHint": "Haz clic en cualquier tarea para editar, eliminar o reordenar.",
      "loading": "Cargando kit…",
      "members": "Miembros",
      "miles": "Miles",
      "modified": "Modificado",
      "rebuild": "Reconstruir",
      "rebuildConfirm": "Reconstruir kit",
      "rebuildConfirmDesc": "Reconstruir creará un nuevo kit basado en tu perfil más reciente. Las modificaciones que hiciste se perderán.",
      "rebuildConfirmTitle": "¿Reconstruir tu kit?",
      "removeTask": "Eliminar tarea",
      "removedTasks": "Tareas eliminadas",
      "required": "Requerido",
      "requiredTask": "Tarea requerida",
      "restore": "Restaurar",
      "retry": "Reintentar",
      "tasks": "Tareas",
      "title": "Tu kit de TelePortal",
      "vaultLinked": "Vinculado desde vault",
      "taskCount_one": "{{count}} tarea",
      "taskCount_other": "{{count}} tareas",
      "milestoneCount_one": "{{count}} hito",
      "milestoneCount_other": "{{count}} hitos"
    },
    "location": {
      "all": "Todo",
      "either": "Cualquier país",
      "filter": "Ubicación",
      "filterLabel": "Ubicación",
      "homeCountry": "País de origen",
      "online": "En Línea",
      "other": "Otro",
      "targetCountry": "País objetivo"
    },
    "locationEither": "Cualquiera",
    "locationHome": "Hogar",
    "locationOnline": "En Línea",
    "locationTarget": "Objetivo",
    "manageJourney": "Planifica tu reubicación",
    "markAsDone": "Marcar como hecho",
    "markComplete": "Marcar completo",
    "milesEarned": "+{{miles}} Miles de Viaje ganadas",
    "milestoneArrivalPlanning": "Planificación de llegada",
    "milestoneDocumentCollection": "Recopilación de documentos",
    "milestoneEssentialServices": "Servicios esenciales",
    "milestoneFinancialSetup": "Configuración financiera",
    "milestoneHousing": "Vivienda",
    "milestoneTravelBooking": "Reserva de viaje",
    "milestoneVisaApplication": "Solicitud de visa",
    "milestones": {
      "admin_complete": "Administración completa",
      "arrived_in_destination": "Llegado a destino",
      "arrived_in_portugal": "Llegado a Portugal",
      "documents_gathered": "Documentos reunidos",
      "documents_legalized": "Documentos legalizados",
      "fully_settled": "Totalmente establecido",
      "housing_secured": "Vivienda asegurada",
      "legal_registration_complete": "Registro legal completo",
      "travel_booked": "Viaje reservado",
      "visa_approved": "Visa aprobada"
    },
    "milestonesCount": "{{completed}}/{{total}} hitos",
    "milestonesLabel": "Hitos",
    "missing": "Faltante",
    "mobileAppDescription": "Utiliza la aplicación móvil para subir documentos, completar tareas y obtener orientación en tiempo real del Agente Consultor de TelePortal.",
    "needHelp": "¿Necesitas ayuda?",
    "needsAttention": "Necesita atención",
    "noAgentHistory": "No hay interacciones con agentes aún",
    "noAgentHistoryDescription": "Utiliza el Agente Consultor de TelePortal en la aplicación móvil para obtener ayuda con documentos",
    "noDocumentsAttached": "No se han adjuntado documentos aún",
    "noDocumentsInTrack": "No hay documentos en esta pista aún",
    "noDocumentsUploaded": "No se han subido documentos aún",
    "noJourneySelected": "No hay viaje seleccionado",
    "noJourneySelectedDesc": "Selecciona un viaje para ver tus tareas y progreso de TelePortal",
    "noMilestonesYet": "No hay hitos aún",
    "noPackages": "No se han creado paquetes de solicitud aún",
    "noPackagesDescription": "Crea paquetes en la aplicación móvil para organizar documentos para envíos",
    "noProofAttached": "No hay documento de prueba adjunto aún",
    "noTasksAnyTrack": "No hay tareas disponibles en ninguna pista aún",
    "noTasksFoundForFilter": "No se encontraron tareas para el filtro seleccionado",
    "noTasksInProgress": "No hay tareas actualmente en progreso",
    "noTasksInTrack": "No hay tareas disponibles en esta pista aún",
    "noTasksMatchingFilters": "No hay tareas que coincidan con tus filtros actuales",
    "notePlaceholder": "Añade tus notas aquí...",
    "noteSaved": "Nota guardada",
    "notes": "Notas",
    "openInApp": "Abrir en la app",
    "openInMobile": "Abrir en móvil",
    "openTonnieCitizen": "Abrir en la app",
    "openingDocument": "Abriendo documento...",
    "orDragAndDrop": "PDF, JPG, PNG hasta 10MB",
    "orUploadNewProof": "O subir nuevo documento de prueba",
    "otherDocuments": "Otros documentos",
    "overallProgress": "Progreso general",
    "overdue": "Atrasado",
    "packageCreated": "Creado",
    "packageDocuments": "Documentos",
    "packageDownload": "Descargar paquete",
    "packageName": "Nombre del paquete",
    "packagePurpose": "Propósito",
    "pending": "Pendiente",
    "pendingReview": "Revisión pendiente",
    "preparingSetup": "Preparando configuración…",
    "priorityBlockedTasks": "Tareas prioritarias y bloqueadas",
    "priorityTasksRequiringAttention": "Tareas prioritarias que requieren atención",
    "proOnly": "Solo Pro",
    "processing": "Procesando...",
    "progress": "Progreso",
    "progressComplete": "{{percent}}% completo",
    "progressSummary": "Estás {{progress}}% a través de tu viaje de reubicación. {{attention}} tareas necesitan tu atención.",
    "progressTitle": "Progreso de evaluación",
    "proof": "Prueba",
    "proofOfDone": "Prueba de completado",
    "proofOfDoneDescription": "Adjunta un documento como prueba de que esta tarea ha sido completada",
    "proofRequired": "Esta tarea requiere prueba de finalización. Por favor, adjunta un documento.",
    "questionCurrentStatus": "¿Cuál es tu estado actual?",
    "questionEmployerSupport": "¿Tienes apoyo o patrocinio del empleador?",
    "questionFamily": "¿Te mudarás con miembros de la familia?",
    "questionTargetDate": "¿Cuál es tu fecha de mudanza objetivo?",
    "questionTargetDateFormatted": "¿Cuál es tu fecha de mudanza objetivo? (MM/YYYY)",
    "questionVisaType": "¿Qué tipo de visa o ruta de reubicación estás planeando?",
    "readOnly": "Vista de solo lectura",
    "readOnlyDescription": "Las tareas se pueden completar en la aplicación móvil",
    "redirectingIn": "Redirigiendo...",
    "rejected": "Rechazado",
    "required": "Requerido",
    "requiredDocuments": "Documentos requeridos",
    "requiredForTask": "Requerido para",
    "requiresProof": "Requiere prueba",
    "resolveNow": "Resolver ahora",
    "retakeOnWeb": "Repetir configuración en Citizen Web",
    "retakeOnWebDesc": "Repite el asistente de configuración de TelePortal en el Portal Web de Citizen para actualizar tu plan de reubicación personalizado.",
    "retakeSetup": {
      "label": "Rehacer configuración",
      "acknowledge": "Entiendo",
      "cleanDocs": "Eliminar documentos vinculados",
      "cleanTasks": "Eliminar tareas modificadas",
      "confirmReset": "Restablecer y reconstruir",
      "preFilled": "Sus respuestas anteriores están pre-rellenadas. Actualice lo que ha cambiado.",
      "rebuildTasks": "Reconstruir lista de tareas"
    },
    "returnToDashboard": "Volver al tablero",
    "saveNote": "Guardar nota",
    "searchTasks": "Buscar tareas...",
    "selectDocumentType": "Seleccionar tipo...",
    "selected": "Seleccionado",
    "setup": {
      "dimensions": {
        "household": {
          "addMember": "Agregar miembro del hogar",
          "memberTypes": {
            "child": "Niño",
            "extended_family": "Familia extendida",
            "partner": "Pareja / Cónyuge",
            "pet": "Mascota",
            "talent": "Solicitante principal (usted)"
          },
          "subtitle": "¿Quién se está reubicando con usted?",
          "title": "Su hogar"
        },
        "housing": {
          "plans": {
            "buy": "Comprar una propiedad",
            "company_provided": "Vivienda proporcionada por la empresa",
            "rent": "Alquilar un apartamento",
            "temporary": "Alojamiento temporal primero"
          },
          "subtitle": "¿Dónde vivirá?",
          "title": "Plan de vivienda"
        },
        "legalStatus": {
          "currentStatus": "Estado migratorio actual",
          "subtitle": "Su situación legal actual",
          "title": "Estado legal y migratorio",
          "visaType": "Tipo de visa"
        },
        "professional": {
          "sponsorshipTypes": {
            "company_sponsored": "Patrocinado por la empresa",
            "freelancer": "Freelancer / Nómada digital",
            "intra_company": "Transferencia dentro de la empresa",
            "job_seeker": "Buscador de empleo",
            "other": "Otro",
            "retired": "Jubilado",
            "self_employed": "Autónomo",
            "startup": "Iniciar un negocio",
            "student": "Estudiante"
          },
          "subtitle": "Su situación laboral",
          "title": "Contexto profesional"
        },
        "specialCircumstances": {
          "freeTextPlaceholder": "Cuéntanos cualquier otra cosa...",
          "options": {
            "custody_arrangement": "Acuerdo de custodia",
            "dietary_needs": "Necesidades dietéticas especiales",
            "disability_accommodation": "Alojamiento para discapacidad",
            "medical_needs": "Necesidades médicas o tratamiento continuo",
            "military_service": "Obligaciones de servicio militar",
            "pending_legal": "Asuntos legales pendientes",
            "religious_requirements": "Requisitos religiosos"
          },
          "subtitle": "¿Hay algo más que debamos saber?",
          "title": "Circunstancias especiales"
        },
        "timeline": {
          "subtitle": "¿Cuándo necesita reubicarse?",
          "title": "Cronograma",
          "urgencies": {
            "flexible": "Flexible / Sin prisa",
            "immediate": "Inmediatamente (dentro de 1 mes)",
            "within_3_months": "Dentro de 3 meses",
            "within_6_months": "Dentro de 6 meses"
          }
        },
        "travel": {
          "modes": {
            "already_there": "Ya en el destino",
            "one_way": "Viaje de ida",
            "round_trip": "Viaje de ida y vuelta (regresando primero)"
          },
          "subtitle": "¿Cómo y cuándo viajará?",
          "title": "Logística de viaje"
        },
        "vaultScan": {
          "linked": "Vinculado desde vault",
          "outdated": "Necesita actualización",
          "skip": "Omitir por ahora",
          "subtitle": "Verifiquemos qué documentos ya tiene",
          "title": "Escaneo de documentos"
        }
      },
      "processing": {
        "subtitle": "Tonnie está analizando tu situación y creando un plan personalizado...",
        "title": "Construyendo su kit de reubicación"
      },
      "refresh": {
        "button": "Actualizar mi kit de reubicación",
        "cancel": "Cancelar",
        "confirm": "Actualizar",
        "confirmMessage": "Sus tareas completadas serán preservadas. Se pueden agregar nuevas tareas y algunas pueden ser archivadas.",
        "confirmTitle": "¿Actualizar kit de reubicación?"
      },
      "subtitle": "Personalicemos su plan de reubicación",
      "summary": {
        "beginJourney": "Comenzar mi viaje",
        "complexityLabel": "Complejidad",
        "documentsLabel": "Documentos necesarios",
        "householdLabel": "Miembros del hogar",
        "tasksLabel": "Total de tareas",
        "title": "Tu kit de reubicación",
        "tracksLabel": "Pistas"
      },
      "title": "Construye tu kit de reubicación",
      "welcome": {
        "prePopulated": "Hemos prellenado información de tu perfil",
        "subtitle": "Construiremos un Kit de Reubicación personalizado basado en tu situación",
        "title": "Bienvenido a la configuración de TelePortal"
      },
      "aria": {
        "collapsePanel": "Colapsar panel",
        "pinPanel": "Fijar panel",
        "unpinPanel": "Desfijar panel"
      }
    },
    "setupActivateError": "Error al activar el kit",
    "setupActivatingMessage": "Activando tu kit — esto toma solo un momento.",
    "setupActivatingTitle": "Activando…",
    "setupComplete": "Configuración completa",
    "setupCompletedOn": "Configuración completada el {{date}}",
    "setupConfigError": "No pudimos cargar tu configuración de instalación",
    "setupError": "Error de configuración",
    "setupEstimatedTime": "Acerca de 5 minutos",
    "setupInfoDescription": "Haremos algunas preguntas para personalizar tu kit — qué llevar, quién viene y tu cronograma.",
    "setupInfoIntro": "TelePortal es tu centro de comando de reubicación. La configuración nos ayuda a adaptar el kit a tu mudanza.",
    "setupMissingJourney": "No pudimos encontrar un viaje para configurar.",
    "setupNoJourney": "Ningún viaje seleccionado",
    "setupNoJourneyMessage": "Primero elige un viaje, luego construiremos tu kit de TelePortal.",
    "setupOnWeb": "Configurar en Citizen Web",
    "setupOnWebDesc": "Completa el asistente de configuración de TelePortal en el Portal Web de Citizen para construir tu plan de reubicación personalizado.",
    "setupProgress": "Progreso de configuración",
    "setupSubtitle": "Personaliza tu kit de reubicación",
    "setupSuccessMessage": "Tu kit está listo. Comencemos tu reubicación.",
    "setupSuccessTitle": "Estás listo",
    "setupTitle": "Configuración de TelePortal",
    "somethingWentWrong": "Algo salió mal",
    "startAssessment": "Iniciar evaluación",
    "startTask": "Iniciar tarea",
    "status": "Estado",
    "statusBlocked": "Bloqueado",
    "statusCompleted": "Completado",
    "statusHome": "Aún en el país de origen",
    "statusInProgress": "En progreso",
    "statusMoved": "Ya te has mudado al destino",
    "statusOverdue": "Atrasado",
    "statusTodo": "Por hacer",
    "statusTransit": "En tránsito",
    "stepOf": "Paso {{current}} de {{total}}",
    "summary": {
      "assessmentDetails": "Detalles de la evaluación",
      "checklistPreviewTitle": "Tu lista de verificación personalizada incluirá:",
      "currentStatus": "Estado actual",
      "description": "Revisa los detalles de tu reubicación antes de que generemos tu lista de verificación personalizada",
      "destination": "Destino",
      "employerSupport": "Soporte del empleador",
      "familyConfiguration": "Configuración familiar",
      "generateChecklist": "Generar lista de verificación",
      "journeyRoute": "Ruta del viaje",
      "legalTrackDesc": "Ruta legal — Preparación legal y documentos",
      "makeChanges": "Hacer cambios",
      "notSelected": "No seleccionado",
      "origin": "Origen",
      "setupTrackDesc": "Ruta de configuración — Alojamiento, reconocimiento de credenciales y primeras semanas",
      "targetMoveDate": "Fecha objetivo de mudanza",
      "title": "Resumen de la evaluación de TelePortal",
      "travelTrackDesc": "Ruta de viaje — Logística y planificación de viajes",
      "viewModeDescription": "Completa información sobre tu evaluación de reubicación",
      "visaType": "Tipo de visa"
    },
    "tabDocuments": "Documentos",
    "tabOverview": "Resumen",
    "tabTasks": "Tareas",
    "tabTimeline": "Cronograma",
    "tabTracks": "Rutas y tareas",
    "targetDate": "Fecha objetivo",
    "task": {
      "allMembers": "Todos los miembros",
      "ask": "Preguntar",
      "askCopilotTask": "Pregunta a CoPilot sobre esta tarea",
      "blockedBy": "Bloqueado Por",
      "blockedComplete": "Bloqueado — Completa las dependencias primero",
      "completeError": "Error al completar la tarea. Por favor, inténtalo de nuevo.",
      "completionNotesPlaceholder": "Agregar notas de finalización (opcional)...",
      "confirmComplete": {
        "message": "¿Estás seguro de que quieres marcar esta tarea como completa? Esta acción no se puede deshacer.",
        "title": "¿Marcar tarea como completa?"
      },
      "dependenciesResolved": "Dependencias (resueltas)",
      "docStatusMissing": "Faltante",
      "docStatusPending": "Pendiente",
      "docStatusRejected": "Rechazado",
      "docStatusUploaded": "Subido",
      "docStatusVerified": "Verificado",
      "documents": "Documentos",
      "documentsRequired": "Documentos requeridos",
      "dueToday": "Vence hoy",
      "dueTomorrow": "Vence mañana",
      "entireFamily": "Toda la familia",
      "markComplete": "Marcar como completo",
      "needHelp": "¿Necesitas ayuda?",
      "noAdditionalDocs": "No hay documentos adicionales",
      "noDocsAttached": "No se han adjuntado documentos aún",
      "notFound": "Tarea no encontrada",
      "notes": "Notas",
      "otherDocuments": "Otros documentos",
      "reopenError": "No se pudo reabrir la tarea. Por favor, inténtalo de nuevo.",
      "reopenTask": "Reabrir tarea",
      "requiredDocuments": "Documentos requeridos",
      "statusBlocked": "Bloqueado",
      "statusCompleted": "Completado",
      "statusInProgress": "En progreso",
      "statusOverdue": "Atrasado",
      "statusTodo": "Por hacer",
      "taskBlocked": "Tarea bloqueada",
      "taskBlockedMsg": "Completa primero las tareas bloqueantes antes de marcar esta como hecha.",
      "title": "Tarea",
      "trackLegal": "Legal",
      "trackSetup": "Configuración",
      "trackTravel": "Viajar",
      "uploadDocument": "Subir documento",
      "uploadDocumentHint": "Usa la cámara, la biblioteca de fotos o archivos",
      "uploadRequired": "Subir requerido",
      "uploaded": "Subido",
      "validated": "Validado",
      "companyOwnedNote": "Esta tarea es manejada por tu empresa — ellos la completarán por su parte.",
      "companyProvidesDoc": "Tu empresa proporciona esto",
      "daysOverdue_one": "{{count}} día de retraso",
      "daysOverdue_other": "{{count}} días de retraso",
      "documentsRequiredMsg_one": "Sube los documentos requeridos antes de completar esta tarea. Aún falta {{count}} documento.",
      "documentsRequiredMsg_other": "Sube los documentos requeridos antes de completar esta tarea. Aún faltan {{count}} documentos.",
      "dueInDays_one": "Vence en {{count}} día",
      "dueInDays_other": "Vence en {{count}} días",
      "milesReward_one": "+{{count}} Mile",
      "milesReward_other": "+{{count}} Miles",
      "missingCount_one": "{{count}} faltante",
      "missingCount_other": "{{count}} faltantes",
      "uploadDocsFirst_one": "Sube primero {{count}} documento requerido",
      "uploadDocsFirst_other": "Sube primero {{count}} documentos requeridos"
    },
    "taskArrangePickup": "Organizar recogida en el aeropuerto",
    "taskArrangePickupDesc": "Organizar transporte desde el aeropuerto",
    "taskBookFlights": "Reservar vuelos",
    "taskBookFlightsDesc": "Reserva tus vuelos al país de destino",
    "taskCompleted": "Tarea completada",
    "taskCompletedError": "Error al completar la tarea. Por favor, inténtalo de nuevo.",
    "taskCompletedSuccess": "¡Tarea completada con éxito!",
    "taskCredentialRecognition": "Completa el proceso de reconocimiento de credenciales",
    "taskCredentialRecognitionDesc": "Completa el proceso de reconocimiento de credenciales para profesiones reguladas",
    "taskDefinitiveHousing": "Encontrar vivienda definitiva",
    "taskDefinitiveHousingDesc": "Encontrar y asegurar vivienda permanente",
    "taskFillApplication": "Completar formulario de solicitud de visa",
    "taskFillApplicationDesc": "Completa el formulario de solicitud de visa con información precisa",
    "taskGatherDocuments": "Reunir documentos requeridos",
    "taskGatherDocumentsDesc": "Recoge todos los documentos necesarios para tu solicitud de visa",
    "taskNotFound": "Tarea no encontrada",
    "taskNoteDescription": "Añadir una nota personal para esta tarea",
    "taskNoteTitle": "Nota de tarea: {{title}}",
    "taskPlanItinerary": "Planificar itinerario de llegada",
    "taskPlanItineraryDesc": "Planifica tu itinerario de llegada y primeros días",
    "taskPrepareMaterials": "Preparar materiales para la entrevista",
    "taskPrepareMaterialsDesc": "Prepara todos los materiales necesarios para la entrevista",
    "taskReopened": "Tarea reabierta",
    "taskScheduleInterview": "Programar entrevista de visa",
    "taskScheduleInterviewDesc": "Programa tu cita para la entrevista de visa",
    "taskSchoolingChildcare": "Organizar escolarización y cuidado infantil",
    "taskSchoolingChildcareDesc": "Organiza la escolarización y el cuidado infantil para los niños",
    "taskStatus": {
      "blocked": "Bloqueado",
      "completed": "Completado",
      "in_progress": "En progreso",
      "not_started": "No comenzado",
      "overdue": "Atrasado",
      "pending": "Pendiente",
      "todo": "Por hacer"
    },
    "taskTemporaryHousing": "Asegurar vivienda temporal",
    "taskTemporaryHousingDesc": "Asegura alojamiento temporal para tu llegada",
    "tasks": {
      "apostille_documents": {
        "description": "Obtener sellos de apostilla oficiales en todos los documentos requeridos",
        "title": "Apostillar documentos"
      },
      "baggage_shipping": {
        "company_title": "Organizar envío de equipaje",
        "description": "Organizar el envío de pertenencias personales al destino",
        "title": "Envío de equipaje"
      },
      "child_dependent_visa": {
        "description": "Enviar solicitud de visa de dependiente para niños",
        "title": "Visa de dependiente infantil"
      },
      "collect_birth_certificate": {
        "description": "Obtener certificados de nacimiento certificados para todos los miembros de la familia que se trasladan",
        "title": "Recoger certificado de nacimiento"
      },
      "collect_marriage_certificate": {
        "description": "Obtener certificado de matrimonio certificado para solicitudes de visa",
        "title": "Recoger certificado de matrimonio"
      },
      "collect_passport": {
        "description": "Reunir pasaportes válidos para todos los miembros de la familia que se trasladan",
        "title": "Recoger Passport"
      },
      "credential_recognition": {
        "description": "Solicitar el reconocimiento de credenciales profesionales en el país de destino",
        "title": "Reconocimiento de credenciales"
      },
      "criminal_record": {
        "description": "Solicitar certificado de antecedentes penales de su país de origen",
        "title": "Obtener antecedentes penales"
      },
      "drivers_license_exchange": {
        "description": "Intercambiar su licencia de conducir extranjera por una local",
        "title": "Intercambio de licencia de conducir"
      },
      "employment_contract": {
        "company_title": "Emitir contrato de trabajo",
        "description": "Asegure su contrato de trabajo firmado de su empleador",
        "title": "Contrato de trabajo"
      },
      "find_housing": {
        "company_title": "Organizar apoyo de vivienda",
        "description": "Buscar y encontrar alojamiento permanente",
        "title": "Encontrar vivienda"
      },
      "flight_booking": {
        "company_title": "Organizar reserva de vuelo",
        "description": "Reservar vuelos para todos los miembros de la familia que se trasladan",
        "title": "Reservar vuelos"
      },
      "get_codice_fiscale": {
        "description": "Obtener su código fiscal italiano",
        "title": "Obtener codice fiscale"
      },
      "get_nie": {
        "description": "Obtener su número de identificación de extranjero español",
        "title": "Obtener NIE"
      },
      "get_nif": {
        "description": "Solicitar su número de identificación fiscal portugués (NIF)",
        "title": "Obtener NIF (número fiscal)"
      },
      "get_niss": {
        "description": "Registrarse para el número de seguridad social portugués (NISS)",
        "title": "Obtener NISS (seguridad social)"
      },
      "groupBy": {
        "member": "Agrupar por miembro",
        "shared": "Compartido (hogar)",
        "status": "Agrupar por estado"
      },
      "health_insurance_enrollment": {
        "company_title": "Organizar seguro de salud",
        "description": "Inscribirse en la cobertura de seguro de salud",
        "title": "Seguro de salud"
      },
      "health_registration": {
        "description": "Registrarse en el sistema de salud local",
        "title": "Registro de salud"
      },
      "local_sim": {
        "description": "Comprar una tarjeta SIM local o eSIM para su país de destino",
        "title": "Obtener tarjeta SIM local"
      },
      "marriage_certificate": {
        "description": "Recoger su certificado de matrimonio",
        "title": "Certificado de matrimonio"
      },
      "municipality_registration": {
        "description": "Registrarse en su municipio local (Junta de Freguesia)",
        "title": "Registro municipal"
      },
      "nif_partner": {
        "description": "Solicitar el número de identificación fiscal portugués de su pareja",
        "title": "NIF de la pareja (número fiscal)"
      },
      "open_bank_account": {
        "description": "Abrir una cuenta bancaria en su país de destino",
        "title": "Abrir cuenta bancaria"
      },
      "ownership": {
        "company": "Tarea de la empresa",
        "dual": "Responsabilidad compartida",
        "government": "Proceso gubernamental",
        "talent": "Su tarea"
      },
      "partner_visa_application": {
        "description": "Enviar solicitud de visa para su pareja/cónyuge",
        "title": "Solicitud de visa para pareja"
      },
      "pet_microchip_verification": {
        "description": "Verificar que el microchip de su mascota cumpla con la norma ISO y sea legible",
        "title": "Verificación de microchip de mascota"
      },
      "pet_passport": {
        "description": "Obtener pasaporte de mascota de la UE con registros de vacunación",
        "title": "Pasaporte de la mascota"
      },
      "pet_transport": {
        "description": "Organizar transporte seguro para su mascota al destino",
        "title": "Transporte de mascota"
      },
      "pet_vaccination": {
        "description": "Asegurarse de que todas las vacunaciones requeridas estén al día para su mascota",
        "title": "Vacunación de mascota"
      },
      "portuguese_bank_transfer": {
        "description": "Configurar transferencias internacionales a su cuenta bancaria portuguesa",
        "title": "Transferencia bancaria internacional"
      },
      "proof_of_address": {
        "description": "Obtener prueba oficial de su dirección residencial",
        "title": "Prueba de dirección"
      },
      "proof_of_income": {
        "description": "Reunir extractos bancarios y prueba de medios financieros",
        "title": "Prueba de ingresos"
      },
      "provide_employment_contract": {
        "company_title": "Proporcionar contrato de trabajo al talento",
        "description": "La empresa proporciona el contrato de trabajo firmado",
        "title": "Proporcionar contrato de trabajo"
      },
      "promise_contract": {
        "company_title": "Proporcionar contrato de promesa de empleo",
        "description": "La empresa emite el contrato de promesa de empleo firmado para la solicitud de visa",
        "title": "Contrato de promesa de empleo"
      },
      "consulate_invitation_letter": {
        "company_title": "Proporcionar carta de invitación para el consulado",
        "description": "La empresa emite la carta de invitación / declaración que el talento presenta en el consulado",
        "title": "Carta de invitación al consulado"
      },
      "term_of_responsibility": {
        "company_title": "Proporcionar término de responsabilidad",
        "description": "La empresa firma el término de responsabilidad notariado que cubre la estancia del talento",
        "title": "Término de responsabilidad"
      },
      "techvisa_endorsement": {
        "company_title": "Proporcionar endoso de visa tecnológica de la empresa",
        "description": "La empresa certificada emite el endoso de Visa Tecnológica / término de responsabilidad para la contratación reconocida por IAPMEI",
        "title": "Endoso de visa tecnológica"
      },
      "reopen": {
        "button": "Reabrir tarea",
        "confirmMessage": "Esto moverá la tarea de nuevo a estado pendiente.",
        "confirmTitle": "¿Reabrir esta tarea?",
        "reason": "Razón para reabrir (opcional)"
      },
      "residence_permit_renewal": {
        "description": "Rastrea y planifica tu cronograma de renovación del permiso de residencia",
        "title": "Renovación del permiso de residencia"
      },
      "salary_proof": {
        "description": "Reúne recibos de salario o prueba de compensación",
        "title": "Prueba de salario"
      },
      "school_enrollment": {
        "description": "Inscribir a los niños en escuelas locales",
        "title": "Inscripción escolar"
      },
      "school_records": {
        "description": "Recoge registros escolares y transcripciones para los niños",
        "title": "Registros escolares"
      },
      "sef_aima_appointment": {
        "description": "Programa y asiste a tu cita con la autoridad de inmigración",
        "title": "Cita en la AIMA"
      },
      "sign_lease": {
        "description": "Revisa y firma tu contrato de arrendamiento",
        "title": "Firmar contrato de arrendamiento"
      },
      "sns_registration": {
        "description": "Regístrate en el Servicio Nacional de Salud Portugués (SNS)",
        "title": "Registro SNS"
      },
      "sponsor_letter": {
        "company_title": "Proporcionar carta de patrocinio",
        "description": "Obtén la carta de patrocinio de tu empleador",
        "title": "Carta de patrocinio"
      },
      "temp_accommodation": {
        "company_title": "Organizar alojamiento temporal",
        "description": "Organiza alojamiento temporal para tus primeras semanas",
        "title": "Alojamiento temporal"
      },
      "translate_documents": {
        "description": "Obtén traducciones certificadas de todos los documentos requeridos",
        "title": "Traducir documentos"
      },
      "travel_insurance": {
        "description": "Organiza cobertura de seguro de viaje para el período de reubicación",
        "title": "Seguro de viaje"
      },
      "utilities_setup": {
        "description": "Configura electricidad, agua, gas e internet en tu nuevo hogar",
        "title": "Configuración de servicios"
      },
      "visa_application": {
        "description": "Presenta tu solicitud de visa en el consulado o portal en línea",
        "title": "Solicitud de visa"
      },
      "visa_pickup": {
        "description": "Recoge la visa aprobada del consulado o embajada",
        "title": "Recogida de visa"
      }
    },
    "tasksCompleted": "Tareas completadas",
    "tasksCount": "{{completed}}/{{total}} tareas",
    "tasksDone": "Tareas hechas",
    "tasksLabel": "Tareas",
    "tasksOfTotal": "{{completed}}/{{total}} tareas",
    "timelineDescription": "Cronograma visual de tus fases de reubicación",
    "timelineTitle": "Cronograma y vista de Gantt",
    "timelineView": "Vista del cronograma",
    "title": "TelePortal",
    "toDo": "Por hacer",
    "tonnieChecked": "Tonnie-Verificado",
    "track": {
      "legal": "Legal",
      "setup": "Configuración",
      "travel": "Viajar"
    },
    "trackJourneyProgress": "Rastrea el progreso de tu viaje de reubicación",
    "trackLegal": "Rastreo legal",
    "trackLegalDesc": "Preparación legal basada en rutas, listas de verificación de documentos (consciente del hogar)",
    "trackLegalDescShort": "Visa, permisos y documentación legal",
    "trackProgress": "Rastrear progreso",
    "trackSetup": "Configuración de rastreo",
    "trackSetupDesc": "Capa de estabilización (primeras semanas) incluyendo alojamiento, reconocimiento de credenciales, escolarización/cuidados infantiles y hitos del Programa de Compañeros",
    "trackSetupDescShort": "Vivienda, banca y asentamiento",
    "trackSuffix": "Rastrear",
    "trackTasksProgress": "{{completed}}/{{total}} tareas",
    "trackTravel": "Rastreo de viaje",
    "trackTravelDesc": "Preparación logística, planificación de viajes consciente del hogar",
    "trackTravelDescShort": "Vuelos, alojamiento y logística",
    "tracks": {
      "legal": "Legal y documentos",
      "setup": "Configuración local",
      "travel": "Viaje y logística"
    },
    "tracksCompleted": "Rastros completados",
    "tryAgain": "Intenta de nuevo",
    "tryAgainLater": "Por favor, intenta de nuevo más tarde.",
    "unableToLoadData": "No se puede cargar los datos de TelePortal",
    "unlockPro": "Desbloquear con Pro",
    "upcomingDeadlines": "Próximos plazos",
    "upcomingTasks": "Próximas tareas",
    "upgradeMessage": "Actualiza para acceder a todas las fases y funciones avanzadas de TelePortal.",
    "upload": "Subir",
    "uploadDocument": "Subir documento",
    "uploadDocumentDescription": "Añadir un documento a tu viaje de TelePortal",
    "uploadFromMobile": "Subir desde móvil",
    "uploadFromMobileDescription": "Usa Tonnie Citizen para escanear y subir documentos al instante",
    "uploadFromMobileTitle": "Subir documentos desde el móvil",
    "uploadInMobile": "Subir en móvil",
    "uploaded": "subido",
    "uploading": "Subiendo...",
    "validate": "Validar",
    "validated": "Validado",
    "vault": {
      "continue": "Continuar",
      "continueWithPending": "Continuar (pendiente de revisión)",
      "documentsFound": "documentos encontrados en tu Vault",
      "empty": "Vault vacío",
      "emptyMessage": "Tu vault está vacío. Añadiremos documentos aquí a medida que completes tareas.",
      "expired": "Caducado",
      "expiringSoon": "Caducando pronto",
      "hint": "Vincula documentos de tu vault para omitir subidas.",
      "link": "Vincular",
      "linked": "Vinculado",
      "remaining": "restante",
      "scanning": "Escaneando vault…",
      "skip": "Omitir",
      "undo": "Deshacer",
      "validUntil": "Válido hasta {{date}}",
      "skipped": "Omitido"
    },
    "verifiedByTonnieGuard": "Verificado por Tonnie guard",
    "viewDetails": "Ver detalles",
    "viewDocumentInMobile": "Sube y gestiona este documento en la aplicación móvil",
    "viewMyOptions": "Ver mis opciones",
    "viewTaskInMobile": "Ver y completar esta tarea en la aplicación móvil",
    "visaBlueCard": "Tarjeta azul de la UE",
    "visaFamily": "Reunificación familiar",
    "visaNomad": "Nómada digital / Trabajador remoto",
    "visaStudent": "Visa de estudiante",
    "visaWork": "Visa de trabajo / Empleo",
    "welcome": {
      "description": "Crea tu plan de reubicación personalizado. Te guiaremos a través de una configuración rápida para crear tu panel con tareas, documentos y plazos adaptados a tu viaje.",
      "docsStep": "Documentos y tareas",
      "docsStepDesc": "Obtén una lista de verificación personalizada de todo lo que necesitas",
      "householdStep": "Tu hogar y visa",
      "householdStepDesc": "Cuéntanos quién se está reubicando y tu situación migratoria",
      "letsStart": "Empecemos",
      "planStep": "Vivienda y logística",
      "planStepDesc": "Configura tu plan de vivienda, viaje y cronograma",
      "timeEstimate": "Toma alrededor de 5-10 minutos para completar",
      "title": "Bienvenido a TelePortal"
    },
    "welcomeMessage": "¡Bienvenido a la Evaluación de TelePortal! Te ayudaré a crear una lista de verificación personalizada para la reubicación. Comencemos por entender tu situación.",
    "you": "Tú",
    "yourNextStep": "Tu siguiente paso",
    "setupDimension": {
      "profile": "Perfil",
      "profileDesc": "Origen, destino y contexto de reubicación",
      "household": "Hogar",
      "householdDesc": "Miembros de la familia que se unen a la mudanza",
      "documents": "Documentos",
      "documentsDesc": "Escaneo y vinculación de documentos en la bóveda",
      "preferences": "Preferencias",
      "preferencesDesc": "Preferencias de viaje, alojamiento y estilo de vida"
    },
    "docType": {
      "accommodation": "Justificante de alojamiento",
      "bank_statements": "Extractos bancarios",
      "birth_certificate": "Certificado de nacimiento",
      "boarding_pass": "Tarjeta de embarque",
      "certificate": "Certificado",
      "certified_translation": "Traducción certificada",
      "consulate_invitation_letter": "Carta de invitación del consulado",
      "contract": "Contrato",
      "criminal_record": "Certificado de antecedentes penales",
      "drivers_license": "Permiso de conducir",
      "employer_declaration": "Declaración del empleador",
      "employment_contract": "Contrato de trabajo",
      "health_insurance_policy": "Póliza de seguro de salud",
      "id_card": "Documento de identidad",
      "insurance": "Seguro",
      "lease_agreement": "Contrato de arrendamiento",
      "marriage_certificate": "Certificado de matrimonio",
      "medical_documentation": "Documentación médica",
      "official_document": "Documento oficial",
      "other": "Otro documento",
      "passport": "Pasaporte",
      "passport_stamp": "Sello en el pasaporte",
      "pet_passport": "Pasaporte de la mascota",
      "photo": "Fotografía de carné",
      "promise_contract": "Contrato de promesa",
      "proof_of_address": "Prueba de dirección",
      "proof_of_income": "Prueba de ingresos",
      "residence_permit": "Permiso de residencia",
      "salary_proof": "Prueba de salario",
      "school_records": "Registros escolares",
      "sponsor_letter": "Carta de patrocinio",
      "tax_document": "Documento fiscal",
      "techvisa_endorsement": "Endoso de TechVisa",
      "term_of_responsibility": "Término de responsabilidad",
      "ticket": "Billete",
      "travel_insurance": "Seguro de viaje",
      "visa": "Visa",
      "work_permit": "Permiso de trabajo"
    },
    "duration": {
      "1_2_days": "1-2 días",
      "1_2_weeks": "1-2 semanas",
      "1_3_days": "1-3 días",
      "1_day": "1 día",
      "1_week": "1 semana",
      "2_3_weeks": "2-3 semanas",
      "2_4_weeks": "2-4 semanas",
      "2_6_weeks": "2-6 semanas",
      "2_8_weeks": "2-8 semanas",
      "3_5_days": "3-5 días",
      "4_12_weeks": "4-12 semanas",
      "4_8_weeks": "4-8 semanas",
      "ongoing": "En curso"
    },
    "daysOverdue_one": "{{count}} día de retraso",
    "daysOverdue_other": "{{count}} días de retraso",
    "documentsAttached_one": "{{count}} documento adjunto",
    "documentsAttached_other": "{{count}} documentos adjuntos",
    "documentsCount_one": "{{count}} documento",
    "documentsCount_other": "{{count}} documentos",
    "dueInDays_one": "Vence en {{count}} día",
    "dueInDays_other": "Vence en {{count}} días",
    "inProgressCount_one": "{{count}} en curso",
    "inProgressCount_other": "{{count}} en progreso",
    "missingDocs_one": "{{count}} faltante",
    "missingDocs_other": "{{count}} faltantes",
    "moreCompleted_one": "+{{count}} completada más",
    "moreCompleted_other": "+{{count}} completadas más",
    "needsAttentionCount_one": "{{count}} necesita atención",
    "needsAttentionCount_other": "{{count}} necesitan atención",
    "pendingCount_one": "{{count}} pendiente",
    "pendingCount_other": "{{count}} pendientes",
    "timeMinutes_one": "~{{count}} minuto",
    "timeMinutes_other": "~{{count}} minutos",
    "capture": {
      "reading": "Leyendo el documento…",
      "readAsOther": "Parece ser {{type}} — comprueba que es el documento que pide esta tarea.",
      "saving": "Guardando en tu Bóveda…",
      "savingProgress": "Guardando en tu Bóveda… {{percent}}%"
    },
    "deleteDocumentError": "No se ha podido eliminar el documento. Inténtalo de nuevo."
  },
  "termsPrivacy": {
    "gdprRights": "Bajo el GDPR y las leyes de protección de datos aplicables, tienes el derecho de acceder, rectificar, borrar y portar tus datos personales. Puedes ejercer estos derechos en cualquier momento a través de Configuración o contactando a nuestro Oficial de Protección de Datos.",
    "privacyPolicy": "Política de privacidad",
    "termsOfService": "Términos de servicio",
    "title": "Términos y privacidad",
    "yourRights": "Tus derechos"
  },
  "theme": {
    "autoMatchSystem": "La aplicación ajustará automáticamente la configuración del tema de tu dispositivo.",
    "configure": "Configurar",
    "custom": "Personalizado",
    "dark": "Oscuro",
    "darkTheme": "Tema oscuro",
    "followSystem": "Seguir sistema ({{mode}})",
    "light": "Ligero",
    "lightTheme": "Tema ligero",
    "system": "Sistema",
    "theme": "Tema",
    "themeSelection": "Selección de tema",
    "useFixedTheme": "La aplicación utilizará el tema {{mode}} independientemente de la configuración de tu dispositivo."
  },
  "validation": {
    "passwordUpdateFailed": "Error al actualizar la contraseña. Por favor, intenta de nuevo.",
    "passwordUpdated": "Contraseña actualizada con éxito",
    "required": "Este campo es obligatorio",
    "email": {
      "invalid": "Dirección de correo electrónico no válida",
      "required": "Introduce tu dirección de correo electrónico."
    },
    "password": {
      "min": "Tu contraseña necesita al menos {{passwordMinLength}} caracteres.",
      "mismatch": "Las contraseñas no coinciden",
      "max": "Tu contraseña puede tener como máximo {{passwordMaxLength}} caracteres.",
      "required": "Introduce tu contraseña.",
      "confirmRequired": "Confirma tu contraseña."
    },
    "firstName": {
      "required": "El nombre es obligatorio",
      "tooLong": "Tu nombre puede tener como máximo 50 caracteres."
    },
    "lastName": {
      "required": "El apellido es obligatorio",
      "tooLong": "Tus apellidos pueden tener como máximo 50 caracteres."
    },
    "uuid": {
      "invalid": "UUID no válido"
    },
    "phone": {
      "invalid": "Número de teléfono no válido"
    },
    "url": {
      "invalid": "URL no válida"
    },
    "countryCode": {
      "length": "El código de país debe tener 2 caracteres (ISO 3166-1 alfa-2)"
    },
    "dateRange": {
      "endAfterStart": "La fecha de finalización debe ser posterior a la fecha de inicio"
    },
    "field": {
      "required": "Este campo es obligatorio"
    },
    "iqulture": {},
    "city": {
      "required": "Indica la ciudad en la que vives",
      "tooLong": "El nombre de la ciudad es demasiado largo (máximo 100 caracteres)"
    },
    "originCountry": {
      "required": "Elige el país del que te vas"
    },
    "nationality": {},
    "timeZone": {
      "invalid": "Esa zona horaria no se reconoce."
    },
    "timeOfDay": {
      "invalid": "Usa una hora como 22:00."
    },
    "code": {
      "sixDigits": "Introduce el código de 6 dígitos."
    },
    "destination": {
      "notOpen": "Todavía no ofrecemos este destino. Hoy, el destino disponible es Portugal."
    },
    "journey": {
      "requestIdRequired": "Un viaje nuevo necesita un identificador de solicitud",
      "newIntentOnly": "Solo un viaje nuevo admite un identificador de solicitud o un nombre",
      "labelRequired": "Escribe un nombre o bórralo",
      "labelTooLong": "Usa 40 caracteres o menos"
    },
    "inoutPortal": {
      "code": "Mayúsculas, dígitos y _, empezando por una letra, de 2 a 40 caracteres.",
      "colour": "Un color como #RRGGBB.",
      "origin": "Un sitio como https://host (http solo para localhost).",
      "originTwice": "Este sitio está repetido.",
      "originsTooMany": "Como máximo 20 sitios.",
      "activeNeedsOrigin": "Un portal activo necesita al menos un sitio.",
      "httpsUrl": "Una dirección https://.",
      "logo": "Una dirección https://, o una imagen que sirve la calculadora (/assets/partners/nombre.png).",
      "nameTooLong": "Como máximo 120 caracteres.",
      "partner": "Elige una asesoría del registro.",
      "accentUnreadable": "Ilegible sobre el color de acción: contraste inferior a 4,5:1.",
      "pagePair": "La página y su texto van juntos.",
      "pageUnreadable": "Ilegible sobre la página: contraste inferior a 4,5:1."
    }
  },
  "vault": {
    "downloadError": "Error al descargar",
    "downloadSuccess": "Descargado",
    "downloadZipError": "Error al descargar documentos",
    "loadingPreview": "Cargando vista previa…",
    "removeError": "Error al eliminar",
    "removeSuccess": "Eliminado",
    "uploadError": "Error al subir",
    "uploadSuccess": "Subido",
    "uploadRejected": {
      "mimeNotAllowed": "Este tipo de archivo no se acepta en esta sección. Elige otro archivo.",
      "unidentifiable": "No hemos podido reconocer este archivo. Puede estar dañado; prueba a exportarlo de nuevo.",
      "declaredMimeMismatch": "El contenido de este archivo no coincide con su tipo. Sube el archivo original.",
      "pitchTooLong": "Este vídeo dura más de {{minutes}} minutos. Elige un vídeo más corto.",
      "fileTooLarge": "Este archivo es demasiado grande para subirlo. Elige un archivo más pequeño.",
      "uploadStalled": "La subida se ha detenido porque tu conexión dejó de enviar datos. Comprueba la conexión e inténtalo de nuevo.",
      "fileNotLinkable": "Ese documento ya no está en tu Bóveda — elige otro."
    },
    "downloadZipSuccess_one": "Descargando {{count}} documento",
    "downloadZipSuccess_other": "Descargando {{count}} documentos",
    "documentsCount_one": "{{count}} documento",
    "documentsCount_other": "{{count}} documentos",
    "pick": {
      "title": "Elegir de tu Bóveda",
      "description": "Un documento que ya guardas — de cualquier héroe.",
      "source": "De tu Bóveda",
      "sourceShort": "Bóveda",
      "sourceHint": "Un documento que ya guardas",
      "whatItIs": "Qué es",
      "yourDocuments": "Tus documentos",
      "attach": "Adjuntar",
      "empty": "Todavía no hay en tu Bóveda un documento que sirva aquí.",
      "errorTitle": "No se ha podido leer tu Bóveda",
      "errorBody": "Inténtalo de nuevo en un momento.",
      "suggested": "Sugeridos"
    },
    "preview": {
      "openWith": "Abrir con…"
    },
    "add": {
      "title": "Añadir un documento",
      "description": "Va a tu Bóveda, en el héroe que elijas.",
      "where": "Dónde guardarlo",
      "camera": "Hacer una foto",
      "library": "De las fotos",
      "files": "De los archivos",
      "uploading": "Subiendo…"
    }
  },
  "viewport": {
    "description": "El Web de Tonnie Citizen está diseñado para pantallas más grandes. Para la mejor experiencia móvil, por favor descarga la aplicación móvil.",
    "downloadAppStore": "Descargar en app store",
    "downloadPlayStore": "Consíguelo en Google play",
    "orAccessDesktop": "O accede desde una tableta o escritorio",
    "switchToMobile": "Cambiar a Tonnie Citizen"
  },
  "webPortal": {
    "availableOnWeb": "Disponible en el portal web de Citizen",
    "copied": "¡Copiado!",
    "copyLink": "Copiar enlace para escritorio",
    "hint": "El Portal Web de Citizen requiere un navegador de escritorio.",
    "shareLink": "Compartir enlace"
  },
  "widgets": {
    "continue": "Continuar",
    "motivationalForm": {
      "sharePlaceholder": "Comparte tus pensamientos..."
    },
    "rating": {
      "notAtAll": "Para nada",
      "veryMuch": "Mucho"
    },
    "timeline": {
      "12plusMonths": "12+ meses",
      "12plusMonthsDesc": "Planificación futura",
      "1to3months": "1-3 meses",
      "1to3monthsDesc": "Planificación a corto plazo",
      "3to6months": "3-6 meses",
      "3to6monthsDesc": "Planificación a medio plazo",
      "6to12months": "6-12 meses",
      "6to12monthsDesc": "Planificación a largo plazo",
      "asap": "Lo antes posible",
      "asapDesc": "Dentro del próximo mes",
      "flexible": "Flexible",
      "flexibleDesc": "Sin cronograma específico"
    }
  },
  "world": {
    "completeToUnlock": "Completa misiones anteriores para desbloquear",
    "upgradeToUnlock": "Mejora tu plan para desbloquear",
    "completed": "Completado",
    "notFound": "Mundo no encontrado",
    "backToQultureUp": "Volver a QultureUp",
    "ofMissions": "{{completed}} de {{total}} misiones",
    "overallProgress": "Progreso general",
    "remaining": "Restante",
    "title": "Mundo",
    "tracks": "Pistas",
    "milesReward_one": "+{{count}} Mile",
    "milesReward_other": "+{{count}} Miles"
  },
  "pricing": {
    "betaPriceLabel": "Precio de acceso anticipado",
    "percentOffLabel": "−{{percent}}%",
    "betaDisclaimer": "Precio de acceso anticipado — precio regular {{listPrice}} después del lanzamiento."
  },
  "ui": {
    "sidebar": {
      "toggle": "Alternar barra lateral"
    },
    "carousel": {
      "prev": "Diapositiva anterior",
      "next": "Diapositiva siguiente"
    },
    "command": {
      "title": "Paleta de comandos",
      "description": "Buscar un comando para ejecutar..."
    }
  },
  "plan": {
    "upgrade": {
      "teleportal": "Desbloquea este viaje o pásate a Pro para abrir todas las fases de TelePortal",
      "qultureup": "Desbloquea este viaje o pásate a Pro para acceder a todos los mundos de QultureUp",
      "care": "Desbloquea este viaje o pásate a Pro para acceder a Care y Soporte",
      "passport": "Desbloquea este viaje o pásate a Pro para tener el Passport completo",
      "career": "Actualiza a Pro para funciones de carrera mejoradas",
      "copilot": "Actualiza a Pro para consultas ilimitadas de CoPilot",
      "familyProgram": "Desbloquea este viaje o pásate a Pro para habilitar el Programa Familiar",
      "default": "Actualiza para desbloquear esta función"
    }
  },
  "appUpdate": {
    "required": {
      "title": "Actualización necesaria",
      "body": "Esta versión de Tonnie ya no es compatible. Actualiza para continuar.",
      "cta": "Actualizar ahora"
    },
    "available": {
      "title": "Actualización disponible",
      "body": "Ya está disponible una nueva versión de Tonnie.",
      "cta": "Actualizar"
    },
    "dismiss": "Más tarde"
  },
  "setup": {
    "title": "¿De qué país te vas?",
    "countryLabel": "País del que te vas",
    "countryPlaceholder": "Selecciona un país",
    "cityLabel": "Ciudad en la que vives",
    "cityPlaceholder": "Empieza a escribir tu ciudad…",
    "destinationLabel": "Destino",
    "destinationOpenToday": "{{country}} es el destino disponible hoy. Pronto habrá más.",
    "submit": "Continuar",
    "saving": "Configurando tu viaje…",
    "saveFailed": "No hemos podido guardarlo. Revisa tu conexión e inténtalo de nuevo."
  },
  "profileComplete": {
    "known": "Ya en tu perfil",
    "countryPlaceholder": "Selecciona un país",
    "cityPlaceholder": "Empieza a escribir tu ciudad…",
    "phonePlaceholder": "Tu número de teléfono",
    "optionalNote": "Los datos del pasaporte, el CV y la unidad familiar son opcionales. Nunca bloquean tu puntuación.",
    "saving": "Guardando…",
    "saveFailed": "No hemos podido guardarlo. Revisa tu conexión e inténtalo de nuevo.",
    "label": {
      "firstName": "Nombre",
      "lastName": "Apellidos",
      "dateOfBirth": "Fecha de nacimiento",
      "currentCountry": "País en el que vives",
      "currentCity": "Ciudad en la que vives",
      "phone": "Teléfono"
    },
    "loadFailed": "No hemos podido cargar tu perfil. Revisa tu conexión e inténtalo de nuevo."
  },
  "profileBasics": {
    "title": "Tus datos básicos",
    "subtitle": "Lo que tu CheckUp necesita para empezar. Deja que un documento escriba por ti: lo revisas todo antes de guardarlo.",
    "progressLabel": "Esenciales para tu CheckUp",
    "close": "Cerrar",
    "back": "Volver a tus datos",
    "faster": {
      "title": "Rellénalo más rápido",
      "fastest": "Lo más rápido",
      "document": {
        "title": "Escanear pasaporte o DNI",
        "fills": "Fecha de nacimiento · ciudadanía"
      },
      "import": {
        "title": "PDF de LinkedIn o CV",
        "fills": "Experiencia · formación · habilidades · idiomas"
      }
    },
    "orType": "o escríbelo",
    "filled": {
      "document_one": "Tu documento rellenó {{count}} dato. Revisa lo que falta abajo.",
      "document_other": "Tu documento rellenó {{count}} datos. Revisa lo que falta abajo.",
      "documentNone": "No se añadió nada de tu documento.",
      "import": "Tu PDF de LinkedIn o CV ya está en tu perfil: afina tu puntuación."
    },
    "done": {
      "title": "Tus datos básicos están completos",
      "body": "Todo lo que tu CheckUp necesita para empezar ya está guardado. Un PDF de LinkedIn o un CV aún afina tu puntuación."
    },
    "doneCta": "Listo",
    "privacy": "No se guarda nada hasta que pulses Guardar.",
    "later": "Más tarde",
    "save": "Guardar mis datos",
    "saved": "Tus datos se han guardado."
  },
  "citizenHome": {
    "needsYou": {
      "checkin": {
        "action": "Hacer check-in",
        "body": "Tu check-in diario lleva un minuto.",
        "last": "Último check-in: {{date}}",
        "title": "¿Cómo estás hoy?"
      },
      "checkpoint": {
        "action": "Empezar",
        "body": "Cuéntanos cómo va tu adaptación.",
        "overdueTitle": "Tienes un punto de control de Care atrasado",
        "title": "Tienes un punto de control de Care pendiente"
      },
      "invitation": {
        "action": "Revisar",
        "body": "Revisa la invitación para decidir si te unes.",
        "title": "Invitación de {{company}}"
      },
      "later": "Más tarde",
      "laterA11y": "Más tarde: {{title}}",
      "seeAll": "Ver todo",
      "showLess": "Ver menos",
      "seeAllA11y_one": "Ver la {{count}} cosa pendiente",
      "seeAllA11y_other": "Ver las {{count}} cosas pendientes",
      "profile": {
        "action": "Completar perfil",
        "body": "Tu puntuación de CheckUp necesita algunos datos más sobre ti.",
        "title": "Completa tu perfil",
        "secondary": "Subir pasaporte"
      },
      "taskOverdue": {
        "action": "Abrir tarea",
        "body": "Algunos plazos de tu mudanza ya han vencido.",
        "title_one": "{{count}} tarea atrasada",
        "title_other": "{{count}} tareas atrasadas"
      },
      "title": "Pendiente de ti",
      "unread": {
        "action": "Leer",
        "body": "Ponte al día con las novedades.",
        "title_one": "{{count}} mensaje sin leer",
        "title_other": "{{count}} mensajes sin leer"
      },
      "dismiss": "Descartar",
      "dismissA11y": "Descartar: {{title}}",
      "sponsorship": {
        "title": "{{company}} quiere patrocinar tu viaje",
        "body": "Se abren todos los capítulos — TelePortal, QultureUp, Care y Passport — sin coste para ti.",
        "action": "Ver oferta"
      },
      "testit": {
        "title_one": "{{company}} te pide {{count}} prueba",
        "title_other": "{{company}} te pide {{count}} pruebas",
        "body_one": "Te queda {{count}}. Los resultados son tuyos para reutilizarlos.",
        "body_other": "Te quedan {{count}}. Los resultados son tuyos para reutilizarlos.",
        "action": "Hacer las pruebas"
      },
      "checkupRequested": {
        "title": "{{company}} está esperando tu CheckUp",
        "bodyStart": "Lo que han pedido es tu puntuación iQulture. Tarda unos 10–15 minutos.",
        "actionStart": "Empezar CheckUp",
        "bodyContinue": "Termina tu CheckUp: lo que han pedido es tu puntuación iQulture.",
        "actionContinue": "Continuar CheckUp",
        "bodyProfile": "Tu CheckUp está hecho. Añade algunos datos al perfil y tu puntuación estará lista.",
        "actionProfile": "Completar perfil",
        "bodyCalculate": "Todos los pasos están hechos. Calcula tu puntuación para responder a su solicitud.",
        "actionCalculate": "Calcular puntuación",
        "bodyCalculating": "Tu puntuación se está calculando. No tardará.",
        "actionCalculating": "Ver CheckUp",
        "bodyConsent": "Tu puntuación está lista. Solo la verán si decides compartirla.",
        "actionConsent": "Elegir qué ven",
        "titleConsent": "{{company}} pide ver la puntuación de tu CheckUp"
      },
      "checkupShared": {
        "title": "{{company}} puede ver tu CheckUp",
        "body": "Ven tu puntuación y tu preparación, nunca tus respuestas. Puedes cambiarlo cuando quieras.",
        "action": "Gestionar lo que compartes"
      },
      "countAria_one": "{{count}} cosa te necesita",
      "countAria_other": "{{count}} cosas te necesitan",
      "request": {
        "titleTests": "{{company}} pide ver más resultados de tus pruebas",
        "body": "Revisa lo que verían y decide. No se comparte nada hasta entonces.",
        "action": "Revisar"
      },
      "inout": {
        "title": "¿Estuviste aquí?",
        "body": "InOut pregunta por el {{from}} – {{to}}. Sin respuesta, esos días quedan inciertos.",
        "action": "Responder"
      },
      "inoutLimit": {
        "title": "Un límite de residencia está cerca",
        "body": "Con tus próximos viajes, alcanzarías un límite el {{date}}. Mira qué puedes hacer antes de salir.",
        "reachedTitle": "Se ha superado un límite de residencia",
        "reachedBody": "La regla que cuenta primero ha superado su límite. Mira qué significa y quién puede ayudarte.",
        "action": "Abrir InOut"
      },
      "inoutRenewal": {
        "title": "Tu ventana de renovación está abierta",
        "body": "Puedes pedir la renovación de tu permiso de residencia hasta el {{date}}.",
        "action": "Abrir InOut"
      }
    },
    "handoff": {
      "testit": {
        "title": "Haz tus pruebas",
        "description": "TestIt funciona en Citizen Web, con la cámara y el micrófono que necesitan algunas pruebas."
      },
      "sharing": {
        "title": "Elige qué ven las empresas",
        "description": "Quién ve tus datos, y qué ve, se gestiona en Citizen Web, en Mis viajes."
      }
    },
    "welcome": {
      "badge": "Te damos la bienvenida a Tonnie",
      "badgeInvited": "Invitación de {{company}}",
      "title": "{{name}}, tu traslado al extranjero empieza aquí.",
      "titleNoName": "Tu traslado al extranjero empieza aquí.",
      "titleInvited": "Hola, {{name}}. {{company}} te está esperando.",
      "titleInvitedNoName": "Hola. {{company}} te está esperando.",
      "body": "Crea tu viaje, descubre lo preparado que estás con un CheckUp tan completo como un chequeo médico y planifica cada documento y cada plazo, hasta ser un Citizen.",
      "bodyInvited": "Acepta la invitación y empieza tu viaje: primero lo que ha pedido {{company}}, después un plan para cada documento y plazo de tu traslado.",
      "ctaBuild": "Crear tu viaje",
      "ctaReview": "Ver invitación",
      "ctaBasics": "Añadir mis datos · 1 min",
      "ctaHow": "Cómo funciona",
      "routeAria": "Cuatro capítulos: tu viaje, el CheckUp, planificar y mudarte, ser Citizen",
      "route": {
        "build": {
          "title": "Crea tu viaje",
          "sub": "Adónde vas"
        },
        "accept": {
          "title": "Acepta la invitación",
          "sub": "Se crea tu viaje"
        },
        "checkup": {
          "title": "CheckUp",
          "sub": "Lo preparado que estás"
        },
        "plan": {
          "title": "Planificar y mudarte",
          "sub": "Documentos, plazos"
        },
        "citizen": {
          "title": "Ser Citizen",
          "sub": "Cultura, cuidado, pasaporte"
        }
      }
    },
    "quickStart": {
      "eyebrow": "Inicio rápido",
      "title": "Tus datos básicos en un minuto",
      "body": "Deja que un documento escriba por ti: lo revisas todo antes de guardarlo.",
      "progress": "Esenciales para tu CheckUp: {{done}} de {{total}}",
      "type": {
        "title": "Escribirlo tú",
        "body": "Solo lo que aún falta: unos dos minutos.",
        "cta": "Añadir a mano"
      }
    },
    "path": {
      "eyebrow": "Primeros pasos",
      "title": "Tus primeros cinco pasos",
      "progress": "{{done}} de {{total}} hechos",
      "progressAria": "{{done}} de {{total}} pasos hechos",
      "parts": "{{done}} de {{total}}",
      "note": "El CheckUp es gratis para todos. Los pasos 3 y 4 son más rápidos con tu pasaporte o tu CV.",
      "status": {
        "done": "Hecho",
        "in_progress": "En curso",
        "available": "Disponible ahora",
        "locked": "Bloqueado"
      },
      "optional": "Opcional · mejor puntuación",
      "missing": "Aún falta: {{items}}",
      "steps": {
        "journey": {
          "title": "Crea tu viaje",
          "titleInvited": "Acepta la invitación de {{company}}",
          "text": "Dinos adónde vas y construimos el plan a partir de ahí.",
          "textInvited": "Al aceptar se crea tu viaje, con {{company}}.",
          "textDone": "Tu viaje está listo.",
          "meta": "Unos 3 minutos",
          "metaInvited": "1 minuto",
          "cta": "Crear viaje",
          "ctaInvited": "Ver invitación"
        },
        "essential": {
          "title": "Añade los datos esenciales",
          "text": "Lo que el CheckUp necesita para empezar: nombre, fecha de nacimiento, ciudadanía, dónde vives y teléfono.",
          "textDone": "Todo lo que el CheckUp necesita para empezar.",
          "meta": "2 minutos · o una foto del pasaporte",
          "cta": "Añadir en un minuto"
        },
        "assessment": {
          "title": "Haz la evaluación CheckUp",
          "text": "Cinco partes cortas: vídeos, tu pitch, idiomas, motivación y una conversación.",
          "textLocked": "Se abre cuando exista tu viaje.",
          "textDone": "Las cinco partes están hechas.",
          "next": "Siguiente: {{part}}.",
          "meta": "Unos 20 minutos · puedes pausar cuando quieras",
          "cta": "Empezar",
          "ctaContinue": "Continuar",
          "parts": {
            "videos_watched": "los vídeos de introducción",
            "pitch_video": "tu vídeo de pitch",
            "language_tests": "tus pruebas de idiomas",
            "motivational_answers": "tus respuestas sobre motivación",
            "assistant_chat": "la conversación con Tonnie"
          }
        },
        "moreData": {
          "title": "Añade más datos",
          "text": "Habilidades, idiomas, formación y experiencia afinan tu puntuación.",
          "textDone": "Todo lo que lee la puntuación está completo.",
          "meta": "1 minuto con un PDF de LinkedIn o CV",
          "cta": "Importar LinkedIn o CV"
        },
        "score": {
          "title": "Obtén tu puntuación iQulture",
          "titleShared": "Envía tu puntuación a {{company}}",
          "text": "Tu preparación, pilar a pilar, y en qué trabajar después.",
          "textShared": "Se calcula con un clic y {{company}} la ve.",
          "meta": "Un clic, tras los pasos 2 y 3",
          "cta": "Calcular mi puntuación",
          "ctaCalculating": "Ver progreso",
          "ctaDone": "Ver resultados"
        }
      }
    },
    "chapters": {
      "eyebrow": "Cómo funciona",
      "title": "Cuatro capítulos hasta ser Citizen",
      "free": "Gratis para todos",
      "planOrSponsor": "Plan o patrocinio",
      "basics": {
        "title": "Todo empieza por tus datos básicos",
        "body": "Tu CheckUp necesita algunos datos sobre ti, y un documento puede escribir la mayoría por ti.",
        "document": "Una foto de tu pasaporte o DNI rellena tu fecha de nacimiento y ciudadanía.",
        "import": "Un PDF de LinkedIn o un CV rellena tu experiencia, formación, habilidades e idiomas.",
        "check": "No se guarda nada sin que lo revises. Solo escribes dónde vives y tu teléfono.",
        "cta": "Añadir mis datos"
      },
      "checkup": {
        "title": "Un diagnóstico, no un cuestionario",
        "body": "Como un chequeo médico para tu traslado: tu puntuación iQulture, pilar a pilar; qué es fuerte y en qué trabajar."
      },
      "teleportal": {
        "title": "Tu traslado, planificado al día",
        "body": "Cada paso del visado, documento y plazo de tu ruta, con los documentos guardados en tu Vault."
      },
      "qultureup": {
        "title": "Conoce el país antes de llegar",
        "body": "Misiones y mundos sobre la cultura, el trabajo y el día a día de tu destino. Gana millas por el camino."
      },
      "care": {
        "label": "Care y Passport",
        "title": "Instálate, y demuéstralo",
        "body": "Check-ins que te cuidan tras la llegada y un Passport que reúne cada sello de tu viaje."
      }
    },
    "unlock": {
      "badge": "Desbloquea todos los capítulos",
      "title": "El CheckUp es gratis. El resto del viaje se abre de dos maneras.",
      "body": "TelePortal, QultureUp, Care y Passport se abren con un plan propio o cuando una empresa patrocina tu viaje.",
      "plan": {
        "title": "Elige un plan",
        "body": "Todos los capítulos de tu viaje se abren en cuanto eliges.",
        "cta": "Ver planes"
      },
      "sponsor": {
        "title": "Consigue el patrocinio de una empresa",
        "body": "Las empresas que contratan en el extranjero pueden pagar todo tu viaje. Cuando una lo haga, su oferta aparecerá aquí."
      }
    },
    "error": {
      "title": "No se ha podido cargar el inicio",
      "body": "Revisa tu conexión e inténtalo de nuevo."
    },
    "ready": {
      "chipInvited": "Invitado por {{company}}",
      "chipSponsored": "Patrocinado por {{company}}",
      "chipRoute": "Tu viaje · {{origin}} → {{destination}}",
      "title": "Hola, {{name}}: tu mudanza a {{country}} empieza aquí.",
      "titleNoName": "Tu mudanza a {{country}} empieza aquí.",
      "titleNoCountry": "Hola, {{name}}: tu mudanza empieza aquí.",
      "titleBare": "Tu mudanza empieza aquí.",
      "body": "Cinco pasos hasta tu puntuación iQulture: tu preparación, pilar a pilar, y en qué trabajar después. Cada capítulo de tu mudanza se ajusta a ella.",
      "bodyWaiting": "Cinco pasos hasta tu puntuación iQulture. {{company}} la está esperando, y cada capítulo de tu viaje se ajusta a ella.",
      "bodyYours": "Cinco pasos hasta tu puntuación iQulture: es tuya. Tú decides si {{company}} la ve.",
      "stepsAria": "Cinco pasos hasta tu puntuación iQulture",
      "ofTotal": "de {{total}} hechos",
      "now": "Ahora",
      "privacyShared": "{{company}} ve tu puntuación y tu preparación, nunca tus respuestas.",
      "privacyOwn": "Tus respuestas son tuyas. Nadie ve tu puntuación a menos que la compartas.",
      "next": {
        "eyebrow": "Tu próximo paso",
        "whatIs": "¿Qué es el CheckUp?",
        "parts": {
          "videos_watched": "Vídeos",
          "pitch_video": "Tu pitch",
          "language_tests": "Idiomas",
          "motivational_answers": "Motivación",
          "assistant_chat": "Una charla breve"
        },
        "assessment": {
          "title": "Haz la evaluación CheckUp",
          "body": "Cinco partes cortas, unos 15 minutos. Puedes parar y seguir donde lo dejaste.",
          "cta": "Empezar CheckUp"
        },
        "assessmentContinue": {
          "title": "Termina la evaluación CheckUp",
          "body": "{{done}} de {{total}} partes hechas. Siguiente: {{part}}.",
          "cta": "Continuar CheckUp"
        },
        "essential": {
          "title_one": "Añade {{count}} dato para obtener tu puntuación",
          "title_other": "Añade {{count}} datos para obtener tu puntuación",
          "body": "{{items}}: menos de un minuto. Tus respuestas están guardadas; no se pierde nada.",
          "cta": "Añadir los datos"
        },
        "moreData": {
          "title": "Afina tu puntuación",
          "body": "Habilidades, idiomas y experiencia: opcional, y cada una cuenta.",
          "cta": "Importar LinkedIn o CV"
        },
        "score": {
          "title": "Obtén tu puntuación iQulture",
          "titleShared": "Calcula tu puntuación y envíala a {{company}}",
          "body": "Un clic. Tu preparación, pilar a pilar, y en qué trabajar después. Sigue siendo tuya a menos que la compartas.",
          "bodyShared": "Un clic. {{company}} ve tu puntuación y tu preparación, nunca tus respuestas.",
          "cta": "Obtener mi puntuación",
          "ctaShared": "Calcular mi puntuación"
        },
        "retry": {
          "title": "Vuelve a intentar el cálculo",
          "body": "Algo falló por nuestra parte. Tus respuestas están guardadas: no hay nada que rehacer.",
          "cta": "Calcular de nuevo",
          "bodyAiUnavailable": "La IA de Tonnie no estuvo disponible temporalmente; no fue nada que hicieras. Tus respuestas están guardadas: no hay nada que rehacer."
        },
        "calculating": {
          "title": "Estamos calculando tu puntuación",
          "body": "Estamos valorando tus respuestas, tu pitch y tus idiomas. Puedes salir: estará aquí cuando vuelvas.",
          "status": "Calculando…",
          "cta": "Ver CheckUp"
        },
        "failed": {
          "title": "No se ha podido calcular tu puntuación",
          "body": "Algo falló por nuestra parte. Abre tu CheckUp para seguir donde se quedó.",
          "cta": "Abrir CheckUp",
          "bodyAiUnavailable": "La IA de Tonnie no estuvo disponible temporalmente; no fue nada que hicieras. Abre tu CheckUp para calcularla de nuevo."
        }
      },
      "chapters": {
        "title": "Lo que se abre después de tu puntuación",
        "body": "Tu puntuación iQulture ajusta cada capítulo de la mudanza a ti.",
        "bodyPlan": "Todo se abre con un plan, o cuando una empresa patrocina tu viaje.",
        "seePlans": "Ver planes",
        "bodySponsored": "Patrocinado por {{company}}: todos los capítulos están abiertos.",
        "teleportal": "Cada tarea de la mudanza (legal, viaje, instalación) en orden.",
        "qultureup": "Conoce la cultura antes de llegar, un mundo cada vez.",
        "care": "Apoyo después de llegar: check-ins de bienestar e hitos.",
        "passport": "Cada hito de tu viaje, sellado.",
        "open": "Abierto",
        "basic": "Básico · abierto ya",
        "locked": "Se abre con un plan o un patrocinio",
        "passportStatus_one": "{{count}} sello · {{miles}} millas",
        "passportStatus_other": "{{count}} sellos · {{miles}} millas",
        "passportStamps_one": "{{count}} sello",
        "passportStamps_other": "{{count}} sellos",
        "explore": "Explorar",
        "view": "Ver"
      },
      "latest": {
        "eyebrow": "Lo último",
        "empty": "Tus primeros sellos y millas aparecerán aquí."
      },
      "ask": {
        "title": "¿Dudas sobre el CheckUp?",
        "cta": "Preguntar a Tonnie"
      }
    },
    "phone": {
      "surface": {
        "phone": "En tu móvil",
        "computer": "En un ordenador",
        "either": "Móvil u ordenador"
      },
      "emailLink": "Envíame el enlace por correo",
      "shareLink": "Compartir el enlace",
      "emailSent": "Te hemos enviado el enlace por correo: ábrelo en tu ordenador.",
      "emailHeld": "Ahora no podemos enviarte correos. Usa «Compartir el enlace» para enviártelo.",
      "emailFailed": "El correo no se ha enviado. Inténtalo de nuevo o comparte el enlace.",
      "next": {
        "assessment": {
          "title": "Haz la evaluación del CheckUp en un ordenador",
          "body": "Cinco partes cortas, unos 15 minutos, con vídeo y tu pitch, así que está pensada para una pantalla más grande. Puedes parar y seguir donde lo dejaste."
        },
        "assessmentContinue": {
          "title": "Termina la evaluación del CheckUp en un ordenador"
        },
        "calculating": {
          "body": "Estamos valorando tus respuestas, tu pitch y tus idiomas. Te enviaremos una notificación cuando esté lista."
        },
        "score": {
          "body": "Un toque. Tu preparación, pilar a pilar, y en qué trabajar después. Es tuya a menos que la compartas.",
          "bodyShared": "Un toque. {{company}} ve tu puntuación y tu preparación, nunca tus respuestas."
        }
      },
      "header": {
        "route": "{{origin}} → {{destination}}",
        "switchJourney": "Cambiar de viaje. Actual: {{route}}"
      },
      "welcome": {
        "meta": "3 preguntas · en tu móvil"
      },
      "quickStart": {
        "eyebrow": "Ya que estás aquí",
        "title": "Añade tus datos básicos · 1 min",
        "body": "Una foto de tu pasaporte rellena tu fecha de nacimiento y tu ciudadanía."
      },
      "meanwhile": {
        "title": "Mientras tanto, en tu móvil",
        "essential": {
          "title_one": "Añade {{count}} dato que necesita tu puntuación",
          "title_other": "Añade {{count}} datos que necesita tu puntuación",
          "body": "{{items}} · una foto del pasaporte rellena la mayoría"
        }
      },
      "stepsTitle": "Tus cinco pasos",
      "steps": {
        "assessment": {
          "text": "Cinco partes cortas, unos 20 minutos, en un ordenador. Te enviamos el enlace por correo."
        },
        "score": {
          "text": "Un toque, cuando los pasos 2 y 3 estén hechos.",
          "textShared": "Un toque, cuando los pasos 2 y 3 estén hechos, y {{company}} la ve."
        }
      },
      "stepper": {
        "notStarted": "Sin empezar"
      }
    },
    "how": {
      "intro": {
        "eyebrow": "Tu compañero",
        "title": "Tonnie, cada día de tu mudanza",
        "body": "De los primeros planes a instalarte, Tonnie te acompaña, en tu móvil y en la web."
      },
      "chapters": {
        "checkup": {
          "title": "Descubre dónde estás",
          "body": "Tu puntuación de preparación para la mudanza y en qué trabajar después. La evaluación se hace en un ordenador; tu puntuación te acompaña a todas partes."
        },
        "teleportal": {
          "title": "Tu mudanza, paso a paso",
          "body": "Sigue tus tareas e hitos de la mudanza y ve marcándolos a medida que avanzas."
        },
        "qultureup": {
          "title": "Siéntete en casa antes",
          "body": "Misiones breves para aprender la cultura, el idioma y el día a día de tu destino."
        },
        "care": {
          "title": "Apoyo cuando lo necesitas",
          "body": "Contacta con tu equipo de mudanza — mensajes, seguimientos y reuniones, todo en un mismo lugar."
        },
        "passport": {
          "title": "Tu progreso, sellado",
          "body": "Consigue sellos y comprueba lo lejos que has llegado en tu trayecto de mudanza."
        }
      },
      "title": "Cómo funciona Tonnie",
      "start": {
        "title": "Todo empieza con tu viaje",
        "body": "Tres preguntas (adónde vas, tu situación, tu familia) y tu viaje está listo, en el móvil o en la web. De él depende todo lo que sigue."
      }
    }
  },
  "profileImport": {
    "phone": {
      "source": {
        "subtitle": "Leemos tu experiencia, formación, habilidades e idiomas; los revisas antes de guardar nada.",
        "linkedin": "Tu perfil de LinkedIn, guardado como PDF.",
        "cv": "Tu CV: PDF, Word o texto, hasta 10 MB."
      },
      "guide": {
        "title": "Consigue tu PDF de LinkedIn",
        "choose": "Elegir el PDF",
        "steps": {
          "computer": "En un ordenador, abre tu perfil en linkedin.com",
          "save": "Elige Más y luego Guardar en PDF",
          "send": "Envía el PDF a este móvil — por correo, Archivos o iCloud",
          "choose": "Vuelve aquí y elígelo"
        }
      },
      "review": {
        "privacy": "No se guarda nada hasta que pulses Guardar. Tu nombre se queda como está.",
        "save": "Guardar en mi perfil",
        "showAll": "Ver todos ({{count}})",
        "showLess": "Ver menos",
        "present": "Actualidad",
        "languageNoLevel_one": "{{names}}: el documento no indica el nivel, así que no se guarda — añádelo en tu perfil.",
        "languageNoLevel_other": "{{names}}: el documento no indica el nivel, así que no se guardan — añádelos en tu perfil."
      },
      "saved": {
        "title": "Tu perfil está actualizado",
        "body": "Tu experiencia, habilidades e idiomas ya afinan tu puntuación."
      },
      "saveFailed": "No pudimos guardarlo. Revisa tu conexión e inténtalo de nuevo."
    }
  },
  "profileQuality": {
    "calculate": {
      "anyway": "Calcular con lo que tengo",
      "footnote": "Puedes añadir datos y recalcular cuando quieras."
    },
    "backTo": "Volver a {{hero}}",
    "returnHint": "Cada dato que añadas aquí hace {{hero}} más preciso."
  },
  "checkupCard": {
    "status": {
      "answersDone": "Respuestas completas"
    },
    "title": {
      "welcome": "Tu puntuación iQulture, en dos partes",
      "ready": "Tus respuestas están listas"
    },
    "subtitle": {
      "welcome": "Tu puntuación lee tus respuestas y tu perfil juntos: cuanto más completos estén, más precisa será.",
      "ready": "Tu puntuación las lee junto con tu perfil. Añade lo que falta para una puntuación más precisa, o calcula ya.",
      "readyComplete": "Tu perfil también está completo: tu puntuación lee todos los datos."
    },
    "ring": {
      "caption": "tu puntuación",
      "label": "Tu puntuación iQulture aparece aquí cuando se calcule"
    },
    "next": {},
    "part": {
      "answers": "Tus respuestas",
      "done": "Hecho",
      "profileRead": "La puntuación lee {{complete}} de {{total}} datos",
      "profileOptional": "Opcional: afina tu puntuación, y puedes empezar ya.",
      "profileComplete": "Completo: la puntuación lee todos los datos."
    },
    "calculate": {
      "improveFirst": "Mejorar mi perfil primero"
    },
    "basics": {
      "title": "A un paso de tu puntuación",
      "subtitle": "Tus respuestas están guardadas. Añade tus datos básicos para desbloquear el cálculo y completa tu perfil para la puntuación más precisa.",
      "lockedHint": "Se desbloquea cuando tengas los datos básicos.",
      "lockedLabel": "Calcular mi puntuación: bloqueado hasta tener los datos básicos"
    },
    "path": {
      "label": "Tu camino hasta la puntuación",
      "answers": "Tus respuestas",
      "answersState": "Hecho",
      "basics": "Datos básicos",
      "basicsState": "Obligatorio · {{complete}} de {{total}}",
      "profile": "Perfil completo",
      "profileState": "Recomendado · {{percent}}",
      "calculate": "Tu puntuación",
      "calculateState": "Bloqueado"
    },
    "required": {
      "eyebrow": "Obligatorio para calcular",
      "title_one": "Añade {{count}} dato para desbloquear tu puntuación",
      "title_other": "Añade {{count}} datos para desbloquear tu puntuación",
      "addField": "Añadir {{field}}",
      "fastest": "Lo más rápido: escanea tu pasaporte; rellena {{items}} de una vez."
    },
    "recommended": {
      "eyebrow": "Recomendado",
      "title": "Para la puntuación más precisa",
      "body": "Tu puntuación lee {{complete}} de {{total}} datos de tu perfil. Cada uno que añades hace más precisos tus pilares y recomendaciones."
    }
  },
  "heroStart": {
    "status": {
      "notStarted": "Sin empezar",
      "inProgress": "En curso"
    },
    "next": {
      "eyebrow": "Tu siguiente paso"
    },
    "part": {
      "profile": "Tu perfil",
      "addBasics": "Añadir tus datos básicos",
      "improve": "Mejorar mi perfil"
    },
    "profileRead": "{{complete}} de {{total}} datos del perfil añadidos",
    "profileComplete": "Completo: están todos los datos.",
    "teleportal": {
      "title": "Tu plan de traslado, en dos partes",
      "subtitle": "TelePortal crea tu plan a partir de tu configuración y tu perfil: cuanto más completos estén, más precisas serán las tareas y los plazos.",
      "ringCaption": "tu plan",
      "steps": "Tu configuración",
      "why": "Tu nacionalidad, residencia y hogar marcan tu vía de visado.",
      "optional": "Opcional: hace tu plan más preciso, y puedes empezar ya."
    },
    "qultureup": {
      "title": "Tu ruta de aprendizaje, en dos partes",
      "subtitle": "QultureUp adapta tu ruta a tu evaluación y tu perfil: cuanto más completos estén, mejor se ajusta a ti.",
      "ringCaption": "tu ruta",
      "steps": "Tu evaluación",
      "why": "De dónde eres y dónde vives marcan tu punto de partida.",
      "optional": "Opcional: acerca la ruta a ti, y puedes empezar ya."
    },
    "care": {
      "title": "Care, junto a tu viaje",
      "subtitle": "Care empieza con una breve evaluación de cómo te estás adaptando. Tu perfil es la base que lee todo tu viaje.",
      "ringCaption": "tu cuidado",
      "steps": "Tu evaluación",
      "why": "Tu puntuación, tu plan de traslado y tu ruta de aprendizaje lo leen.",
      "optional": "Opcional: mantiene preciso todo tu viaje, y puedes empezar ya."
    },
    "inout": {
      "title": "InOut, para tu permiso de residencia",
      "subtitle": "Cuenta los días que pasas fuera frente a los límites de tu permiso y te avisa a tiempo. Cuatro pasos cortos para empezar.",
      "ringCaption": "días restantes",
      "steps": "La configuración",
      "why": "InOut cuenta a partir de tu permiso y tus viajes — tu perfil no cambia los números.",
      "optional": "Opcional para InOut — mantiene exacto el resto de tu recorrido."
    }
  },
  "inout": {
    "start": {
      "cta": "Empezar InOut",
      "timeEstimate": "Unos 3 minutos",
      "titleStep": "Tu permiso",
      "titleStepDesc": "El permiso de residencia que tienes.",
      "tripsStep": "Tus viajes",
      "tripsStepDesc": "Cada vez que estuviste fuera desde que se expidió.",
      "countryStep": "Tu país",
      "countryStepDesc": "El país de tu permiso de residencia.",
      "datesStep": "Sus fechas",
      "datesStepDesc": "Cuándo se expidió y hasta cuándo es válido.",
      "recover": "Recuperar de tu historial"
    },
    "page": {
      "title": "InOut",
      "subtitle": "Tus días fuera del país de residencia, contados frente a tu permiso.",
      "errorTitle": "No pudimos leer tus contadores",
      "errorBody": "Tu registro está a salvo. Inténtalo de nuevo en un momento.",
      "short": "Días fuera, contados"
    },
    "tabs": {
      "overview": "Resumen",
      "trips": "Viajes",
      "documents": "Documentos",
      "notices": "Avisos",
      "agency": "Asesoría",
      "limits": "Límites",
      "history": "Historial"
    },
    "banner": {
      "away": "Fuera",
      "inHost": "En {{country}}",
      "noTitle": "Ningún permiso en vigor hoy",
      "humanCheck": "Tu permiso sigue sus propias reglas, aún por leer por la asesoría: una persona lo revisa, así que InOut no muestra números.",
      "noBinding": "Hoy no se aplica ningún límite a tu permiso.",
      "bindingUnresolved": "{{rule}} es el primer límite, pero su lectura aún se está fijando: sin número hasta entonces.",
      "daysStillNeeded": "días de presencia pendientes",
      "noNumber": "aún sin número",
      "hourglassLabel": "Reloj de arena: quedan {{left}} de {{limit}} días",
      "daysLeft": "días restantes",
      "toConfirmChip_one": "{{days}} día por confirmar",
      "toConfirmChip_other": "{{days}} días por confirmar",
      "otherSchengen_one": "En otros países Schengen: hasta {{days}} día",
      "otherSchengen_other": "En otros países Schengen: hasta {{days}} días",
      "noTitleOn": "Ningún permiso en vigor el {{date}}",
      "noBindingOn": "El {{date}} no se aplicaba ningún límite a tu permiso."
    },
    "answer": {
      "presenceNeeded_one": "Necesitas {{days}} día más en {{country}}",
      "presenceNeeded_other": "Necesitas {{days}} días más en {{country}}",
      "beyond": "{{rule}}: por encima del límite",
      "unresolved": "Aún sin número",
      "humanCheck": "Una persona revisa tu permiso",
      "headline": "{{rule}}: {{counted}}",
      "headlineAndFirst": "{{headline}}. {{first}}",
      "oneTrip_one": "Puedes estar fuera de {{country}} hasta {{days}} día en un solo viaje",
      "oneTrip_other": "Puedes estar fuera de {{country}} hasta {{days}} días en un solo viaje",
      "thisTrip_one": "Puedes seguir fuera de {{country}} {{days}} día más en este viaje",
      "thisTrip_other": "Puedes seguir fuera de {{country}} {{days}} días más en este viaje",
      "oneTripOutsideEu_one": "Puedes estar fuera de la UE hasta {{days}} día en un solo viaje",
      "oneTripOutsideEu_other": "Puedes estar fuera de la UE hasta {{days}} días en un solo viaje",
      "thisTripOutsideEu_one": "Puedes seguir fuera de la UE {{days}} día más en este viaje",
      "thisTripOutsideEu_other": "Puedes seguir fuera de la UE {{days}} días más en este viaje",
      "unit": {
        "oneTrip": "días en un solo viaje",
        "thisTrip": "días más en este viaje"
      },
      "short": {
        "oneTrip_one": "Puedes estar fuera hasta {{days}} día",
        "oneTrip_other": "Puedes estar fuera hasta {{days}} días",
        "thisTrip_one": "Puedes seguir fuera {{days}} día más",
        "thisTrip_other": "Puedes seguir fuera {{days}} días más"
      },
      "detail": {
        "oneTrip": "En un solo viaje fuera de {{country}}, a partir de hoy, sin pasar ningún límite de tu permiso.",
        "thisTrip": "En este viaje, sin pasar ningún límite de tu permiso.",
        "oneTripOutsideEu": "En un solo viaje fuera de la UE, a partir de hoy, sin pasar ningún límite de tu permiso.",
        "thisTripOutsideEu": "En este viaje fuera de la UE, sin pasar ningún límite de tu permiso.",
        "oneTripFrom": "En un solo viaje fuera de {{country}}, a partir del {{date}}, sin pasar ningún límite de tu permiso.",
        "oneTripOutsideEuFrom": "En un solo viaje fuera de la UE, a partir del {{date}}, sin pasar ningún límite de tu permiso.",
        "thisTripOn": "En el viaje en curso el {{date}}, sin pasar ningún límite de tu permiso.",
        "thisTripOutsideEuOn": "En el viaje fuera de la UE en curso el {{date}}, sin pasar ningún límite de tu permiso."
      }
    },
    "binding": {
      "alreadyReached": "{{rule}}: los días que registraste ya superan el límite.",
      "mayBeReached": "{{rule}}: el límite puede superarse si cuentan los días por confirmar.",
      "earliestExhaustion": "{{rule}} es el primero en llegar a su límite: el {{date}}, a este ritmo.",
      "leastRemaining": "{{rule}} es el más cercano a su límite."
    },
    "switch": {
      "inHost": "En {{country}}",
      "awaySince": "Fuera desde el {{date}}",
      "leave": "Salgo hoy",
      "back": "Hoy vuelvo a {{country}}",
      "caption": "Un toque es un registro: puedes corregirlo justo después.",
      "confirm": {
        "leftTitle": "Estás fuera desde el {{date}}",
        "leftBody": "Registrado. Buen viaje.",
        "leftTo": "Registrado: a {{country}}, como planeaste. Buen viaje.",
        "undo": "Deshacer",
        "correct": "Corregir",
        "done": "Hecho",
        "undone": "Deshecho: no queda nada registrado.",
        "backTitle": "Bienvenido de vuelta",
        "backBody_one": "Estuviste fuera del {{from}} al {{to}}: {{days}} día.",
        "backBody_other": "Estuviste fuera del {{from}} al {{to}}: {{days}} días.",
        "adjust": "Ajustar las fechas",
        "yes": "Sí, es correcto",
        "correctTitle": "¿Saliste otro día o quieres decir adónde fuiste?",
        "correctHint": "La fecha y el destino se ajustan aquí.",
        "undoTitle": "¿Lo tocaste por error?",
        "undoHint": "No queda nada registrado.",
        "adjustTitle": "¿Las fechas fueron otras?",
        "adjustHint": "Ajusta el día en que saliste y el día en que volviste.",
        "continuedTitle": "Has vuelto a salir hoy",
        "continuedBody": "Tu viaje del {{from}} continúa — hoy ya contaba y cuenta una sola vez.",
        "undoContinuedHint": "El viaje vuelve a terminar hoy, como estaba."
      }
    },
    "clocks": {
      "title": "Tus límites",
      "humanCheck": "Tu permiso sigue sus propias reglas, aún por leer por la asesoría. Una persona lo revisa; mientras tanto, InOut no muestra números.",
      "empty": "Hoy no se aplica ninguna regla a tu permiso.",
      "disclaimer": "InOut hace la aritmética de tu registro; nunca es una opinión jurídica. Para una decisión, consulta a la asesoría.",
      "emptyOn": "El {{date}} no se aplicaba ninguna regla a tu permiso."
    },
    "clock": {
      "name": {
        "awayFromHost": "Días fuera de {{country}}",
        "outsideEu": "Días fuera de la UE",
        "countedInHost": "Días contados en {{country}}",
        "otherSchengen": "Días en otros países Schengen",
        "eachTripFromHost": "Cada salida de {{country}}",
        "eachTripOutsideEu": "Cada salida de la UE",
        "eachStayInHost": "Cada estancia en {{country}}",
        "eachStayOtherSchengen": "Cada estancia en otros países Schengen",
        "neededOutsideHost": "Días necesarios fuera de {{country}}",
        "neededOutsideEu": "Días necesarios fuera de la UE",
        "neededInHost": "Días necesarios en {{country}}",
        "neededOtherSchengen": "Días necesarios en otros países Schengen",
        "unbrokenOutsideHost": "Tiempo seguido necesario fuera de {{country}}",
        "unbrokenOutsideEu": "Tiempo seguido necesario fuera de la UE",
        "unbrokenInHost": "Tiempo seguido necesario en {{country}}",
        "unbrokenOtherSchengen": "Tiempo seguido necesario en otros países Schengen"
      },
      "window": "contados del {{from}} al {{to}}",
      "windowOpen": "contados desde el {{from}}",
      "status": {
        "within": "Dentro del límite",
        "depends": "Depende de días por confirmar",
        "beyond": "Por encima del límite",
        "unresolved": "En definición",
        "notApplicable": "No se aplica"
      },
      "plannedBy": "Lectura más estricta",
      "counted": "{{value}} de {{limit}} días",
      "longestTrip": "La más larga hasta ahora: {{value}} de {{limit}} días",
      "longestTripOn": "La más larga hasta el {{date}}: {{value}} de {{limit}} días",
      "tripUpTo_one": "desde hoy, hasta {{days}} día seguido fuera",
      "tripUpTo_other": "desde hoy, hasta {{days}} días seguidos fuera",
      "left_one": "queda {{days}} día",
      "left_other": "quedan {{days}} días",
      "stillNeeded_one": "falta {{days}} día de presencia",
      "stillNeeded_other": "faltan {{days}} días de presencia",
      "margin_one": "±{{days}} día aún por confirmar: depende de ti.",
      "margin_other": "±{{days}} días aún por confirmar: depende de ti.",
      "settleMargin": "Confirmarlos",
      "exhaustsOn": "A este ritmo, el límite se superaría el {{date}}.",
      "riskZone": "Dos normas discrepan entre {{from}} y {{to}} días: una zona de riesgo, no un margen.",
      "inRiskZone": "Estás en esa zona.",
      "noNumber": "Aún no hay número para esta regla.",
      "owner": {
        "agency": "La asesoría está fijando la lectura: no tienes que hacer nada.",
        "tonnie": "Tonnie está fijando la lectura: no tienes que hacer nada.",
        "user": "Solo tú puedes resolverlo: el CoPilot te explica qué falta."
      },
      "consequence": {
        "mayCancel": "Por encima, la ley permite cancelar el permiso.",
        "losesStatus": "Por encima, la ley dice que el estatus se pierde.",
        "blocksAcquisition": "Por encima, el tiempo deja de contar para un derecho de larga duración.",
        "irregularStay": "Por encima, la estancia en esos países pasa a ser irregular."
      },
      "info": "Sobre «{{rule}}»",
      "lawTitle": "Qué dice la ley",
      "exceptionsTitle": "Excepciones que prevé la ley",
      "exceptionTiming": "{{timing}} ({{source}})",
      "short": {
        "awayFromHost": "Días fuera",
        "outsideEu": "Fuera de la UE",
        "countedInHost": "Días contados",
        "otherSchengen": "Schengen",
        "eachTripFromHost": "Cada salida",
        "eachTripOutsideEu": "Cada salida de la UE",
        "eachStayInHost": "Cada estancia",
        "eachStayOtherSchengen": "Estancias Schengen",
        "neededOutsideHost": "Días fuera",
        "neededOutsideEu": "Fuera de la UE",
        "neededInHost": "Días aquí",
        "neededOtherSchengen": "Días Schengen",
        "unbrokenOutsideHost": "Tiempo fuera",
        "unbrokenOutsideEu": "Tiempo fuera UE",
        "unbrokenInHost": "Tiempo aquí",
        "unbrokenOtherSchengen": "Tiempo Schengen"
      },
      "tripUpToFrom_one": "desde el {{date}}, hasta {{days}} día seguido fuera",
      "tripUpToFrom_other": "desde el {{date}}, hasta {{days}} días seguidos fuera",
      "marginOn_one": "±{{days}} día sin confirmar el {{date}}.",
      "marginOn_other": "±{{days}} días sin confirmar el {{date}}.",
      "exhaustsOnFrom": "Al ritmo que llevaba el {{asOf}}, el límite se superaría el {{date}}.",
      "inRiskZoneOn": "El {{date}} estabas en esa zona."
    },
    "exceptions": {
      "timing": {
        "beforeDeparture": "se pide antes de salir",
        "any": "se puede pedir en cualquier momento"
      }
    },
    "precision": {
      "margin_one": "{{days}} día que nadie ha confirmado puede cambiar un límite.",
      "margin_other": "{{days}} días que nadie ha confirmado pueden cambiar un límite.",
      "addTrip": "Añadir viaje",
      "answerQuestion": "Responder a InOut",
      "title": "Días por confirmar",
      "complete": "Tu registro está completo al {{percent}}.",
      "checkTrip": "Ver tus viajes",
      "reason": {
        "openQuestion": "La pregunta abierta de InOut es sobre estos días.",
        "unanswered": "Su pregunta se cerró sin respuesta: aún puedes añadir un viaje de ese periodo.",
        "wasAway": "Dijiste que estuviste fuera: falta añadir el viaje.",
        "notAskedYet": "Ninguna pregunta ha tratado aún estos días: la próxima lo hará.",
        "uncertainTrip": "Un viaje cuyas fechas no son seguras."
      }
    },
    "renewal": {
      "title": "Ventana de renovación",
      "none": "Tu permiso no tiene ventana de renovación.",
      "window": "Del {{opens}} al {{closes}}",
      "planTrips": "Planifica los viajes en torno a ella: la renovación se pide en persona."
    },
    "acquisition": {
      "title": "Hacia un derecho de larga duración",
      "subtitle": "Para lo que está contando tu tiempo en el país.",
      "status": {
        "accruing": "Contando",
        "complete": "Periodo completo",
        "depends": "Depende de días por confirmar",
        "toleranceExceeded": "Ausencias por encima de la tolerancia",
        "unresolved": "En definición",
        "notApplicable": "No se aplica"
      },
      "completesOn": "El periodo se completaría el {{date}} si se mantienen las tolerancias.",
      "cumulative": "Ausencias en total: {{value}} de {{tolerance}} días tolerados",
      "consecutive": "Ausencia más larga: {{value}} de {{tolerance}} días tolerados",
      "info": "Sobre «{{right}}»",
      "completeOn": "Completo el {{date}}",
      "progress_one": "{{done}} de {{total}} año",
      "progress_other": "{{done}} de {{total}} años"
    },
    "chronology": {
      "title": "Tus viajes",
      "subtitle": "Todas las veces que estuviste fuera. Los días que nadie confirma quedan inciertos: nunca cuentan como días en que estuviste aquí.",
      "add": "Añadir viaje",
      "error": "No pudimos leer tus viajes.",
      "short": "Todos tus viajes",
      "group": {
        "now": "Ahora",
        "done": "Realizados",
        "planned": "Planificados"
      },
      "emptyTitle": "Aún no hay viajes",
      "emptyBody": "Usa el interruptor cuando salgas, o añade uno que ya hiciste."
    },
    "absence": {
      "range": "{{from}} – {{to}}",
      "stillAway": "Desde el {{from}}: aún fuera",
      "days_one": "{{days}} día",
      "days_other": "{{days}} días",
      "noDestination": "Destino sin indicar",
      "bySwitch": "Registrado con «Salgo hoy»",
      "documents_one": "{{count}} documento",
      "documents_other": "{{count}} documentos",
      "edit": "Corregir el viaje del {{from}}",
      "remove": "Eliminar el viaje del {{from}}",
      "addTitle": "Añadir un viaje",
      "editTitle": "Corregir un viaje",
      "description": "El día en que saliste y el día en que volviste cuentan como días fuera.",
      "departedOn": "Salida",
      "returnedOn": "Regreso",
      "stillAwayHint": "¿Aún fuera? Deja vacía la fecha de regreso.",
      "destination": "A dónde fuiste",
      "destinationPlaceholder": "Elige un país (opcional)",
      "destinationHint": "Algunas reglas solo cuentan ciertos países. Sin destino, esos días quedan inciertos.",
      "saved": "Viaje guardado.",
      "removeTitle": "¿Eliminar este viaje?",
      "removeBody": "Solo para un viaje registrado por error: sus días dejan de contar y sus documentos quedan en tu Bóveda.",
      "removeConfirm": "Eliminar viaje",
      "removed": "Viaje eliminado.",
      "fromPassTitle": "Confirmar el viaje de la tarjeta de embarque",
      "fromPassDescription": "Leímos estas fechas y el destino de tu tarjeta. Revísalos y guarda.",
      "removeThis": "Eliminar este viaje",
      "join": "Unir en un solo viaje",
      "joined": "Viajes unidos en uno."
    },
    "form": {
      "dateRequired": "Elige las fechas.",
      "dateInvalid": "Escribe una fecha válida o elígela en el calendario.",
      "returnBeforeDeparture": "El regreso es anterior a la salida.",
      "pickDate": "Elige una fecha"
    },
    "planner": {
      "title": "Planificar un viaje",
      "subtitle": "Mira lo que un viaje hace a tus límites antes de reservarlo. Un viaje planificado permite que el aviso te llegue antes de salir.",
      "departsOn": "Salida",
      "returnsOn": "Regreso",
      "destination": "A dónde vas",
      "simulate": "Ver el efecto",
      "plan": "Planificar",
      "planned": "Viaje planificado.",
      "onReturn": "A tu regreso, el {{date}}",
      "duringRenewalWindow": "Este viaje cae en tu ventana de renovación: la renovación se pide en persona.",
      "outlastsTitle": "Volverías después de que caduque tu permiso.",
      "ahead": "Próximos viajes",
      "empty": "Ningún viaje planificado.",
      "listError": "No pudimos leer tus viajes planificados.",
      "remove": "Eliminar el viaje planificado del {{from}}",
      "removed": "Viaje planificado eliminado.",
      "now": "Hoy",
      "removeTitle": "¿Quitar este viaje previsto?",
      "removeBody": "Sale de los viajes previstos e InOut deja de recordártelo.",
      "removeConfirm": "Quitar viaje previsto",
      "limitMoved": "{{name}}: {{from}} → {{to}} de {{limit}} días"
    },
    "timeline": {
      "title": "Tu registro en el tiempo",
      "window": "La ventana de «{{rule}}», con tus viajes",
      "today": "Hoy",
      "trip": "Viaje",
      "planned": "Planificado",
      "renewal": "Ventana de renovación",
      "loadError": "No se han podido leer sus viajes planificados, así que la línea no se muestra.",
      "away": "Aún fuera",
      "uncertain": "Días por confirmar",
      "emptyWindow": "Aún no hay viajes en la ventana del {{from}} al {{to}}.",
      "empty": "Aún no hay viajes en esta ventana: cada viaje que añadas aparece aquí."
    },
    "documents": {
      "title": "Documentos de tus viajes",
      "subtitle": "Los documentos de cada viaje: lo que prueba el viaje y el contexto de la ausencia.",
      "provisional": "Esta organización es provisional hasta que la asesoría confirme la lista.",
      "provisionalBadge": "Lista provisional",
      "scope": "No te decimos qué documentos necesitas: eso es una evaluación jurídica, que hace la asesoría. Nosotros guardamos, organizamos y entregamos.",
      "info": "Sobre estos documentos",
      "empty": "Aún no hay viajes: los documentos se adjuntan a un viaje.",
      "error": "No pudimos leer tus documentos.",
      "none": "Sin documentos",
      "whatItIs": "Qué es",
      "uploading": "Guardando…",
      "attached": "Documento añadido al viaje.",
      "detach": "Quitar {{name}} de este viaje",
      "addTitle": "Añadir un documento",
      "add": "Añadir",
      "addDocument": "Añadir documento",
      "whichDocument": "¿Qué documento es?",
      "uploadingFile": "Guardando {{name}}…",
      "open": "Abrir {{item}} — {{name}}",
      "openError": "No se pudo abrir este documento. Inténtalo de nuevo.",
      "detached": "Documento quitado del viaje.",
      "short": "Pruebas de cada viaje",
      "reason": {
        "label": "Motivo de la ausencia",
        "none": "Sin motivo indicado",
        "info": "Sobre el motivo",
        "hint": "Queda en tu registro y en el dossier para la asesoría. No cambia el cómputo de los días."
      },
      "addToFamily": "Añadir a «{{family}}» — el viaje del {{from}}",
      "undo": "Deshacer",
      "reattached": "Documento adjuntado de nuevo al viaje.",
      "emptyTitle": "Aún no hay viajes",
      "emptyBody": "Los documentos van con un viaje: añade el primero.",
      "fromVaultDescription": "Para «{{family}}» — el viaje del {{from}}."
    },
    "notices": {
      "leadTimeTitle": "Avisarme antes de que se supere un límite",
      "leadTimeWhy": "Tiempo para pedir autorización previa antes de salir: la ley la exige antes de la partida.",
      "leadTimeOption_one": "{{days}} día antes",
      "leadTimeOption_other": "{{days}} días antes",
      "cadenceTitle": "Preguntarme si estuve en el país",
      "cadenceWhy": "Mantiene tu registro completo. Si no respondes, no se da nada por supuesto: esos días quedan por confirmar.",
      "cadence": {
        "P15D": "Cada 15 días",
        "P30D": "Cada 30 días",
        "P1M": "Una vez al mes",
        "OFF": "Nunca"
      },
      "channelsTitle": "Por dónde llegan",
      "push": "Notificaciones push",
      "email": "Correo electrónico",
      "error": "No pudimos leer tus avisos.",
      "questionsError": "No se han podido leer las preguntas de InOut.",
      "questionsTitle": "Preguntas de InOut",
      "questionsSubtitle": "Solo preguntamos si estuviste en el país, nunca dónde estás.",
      "question": "¿Estuviste en {{country}} todos los días del {{from}} al {{to}}, salvo los viajes que registraste?",
      "answerInHost": "Sí, estuve",
      "answerWasAway": "No, estuve fuera",
      "wasAwayHint": "Las fechas preguntadas abren un viaje nuevo, listo para guardar.",
      "questionWhy": "Sin respuesta, estos días quedan por confirmar: nunca cuentan como días en que estuviste aquí.",
      "thanksInHost": "Gracias: esos días quedan confirmados.",
      "addTheTrip": "Nos dijiste que estuviste fuera.",
      "noHistory": "Ninguna pregunta anterior.",
      "whyLabel": "Por qué importa",
      "confirmation": {
        "state": {
          "open": "Esperando tu respuesta",
          "inHost": "Confirmaste que estuviste aquí",
          "wasAway": "Dijiste que estuviste fuera",
          "noAnswer": "Sin respuesta: días por confirmar"
        }
      },
      "next": {
        "none": "No hay avisos a la vista: InOut te avisará cuando los haya."
      },
      "upcomingTitle": "Próximos avisos",
      "upcomingSubtitle": "Lo que InOut te enviará, y cuándo, según las normas de {{country}} y tus preferencias.",
      "upcoming": {
        "leadTime": "Aviso antes de un límite",
        "leadTimeDetail_one": "Con los viajes en curso y planificados, «{{rule}}» llegaría a su límite el {{date}}: te avisamos {{days}} día antes.",
        "leadTimeDetail_other": "Con los viajes en curso y planificados, «{{rule}}» llegaría a su límite el {{date}}: te avisamos {{days}} días antes.",
        "confirmation": "Pregunta de presencia",
        "confirmationDetail": "Si estuviste en {{country}} del {{from}} al {{to}}: sí o no.",
        "renewalWindow": "Se abre el plazo de renovación",
        "renewalWindowDetail": "Puedes pedir la renovación de tu título del {{from}} al {{to}}.",
        "inDays_one": "dentro de {{days}} día",
        "inDays_other": "dentro de {{days}} días"
      },
      "chip": {
        "app": "App",
        "push": "Push",
        "email": "Correo"
      },
      "appChannel": "En la app",
      "appHint": "Aquí y en el móvil.",
      "pushHint": "En el móvil, incluso con la app cerrada.",
      "emailHint": "Al correo de tu cuenta.",
      "preferencesTitle": "Tus preferencias",
      "preferencesSubtitle": "Cada elección se guarda al momento.",
      "saving": "Guardando…",
      "savedShort": "Guardado",
      "recommended": "Recomendado",
      "cadenceOffNote": "Sin preguntas, los próximos días quedan por confirmar hasta que los confirmes en el Resumen.",
      "upToDate": "Estás al día",
      "noOpenQuestionNext": "Ninguna pregunta pendiente. La próxima llega el {{date}}.",
      "noOpenQuestionOff": "Ninguna pregunta pendiente: las preguntas están desactivadas.",
      "historyTitle": "Respuestas anteriores",
      "seeTrips": "Ver los viajes",
      "leadTimeUnit_one": "día antes",
      "leadTimeUnit_other": "días antes",
      "always": "Siempre",
      "comesBy": "Llegan por",
      "screenSubtitle": "Lo que InOut te preguntó, y lo que viene después"
    },
    "errors": {
      "overlap": "Comparte un día con tu viaje del {{from}} al {{to}}. Corrige uno de ellos.",
      "overlapOpen": "Ya estás fuera desde el {{from}}. Cierra antes ese viaje.",
      "notSetUp": "Configura antes InOut: los viajes cuentan frente a tu permiso.",
      "deactivated": "Tu InOut está desactivado: reactívalo para volver a registrar viajes.",
      "caseOpen": "InOut sigue en marcha mientras tu caso con la asesoría esté abierto.",
      "handoffNotFound": "Este cálculo ha caducado o ya se ha usado: vuelve a calcular, lleva un minuto.",
      "ruleValue": "Esa opción no es una de las de tu país.",
      "datesOutOfOrder": "Las fechas no están en orden.",
      "notAway": "Ese viaje ya está cerrado.",
      "calculationRefused": "Las reglas del país han cambiado desde su cálculo. Hágalo de nuevo en la calculadora de InOut: lee las reglas tal como están ahora.",
      "lastTitle": "Tu InOut necesita un permiso de residencia. Para empezar de nuevo, empieza un InOut nuevo.",
      "confirmationClosed": "Esa pregunta ya está cerrada.",
      "notFound": "No encontramos eso en tu registro.",
      "generic": "Algo ha fallado. Inténtalo de nuevo en un momento.",
      "agencyUnavailable": "La asesoría de tu país aún no acepta solicitudes.",
      "consentRequired": "Aprueba primero lo que compartes con la asesoría.",
      "slotUnavailable": "Esa hora ya no está libre. Elige otra.",
      "tooCloseToMove": "Falta muy poco para la consulta para cambiarla ahora.",
      "notMovable": "Esta consulta no se puede cambiar.",
      "requisitionExists": "Este caso ya tiene su solicitud.",
      "calendarUnavailable": "No se puede acceder a la agenda de la asesoría en este momento.",
      "calendarAvailable": "La agenda de la asesoría vuelve a estar disponible: elige una hora.",
      "fileNotLinkable": "Ese documento ya no está en tu Bóveda — elige otro.",
      "aiUnavailable": "La calculadora de InOut no puede responder ahora mismo. Vuelve a intentarlo en un momento; tu registro está a salvo.",
      "touches": "Empieza o termina el día de tu viaje del {{from}} – {{to}}. Únelos en uno — ese día cuenta una vez.",
      "touchesOpen": "Termina el día en que empezó tu viaje aún en curso, {{from}}. Únelos en uno — ese día cuenta una vez.",
      "notJoinable": "Estos viajes ya no coinciden en un solo día — corrige las fechas y guarda de nuevo.",
      "caseOpenChange": "Tu InOut se queda como está mientras tu caso con la asesoría esté abierto: la asesoría trabaja sobre él.",
      "recordInUse": "Este InOut pertenece a un caso con la asesoría: no se puede eliminar.",
      "notClosed": "Solo un InOut de tu historial se puede recuperar o eliminar.",
      "noTitle": "Este InOut no tiene ningún permiso de residencia: no puede volver a ser tu InOut. Empieza uno nuevo."
    },
    "setup": {
      "notServed": "InOut aún no cuenta días para {{country}}.",
      "regimesError": "No pudimos leer los permisos de este país.",
      "regime": "El permiso que tienes",
      "regimeRequired": "Elige tu permiso.",
      "subtype": "Qué tipo",
      "issuedOn": "Emitido el",
      "validUntil": "Válido hasta",
      "expiresBeforeIssued": "La caducidad es anterior a la emisión."
    },
    "calculator": {
      "back": "Atrás",
      "poweredBy": "Powered by Tonnie",
      "name": "Calculadora de ausencias",
      "stepOf": "Paso {{step}} de {{total}}",
      "stepAnnouncement": "{{step}}: {{title}}",
      "progress": "Tu progreso",
      "country": {
        "question": "¿Qué país emitió tu permiso de residencia?",
        "hint": "InOut cuenta tus días según las reglas de ese país.",
        "comingSoon": "Próximamente",
        "required": "Elige el país."
      },
      "title": {
        "question": "¿Qué permiso tienes?",
        "hint": "Cada uno tiene sus propios límites de tiempo fuera. El nombre figura en tu tarjeta.",
        "showAll_one": "Ver {{titles}} permiso más",
        "showAll_other": "Ver {{titles}} permisos más",
        "subtypeNone": "Elige el tipo",
        "notSure": "No estoy seguro",
        "notSureHelp": "El tipo de permiso figura en tu tarjeta de residencia. ¿Aún no tienes la tarjeta? Elige el permiso que solicitaste: podrás corregirlo en InOut más adelante. Una asesoría migratoria regulada puede decirte cuál te corresponde."
      },
      "dates": {
        "question": "¿Cuándo se emitió?",
        "hint": "Las dos fechas figuran en tu tarjeta. Tus días cuentan desde la fecha de emisión.",
        "issuedPlaceholder": "Elige la fecha de emisión",
        "validPlaceholder": "Elige la fecha de caducidad",
        "noEnd": "Mi permiso no tiene fecha de caducidad",
        "noEndSet": "Sin fecha de caducidad."
      },
      "trips": {
        "question": "¿Cuándo estuviste fuera?",
        "hint": "Todos los viajes desde la emisión del permiso: el día que saliste y el día que volviste cuentan los dos.",
        "add": "Añadir un viaje",
        "none": "¿No has salido? Entonces no hay nada que añadir: ve tus días directamente.",
        "save": "Guardar viaje",
        "saveFirst": "Primero guarda o cancela el viaje que estás escribiendo.",
        "calculate": "Ver mis días"
      },
      "result": {
        "title": "Tus días, contados",
        "subtitle": "Leídos por el mismo motor que InOut en Tonnie Citizen. No se ha guardado nada.",
        "asOf": "A fecha de {{date}}",
        "startTitle": "Empezar InOut con esto",
        "startWhy": "Tu registro queda tal como lo describiste, e InOut te avisa antes de un límite. Puedes cambiarlo en cualquier momento.",
        "start": "Empezar InOut",
        "uncertainBetween": "No has dicho si estuviste en el país entre los viajes, así que esos días cuentan como posiblemente fuera.",
        "countRest": "Estuve en {{country}}",
        "whatIfTitle": "¿Y si viajo?",
        "whatIfSubtitle": "Prueba un viaje antes de reservarlo: tus días se leen el día en que volverías. No se guarda nada.",
        "change": "Cambiar mis respuestas",
        "restart": "Empezar de nuevo"
      },
      "dialogDescription": "Describe tu autorización de residencia y tus viajes; guardar la respuesta empieza InOut con ella.",
      "discard": {
        "title": "¿Cerrar la calculadora?",
        "body": "Tus respuestas no se guardan: al cerrar, se pierden.",
        "confirm": "Cerrar y descartar",
        "keep": "Seguir respondiendo",
        "restartTitle": "¿Empezar de nuevo?",
        "restartBody": "Se borrarán las respuestas que has dado."
      }
    },
    "embed": {
      "language": "Idioma",
      "keepTitle": "Guárdalo en Tonnie y recibe un aviso antes de un límite",
      "keepWhy": "Tus respuestas se quedan en este navegador hasta que continúes. Al continuar, se envían a Tonnie, que las guarda durante 72 horas para que crees tu cuenta y empieces InOut con ellas.",
      "keep": "Continuar en Tonnie",
      "handedOffTitle": "Continúa en Tonnie",
      "handedOffBody": "Tonnie se abrió en una pestaña nueva con tu cálculo. Crea allí tu cuenta para guardarlo. El enlace funciona una vez, durante 72 horas.",
      "blockedBody": "Tu navegador no abrió una pestaña nueva. Continúa con el botón de abajo. El enlace funciona una vez, durante 72 horas.",
      "continue": "Abrir Tonnie",
      "unavailableTitle": "La calculadora no está disponible aquí",
      "unavailableBody": "Esta página no está configurada para mostrar la calculadora InOut.",
      "loadFailedTitle": "No se ha podido cargar la calculadora",
      "loadFailedBody": "No se ha podido contactar con Tonnie. Compruebe la conexión e inténtelo de nuevo."
    },
    "presence": {
      "restInHost": "El resto del tiempo estuve en {{country}}",
      "restInHostHint": "Sin esto, los días entre tus viajes cuentan como posiblemente fuera.",
      "title": "Sus años, día a día",
      "subtitle": "Cada día de su registro, más allá de la ventana de cualquier regla.",
      "here": "En {{country}}",
      "away": "Fuera",
      "travel": "Día de viaje",
      "uncertain": "Por confirmar",
      "planned": "Previsto",
      "hereCount_one": "{{days}} día en {{country}}",
      "hereCount_other": "{{days}} días en {{country}}",
      "awayCount_one": "{{days}} día fuera",
      "awayCount_other": "{{days}} días fuera",
      "travelCount_one": "{{days}} día de viaje",
      "travelCount_other": "{{days}} días de viaje",
      "uncertainCount_one": "{{days}} día por confirmar",
      "uncertainCount_other": "{{days}} días por confirmar",
      "plannedCount_one": "{{days}} día previsto",
      "plannedCount_other": "{{days}} días previstos",
      "year": "{{year}}: {{summary}}",
      "travelNote": "Un día de viaje (el día en que sale o vuelve) cuenta como dicen las reglas de {{country}}.",
      "loadError": "No se han podido leer sus días a lo largo de los años."
    },
    "adopt": {
      "working": "Configurando InOut con tu cálculo…",
      "recorded": "InOut está configurado con tu cálculo.",
      "already": "InOut ya estaba configurado: tu registro se mantiene tal cual.",
      "refusedTitle": "No se ha podido usar tu cálculo",
      "waitingTitle": "Un cálculo en espera",
      "waitingBody": "Calculaste en un portal colaborador y ya tienes un InOut. Se queda como está, o empieza un nuevo InOut con este cálculo y el que tienes pasa a tu historial.",
      "keepMine": "Mantener mi InOut",
      "newWithIt": "Empezar un nuevo InOut con este cálculo",
      "newDone": "Tu nuevo InOut está en marcha con el cálculo del portal: el anterior está en tu historial."
    },
    "signup": {
      "titleFeminine": "Guarda el cálculo de InOut que hiciste en {{portal}}",
      "titleMasculine": "Guarda el cálculo de InOut que hiciste en {{portal}}",
      "description_one": "Guardamos tu cálculo: {{count}} viaje. Crea tu cuenta para conservarlo.",
      "description_other": "Guardamos tu cálculo: {{count}} viajes. Crea tu cuenta para conservarlo.",
      "descriptionAnswer": "{{answer}}. Crea tu cuenta para guardar este cálculo.",
      "descriptionBeyond": "Ya has superado uno de tus límites. Crea tu cuenta para guardar este cálculo y ver cuál.",
      "goneTitle": "Ese enlace al cálculo ha caducado",
      "goneDescription": "Funciona una vez, durante 72 horas. Crea tu cuenta: la calculadora de InOut está a un toque dentro.",
      "unreadTitle": "Su cálculo está a salvo",
      "unreadDescription": "No hemos podido mostrarlo ahora, pero se conserva: InOut lo usa en cuanto exista su cuenta."
    },
    "phone": {
      "title": "Guarde su cálculo en la app Tonnie",
      "body": "La app lo guarda, cuenta sus días y le avisa antes de un límite. El enlace funciona una vez, durante 72 horas.",
      "openApp": "Abrir en la app",
      "installApp": "Instalar la app",
      "installHint": "Después de instalarla, abra la app en los 15 minutos siguientes: su cálculo va con ella.",
      "goneBody": "Funciona una vez, durante 72 horas. En la app Tonnie, la calculadora de InOut está a un toque."
    },
    "keepCalculation": {
      "signUp": "Crear mi cuenta",
      "signIn": "Ya tengo cuenta"
    },
    "sharedDossier": {
      "title": "Dosier de un caso InOut",
      "body": "Una persona compartió su registro de residencia con tu asesoría para su solicitud. El dosier se genera a partir de su registro cuando lo descargas.",
      "download": "Descargar el dosier (PDF)",
      "downloading": "Preparando el dosier…",
      "failed": "No se pudo descargar el dosier. Inténtalo de nuevo en un momento.",
      "unavailableTitle": "Este enlace no se puede abrir",
      "unavailableBody": "Puede haber caducado, o la persona puede haber retirado su consentimiento. Contacta con Tonnie si todavía necesitas el dosier."
    },
    "case": {
      "state": {
        "open": "Abierto",
        "inProgress": "En curso",
        "closed": "Cerrado"
      },
      "closedReason": {
        "completed": "Completado",
        "withoutSubmission": "Cerrado sin presentación"
      }
    },
    "consultation": {
      "state": {
        "pendingPayment": "Pendiente de pago",
        "paid": "Pagada — reservando",
        "scheduled": "Reservada",
        "completed": "Realizada",
        "paymentReceivedRebook": "Pagada — elige otra hora",
        "cancelledByAgency": "Cancelada por la asesoría — reserva de nuevo",
        "checkoutExpired": "No pagada"
      }
    },
    "requisition": {
      "state": {
        "pendingPayment": "Pendiente de pago",
        "paid": "Pagada — dosier en camino",
        "delivered": "Dosier en la asesoría",
        "inProgress": "En curso",
        "completed": "Completada",
        "closedWithoutSubmission": "Cerrada sin presentación",
        "checkoutExpired": "No pagada"
      },
      "stepsLabel": "Dónde está tu solicitud",
      "step": {
        "delivered": "Dosier entregado",
        "working": "La asesoría se ocupa",
        "done": "Completado",
        "closed": "Cerrado"
      },
      "next": {
        "paid": "Tu dosier se está preparando y enviando a {{agency}}.",
        "delivered": "{{agency}} tiene tu dosier y te contactará sobre el siguiente paso.",
        "inProgress": "{{agency}} se está ocupando de tu solicitud y te contactará si necesita algo.",
        "completed": "{{agency}} ha terminado tu solicitud.",
        "closedWithoutSubmission": "{{agency}} cerró la solicitud sin presentarla. Si no lo esperabas, contacta con {{agency}}."
      },
      "receives": "Qué recibe {{agency}}"
    },
    "refundRequest": {
      "state": {
        "requested": "Solicitada",
        "handledExternally": "Tramitada"
      }
    },
    "operations": {
      "eventSource": {
        "agencyFile": "Archivo de la asesoría",
        "operator": "Registrado por Tonnie"
      },
      "files": {
        "state": {
          "previewed": "Comprobado — listo para cargar",
          "accepted": "Cargado",
          "rejected": "Rechazado — nada cargado",
          "expired": "Caducado — compruébalo de nuevo"
        },
        "outcome": {
          "new": "Nuevo",
          "duplicate": "Ya cargado",
          "error": "Con error"
        }
      },
      "problem": {
        "emptyFile": "El archivo no tiene eventos.",
        "headerMismatch": "La cabecera no es el formato v1.",
        "columnCount": "La fila no tiene 7 columnas.",
        "unclosedQuote": "Hay comillas sin cerrar.",
        "formatVersion": "No es la versión 1 del formato.",
        "agencyMismatch": "Código de otra asesoría.",
        "eventIdMissing": "Sin id del evento.",
        "eventIdRepeated": "El id del evento se repite en el archivo.",
        "caseRefMissing": "Sin referencia del caso.",
        "eventCodeUnknown": "Un código de evento que el país no conoce.",
        "noteCodeUnknown": "Un código de nota que el país no conoce.",
        "occurredAtInvalid": "La fecha no está en ISO 8601 con su desfase.",
        "caseUnknown": "Ningún caso de esta asesoría tiene esta referencia.",
        "caseClosed": "El caso está cerrado."
      }
    },
    "agency": {
      "purpose": {
        "consultation": "Consulta",
        "requisition": "Solicitud"
      },
      "field": {
        "identity": "Tu nombre y datos de identidad",
        "contact": "Cómo contactarte (email, teléfono, zona horaria)",
        "title": "Tu título de residencia y sus fechas",
        "absences": "Los viajes al extranjero que registraste",
        "plannedTrips": "Los viajes que planeaste",
        "clocks": "Tus cómputos de ausencia, con su incertidumbre",
        "evidenceDocuments": "La lista de los documentos de tus viajes"
      },
      "consent": {
        "intro": "Finalidad: {{purpose}}. {{agency}} recibirá esto de tu registro InOut:",
        "fields": "Lo que se comparte",
        "version": "Versión del texto {{version}}",
        "withdraw": "Puedes retirarla en cualquier momento en esta pestaña; desde entonces no se comparte nada más.",
        "approve": "Apruebo compartir esto con {{agency}}.",
        "submit": "Aprobar y continuar",
        "readFull": "Leer el texto completo"
      },
      "purchase": {
        "consultationTitle": "Consulta con {{agency}}",
        "requisitionTitle": "Solicitud a cargo de {{agency}}",
        "price": "Precio",
        "credit": "Crédito de tus consultas",
        "toPay": "A pagar ahora",
        "accept": "He leído este aviso y lo acepto.",
        "pay": "Pagar {{amount}}",
        "confirmCredit": "Confirmar: cubierto por tu crédito",
        "subtitle": "Prestado por {{agency}} · pagado aquí, con seguridad",
        "stepsLabel": "Pasos de la compra",
        "steps": {
          "summary": "El servicio",
          "share": "Compartir",
          "billing": "Factura",
          "pay": "Pagar"
        },
        "when": "{{date}} · {{from}}–{{to}}",
        "whenShort": "{{date}} · {{time}}",
        "summary": {
          "title": "Lo que estás comprando",
          "lead": "Revisa el servicio y el importe antes de continuar.",
          "changeTime": "Cambiar la hora"
        },
        "share": {
          "title": "Lo que {{agency}} recibe de tu registro",
          "leadConsultation": "Para la consulta, {{agency}} necesita esto, y solo esto.",
          "leadRequisition": "Para la solicitud, {{agency}} necesita esto, y solo esto.",
          "standingTitle": "Ya aprobaste compartir esto",
          "standing": "Aprobado el {{date}} · versión {{version}} del texto. Nada cambia: pasa al siguiente paso."
        },
        "billing": {
          "title": "A quién va la factura",
          "lead": "Cada pago tiene su factura-recibo. Dinos a quién emitirla; queda guardado para las próximas.",
          "leadSaved": "Cada pago tiene su factura-recibo, con estos datos.",
          "change": "Cambiar",
          "incomplete": "Faltan datos para la factura: complétalos para pasar al pago."
        },
        "payStep": {
          "title": "Confirma y paga",
          "lead": "El resumen, el aviso de {{agency}} y el pago.",
          "service": "Servicio",
          "invoice": "Factura",
          "amount": "A pagar",
          "vat": "IVA incluido",
          "withCredit": "Tras {{credit}} de crédito",
          "after": "Después de pagar",
          "afterConsultation": "La hora queda reservada en el calendario de {{agency}} y el enlace de la videollamada llega por correo.",
          "afterRequisition": "{{agency}} recibe tu dosier y se pone en contacto contigo para empezar.",
          "afterCase": "Lo sigues todo en tu caso, en la pestaña Asesoría.",
          "afterReceipt": "Tu factura-recibo queda disponible en Facturación."
        },
        "secure": "Pago seguro con Stripe",
        "back": "Atrás",
        "next": "Continuar",
        "approveNext": "Aprobar y continuar",
        "saveNext": "Guardar y continuar"
      },
      "slots": {
        "previousWeek": "Semana anterior",
        "nextWeek": "Semana siguiente",
        "week": "{{from}} – {{to}}",
        "loadError": "No se pudieron cargar las horas libres.",
        "empty": "No hay horas libres esta semana. Prueba la siguiente.",
        "pickDay": "Elige un día",
        "pickTime": "Elige una hora",
        "zone": "Horas en tu zona horaria: {{zone}}",
        "current": "tu hora"
      },
      "contact": {
        "title": "La agenda de {{agency}} no está disponible ahora",
        "body": "Pide a {{agency}} que te contacte y te escribirá para acordar una hora.",
        "request": "Pedir a {{agency}} que me contacte",
        "sent": "Enviado. {{agency}} te contactará.",
        "alreadySent": "Ya lo pediste hoy. {{agency}} te contactará.",
        "consentTitle": "Antes de que {{agency}} te contacte",
        "consentDescription": "{{agency}} recibe lo que comparte la consulta, para prepararla."
      },
      "move": {
        "title": "Cambiar la consulta",
        "description": "Elige otra hora libre. Una consulta reservada puede cambiarse hasta {{hours}} h antes.",
        "rebookTitle": "Elige una nueva hora",
        "rebookDescription": "Tu pago sigue en pie: elige otra hora libre, sin coste adicional.",
        "confirm": "Confirmar la nueva hora",
        "done": "Se está reservando la nueva hora. La confirmación llegará por email.",
        "current": "Tu consulta",
        "chosen": "Nueva hora: {{date}}, {{from}}–{{to}}",
        "chooseTime": "Elige la nueva hora."
      },
      "refund": {
        "title": "Solicitar un reembolso",
        "description": "Caso {{caseRef}} con {{agency}}.",
        "reason": "¿Por qué lo solicitas?",
        "chooseReason": "Elige un motivo.",
        "handledBy": "{{agency}} y Tonnie tramitan la solicitud y te escriben.",
        "submit": "Enviar la solicitud",
        "done": "Solicitud enviada. Recibirás respuesta por email.",
        "paid": "Lo que pagaste en este caso",
        "paidConsultation": "Consulta del {{date}}",
        "paidRequisition": "Solicitud"
      },
      "case": {
        "title": "Tu caso con {{agency}}",
        "opened": "Abierto el {{date}}",
        "movableUntil": "Se puede cambiar hasta el {{date}}",
        "join": "Unirse a la reunión",
        "move": "Cambiar",
        "chooseTime": "Elegir hora",
        "credit": "Crédito para la solicitud: {{amount}}",
        "requisition": "Solicitud",
        "requisitionPaid": "Pagado: {{amount}}",
        "continuePayment": "Continuar al pago",
        "confirmingPayment": "Confirmando su pago…",
        "dossier": "Descargar tu copia del dosier",
        "dossierPreparing": "Preparando el dosier…",
        "dossierFailed": "No se pudo descargar el dosier. Inténtalo de nuevo en un momento.",
        "requisitionOffer": "{{agency}} evalúa tu caso, prepara la solicitud y la presenta.",
        "buyRequisition": "Pedir la solicitud",
        "noRequisition": "Ninguna solicitud en este caso.",
        "refunds": "Reembolsos",
        "askRefund": "Solicitar un reembolso",
        "consultations_one": "Consulta",
        "consultations_other": "Consultas",
        "creditTaken": "{{credit}} de crédito de la consulta descontados",
        "toPay": "Por pagar",
        "refundsHint": "Si algo no salió como se acordó, puedes pedir un reembolso a {{agency}} por uno de los motivos previstos.",
        "refundAsked": "Solicitado el {{date}} · {{reason}}",
        "next": {
          "label": "Siguiente paso",
          "payRequisition": "La solicitud espera el pago: {{amount}}",
          "chooseTime": "La consulta necesita otra hora; tu pago sigue en pie.",
          "consultationBooked": "Consulta {{date}}, {{from}}–{{to}}",
          "consultationBooking": "La consulta está pagada; se está reservando la hora.",
          "buyRequisition": "Puedes pedir la solicitud: {{amount}}"
        }
      },
      "identity": {
        "byCountry": "La asesoría de InOut en {{country}}.",
        "legalName": "Razón social",
        "taxId": "NIF",
        "registry": "Registro",
        "address": "Dirección",
        "dataProtection": "Contacto de protección de datos",
        "dpa": "Acuerdo de tratamiento de datos",
        "dpaValue": "{{reference}}, versión {{version}}",
        "website": "Visitar la web de la asesoría",
        "about": "Sobre {{agency}}",
        "addressValue": "{{line}}, {{postalCode}} {{city}}, {{country}}"
      },
      "offer": {
        "credited": "Su precio se descuenta de la solicitud del mismo caso.",
        "requisition": "Solicitud",
        "buyRequisition": "Pedir la solicitud",
        "bookConsultation": "Reservar una consulta",
        "vatIncluded": "Precios con IVA incluido."
      },
      "consents": {
        "none": "No has compartido nada con la asesoría.",
        "grantedOn": "Aprobado el {{date}} · versión {{version}} del texto",
        "revokedOn": "Retirado el {{date}}",
        "withdraw": "Retirar",
        "withdrawn": "Retirado. No se comparte nada más.",
        "confirmTitle": "¿Retirar esta aprobación?",
        "confirmConsultation": "La asesoría no recibe nada más para consultas. Para reservar otra, vuelves a aprobarlo.",
        "confirmRequisition": "La asesoría no recibe nada más y el enlace del dosier que tiene deja de abrirse.",
        "titleWith": "Lo que compartes con {{agency}}",
        "approvedState": "Aprobada",
        "withdrawnState": "Retirada",
        "fields": "Lo que se comparte",
        "beforeNote": "Al reservar una consulta o pedir la solicitud, ves exactamente qué se comparte antes de aprobar."
      },
      "booking": {
        "title": "Reservar una consulta con {{agency}}",
        "online": "Las horas vienen de la propia agenda de la asesoría. La reunión es online; el enlace llega por email y aparece en tu caso una vez reservada.",
        "continue": "Continuar",
        "chosen": "Elegido: {{date}}, {{from}}–{{to}}",
        "chooseTime": "Elige una hora para continuar."
      },
      "checkout": {
        "success": "Pago recibido. Tu caso, abajo, muestra lo que sigue.",
        "cancelled": "Pago cancelado. No se cobró nada."
      },
      "requisition": {
        "paidByCredit": "Pagado con tu crédito. La asesoría recibe tu dosier."
      },
      "loadError": "No se pudo cargar la asesoría.",
      "casesError": "No se pudieron cargar tus casos.",
      "notReady": {
        "title": "La asesoría de tu país aún no está lista",
        "body": "Sus términos de protección de datos aún se están completando. Hasta entonces no se comparte nada con ella ni se puede comprar nada."
      },
      "storefront": {
        "eyebrow": "Tu asesoría migratoria en {{country}}",
        "title": "Lleva tu caso a {{agency}}, con tu registro ya listo.",
        "lead": "Una consulta online para saber qué hacer, o la solicitud completa: {{agency}} evalúa el caso, prepara y presenta la solicitud y la sigue hasta la decisión.",
        "trustDossier": "Tu registro de InOut, entregado en dosier",
        "trustVat": "Precios con IVA incluido",
        "once": "pago único",
        "complete": "el proceso completo",
        "closeCalendar": "Cerrar el calendario",
        "consultation": {
          "meeting": "Una reunión con {{agency}} sobre tu situación",
          "record": "{{agency}} recibe antes tu registro: no empieza de cero",
          "movable": "Se puede cambiar hasta {{hours}} h antes",
          "credited": "Su precio se descuenta de la solicitud del mismo caso"
        },
        "requisition": {
          "tag": "Todo gestionado por {{agency}}",
          "assess": "{{agency}} evalúa tu caso",
          "submit": "Prepara y presenta la solicitud por ti",
          "follow": "La sigue hasta la decisión",
          "dossier": "Tu registro y tus documentos van en un dosier",
          "inCase": "Tienes un caso abierto: la solicitud se pide en él.",
          "showCase": "Ver tu caso",
          "unreadable": "No pudimos leer tus casos: inténtalo de nuevo arriba."
        }
      },
      "how": {
        "title": "Cómo funciona",
        "choose": "Elige y paga aquí",
        "chooseBody": "La consulta o la solicitud, con pago seguro y factura a tu nombre.",
        "share": "Aprueba compartir tu registro",
        "shareBody": "Solo lo que necesita cada servicio. Puedes retirar la aprobación cuando quieras.",
        "firm": "{{agency}} se ocupa contigo",
        "firmBody": "En la consulta, a la hora reservada; en la solicitud, de la presentación a la decisión."
      },
      "providers": {
        "title": "Quién presta el servicio",
        "firm": "{{agency}} presta la consulta y la solicitud",
        "firmBody": "Sociedad regulada, bajo su propia responsabilidad profesional: la evaluación jurídica y la solicitud son suyas.",
        "tonnie": "Tonnie guarda tu registro",
        "tonnieBody": "Cuenta tus días, organiza tus documentos y se los entrega a {{agency}}, con tu autorización."
      }
    },
    "mobile": {
      "setupOnWeb": "Empezar InOut en Citizen Web",
      "setupOnWebDesc": "Allí se abre la calculadora; guarda la respuesta para empezar InOut. Después, el interruptor, los plazos y las preguntas de InOut también están aquí.",
      "calculatorErrorTitle": "La calculadora no se abrió",
      "calculatorErrorBody": "Comprueba tu conexión e inténtalo de nuevo.",
      "noticesLink": "Preguntas y avisos",
      "agencyOnWeb": "La asesoría, en Citizen Web",
      "agencyOnWebDesc": "Las consultas, la solicitud y tus casos con la asesoría están en Citizen Web: la app no vende.",
      "answer": "Responder",
      "sourceCamera": "Hacer una foto",
      "sourceLibrary": "De las fotos",
      "sourceFiles": "De los archivos",
      "cameraTitle": "Acceso a la cámara",
      "cameraMessage": "Para fotografiar un documento de tu viaje, permite que Tonnie use la cámara en los ajustes del teléfono.",
      "pickerUnavailableTitle": "No se pueden abrir tus documentos",
      "pickerUnavailableMessage": "Inténtalo de nuevo o elige el documento de otra forma.",
      "pauseConfirmBody": "InOut conserva todo como está, pero no cuenta ni pregunta nada. Su pestaña sale de la aplicación hasta que lo reanudes en Configuraciones.",
      "titleOnWebDesc": "Corrígelo o añade tu tarjeta renovada, en Citizen Web.",
      "newOnWebDesc": "Empieza un nuevo InOut con un cálculo nuevo, en Citizen Web. El que tienes pasa a tu historial; no se borra nada.",
      "historySubtitle": "Todos los InOut que guardas"
    },
    "paused": {
      "title": "InOut está en pausa",
      "body": "En pausa desde el {{date}}. Tu autorización, tus viajes y tus documentos se conservan como estaban, pero InOut no cuenta ni pregunta nada hasta que lo reanudes.",
      "resume": "Reanudar InOut",
      "resumed": "InOut vuelve a funcionar.",
      "failed": "No se pudo reanudar InOut. Inténtalo de nuevo.",
      "history": "Tu historial de InOut"
    },
    "menu": {
      "label": "Opciones de InOut",
      "title": "Actualizar mi autorización",
      "pause": "Pausar InOut",
      "new": "Nuevo InOut",
      "close": "Cerrar InOut"
    },
    "titleDialog": {
      "title": "Actualizar mi autorización",
      "description": "El país se mantiene. Otro país es un InOut nuevo.",
      "renewed": "Recibí una tarjeta nueva",
      "renewedHint": "Ocupa el lugar del actual; tus días cuentan en ambos.",
      "saved": "Tu autorización está actualizada.",
      "correct": "Corregir el actual",
      "correctHint": "Es distinto de lo que dice la tarjeta."
    },
    "pause": {
      "confirmTitle": "¿Pausar InOut?",
      "confirmBody": "InOut conserva todo como está, pero no cuenta ni pregunta nada hasta que lo reanudes aquí.",
      "confirm": "Pausar InOut",
      "done": "InOut está en pausa.",
      "caseOpenTitle": "InOut sigue en marcha",
      "caseOpenBody": "La asesoría trabaja sobre tu registro mientras el caso esté abierto, así que InOut no puede detenerse ahora.",
      "caseOpenLead": "Puedes pausarlo cuando el caso se cierre."
    },
    "askBefore": {
      "title": "Pídela antes de salir",
      "body": "Para una ausencia como esta, la ley prevé “{{exception}}”: se pide antes de salir. No damos asesoramiento jurídico: el CoPilot te explica qué implica y la asesoría puede asesorarte.",
      "askCoPilot": "Preguntar al CoPilot",
      "agency": "Hablar con la asesoría",
      "questionNext": "¿Necesito pedir “{{exception}}” antes de mi próximo viaje?",
      "questionTrip": "Antes de mi viaje del {{from}} al {{to}}, ¿necesito pedir “{{exception}}”?"
    },
    "shortStay": {
      "open": "Cómo se le aplica la regla 90/180",
      "title": "La regla 90/180: dónde se le aplica",
      "lead": "Lo que ha oído sobre 90 días de cada 180 se le aplica, pero no en {{country}}.",
      "where": "Dónde está",
      "away": "Cuenta como fuera de {{country}}",
      "shortStay": "Cuenta para los 90/180",
      "inHost": "En {{country}}",
      "otherSchengen": "En otro país Schengen",
      "outsideSchengen": "Fuera del espacio Schengen",
      "yes": "Sí",
      "no": "No",
      "twice": "Un día en otro país Schengen cuenta dos veces: como día fuera de {{country}} y para los 90 días de cada 180 de ese espacio. InOut cuenta ambos.",
      "calculator": "La calculadora de estancias de corta duración de la UE es para visitantes. Lo dice ella misma: quien tiene un permiso de residencia no está sujeto a ella ni debe introducir allí sus estancias.",
      "source": "Artículo 21 del Convenio de Aplicación del Acuerdo de Schengen",
      "today": "Hoy: {{figures}}",
      "youAreHere": "Estás aquí",
      "on": "El {{date}}: {{figures}}",
      "youWereHere": "Donde estabas el {{date}}"
    },
    "severity": {
      "title": "Nivel de alerta",
      "subtitle": "Dónde está tu registro hoy, de informativo a urgente.",
      "ladder": "Nivel {{rank}} de {{total}}: {{level}}",
      "level": {
        "informative": "Informativo",
        "attention": "Atención",
        "potentialRisk": "Riesgo potencial",
        "professionalReview": "Revisión profesional recomendada",
        "urgent": "Urgente"
      },
      "informative": "Ahora no necesita hacer nada. InOut sigue contando y le avisa con antelación.",
      "uncertainDays_one": "{{days}} día de su registro está aún por confirmar; hasta entonces, sus cifras son menos precisas.",
      "uncertainDays_other": "{{days}} días de su registro están aún por confirmar; hasta entonces, sus cifras son menos precisas.",
      "renewalWindow": "El plazo para renovar su permiso está abierto.",
      "riskZone": "Está en la franja en la que dos lecturas de «{{rule}}» no coinciden.",
      "dependsOnUncertain": "Que «{{rule}}» quede dentro del límite depende de días aún por confirmar.",
      "nearLimit": "«{{rule}}» está cerca de su límite.",
      "passing": "Sus viajes llevarían «{{rule}}» a su límite el {{date}}.",
      "passingException": "{{exception}} puede hacerse antes de salir; la asesoría puede prepararla.",
      "passingAgency": "La asesoría puede revisarlo con usted antes de que se vaya.",
      "urgent": "«{{rule}}» ha superado su límite. Eso no significa que su residencia esté perdida: la ley prevé respuestas, con audiencia previa. La asesoría puede ayudarle.",
      "daysLeft_one": "Queda {{days}} día",
      "daysLeft_other": "Quedan {{days}} días",
      "untilCloses_one": "{{days}} día hasta que cierre",
      "untilCloses_other": "{{days}} días hasta que cierre",
      "toAct_one": "{{days}} día para actuar",
      "toAct_other": "{{days}} días para actuar",
      "action": {
        "agency": "Hablar con la asesoría",
        "confirmDays": "Confirmar los días",
        "limits": "Ver sus límites",
        "renewal": "Ver la renovación"
      }
    },
    "export": {
      "title": "Su registro, listo para una auditoría",
      "body": "Sus permisos, sus viajes, los viajes que planea, sus límites y sus documentos en un solo PDF: suyo, para guardarlo o entregarlo a quien se lo pida.",
      "download": "Descargar su registro (PDF)",
      "failed": "No se ha podido descargar su registro. Inténtelo de nuevo.",
      "onWeb": "Descargar su registro",
      "onWebDesc": "Su registro en PDF se descarga en Citizen Web."
    },
    "boardingPass": {
      "add": "Desde una tarjeta de embarque",
      "hint": "Una foto de la tarjeta o el PDF de la aerolínea: el viaje se lee a partir de ella, para que lo confirme, y la tarjeta se guarda como prueba.",
      "elsewhere": "Este vuelo va de {{from}} a {{to}}: no es un viaje de entrada o salida de su país de residencia, así que no se ha registrado nada.",
      "proofNotKept": "El viaje se ha guardado, pero no se ha podido conservar la tarjeta de embarque. Añádala desde Documentos.",
      "failed": {
        "notBoardingPass": "Eso no es una tarjeta de embarque. Fotografíe la propia tarjeta.",
        "unreadable": "No se ha podido leer el vuelo. Pruebe con una foto más nítida, con la fecha y los aeropuertos a la vista.",
        "unsupported": "Ese archivo no se puede leer. Use una foto o un PDF.",
        "tooLarge": "Ese archivo es demasiado grande. Use una foto más pequeña.",
        "unavailable": "Ahora mismo no se pueden leer tarjetas de embarque. Inténtelo en un momento o registre el viaje usted mismo.",
        "generic": "No se ha podido leer la tarjeta de embarque. Inténtelo de nuevo."
      },
      "fromFile": "Una foto o un archivo",
      "fromVaultDescription": "Una tarjeta de embarque que ya guardas — leída en el viaje que es."
    },
    "summary": {
      "detail": "Ver el detalle",
      "perTrip": "hasta {{limit}} días seguidos en cada salida",
      "unit": {
        "total": "días",
        "eachTrip": "días seguidos",
        "needed": "días que faltan"
      }
    },
    "offer": {
      "subtitle": "Tu asesoría migratoria",
      "title": {
        "calm": "Asegúrate antes de salir",
        "review": "Habla con la asesoría antes de salir",
        "urgent": "La asesoría puede ayudarte ya"
      },
      "body": {
        "calm": "InOut cuenta tus días; {{agency}} te dice qué hacer con ellos.",
        "review": "Tus viajes se acercan a un límite: consulta con {{agency}} qué hacer antes de salir.",
        "urgent": "Se ha superado un límite. Eso no significa que hayas perdido la residencia: {{agency}} prepara la respuesta que prevé la ley."
      },
      "case": {
        "title": "Tu caso con {{agency}}",
        "body": "El caso {{caseRef}} está en curso.",
        "open": "Ver el caso"
      },
      "consultationTitle": "Consulta online",
      "consultationMeta": "{{minutes}} min · por videollamada",
      "nextSlot": "Próximo hueco: {{date}} · {{time}}",
      "requisitionMeta": "Preparada y presentada por {{agency}}",
      "regulated": "Sociedad regulada"
    },
    "milestones": {
      "label": "Lo que viene",
      "renewal": "Renovación a partir del {{date}}",
      "acquisition": "{{name}} el {{date}}",
      "planTrip": "Planificar un viaje",
      "title": "Tus hitos",
      "subtitle": "Renovación y derechos de larga duración"
    },
    "stage": {
      "inHost": "En Portugal",
      "away": "Fuera de Portugal",
      "tapToLeave": "Toca el círculo al salir",
      "tapToReturn": "Desde el {{date}} · toca al volver",
      "mine": "Mi InOut",
      "noNumber": "aún sin número",
      "unit": {
        "days": "días"
      },
      "leftNotice": "Salida registrada el {{date}}",
      "backNotice_one": "Regreso registrado — {{days}} día fuera",
      "backNotice_other": "Regreso registrado — {{days}} días fuera",
      "attention": {
        "beyond": "por encima del límite",
        "daysLeft_one": "queda {{days}} día",
        "daysLeft_other": "quedan {{days}} días",
        "check": "por revisar",
        "questions": "Pendiente de respuesta",
        "questionCount_one": "{{questions}} pregunta",
        "questionCount_other": "{{questions}} preguntas",
        "toConfirm": "Días por confirmar",
        "days_one": "{{days}} día",
        "days_other": "{{days}} días",
        "none": "Todo al día",
        "unread": "No pudimos leer tus avisos"
      },
      "upTo_one": "hasta {{days}} día",
      "upTo_other": "hasta {{days}} días",
      "upToInARow_one": "hasta {{days}} día seguido",
      "upToInARow_other": "hasta {{days}} días seguidos",
      "continuedNotice": "Has vuelto a salir — el viaje de hoy continúa"
    },
    "help": {
      "title": "Pedir ayuda",
      "description": "Pregunta ahora, o habla con quien decide.",
      "copilot": "Preguntar al CoPilot",
      "copilotHint": "Responde ahora, a cualquier hora, sobre tu registro.",
      "agency": "Hablar con la asesoría",
      "agencyHint": "Una consulta con quien decide, en Citizen Web."
    },
    "hub": {
      "subtitle": "Todo en un solo lugar",
      "titleOverline": "Tu título",
      "where": "Dónde estás",
      "validUntil": "Válido hasta",
      "renewalFrom": "Renovación desde el",
      "all": "Todo sobre tu InOut",
      "manage": "Gestionar",
      "onWeb": "En Citizen Web",
      "agency": "La asesoría",
      "documents": "Documentos",
      "planned_one": "{{count}} planificado",
      "planned_other": "{{count}} planificados"
    },
    "limits": {
      "title": "Tus límites",
      "subtitle": "Una regla a la vez",
      "unit": {
        "left": "días que aún puedes estar fuera",
        "inARow": "días seguidos, desde hoy",
        "needed": "días que aún faltan en el país"
      },
      "others": "Otras reglas",
      "why": {
        "title_one": "Por qué un viaje puede durar {{days}} día y no {{other}}",
        "title_other": "Por qué un viaje puede durar {{days}} días y no {{other}}",
        "byTotal_one": "En un viaje cuenta el menor de los dos límites. Hoy es el total: te queda {{left}} día de los {{limit}}.",
        "byTotal_other": "En un viaje cuenta el menor de los dos límites. Hoy es el total: te quedan {{left}} días de los {{limit}}.",
        "byInARow_one": "En un viaje cuenta el menor de los dos límites. Hoy es el de seguidos: un viaje fuera de {{country}} no puede pasar de {{limit}} día.",
        "byInARow_other": "En un viaje cuenta el menor de los dos límites. Hoy es el de seguidos: un viaje fuera de {{country}} no puede pasar de {{limit}} días.",
        "titleFrom_one": "Por qué un viaje desde el {{date}} podía durar {{days}} día y no {{other}}",
        "titleFrom_other": "Por qué un viaje desde el {{date}} podía durar {{days}} días y no {{other}}",
        "byTotalOn_one": "En un viaje cuenta el menor de los dos límites. El {{date}} era el total: quedaba {{left}} día de los {{limit}}.",
        "byTotalOn_other": "En un viaje cuenta el menor de los dos límites. El {{date}} era el total: quedaban {{left}} días de los {{limit}}.",
        "byInARowOn_one": "En un viaje cuenta el menor de los dos límites. El {{date}} era el de seguidos: un viaje fuera de {{country}} no podía pasar de {{limit}} día.",
        "byInARowOn_other": "En un viaje cuenta el menor de los dos límites. El {{date}} era el de seguidos: un viaje fuera de {{country}} no podía pasar de {{limit}} días."
      },
      "line": {
        "today": "hoy",
        "away": "días fuera",
        "toConfirm": "por confirmar",
        "closed": "cerrado"
      },
      "run_one": "{{from}} – {{to}} · {{days}} día",
      "run_other": "{{from}} – {{to}} · {{days}} días",
      "trips": {
        "thisTrip_one": "Este viaje, desde {{from}} · {{days}} día",
        "thisTrip_other": "Este viaje, desde {{from}} · {{days}} días",
        "next_one": "Tu próximo viaje: hasta {{days}} día — el total llega al límite antes de los {{limit}}",
        "next_other": "Tu próximo viaje: hasta {{days}} días — el total llega al límite antes de los {{limit}}",
        "none": "Aún no ha contado ningún viaje.",
        "thisTripOn_one": "El viaje en curso el {{date}}, desde el {{from}} · {{days}} día",
        "thisTripOn_other": "El viaje en curso el {{date}}, desde el {{from}} · {{days}} días",
        "nextFrom_one": "Un viaje desde el {{date}}: hasta {{days}} día — el total llega al límite antes de los {{limit}}",
        "nextFrom_other": "Un viaje desde el {{date}}: hasta {{days}} días — el total llega al límite antes de los {{limit}}"
      }
    },
    "trips": {
      "passHint": "Fotografíala: el viaje se lee y la foto queda como prueba.",
      "tab": {
        "trips": "Viajes",
        "record": "Registro"
      },
      "count_one": "{{count}} viaje",
      "count_other": "{{count}} viajes",
      "yearHeading": "{{year}} · {{trips}}"
    },
    "duration": {
      "days_one": "{{value}} día",
      "days_other": "{{value}} días",
      "months_one": "{{value}} mes",
      "months_other": "{{value}} meses",
      "years_one": "{{value}} año",
      "years_other": "{{value}} años"
    },
    "meter": {
      "title": "Los límites de ausencia de tu permiso",
      "name": {
        "inTotal": "En total",
        "inARow": "Seguidos",
        "outsideEuInTotal": "Fuera de la UE, en total",
        "outsideEuInARow": "Fuera de la UE, seguidos"
      },
      "detail": {
        "perTrip": "{{limit}} por viaje",
        "perTripRolling": "{{limit}} por viaje, en cualquier periodo de {{window}}",
        "perTripCalendarYear": "{{limit}} por viaje, cada año natural",
        "perTripFromIssue": "{{limit}} por viaje, en los primeros {{window}}",
        "total": "{{limit}}",
        "totalPermit": "{{limit}} en el permiso",
        "totalPermitAndRenewals": "{{limit}} en el permiso y sus renovaciones",
        "totalRolling": "{{limit}} en cualquier periodo de {{window}}",
        "totalCalendarYear": "{{limit}} cada año natural",
        "totalFromIssue": "{{limit}} en los primeros {{window}}"
      },
      "fraction": "{{taken}} / {{limit}}",
      "valueText": "{{taken}} de {{limit}} días, quedan {{left}}",
      "definesAnswer": "Define tu respuesta"
    },
    "holds": {
      "trips": "Viajes",
      "planned": "Viajes planificados",
      "documents": "Documentos adjuntos",
      "daysAway_one": "{{days}} día fuera",
      "daysAway_other": "{{days}} días fuera"
    },
    "newRecord": {
      "confirmTitle": "¿Empezar un nuevo InOut?",
      "confirmBody": "Tu InOut actual pasa a tu historial con todo lo que guarda: no se borra nada y puedes volver a hacerlo principal cuando quieras.",
      "confirm": "Empezar un nuevo InOut",
      "holdsLabel": "Lo que pasa a tu historial",
      "keepTitle": "Empezar un nuevo InOut con esto",
      "keepWhy": "Esto pasa a ser tu InOut: tu autorización, tus viajes y el tiempo que estuviste en el país, tal como los describes ahora. El que tienes pasa a tu historial.",
      "keep": "Empezar nuevo InOut",
      "done": "Tu nuevo InOut está en marcha: el anterior está en tu historial."
    },
    "recordCase": {
      "title": "Tu InOut se queda como está",
      "body": "La asesoría trabaja sobre este InOut mientras tu caso esté abierto, así que no puede pasar a tu historial ahora.",
      "leadNew": "Puedes empezar un nuevo InOut cuando el caso se cierre.",
      "leadClose": "Puedes cerrarlo cuando el caso se cierre."
    },
    "close": {
      "confirmTitle": "¿Cerrar InOut?",
      "confirmBody": "Tu InOut pasa a tu historial con todo lo que guarda: no se borra nada. InOut no cuenta ni envía avisos hasta que empieces uno nuevo o vuelvas a hacer principal uno de tu historial.",
      "confirm": "Cerrar InOut",
      "done": "Tu InOut está cerrado y guardado en tu historial."
    },
    "history": {
      "principalTitle": "Tu InOut",
      "closedTitle": "En tu historial",
      "closedLead": "Los InOut que sustituiste o cerraste, guardados como estaban: cada uno leído a la fecha en que se cerró.",
      "stateActive": "Activo",
      "statePaused": "En pausa",
      "sinceActive": "En marcha desde el {{date}}",
      "sincePaused": "En pausa desde el {{date}}",
      "goToInOut": "Ir a InOut",
      "view": "Ver",
      "restore": "Hacerlo principal",
      "delete": "Eliminar",
      "noTitle": "Sin permiso de residencia",
      "period": "{{from}} – {{to}}",
      "periodOpen": "Desde el {{from}}, sin fecha de fin",
      "trips_one": "{{trips}} viaje",
      "trips_other": "{{trips}} viajes",
      "daysAway_one": "{{days}} día fuera",
      "daysAway_other": "{{days}} días fuera",
      "documents_one": "{{documents}} documento",
      "documents_other": "{{documents}} documentos",
      "closedReplaced": "Cerrado el {{date}}: un nuevo InOut ocupó su lugar",
      "closedRestoredOther": "Cerrado el {{date}}: otro de tu historial ocupó su lugar",
      "closedByYou": "Cerrado por ti el {{date}}",
      "closedLegacy": "Guardado de antes de que InOut tuviera historial",
      "emptyTitle": "Todavía no hay nada en tu historial",
      "emptyBody": "Cuando empieces un nuevo InOut o cierres el que tienes, se guarda aquí: no se borra nada.",
      "noneTitle": "Todavía no tienes InOut",
      "noneBody": "Empieza InOut con su calculadora. Cada InOut que empieces se guarda aquí.",
      "loadError": "No hemos podido leer tu historial",
      "restoreTitle": "¿Hacer principal este InOut?",
      "restoreBody": "Tu InOut actual pasa a tu historial. Este vuelve en pausa: reanúdalo cuando quieras.",
      "restoreBodyNone": "Vuelve en pausa: reanúdalo cuando quieras.",
      "restoreConfirm": "Hacerlo principal",
      "restored": "Vuelve a ser tu InOut, en pausa: reanúdalo cuando quieras.",
      "deleteTitle": "¿Eliminar este InOut para siempre?",
      "deleteBody": "Sale de tu historial y no se puede recuperar. Lo que guarda se elimina con él; los archivos se quedan en tu Bóveda.",
      "deleteConfirm": "Eliminar para siempre",
      "deleteHolds": "Lo que se elimina",
      "deleted": "El InOut se ha eliminado.",
      "back": "Tu historial",
      "detail": {
        "closedPill": "Cerrado",
        "asOf": "Las cifras tal como estaban el {{date}}, el día en que se cerró.",
        "noReading": "Este InOut no tiene permiso de residencia: no hay nada que contar.",
        "principalTitle": "Este es tu InOut",
        "principalBody": "Funciona en la página de InOut: allí está todo sobre él.",
        "tripsTitle": "Sus viajes",
        "tripsEmpty": "No se anotó ningún viaje en este InOut.",
        "plannedTitle": "Viajes que aún tenía planificados",
        "documentsTitle": "Documentos",
        "documents_one": "{{documents}} documento adjunto a sus viajes. El archivo está en tu Bóveda.",
        "documents_other": "{{documents}} documentos adjuntos a sus viajes. Los archivos están en tu Bóveda.",
        "documentsNone": "No se adjuntó ningún documento a sus viajes.",
        "notFoundTitle": "Este InOut no está en tu historial",
        "notFoundBody": "Puede que se haya eliminado. Tu historial tiene todos los InOut que guardas.",
        "loadError": "No hemos podido leer este InOut"
      }
    }
  }
}
